(function () {
  var __create = Object.create,
    __defProp = Object.defineProperty,
    __getOwnPropDesc = Object.getOwnPropertyDescriptor,
    __getOwnPropNames = Object.getOwnPropertyNames,
    __getProtoOf = Object.getPrototypeOf,
    __hasOwnProp = Object.prototype.hasOwnProperty,
    __esmMin = (e, t) => () => (e && (t = e((e = 0))), t),
    __commonJSMin = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), (e = null)), t.exports),
    __exportAll = (e, t) => {
      let n = {};
      for (var r in e) __defProp(n, r, { get: e[r], enumerable: !0 });
      return (t || __defProp(n, Symbol.toStringTag, { value: `Module` }), n);
    },
    __copyProps = (e, t, n, r) => {
      if ((t && typeof t == `object`) || typeof t == `function`)
        for (var i = __getOwnPropNames(t), a = 0, o = i.length, s; a < o; a++)
          ((s = i[a]),
            !__hasOwnProp.call(e, s) &&
              s !== n &&
              __defProp(e, s, {
                get: ((e) => t[e]).bind(null, s),
                enumerable: !(r = __getOwnPropDesc(t, s)) || r.enumerable,
              }));
      return e;
    },
    __toESM = (e, t, n) => (
      (n = e == null ? {} : __create(__getProtoOf(e))),
      __copyProps(t || !e || !e.__esModule ? __defProp(n, `default`, { value: e, enumerable: !0 }) : n, e)
    ),
    __toCommonJS = (e) =>
      __hasOwnProp.call(e, `module.exports`)
        ? e[`module.exports`]
        : __copyProps(__defProp({}, `__esModule`, { value: !0 }), e);
  function dispatchCallback(e, t) {
    e && e(t);
  }
  function reverseDictionary(e) {
    return Object.fromEntries(Object.entries(e).map(([e, t]) => [t, e]));
  }
  function escapeRegExp(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, `\\$&`);
  }
  const Callable = class {
    constructor() {
      let e = function (...t) {
        return e._call(...t);
      };
      return Object.setPrototypeOf(e, new.target.prototype);
    }
    _call(...e) {
      throw Error(`Must implement _call method in subclass`);
    }
  };
  function isTypedArray(e) {
    return e?.prototype?.__proto__?.constructor?.name === `TypedArray`;
  }
  function isIntegralNumber(e) {
    return Number.isInteger(e) || typeof e == `bigint`;
  }
  function exists(e) {
    return e != null;
  }
  function calculateDimensions(e) {
    let t = [],
      n = e;
    for (; Array.isArray(n); ) (t.push(n.length), (n = n[0]));
    return t;
  }
  function pop(e, t, n = void 0) {
    let r = e[t];
    if (r !== void 0) return (delete e[t], r);
    if (n === void 0) throw Error(`Key ${t} does not exist in object.`);
    return n;
  }
  function mergeArrays(...e) {
    return Array.prototype.concat.apply([], e);
  }
  function product(...e) {
    return e.reduce((e, t) => e.flatMap((e) => t.map((t) => [e, t])));
  }
  function calculateReflectOffset(e, t) {
    return Math.abs(((e + t) % (2 * t)) - t);
  }
  var require___vite_browser_external = __commonJSMin((e, t) => {
      t.exports = {};
    }),
    backends,
    backendsSortedByPriority,
    registerBackend,
    resolveBackend,
    init_backend_impl = __esmMin(() => {
      ((backends = {}),
        (backendsSortedByPriority = []),
        (registerBackend = (e, t, n) => {
          if (t && typeof t.init == `function` && typeof t.createSessionHandler == `function`) {
            let r = backends[e];
            if (r === void 0) backends[e] = { backend: t, priority: n };
            else if (r.priority > n) return;
            else if (r.priority === n && r.backend !== t)
              throw Error(`cannot register backend "${e}" using priority ${n}`);
            if (n >= 0) {
              let t = backendsSortedByPriority.indexOf(e);
              t !== -1 && backendsSortedByPriority.splice(t, 1);
              for (let t = 0; t < backendsSortedByPriority.length; t++)
                if (backends[backendsSortedByPriority[t]].priority <= n) {
                  backendsSortedByPriority.splice(t, 0, e);
                  return;
                }
              backendsSortedByPriority.push(e);
            }
            return;
          }
          throw TypeError(`not a valid backend`);
        }),
        (resolveBackend = async (e) => {
          let t = e.length === 0 ? backendsSortedByPriority : e,
            n = [];
          for (let e of t) {
            let t = backends[e];
            if (t) {
              if (t.initialized) return t.backend;
              if (t.aborted) continue;
              let r = !!t.initPromise;
              try {
                return (r || (t.initPromise = t.backend.init()), await t.initPromise, (t.initialized = !0), t.backend);
              } catch (i) {
                (r || n.push({ name: e, err: i }), (t.aborted = !0));
              } finally {
                delete t.initPromise;
              }
            }
          }
          throw Error(`no available backend found. ERR: ${n.map((e) => `[${e.name}] ${e.err}`).join(`, `)}`);
        }));
    }),
    init_backend = __esmMin(() => {
      init_backend_impl();
    }),
    EnvImpl,
    init_env_impl = __esmMin(() => {
      EnvImpl = class {
        constructor() {
          ((this.wasm = {}), (this.webgl = {}), (this.logLevelInternal = `warning`));
        }
        set logLevel(e) {
          if (e !== void 0) {
            if (typeof e != `string` || [`verbose`, `info`, `warning`, `error`, `fatal`].indexOf(e) === -1)
              throw Error(`Unsupported logging level: ${e}`);
            this.logLevelInternal = e;
          }
        }
        get logLevel() {
          return this.logLevelInternal;
        }
      };
    }),
    env$2,
    init_env = __esmMin(() => {
      (init_env_impl(), (env$2 = new EnvImpl()));
    }),
    isBigInt64ArrayAvailable,
    isBigUint64ArrayAvailable,
    NUMERIC_TENSOR_TYPE_TO_TYPEDARRAY_MAP,
    NUMERIC_TENSOR_TYPEDARRAY_TO_TYPE_MAP,
    calculateSize,
    Tensor$2,
    init_tensor_impl = __esmMin(() => {
      ((isBigInt64ArrayAvailable = typeof BigInt64Array < `u` && typeof BigInt64Array.from == `function`),
        (isBigUint64ArrayAvailable = typeof BigUint64Array < `u` && typeof BigUint64Array.from == `function`),
        (NUMERIC_TENSOR_TYPE_TO_TYPEDARRAY_MAP = new Map([
          [`float32`, Float32Array],
          [`uint8`, Uint8Array],
          [`int8`, Int8Array],
          [`uint16`, Uint16Array],
          [`int16`, Int16Array],
          [`int32`, Int32Array],
          [`bool`, Uint8Array],
          [`float64`, Float64Array],
          [`uint32`, Uint32Array],
        ])),
        (NUMERIC_TENSOR_TYPEDARRAY_TO_TYPE_MAP = new Map([
          [Float32Array, `float32`],
          [Uint8Array, `uint8`],
          [Int8Array, `int8`],
          [Uint16Array, `uint16`],
          [Int16Array, `int16`],
          [Int32Array, `int32`],
          [Float64Array, `float64`],
          [Uint32Array, `uint32`],
        ])),
        isBigInt64ArrayAvailable &&
          (NUMERIC_TENSOR_TYPE_TO_TYPEDARRAY_MAP.set(`int64`, BigInt64Array),
          NUMERIC_TENSOR_TYPEDARRAY_TO_TYPE_MAP.set(BigInt64Array, `int64`)),
        isBigUint64ArrayAvailable &&
          (NUMERIC_TENSOR_TYPE_TO_TYPEDARRAY_MAP.set(`uint64`, BigUint64Array),
          NUMERIC_TENSOR_TYPEDARRAY_TO_TYPE_MAP.set(BigUint64Array, `uint64`)),
        (calculateSize = (e) => {
          let t = 1;
          for (let n = 0; n < e.length; n++) {
            let r = e[n];
            if (typeof r != `number` || !Number.isSafeInteger(r))
              throw TypeError(`dims[${n}] must be an integer, got: ${r}`);
            if (r < 0) throw RangeError(`dims[${n}] must be a non-negative integer, got: ${r}`);
            t *= r;
          }
          return t;
        }),
        (Tensor$2 = class e {
          constructor(e, t, n) {
            let r, i, a;
            if (typeof e == `string`)
              if (((r = e), (a = n), e === `string`)) {
                if (!Array.isArray(t)) throw TypeError(`A string tensor's data must be a string array.`);
                i = t;
              } else {
                let n = NUMERIC_TENSOR_TYPE_TO_TYPEDARRAY_MAP.get(e);
                if (n === void 0) throw TypeError(`Unsupported tensor type: ${e}.`);
                if (Array.isArray(t)) i = n.from(t);
                else if (t instanceof n) i = t;
                else throw TypeError(`A ${r} tensor's data must be type of ${n}`);
              }
            else if (((a = t), Array.isArray(e))) {
              if (e.length === 0) throw TypeError(`Tensor type cannot be inferred from an empty array.`);
              let t = typeof e[0];
              if (t === `string`) ((r = `string`), (i = e));
              else if (t === `boolean`) ((r = `bool`), (i = Uint8Array.from(e)));
              else throw TypeError(`Invalid element type of data array: ${t}.`);
            } else {
              let t = NUMERIC_TENSOR_TYPEDARRAY_TO_TYPE_MAP.get(e.constructor);
              if (t === void 0) throw TypeError(`Unsupported type for tensor data: ${e.constructor}.`);
              ((r = t), (i = e));
            }
            if (a === void 0) a = [i.length];
            else if (!Array.isArray(a)) throw TypeError(`A tensor's dims must be a number array`);
            let o = calculateSize(a);
            if (o !== i.length) throw Error(`Tensor's size(${o}) does not match data length(${i.length}).`);
            ((this.dims = a), (this.type = r), (this.data = i), (this.size = o));
          }
          static bufferToTensor(t, n) {
            if (t === void 0) throw Error(`Image buffer must be defined`);
            if (n.height === void 0 || n.width === void 0) throw Error(`Image height and width must be defined`);
            let { height: r, width: i } = n,
              a = n.norm,
              o,
              s;
            ((o = a === void 0 || a.mean === void 0 ? 255 : a.mean),
              (s = a === void 0 || a.bias === void 0 ? 0 : a.bias));
            let c = n.bitmapFormat === void 0 ? `RGBA` : n.bitmapFormat,
              l = n.tensorFormat === void 0 || n.tensorFormat === void 0 ? `RGB` : n.tensorFormat,
              u = r * i,
              d = l === `RGBA` ? new Float32Array(u * 4) : new Float32Array(u * 3),
              f = 4,
              p = 0,
              m = 1,
              h = 2,
              g = 3,
              _ = 0,
              v = u,
              y = u * 2,
              b = -1;
            (c === `RGB` && ((f = 3), (p = 0), (m = 1), (h = 2), (g = -1)),
              l === `RGBA`
                ? (b = u * 3)
                : l === `RBG`
                  ? ((_ = 0), (y = u), (v = u * 2))
                  : l === `BGR` && ((y = 0), (v = u), (_ = u * 2)));
            for (let e = 0; e < u; e++, p += f, h += f, m += f, g += f)
              ((d[_++] = (t[p] + s) / o),
                (d[v++] = (t[m] + s) / o),
                (d[y++] = (t[h] + s) / o),
                b !== -1 && g !== -1 && (d[b++] = (t[g] + s) / o));
            return l === `RGBA` ? new e(`float32`, d, [1, 4, r, i]) : new e(`float32`, d, [1, 3, r, i]);
          }
          static async fromImage(t, n) {
            let r = typeof HTMLImageElement < `u` && t instanceof HTMLImageElement,
              i = typeof ImageData < `u` && t instanceof ImageData,
              a = typeof ImageBitmap < `u` && t instanceof ImageBitmap,
              o = typeof String < `u` && (t instanceof String || typeof t == `string`),
              s,
              c = {};
            if (r) {
              let e = document.createElement(`canvas`),
                r = e.getContext(`2d`);
              if (r != null) {
                let i = t.naturalHeight,
                  a = t.naturalWidth;
                if (
                  (n !== void 0 &&
                    n.resizedHeight !== void 0 &&
                    n.resizedWidth !== void 0 &&
                    ((i = n.resizedHeight), (a = n.resizedWidth)),
                  n !== void 0)
                ) {
                  if (((c = n), n.tensorFormat !== void 0))
                    throw Error(`Image input config format must be RGBA for HTMLImageElement`);
                  if (((c.tensorFormat = `RGBA`), n.height !== void 0 && n.height !== i))
                    throw Error(`Image input config height doesn't match HTMLImageElement height`);
                  if (((c.height = i), n.width !== void 0 && n.width !== a))
                    throw Error(`Image input config width doesn't match HTMLImageElement width`);
                  c.width = a;
                } else ((c.tensorFormat = `RGBA`), (c.height = i), (c.width = a));
                ((e.width = a), (e.height = i), r.drawImage(t, 0, 0, a, i), (s = r.getImageData(0, 0, a, i).data));
              } else throw Error(`Can not access image data`);
            } else if (i) {
              let e = `RGBA`,
                r,
                i;
              if (
                (n !== void 0 && n.resizedWidth !== void 0 && n.resizedHeight !== void 0
                  ? ((r = n.resizedHeight), (i = n.resizedWidth))
                  : ((r = t.height), (i = t.width)),
                n !== void 0)
              ) {
                if (((c = n), n.bitmapFormat !== void 0 && n.bitmapFormat !== `RGBA`))
                  throw Error(`Image input config format must be RGBA for ImageData`);
                c.bitmapFormat = `RGBA`;
              } else c.bitmapFormat = `RGBA`;
              if (((c.height = r), (c.width = i), n !== void 0)) {
                let e = document.createElement(`canvas`);
                ((e.width = i), (e.height = r));
                let n = e.getContext(`2d`);
                if (n != null) (n.putImageData(t, 0, 0), (s = n.getImageData(0, 0, i, r).data));
                else throw Error(`Can not access image data`);
              } else s = t.data;
            } else if (a) {
              if (n === void 0) throw Error(`Please provide image config with format for Imagebitmap`);
              if (n.bitmapFormat !== void 0) throw Error(`Image input config format must be defined for ImageBitmap`);
              let r = document.createElement(`canvas`).getContext(`2d`);
              if (r != null) {
                let i = t.height,
                  a = t.width;
                if ((r.drawImage(t, 0, 0, a, i), (s = r.getImageData(0, 0, a, i).data), n !== void 0)) {
                  if (n.height !== void 0 && n.height !== i)
                    throw Error(`Image input config height doesn't match ImageBitmap height`);
                  if (((c.height = i), n.width !== void 0 && n.width !== a))
                    throw Error(`Image input config width doesn't match ImageBitmap width`);
                  c.width = a;
                } else ((c.height = i), (c.width = a));
                return e.bufferToTensor(s, c);
              } else throw Error(`Can not access image data`);
            } else if (o)
              return new Promise((r, i) => {
                let a = document.createElement(`canvas`),
                  o = a.getContext(`2d`);
                if (!t || !o) return i();
                let s = new Image();
                ((s.crossOrigin = `Anonymous`),
                  (s.src = t),
                  (s.onload = () => {
                    ((a.width = s.width), (a.height = s.height), o.drawImage(s, 0, 0, a.width, a.height));
                    let t = o.getImageData(0, 0, a.width, a.height);
                    if (n !== void 0) {
                      if (n.height !== void 0 && n.height !== a.height)
                        throw Error(`Image input config height doesn't match ImageBitmap height`);
                      if (((c.height = a.height), n.width !== void 0 && n.width !== a.width))
                        throw Error(`Image input config width doesn't match ImageBitmap width`);
                      c.width = a.width;
                    } else ((c.height = a.height), (c.width = a.width));
                    r(e.bufferToTensor(t.data, c));
                  }));
              });
            else throw Error(`Input data provided is not supported - aborted tensor creation`);
            if (s !== void 0) return e.bufferToTensor(s, c);
            throw Error(`Input data provided is not supported - aborted tensor creation`);
          }
          toImageData(e) {
            var t, n;
            let r = document.createElement(`canvas`).getContext(`2d`),
              i;
            if (r != null) {
              let t = this.dims[3],
                n = this.dims[2],
                a = this.dims[1],
                o = e === void 0 || e.format === void 0 ? `RGB` : e.format,
                s = e === void 0 || e.norm?.mean === void 0 ? 255 : e.norm.mean,
                c = e === void 0 || e.norm?.bias === void 0 ? 0 : e.norm.bias,
                l = n * t;
              if (e !== void 0) {
                if (e.height !== void 0 && e.height !== n)
                  throw Error(`Image output config height doesn't match tensor height`);
                if (e.width !== void 0 && e.width !== t)
                  throw Error(`Image output config width doesn't match tensor width`);
                if (
                  (e.format !== void 0 && a === 4 && e.format !== `RGBA`) ||
                  (a === 3 && e.format !== `RGB` && e.format !== `BGR`)
                )
                  throw Error(`Tensor format doesn't match input tensor dims`);
              }
              let u = 4,
                d = 0,
                f = 1,
                p = 2,
                m = 3,
                h = 0,
                g = l,
                _ = l * 2,
                v = -1;
              (o === `RGBA`
                ? ((h = 0), (g = l), (_ = l * 2), (v = l * 3))
                : o === `RGB`
                  ? ((h = 0), (g = l), (_ = l * 2))
                  : o === `RBG` && ((h = 0), (_ = l), (g = l * 2)),
                (i = r.createImageData(t, n)));
              for (let e = 0; e < n * t; d += 4, f += 4, p += 4, m += 4, e++)
                ((i.data[d] = (this.data[h++] - c) * s),
                  (i.data[f] = (this.data[g++] - c) * s),
                  (i.data[p] = (this.data[_++] - c) * s),
                  (i.data[m] = v === -1 ? 255 : (this.data[v++] - c) * s));
            } else throw Error(`Can not access image data`);
            return i;
          }
          reshape(t) {
            return new e(this.type, this.data, t);
          }
        }));
    }),
    Tensor$1,
    init_tensor = __esmMin(() => {
      (init_tensor_impl(), (Tensor$1 = Tensor$2));
    }),
    InferenceSession$2,
    init_inference_session_impl = __esmMin(() => {
      (init_backend_impl(),
        init_tensor(),
        (InferenceSession$2 = class e {
          constructor(e) {
            this.handler = e;
          }
          async run(e, t, n) {
            let r = {},
              i = {};
            if (typeof e != `object` || !e || e instanceof Tensor$1 || Array.isArray(e))
              throw TypeError(
                `'feeds' must be an object that use input names as keys and OnnxValue as corresponding values.`,
              );
            let a = !0;
            if (typeof t == `object`) {
              if (t === null) throw TypeError(`Unexpected argument[1]: cannot be null.`);
              if (t instanceof Tensor$1) throw TypeError(`'fetches' cannot be a Tensor`);
              if (Array.isArray(t)) {
                if (t.length === 0) throw TypeError(`'fetches' cannot be an empty array.`);
                a = !1;
                for (let e of t) {
                  if (typeof e != `string`) throw TypeError(`'fetches' must be a string array or an object.`);
                  if (this.outputNames.indexOf(e) === -1)
                    throw RangeError(`'fetches' contains invalid output name: ${e}.`);
                  r[e] = null;
                }
                if (typeof n == `object` && n) i = n;
                else if (n !== void 0) throw TypeError(`'options' must be an object.`);
              } else {
                let e = !1,
                  o = Object.getOwnPropertyNames(t);
                for (let n of this.outputNames)
                  if (o.indexOf(n) !== -1) {
                    let i = t[n];
                    (i === null || i instanceof Tensor$1) && ((e = !0), (a = !1), (r[n] = i));
                  }
                if (e) {
                  if (typeof n == `object` && n) i = n;
                  else if (n !== void 0) throw TypeError(`'options' must be an object.`);
                } else i = t;
              }
            } else if (t !== void 0) throw TypeError(`Unexpected argument[1]: must be 'fetches' or 'options'.`);
            for (let t of this.inputNames) if (e[t] === void 0) throw Error(`input '${t}' is missing in 'feeds'.`);
            if (a) for (let e of this.outputNames) r[e] = null;
            let o = await this.handler.run(e, r, i),
              s = {};
            for (let e in o) Object.hasOwnProperty.call(o, e) && (s[e] = new Tensor$1(o[e].type, o[e].data, o[e].dims));
            return s;
          }
          static async create(t, n, r, i) {
            let a,
              o = {};
            if (typeof t == `string`) {
              if (((a = t), typeof n == `object` && n)) o = n;
              else if (n !== void 0) throw TypeError(`'options' must be an object.`);
            } else if (t instanceof Uint8Array) {
              if (((a = t), typeof n == `object` && n)) o = n;
              else if (n !== void 0) throw TypeError(`'options' must be an object.`);
            } else if (t instanceof ArrayBuffer || (typeof SharedArrayBuffer < `u` && t instanceof SharedArrayBuffer)) {
              let e = t,
                s = 0,
                c = t.byteLength;
              if (typeof n == `object` && n) o = n;
              else if (typeof n == `number`) {
                if (((s = n), !Number.isSafeInteger(s))) throw RangeError(`'byteOffset' must be an integer.`);
                if (s < 0 || s >= e.byteLength) throw RangeError(`'byteOffset' is out of range [0, ${e.byteLength}).`);
                if (((c = t.byteLength - s), typeof r == `number`)) {
                  if (((c = r), !Number.isSafeInteger(c))) throw RangeError(`'byteLength' must be an integer.`);
                  if (c <= 0 || s + c > e.byteLength)
                    throw RangeError(`'byteLength' is out of range (0, ${e.byteLength - s}].`);
                  if (typeof i == `object` && i) o = i;
                  else if (i !== void 0) throw TypeError(`'options' must be an object.`);
                } else if (r !== void 0) throw TypeError(`'byteLength' must be a number.`);
              } else if (n !== void 0) throw TypeError(`'options' must be an object.`);
              a = new Uint8Array(e, s, c);
            } else throw TypeError(`Unexpected argument[0]: must be 'path' or 'buffer'.`);
            return new e(
              await (
                await resolveBackend((o.executionProviders || []).map((e) => (typeof e == `string` ? e : e.name)))
              ).createSessionHandler(a, o),
            );
          }
          startProfiling() {
            this.handler.startProfiling();
          }
          endProfiling() {
            this.handler.endProfiling();
          }
          get inputNames() {
            return this.handler.inputNames;
          }
          get outputNames() {
            return this.handler.outputNames;
          }
        }));
    }),
    InferenceSession$1,
    init_inference_session = __esmMin(() => {
      (init_inference_session_impl(), (InferenceSession$1 = InferenceSession$2));
    }),
    init_onnx_value = __esmMin(() => {}),
    lib_exports = __exportAll({
      InferenceSession: () => InferenceSession$1,
      Tensor: () => Tensor$1,
      env: () => env$2,
      registerBackend: () => registerBackend,
    }),
    init_lib = __esmMin(() => {
      (init_backend(), init_env(), init_inference_session(), init_tensor(), init_onnx_value());
    }),
    require_ort_web_min = __commonJSMin((exports, module) => {
      /*!
       * ONNX Runtime Web v1.14.0
       * Copyright (c) Microsoft Corporation. All rights reserved.
       * Licensed under the MIT License.
       */
      (function (e, t) {
        if (typeof exports == `object` && typeof module == `object`)
          module.exports = t((init_lib(), __toCommonJS(lib_exports)));
        else if (typeof define == `function` && define.amd) define([], t);
        else {
          var n = t(typeof exports == `object` ? (init_lib(), __toCommonJS(lib_exports)) : e.ort);
          for (var r in n) (typeof exports == `object` ? exports : e)[r] = n[r];
        }
      })(self, (__WEBPACK_EXTERNAL_MODULE__1670__) =>
        (() => {
          var __webpack_modules__ = {
              3474: (e, t, n) => {
                var r;
                e.exports =
                  ((r =
                    (r = typeof document < `u` && document.currentScript ? document.currentScript.src : void 0) ||
                    `/index.js`),
                  function (e) {
                    function t() {
                      return (M.buffer != P && R(M.buffer), F);
                    }
                    function i() {
                      return (M.buffer != P && R(M.buffer), ee);
                    }
                    function a() {
                      return (M.buffer != P && R(M.buffer), te);
                    }
                    function o() {
                      return (M.buffer != P && R(M.buffer), ne);
                    }
                    function s() {
                      return (M.buffer != P && R(M.buffer), re);
                    }
                    var c, l, u;
                    ((e ||= {}),
                      (c ||= e === void 0 ? {} : e),
                      (c.ready = new Promise(function (e, t) {
                        ((l = e), (u = t));
                      })));
                    var d,
                      f,
                      p,
                      m,
                      h,
                      g,
                      _ = Object.assign({}, c),
                      v = `./this.program`,
                      y = (e, t) => {
                        throw t;
                      },
                      b = typeof window == `object`,
                      x = typeof importScripts == `function`,
                      S =
                        typeof process == `object` &&
                        typeof process.versions == `object` &&
                        typeof process.versions.node == `string`,
                      C = c.ENVIRONMENT_IS_PTHREAD || !1,
                      w = ``;
                    function T(e) {
                      return c.locateFile ? c.locateFile(e, w) : w + e;
                    }
                    if (S) {
                      let e;
                      ((w = x ? n(908).dirname(w) + `/` : `//`),
                        (g = () => {
                          h ||= ((m = n(1384)), n(908));
                        }),
                        (d = function (e, t) {
                          return (g(), (e = h.normalize(e)), m.readFileSync(e, t ? void 0 : `utf8`));
                        }),
                        (p = (e) => ((e = d(e, !0)).buffer || (e = new Uint8Array(e)), e)),
                        (f = (e, t, n) => {
                          (g(),
                            (e = h.normalize(e)),
                            m.readFile(e, function (e, r) {
                              e ? n(e) : t(r.buffer);
                            }));
                        }),
                        1 < process.argv.length && (v = process.argv[1].replace(/\\/g, `/`)),
                        process.argv.slice(2),
                        process.on(`uncaughtException`, function (e) {
                          if (!(e instanceof be)) throw e;
                        }),
                        process.on(`unhandledRejection`, function (e) {
                          throw e;
                        }),
                        (y = (e, t) => {
                          if (pe()) throw ((process.exitCode = e), t);
                          (t instanceof be || A(`exiting due to exception: ` + t), process.exit(e));
                        }),
                        (c.inspect = function () {
                          return `[Emscripten Module object]`;
                        }));
                      try {
                        e = n(9925);
                      } catch (e) {
                        throw (
                          console.error(
                            `The "worker_threads" module is not supported in this node.js build - perhaps a newer version is needed?`,
                          ),
                          e
                        );
                      }
                      n.g.Worker = e.Worker;
                    } else
                      (b || x) &&
                        (x
                          ? (w = self.location.href)
                          : typeof document < `u` && document.currentScript && (w = document.currentScript.src),
                        r && (w = r),
                        (w = w.indexOf(`blob:`) === 0 ? `` : w.substr(0, w.replace(/[?#].*/, ``).lastIndexOf(`/`) + 1)),
                        S ||
                          ((d = (e) => {
                            var t = new XMLHttpRequest();
                            return (t.open(`GET`, e, !1), t.send(null), t.responseText);
                          }),
                          x &&
                            (p = (e) => {
                              var t = new XMLHttpRequest();
                              return (
                                t.open(`GET`, e, !1),
                                (t.responseType = `arraybuffer`),
                                t.send(null),
                                new Uint8Array(t.response)
                              );
                            }),
                          (f = (e, t, n) => {
                            var r = new XMLHttpRequest();
                            (r.open(`GET`, e, !0),
                              (r.responseType = `arraybuffer`),
                              (r.onload = () => {
                                r.status == 200 || (r.status == 0 && r.response) ? t(r.response) : n();
                              }),
                              (r.onerror = n),
                              r.send(null));
                          })));
                    S && typeof performance > `u` && (n.g.performance = n(6953).performance);
                    var E = console.log.bind(console),
                      D = console.warn.bind(console);
                    S &&
                      (g(),
                      (E = (e) =>
                        m.writeSync(
                          1,
                          e +
                            `
`,
                        )),
                      (D = (e) =>
                        m.writeSync(
                          2,
                          e +
                            `
`,
                        )));
                    var O,
                      k = c.print || E,
                      A = c.printErr || D;
                    (Object.assign(c, _),
                      (_ = null),
                      c.thisProgram && (v = c.thisProgram),
                      c.quit && (y = c.quit),
                      c.wasmBinary && (O = c.wasmBinary));
                    var j = c.noExitRuntime || !1;
                    typeof WebAssembly != `object` && H(`no native wasm support detected`);
                    var M,
                      N,
                      P,
                      F,
                      ee,
                      te,
                      ne,
                      re,
                      ie = !1,
                      ae = typeof TextDecoder < `u` ? new TextDecoder(`utf8`) : void 0;
                    function oe(e, t, n) {
                      var r = (t >>>= 0) + n;
                      for (n = t; e[n] && !(n >= r); ) ++n;
                      if (16 < n - t && e.buffer && ae)
                        return ae.decode(e.buffer instanceof SharedArrayBuffer ? e.slice(t, n) : e.subarray(t, n));
                      for (r = ``; t < n; ) {
                        var i = e[t++];
                        if (128 & i) {
                          var a = 63 & e[t++];
                          if ((224 & i) == 192) r += String.fromCharCode(((31 & i) << 6) | a);
                          else {
                            var o = 63 & e[t++];
                            65536 >
                            (i =
                              (240 & i) == 224
                                ? ((15 & i) << 12) | (a << 6) | o
                                : ((7 & i) << 18) | (a << 12) | (o << 6) | (63 & e[t++]))
                              ? (r += String.fromCharCode(i))
                              : ((i -= 65536), (r += String.fromCharCode(55296 | (i >> 10), 56320 | (1023 & i))));
                          }
                        } else r += String.fromCharCode(i);
                      }
                      return r;
                    }
                    function I(e, t) {
                      return (e >>>= 0) ? oe(i(), e, t) : ``;
                    }
                    function L(e, t, n, r) {
                      if (!(0 < r)) return 0;
                      var i = (n >>>= 0);
                      r = n + r - 1;
                      for (var a = 0; a < e.length; ++a) {
                        var o = e.charCodeAt(a);
                        if (
                          (55296 <= o && 57343 >= o && (o = (65536 + ((1023 & o) << 10)) | (1023 & e.charCodeAt(++a))),
                          127 >= o)
                        ) {
                          if (n >= r) break;
                          t[n++ >>> 0] = o;
                        } else {
                          if (2047 >= o) {
                            if (n + 1 >= r) break;
                            t[n++ >>> 0] = 192 | (o >> 6);
                          } else {
                            if (65535 >= o) {
                              if (n + 2 >= r) break;
                              t[n++ >>> 0] = 224 | (o >> 12);
                            } else {
                              if (n + 3 >= r) break;
                              ((t[n++ >>> 0] = 240 | (o >> 18)), (t[n++ >>> 0] = 128 | ((o >> 12) & 63)));
                            }
                            t[n++ >>> 0] = 128 | ((o >> 6) & 63);
                          }
                          t[n++ >>> 0] = 128 | (63 & o);
                        }
                      }
                      return ((t[n >>> 0] = 0), n - i);
                    }
                    function se(e) {
                      for (var t = 0, n = 0; n < e.length; ++n) {
                        var r = e.charCodeAt(n);
                        127 >= r ? t++ : 2047 >= r ? (t += 2) : 55296 <= r && 57343 >= r ? ((t += 4), ++n) : (t += 3);
                      }
                      return t;
                    }
                    function R(e) {
                      ((P = e),
                        (c.HEAP8 = F = new Int8Array(e)),
                        (c.HEAP16 = new Int16Array(e)),
                        (c.HEAP32 = te = new Int32Array(e)),
                        (c.HEAPU8 = ee = new Uint8Array(e)),
                        (c.HEAPU16 = new Uint16Array(e)),
                        (c.HEAPU32 = ne = new Uint32Array(e)),
                        (c.HEAPF32 = new Float32Array(e)),
                        (c.HEAPF64 = re = new Float64Array(e)));
                    }
                    C && (P = c.buffer);
                    var z = c.INITIAL_MEMORY || 16777216;
                    if (C) ((M = c.wasmMemory), (P = c.buffer));
                    else if (c.wasmMemory) M = c.wasmMemory;
                    else if (
                      !(
                        (M = new WebAssembly.Memory({ initial: z / 65536, maximum: 65536, shared: !0 }))
                          .buffer instanceof SharedArrayBuffer
                      )
                    )
                      throw (
                        A(
                          `requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag`,
                        ),
                        S &&
                          console.log(
                            `(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and also use a recent version)`,
                          ),
                        Error(`bad memory`)
                      );
                    (M && (P = M.buffer), (z = P.byteLength), R(P));
                    var ce,
                      le = [],
                      ue = [],
                      de = [],
                      fe = [];
                    function pe() {
                      return j || !1;
                    }
                    function me() {
                      var e = c.preRun.shift();
                      le.unshift(e);
                    }
                    var B,
                      V = 0,
                      he = null,
                      ge = null;
                    function H(e) {
                      throw (
                        C ? postMessage({ cmd: `onAbort`, arg: e }) : c.onAbort && c.onAbort(e),
                        A((e = `Aborted(` + e + `)`)),
                        (ie = !0),
                        (e = new WebAssembly.RuntimeError(e + `. Build with -sASSERTIONS for more info.`)),
                        u(e),
                        e
                      );
                    }
                    function _e() {
                      return B.startsWith(`data:application/octet-stream;base64,`);
                    }
                    function ve() {
                      var e = B;
                      try {
                        if (e == B && O) return new Uint8Array(O);
                        if (p) return p(e);
                        throw `both async and sync fetching of the wasm failed`;
                      } catch (e) {
                        H(e);
                      }
                    }
                    ((B = `ort-wasm-threaded.wasm`), _e() || (B = T(B)));
                    var ye = {};
                    function be(e) {
                      ((this.name = `ExitStatus`),
                        (this.message = `Program terminated with exit(` + e + `)`),
                        (this.status = e));
                    }
                    function xe(e) {
                      ((e = W.Vb[e]) || H(), W.mc(e));
                    }
                    function Se(e) {
                      var t = W.Cc();
                      if (!t) return 6;
                      (W.ac.push(t), (W.Vb[e.Ub] = t), (t.Ub = e.Ub));
                      var n = { cmd: `run`, start_routine: e.Ic, arg: e.zc, pthread_ptr: e.Ub };
                      return (
                        (t.$b = () => {
                          ((n.time = performance.now()), t.postMessage(n, e.Nc));
                        }),
                        t.loaded && (t.$b(), delete t.$b),
                        0
                      );
                    }
                    function U(e) {
                      if (C) return Y(1, 1, e);
                      (pe() || (W.oc(), c.onExit && c.onExit(e), (ie = !0)), y(e, new be(e)));
                    }
                    function Ce(e, t) {
                      if (!t && C) throw (Ee(e), `unwind`);
                      (pe() || C || (xt(), we(de), bt(0), ct[1].length && lt(1, 10), ct[2].length && lt(2, 10), W.oc()),
                        U(e));
                    }
                    var W = {
                      Yb: [],
                      ac: [],
                      qc: [],
                      Vb: {},
                      fc: function () {
                        C && W.Ec();
                      },
                      Pc: function () {},
                      Ec: function () {
                        ((W.receiveObjectTransfer = W.Gc),
                          (W.threadInitTLS = W.pc),
                          (W.setExitStatus = W.nc),
                          (j = !1));
                      },
                      nc: function () {},
                      oc: function () {
                        for (var e of Object.values(W.Vb)) W.mc(e);
                        for (e of W.Yb) e.terminate();
                        W.Yb = [];
                      },
                      mc: function (e) {
                        var t = e.Ub;
                        (delete W.Vb[t], W.Yb.push(e), W.ac.splice(W.ac.indexOf(e), 1), (e.Ub = 0), Et(t));
                      },
                      Gc: function () {},
                      pc: function () {
                        W.qc.forEach((e) => e());
                      },
                      Fc: function (e, t) {
                        ((e.onmessage = (n) => {
                          var r = (n = n.data).cmd;
                          if ((e.Ub && (W.Bc = e.Ub), n.targetThread && n.targetThread != _t())) {
                            var i = W.Vb[n.Qc];
                            i
                              ? i.postMessage(n, n.transferList)
                              : A(
                                  `Internal error! Worker sent a message "` +
                                    r +
                                    `" to target pthread ` +
                                    n.targetThread +
                                    `, but that thread no longer exists!`,
                                );
                          } else
                            r === `processProxyingQueue`
                              ? qe(n.queue)
                              : r === `spawnThread`
                                ? Se(n)
                                : r === `cleanupThread`
                                  ? xe(n.thread)
                                  : r === `killThread`
                                    ? ((n = n.thread),
                                      (r = W.Vb[n]),
                                      delete W.Vb[n],
                                      r.terminate(),
                                      Et(n),
                                      W.ac.splice(W.ac.indexOf(r), 1),
                                      (r.Ub = 0))
                                    : r === `cancelThread`
                                      ? W.Vb[n.thread].postMessage({ cmd: `cancel` })
                                      : r === `loaded`
                                        ? ((e.loaded = !0), t && t(e), e.$b && (e.$b(), delete e.$b))
                                        : r === `print`
                                          ? k(`Thread ` + n.threadId + `: ` + n.text)
                                          : r === `printErr`
                                            ? A(`Thread ` + n.threadId + `: ` + n.text)
                                            : r === `alert`
                                              ? alert(`Thread ` + n.threadId + `: ` + n.text)
                                              : n.target === `setimmediate`
                                                ? e.postMessage(n)
                                                : r === `onAbort`
                                                  ? c.onAbort && c.onAbort(n.arg)
                                                  : r && A(`worker sent an unknown command ` + r);
                          W.Bc = void 0;
                        }),
                          (e.onerror = (e) => {
                            throw (A(`worker sent an error! ` + e.filename + `:` + e.lineno + `: ` + e.message), e);
                          }),
                          S &&
                            (e.on(`message`, function (t) {
                              e.onmessage({ data: t });
                            }),
                            e.on(`error`, function (t) {
                              e.onerror(t);
                            }),
                            e.on(`detachedExit`, function () {})),
                          e.postMessage({
                            cmd: `load`,
                            urlOrBlob: c.mainScriptUrlOrBlob || r,
                            wasmMemory: M,
                            wasmModule: N,
                          }));
                      },
                      yc: function () {
                        var e = T(`ort-wasm-threaded.worker.js`);
                        W.Yb.push(new Worker(e));
                      },
                      Cc: function () {
                        return (W.Yb.length == 0 && (W.yc(), W.Fc(W.Yb[0])), W.Yb.pop());
                      },
                    };
                    function we(e) {
                      for (; 0 < e.length; ) e.shift()(c);
                    }
                    function Te(e) {
                      var t = Q();
                      return ((e = e()), $(t), e);
                    }
                    function Ee(e) {
                      if (C) return Y(2, 0, e);
                      try {
                        Ce(e);
                      } catch (e) {
                        e instanceof be || e == `unwind` || y(1, e);
                      }
                    }
                    ((c.PThread = W),
                      (c.establishStackSpace = function () {
                        var e = _t(),
                          t = a()[((e + 44) >> 2) >>> 0];
                        ((e = a()[((e + 48) >> 2) >>> 0]), Ot(t, t - e), $(t));
                      }));
                    var De = [];
                    function G(e) {
                      var t = De[e];
                      return (t || (e >= De.length && (De.length = e + 1), (De[e] = t = ce.get(e))), t);
                    }
                    c.invokeEntryPoint = function (e, t) {
                      ((e = G(e)(t)), pe() ? W.nc(e) : Dt(e));
                    };
                    var Oe,
                      ke,
                      Ae = [],
                      K = 0,
                      q = 0;
                    function J(e) {
                      ((this.Zb = e),
                        (this.Sb = e - 24),
                        (this.xc = function (e) {
                          o()[((this.Sb + 4) >> 2) >>> 0] = e;
                        }),
                        (this.bc = function () {
                          return o()[((this.Sb + 4) >> 2) >>> 0];
                        }),
                        (this.wc = function (e) {
                          o()[((this.Sb + 8) >> 2) >>> 0] = e;
                        }),
                        (this.Dc = function () {
                          return o()[((this.Sb + 8) >> 2) >>> 0];
                        }),
                        (this.rc = function () {
                          a()[(this.Sb >> 2) >>> 0] = 0;
                        }),
                        (this.hc = function (e) {
                          ((e = +!!e), (t()[((this.Sb + 12) >> 0) >>> 0] = e));
                        }),
                        (this.uc = function () {
                          return t()[((this.Sb + 12) >> 0) >>> 0] != 0;
                        }),
                        (this.ic = function (e) {
                          ((e = +!!e), (t()[((this.Sb + 13) >> 0) >>> 0] = e));
                        }),
                        (this.kc = function () {
                          return t()[((this.Sb + 13) >> 0) >>> 0] != 0;
                        }),
                        (this.fc = function (e, t) {
                          (this.cc(0), this.xc(e), this.wc(t), this.rc(), this.hc(!1), this.ic(!1));
                        }),
                        (this.sc = function () {
                          Atomics.add(a(), this.Sb >> 2, 1);
                        }),
                        (this.Hc = function () {
                          return Atomics.sub(a(), this.Sb >> 2, 1) === 1;
                        }),
                        (this.cc = function (e) {
                          o()[((this.Sb + 16) >> 2) >>> 0] = e;
                        }),
                        (this.tc = function () {
                          return o()[((this.Sb + 16) >> 2) >>> 0];
                        }),
                        (this.vc = function () {
                          if (jt(this.bc())) return o()[(this.Zb >> 2) >>> 0];
                          var e = this.tc();
                          return e === 0 ? this.Zb : e;
                        }));
                    }
                    function je(e) {
                      return yt(new J(e).Sb);
                    }
                    function Me(e, t, n, r) {
                      return C ? Y(3, 1, e, t, n, r) : Ne(e, t, n, r);
                    }
                    function Ne(e, t, n, r) {
                      if (typeof SharedArrayBuffer > `u`)
                        return (
                          A(`Current environment does not support SharedArrayBuffer, pthreads are not available!`),
                          6
                        );
                      var i = [];
                      return C && i.length === 0
                        ? Me(e, t, n, r)
                        : ((e = { Ic: n, Ub: e, zc: r, Nc: i }),
                          C ? ((e.Oc = `spawnThread`), postMessage(e, i), 0) : Se(e));
                    }
                    function Pe(e, t, n) {
                      return C ? Y(4, 1, e, t, n) : 0;
                    }
                    function Fe(e, t) {
                      if (C) return Y(5, 1, e, t);
                    }
                    function Ie(e, t) {
                      if (C) return Y(6, 1, e, t);
                    }
                    function Le(e, t, n) {
                      if (C) return Y(7, 1, e, t, n);
                    }
                    function Re(e, t, n) {
                      return C ? Y(8, 1, e, t, n) : 0;
                    }
                    function ze(e, t) {
                      if (C) return Y(9, 1, e, t);
                    }
                    function Be(e, t, n) {
                      if (C) return Y(10, 1, e, t, n);
                    }
                    function Ve(e, t, n, r) {
                      if (C) return Y(11, 1, e, t, n, r);
                    }
                    function He(e, t, n, r) {
                      if (C) return Y(12, 1, e, t, n, r);
                    }
                    function Ue(e, t, n, r) {
                      if (C) return Y(13, 1, e, t, n, r);
                    }
                    function We(e) {
                      if (C) return Y(14, 1, e);
                    }
                    function Ge(e, t) {
                      if (C) return Y(15, 1, e, t);
                    }
                    function Ke(e, t, n) {
                      if (C) return Y(16, 1, e, t, n);
                    }
                    function qe(e) {
                      (Atomics.store(a(), e >> 2, 1), _t() && Tt(e), Atomics.compareExchange(a(), e >> 2, 1, 0));
                    }
                    function Je(e) {
                      return o()[e >>> 2] + 4294967296 * a()[(e + 4) >>> 2];
                    }
                    function Ye(e, t, n, r, i, a) {
                      return C ? Y(17, 1, e, t, n, r, i, a) : -52;
                    }
                    function Xe(e, t, n, r, i, a) {
                      if (C) return Y(18, 1, e, t, n, r, i, a);
                    }
                    function Ze(e) {
                      var n = se(e) + 1,
                        r = vt(n);
                      return (r && L(e, t(), r, n), r);
                    }
                    function Qe(e, t, n) {
                      function r(e) {
                        return (e = e.toTimeString().match(/\(([A-Za-z ]+)\)$/)) ? e[1] : `GMT`;
                      }
                      if (C) return Y(19, 1, e, t, n);
                      var i = new Date().getFullYear(),
                        s = new Date(i, 0, 1),
                        c = new Date(i, 6, 1);
                      i = s.getTimezoneOffset();
                      var l = c.getTimezoneOffset(),
                        u = Math.max(i, l);
                      ((a()[(e >> 2) >>> 0] = 60 * u),
                        (a()[(t >> 2) >>> 0] = Number(i != l)),
                        (e = r(s)),
                        (t = r(c)),
                        (e = Ze(e)),
                        (t = Ze(t)),
                        l < i
                          ? ((o()[(n >> 2) >>> 0] = e), (o()[((n + 4) >> 2) >>> 0] = t))
                          : ((o()[(n >> 2) >>> 0] = t), (o()[((n + 4) >> 2) >>> 0] = e)));
                    }
                    function Y(e, t) {
                      var n = arguments.length - 2,
                        r = arguments;
                      return Te(() => {
                        for (var i = kt(8 * n), a = i >> 3, o = 0; o < n; o++) {
                          var c = r[2 + o];
                          s()[(a + o) >>> 0] = c;
                        }
                        return wt(e, n, i, t);
                      });
                    }
                    ((c.executeNotifiedProxyingQueue = qe),
                      (ke = S
                        ? () => {
                            var e = process.hrtime();
                            return 1e3 * e[0] + e[1] / 1e6;
                          }
                        : C
                          ? () => performance.now() - c.__performance_now_clock_drift
                          : () => performance.now()));
                    var $e,
                      et = [],
                      tt = {};
                    function nt() {
                      if (!$e) {
                        var e,
                          t = {
                            USER: `web_user`,
                            LOGNAME: `web_user`,
                            PATH: `/`,
                            PWD: `/`,
                            HOME: `/home/web_user`,
                            LANG:
                              (
                                (typeof navigator == `object` && navigator.languages && navigator.languages[0]) ||
                                `C`
                              ).replace(`-`, `_`) + `.UTF-8`,
                            _: v || `./this.program`,
                          };
                        for (e in tt) tt[e] === void 0 ? delete t[e] : (t[e] = tt[e]);
                        var n = [];
                        for (e in t) n.push(e + `=` + t[e]);
                        $e = n;
                      }
                      return $e;
                    }
                    function rt(e, n) {
                      if (C) return Y(20, 1, e, n);
                      var r = 0;
                      return (
                        nt().forEach(function (i, a) {
                          var s = n + r;
                          for (a = o()[((e + 4 * a) >> 2) >>> 0] = s, s = 0; s < i.length; ++s)
                            t()[(a++ >> 0) >>> 0] = i.charCodeAt(s);
                          ((t()[(a >> 0) >>> 0] = 0), (r += i.length + 1));
                        }),
                        0
                      );
                    }
                    function it(e, t) {
                      if (C) return Y(21, 1, e, t);
                      var n = nt();
                      o()[(e >> 2) >>> 0] = n.length;
                      var r = 0;
                      return (
                        n.forEach(function (e) {
                          r += e.length + 1;
                        }),
                        (o()[(t >> 2) >>> 0] = r),
                        0
                      );
                    }
                    function at(e) {
                      return C ? Y(22, 1, e) : 52;
                    }
                    function ot(e, t, n, r) {
                      return C ? Y(23, 1, e, t, n, r) : 52;
                    }
                    function st(e, t, n, r, i) {
                      return C ? Y(24, 1, e, t, n, r, i) : 70;
                    }
                    var ct = [null, [], []];
                    function lt(e, t) {
                      var n = ct[e];
                      t === 0 || t === 10 ? ((e === 1 ? k : A)(oe(n, 0)), (n.length = 0)) : n.push(t);
                    }
                    function ut(e, t, n, r) {
                      if (C) return Y(25, 1, e, t, n, r);
                      for (var a = 0, s = 0; s < n; s++) {
                        var c = o()[(t >> 2) >>> 0],
                          l = o()[((t + 4) >> 2) >>> 0];
                        t += 8;
                        for (var u = 0; u < l; u++) lt(e, i()[(c + u) >>> 0]);
                        a += l;
                      }
                      return ((o()[(r >> 2) >>> 0] = a), 0);
                    }
                    var X = 0;
                    function dt(e) {
                      return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
                    }
                    var ft = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                      pt = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                    function mt(e, n, r, i) {
                      function o(e, t, n) {
                        for (e = typeof e == `number` ? e.toString() : e || ``; e.length < t; ) e = n[0] + e;
                        return e;
                      }
                      function s(e, t) {
                        return o(e, t, `0`);
                      }
                      function c(e, t) {
                        function n(e) {
                          return 0 > e ? -1 : +(0 < e);
                        }
                        var r;
                        return (
                          (r = n(e.getFullYear() - t.getFullYear())) === 0 &&
                            (r = n(e.getMonth() - t.getMonth())) === 0 &&
                            (r = n(e.getDate() - t.getDate())),
                          r
                        );
                      }
                      function l(e) {
                        switch (e.getDay()) {
                          case 0:
                            return new Date(e.getFullYear() - 1, 11, 29);
                          case 1:
                            return e;
                          case 2:
                            return new Date(e.getFullYear(), 0, 3);
                          case 3:
                            return new Date(e.getFullYear(), 0, 2);
                          case 4:
                            return new Date(e.getFullYear(), 0, 1);
                          case 5:
                            return new Date(e.getFullYear() - 1, 11, 31);
                          case 6:
                            return new Date(e.getFullYear() - 1, 11, 30);
                        }
                      }
                      function u(e) {
                        var t = e.Wb;
                        for (e = new Date(new Date(e.Xb + 1900, 0, 1).getTime()); 0 < t; ) {
                          var n = e.getMonth(),
                            r = (dt(e.getFullYear()) ? ft : pt)[n];
                          if (!(t > r - e.getDate())) {
                            e.setDate(e.getDate() + t);
                            break;
                          }
                          ((t -= r - e.getDate() + 1),
                            e.setDate(1),
                            11 > n ? e.setMonth(n + 1) : (e.setMonth(0), e.setFullYear(e.getFullYear() + 1)));
                        }
                        return (
                          (n = new Date(e.getFullYear() + 1, 0, 4)),
                          (t = l(new Date(e.getFullYear(), 0, 4))),
                          (n = l(n)),
                          0 >= c(t, e) ? (0 >= c(n, e) ? e.getFullYear() + 1 : e.getFullYear()) : e.getFullYear() - 1
                        );
                      }
                      var d = a()[((i + 40) >> 2) >>> 0];
                      for (var f in ((i = {
                        Lc: a()[(i >> 2) >>> 0],
                        Kc: a()[((i + 4) >> 2) >>> 0],
                        dc: a()[((i + 8) >> 2) >>> 0],
                        jc: a()[((i + 12) >> 2) >>> 0],
                        ec: a()[((i + 16) >> 2) >>> 0],
                        Xb: a()[((i + 20) >> 2) >>> 0],
                        Tb: a()[((i + 24) >> 2) >>> 0],
                        Wb: a()[((i + 28) >> 2) >>> 0],
                        Rc: a()[((i + 32) >> 2) >>> 0],
                        Jc: a()[((i + 36) >> 2) >>> 0],
                        Mc: d ? I(d) : ``,
                      }),
                      (r = I(r)),
                      (d = {
                        '%c': `%a %b %d %H:%M:%S %Y`,
                        '%D': `%m/%d/%y`,
                        '%F': `%Y-%m-%d`,
                        '%h': `%b`,
                        '%r': `%I:%M:%S %p`,
                        '%R': `%H:%M`,
                        '%T': `%H:%M:%S`,
                        '%x': `%m/%d/%y`,
                        '%X': `%H:%M:%S`,
                        '%Ec': `%c`,
                        '%EC': `%C`,
                        '%Ex': `%m/%d/%y`,
                        '%EX': `%H:%M:%S`,
                        '%Ey': `%y`,
                        '%EY': `%Y`,
                        '%Od': `%d`,
                        '%Oe': `%e`,
                        '%OH': `%H`,
                        '%OI': `%I`,
                        '%Om': `%m`,
                        '%OM': `%M`,
                        '%OS': `%S`,
                        '%Ou': `%u`,
                        '%OU': `%U`,
                        '%OV': `%V`,
                        '%Ow': `%w`,
                        '%OW': `%W`,
                        '%Oy': `%y`,
                      })))
                        r = r.replace(new RegExp(f, `g`), d[f]);
                      var p = `Sunday Monday Tuesday Wednesday Thursday Friday Saturday`.split(` `),
                        m =
                          `January February March April May June July August September October November December`.split(
                            ` `,
                          );
                      for (f in ((d = {
                        '%a': function (e) {
                          return p[e.Tb].substring(0, 3);
                        },
                        '%A': function (e) {
                          return p[e.Tb];
                        },
                        '%b': function (e) {
                          return m[e.ec].substring(0, 3);
                        },
                        '%B': function (e) {
                          return m[e.ec];
                        },
                        '%C': function (e) {
                          return s(((e.Xb + 1900) / 100) | 0, 2);
                        },
                        '%d': function (e) {
                          return s(e.jc, 2);
                        },
                        '%e': function (e) {
                          return o(e.jc, 2, ` `);
                        },
                        '%g': function (e) {
                          return u(e).toString().substring(2);
                        },
                        '%G': function (e) {
                          return u(e);
                        },
                        '%H': function (e) {
                          return s(e.dc, 2);
                        },
                        '%I': function (e) {
                          return ((e = e.dc) == 0 ? (e = 12) : 12 < e && (e -= 12), s(e, 2));
                        },
                        '%j': function (e) {
                          for (var t = 0, n = 0; n <= e.ec - 1; t += (dt(e.Xb + 1900) ? ft : pt)[n++]);
                          return s(e.jc + t, 3);
                        },
                        '%m': function (e) {
                          return s(e.ec + 1, 2);
                        },
                        '%M': function (e) {
                          return s(e.Kc, 2);
                        },
                        '%n': function () {
                          return `
`;
                        },
                        '%p': function (e) {
                          return 0 <= e.dc && 12 > e.dc ? `AM` : `PM`;
                        },
                        '%S': function (e) {
                          return s(e.Lc, 2);
                        },
                        '%t': function () {
                          return `	`;
                        },
                        '%u': function (e) {
                          return e.Tb || 7;
                        },
                        '%U': function (e) {
                          return s(Math.floor((e.Wb + 7 - e.Tb) / 7), 2);
                        },
                        '%V': function (e) {
                          var t = Math.floor((e.Wb + 7 - ((e.Tb + 6) % 7)) / 7);
                          if ((2 >= (e.Tb + 371 - e.Wb - 2) % 7 && t++, t))
                            t == 53 && ((n = (e.Tb + 371 - e.Wb) % 7) == 4 || (n == 3 && dt(e.Xb)) || (t = 1));
                          else {
                            t = 52;
                            var n = (e.Tb + 7 - e.Wb - 1) % 7;
                            (n == 4 || (n == 5 && dt((e.Xb % 400) - 1))) && t++;
                          }
                          return s(t, 2);
                        },
                        '%w': function (e) {
                          return e.Tb;
                        },
                        '%W': function (e) {
                          return s(Math.floor((e.Wb + 7 - ((e.Tb + 6) % 7)) / 7), 2);
                        },
                        '%y': function (e) {
                          return (e.Xb + 1900).toString().substring(2);
                        },
                        '%Y': function (e) {
                          return e.Xb + 1900;
                        },
                        '%z': function (e) {
                          var t = 0 <= (e = e.Jc);
                          return (
                            (e = Math.abs(e) / 60),
                            (t ? `+` : `-`) + String(`0000` + ((e / 60) * 100 + (e % 60))).slice(-4)
                          );
                        },
                        '%Z': function (e) {
                          return e.Mc;
                        },
                        '%%': function () {
                          return `%`;
                        },
                      }),
                      (r = r.replace(/%%/g, `\0\0`)),
                      d))
                        r.includes(f) && (r = r.replace(new RegExp(f, `g`), d[f](i)));
                      return (
                        (f = (function (e) {
                          var t = Array(se(e) + 1);
                          return (L(e, t, 0, t.length), t);
                        })((r = r.replace(/\0\0/g, `%`)))),
                        f.length > n
                          ? 0
                          : ((function (e, n) {
                              t().set(e, n >>> 0);
                            })(f, e),
                            f.length - 1)
                      );
                    }
                    W.fc();
                    var ht = [
                        null,
                        U,
                        Ee,
                        Me,
                        Pe,
                        Fe,
                        Ie,
                        Le,
                        Re,
                        ze,
                        Be,
                        Ve,
                        He,
                        Ue,
                        We,
                        Ge,
                        Ke,
                        Ye,
                        Xe,
                        Qe,
                        rt,
                        it,
                        at,
                        ot,
                        st,
                        ut,
                      ],
                      gt = {
                        b: function (e) {
                          return vt(e + 24) + 24;
                        },
                        n: function (e) {
                          return ((e = new J(e)).uc() || (e.hc(!0), K--), e.ic(!1), Ae.push(e), e.sc(), e.vc());
                        },
                        ma: function (e) {
                          throw (
                            A(`Unexpected exception thrown, this is not properly supported - aborting`),
                            (ie = !0),
                            e
                          );
                        },
                        x: function () {
                          Z(0);
                          var e = Ae.pop();
                          if (e.Hc() && !e.kc()) {
                            var t = e.Dc();
                            (t && G(t)(e.Zb), je(e.Zb));
                          }
                          q = 0;
                        },
                        e: function () {
                          var e = q;
                          if (!e) return (X = 0);
                          var t = new J(e);
                          t.cc(e);
                          var n = t.bc();
                          if (!n) return ((X = 0), e);
                          for (var r = Array.prototype.slice.call(arguments), i = 0; i < r.length; i++) {
                            var a = r[i];
                            if (a === 0 || a === n) break;
                            if (At(a, n, t.Sb + 16)) return ((X = a), e);
                          }
                          return ((X = n), e);
                        },
                        l: function () {
                          var e = q;
                          if (!e) return (X = 0);
                          var t = new J(e);
                          t.cc(e);
                          var n = t.bc();
                          if (!n) return ((X = 0), e);
                          for (var r = Array.prototype.slice.call(arguments), i = 0; i < r.length; i++) {
                            var a = r[i];
                            if (a === 0 || a === n) break;
                            if (At(a, n, t.Sb + 16)) return ((X = a), e);
                          }
                          return ((X = n), e);
                        },
                        h: function () {
                          var e = q;
                          if (!e) return (X = 0);
                          var t = new J(e);
                          t.cc(e);
                          var n = t.bc();
                          if (!n) return ((X = 0), e);
                          for (var r = Array.prototype.slice.call(arguments), i = 0; i < r.length; i++) {
                            var a = r[i];
                            if (a === 0 || a === n) break;
                            if (At(a, n, t.Sb + 16)) return ((X = a), e);
                          }
                          return ((X = n), e);
                        },
                        t: je,
                        M: function () {
                          var e = Ae.pop();
                          e || H(`no exception to throw`);
                          var t = e.Zb;
                          throw (e.kc() || (Ae.push(e), e.ic(!0), e.hc(!1), K++), (q = t), t);
                        },
                        c: function (e, t, n) {
                          throw (new J(e).fc(t, n), (q = e), K++, e);
                        },
                        pa: function () {
                          return K;
                        },
                        Fa: function (e) {
                          (St(e, !x, 1, !b), W.pc());
                        },
                        T: function (e) {
                          C ? postMessage({ cmd: `cleanupThread`, thread: e }) : xe(e);
                        },
                        xa: Ne,
                        j: function (e) {
                          throw ((q ||= e), e);
                        },
                        H: Pe,
                        Ma: Fe,
                        ua: Ie,
                        wa: Le,
                        oa: Re,
                        Ka: ze,
                        Ca: Be,
                        Ja: Ve,
                        V: He,
                        va: Ue,
                        sa: We,
                        La: Ge,
                        ta: Ke,
                        Ta: function () {},
                        X: function () {
                          H(
                            `To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking`,
                          );
                        },
                        Ua: function () {
                          H(
                            `To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking`,
                          );
                        },
                        W: function () {
                          return Date.now();
                        },
                        ya: function () {
                          return 2097152;
                        },
                        Oa: function () {
                          return !0;
                        },
                        za: function (e, t, n, r) {
                          if (e == t) setTimeout(() => qe(r));
                          else if (C) postMessage({ targetThread: e, cmd: `processProxyingQueue`, queue: r });
                          else {
                            if (!(e = W.Vb[e])) return;
                            e.postMessage({ cmd: `processProxyingQueue`, queue: r });
                          }
                          return 1;
                        },
                        Ea: function () {
                          return -1;
                        },
                        Pa: function (e, t) {
                          ((e = new Date(1e3 * Je(e))),
                            (a()[(t >> 2) >>> 0] = e.getUTCSeconds()),
                            (a()[((t + 4) >> 2) >>> 0] = e.getUTCMinutes()),
                            (a()[((t + 8) >> 2) >>> 0] = e.getUTCHours()),
                            (a()[((t + 12) >> 2) >>> 0] = e.getUTCDate()),
                            (a()[((t + 16) >> 2) >>> 0] = e.getUTCMonth()),
                            (a()[((t + 20) >> 2) >>> 0] = e.getUTCFullYear() - 1900),
                            (a()[((t + 24) >> 2) >>> 0] = e.getUTCDay()),
                            (e = ((e.getTime() - Date.UTC(e.getUTCFullYear(), 0, 1, 0, 0, 0, 0)) / 864e5) | 0),
                            (a()[((t + 28) >> 2) >>> 0] = e));
                        },
                        Qa: function (e, t) {
                          ((e = new Date(1e3 * Je(e))),
                            (a()[(t >> 2) >>> 0] = e.getSeconds()),
                            (a()[((t + 4) >> 2) >>> 0] = e.getMinutes()),
                            (a()[((t + 8) >> 2) >>> 0] = e.getHours()),
                            (a()[((t + 12) >> 2) >>> 0] = e.getDate()),
                            (a()[((t + 16) >> 2) >>> 0] = e.getMonth()),
                            (a()[((t + 20) >> 2) >>> 0] = e.getFullYear() - 1900),
                            (a()[((t + 24) >> 2) >>> 0] = e.getDay()));
                          var n = new Date(e.getFullYear(), 0, 1),
                            r = ((e.getTime() - n.getTime()) / 864e5) | 0;
                          ((a()[((t + 28) >> 2) >>> 0] = r),
                            (a()[((t + 36) >> 2) >>> 0] = -60 * e.getTimezoneOffset()),
                            (r = new Date(e.getFullYear(), 6, 1).getTimezoneOffset()),
                            (e = 0 | (r != (n = n.getTimezoneOffset()) && e.getTimezoneOffset() == Math.min(n, r))),
                            (a()[((t + 32) >> 2) >>> 0] = e));
                        },
                        Ra: function (e) {
                          var t = new Date(
                              a()[((e + 20) >> 2) >>> 0] + 1900,
                              a()[((e + 16) >> 2) >>> 0],
                              a()[((e + 12) >> 2) >>> 0],
                              a()[((e + 8) >> 2) >>> 0],
                              a()[((e + 4) >> 2) >>> 0],
                              a()[(e >> 2) >>> 0],
                              0,
                            ),
                            n = a()[((e + 32) >> 2) >>> 0],
                            r = t.getTimezoneOffset(),
                            i = new Date(t.getFullYear(), 0, 1),
                            o = new Date(t.getFullYear(), 6, 1).getTimezoneOffset(),
                            s = i.getTimezoneOffset(),
                            c = Math.min(s, o);
                          return (
                            0 > n
                              ? (a()[((e + 32) >> 2) >>> 0] = Number(o != s && c == r))
                              : 0 < n != (c == r) &&
                                ((o = Math.max(s, o)), t.setTime(t.getTime() + 6e4 * ((0 < n ? c : o) - r))),
                            (a()[((e + 24) >> 2) >>> 0] = t.getDay()),
                            (n = ((t.getTime() - i.getTime()) / 864e5) | 0),
                            (a()[((e + 28) >> 2) >>> 0] = n),
                            (a()[(e >> 2) >>> 0] = t.getSeconds()),
                            (a()[((e + 4) >> 2) >>> 0] = t.getMinutes()),
                            (a()[((e + 8) >> 2) >>> 0] = t.getHours()),
                            (a()[((e + 12) >> 2) >>> 0] = t.getDate()),
                            (a()[((e + 16) >> 2) >>> 0] = t.getMonth()),
                            (t.getTime() / 1e3) | 0
                          );
                        },
                        Aa: Ye,
                        Ba: Xe,
                        Sa: function e(t, n, r) {
                          e.Ac || ((e.Ac = !0), Qe(t, n, r));
                        },
                        y: function () {
                          H(``);
                        },
                        U: function () {
                          if (!S && !x) {
                            var e = `Blocking on the main thread is very dangerous, see https://emscripten.org/docs/porting/pthreads.html#blocking-on-the-main-browser-thread`;
                            ((Oe ||= {}), Oe[e] || ((Oe[e] = 1), S && (e = `warning: ` + e), A(e)));
                          }
                        },
                        ra: function () {
                          return 4294901760;
                        },
                        B: ke,
                        Ia: function (e, t, n) {
                          i().copyWithin(e >>> 0, t >>> 0, (t + n) >>> 0);
                        },
                        F: function () {
                          return S ? n(3993).cpus().length : navigator.hardwareConcurrency;
                        },
                        Da: function (e, t, n) {
                          ((et.length = t), (n >>= 3));
                          for (var r = 0; r < t; r++) et[r] = s()[(n + r) >>> 0];
                          return (0 > e ? ye[-e - 1] : ht[e]).apply(null, et);
                        },
                        qa: function (e) {
                          var t = i().length;
                          if ((e >>>= 0) <= t || 4294901760 < e) return !1;
                          for (var n = 1; 4 >= n; n *= 2) {
                            var r = t * (1 + 0.2 / n);
                            r = Math.min(r, e + 100663296);
                            var a = Math;
                            ((r = Math.max(e, r)),
                              (a = a.min.call(a, 4294901760, r + ((65536 - (r % 65536)) % 65536))));
                            t: {
                              try {
                                (M.grow((a - P.byteLength + 65535) >>> 16), R(M.buffer));
                                var o = 1;
                                break t;
                              } catch {}
                              o = void 0;
                            }
                            if (o) return !0;
                          }
                          return !1;
                        },
                        Na: function () {
                          throw `unwind`;
                        },
                        Ga: rt,
                        Ha: it,
                        J: Ce,
                        I: at,
                        S: ot,
                        ga: st,
                        R: ut,
                        d: function () {
                          return X;
                        },
                        na: function e(r, i) {
                          e.lc ||= (function () {
                            if (typeof crypto == `object` && typeof crypto.getRandomValues == `function`) {
                              var e = new Uint8Array(1);
                              return () => (crypto.getRandomValues(e), e[0]);
                            }
                            if (S)
                              try {
                                var t = n(
                                  Object(
                                    (function () {
                                      var e = Error(`Cannot find module 'crypto'`);
                                      throw ((e.code = `MODULE_NOT_FOUND`), e);
                                    })(),
                                  ),
                                );
                                return () => t.randomBytes(1)[0];
                              } catch {}
                            return () => H(`randomDevice`);
                          })();
                          for (var a = 0; a < i; a++) t()[((r + a) >> 0) >>> 0] = e.lc();
                          return 0;
                        },
                        ia: function (e, t, n) {
                          var r = Q();
                          try {
                            return G(e)(t, n);
                          } catch (e) {
                            if (($(r), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        ja: function (e, t, n) {
                          var r = Q();
                          try {
                            return G(e)(t, n);
                          } catch (e) {
                            if (($(r), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        K: function (e) {
                          var t = Q();
                          try {
                            return G(e)();
                          } catch (e) {
                            if (($(t), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        f: function (e, t) {
                          var n = Q();
                          try {
                            return G(e)(t);
                          } catch (e) {
                            if (($(n), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        P: function (e, t, n) {
                          var r = Q();
                          try {
                            return G(e)(t, n);
                          } catch (e) {
                            if (($(r), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        Q: function (e, t, n) {
                          var r = Q();
                          try {
                            return G(e)(t, n);
                          } catch (e) {
                            if (($(r), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        k: function (e, t, n) {
                          var r = Q();
                          try {
                            return G(e)(t, n);
                          } catch (e) {
                            if (($(r), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        p: function (e, t, n, r) {
                          var i = Q();
                          try {
                            return G(e)(t, n, r);
                          } catch (e) {
                            if (($(i), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        q: function (e, t, n, r, i) {
                          var a = Q();
                          try {
                            return G(e)(t, n, r, i);
                          } catch (e) {
                            if (($(a), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        N: function (e, t, n, r, i, a) {
                          var o = Q();
                          try {
                            return G(e)(t, n, r, i, a);
                          } catch (e) {
                            if (($(o), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        s: function (e, t, n, r, i, a) {
                          var o = Q();
                          try {
                            return G(e)(t, n, r, i, a);
                          } catch (e) {
                            if (($(o), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        w: function (e, t, n, r, i, a, o) {
                          var s = Q();
                          try {
                            return G(e)(t, n, r, i, a, o);
                          } catch (e) {
                            if (($(s), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        L: function (e, t, n, r, i, a, o, s) {
                          var c = Q();
                          try {
                            return G(e)(t, n, r, i, a, o, s);
                          } catch (e) {
                            if (($(c), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        E: function (e, t, n, r, i, a, o, s, c, l, u, d) {
                          var f = Q();
                          try {
                            return G(e)(t, n, r, i, a, o, s, c, l, u, d);
                          } catch (e) {
                            if (($(f), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        aa: function (e, t, n, r, i, a, o, s) {
                          var c = Q();
                          try {
                            return Bt(e, t, n, r, i, a, o, s);
                          } catch (e) {
                            if (($(c), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        _: function (e, t, n, r, i, a, o) {
                          var s = Q();
                          try {
                            return Nt(e, t, n, r, i, a, o);
                          } catch (e) {
                            if (($(s), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        Z: function (e, t, n, r, i) {
                          var a = Q();
                          try {
                            return Vt(e, t, n, r, i);
                          } catch (e) {
                            if (($(a), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        ca: function (e, t, n, r) {
                          var i = Q();
                          try {
                            return Rt(e, t, n, r);
                          } catch (e) {
                            if (($(i), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        $: function (e) {
                          var t = Q();
                          try {
                            return Mt(e);
                          } catch (e) {
                            if (($(t), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        ba: function (e, t) {
                          var n = Q();
                          try {
                            return zt(e, t);
                          } catch (e) {
                            if (($(n), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        Y: function (e, t, n) {
                          var r = Q();
                          try {
                            return Pt(e, t, n);
                          } catch (e) {
                            if (($(r), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        g: function (e) {
                          var t = Q();
                          try {
                            G(e)();
                          } catch (e) {
                            if (($(t), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        r: function (e, t) {
                          var n = Q();
                          try {
                            G(e)(t);
                          } catch (e) {
                            if (($(n), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        i: function (e, t, n) {
                          var r = Q();
                          try {
                            G(e)(t, n);
                          } catch (e) {
                            if (($(r), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        ha: function (e, t, n, r) {
                          var i = Q();
                          try {
                            G(e)(t, n, r);
                          } catch (e) {
                            if (($(i), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        m: function (e, t, n, r) {
                          var i = Q();
                          try {
                            G(e)(t, n, r);
                          } catch (e) {
                            if (($(i), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        v: function (e, t, n, r, i) {
                          var a = Q();
                          try {
                            G(e)(t, n, r, i);
                          } catch (e) {
                            if (($(a), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        u: function (e, t, n, r, i, a) {
                          var o = Q();
                          try {
                            G(e)(t, n, r, i, a);
                          } catch (e) {
                            if (($(o), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        O: function (e, t, n, r, i, a, o) {
                          var s = Q();
                          try {
                            G(e)(t, n, r, i, a, o);
                          } catch (e) {
                            if (($(s), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        A: function (e, t, n, r, i, a, o, s) {
                          var c = Q();
                          try {
                            G(e)(t, n, r, i, a, o, s);
                          } catch (e) {
                            if (($(c), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        ka: function (e, t, n, r, i, a, o, s, c) {
                          var l = Q();
                          try {
                            G(e)(t, n, r, i, a, o, s, c);
                          } catch (e) {
                            if (($(l), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        C: function (e, t, n, r, i, a, o, s, c, l, u) {
                          var d = Q();
                          try {
                            G(e)(t, n, r, i, a, o, s, c, l, u);
                          } catch (e) {
                            if (($(d), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        D: function (e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
                          var g = Q();
                          try {
                            G(e)(t, n, r, i, a, o, s, c, l, u, d, f, p, m, h);
                          } catch (e) {
                            if (($(g), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        fa: function (e, t, n, r, i, a, o, s) {
                          var c = Q();
                          try {
                            Ft(e, t, n, r, i, a, o, s);
                          } catch (e) {
                            if (($(c), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        da: function (e, t, n, r, i, a, o, s, c, l, u, d) {
                          var f = Q();
                          try {
                            Lt(e, t, n, r, i, a, o, s, c, l, u, d);
                          } catch (e) {
                            if (($(f), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        ea: function (e, t, n, r, i, a) {
                          var o = Q();
                          try {
                            It(e, t, n, r, i, a);
                          } catch (e) {
                            if (($(o), e !== e + 0)) throw e;
                            Z(1, 0);
                          }
                        },
                        o: function (e) {
                          return e;
                        },
                        a: M || c.wasmMemory,
                        G: function (e) {
                          X = e;
                        },
                        la: mt,
                        z: function (e, t, n, r) {
                          return mt(e, t, n, r);
                        },
                      };
                    ((function () {
                      function e(e, t) {
                        ((c.asm = e.exports),
                          W.qc.push(c.asm.sb),
                          (ce = c.asm.ub),
                          ue.unshift(c.asm.Va),
                          (N = t),
                          C ||
                            (V--,
                            c.monitorRunDependencies && c.monitorRunDependencies(V),
                            V == 0 &&
                              (he !== null && (clearInterval(he), (he = null)), ge && ((e = ge), (ge = null), e()))));
                      }
                      function t(t) {
                        e(t.instance, t.module);
                      }
                      function n(e) {
                        return (function () {
                          if (!O && (b || x)) {
                            if (typeof fetch == `function` && !B.startsWith(`file://`))
                              return fetch(B, { credentials: `same-origin` })
                                .then(function (e) {
                                  if (!e.ok) throw `failed to load wasm binary file at '` + B + `'`;
                                  return e.arrayBuffer();
                                })
                                .catch(function () {
                                  return ve();
                                });
                            if (f)
                              return new Promise(function (e, t) {
                                f(
                                  B,
                                  function (t) {
                                    e(new Uint8Array(t));
                                  },
                                  t,
                                );
                              });
                          }
                          return Promise.resolve().then(function () {
                            return ve();
                          });
                        })()
                          .then(function (e) {
                            return WebAssembly.instantiate(e, r);
                          })
                          .then(function (e) {
                            return e;
                          })
                          .then(e, function (e) {
                            (A(`failed to asynchronously prepare wasm: ` + e), H(e));
                          });
                      }
                      var r = { a: gt };
                      if ((C || (V++, c.monitorRunDependencies && c.monitorRunDependencies(V)), c.instantiateWasm))
                        try {
                          return c.instantiateWasm(r, e);
                        } catch (e) {
                          return (A(`Module.instantiateWasm callback failed with error: ` + e), !1);
                        }
                      (O ||
                      typeof WebAssembly.instantiateStreaming != `function` ||
                      _e() ||
                      B.startsWith(`file://`) ||
                      S ||
                      typeof fetch != `function`
                        ? n(t)
                        : fetch(B, { credentials: `same-origin` }).then(function (e) {
                            return WebAssembly.instantiateStreaming(e, r).then(t, function (e) {
                              return (
                                A(`wasm streaming compile failed: ` + e),
                                A(`falling back to ArrayBuffer instantiation`),
                                n(t)
                              );
                            });
                          })
                      ).catch(u);
                    })(),
                      (c.___wasm_call_ctors = function () {
                        return (c.___wasm_call_ctors = c.asm.Va).apply(null, arguments);
                      }),
                      (c._OrtInit = function () {
                        return (c._OrtInit = c.asm.Wa).apply(null, arguments);
                      }),
                      (c._OrtCreateSessionOptions = function () {
                        return (c._OrtCreateSessionOptions = c.asm.Xa).apply(null, arguments);
                      }),
                      (c._OrtAppendExecutionProvider = function () {
                        return (c._OrtAppendExecutionProvider = c.asm.Ya).apply(null, arguments);
                      }),
                      (c._OrtAddSessionConfigEntry = function () {
                        return (c._OrtAddSessionConfigEntry = c.asm.Za).apply(null, arguments);
                      }),
                      (c._OrtReleaseSessionOptions = function () {
                        return (c._OrtReleaseSessionOptions = c.asm._a).apply(null, arguments);
                      }),
                      (c._OrtCreateSession = function () {
                        return (c._OrtCreateSession = c.asm.$a).apply(null, arguments);
                      }),
                      (c._OrtReleaseSession = function () {
                        return (c._OrtReleaseSession = c.asm.ab).apply(null, arguments);
                      }),
                      (c._OrtGetInputCount = function () {
                        return (c._OrtGetInputCount = c.asm.bb).apply(null, arguments);
                      }),
                      (c._OrtGetOutputCount = function () {
                        return (c._OrtGetOutputCount = c.asm.cb).apply(null, arguments);
                      }),
                      (c._OrtGetInputName = function () {
                        return (c._OrtGetInputName = c.asm.db).apply(null, arguments);
                      }),
                      (c._OrtGetOutputName = function () {
                        return (c._OrtGetOutputName = c.asm.eb).apply(null, arguments);
                      }),
                      (c._OrtFree = function () {
                        return (c._OrtFree = c.asm.fb).apply(null, arguments);
                      }),
                      (c._OrtCreateTensor = function () {
                        return (c._OrtCreateTensor = c.asm.gb).apply(null, arguments);
                      }),
                      (c._OrtGetTensorData = function () {
                        return (c._OrtGetTensorData = c.asm.hb).apply(null, arguments);
                      }),
                      (c._OrtReleaseTensor = function () {
                        return (c._OrtReleaseTensor = c.asm.ib).apply(null, arguments);
                      }),
                      (c._OrtCreateRunOptions = function () {
                        return (c._OrtCreateRunOptions = c.asm.jb).apply(null, arguments);
                      }),
                      (c._OrtAddRunConfigEntry = function () {
                        return (c._OrtAddRunConfigEntry = c.asm.kb).apply(null, arguments);
                      }),
                      (c._OrtReleaseRunOptions = function () {
                        return (c._OrtReleaseRunOptions = c.asm.lb).apply(null, arguments);
                      }),
                      (c._OrtRun = function () {
                        return (c._OrtRun = c.asm.mb).apply(null, arguments);
                      }),
                      (c._OrtEndProfiling = function () {
                        return (c._OrtEndProfiling = c.asm.nb).apply(null, arguments);
                      }));
                    var _t = (c._pthread_self = function () {
                        return (_t = c._pthread_self = c.asm.ob).apply(null, arguments);
                      }),
                      vt = (c._malloc = function () {
                        return (vt = c._malloc = c.asm.pb).apply(null, arguments);
                      }),
                      yt = (c._free = function () {
                        return (yt = c._free = c.asm.qb).apply(null, arguments);
                      }),
                      bt = (c._fflush = function () {
                        return (bt = c._fflush = c.asm.rb).apply(null, arguments);
                      });
                    c.__emscripten_tls_init = function () {
                      return (c.__emscripten_tls_init = c.asm.sb).apply(null, arguments);
                    };
                    var xt = (c.___funcs_on_exit = function () {
                        return (xt = c.___funcs_on_exit = c.asm.tb).apply(null, arguments);
                      }),
                      St = (c.__emscripten_thread_init = function () {
                        return (St = c.__emscripten_thread_init = c.asm.vb).apply(null, arguments);
                      });
                    c.__emscripten_thread_crashed = function () {
                      return (c.__emscripten_thread_crashed = c.asm.wb).apply(null, arguments);
                    };
                    var Ct,
                      wt = (c._emscripten_run_in_main_runtime_thread_js = function () {
                        return (wt = c._emscripten_run_in_main_runtime_thread_js = c.asm.xb).apply(null, arguments);
                      }),
                      Tt = (c.__emscripten_proxy_execute_task_queue = function () {
                        return (Tt = c.__emscripten_proxy_execute_task_queue = c.asm.yb).apply(null, arguments);
                      }),
                      Et = (c.__emscripten_thread_free_data = function () {
                        return (Et = c.__emscripten_thread_free_data = c.asm.zb).apply(null, arguments);
                      }),
                      Dt = (c.__emscripten_thread_exit = function () {
                        return (Dt = c.__emscripten_thread_exit = c.asm.Ab).apply(null, arguments);
                      }),
                      Z = (c._setThrew = function () {
                        return (Z = c._setThrew = c.asm.Bb).apply(null, arguments);
                      }),
                      Ot = (c._emscripten_stack_set_limits = function () {
                        return (Ot = c._emscripten_stack_set_limits = c.asm.Cb).apply(null, arguments);
                      }),
                      Q = (c.stackSave = function () {
                        return (Q = c.stackSave = c.asm.Db).apply(null, arguments);
                      }),
                      $ = (c.stackRestore = function () {
                        return ($ = c.stackRestore = c.asm.Eb).apply(null, arguments);
                      }),
                      kt = (c.stackAlloc = function () {
                        return (kt = c.stackAlloc = c.asm.Fb).apply(null, arguments);
                      }),
                      At = (c.___cxa_can_catch = function () {
                        return (At = c.___cxa_can_catch = c.asm.Gb).apply(null, arguments);
                      }),
                      jt = (c.___cxa_is_pointer_type = function () {
                        return (jt = c.___cxa_is_pointer_type = c.asm.Hb).apply(null, arguments);
                      }),
                      Mt = (c.dynCall_j = function () {
                        return (Mt = c.dynCall_j = c.asm.Ib).apply(null, arguments);
                      }),
                      Nt = (c.dynCall_iiiiij = function () {
                        return (Nt = c.dynCall_iiiiij = c.asm.Jb).apply(null, arguments);
                      }),
                      Pt = (c.dynCall_jii = function () {
                        return (Pt = c.dynCall_jii = c.asm.Kb).apply(null, arguments);
                      }),
                      Ft = (c.dynCall_viiiiij = function () {
                        return (Ft = c.dynCall_viiiiij = c.asm.Lb).apply(null, arguments);
                      }),
                      It = (c.dynCall_vjji = function () {
                        return (It = c.dynCall_vjji = c.asm.Mb).apply(null, arguments);
                      }),
                      Lt = (c.dynCall_viiijjjii = function () {
                        return (Lt = c.dynCall_viiijjjii = c.asm.Nb).apply(null, arguments);
                      }),
                      Rt = (c.dynCall_iij = function () {
                        return (Rt = c.dynCall_iij = c.asm.Ob).apply(null, arguments);
                      }),
                      zt = (c.dynCall_ji = function () {
                        return (zt = c.dynCall_ji = c.asm.Pb).apply(null, arguments);
                      }),
                      Bt = (c.dynCall_iiiiiij = function () {
                        return (Bt = c.dynCall_iiiiiij = c.asm.Qb).apply(null, arguments);
                      }),
                      Vt = (c.dynCall_iiij = function () {
                        return (Vt = c.dynCall_iiij = c.asm.Rb).apply(null, arguments);
                      });
                    function Ht() {
                      function e() {
                        if (
                          !Ct &&
                          ((Ct = !0), (c.calledRun = !0), !ie) &&
                          (C || we(ue), l(c), c.onRuntimeInitialized && c.onRuntimeInitialized(), !C)
                        ) {
                          if (c.postRun)
                            for (typeof c.postRun == `function` && (c.postRun = [c.postRun]); c.postRun.length; ) {
                              var e = c.postRun.shift();
                              fe.unshift(e);
                            }
                          we(fe);
                        }
                      }
                      if (!(0 < V))
                        if (C) (l(c), C || we(ue), postMessage({ cmd: `loaded` }));
                        else {
                          if (c.preRun)
                            for (typeof c.preRun == `function` && (c.preRun = [c.preRun]); c.preRun.length; ) me();
                          (we(le),
                            0 < V ||
                              (c.setStatus
                                ? (c.setStatus(`Running...`),
                                  setTimeout(function () {
                                    (setTimeout(function () {
                                      c.setStatus(``);
                                    }, 1),
                                      e());
                                  }, 1))
                                : e()));
                        }
                    }
                    if (
                      ((c.UTF8ToString = I),
                      (c.stringToUTF8 = function (e, t, n) {
                        return L(e, i(), t, n);
                      }),
                      (c.lengthBytesUTF8 = se),
                      (c.keepRuntimeAlive = pe),
                      (c.wasmMemory = M),
                      (c.stackSave = Q),
                      (c.stackRestore = $),
                      (c.stackAlloc = kt),
                      (c.ExitStatus = be),
                      (c.PThread = W),
                      (ge = function e() {
                        (Ct || Ht(), Ct || (ge = e));
                      }),
                      c.preInit)
                    )
                      for (typeof c.preInit == `function` && (c.preInit = [c.preInit]); 0 < c.preInit.length; )
                        c.preInit.pop()();
                    return (Ht(), e.ready);
                  });
              },
              932: (e, t, n) => {
                var r;
                e.exports =
                  ((r =
                    (r = typeof document < `u` && document.currentScript ? document.currentScript.src : void 0) ||
                    `/index.js`),
                  function (e) {
                    var t, i, a;
                    ((e ||= {}),
                      (t ||= e === void 0 ? {} : e),
                      (t.ready = new Promise(function (e, t) {
                        ((i = e), (a = t));
                      })));
                    var o,
                      s,
                      c,
                      l,
                      u,
                      d,
                      f = Object.assign({}, t),
                      p = `./this.program`,
                      m = (e, t) => {
                        throw t;
                      },
                      h = typeof window == `object`,
                      g = typeof importScripts == `function`,
                      _ =
                        typeof process == `object` &&
                        typeof process.versions == `object` &&
                        typeof process.versions.node == `string`,
                      v = ``;
                    _
                      ? ((v = g ? n(908).dirname(v) + `/` : `//`),
                        (d = () => {
                          u ||= ((l = n(1384)), n(908));
                        }),
                        (o = function (e, t) {
                          return (d(), (e = u.normalize(e)), l.readFileSync(e, t ? void 0 : `utf8`));
                        }),
                        (c = (e) => ((e = o(e, !0)).buffer || (e = new Uint8Array(e)), e)),
                        (s = (e, t, n) => {
                          (d(),
                            (e = u.normalize(e)),
                            l.readFile(e, function (e, r) {
                              e ? n(e) : t(r.buffer);
                            }));
                        }),
                        1 < process.argv.length && (p = process.argv[1].replace(/\\/g, `/`)),
                        process.argv.slice(2),
                        process.on(`uncaughtException`, function (e) {
                          if (!(e instanceof de)) throw e;
                        }),
                        process.on(`unhandledRejection`, function (e) {
                          throw e;
                        }),
                        (m = (e, t) => {
                          if (S || 0 < ae) throw ((process.exitCode = e), t);
                          (t instanceof de || x(`exiting due to exception: ` + t), process.exit(e));
                        }),
                        (t.inspect = function () {
                          return `[Emscripten Module object]`;
                        }))
                      : (h || g) &&
                        (g
                          ? (v = self.location.href)
                          : typeof document < `u` && document.currentScript && (v = document.currentScript.src),
                        r && (v = r),
                        (v = v.indexOf(`blob:`) === 0 ? `` : v.substr(0, v.replace(/[?#].*/, ``).lastIndexOf(`/`) + 1)),
                        (o = (e) => {
                          var t = new XMLHttpRequest();
                          return (t.open(`GET`, e, !1), t.send(null), t.responseText);
                        }),
                        g &&
                          (c = (e) => {
                            var t = new XMLHttpRequest();
                            return (
                              t.open(`GET`, e, !1),
                              (t.responseType = `arraybuffer`),
                              t.send(null),
                              new Uint8Array(t.response)
                            );
                          }),
                        (s = (e, t, n) => {
                          var r = new XMLHttpRequest();
                          (r.open(`GET`, e, !0),
                            (r.responseType = `arraybuffer`),
                            (r.onload = () => {
                              r.status == 200 || (r.status == 0 && r.response) ? t(r.response) : n();
                            }),
                            (r.onerror = n),
                            r.send(null));
                        }));
                    var y,
                      b = t.print || console.log.bind(console),
                      x = t.printErr || console.warn.bind(console);
                    (Object.assign(t, f),
                      (f = null),
                      t.thisProgram && (p = t.thisProgram),
                      t.quit && (m = t.quit),
                      t.wasmBinary && (y = t.wasmBinary));
                    var S = t.noExitRuntime || !1;
                    typeof WebAssembly != `object` && z(`no native wasm support detected`);
                    var C,
                      w,
                      T,
                      E,
                      D,
                      O,
                      k = !1,
                      A = typeof TextDecoder < `u` ? new TextDecoder(`utf8`) : void 0;
                    function j(e, t, n) {
                      var r = (t >>>= 0) + n;
                      for (n = t; e[n] && !(n >= r); ) ++n;
                      if (16 < n - t && e.buffer && A) return A.decode(e.subarray(t, n));
                      for (r = ``; t < n; ) {
                        var i = e[t++];
                        if (128 & i) {
                          var a = 63 & e[t++];
                          if ((224 & i) == 192) r += String.fromCharCode(((31 & i) << 6) | a);
                          else {
                            var o = 63 & e[t++];
                            65536 >
                            (i =
                              (240 & i) == 224
                                ? ((15 & i) << 12) | (a << 6) | o
                                : ((7 & i) << 18) | (a << 12) | (o << 6) | (63 & e[t++]))
                              ? (r += String.fromCharCode(i))
                              : ((i -= 65536), (r += String.fromCharCode(55296 | (i >> 10), 56320 | (1023 & i))));
                          }
                        } else r += String.fromCharCode(i);
                      }
                      return r;
                    }
                    function M(e, t) {
                      return (e >>>= 0) ? j(E, e, t) : ``;
                    }
                    function N(e, t, n, r) {
                      if (!(0 < r)) return 0;
                      var i = (n >>>= 0);
                      r = n + r - 1;
                      for (var a = 0; a < e.length; ++a) {
                        var o = e.charCodeAt(a);
                        if (
                          (55296 <= o && 57343 >= o && (o = (65536 + ((1023 & o) << 10)) | (1023 & e.charCodeAt(++a))),
                          127 >= o)
                        ) {
                          if (n >= r) break;
                          t[n++ >>> 0] = o;
                        } else {
                          if (2047 >= o) {
                            if (n + 1 >= r) break;
                            t[n++ >>> 0] = 192 | (o >> 6);
                          } else {
                            if (65535 >= o) {
                              if (n + 2 >= r) break;
                              t[n++ >>> 0] = 224 | (o >> 12);
                            } else {
                              if (n + 3 >= r) break;
                              ((t[n++ >>> 0] = 240 | (o >> 18)), (t[n++ >>> 0] = 128 | ((o >> 12) & 63)));
                            }
                            t[n++ >>> 0] = 128 | ((o >> 6) & 63);
                          }
                          t[n++ >>> 0] = 128 | (63 & o);
                        }
                      }
                      return ((t[n >>> 0] = 0), n - i);
                    }
                    function P(e) {
                      for (var t = 0, n = 0; n < e.length; ++n) {
                        var r = e.charCodeAt(n);
                        127 >= r ? t++ : 2047 >= r ? (t += 2) : 55296 <= r && 57343 >= r ? ((t += 4), ++n) : (t += 3);
                      }
                      return t;
                    }
                    function F() {
                      var e = C.buffer;
                      ((w = e),
                        (t.HEAP8 = T = new Int8Array(e)),
                        (t.HEAP16 = new Int16Array(e)),
                        (t.HEAP32 = D = new Int32Array(e)),
                        (t.HEAPU8 = E = new Uint8Array(e)),
                        (t.HEAPU16 = new Uint16Array(e)),
                        (t.HEAPU32 = O = new Uint32Array(e)),
                        (t.HEAPF32 = new Float32Array(e)),
                        (t.HEAPF64 = new Float64Array(e)));
                    }
                    var ee,
                      te = [],
                      ne = [],
                      re = [],
                      ie = [],
                      ae = 0;
                    function oe() {
                      var e = t.preRun.shift();
                      te.unshift(e);
                    }
                    var I,
                      L = 0,
                      se = null,
                      R = null;
                    function z(e) {
                      throw (
                        t.onAbort && t.onAbort(e),
                        x((e = `Aborted(` + e + `)`)),
                        (k = !0),
                        (e = new WebAssembly.RuntimeError(e + `. Build with -sASSERTIONS for more info.`)),
                        a(e),
                        e
                      );
                    }
                    function ce() {
                      return I.startsWith(`data:application/octet-stream;base64,`);
                    }
                    if (((I = `ort-wasm.wasm`), !ce())) {
                      var le = I;
                      I = t.locateFile ? t.locateFile(le, v) : v + le;
                    }
                    function ue() {
                      var e = I;
                      try {
                        if (e == I && y) return new Uint8Array(y);
                        if (c) return c(e);
                        throw `both async and sync fetching of the wasm failed`;
                      } catch (e) {
                        z(e);
                      }
                    }
                    function de(e) {
                      ((this.name = `ExitStatus`),
                        (this.message = `Program terminated with exit(` + e + `)`),
                        (this.status = e));
                    }
                    function fe(e) {
                      for (; 0 < e.length; ) e.shift()(t);
                    }
                    var pe = [],
                      me = 0,
                      B = 0;
                    function V(e) {
                      ((this.Db = e),
                        (this.zb = e - 24),
                        (this.Ub = function (e) {
                          O[((this.zb + 4) >> 2) >>> 0] = e;
                        }),
                        (this.Eb = function () {
                          return O[((this.zb + 4) >> 2) >>> 0];
                        }),
                        (this.Sb = function (e) {
                          O[((this.zb + 8) >> 2) >>> 0] = e;
                        }),
                        (this.Wb = function () {
                          return O[((this.zb + 8) >> 2) >>> 0];
                        }),
                        (this.Tb = function () {
                          D[(this.zb >> 2) >>> 0] = 0;
                        }),
                        (this.Ib = function (e) {
                          T[((this.zb + 12) >> 0) >>> 0] = +!!e;
                        }),
                        (this.Pb = function () {
                          return T[((this.zb + 12) >> 0) >>> 0] != 0;
                        }),
                        (this.Jb = function (e) {
                          T[((this.zb + 13) >> 0) >>> 0] = +!!e;
                        }),
                        (this.Lb = function () {
                          return T[((this.zb + 13) >> 0) >>> 0] != 0;
                        }),
                        (this.Rb = function (e, t) {
                          (this.Fb(0), this.Ub(e), this.Sb(t), this.Tb(), this.Ib(!1), this.Jb(!1));
                        }),
                        (this.Nb = function () {
                          D[(this.zb >> 2) >>> 0] += 1;
                        }),
                        (this.Xb = function () {
                          var e = D[(this.zb >> 2) >>> 0];
                          return ((D[(this.zb >> 2) >>> 0] = e - 1), e === 1);
                        }),
                        (this.Fb = function (e) {
                          O[((this.zb + 16) >> 2) >>> 0] = e;
                        }),
                        (this.Ob = function () {
                          return O[((this.zb + 16) >> 2) >>> 0];
                        }),
                        (this.Qb = function () {
                          if (Ne(this.Eb())) return O[(this.Db >> 2) >>> 0];
                          var e = this.Ob();
                          return e === 0 ? this.Db : e;
                        }));
                    }
                    function he(e) {
                      return Oe(new V(e).zb);
                    }
                    var ge = [];
                    function H(e) {
                      var t = ge[e];
                      return (t || (e >= ge.length && (ge.length = e + 1), (ge[e] = t = ee.get(e))), t);
                    }
                    function _e(e) {
                      var t = P(e) + 1,
                        n = G(t);
                      return (n && N(e, T, n, t), n);
                    }
                    var ve = {};
                    function ye() {
                      if (!be) {
                        var e,
                          t = {
                            USER: `web_user`,
                            LOGNAME: `web_user`,
                            PATH: `/`,
                            PWD: `/`,
                            HOME: `/home/web_user`,
                            LANG:
                              (
                                (typeof navigator == `object` && navigator.languages && navigator.languages[0]) ||
                                `C`
                              ).replace(`-`, `_`) + `.UTF-8`,
                            _: p || `./this.program`,
                          };
                        for (e in ve) ve[e] === void 0 ? delete t[e] : (t[e] = ve[e]);
                        var n = [];
                        for (e in t) n.push(e + `=` + t[e]);
                        be = n;
                      }
                      return be;
                    }
                    var be,
                      xe = [null, [], []];
                    function Se(e, t) {
                      var n = xe[e];
                      t === 0 || t === 10 ? ((e === 1 ? b : x)(j(n, 0)), (n.length = 0)) : n.push(t);
                    }
                    var U = 0;
                    function Ce(e) {
                      return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
                    }
                    var W = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                      we = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                    function Te(e, t, n, r) {
                      function i(e, t, n) {
                        for (e = typeof e == `number` ? e.toString() : e || ``; e.length < t; ) e = n[0] + e;
                        return e;
                      }
                      function a(e, t) {
                        return i(e, t, `0`);
                      }
                      function o(e, t) {
                        function n(e) {
                          return 0 > e ? -1 : +(0 < e);
                        }
                        var r;
                        return (
                          (r = n(e.getFullYear() - t.getFullYear())) === 0 &&
                            (r = n(e.getMonth() - t.getMonth())) === 0 &&
                            (r = n(e.getDate() - t.getDate())),
                          r
                        );
                      }
                      function s(e) {
                        switch (e.getDay()) {
                          case 0:
                            return new Date(e.getFullYear() - 1, 11, 29);
                          case 1:
                            return e;
                          case 2:
                            return new Date(e.getFullYear(), 0, 3);
                          case 3:
                            return new Date(e.getFullYear(), 0, 2);
                          case 4:
                            return new Date(e.getFullYear(), 0, 1);
                          case 5:
                            return new Date(e.getFullYear() - 1, 11, 31);
                          case 6:
                            return new Date(e.getFullYear() - 1, 11, 30);
                        }
                      }
                      function c(e) {
                        var t = e.Bb;
                        for (e = new Date(new Date(e.Cb + 1900, 0, 1).getTime()); 0 < t; ) {
                          var n = e.getMonth(),
                            r = (Ce(e.getFullYear()) ? W : we)[n];
                          if (!(t > r - e.getDate())) {
                            e.setDate(e.getDate() + t);
                            break;
                          }
                          ((t -= r - e.getDate() + 1),
                            e.setDate(1),
                            11 > n ? e.setMonth(n + 1) : (e.setMonth(0), e.setFullYear(e.getFullYear() + 1)));
                        }
                        return (
                          (n = new Date(e.getFullYear() + 1, 0, 4)),
                          (t = s(new Date(e.getFullYear(), 0, 4))),
                          (n = s(n)),
                          0 >= o(t, e) ? (0 >= o(n, e) ? e.getFullYear() + 1 : e.getFullYear()) : e.getFullYear() - 1
                        );
                      }
                      var l = D[((r + 40) >> 2) >>> 0];
                      for (var u in ((r = {
                        $b: D[(r >> 2) >>> 0],
                        Zb: D[((r + 4) >> 2) >>> 0],
                        Gb: D[((r + 8) >> 2) >>> 0],
                        Kb: D[((r + 12) >> 2) >>> 0],
                        Hb: D[((r + 16) >> 2) >>> 0],
                        Cb: D[((r + 20) >> 2) >>> 0],
                        Ab: D[((r + 24) >> 2) >>> 0],
                        Bb: D[((r + 28) >> 2) >>> 0],
                        bc: D[((r + 32) >> 2) >>> 0],
                        Yb: D[((r + 36) >> 2) >>> 0],
                        ac: l ? M(l) : ``,
                      }),
                      (n = M(n)),
                      (l = {
                        '%c': `%a %b %d %H:%M:%S %Y`,
                        '%D': `%m/%d/%y`,
                        '%F': `%Y-%m-%d`,
                        '%h': `%b`,
                        '%r': `%I:%M:%S %p`,
                        '%R': `%H:%M`,
                        '%T': `%H:%M:%S`,
                        '%x': `%m/%d/%y`,
                        '%X': `%H:%M:%S`,
                        '%Ec': `%c`,
                        '%EC': `%C`,
                        '%Ex': `%m/%d/%y`,
                        '%EX': `%H:%M:%S`,
                        '%Ey': `%y`,
                        '%EY': `%Y`,
                        '%Od': `%d`,
                        '%Oe': `%e`,
                        '%OH': `%H`,
                        '%OI': `%I`,
                        '%Om': `%m`,
                        '%OM': `%M`,
                        '%OS': `%S`,
                        '%Ou': `%u`,
                        '%OU': `%U`,
                        '%OV': `%V`,
                        '%Ow': `%w`,
                        '%OW': `%W`,
                        '%Oy': `%y`,
                      })))
                        n = n.replace(new RegExp(u, `g`), l[u]);
                      var d = `Sunday Monday Tuesday Wednesday Thursday Friday Saturday`.split(` `),
                        f =
                          `January February March April May June July August September October November December`.split(
                            ` `,
                          );
                      for (u in ((l = {
                        '%a': function (e) {
                          return d[e.Ab].substring(0, 3);
                        },
                        '%A': function (e) {
                          return d[e.Ab];
                        },
                        '%b': function (e) {
                          return f[e.Hb].substring(0, 3);
                        },
                        '%B': function (e) {
                          return f[e.Hb];
                        },
                        '%C': function (e) {
                          return a(((e.Cb + 1900) / 100) | 0, 2);
                        },
                        '%d': function (e) {
                          return a(e.Kb, 2);
                        },
                        '%e': function (e) {
                          return i(e.Kb, 2, ` `);
                        },
                        '%g': function (e) {
                          return c(e).toString().substring(2);
                        },
                        '%G': function (e) {
                          return c(e);
                        },
                        '%H': function (e) {
                          return a(e.Gb, 2);
                        },
                        '%I': function (e) {
                          return ((e = e.Gb) == 0 ? (e = 12) : 12 < e && (e -= 12), a(e, 2));
                        },
                        '%j': function (e) {
                          for (var t = 0, n = 0; n <= e.Hb - 1; t += (Ce(e.Cb + 1900) ? W : we)[n++]);
                          return a(e.Kb + t, 3);
                        },
                        '%m': function (e) {
                          return a(e.Hb + 1, 2);
                        },
                        '%M': function (e) {
                          return a(e.Zb, 2);
                        },
                        '%n': function () {
                          return `
`;
                        },
                        '%p': function (e) {
                          return 0 <= e.Gb && 12 > e.Gb ? `AM` : `PM`;
                        },
                        '%S': function (e) {
                          return a(e.$b, 2);
                        },
                        '%t': function () {
                          return `	`;
                        },
                        '%u': function (e) {
                          return e.Ab || 7;
                        },
                        '%U': function (e) {
                          return a(Math.floor((e.Bb + 7 - e.Ab) / 7), 2);
                        },
                        '%V': function (e) {
                          var t = Math.floor((e.Bb + 7 - ((e.Ab + 6) % 7)) / 7);
                          if ((2 >= (e.Ab + 371 - e.Bb - 2) % 7 && t++, t))
                            t == 53 && ((n = (e.Ab + 371 - e.Bb) % 7) == 4 || (n == 3 && Ce(e.Cb)) || (t = 1));
                          else {
                            t = 52;
                            var n = (e.Ab + 7 - e.Bb - 1) % 7;
                            (n == 4 || (n == 5 && Ce((e.Cb % 400) - 1))) && t++;
                          }
                          return a(t, 2);
                        },
                        '%w': function (e) {
                          return e.Ab;
                        },
                        '%W': function (e) {
                          return a(Math.floor((e.Bb + 7 - ((e.Ab + 6) % 7)) / 7), 2);
                        },
                        '%y': function (e) {
                          return (e.Cb + 1900).toString().substring(2);
                        },
                        '%Y': function (e) {
                          return e.Cb + 1900;
                        },
                        '%z': function (e) {
                          var t = 0 <= (e = e.Yb);
                          return (
                            (e = Math.abs(e) / 60),
                            (t ? `+` : `-`) + String(`0000` + ((e / 60) * 100 + (e % 60))).slice(-4)
                          );
                        },
                        '%Z': function (e) {
                          return e.ac;
                        },
                        '%%': function () {
                          return `%`;
                        },
                      }),
                      (n = n.replace(/%%/g, `\0\0`)),
                      l))
                        n.includes(u) && (n = n.replace(new RegExp(u, `g`), l[u](r)));
                      return (
                        (u = (function (e) {
                          var t = Array(P(e) + 1);
                          return (N(e, t, 0, t.length), t);
                        })((n = n.replace(/\0\0/g, `%`)))),
                        u.length > t ? 0 : (T.set(u, e >>> 0), u.length - 1)
                      );
                    }
                    var Ee = {
                      a: function (e) {
                        return G(e + 24) + 24;
                      },
                      m: function (e) {
                        return ((e = new V(e)).Pb() || (e.Ib(!0), me--), e.Jb(!1), pe.push(e), e.Nb(), e.Qb());
                      },
                      ia: function (e) {
                        throw (
                          x(`Unexpected exception thrown, this is not properly supported - aborting`),
                          (k = !0),
                          e
                        );
                      },
                      w: function () {
                        K(0);
                        var e = pe.pop();
                        if (e.Xb() && !e.Lb()) {
                          var t = e.Wb();
                          (t && H(t)(e.Db), he(e.Db));
                        }
                        B = 0;
                      },
                      d: function () {
                        var e = B;
                        if (!e) return (U = 0);
                        var t = new V(e);
                        t.Fb(e);
                        var n = t.Eb();
                        if (!n) return ((U = 0), e);
                        for (var r = Array.prototype.slice.call(arguments), i = 0; i < r.length; i++) {
                          var a = r[i];
                          if (a === 0 || a === n) break;
                          if (Me(a, n, t.zb + 16)) return ((U = a), e);
                        }
                        return ((U = n), e);
                      },
                      k: function () {
                        var e = B;
                        if (!e) return (U = 0);
                        var t = new V(e);
                        t.Fb(e);
                        var n = t.Eb();
                        if (!n) return ((U = 0), e);
                        for (var r = Array.prototype.slice.call(arguments), i = 0; i < r.length; i++) {
                          var a = r[i];
                          if (a === 0 || a === n) break;
                          if (Me(a, n, t.zb + 16)) return ((U = a), e);
                        }
                        return ((U = n), e);
                      },
                      g: function () {
                        var e = B;
                        if (!e) return (U = 0);
                        var t = new V(e);
                        t.Fb(e);
                        var n = t.Eb();
                        if (!n) return ((U = 0), e);
                        for (var r = Array.prototype.slice.call(arguments), i = 0; i < r.length; i++) {
                          var a = r[i];
                          if (a === 0 || a === n) break;
                          if (Me(a, n, t.zb + 16)) return ((U = a), e);
                        }
                        return ((U = n), e);
                      },
                      s: he,
                      L: function () {
                        var e = pe.pop();
                        e || z(`no exception to throw`);
                        var t = e.Db;
                        throw (e.Lb() || (pe.push(e), e.Jb(!0), e.Ib(!1), me++), (B = t), t);
                      },
                      b: function (e, t, n) {
                        throw (new V(e).Rb(t, n), (B = e), me++, e);
                      },
                      la: function () {
                        return me;
                      },
                      i: function (e) {
                        throw ((B ||= e), e);
                      },
                      H: function () {
                        return 0;
                      },
                      Ba: function () {},
                      pa: function () {},
                      ra: function () {},
                      ka: function () {
                        return 0;
                      },
                      za: function () {},
                      ua: function () {},
                      ya: function () {},
                      R: function () {},
                      qa: function () {},
                      na: function () {},
                      Aa: function () {},
                      oa: function () {},
                      Ha: function () {},
                      Ja: function () {
                        z(
                          `To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking`,
                        );
                      },
                      Ia: function () {
                        z(
                          `To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking`,
                        );
                      },
                      S: function () {
                        return Date.now();
                      },
                      Ca: function () {
                        return !0;
                      },
                      Da: function (e, t) {
                        ((e = new Date(1e3 * (O[e >>> 2] + 4294967296 * D[(e + 4) >>> 2]))),
                          (D[(t >> 2) >>> 0] = e.getUTCSeconds()),
                          (D[((t + 4) >> 2) >>> 0] = e.getUTCMinutes()),
                          (D[((t + 8) >> 2) >>> 0] = e.getUTCHours()),
                          (D[((t + 12) >> 2) >>> 0] = e.getUTCDate()),
                          (D[((t + 16) >> 2) >>> 0] = e.getUTCMonth()),
                          (D[((t + 20) >> 2) >>> 0] = e.getUTCFullYear() - 1900),
                          (D[((t + 24) >> 2) >>> 0] = e.getUTCDay()),
                          (D[((t + 28) >> 2) >>> 0] =
                            ((e.getTime() - Date.UTC(e.getUTCFullYear(), 0, 1, 0, 0, 0, 0)) / 864e5) | 0));
                      },
                      Ea: function (e, t) {
                        ((e = new Date(1e3 * (O[e >>> 2] + 4294967296 * D[(e + 4) >>> 2]))),
                          (D[(t >> 2) >>> 0] = e.getSeconds()),
                          (D[((t + 4) >> 2) >>> 0] = e.getMinutes()),
                          (D[((t + 8) >> 2) >>> 0] = e.getHours()),
                          (D[((t + 12) >> 2) >>> 0] = e.getDate()),
                          (D[((t + 16) >> 2) >>> 0] = e.getMonth()),
                          (D[((t + 20) >> 2) >>> 0] = e.getFullYear() - 1900),
                          (D[((t + 24) >> 2) >>> 0] = e.getDay()));
                        var n = new Date(e.getFullYear(), 0, 1);
                        ((D[((t + 28) >> 2) >>> 0] = ((e.getTime() - n.getTime()) / 864e5) | 0),
                          (D[((t + 36) >> 2) >>> 0] = -60 * e.getTimezoneOffset()));
                        var r = new Date(e.getFullYear(), 6, 1).getTimezoneOffset();
                        ((n = n.getTimezoneOffset()),
                          (D[((t + 32) >> 2) >>> 0] = 0 | (r != n && e.getTimezoneOffset() == Math.min(n, r))));
                      },
                      Fa: function (e) {
                        var t = new Date(
                            D[((e + 20) >> 2) >>> 0] + 1900,
                            D[((e + 16) >> 2) >>> 0],
                            D[((e + 12) >> 2) >>> 0],
                            D[((e + 8) >> 2) >>> 0],
                            D[((e + 4) >> 2) >>> 0],
                            D[(e >> 2) >>> 0],
                            0,
                          ),
                          n = D[((e + 32) >> 2) >>> 0],
                          r = t.getTimezoneOffset(),
                          i = new Date(t.getFullYear(), 0, 1),
                          a = new Date(t.getFullYear(), 6, 1).getTimezoneOffset(),
                          o = i.getTimezoneOffset(),
                          s = Math.min(o, a);
                        return (
                          0 > n
                            ? (D[((e + 32) >> 2) >>> 0] = Number(a != o && s == r))
                            : 0 < n != (s == r) &&
                              ((a = Math.max(o, a)), t.setTime(t.getTime() + 6e4 * ((0 < n ? s : a) - r))),
                          (D[((e + 24) >> 2) >>> 0] = t.getDay()),
                          (D[((e + 28) >> 2) >>> 0] = ((t.getTime() - i.getTime()) / 864e5) | 0),
                          (D[(e >> 2) >>> 0] = t.getSeconds()),
                          (D[((e + 4) >> 2) >>> 0] = t.getMinutes()),
                          (D[((e + 8) >> 2) >>> 0] = t.getHours()),
                          (D[((e + 12) >> 2) >>> 0] = t.getDate()),
                          (D[((e + 16) >> 2) >>> 0] = t.getMonth()),
                          (t.getTime() / 1e3) | 0
                        );
                      },
                      sa: function () {
                        return -52;
                      },
                      ta: function () {},
                      Ga: function e(t, n, r) {
                        e.Vb ||
                          ((e.Vb = !0),
                          (function (e, t, n) {
                            function r(e) {
                              return (e = e.toTimeString().match(/\(([A-Za-z ]+)\)$/)) ? e[1] : `GMT`;
                            }
                            var i = new Date().getFullYear(),
                              a = new Date(i, 0, 1),
                              o = new Date(i, 6, 1);
                            i = a.getTimezoneOffset();
                            var s = o.getTimezoneOffset();
                            ((D[(e >> 2) >>> 0] = 60 * Math.max(i, s)),
                              (D[(t >> 2) >>> 0] = Number(i != s)),
                              (e = r(a)),
                              (t = r(o)),
                              (e = _e(e)),
                              (t = _e(t)),
                              s < i
                                ? ((O[(n >> 2) >>> 0] = e), (O[((n + 4) >> 2) >>> 0] = t))
                                : ((O[(n >> 2) >>> 0] = t), (O[((n + 4) >> 2) >>> 0] = e)));
                          })(t, n, r));
                      },
                      B: function () {
                        z(``);
                      },
                      ma: function () {
                        return 4294901760;
                      },
                      I: _
                        ? () => {
                            var e = process.hrtime();
                            return 1e3 * e[0] + e[1] / 1e6;
                          }
                        : () => performance.now(),
                      xa: function (e, t, n) {
                        E.copyWithin(e >>> 0, t >>> 0, (t + n) >>> 0);
                      },
                      G: function (e) {
                        var t = E.length;
                        if (4294901760 < (e >>>= 0)) return !1;
                        for (var n = 1; 4 >= n; n *= 2) {
                          var r = t * (1 + 0.2 / n);
                          r = Math.min(r, e + 100663296);
                          var i = Math;
                          ((r = Math.max(e, r)), (i = i.min.call(i, 4294901760, r + ((65536 - (r % 65536)) % 65536))));
                          t: {
                            try {
                              (C.grow((i - w.byteLength + 65535) >>> 16), F());
                              var a = 1;
                              break t;
                            } catch {}
                            a = void 0;
                          }
                          if (a) return !0;
                        }
                        return !1;
                      },
                      va: function (e, t) {
                        var n = 0;
                        return (
                          ye().forEach(function (r, i) {
                            var a = t + n;
                            for (i = O[((e + 4 * i) >> 2) >>> 0] = a, a = 0; a < r.length; ++a)
                              T[(i++ >> 0) >>> 0] = r.charCodeAt(a);
                            ((T[(i >> 0) >>> 0] = 0), (n += r.length + 1));
                          }),
                          0
                        );
                      },
                      wa: function (e, t) {
                        var n = ye();
                        O[(e >> 2) >>> 0] = n.length;
                        var r = 0;
                        return (
                          n.forEach(function (e) {
                            r += e.length + 1;
                          }),
                          (O[(t >> 2) >>> 0] = r),
                          0
                        );
                      },
                      ba: function (e) {
                        (S || 0 < ae || (Ae(), fe(re), ke(0), xe[1].length && Se(1, 10), xe[2].length && Se(2, 10)),
                          S || 0 < ae || (t.onExit && t.onExit(e), (k = !0)),
                          m(e, new de(e)));
                      },
                      E: function () {
                        return 52;
                      },
                      Q: function () {
                        return 52;
                      },
                      ca: function () {
                        return 70;
                      },
                      P: function (e, t, n, r) {
                        for (var i = 0, a = 0; a < n; a++) {
                          var o = O[(t >> 2) >>> 0],
                            s = O[((t + 4) >> 2) >>> 0];
                          t += 8;
                          for (var c = 0; c < s; c++) Se(e, E[(o + c) >>> 0]);
                          i += s;
                        }
                        return ((O[(r >> 2) >>> 0] = i), 0);
                      },
                      c: function () {
                        return U;
                      },
                      ja: function e(t, r) {
                        e.Mb ||= (function () {
                          if (typeof crypto == `object` && typeof crypto.getRandomValues == `function`) {
                            var e = new Uint8Array(1);
                            return () => (crypto.getRandomValues(e), e[0]);
                          }
                          if (_)
                            try {
                              var t = n(
                                Object(
                                  (function () {
                                    var e = Error(`Cannot find module 'crypto'`);
                                    throw ((e.code = `MODULE_NOT_FOUND`), e);
                                  })(),
                                ),
                              );
                              return () => t.randomBytes(1)[0];
                            } catch {}
                          return () => z(`randomDevice`);
                        })();
                        for (var i = 0; i < r; i++) T[((t + i) >> 0) >>> 0] = e.Mb();
                        return 0;
                      },
                      ea: function (e, t, n) {
                        var r = q();
                        try {
                          return H(e)(t, n);
                        } catch (e) {
                          if ((J(r), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      fa: function (e, t, n) {
                        var r = q();
                        try {
                          return H(e)(t, n);
                        } catch (e) {
                          if ((J(r), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      J: function (e) {
                        var t = q();
                        try {
                          return H(e)();
                        } catch (e) {
                          if ((J(t), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      e: function (e, t) {
                        var n = q();
                        try {
                          return H(e)(t);
                        } catch (e) {
                          if ((J(n), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      N: function (e, t, n) {
                        var r = q();
                        try {
                          return H(e)(t, n);
                        } catch (e) {
                          if ((J(r), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      O: function (e, t, n) {
                        var r = q();
                        try {
                          return H(e)(t, n);
                        } catch (e) {
                          if ((J(r), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      j: function (e, t, n) {
                        var r = q();
                        try {
                          return H(e)(t, n);
                        } catch (e) {
                          if ((J(r), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      o: function (e, t, n, r) {
                        var i = q();
                        try {
                          return H(e)(t, n, r);
                        } catch (e) {
                          if ((J(i), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      p: function (e, t, n, r, i) {
                        var a = q();
                        try {
                          return H(e)(t, n, r, i);
                        } catch (e) {
                          if ((J(a), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      M: function (e, t, n, r, i, a) {
                        var o = q();
                        try {
                          return H(e)(t, n, r, i, a);
                        } catch (e) {
                          if ((J(o), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      r: function (e, t, n, r, i, a) {
                        var o = q();
                        try {
                          return H(e)(t, n, r, i, a);
                        } catch (e) {
                          if ((J(o), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      v: function (e, t, n, r, i, a, o) {
                        var s = q();
                        try {
                          return H(e)(t, n, r, i, a, o);
                        } catch (e) {
                          if ((J(s), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      K: function (e, t, n, r, i, a, o, s) {
                        var c = q();
                        try {
                          return H(e)(t, n, r, i, a, o, s);
                        } catch (e) {
                          if ((J(c), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      D: function (e, t, n, r, i, a, o, s, c, l, u, d) {
                        var f = q();
                        try {
                          return H(e)(t, n, r, i, a, o, s, c, l, u, d);
                        } catch (e) {
                          if ((J(f), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      X: function (e, t, n, r, i, a, o, s) {
                        var c = q();
                        try {
                          return He(e, t, n, r, i, a, o, s);
                        } catch (e) {
                          if ((J(c), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      V: function (e, t, n, r, i, a, o) {
                        var s = q();
                        try {
                          return Fe(e, t, n, r, i, a, o);
                        } catch (e) {
                          if ((J(s), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      U: function (e, t, n, r, i) {
                        var a = q();
                        try {
                          return Ue(e, t, n, r, i);
                        } catch (e) {
                          if ((J(a), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      Z: function (e, t, n, r) {
                        var i = q();
                        try {
                          return Be(e, t, n, r);
                        } catch (e) {
                          if ((J(i), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      W: function (e) {
                        var t = q();
                        try {
                          return Pe(e);
                        } catch (e) {
                          if ((J(t), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      Y: function (e, t) {
                        var n = q();
                        try {
                          return Ve(e, t);
                        } catch (e) {
                          if ((J(n), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      T: function (e, t, n) {
                        var r = q();
                        try {
                          return Ie(e, t, n);
                        } catch (e) {
                          if ((J(r), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      f: function (e) {
                        var t = q();
                        try {
                          H(e)();
                        } catch (e) {
                          if ((J(t), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      q: function (e, t) {
                        var n = q();
                        try {
                          H(e)(t);
                        } catch (e) {
                          if ((J(n), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      h: function (e, t, n) {
                        var r = q();
                        try {
                          H(e)(t, n);
                        } catch (e) {
                          if ((J(r), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      da: function (e, t, n, r) {
                        var i = q();
                        try {
                          H(e)(t, n, r);
                        } catch (e) {
                          if ((J(i), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      l: function (e, t, n, r) {
                        var i = q();
                        try {
                          H(e)(t, n, r);
                        } catch (e) {
                          if ((J(i), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      t: function (e, t, n, r, i) {
                        var a = q();
                        try {
                          H(e)(t, n, r, i);
                        } catch (e) {
                          if ((J(a), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      u: function (e, t, n, r, i, a) {
                        var o = q();
                        try {
                          H(e)(t, n, r, i, a);
                        } catch (e) {
                          if ((J(o), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      x: function (e, t, n, r, i, a, o) {
                        var s = q();
                        try {
                          H(e)(t, n, r, i, a, o);
                        } catch (e) {
                          if ((J(s), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      z: function (e, t, n, r, i, a, o, s) {
                        var c = q();
                        try {
                          H(e)(t, n, r, i, a, o, s);
                        } catch (e) {
                          if ((J(c), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      ga: function (e, t, n, r, i, a, o, s, c) {
                        var l = q();
                        try {
                          H(e)(t, n, r, i, a, o, s, c);
                        } catch (e) {
                          if ((J(l), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      A: function (e, t, n, r, i, a, o, s, c, l, u) {
                        var d = q();
                        try {
                          H(e)(t, n, r, i, a, o, s, c, l, u);
                        } catch (e) {
                          if ((J(d), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      C: function (e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
                        var g = q();
                        try {
                          H(e)(t, n, r, i, a, o, s, c, l, u, d, f, p, m, h);
                        } catch (e) {
                          if ((J(g), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      aa: function (e, t, n, r, i, a, o, s) {
                        var c = q();
                        try {
                          Le(e, t, n, r, i, a, o, s);
                        } catch (e) {
                          if ((J(c), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      _: function (e, t, n, r, i, a, o, s, c, l, u, d) {
                        var f = q();
                        try {
                          ze(e, t, n, r, i, a, o, s, c, l, u, d);
                        } catch (e) {
                          if ((J(f), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      $: function (e, t, n, r, i, a) {
                        var o = q();
                        try {
                          Re(e, t, n, r, i, a);
                        } catch (e) {
                          if ((J(o), e !== e + 0)) throw e;
                          K(1, 0);
                        }
                      },
                      n: function (e) {
                        return e;
                      },
                      F: function (e) {
                        U = e;
                      },
                      ha: Te,
                      y: function (e, t, n, r) {
                        return Te(e, t, n, r);
                      },
                    };
                    ((function () {
                      function e(e) {
                        ((t.asm = e.exports),
                          (C = t.asm.Ka),
                          F(),
                          (ee = t.asm.ib),
                          ne.unshift(t.asm.La),
                          L--,
                          t.monitorRunDependencies && t.monitorRunDependencies(L),
                          L == 0 && (se !== null && (clearInterval(se), (se = null)), R && ((e = R), (R = null), e())));
                      }
                      function n(t) {
                        e(t.instance);
                      }
                      function r(e) {
                        return (function () {
                          if (!y && (h || g)) {
                            if (typeof fetch == `function` && !I.startsWith(`file://`))
                              return fetch(I, { credentials: `same-origin` })
                                .then(function (e) {
                                  if (!e.ok) throw `failed to load wasm binary file at '` + I + `'`;
                                  return e.arrayBuffer();
                                })
                                .catch(function () {
                                  return ue();
                                });
                            if (s)
                              return new Promise(function (e, t) {
                                s(
                                  I,
                                  function (t) {
                                    e(new Uint8Array(t));
                                  },
                                  t,
                                );
                              });
                          }
                          return Promise.resolve().then(function () {
                            return ue();
                          });
                        })()
                          .then(function (e) {
                            return WebAssembly.instantiate(e, i);
                          })
                          .then(function (e) {
                            return e;
                          })
                          .then(e, function (e) {
                            (x(`failed to asynchronously prepare wasm: ` + e), z(e));
                          });
                      }
                      var i = { a: Ee };
                      if ((L++, t.monitorRunDependencies && t.monitorRunDependencies(L), t.instantiateWasm))
                        try {
                          return t.instantiateWasm(i, e);
                        } catch (e) {
                          return (x(`Module.instantiateWasm callback failed with error: ` + e), !1);
                        }
                      (y ||
                      typeof WebAssembly.instantiateStreaming != `function` ||
                      ce() ||
                      I.startsWith(`file://`) ||
                      _ ||
                      typeof fetch != `function`
                        ? r(n)
                        : fetch(I, { credentials: `same-origin` }).then(function (e) {
                            return WebAssembly.instantiateStreaming(e, i).then(n, function (e) {
                              return (
                                x(`wasm streaming compile failed: ` + e),
                                x(`falling back to ArrayBuffer instantiation`),
                                r(n)
                              );
                            });
                          })
                      ).catch(a);
                    })(),
                      (t.___wasm_call_ctors = function () {
                        return (t.___wasm_call_ctors = t.asm.La).apply(null, arguments);
                      }),
                      (t._OrtInit = function () {
                        return (t._OrtInit = t.asm.Ma).apply(null, arguments);
                      }),
                      (t._OrtCreateSessionOptions = function () {
                        return (t._OrtCreateSessionOptions = t.asm.Na).apply(null, arguments);
                      }),
                      (t._OrtAppendExecutionProvider = function () {
                        return (t._OrtAppendExecutionProvider = t.asm.Oa).apply(null, arguments);
                      }),
                      (t._OrtAddSessionConfigEntry = function () {
                        return (t._OrtAddSessionConfigEntry = t.asm.Pa).apply(null, arguments);
                      }),
                      (t._OrtReleaseSessionOptions = function () {
                        return (t._OrtReleaseSessionOptions = t.asm.Qa).apply(null, arguments);
                      }),
                      (t._OrtCreateSession = function () {
                        return (t._OrtCreateSession = t.asm.Ra).apply(null, arguments);
                      }),
                      (t._OrtReleaseSession = function () {
                        return (t._OrtReleaseSession = t.asm.Sa).apply(null, arguments);
                      }),
                      (t._OrtGetInputCount = function () {
                        return (t._OrtGetInputCount = t.asm.Ta).apply(null, arguments);
                      }),
                      (t._OrtGetOutputCount = function () {
                        return (t._OrtGetOutputCount = t.asm.Ua).apply(null, arguments);
                      }),
                      (t._OrtGetInputName = function () {
                        return (t._OrtGetInputName = t.asm.Va).apply(null, arguments);
                      }),
                      (t._OrtGetOutputName = function () {
                        return (t._OrtGetOutputName = t.asm.Wa).apply(null, arguments);
                      }),
                      (t._OrtFree = function () {
                        return (t._OrtFree = t.asm.Xa).apply(null, arguments);
                      }),
                      (t._OrtCreateTensor = function () {
                        return (t._OrtCreateTensor = t.asm.Ya).apply(null, arguments);
                      }),
                      (t._OrtGetTensorData = function () {
                        return (t._OrtGetTensorData = t.asm.Za).apply(null, arguments);
                      }),
                      (t._OrtReleaseTensor = function () {
                        return (t._OrtReleaseTensor = t.asm._a).apply(null, arguments);
                      }),
                      (t._OrtCreateRunOptions = function () {
                        return (t._OrtCreateRunOptions = t.asm.$a).apply(null, arguments);
                      }),
                      (t._OrtAddRunConfigEntry = function () {
                        return (t._OrtAddRunConfigEntry = t.asm.ab).apply(null, arguments);
                      }),
                      (t._OrtReleaseRunOptions = function () {
                        return (t._OrtReleaseRunOptions = t.asm.bb).apply(null, arguments);
                      }),
                      (t._OrtRun = function () {
                        return (t._OrtRun = t.asm.cb).apply(null, arguments);
                      }),
                      (t._OrtEndProfiling = function () {
                        return (t._OrtEndProfiling = t.asm.db).apply(null, arguments);
                      }));
                    var De,
                      G = (t._malloc = function () {
                        return (G = t._malloc = t.asm.eb).apply(null, arguments);
                      }),
                      Oe = (t._free = function () {
                        return (Oe = t._free = t.asm.fb).apply(null, arguments);
                      }),
                      ke = (t._fflush = function () {
                        return (ke = t._fflush = t.asm.gb).apply(null, arguments);
                      }),
                      Ae = (t.___funcs_on_exit = function () {
                        return (Ae = t.___funcs_on_exit = t.asm.hb).apply(null, arguments);
                      }),
                      K = (t._setThrew = function () {
                        return (K = t._setThrew = t.asm.jb).apply(null, arguments);
                      }),
                      q = (t.stackSave = function () {
                        return (q = t.stackSave = t.asm.kb).apply(null, arguments);
                      }),
                      J = (t.stackRestore = function () {
                        return (J = t.stackRestore = t.asm.lb).apply(null, arguments);
                      }),
                      je = (t.stackAlloc = function () {
                        return (je = t.stackAlloc = t.asm.mb).apply(null, arguments);
                      }),
                      Me = (t.___cxa_can_catch = function () {
                        return (Me = t.___cxa_can_catch = t.asm.nb).apply(null, arguments);
                      }),
                      Ne = (t.___cxa_is_pointer_type = function () {
                        return (Ne = t.___cxa_is_pointer_type = t.asm.ob).apply(null, arguments);
                      }),
                      Pe = (t.dynCall_j = function () {
                        return (Pe = t.dynCall_j = t.asm.pb).apply(null, arguments);
                      }),
                      Fe = (t.dynCall_iiiiij = function () {
                        return (Fe = t.dynCall_iiiiij = t.asm.qb).apply(null, arguments);
                      }),
                      Ie = (t.dynCall_jii = function () {
                        return (Ie = t.dynCall_jii = t.asm.rb).apply(null, arguments);
                      }),
                      Le = (t.dynCall_viiiiij = function () {
                        return (Le = t.dynCall_viiiiij = t.asm.sb).apply(null, arguments);
                      }),
                      Re = (t.dynCall_vjji = function () {
                        return (Re = t.dynCall_vjji = t.asm.tb).apply(null, arguments);
                      }),
                      ze = (t.dynCall_viiijjjii = function () {
                        return (ze = t.dynCall_viiijjjii = t.asm.ub).apply(null, arguments);
                      }),
                      Be = (t.dynCall_iij = function () {
                        return (Be = t.dynCall_iij = t.asm.vb).apply(null, arguments);
                      }),
                      Ve = (t.dynCall_ji = function () {
                        return (Ve = t.dynCall_ji = t.asm.wb).apply(null, arguments);
                      }),
                      He = (t.dynCall_iiiiiij = function () {
                        return (He = t.dynCall_iiiiiij = t.asm.xb).apply(null, arguments);
                      }),
                      Ue = (t.dynCall_iiij = function () {
                        return (Ue = t.dynCall_iiij = t.asm.yb).apply(null, arguments);
                      });
                    function We() {
                      function e() {
                        if (!De && ((De = !0), (t.calledRun = !0), !k)) {
                          if ((fe(ne), i(t), t.onRuntimeInitialized && t.onRuntimeInitialized(), t.postRun))
                            for (typeof t.postRun == `function` && (t.postRun = [t.postRun]); t.postRun.length; ) {
                              var e = t.postRun.shift();
                              ie.unshift(e);
                            }
                          fe(ie);
                        }
                      }
                      if (!(0 < L)) {
                        if (t.preRun)
                          for (typeof t.preRun == `function` && (t.preRun = [t.preRun]); t.preRun.length; ) oe();
                        (fe(te),
                          0 < L ||
                            (t.setStatus
                              ? (t.setStatus(`Running...`),
                                setTimeout(function () {
                                  (setTimeout(function () {
                                    t.setStatus(``);
                                  }, 1),
                                    e());
                                }, 1))
                              : e()));
                      }
                    }
                    if (
                      ((t.UTF8ToString = M),
                      (t.stringToUTF8 = function (e, t, n) {
                        return N(e, E, t, n);
                      }),
                      (t.lengthBytesUTF8 = P),
                      (t.stackSave = q),
                      (t.stackRestore = J),
                      (t.stackAlloc = je),
                      (R = function e() {
                        (De || We(), De || (R = e));
                      }),
                      t.preInit)
                    )
                      for (typeof t.preInit == `function` && (t.preInit = [t.preInit]); 0 < t.preInit.length; )
                        t.preInit.pop()();
                    return (We(), e.ready);
                  });
              },
              4537: (e) => {
                'use strict';
                e.exports = function (e, t) {
                  for (var n = Array(arguments.length - 1), r = 0, i = 2, a = !0; i < arguments.length; )
                    n[r++] = arguments[i++];
                  return new Promise(function (i, o) {
                    n[r] = function (e) {
                      if (a)
                        if (((a = !1), e)) o(e);
                        else {
                          for (var t = Array(arguments.length - 1), n = 0; n < t.length; ) t[n++] = arguments[n];
                          i.apply(null, t);
                        }
                    };
                    try {
                      e.apply(t || null, n);
                    } catch (e) {
                      a && ((a = !1), o(e));
                    }
                  });
                };
              },
              7419: (e, t) => {
                'use strict';
                var n = t;
                n.length = function (e) {
                  var t = e.length;
                  if (!t) return 0;
                  for (var n = 0; --t % 4 > 1 && e.charAt(t) === `=`; ) ++n;
                  return Math.ceil(3 * e.length) / 4 - n;
                };
                for (var r = Array(64), i = Array(123), a = 0; a < 64; )
                  i[(r[a] = a < 26 ? a + 65 : a < 52 ? a + 71 : a < 62 ? a - 4 : (a - 59) | 43)] = a++;
                n.encode = function (e, t, n) {
                  for (var i, a = null, o = [], s = 0, c = 0; t < n; ) {
                    var l = e[t++];
                    switch (c) {
                      case 0:
                        ((o[s++] = r[l >> 2]), (i = (3 & l) << 4), (c = 1));
                        break;
                      case 1:
                        ((o[s++] = r[i | (l >> 4)]), (i = (15 & l) << 2), (c = 2));
                        break;
                      case 2:
                        ((o[s++] = r[i | (l >> 6)]), (o[s++] = r[63 & l]), (c = 0));
                    }
                    s > 8191 && ((a ||= []).push(String.fromCharCode.apply(String, o)), (s = 0));
                  }
                  return (
                    c && ((o[s++] = r[i]), (o[s++] = 61), c === 1 && (o[s++] = 61)),
                    a
                      ? (s && a.push(String.fromCharCode.apply(String, o.slice(0, s))), a.join(``))
                      : String.fromCharCode.apply(String, o.slice(0, s))
                  );
                };
                var o = `invalid encoding`;
                ((n.decode = function (e, t, n) {
                  for (var r, a = n, s = 0, c = 0; c < e.length; ) {
                    var l = e.charCodeAt(c++);
                    if (l === 61 && s > 1) break;
                    if ((l = i[l]) === void 0) throw Error(o);
                    switch (s) {
                      case 0:
                        ((r = l), (s = 1));
                        break;
                      case 1:
                        ((t[n++] = (r << 2) | ((48 & l) >> 4)), (r = l), (s = 2));
                        break;
                      case 2:
                        ((t[n++] = ((15 & r) << 4) | ((60 & l) >> 2)), (r = l), (s = 3));
                        break;
                      case 3:
                        ((t[n++] = ((3 & r) << 6) | l), (s = 0));
                    }
                  }
                  if (s === 1) throw Error(o);
                  return n - a;
                }),
                  (n.test = function (e) {
                    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(e);
                  }));
              },
              9211: (e) => {
                'use strict';
                function t() {
                  this._listeners = {};
                }
                ((e.exports = t),
                  (t.prototype.on = function (e, t, n) {
                    return ((this._listeners[e] || (this._listeners[e] = [])).push({ fn: t, ctx: n || this }), this);
                  }),
                  (t.prototype.off = function (e, t) {
                    if (e === void 0) this._listeners = {};
                    else if (t === void 0) this._listeners[e] = [];
                    else for (var n = this._listeners[e], r = 0; r < n.length; ) n[r].fn === t ? n.splice(r, 1) : ++r;
                    return this;
                  }),
                  (t.prototype.emit = function (e) {
                    var t = this._listeners[e];
                    if (t) {
                      for (var n = [], r = 1; r < arguments.length; ) n.push(arguments[r++]);
                      for (r = 0; r < t.length; ) t[r].fn.apply(t[r++].ctx, n);
                    }
                    return this;
                  }));
              },
              945: (e) => {
                'use strict';
                function t(e) {
                  return (
                    typeof Float32Array < `u`
                      ? (function () {
                          var t = new Float32Array([-0]),
                            n = new Uint8Array(t.buffer),
                            r = n[3] === 128;
                          function i(e, r, i) {
                            ((t[0] = e), (r[i] = n[0]), (r[i + 1] = n[1]), (r[i + 2] = n[2]), (r[i + 3] = n[3]));
                          }
                          function a(e, r, i) {
                            ((t[0] = e), (r[i] = n[3]), (r[i + 1] = n[2]), (r[i + 2] = n[1]), (r[i + 3] = n[0]));
                          }
                          function o(e, r) {
                            return ((n[0] = e[r]), (n[1] = e[r + 1]), (n[2] = e[r + 2]), (n[3] = e[r + 3]), t[0]);
                          }
                          function s(e, r) {
                            return ((n[3] = e[r]), (n[2] = e[r + 1]), (n[1] = e[r + 2]), (n[0] = e[r + 3]), t[0]);
                          }
                          ((e.writeFloatLE = r ? i : a),
                            (e.writeFloatBE = r ? a : i),
                            (e.readFloatLE = r ? o : s),
                            (e.readFloatBE = r ? s : o));
                        })()
                      : (function () {
                          function t(e, t, n, r) {
                            var i = +(t < 0);
                            if ((i && (t = -t), t === 0)) e(1 / t > 0 ? 0 : 2147483648, n, r);
                            else if (isNaN(t)) e(2143289344, n, r);
                            else if (t > 34028234663852886e22) e(((i << 31) | 2139095040) >>> 0, n, r);
                            else if (t < 11754943508222875e-54)
                              e(((i << 31) | Math.round(t / 1401298464324817e-60)) >>> 0, n, r);
                            else {
                              var a = Math.floor(Math.log(t) / Math.LN2);
                              e(
                                ((i << 31) | ((a + 127) << 23) | (8388607 & Math.round(t * 2 ** -a * 8388608))) >>> 0,
                                n,
                                r,
                              );
                            }
                          }
                          function o(e, t, n) {
                            var r = e(t, n),
                              i = 2 * (r >> 31) + 1,
                              a = (r >>> 23) & 255,
                              o = 8388607 & r;
                            return a === 255
                              ? o
                                ? NaN
                                : i * (1 / 0)
                              : a === 0
                                ? 1401298464324817e-60 * i * o
                                : i * 2 ** (a - 150) * (o + 8388608);
                          }
                          ((e.writeFloatLE = t.bind(null, n)),
                            (e.writeFloatBE = t.bind(null, r)),
                            (e.readFloatLE = o.bind(null, i)),
                            (e.readFloatBE = o.bind(null, a)));
                        })(),
                    typeof Float64Array < `u`
                      ? (function () {
                          var t = new Float64Array([-0]),
                            n = new Uint8Array(t.buffer),
                            r = n[7] === 128;
                          function i(e, r, i) {
                            ((t[0] = e),
                              (r[i] = n[0]),
                              (r[i + 1] = n[1]),
                              (r[i + 2] = n[2]),
                              (r[i + 3] = n[3]),
                              (r[i + 4] = n[4]),
                              (r[i + 5] = n[5]),
                              (r[i + 6] = n[6]),
                              (r[i + 7] = n[7]));
                          }
                          function a(e, r, i) {
                            ((t[0] = e),
                              (r[i] = n[7]),
                              (r[i + 1] = n[6]),
                              (r[i + 2] = n[5]),
                              (r[i + 3] = n[4]),
                              (r[i + 4] = n[3]),
                              (r[i + 5] = n[2]),
                              (r[i + 6] = n[1]),
                              (r[i + 7] = n[0]));
                          }
                          function o(e, r) {
                            return (
                              (n[0] = e[r]),
                              (n[1] = e[r + 1]),
                              (n[2] = e[r + 2]),
                              (n[3] = e[r + 3]),
                              (n[4] = e[r + 4]),
                              (n[5] = e[r + 5]),
                              (n[6] = e[r + 6]),
                              (n[7] = e[r + 7]),
                              t[0]
                            );
                          }
                          function s(e, r) {
                            return (
                              (n[7] = e[r]),
                              (n[6] = e[r + 1]),
                              (n[5] = e[r + 2]),
                              (n[4] = e[r + 3]),
                              (n[3] = e[r + 4]),
                              (n[2] = e[r + 5]),
                              (n[1] = e[r + 6]),
                              (n[0] = e[r + 7]),
                              t[0]
                            );
                          }
                          ((e.writeDoubleLE = r ? i : a),
                            (e.writeDoubleBE = r ? a : i),
                            (e.readDoubleLE = r ? o : s),
                            (e.readDoubleBE = r ? s : o));
                        })()
                      : (function () {
                          function t(e, t, n, r, i, a) {
                            var o = +(r < 0);
                            if ((o && (r = -r), r === 0)) (e(0, i, a + t), e(1 / r > 0 ? 0 : 2147483648, i, a + n));
                            else if (isNaN(r)) (e(0, i, a + t), e(2146959360, i, a + n));
                            else if (r > 17976931348623157e292)
                              (e(0, i, a + t), e(((o << 31) | 2146435072) >>> 0, i, a + n));
                            else {
                              var s;
                              if (r < 22250738585072014e-324)
                                (e((s = r / 5e-324) >>> 0, i, a + t),
                                  e(((o << 31) | (s / 4294967296)) >>> 0, i, a + n));
                              else {
                                var c = Math.floor(Math.log(r) / Math.LN2);
                                (c === 1024 && (c = 1023),
                                  e((4503599627370496 * (s = r * 2 ** -c)) >>> 0, i, a + t),
                                  e(((o << 31) | ((c + 1023) << 20) | ((1048576 * s) & 1048575)) >>> 0, i, a + n));
                              }
                            }
                          }
                          function o(e, t, n, r, i) {
                            var a = e(r, i + t),
                              o = e(r, i + n),
                              s = 2 * (o >> 31) + 1,
                              c = (o >>> 20) & 2047,
                              l = 4294967296 * (1048575 & o) + a;
                            return c === 2047
                              ? l
                                ? NaN
                                : s * (1 / 0)
                              : c === 0
                                ? 5e-324 * s * l
                                : s * 2 ** (c - 1075) * (l + 4503599627370496);
                          }
                          ((e.writeDoubleLE = t.bind(null, n, 0, 4)),
                            (e.writeDoubleBE = t.bind(null, r, 4, 0)),
                            (e.readDoubleLE = o.bind(null, i, 0, 4)),
                            (e.readDoubleBE = o.bind(null, a, 4, 0)));
                        })(),
                    e
                  );
                }
                function n(e, t, n) {
                  ((t[n] = 255 & e),
                    (t[n + 1] = (e >>> 8) & 255),
                    (t[n + 2] = (e >>> 16) & 255),
                    (t[n + 3] = e >>> 24));
                }
                function r(e, t, n) {
                  ((t[n] = e >>> 24),
                    (t[n + 1] = (e >>> 16) & 255),
                    (t[n + 2] = (e >>> 8) & 255),
                    (t[n + 3] = 255 & e));
                }
                function i(e, t) {
                  return (e[t] | (e[t + 1] << 8) | (e[t + 2] << 16) | (e[t + 3] << 24)) >>> 0;
                }
                function a(e, t) {
                  return ((e[t] << 24) | (e[t + 1] << 16) | (e[t + 2] << 8) | e[t + 3]) >>> 0;
                }
                e.exports = t(t);
              },
              7199: (module$1) => {
                'use strict';
                function inquire(moduleName) {
                  try {
                    var mod = eval(`quire`.replace(/^/, `re`))(moduleName);
                    if (mod && (mod.length || Object.keys(mod).length)) return mod;
                  } catch {}
                  return null;
                }
                module$1.exports = inquire;
              },
              6662: (e) => {
                'use strict';
                e.exports = function (e, t, n) {
                  var r = n || 8192,
                    i = r >>> 1,
                    a = null,
                    o = r;
                  return function (n) {
                    if (n < 1 || n > i) return e(n);
                    o + n > r && ((a = e(r)), (o = 0));
                    var s = t.call(a, o, (o += n));
                    return (7 & o && (o = 1 + (7 | o)), s);
                  };
                };
              },
              4997: (e, t) => {
                'use strict';
                var n = t;
                ((n.length = function (e) {
                  for (var t = 0, n = 0, r = 0; r < e.length; ++r)
                    (n = e.charCodeAt(r)) < 128
                      ? (t += 1)
                      : n < 2048
                        ? (t += 2)
                        : (64512 & n) == 55296 && (64512 & e.charCodeAt(r + 1)) == 56320
                          ? (++r, (t += 4))
                          : (t += 3);
                  return t;
                }),
                  (n.read = function (e, t, n) {
                    if (n - t < 1) return ``;
                    for (var r, i = null, a = [], o = 0; t < n; )
                      ((r = e[t++]) < 128
                        ? (a[o++] = r)
                        : r > 191 && r < 224
                          ? (a[o++] = ((31 & r) << 6) | (63 & e[t++]))
                          : r > 239 && r < 365
                            ? ((r =
                                (((7 & r) << 18) | ((63 & e[t++]) << 12) | ((63 & e[t++]) << 6) | (63 & e[t++])) -
                                65536),
                              (a[o++] = 55296 + (r >> 10)),
                              (a[o++] = 56320 + (1023 & r)))
                            : (a[o++] = ((15 & r) << 12) | ((63 & e[t++]) << 6) | (63 & e[t++])),
                        o > 8191 && ((i ||= []).push(String.fromCharCode.apply(String, a)), (o = 0)));
                    return i
                      ? (o && i.push(String.fromCharCode.apply(String, a.slice(0, o))), i.join(``))
                      : String.fromCharCode.apply(String, a.slice(0, o));
                  }),
                  (n.write = function (e, t, n) {
                    for (var r, i, a = n, o = 0; o < e.length; ++o)
                      (r = e.charCodeAt(o)) < 128
                        ? (t[n++] = r)
                        : r < 2048
                          ? ((t[n++] = (r >> 6) | 192), (t[n++] = (63 & r) | 128))
                          : (64512 & r) == 55296 && (64512 & (i = e.charCodeAt(o + 1))) == 56320
                            ? ((r = 65536 + ((1023 & r) << 10) + (1023 & i)),
                              ++o,
                              (t[n++] = (r >> 18) | 240),
                              (t[n++] = ((r >> 12) & 63) | 128),
                              (t[n++] = ((r >> 6) & 63) | 128),
                              (t[n++] = (63 & r) | 128))
                            : ((t[n++] = (r >> 12) | 224), (t[n++] = ((r >> 6) & 63) | 128), (t[n++] = (63 & r) | 128));
                    return n - a;
                  }));
              },
              3442: (e, t) => {
                'use strict';
                ((t.__esModule = !0),
                  (t.Guid = (function () {
                    function e(t) {
                      if (!t) throw TypeError('Invalid argument; `value` has no value.');
                      ((this.value = e.EMPTY), t && e.isGuid(t) && (this.value = t));
                    }
                    return (
                      (e.isGuid = function (t) {
                        var n = t.toString();
                        return t && (t instanceof e || e.validator.test(n));
                      }),
                      (e.create = function () {
                        return new e([e.gen(2), e.gen(1), e.gen(1), e.gen(1), e.gen(3)].join(`-`));
                      }),
                      (e.createEmpty = function () {
                        return new e(`emptyguid`);
                      }),
                      (e.parse = function (t) {
                        return new e(t);
                      }),
                      (e.raw = function () {
                        return [e.gen(2), e.gen(1), e.gen(1), e.gen(1), e.gen(3)].join(`-`);
                      }),
                      (e.gen = function (e) {
                        for (var t = ``, n = 0; n < e; n++)
                          t += ((65536 * (1 + Math.random())) | 0).toString(16).substring(1);
                        return t;
                      }),
                      (e.prototype.equals = function (t) {
                        return e.isGuid(t) && this.value === t.toString();
                      }),
                      (e.prototype.isEmpty = function () {
                        return this.value === e.EMPTY;
                      }),
                      (e.prototype.toString = function () {
                        return this.value;
                      }),
                      (e.prototype.toJSON = function () {
                        return { value: this.value };
                      }),
                      (e.validator = RegExp(`^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$`, `i`)),
                      (e.EMPTY = `00000000-0000-0000-0000-000000000000`),
                      e
                    );
                  })()));
              },
              3720: (e) => {
                e.exports = n;
                var t = null;
                try {
                  t = new WebAssembly.Instance(
                    new WebAssembly.Module(
                      new Uint8Array([
                        0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7,
                        6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105,
                        118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114,
                        101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0,
                        35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66,
                        32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173,
                        32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135,
                        167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173,
                        32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1,
                        126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129,
                        34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32,
                        134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4,
                        167, 11,
                      ]),
                    ),
                    {},
                  ).exports;
                } catch {}
                function n(e, t, n) {
                  ((this.low = 0 | e), (this.high = 0 | t), (this.unsigned = !!n));
                }
                function r(e) {
                  return !0 === (e && e.__isLong__);
                }
                (n.prototype.__isLong__,
                  Object.defineProperty(n.prototype, `__isLong__`, { value: !0 }),
                  (n.isLong = r));
                var i = {},
                  a = {};
                function o(e, t) {
                  var n, r, o;
                  return t
                    ? (o = 0 <= (e >>>= 0) && e < 256) && (r = a[e])
                      ? r
                      : ((n = c(e, (0 | e) < 0 ? -1 : 0, !0)), o && (a[e] = n), n)
                    : (o = -128 <= (e |= 0) && e < 128) && (r = i[e])
                      ? r
                      : ((n = c(e, e < 0 ? -1 : 0, !1)), o && (i[e] = n), n);
                }
                function s(e, t) {
                  if (isNaN(e)) return t ? _ : g;
                  if (t) {
                    if (e < 0) return _;
                    if (e >= p) return S;
                  } else {
                    if (e <= -m) return C;
                    if (e + 1 >= m) return x;
                  }
                  return e < 0 ? s(-e, t).neg() : c((e % f) | 0, (e / f) | 0, t);
                }
                function c(e, t, r) {
                  return new n(e, t, r);
                }
                ((n.fromInt = o), (n.fromNumber = s), (n.fromBits = c));
                var l = Math.pow;
                function u(e, t, n) {
                  if (e.length === 0) throw Error(`empty string`);
                  if (e === `NaN` || e === `Infinity` || e === `+Infinity` || e === `-Infinity`) return g;
                  if ((typeof t == `number` ? ((n = t), (t = !1)) : (t = !!t), (n ||= 10) < 2 || 36 < n))
                    throw RangeError(`radix`);
                  var r;
                  if ((r = e.indexOf(`-`)) > 0) throw Error(`interior hyphen`);
                  if (r === 0) return u(e.substring(1), t, n).neg();
                  for (var i = s(l(n, 8)), a = g, o = 0; o < e.length; o += 8) {
                    var c = Math.min(8, e.length - o),
                      d = parseInt(e.substring(o, o + c), n);
                    if (c < 8) {
                      var f = s(l(n, c));
                      a = a.mul(f).add(s(d));
                    } else a = (a = a.mul(i)).add(s(d));
                  }
                  return ((a.unsigned = t), a);
                }
                function d(e, t) {
                  return typeof e == `number`
                    ? s(e, t)
                    : typeof e == `string`
                      ? u(e, t)
                      : c(e.low, e.high, typeof t == `boolean` ? t : e.unsigned);
                }
                ((n.fromString = u), (n.fromValue = d));
                var f = 4294967296,
                  p = f * f,
                  m = p / 2,
                  h = o(1 << 24),
                  g = o(0);
                n.ZERO = g;
                var _ = o(0, !0);
                n.UZERO = _;
                var v = o(1);
                n.ONE = v;
                var y = o(1, !0);
                n.UONE = y;
                var b = o(-1);
                n.NEG_ONE = b;
                var x = c(-1, 2147483647, !1);
                n.MAX_VALUE = x;
                var S = c(-1, -1, !0);
                n.MAX_UNSIGNED_VALUE = S;
                var C = c(0, -2147483648, !1);
                n.MIN_VALUE = C;
                var w = n.prototype;
                ((w.toInt = function () {
                  return this.unsigned ? this.low >>> 0 : this.low;
                }),
                  (w.toNumber = function () {
                    return this.unsigned ? (this.high >>> 0) * f + (this.low >>> 0) : this.high * f + (this.low >>> 0);
                  }),
                  (w.toString = function (e) {
                    if ((e ||= 10) < 2 || 36 < e) throw RangeError(`radix`);
                    if (this.isZero()) return `0`;
                    if (this.isNegative()) {
                      if (this.eq(C)) {
                        var t = s(e),
                          n = this.div(t),
                          r = n.mul(t).sub(this);
                        return n.toString(e) + r.toInt().toString(e);
                      }
                      return `-` + this.neg().toString(e);
                    }
                    for (var i = s(l(e, 6), this.unsigned), a = this, o = ``; ; ) {
                      var c = a.div(i),
                        u = (a.sub(c.mul(i)).toInt() >>> 0).toString(e);
                      if ((a = c).isZero()) return u + o;
                      for (; u.length < 6; ) u = `0` + u;
                      o = `` + u + o;
                    }
                  }),
                  (w.getHighBits = function () {
                    return this.high;
                  }),
                  (w.getHighBitsUnsigned = function () {
                    return this.high >>> 0;
                  }),
                  (w.getLowBits = function () {
                    return this.low;
                  }),
                  (w.getLowBitsUnsigned = function () {
                    return this.low >>> 0;
                  }),
                  (w.getNumBitsAbs = function () {
                    if (this.isNegative()) return this.eq(C) ? 64 : this.neg().getNumBitsAbs();
                    for (var e = this.high == 0 ? this.low : this.high, t = 31; t > 0 && !(e & (1 << t)); t--);
                    return this.high == 0 ? t + 1 : t + 33;
                  }),
                  (w.isZero = function () {
                    return this.high === 0 && this.low === 0;
                  }),
                  (w.eqz = w.isZero),
                  (w.isNegative = function () {
                    return !this.unsigned && this.high < 0;
                  }),
                  (w.isPositive = function () {
                    return this.unsigned || this.high >= 0;
                  }),
                  (w.isOdd = function () {
                    return (1 & this.low) == 1;
                  }),
                  (w.isEven = function () {
                    return (1 & this.low) == 0;
                  }),
                  (w.equals = function (e) {
                    return (
                      r(e) || (e = d(e)),
                      (this.unsigned === e.unsigned || this.high >>> 31 != 1 || e.high >>> 31 != 1) &&
                        this.high === e.high &&
                        this.low === e.low
                    );
                  }),
                  (w.eq = w.equals),
                  (w.notEquals = function (e) {
                    return !this.eq(e);
                  }),
                  (w.neq = w.notEquals),
                  (w.ne = w.notEquals),
                  (w.lessThan = function (e) {
                    return this.comp(e) < 0;
                  }),
                  (w.lt = w.lessThan),
                  (w.lessThanOrEqual = function (e) {
                    return this.comp(e) <= 0;
                  }),
                  (w.lte = w.lessThanOrEqual),
                  (w.le = w.lessThanOrEqual),
                  (w.greaterThan = function (e) {
                    return this.comp(e) > 0;
                  }),
                  (w.gt = w.greaterThan),
                  (w.greaterThanOrEqual = function (e) {
                    return this.comp(e) >= 0;
                  }),
                  (w.gte = w.greaterThanOrEqual),
                  (w.ge = w.greaterThanOrEqual),
                  (w.compare = function (e) {
                    if ((r(e) || (e = d(e)), this.eq(e))) return 0;
                    var t = this.isNegative(),
                      n = e.isNegative();
                    return t && !n
                      ? -1
                      : !t && n
                        ? 1
                        : this.unsigned
                          ? e.high >>> 0 > this.high >>> 0 || (e.high === this.high && e.low >>> 0 > this.low >>> 0)
                            ? -1
                            : 1
                          : this.sub(e).isNegative()
                            ? -1
                            : 1;
                  }),
                  (w.comp = w.compare),
                  (w.negate = function () {
                    return !this.unsigned && this.eq(C) ? C : this.not().add(v);
                  }),
                  (w.neg = w.negate),
                  (w.add = function (e) {
                    r(e) || (e = d(e));
                    var t = this.high >>> 16,
                      n = 65535 & this.high,
                      i = this.low >>> 16,
                      a = 65535 & this.low,
                      o = e.high >>> 16,
                      s = 65535 & e.high,
                      l = e.low >>> 16,
                      u = 0,
                      f = 0,
                      p = 0,
                      m = 0;
                    return (
                      (p += (m += a + (65535 & e.low)) >>> 16),
                      (f += (p += i + l) >>> 16),
                      (u += (f += n + s) >>> 16),
                      (u += t + o),
                      c(((p &= 65535) << 16) | (m &= 65535), ((u &= 65535) << 16) | (f &= 65535), this.unsigned)
                    );
                  }),
                  (w.subtract = function (e) {
                    return (r(e) || (e = d(e)), this.add(e.neg()));
                  }),
                  (w.sub = w.subtract),
                  (w.multiply = function (e) {
                    if (this.isZero()) return g;
                    if ((r(e) || (e = d(e)), t))
                      return c(t.mul(this.low, this.high, e.low, e.high), t.get_high(), this.unsigned);
                    if (e.isZero()) return g;
                    if (this.eq(C)) return e.isOdd() ? C : g;
                    if (e.eq(C)) return this.isOdd() ? C : g;
                    if (this.isNegative()) return e.isNegative() ? this.neg().mul(e.neg()) : this.neg().mul(e).neg();
                    if (e.isNegative()) return this.mul(e.neg()).neg();
                    if (this.lt(h) && e.lt(h)) return s(this.toNumber() * e.toNumber(), this.unsigned);
                    var n = this.high >>> 16,
                      i = 65535 & this.high,
                      a = this.low >>> 16,
                      o = 65535 & this.low,
                      l = e.high >>> 16,
                      u = 65535 & e.high,
                      f = e.low >>> 16,
                      p = 65535 & e.low,
                      m = 0,
                      _ = 0,
                      v = 0,
                      y = 0;
                    return (
                      (v += (y += o * p) >>> 16),
                      (_ += (v += a * p) >>> 16),
                      (v &= 65535),
                      (_ += (v += o * f) >>> 16),
                      (m += (_ += i * p) >>> 16),
                      (_ &= 65535),
                      (m += (_ += a * f) >>> 16),
                      (_ &= 65535),
                      (m += (_ += o * u) >>> 16),
                      (m += n * p + i * f + a * u + o * l),
                      c(((v &= 65535) << 16) | (y &= 65535), ((m &= 65535) << 16) | (_ &= 65535), this.unsigned)
                    );
                  }),
                  (w.mul = w.multiply),
                  (w.divide = function (e) {
                    if ((r(e) || (e = d(e)), e.isZero())) throw Error(`division by zero`);
                    var n, i, a;
                    if (t)
                      return this.unsigned || this.high !== -2147483648 || e.low !== -1 || e.high !== -1
                        ? c(
                            (this.unsigned ? t.div_u : t.div_s)(this.low, this.high, e.low, e.high),
                            t.get_high(),
                            this.unsigned,
                          )
                        : this;
                    if (this.isZero()) return this.unsigned ? _ : g;
                    if (this.unsigned) {
                      if ((e.unsigned || (e = e.toUnsigned()), e.gt(this))) return _;
                      if (e.gt(this.shru(1))) return y;
                      a = _;
                    } else {
                      if (this.eq(C))
                        return e.eq(v) || e.eq(b)
                          ? C
                          : e.eq(C)
                            ? v
                            : (n = this.shr(1).div(e).shl(1)).eq(g)
                              ? e.isNegative()
                                ? v
                                : b
                              : ((i = this.sub(e.mul(n))), (a = n.add(i.div(e))));
                      if (e.eq(C)) return this.unsigned ? _ : g;
                      if (this.isNegative()) return e.isNegative() ? this.neg().div(e.neg()) : this.neg().div(e).neg();
                      if (e.isNegative()) return this.div(e.neg()).neg();
                      a = g;
                    }
                    for (i = this; i.gte(e); ) {
                      n = Math.max(1, Math.floor(i.toNumber() / e.toNumber()));
                      for (
                        var o = Math.ceil(Math.log(n) / Math.LN2),
                          u = o <= 48 ? 1 : l(2, o - 48),
                          f = s(n),
                          p = f.mul(e);
                        p.isNegative() || p.gt(i);
                      )
                        p = (f = s((n -= u), this.unsigned)).mul(e);
                      (f.isZero() && (f = v), (a = a.add(f)), (i = i.sub(p)));
                    }
                    return a;
                  }),
                  (w.div = w.divide),
                  (w.modulo = function (e) {
                    return (
                      r(e) || (e = d(e)),
                      t
                        ? c(
                            (this.unsigned ? t.rem_u : t.rem_s)(this.low, this.high, e.low, e.high),
                            t.get_high(),
                            this.unsigned,
                          )
                        : this.sub(this.div(e).mul(e))
                    );
                  }),
                  (w.mod = w.modulo),
                  (w.rem = w.modulo),
                  (w.not = function () {
                    return c(~this.low, ~this.high, this.unsigned);
                  }),
                  (w.and = function (e) {
                    return (r(e) || (e = d(e)), c(this.low & e.low, this.high & e.high, this.unsigned));
                  }),
                  (w.or = function (e) {
                    return (r(e) || (e = d(e)), c(this.low | e.low, this.high | e.high, this.unsigned));
                  }),
                  (w.xor = function (e) {
                    return (r(e) || (e = d(e)), c(this.low ^ e.low, this.high ^ e.high, this.unsigned));
                  }),
                  (w.shiftLeft = function (e) {
                    return (
                      r(e) && (e = e.toInt()),
                      (e &= 63) == 0
                        ? this
                        : e < 32
                          ? c(this.low << e, (this.high << e) | (this.low >>> (32 - e)), this.unsigned)
                          : c(0, this.low << (e - 32), this.unsigned)
                    );
                  }),
                  (w.shl = w.shiftLeft),
                  (w.shiftRight = function (e) {
                    return (
                      r(e) && (e = e.toInt()),
                      (e &= 63) == 0
                        ? this
                        : e < 32
                          ? c((this.low >>> e) | (this.high << (32 - e)), this.high >> e, this.unsigned)
                          : c(this.high >> (e - 32), this.high >= 0 ? 0 : -1, this.unsigned)
                    );
                  }),
                  (w.shr = w.shiftRight),
                  (w.shiftRightUnsigned = function (e) {
                    if ((r(e) && (e = e.toInt()), (e &= 63) == 0)) return this;
                    var t = this.high;
                    return e < 32
                      ? c((this.low >>> e) | (t << (32 - e)), t >>> e, this.unsigned)
                      : c(e === 32 ? t : t >>> (e - 32), 0, this.unsigned);
                  }),
                  (w.shru = w.shiftRightUnsigned),
                  (w.shr_u = w.shiftRightUnsigned),
                  (w.toSigned = function () {
                    return this.unsigned ? c(this.low, this.high, !1) : this;
                  }),
                  (w.toUnsigned = function () {
                    return this.unsigned ? this : c(this.low, this.high, !0);
                  }),
                  (w.toBytes = function (e) {
                    return e ? this.toBytesLE() : this.toBytesBE();
                  }),
                  (w.toBytesLE = function () {
                    var e = this.high,
                      t = this.low;
                    return [
                      255 & t,
                      (t >>> 8) & 255,
                      (t >>> 16) & 255,
                      t >>> 24,
                      255 & e,
                      (e >>> 8) & 255,
                      (e >>> 16) & 255,
                      e >>> 24,
                    ];
                  }),
                  (w.toBytesBE = function () {
                    var e = this.high,
                      t = this.low;
                    return [
                      e >>> 24,
                      (e >>> 16) & 255,
                      (e >>> 8) & 255,
                      255 & e,
                      t >>> 24,
                      (t >>> 16) & 255,
                      (t >>> 8) & 255,
                      255 & t,
                    ];
                  }),
                  (n.fromBytes = function (e, t, r) {
                    return r ? n.fromBytesLE(e, t) : n.fromBytesBE(e, t);
                  }),
                  (n.fromBytesLE = function (e, t) {
                    return new n(
                      e[0] | (e[1] << 8) | (e[2] << 16) | (e[3] << 24),
                      e[4] | (e[5] << 8) | (e[6] << 16) | (e[7] << 24),
                      t,
                    );
                  }),
                  (n.fromBytesBE = function (e, t) {
                    return new n(
                      (e[4] << 24) | (e[5] << 16) | (e[6] << 8) | e[7],
                      (e[0] << 24) | (e[1] << 16) | (e[2] << 8) | e[3],
                      t,
                    );
                  }));
              },
              1446: (e, t, n) => {
                'use strict';
                var r,
                  i,
                  a,
                  o = n(2100),
                  s = o.Reader,
                  c = o.Writer,
                  l = o.util,
                  u = o.roots.default || (o.roots.default = {});
                ((u.onnx =
                  (((a = {}).Version =
                    ((r = {}),
                    ((i = Object.create(r))[(r[0] = `_START_VERSION`)] = 0),
                    (i[(r[1] = `IR_VERSION_2017_10_10`)] = 1),
                    (i[(r[2] = `IR_VERSION_2017_10_30`)] = 2),
                    (i[(r[3] = `IR_VERSION_2017_11_3`)] = 3),
                    (i[(r[4] = `IR_VERSION_2019_1_22`)] = 4),
                    (i[(r[5] = `IR_VERSION`)] = 5),
                    i)),
                  (a.AttributeProto = (function () {
                    function e(e) {
                      if (
                        ((this.floats = []),
                        (this.ints = []),
                        (this.strings = []),
                        (this.tensors = []),
                        (this.graphs = []),
                        e)
                      )
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.name = ``),
                      (e.prototype.refAttrName = ``),
                      (e.prototype.docString = ``),
                      (e.prototype.type = 0),
                      (e.prototype.f = 0),
                      (e.prototype.i = l.Long ? l.Long.fromBits(0, 0, !1) : 0),
                      (e.prototype.s = l.newBuffer([])),
                      (e.prototype.t = null),
                      (e.prototype.g = null),
                      (e.prototype.floats = l.emptyArray),
                      (e.prototype.ints = l.emptyArray),
                      (e.prototype.strings = l.emptyArray),
                      (e.prototype.tensors = l.emptyArray),
                      (e.prototype.graphs = l.emptyArray),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        if (
                          ((t ||= c.create()),
                          e.name != null && e.hasOwnProperty(`name`) && t.uint32(10).string(e.name),
                          e.f != null && e.hasOwnProperty(`f`) && t.uint32(21).float(e.f),
                          e.i != null && e.hasOwnProperty(`i`) && t.uint32(24).int64(e.i),
                          e.s != null && e.hasOwnProperty(`s`) && t.uint32(34).bytes(e.s),
                          e.t != null &&
                            e.hasOwnProperty(`t`) &&
                            u.onnx.TensorProto.encode(e.t, t.uint32(42).fork()).ldelim(),
                          e.g != null &&
                            e.hasOwnProperty(`g`) &&
                            u.onnx.GraphProto.encode(e.g, t.uint32(50).fork()).ldelim(),
                          e.floats != null && e.floats.length)
                        ) {
                          t.uint32(58).fork();
                          for (var n = 0; n < e.floats.length; ++n) t.float(e.floats[n]);
                          t.ldelim();
                        }
                        if (e.ints != null && e.ints.length) {
                          for (t.uint32(66).fork(), n = 0; n < e.ints.length; ++n) t.int64(e.ints[n]);
                          t.ldelim();
                        }
                        if (e.strings != null && e.strings.length)
                          for (n = 0; n < e.strings.length; ++n) t.uint32(74).bytes(e.strings[n]);
                        if (e.tensors != null && e.tensors.length)
                          for (n = 0; n < e.tensors.length; ++n)
                            u.onnx.TensorProto.encode(e.tensors[n], t.uint32(82).fork()).ldelim();
                        if (e.graphs != null && e.graphs.length)
                          for (n = 0; n < e.graphs.length; ++n)
                            u.onnx.GraphProto.encode(e.graphs[n], t.uint32(90).fork()).ldelim();
                        return (
                          e.docString != null && e.hasOwnProperty(`docString`) && t.uint32(106).string(e.docString),
                          e.type != null && e.hasOwnProperty(`type`) && t.uint32(160).int32(e.type),
                          e.refAttrName != null &&
                            e.hasOwnProperty(`refAttrName`) &&
                            t.uint32(170).string(e.refAttrName),
                          t
                        );
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.AttributeProto(); e.pos < n; ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              r.name = e.string();
                              break;
                            case 21:
                              r.refAttrName = e.string();
                              break;
                            case 13:
                              r.docString = e.string();
                              break;
                            case 20:
                              r.type = e.int32();
                              break;
                            case 2:
                              r.f = e.float();
                              break;
                            case 3:
                              r.i = e.int64();
                              break;
                            case 4:
                              r.s = e.bytes();
                              break;
                            case 5:
                              r.t = u.onnx.TensorProto.decode(e, e.uint32());
                              break;
                            case 6:
                              r.g = u.onnx.GraphProto.decode(e, e.uint32());
                              break;
                            case 7:
                              if (((r.floats && r.floats.length) || (r.floats = []), (7 & i) == 2))
                                for (var a = e.uint32() + e.pos; e.pos < a; ) r.floats.push(e.float());
                              else r.floats.push(e.float());
                              break;
                            case 8:
                              if (((r.ints && r.ints.length) || (r.ints = []), (7 & i) == 2))
                                for (a = e.uint32() + e.pos; e.pos < a; ) r.ints.push(e.int64());
                              else r.ints.push(e.int64());
                              break;
                            case 9:
                              ((r.strings && r.strings.length) || (r.strings = []), r.strings.push(e.bytes()));
                              break;
                            case 10:
                              ((r.tensors && r.tensors.length) || (r.tensors = []),
                                r.tensors.push(u.onnx.TensorProto.decode(e, e.uint32())));
                              break;
                            case 11:
                              ((r.graphs && r.graphs.length) || (r.graphs = []),
                                r.graphs.push(u.onnx.GraphProto.decode(e, e.uint32())));
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (e.name != null && e.hasOwnProperty(`name`) && !l.isString(e.name))
                          return `name: string expected`;
                        if (e.refAttrName != null && e.hasOwnProperty(`refAttrName`) && !l.isString(e.refAttrName))
                          return `refAttrName: string expected`;
                        if (e.docString != null && e.hasOwnProperty(`docString`) && !l.isString(e.docString))
                          return `docString: string expected`;
                        if (e.type != null && e.hasOwnProperty(`type`))
                          switch (e.type) {
                            default:
                              return `type: enum value expected`;
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                          }
                        if (e.f != null && e.hasOwnProperty(`f`) && typeof e.f != `number`) return `f: number expected`;
                        if (
                          e.i != null &&
                          e.hasOwnProperty(`i`) &&
                          !(l.isInteger(e.i) || (e.i && l.isInteger(e.i.low) && l.isInteger(e.i.high)))
                        )
                          return `i: integer|Long expected`;
                        if (
                          e.s != null &&
                          e.hasOwnProperty(`s`) &&
                          !((e.s && typeof e.s.length == `number`) || l.isString(e.s))
                        )
                          return `s: buffer expected`;
                        if (e.t != null && e.hasOwnProperty(`t`) && (n = u.onnx.TensorProto.verify(e.t)))
                          return `t.` + n;
                        if (e.g != null && e.hasOwnProperty(`g`) && (n = u.onnx.GraphProto.verify(e.g)))
                          return `g.` + n;
                        if (e.floats != null && e.hasOwnProperty(`floats`)) {
                          if (!Array.isArray(e.floats)) return `floats: array expected`;
                          for (var t = 0; t < e.floats.length; ++t)
                            if (typeof e.floats[t] != `number`) return `floats: number[] expected`;
                        }
                        if (e.ints != null && e.hasOwnProperty(`ints`)) {
                          if (!Array.isArray(e.ints)) return `ints: array expected`;
                          for (t = 0; t < e.ints.length; ++t)
                            if (
                              !(
                                l.isInteger(e.ints[t]) ||
                                (e.ints[t] && l.isInteger(e.ints[t].low) && l.isInteger(e.ints[t].high))
                              )
                            )
                              return `ints: integer|Long[] expected`;
                        }
                        if (e.strings != null && e.hasOwnProperty(`strings`)) {
                          if (!Array.isArray(e.strings)) return `strings: array expected`;
                          for (t = 0; t < e.strings.length; ++t)
                            if (!((e.strings[t] && typeof e.strings[t].length == `number`) || l.isString(e.strings[t])))
                              return `strings: buffer[] expected`;
                        }
                        if (e.tensors != null && e.hasOwnProperty(`tensors`)) {
                          if (!Array.isArray(e.tensors)) return `tensors: array expected`;
                          for (t = 0; t < e.tensors.length; ++t)
                            if ((n = u.onnx.TensorProto.verify(e.tensors[t]))) return `tensors.` + n;
                        }
                        if (e.graphs != null && e.hasOwnProperty(`graphs`)) {
                          if (!Array.isArray(e.graphs)) return `graphs: array expected`;
                          for (t = 0; t < e.graphs.length; ++t) {
                            var n;
                            if ((n = u.onnx.GraphProto.verify(e.graphs[t]))) return `graphs.` + n;
                          }
                        }
                        return null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.AttributeProto) return e;
                        var t = new u.onnx.AttributeProto();
                        switch (
                          (e.name != null && (t.name = String(e.name)),
                          e.refAttrName != null && (t.refAttrName = String(e.refAttrName)),
                          e.docString != null && (t.docString = String(e.docString)),
                          e.type)
                        ) {
                          case `UNDEFINED`:
                          case 0:
                            t.type = 0;
                            break;
                          case `FLOAT`:
                          case 1:
                            t.type = 1;
                            break;
                          case `INT`:
                          case 2:
                            t.type = 2;
                            break;
                          case `STRING`:
                          case 3:
                            t.type = 3;
                            break;
                          case `TENSOR`:
                          case 4:
                            t.type = 4;
                            break;
                          case `GRAPH`:
                          case 5:
                            t.type = 5;
                            break;
                          case `FLOATS`:
                          case 6:
                            t.type = 6;
                            break;
                          case `INTS`:
                          case 7:
                            t.type = 7;
                            break;
                          case `STRINGS`:
                          case 8:
                            t.type = 8;
                            break;
                          case `TENSORS`:
                          case 9:
                            t.type = 9;
                            break;
                          case `GRAPHS`:
                          case 10:
                            t.type = 10;
                        }
                        if (
                          (e.f != null && (t.f = Number(e.f)),
                          e.i != null &&
                            (l.Long
                              ? ((t.i = l.Long.fromValue(e.i)).unsigned = !1)
                              : typeof e.i == `string`
                                ? (t.i = parseInt(e.i, 10))
                                : typeof e.i == `number`
                                  ? (t.i = e.i)
                                  : typeof e.i == `object` &&
                                    (t.i = new l.LongBits(e.i.low >>> 0, e.i.high >>> 0).toNumber())),
                          e.s != null &&
                            (typeof e.s == `string`
                              ? l.base64.decode(e.s, (t.s = l.newBuffer(l.base64.length(e.s))), 0)
                              : e.s.length && (t.s = e.s)),
                          e.t != null)
                        ) {
                          if (typeof e.t != `object`) throw TypeError(`.onnx.AttributeProto.t: object expected`);
                          t.t = u.onnx.TensorProto.fromObject(e.t);
                        }
                        if (e.g != null) {
                          if (typeof e.g != `object`) throw TypeError(`.onnx.AttributeProto.g: object expected`);
                          t.g = u.onnx.GraphProto.fromObject(e.g);
                        }
                        if (e.floats) {
                          if (!Array.isArray(e.floats)) throw TypeError(`.onnx.AttributeProto.floats: array expected`);
                          t.floats = [];
                          for (var n = 0; n < e.floats.length; ++n) t.floats[n] = Number(e.floats[n]);
                        }
                        if (e.ints) {
                          if (!Array.isArray(e.ints)) throw TypeError(`.onnx.AttributeProto.ints: array expected`);
                          for (t.ints = [], n = 0; n < e.ints.length; ++n)
                            l.Long
                              ? ((t.ints[n] = l.Long.fromValue(e.ints[n])).unsigned = !1)
                              : typeof e.ints[n] == `string`
                                ? (t.ints[n] = parseInt(e.ints[n], 10))
                                : typeof e.ints[n] == `number`
                                  ? (t.ints[n] = e.ints[n])
                                  : typeof e.ints[n] == `object` &&
                                    (t.ints[n] = new l.LongBits(e.ints[n].low >>> 0, e.ints[n].high >>> 0).toNumber());
                        }
                        if (e.strings) {
                          if (!Array.isArray(e.strings))
                            throw TypeError(`.onnx.AttributeProto.strings: array expected`);
                          for (t.strings = [], n = 0; n < e.strings.length; ++n)
                            typeof e.strings[n] == `string`
                              ? l.base64.decode(
                                  e.strings[n],
                                  (t.strings[n] = l.newBuffer(l.base64.length(e.strings[n]))),
                                  0,
                                )
                              : e.strings[n].length && (t.strings[n] = e.strings[n]);
                        }
                        if (e.tensors) {
                          if (!Array.isArray(e.tensors))
                            throw TypeError(`.onnx.AttributeProto.tensors: array expected`);
                          for (t.tensors = [], n = 0; n < e.tensors.length; ++n) {
                            if (typeof e.tensors[n] != `object`)
                              throw TypeError(`.onnx.AttributeProto.tensors: object expected`);
                            t.tensors[n] = u.onnx.TensorProto.fromObject(e.tensors[n]);
                          }
                        }
                        if (e.graphs) {
                          if (!Array.isArray(e.graphs)) throw TypeError(`.onnx.AttributeProto.graphs: array expected`);
                          for (t.graphs = [], n = 0; n < e.graphs.length; ++n) {
                            if (typeof e.graphs[n] != `object`)
                              throw TypeError(`.onnx.AttributeProto.graphs: object expected`);
                            t.graphs[n] = u.onnx.GraphProto.fromObject(e.graphs[n]);
                          }
                        }
                        return t;
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        if (
                          ((t.arrays || t.defaults) &&
                            ((n.floats = []), (n.ints = []), (n.strings = []), (n.tensors = []), (n.graphs = [])),
                          t.defaults)
                        ) {
                          if (((n.name = ``), (n.f = 0), l.Long)) {
                            var r = new l.Long(0, 0, !1);
                            n.i = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
                          } else n.i = t.longs === String ? `0` : 0;
                          (t.bytes === String
                            ? (n.s = ``)
                            : ((n.s = []), t.bytes !== Array && (n.s = l.newBuffer(n.s))),
                            (n.t = null),
                            (n.g = null),
                            (n.docString = ``),
                            (n.type = t.enums === String ? `UNDEFINED` : 0),
                            (n.refAttrName = ``));
                        }
                        if (
                          (e.name != null && e.hasOwnProperty(`name`) && (n.name = e.name),
                          e.f != null && e.hasOwnProperty(`f`) && (n.f = t.json && !isFinite(e.f) ? String(e.f) : e.f),
                          e.i != null &&
                            e.hasOwnProperty(`i`) &&
                            (typeof e.i == `number`
                              ? (n.i = t.longs === String ? String(e.i) : e.i)
                              : (n.i =
                                  t.longs === String
                                    ? l.Long.prototype.toString.call(e.i)
                                    : t.longs === Number
                                      ? new l.LongBits(e.i.low >>> 0, e.i.high >>> 0).toNumber()
                                      : e.i)),
                          e.s != null &&
                            e.hasOwnProperty(`s`) &&
                            (n.s =
                              t.bytes === String
                                ? l.base64.encode(e.s, 0, e.s.length)
                                : t.bytes === Array
                                  ? Array.prototype.slice.call(e.s)
                                  : e.s),
                          e.t != null && e.hasOwnProperty(`t`) && (n.t = u.onnx.TensorProto.toObject(e.t, t)),
                          e.g != null && e.hasOwnProperty(`g`) && (n.g = u.onnx.GraphProto.toObject(e.g, t)),
                          e.floats && e.floats.length)
                        ) {
                          n.floats = [];
                          for (var i = 0; i < e.floats.length; ++i)
                            n.floats[i] = t.json && !isFinite(e.floats[i]) ? String(e.floats[i]) : e.floats[i];
                        }
                        if (e.ints && e.ints.length)
                          for (n.ints = [], i = 0; i < e.ints.length; ++i)
                            typeof e.ints[i] == `number`
                              ? (n.ints[i] = t.longs === String ? String(e.ints[i]) : e.ints[i])
                              : (n.ints[i] =
                                  t.longs === String
                                    ? l.Long.prototype.toString.call(e.ints[i])
                                    : t.longs === Number
                                      ? new l.LongBits(e.ints[i].low >>> 0, e.ints[i].high >>> 0).toNumber()
                                      : e.ints[i]);
                        if (e.strings && e.strings.length)
                          for (n.strings = [], i = 0; i < e.strings.length; ++i)
                            n.strings[i] =
                              t.bytes === String
                                ? l.base64.encode(e.strings[i], 0, e.strings[i].length)
                                : t.bytes === Array
                                  ? Array.prototype.slice.call(e.strings[i])
                                  : e.strings[i];
                        if (e.tensors && e.tensors.length)
                          for (n.tensors = [], i = 0; i < e.tensors.length; ++i)
                            n.tensors[i] = u.onnx.TensorProto.toObject(e.tensors[i], t);
                        if (e.graphs && e.graphs.length)
                          for (n.graphs = [], i = 0; i < e.graphs.length; ++i)
                            n.graphs[i] = u.onnx.GraphProto.toObject(e.graphs[i], t);
                        return (
                          e.docString != null && e.hasOwnProperty(`docString`) && (n.docString = e.docString),
                          e.type != null &&
                            e.hasOwnProperty(`type`) &&
                            (n.type = t.enums === String ? u.onnx.AttributeProto.AttributeType[e.type] : e.type),
                          e.refAttrName != null && e.hasOwnProperty(`refAttrName`) && (n.refAttrName = e.refAttrName),
                          n
                        );
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      (e.AttributeType = (function () {
                        var e = {},
                          t = Object.create(e);
                        return (
                          (t[(e[0] = `UNDEFINED`)] = 0),
                          (t[(e[1] = `FLOAT`)] = 1),
                          (t[(e[2] = `INT`)] = 2),
                          (t[(e[3] = `STRING`)] = 3),
                          (t[(e[4] = `TENSOR`)] = 4),
                          (t[(e[5] = `GRAPH`)] = 5),
                          (t[(e[6] = `FLOATS`)] = 6),
                          (t[(e[7] = `INTS`)] = 7),
                          (t[(e[8] = `STRINGS`)] = 8),
                          (t[(e[9] = `TENSORS`)] = 9),
                          (t[(e[10] = `GRAPHS`)] = 10),
                          t
                        );
                      })()),
                      e
                    );
                  })()),
                  (a.ValueInfoProto = (function () {
                    function e(e) {
                      if (e)
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.name = ``),
                      (e.prototype.type = null),
                      (e.prototype.docString = ``),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        return (
                          (t ||= c.create()),
                          e.name != null && e.hasOwnProperty(`name`) && t.uint32(10).string(e.name),
                          e.type != null &&
                            e.hasOwnProperty(`type`) &&
                            u.onnx.TypeProto.encode(e.type, t.uint32(18).fork()).ldelim(),
                          e.docString != null && e.hasOwnProperty(`docString`) && t.uint32(26).string(e.docString),
                          t
                        );
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.ValueInfoProto(); e.pos < n; ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              r.name = e.string();
                              break;
                            case 2:
                              r.type = u.onnx.TypeProto.decode(e, e.uint32());
                              break;
                            case 3:
                              r.docString = e.string();
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (e.name != null && e.hasOwnProperty(`name`) && !l.isString(e.name))
                          return `name: string expected`;
                        if (e.type != null && e.hasOwnProperty(`type`)) {
                          var t = u.onnx.TypeProto.verify(e.type);
                          if (t) return `type.` + t;
                        }
                        return e.docString != null && e.hasOwnProperty(`docString`) && !l.isString(e.docString)
                          ? `docString: string expected`
                          : null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.ValueInfoProto) return e;
                        var t = new u.onnx.ValueInfoProto();
                        if ((e.name != null && (t.name = String(e.name)), e.type != null)) {
                          if (typeof e.type != `object`) throw TypeError(`.onnx.ValueInfoProto.type: object expected`);
                          t.type = u.onnx.TypeProto.fromObject(e.type);
                        }
                        return (e.docString != null && (t.docString = String(e.docString)), t);
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        return (
                          t.defaults && ((n.name = ``), (n.type = null), (n.docString = ``)),
                          e.name != null && e.hasOwnProperty(`name`) && (n.name = e.name),
                          e.type != null && e.hasOwnProperty(`type`) && (n.type = u.onnx.TypeProto.toObject(e.type, t)),
                          e.docString != null && e.hasOwnProperty(`docString`) && (n.docString = e.docString),
                          n
                        );
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      e
                    );
                  })()),
                  (a.NodeProto = (function () {
                    function e(e) {
                      if (((this.input = []), (this.output = []), (this.attribute = []), e))
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.input = l.emptyArray),
                      (e.prototype.output = l.emptyArray),
                      (e.prototype.name = ``),
                      (e.prototype.opType = ``),
                      (e.prototype.domain = ``),
                      (e.prototype.attribute = l.emptyArray),
                      (e.prototype.docString = ``),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        if (((t ||= c.create()), e.input != null && e.input.length))
                          for (var n = 0; n < e.input.length; ++n) t.uint32(10).string(e.input[n]);
                        if (e.output != null && e.output.length)
                          for (n = 0; n < e.output.length; ++n) t.uint32(18).string(e.output[n]);
                        if (
                          (e.name != null && e.hasOwnProperty(`name`) && t.uint32(26).string(e.name),
                          e.opType != null && e.hasOwnProperty(`opType`) && t.uint32(34).string(e.opType),
                          e.attribute != null && e.attribute.length)
                        )
                          for (n = 0; n < e.attribute.length; ++n)
                            u.onnx.AttributeProto.encode(e.attribute[n], t.uint32(42).fork()).ldelim();
                        return (
                          e.docString != null && e.hasOwnProperty(`docString`) && t.uint32(50).string(e.docString),
                          e.domain != null && e.hasOwnProperty(`domain`) && t.uint32(58).string(e.domain),
                          t
                        );
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.NodeProto(); e.pos < n; ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              ((r.input && r.input.length) || (r.input = []), r.input.push(e.string()));
                              break;
                            case 2:
                              ((r.output && r.output.length) || (r.output = []), r.output.push(e.string()));
                              break;
                            case 3:
                              r.name = e.string();
                              break;
                            case 4:
                              r.opType = e.string();
                              break;
                            case 7:
                              r.domain = e.string();
                              break;
                            case 5:
                              ((r.attribute && r.attribute.length) || (r.attribute = []),
                                r.attribute.push(u.onnx.AttributeProto.decode(e, e.uint32())));
                              break;
                            case 6:
                              r.docString = e.string();
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (e.input != null && e.hasOwnProperty(`input`)) {
                          if (!Array.isArray(e.input)) return `input: array expected`;
                          for (var t = 0; t < e.input.length; ++t)
                            if (!l.isString(e.input[t])) return `input: string[] expected`;
                        }
                        if (e.output != null && e.hasOwnProperty(`output`)) {
                          if (!Array.isArray(e.output)) return `output: array expected`;
                          for (t = 0; t < e.output.length; ++t)
                            if (!l.isString(e.output[t])) return `output: string[] expected`;
                        }
                        if (e.name != null && e.hasOwnProperty(`name`) && !l.isString(e.name))
                          return `name: string expected`;
                        if (e.opType != null && e.hasOwnProperty(`opType`) && !l.isString(e.opType))
                          return `opType: string expected`;
                        if (e.domain != null && e.hasOwnProperty(`domain`) && !l.isString(e.domain))
                          return `domain: string expected`;
                        if (e.attribute != null && e.hasOwnProperty(`attribute`)) {
                          if (!Array.isArray(e.attribute)) return `attribute: array expected`;
                          for (t = 0; t < e.attribute.length; ++t) {
                            var n = u.onnx.AttributeProto.verify(e.attribute[t]);
                            if (n) return `attribute.` + n;
                          }
                        }
                        return e.docString != null && e.hasOwnProperty(`docString`) && !l.isString(e.docString)
                          ? `docString: string expected`
                          : null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.NodeProto) return e;
                        var t = new u.onnx.NodeProto();
                        if (e.input) {
                          if (!Array.isArray(e.input)) throw TypeError(`.onnx.NodeProto.input: array expected`);
                          t.input = [];
                          for (var n = 0; n < e.input.length; ++n) t.input[n] = String(e.input[n]);
                        }
                        if (e.output) {
                          if (!Array.isArray(e.output)) throw TypeError(`.onnx.NodeProto.output: array expected`);
                          for (t.output = [], n = 0; n < e.output.length; ++n) t.output[n] = String(e.output[n]);
                        }
                        if (
                          (e.name != null && (t.name = String(e.name)),
                          e.opType != null && (t.opType = String(e.opType)),
                          e.domain != null && (t.domain = String(e.domain)),
                          e.attribute)
                        ) {
                          if (!Array.isArray(e.attribute)) throw TypeError(`.onnx.NodeProto.attribute: array expected`);
                          for (t.attribute = [], n = 0; n < e.attribute.length; ++n) {
                            if (typeof e.attribute[n] != `object`)
                              throw TypeError(`.onnx.NodeProto.attribute: object expected`);
                            t.attribute[n] = u.onnx.AttributeProto.fromObject(e.attribute[n]);
                          }
                        }
                        return (e.docString != null && (t.docString = String(e.docString)), t);
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        if (
                          ((t.arrays || t.defaults) && ((n.input = []), (n.output = []), (n.attribute = [])),
                          t.defaults && ((n.name = ``), (n.opType = ``), (n.docString = ``), (n.domain = ``)),
                          e.input && e.input.length)
                        ) {
                          n.input = [];
                          for (var r = 0; r < e.input.length; ++r) n.input[r] = e.input[r];
                        }
                        if (e.output && e.output.length)
                          for (n.output = [], r = 0; r < e.output.length; ++r) n.output[r] = e.output[r];
                        if (
                          (e.name != null && e.hasOwnProperty(`name`) && (n.name = e.name),
                          e.opType != null && e.hasOwnProperty(`opType`) && (n.opType = e.opType),
                          e.attribute && e.attribute.length)
                        )
                          for (n.attribute = [], r = 0; r < e.attribute.length; ++r)
                            n.attribute[r] = u.onnx.AttributeProto.toObject(e.attribute[r], t);
                        return (
                          e.docString != null && e.hasOwnProperty(`docString`) && (n.docString = e.docString),
                          e.domain != null && e.hasOwnProperty(`domain`) && (n.domain = e.domain),
                          n
                        );
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      e
                    );
                  })()),
                  (a.ModelProto = (function () {
                    function e(e) {
                      if (((this.opsetImport = []), (this.metadataProps = []), e))
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.irVersion = l.Long ? l.Long.fromBits(0, 0, !1) : 0),
                      (e.prototype.opsetImport = l.emptyArray),
                      (e.prototype.producerName = ``),
                      (e.prototype.producerVersion = ``),
                      (e.prototype.domain = ``),
                      (e.prototype.modelVersion = l.Long ? l.Long.fromBits(0, 0, !1) : 0),
                      (e.prototype.docString = ``),
                      (e.prototype.graph = null),
                      (e.prototype.metadataProps = l.emptyArray),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        if (
                          ((t ||= c.create()),
                          e.irVersion != null && e.hasOwnProperty(`irVersion`) && t.uint32(8).int64(e.irVersion),
                          e.producerName != null &&
                            e.hasOwnProperty(`producerName`) &&
                            t.uint32(18).string(e.producerName),
                          e.producerVersion != null &&
                            e.hasOwnProperty(`producerVersion`) &&
                            t.uint32(26).string(e.producerVersion),
                          e.domain != null && e.hasOwnProperty(`domain`) && t.uint32(34).string(e.domain),
                          e.modelVersion != null &&
                            e.hasOwnProperty(`modelVersion`) &&
                            t.uint32(40).int64(e.modelVersion),
                          e.docString != null && e.hasOwnProperty(`docString`) && t.uint32(50).string(e.docString),
                          e.graph != null &&
                            e.hasOwnProperty(`graph`) &&
                            u.onnx.GraphProto.encode(e.graph, t.uint32(58).fork()).ldelim(),
                          e.opsetImport != null && e.opsetImport.length)
                        )
                          for (var n = 0; n < e.opsetImport.length; ++n)
                            u.onnx.OperatorSetIdProto.encode(e.opsetImport[n], t.uint32(66).fork()).ldelim();
                        if (e.metadataProps != null && e.metadataProps.length)
                          for (n = 0; n < e.metadataProps.length; ++n)
                            u.onnx.StringStringEntryProto.encode(e.metadataProps[n], t.uint32(114).fork()).ldelim();
                        return t;
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.ModelProto(); e.pos < n; ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              r.irVersion = e.int64();
                              break;
                            case 8:
                              ((r.opsetImport && r.opsetImport.length) || (r.opsetImport = []),
                                r.opsetImport.push(u.onnx.OperatorSetIdProto.decode(e, e.uint32())));
                              break;
                            case 2:
                              r.producerName = e.string();
                              break;
                            case 3:
                              r.producerVersion = e.string();
                              break;
                            case 4:
                              r.domain = e.string();
                              break;
                            case 5:
                              r.modelVersion = e.int64();
                              break;
                            case 6:
                              r.docString = e.string();
                              break;
                            case 7:
                              r.graph = u.onnx.GraphProto.decode(e, e.uint32());
                              break;
                            case 14:
                              ((r.metadataProps && r.metadataProps.length) || (r.metadataProps = []),
                                r.metadataProps.push(u.onnx.StringStringEntryProto.decode(e, e.uint32())));
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (
                          e.irVersion != null &&
                          e.hasOwnProperty(`irVersion`) &&
                          !(
                            l.isInteger(e.irVersion) ||
                            (e.irVersion && l.isInteger(e.irVersion.low) && l.isInteger(e.irVersion.high))
                          )
                        )
                          return `irVersion: integer|Long expected`;
                        if (e.opsetImport != null && e.hasOwnProperty(`opsetImport`)) {
                          if (!Array.isArray(e.opsetImport)) return `opsetImport: array expected`;
                          for (var t = 0; t < e.opsetImport.length; ++t)
                            if ((n = u.onnx.OperatorSetIdProto.verify(e.opsetImport[t]))) return `opsetImport.` + n;
                        }
                        if (e.producerName != null && e.hasOwnProperty(`producerName`) && !l.isString(e.producerName))
                          return `producerName: string expected`;
                        if (
                          e.producerVersion != null &&
                          e.hasOwnProperty(`producerVersion`) &&
                          !l.isString(e.producerVersion)
                        )
                          return `producerVersion: string expected`;
                        if (e.domain != null && e.hasOwnProperty(`domain`) && !l.isString(e.domain))
                          return `domain: string expected`;
                        if (
                          e.modelVersion != null &&
                          e.hasOwnProperty(`modelVersion`) &&
                          !(
                            l.isInteger(e.modelVersion) ||
                            (e.modelVersion && l.isInteger(e.modelVersion.low) && l.isInteger(e.modelVersion.high))
                          )
                        )
                          return `modelVersion: integer|Long expected`;
                        if (e.docString != null && e.hasOwnProperty(`docString`) && !l.isString(e.docString))
                          return `docString: string expected`;
                        if (e.graph != null && e.hasOwnProperty(`graph`) && (n = u.onnx.GraphProto.verify(e.graph)))
                          return `graph.` + n;
                        if (e.metadataProps != null && e.hasOwnProperty(`metadataProps`)) {
                          if (!Array.isArray(e.metadataProps)) return `metadataProps: array expected`;
                          for (t = 0; t < e.metadataProps.length; ++t) {
                            var n;
                            if ((n = u.onnx.StringStringEntryProto.verify(e.metadataProps[t])))
                              return `metadataProps.` + n;
                          }
                        }
                        return null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.ModelProto) return e;
                        var t = new u.onnx.ModelProto();
                        if (
                          (e.irVersion != null &&
                            (l.Long
                              ? ((t.irVersion = l.Long.fromValue(e.irVersion)).unsigned = !1)
                              : typeof e.irVersion == `string`
                                ? (t.irVersion = parseInt(e.irVersion, 10))
                                : typeof e.irVersion == `number`
                                  ? (t.irVersion = e.irVersion)
                                  : typeof e.irVersion == `object` &&
                                    (t.irVersion = new l.LongBits(
                                      e.irVersion.low >>> 0,
                                      e.irVersion.high >>> 0,
                                    ).toNumber())),
                          e.opsetImport)
                        ) {
                          if (!Array.isArray(e.opsetImport))
                            throw TypeError(`.onnx.ModelProto.opsetImport: array expected`);
                          t.opsetImport = [];
                          for (var n = 0; n < e.opsetImport.length; ++n) {
                            if (typeof e.opsetImport[n] != `object`)
                              throw TypeError(`.onnx.ModelProto.opsetImport: object expected`);
                            t.opsetImport[n] = u.onnx.OperatorSetIdProto.fromObject(e.opsetImport[n]);
                          }
                        }
                        if (
                          (e.producerName != null && (t.producerName = String(e.producerName)),
                          e.producerVersion != null && (t.producerVersion = String(e.producerVersion)),
                          e.domain != null && (t.domain = String(e.domain)),
                          e.modelVersion != null &&
                            (l.Long
                              ? ((t.modelVersion = l.Long.fromValue(e.modelVersion)).unsigned = !1)
                              : typeof e.modelVersion == `string`
                                ? (t.modelVersion = parseInt(e.modelVersion, 10))
                                : typeof e.modelVersion == `number`
                                  ? (t.modelVersion = e.modelVersion)
                                  : typeof e.modelVersion == `object` &&
                                    (t.modelVersion = new l.LongBits(
                                      e.modelVersion.low >>> 0,
                                      e.modelVersion.high >>> 0,
                                    ).toNumber())),
                          e.docString != null && (t.docString = String(e.docString)),
                          e.graph != null)
                        ) {
                          if (typeof e.graph != `object`) throw TypeError(`.onnx.ModelProto.graph: object expected`);
                          t.graph = u.onnx.GraphProto.fromObject(e.graph);
                        }
                        if (e.metadataProps) {
                          if (!Array.isArray(e.metadataProps))
                            throw TypeError(`.onnx.ModelProto.metadataProps: array expected`);
                          for (t.metadataProps = [], n = 0; n < e.metadataProps.length; ++n) {
                            if (typeof e.metadataProps[n] != `object`)
                              throw TypeError(`.onnx.ModelProto.metadataProps: object expected`);
                            t.metadataProps[n] = u.onnx.StringStringEntryProto.fromObject(e.metadataProps[n]);
                          }
                        }
                        return t;
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        if (((t.arrays || t.defaults) && ((n.opsetImport = []), (n.metadataProps = [])), t.defaults)) {
                          if (l.Long) {
                            var r = new l.Long(0, 0, !1);
                            n.irVersion = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
                          } else n.irVersion = t.longs === String ? `0` : 0;
                          ((n.producerName = ``),
                            (n.producerVersion = ``),
                            (n.domain = ``),
                            l.Long
                              ? ((r = new l.Long(0, 0, !1)),
                                (n.modelVersion =
                                  t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r))
                              : (n.modelVersion = t.longs === String ? `0` : 0),
                            (n.docString = ``),
                            (n.graph = null));
                        }
                        if (
                          (e.irVersion != null &&
                            e.hasOwnProperty(`irVersion`) &&
                            (typeof e.irVersion == `number`
                              ? (n.irVersion = t.longs === String ? String(e.irVersion) : e.irVersion)
                              : (n.irVersion =
                                  t.longs === String
                                    ? l.Long.prototype.toString.call(e.irVersion)
                                    : t.longs === Number
                                      ? new l.LongBits(e.irVersion.low >>> 0, e.irVersion.high >>> 0).toNumber()
                                      : e.irVersion)),
                          e.producerName != null &&
                            e.hasOwnProperty(`producerName`) &&
                            (n.producerName = e.producerName),
                          e.producerVersion != null &&
                            e.hasOwnProperty(`producerVersion`) &&
                            (n.producerVersion = e.producerVersion),
                          e.domain != null && e.hasOwnProperty(`domain`) && (n.domain = e.domain),
                          e.modelVersion != null &&
                            e.hasOwnProperty(`modelVersion`) &&
                            (typeof e.modelVersion == `number`
                              ? (n.modelVersion = t.longs === String ? String(e.modelVersion) : e.modelVersion)
                              : (n.modelVersion =
                                  t.longs === String
                                    ? l.Long.prototype.toString.call(e.modelVersion)
                                    : t.longs === Number
                                      ? new l.LongBits(e.modelVersion.low >>> 0, e.modelVersion.high >>> 0).toNumber()
                                      : e.modelVersion)),
                          e.docString != null && e.hasOwnProperty(`docString`) && (n.docString = e.docString),
                          e.graph != null &&
                            e.hasOwnProperty(`graph`) &&
                            (n.graph = u.onnx.GraphProto.toObject(e.graph, t)),
                          e.opsetImport && e.opsetImport.length)
                        ) {
                          n.opsetImport = [];
                          for (var i = 0; i < e.opsetImport.length; ++i)
                            n.opsetImport[i] = u.onnx.OperatorSetIdProto.toObject(e.opsetImport[i], t);
                        }
                        if (e.metadataProps && e.metadataProps.length)
                          for (n.metadataProps = [], i = 0; i < e.metadataProps.length; ++i)
                            n.metadataProps[i] = u.onnx.StringStringEntryProto.toObject(e.metadataProps[i], t);
                        return n;
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      e
                    );
                  })()),
                  (a.StringStringEntryProto = (function () {
                    function e(e) {
                      if (e)
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.key = ``),
                      (e.prototype.value = ``),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        return (
                          (t ||= c.create()),
                          e.key != null && e.hasOwnProperty(`key`) && t.uint32(10).string(e.key),
                          e.value != null && e.hasOwnProperty(`value`) && t.uint32(18).string(e.value),
                          t
                        );
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (
                          var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.StringStringEntryProto();
                          e.pos < n;
                        ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              r.key = e.string();
                              break;
                            case 2:
                              r.value = e.string();
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        return typeof e != `object` || !e
                          ? `object expected`
                          : e.key != null && e.hasOwnProperty(`key`) && !l.isString(e.key)
                            ? `key: string expected`
                            : e.value != null && e.hasOwnProperty(`value`) && !l.isString(e.value)
                              ? `value: string expected`
                              : null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.StringStringEntryProto) return e;
                        var t = new u.onnx.StringStringEntryProto();
                        return (
                          e.key != null && (t.key = String(e.key)),
                          e.value != null && (t.value = String(e.value)),
                          t
                        );
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        return (
                          t.defaults && ((n.key = ``), (n.value = ``)),
                          e.key != null && e.hasOwnProperty(`key`) && (n.key = e.key),
                          e.value != null && e.hasOwnProperty(`value`) && (n.value = e.value),
                          n
                        );
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      e
                    );
                  })()),
                  (a.TensorAnnotation = (function () {
                    function e(e) {
                      if (((this.quantParameterTensorNames = []), e))
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.tensorName = ``),
                      (e.prototype.quantParameterTensorNames = l.emptyArray),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        if (
                          ((t ||= c.create()),
                          e.tensorName != null && e.hasOwnProperty(`tensorName`) && t.uint32(10).string(e.tensorName),
                          e.quantParameterTensorNames != null && e.quantParameterTensorNames.length)
                        )
                          for (var n = 0; n < e.quantParameterTensorNames.length; ++n)
                            u.onnx.StringStringEntryProto.encode(
                              e.quantParameterTensorNames[n],
                              t.uint32(18).fork(),
                            ).ldelim();
                        return t;
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.TensorAnnotation(); e.pos < n; ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              r.tensorName = e.string();
                              break;
                            case 2:
                              ((r.quantParameterTensorNames && r.quantParameterTensorNames.length) ||
                                (r.quantParameterTensorNames = []),
                                r.quantParameterTensorNames.push(u.onnx.StringStringEntryProto.decode(e, e.uint32())));
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (e.tensorName != null && e.hasOwnProperty(`tensorName`) && !l.isString(e.tensorName))
                          return `tensorName: string expected`;
                        if (e.quantParameterTensorNames != null && e.hasOwnProperty(`quantParameterTensorNames`)) {
                          if (!Array.isArray(e.quantParameterTensorNames))
                            return `quantParameterTensorNames: array expected`;
                          for (var t = 0; t < e.quantParameterTensorNames.length; ++t) {
                            var n = u.onnx.StringStringEntryProto.verify(e.quantParameterTensorNames[t]);
                            if (n) return `quantParameterTensorNames.` + n;
                          }
                        }
                        return null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.TensorAnnotation) return e;
                        var t = new u.onnx.TensorAnnotation();
                        if (
                          (e.tensorName != null && (t.tensorName = String(e.tensorName)), e.quantParameterTensorNames)
                        ) {
                          if (!Array.isArray(e.quantParameterTensorNames))
                            throw TypeError(`.onnx.TensorAnnotation.quantParameterTensorNames: array expected`);
                          t.quantParameterTensorNames = [];
                          for (var n = 0; n < e.quantParameterTensorNames.length; ++n) {
                            if (typeof e.quantParameterTensorNames[n] != `object`)
                              throw TypeError(`.onnx.TensorAnnotation.quantParameterTensorNames: object expected`);
                            t.quantParameterTensorNames[n] = u.onnx.StringStringEntryProto.fromObject(
                              e.quantParameterTensorNames[n],
                            );
                          }
                        }
                        return t;
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        if (
                          ((t.arrays || t.defaults) && (n.quantParameterTensorNames = []),
                          t.defaults && (n.tensorName = ``),
                          e.tensorName != null && e.hasOwnProperty(`tensorName`) && (n.tensorName = e.tensorName),
                          e.quantParameterTensorNames && e.quantParameterTensorNames.length)
                        ) {
                          n.quantParameterTensorNames = [];
                          for (var r = 0; r < e.quantParameterTensorNames.length; ++r)
                            n.quantParameterTensorNames[r] = u.onnx.StringStringEntryProto.toObject(
                              e.quantParameterTensorNames[r],
                              t,
                            );
                        }
                        return n;
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      e
                    );
                  })()),
                  (a.GraphProto = (function () {
                    function e(e) {
                      if (
                        ((this.node = []),
                        (this.initializer = []),
                        (this.input = []),
                        (this.output = []),
                        (this.valueInfo = []),
                        (this.quantizationAnnotation = []),
                        e)
                      )
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.node = l.emptyArray),
                      (e.prototype.name = ``),
                      (e.prototype.initializer = l.emptyArray),
                      (e.prototype.docString = ``),
                      (e.prototype.input = l.emptyArray),
                      (e.prototype.output = l.emptyArray),
                      (e.prototype.valueInfo = l.emptyArray),
                      (e.prototype.quantizationAnnotation = l.emptyArray),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        if (((t ||= c.create()), e.node != null && e.node.length))
                          for (var n = 0; n < e.node.length; ++n)
                            u.onnx.NodeProto.encode(e.node[n], t.uint32(10).fork()).ldelim();
                        if (
                          (e.name != null && e.hasOwnProperty(`name`) && t.uint32(18).string(e.name),
                          e.initializer != null && e.initializer.length)
                        )
                          for (n = 0; n < e.initializer.length; ++n)
                            u.onnx.TensorProto.encode(e.initializer[n], t.uint32(42).fork()).ldelim();
                        if (
                          (e.docString != null && e.hasOwnProperty(`docString`) && t.uint32(82).string(e.docString),
                          e.input != null && e.input.length)
                        )
                          for (n = 0; n < e.input.length; ++n)
                            u.onnx.ValueInfoProto.encode(e.input[n], t.uint32(90).fork()).ldelim();
                        if (e.output != null && e.output.length)
                          for (n = 0; n < e.output.length; ++n)
                            u.onnx.ValueInfoProto.encode(e.output[n], t.uint32(98).fork()).ldelim();
                        if (e.valueInfo != null && e.valueInfo.length)
                          for (n = 0; n < e.valueInfo.length; ++n)
                            u.onnx.ValueInfoProto.encode(e.valueInfo[n], t.uint32(106).fork()).ldelim();
                        if (e.quantizationAnnotation != null && e.quantizationAnnotation.length)
                          for (n = 0; n < e.quantizationAnnotation.length; ++n)
                            u.onnx.TensorAnnotation.encode(e.quantizationAnnotation[n], t.uint32(114).fork()).ldelim();
                        return t;
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.GraphProto(); e.pos < n; ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              ((r.node && r.node.length) || (r.node = []),
                                r.node.push(u.onnx.NodeProto.decode(e, e.uint32())));
                              break;
                            case 2:
                              r.name = e.string();
                              break;
                            case 5:
                              ((r.initializer && r.initializer.length) || (r.initializer = []),
                                r.initializer.push(u.onnx.TensorProto.decode(e, e.uint32())));
                              break;
                            case 10:
                              r.docString = e.string();
                              break;
                            case 11:
                              ((r.input && r.input.length) || (r.input = []),
                                r.input.push(u.onnx.ValueInfoProto.decode(e, e.uint32())));
                              break;
                            case 12:
                              ((r.output && r.output.length) || (r.output = []),
                                r.output.push(u.onnx.ValueInfoProto.decode(e, e.uint32())));
                              break;
                            case 13:
                              ((r.valueInfo && r.valueInfo.length) || (r.valueInfo = []),
                                r.valueInfo.push(u.onnx.ValueInfoProto.decode(e, e.uint32())));
                              break;
                            case 14:
                              ((r.quantizationAnnotation && r.quantizationAnnotation.length) ||
                                (r.quantizationAnnotation = []),
                                r.quantizationAnnotation.push(u.onnx.TensorAnnotation.decode(e, e.uint32())));
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (e.node != null && e.hasOwnProperty(`node`)) {
                          if (!Array.isArray(e.node)) return `node: array expected`;
                          for (var t = 0; t < e.node.length; ++t)
                            if ((n = u.onnx.NodeProto.verify(e.node[t]))) return `node.` + n;
                        }
                        if (e.name != null && e.hasOwnProperty(`name`) && !l.isString(e.name))
                          return `name: string expected`;
                        if (e.initializer != null && e.hasOwnProperty(`initializer`)) {
                          if (!Array.isArray(e.initializer)) return `initializer: array expected`;
                          for (t = 0; t < e.initializer.length; ++t)
                            if ((n = u.onnx.TensorProto.verify(e.initializer[t]))) return `initializer.` + n;
                        }
                        if (e.docString != null && e.hasOwnProperty(`docString`) && !l.isString(e.docString))
                          return `docString: string expected`;
                        if (e.input != null && e.hasOwnProperty(`input`)) {
                          if (!Array.isArray(e.input)) return `input: array expected`;
                          for (t = 0; t < e.input.length; ++t)
                            if ((n = u.onnx.ValueInfoProto.verify(e.input[t]))) return `input.` + n;
                        }
                        if (e.output != null && e.hasOwnProperty(`output`)) {
                          if (!Array.isArray(e.output)) return `output: array expected`;
                          for (t = 0; t < e.output.length; ++t)
                            if ((n = u.onnx.ValueInfoProto.verify(e.output[t]))) return `output.` + n;
                        }
                        if (e.valueInfo != null && e.hasOwnProperty(`valueInfo`)) {
                          if (!Array.isArray(e.valueInfo)) return `valueInfo: array expected`;
                          for (t = 0; t < e.valueInfo.length; ++t)
                            if ((n = u.onnx.ValueInfoProto.verify(e.valueInfo[t]))) return `valueInfo.` + n;
                        }
                        if (e.quantizationAnnotation != null && e.hasOwnProperty(`quantizationAnnotation`)) {
                          if (!Array.isArray(e.quantizationAnnotation)) return `quantizationAnnotation: array expected`;
                          for (t = 0; t < e.quantizationAnnotation.length; ++t) {
                            var n;
                            if ((n = u.onnx.TensorAnnotation.verify(e.quantizationAnnotation[t])))
                              return `quantizationAnnotation.` + n;
                          }
                        }
                        return null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.GraphProto) return e;
                        var t = new u.onnx.GraphProto();
                        if (e.node) {
                          if (!Array.isArray(e.node)) throw TypeError(`.onnx.GraphProto.node: array expected`);
                          t.node = [];
                          for (var n = 0; n < e.node.length; ++n) {
                            if (typeof e.node[n] != `object`) throw TypeError(`.onnx.GraphProto.node: object expected`);
                            t.node[n] = u.onnx.NodeProto.fromObject(e.node[n]);
                          }
                        }
                        if ((e.name != null && (t.name = String(e.name)), e.initializer)) {
                          if (!Array.isArray(e.initializer))
                            throw TypeError(`.onnx.GraphProto.initializer: array expected`);
                          for (t.initializer = [], n = 0; n < e.initializer.length; ++n) {
                            if (typeof e.initializer[n] != `object`)
                              throw TypeError(`.onnx.GraphProto.initializer: object expected`);
                            t.initializer[n] = u.onnx.TensorProto.fromObject(e.initializer[n]);
                          }
                        }
                        if ((e.docString != null && (t.docString = String(e.docString)), e.input)) {
                          if (!Array.isArray(e.input)) throw TypeError(`.onnx.GraphProto.input: array expected`);
                          for (t.input = [], n = 0; n < e.input.length; ++n) {
                            if (typeof e.input[n] != `object`)
                              throw TypeError(`.onnx.GraphProto.input: object expected`);
                            t.input[n] = u.onnx.ValueInfoProto.fromObject(e.input[n]);
                          }
                        }
                        if (e.output) {
                          if (!Array.isArray(e.output)) throw TypeError(`.onnx.GraphProto.output: array expected`);
                          for (t.output = [], n = 0; n < e.output.length; ++n) {
                            if (typeof e.output[n] != `object`)
                              throw TypeError(`.onnx.GraphProto.output: object expected`);
                            t.output[n] = u.onnx.ValueInfoProto.fromObject(e.output[n]);
                          }
                        }
                        if (e.valueInfo) {
                          if (!Array.isArray(e.valueInfo))
                            throw TypeError(`.onnx.GraphProto.valueInfo: array expected`);
                          for (t.valueInfo = [], n = 0; n < e.valueInfo.length; ++n) {
                            if (typeof e.valueInfo[n] != `object`)
                              throw TypeError(`.onnx.GraphProto.valueInfo: object expected`);
                            t.valueInfo[n] = u.onnx.ValueInfoProto.fromObject(e.valueInfo[n]);
                          }
                        }
                        if (e.quantizationAnnotation) {
                          if (!Array.isArray(e.quantizationAnnotation))
                            throw TypeError(`.onnx.GraphProto.quantizationAnnotation: array expected`);
                          for (t.quantizationAnnotation = [], n = 0; n < e.quantizationAnnotation.length; ++n) {
                            if (typeof e.quantizationAnnotation[n] != `object`)
                              throw TypeError(`.onnx.GraphProto.quantizationAnnotation: object expected`);
                            t.quantizationAnnotation[n] = u.onnx.TensorAnnotation.fromObject(
                              e.quantizationAnnotation[n],
                            );
                          }
                        }
                        return t;
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        if (
                          ((t.arrays || t.defaults) &&
                            ((n.node = []),
                            (n.initializer = []),
                            (n.input = []),
                            (n.output = []),
                            (n.valueInfo = []),
                            (n.quantizationAnnotation = [])),
                          t.defaults && ((n.name = ``), (n.docString = ``)),
                          e.node && e.node.length)
                        ) {
                          n.node = [];
                          for (var r = 0; r < e.node.length; ++r) n.node[r] = u.onnx.NodeProto.toObject(e.node[r], t);
                        }
                        if (
                          (e.name != null && e.hasOwnProperty(`name`) && (n.name = e.name),
                          e.initializer && e.initializer.length)
                        )
                          for (n.initializer = [], r = 0; r < e.initializer.length; ++r)
                            n.initializer[r] = u.onnx.TensorProto.toObject(e.initializer[r], t);
                        if (
                          (e.docString != null && e.hasOwnProperty(`docString`) && (n.docString = e.docString),
                          e.input && e.input.length)
                        )
                          for (n.input = [], r = 0; r < e.input.length; ++r)
                            n.input[r] = u.onnx.ValueInfoProto.toObject(e.input[r], t);
                        if (e.output && e.output.length)
                          for (n.output = [], r = 0; r < e.output.length; ++r)
                            n.output[r] = u.onnx.ValueInfoProto.toObject(e.output[r], t);
                        if (e.valueInfo && e.valueInfo.length)
                          for (n.valueInfo = [], r = 0; r < e.valueInfo.length; ++r)
                            n.valueInfo[r] = u.onnx.ValueInfoProto.toObject(e.valueInfo[r], t);
                        if (e.quantizationAnnotation && e.quantizationAnnotation.length)
                          for (n.quantizationAnnotation = [], r = 0; r < e.quantizationAnnotation.length; ++r)
                            n.quantizationAnnotation[r] = u.onnx.TensorAnnotation.toObject(
                              e.quantizationAnnotation[r],
                              t,
                            );
                        return n;
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      e
                    );
                  })()),
                  (a.TensorProto = (function () {
                    function e(e) {
                      if (
                        ((this.dims = []),
                        (this.floatData = []),
                        (this.int32Data = []),
                        (this.stringData = []),
                        (this.int64Data = []),
                        (this.externalData = []),
                        (this.doubleData = []),
                        (this.uint64Data = []),
                        e)
                      )
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.dims = l.emptyArray),
                      (e.prototype.dataType = 0),
                      (e.prototype.segment = null),
                      (e.prototype.floatData = l.emptyArray),
                      (e.prototype.int32Data = l.emptyArray),
                      (e.prototype.stringData = l.emptyArray),
                      (e.prototype.int64Data = l.emptyArray),
                      (e.prototype.name = ``),
                      (e.prototype.docString = ``),
                      (e.prototype.rawData = l.newBuffer([])),
                      (e.prototype.externalData = l.emptyArray),
                      (e.prototype.dataLocation = 0),
                      (e.prototype.doubleData = l.emptyArray),
                      (e.prototype.uint64Data = l.emptyArray),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        if (((t ||= c.create()), e.dims != null && e.dims.length)) {
                          t.uint32(10).fork();
                          for (var n = 0; n < e.dims.length; ++n) t.int64(e.dims[n]);
                          t.ldelim();
                        }
                        if (
                          (e.dataType != null && e.hasOwnProperty(`dataType`) && t.uint32(16).int32(e.dataType),
                          e.segment != null &&
                            e.hasOwnProperty(`segment`) &&
                            u.onnx.TensorProto.Segment.encode(e.segment, t.uint32(26).fork()).ldelim(),
                          e.floatData != null && e.floatData.length)
                        ) {
                          for (t.uint32(34).fork(), n = 0; n < e.floatData.length; ++n) t.float(e.floatData[n]);
                          t.ldelim();
                        }
                        if (e.int32Data != null && e.int32Data.length) {
                          for (t.uint32(42).fork(), n = 0; n < e.int32Data.length; ++n) t.int32(e.int32Data[n]);
                          t.ldelim();
                        }
                        if (e.stringData != null && e.stringData.length)
                          for (n = 0; n < e.stringData.length; ++n) t.uint32(50).bytes(e.stringData[n]);
                        if (e.int64Data != null && e.int64Data.length) {
                          for (t.uint32(58).fork(), n = 0; n < e.int64Data.length; ++n) t.int64(e.int64Data[n]);
                          t.ldelim();
                        }
                        if (
                          (e.name != null && e.hasOwnProperty(`name`) && t.uint32(66).string(e.name),
                          e.rawData != null && e.hasOwnProperty(`rawData`) && t.uint32(74).bytes(e.rawData),
                          e.doubleData != null && e.doubleData.length)
                        ) {
                          for (t.uint32(82).fork(), n = 0; n < e.doubleData.length; ++n) t.double(e.doubleData[n]);
                          t.ldelim();
                        }
                        if (e.uint64Data != null && e.uint64Data.length) {
                          for (t.uint32(90).fork(), n = 0; n < e.uint64Data.length; ++n) t.uint64(e.uint64Data[n]);
                          t.ldelim();
                        }
                        if (
                          (e.docString != null && e.hasOwnProperty(`docString`) && t.uint32(98).string(e.docString),
                          e.externalData != null && e.externalData.length)
                        )
                          for (n = 0; n < e.externalData.length; ++n)
                            u.onnx.StringStringEntryProto.encode(e.externalData[n], t.uint32(106).fork()).ldelim();
                        return (
                          e.dataLocation != null &&
                            e.hasOwnProperty(`dataLocation`) &&
                            t.uint32(112).int32(e.dataLocation),
                          t
                        );
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.TensorProto(); e.pos < n; ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              if (((r.dims && r.dims.length) || (r.dims = []), (7 & i) == 2))
                                for (var a = e.uint32() + e.pos; e.pos < a; ) r.dims.push(e.int64());
                              else r.dims.push(e.int64());
                              break;
                            case 2:
                              r.dataType = e.int32();
                              break;
                            case 3:
                              r.segment = u.onnx.TensorProto.Segment.decode(e, e.uint32());
                              break;
                            case 4:
                              if (((r.floatData && r.floatData.length) || (r.floatData = []), (7 & i) == 2))
                                for (a = e.uint32() + e.pos; e.pos < a; ) r.floatData.push(e.float());
                              else r.floatData.push(e.float());
                              break;
                            case 5:
                              if (((r.int32Data && r.int32Data.length) || (r.int32Data = []), (7 & i) == 2))
                                for (a = e.uint32() + e.pos; e.pos < a; ) r.int32Data.push(e.int32());
                              else r.int32Data.push(e.int32());
                              break;
                            case 6:
                              ((r.stringData && r.stringData.length) || (r.stringData = []),
                                r.stringData.push(e.bytes()));
                              break;
                            case 7:
                              if (((r.int64Data && r.int64Data.length) || (r.int64Data = []), (7 & i) == 2))
                                for (a = e.uint32() + e.pos; e.pos < a; ) r.int64Data.push(e.int64());
                              else r.int64Data.push(e.int64());
                              break;
                            case 8:
                              r.name = e.string();
                              break;
                            case 12:
                              r.docString = e.string();
                              break;
                            case 9:
                              r.rawData = e.bytes();
                              break;
                            case 13:
                              ((r.externalData && r.externalData.length) || (r.externalData = []),
                                r.externalData.push(u.onnx.StringStringEntryProto.decode(e, e.uint32())));
                              break;
                            case 14:
                              r.dataLocation = e.int32();
                              break;
                            case 10:
                              if (((r.doubleData && r.doubleData.length) || (r.doubleData = []), (7 & i) == 2))
                                for (a = e.uint32() + e.pos; e.pos < a; ) r.doubleData.push(e.double());
                              else r.doubleData.push(e.double());
                              break;
                            case 11:
                              if (((r.uint64Data && r.uint64Data.length) || (r.uint64Data = []), (7 & i) == 2))
                                for (a = e.uint32() + e.pos; e.pos < a; ) r.uint64Data.push(e.uint64());
                              else r.uint64Data.push(e.uint64());
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (e.dims != null && e.hasOwnProperty(`dims`)) {
                          if (!Array.isArray(e.dims)) return `dims: array expected`;
                          for (var t = 0; t < e.dims.length; ++t)
                            if (
                              !(
                                l.isInteger(e.dims[t]) ||
                                (e.dims[t] && l.isInteger(e.dims[t].low) && l.isInteger(e.dims[t].high))
                              )
                            )
                              return `dims: integer|Long[] expected`;
                        }
                        if (e.dataType != null && e.hasOwnProperty(`dataType`) && !l.isInteger(e.dataType))
                          return `dataType: integer expected`;
                        if (
                          e.segment != null &&
                          e.hasOwnProperty(`segment`) &&
                          (n = u.onnx.TensorProto.Segment.verify(e.segment))
                        )
                          return `segment.` + n;
                        if (e.floatData != null && e.hasOwnProperty(`floatData`)) {
                          if (!Array.isArray(e.floatData)) return `floatData: array expected`;
                          for (t = 0; t < e.floatData.length; ++t)
                            if (typeof e.floatData[t] != `number`) return `floatData: number[] expected`;
                        }
                        if (e.int32Data != null && e.hasOwnProperty(`int32Data`)) {
                          if (!Array.isArray(e.int32Data)) return `int32Data: array expected`;
                          for (t = 0; t < e.int32Data.length; ++t)
                            if (!l.isInteger(e.int32Data[t])) return `int32Data: integer[] expected`;
                        }
                        if (e.stringData != null && e.hasOwnProperty(`stringData`)) {
                          if (!Array.isArray(e.stringData)) return `stringData: array expected`;
                          for (t = 0; t < e.stringData.length; ++t)
                            if (
                              !(
                                (e.stringData[t] && typeof e.stringData[t].length == `number`) ||
                                l.isString(e.stringData[t])
                              )
                            )
                              return `stringData: buffer[] expected`;
                        }
                        if (e.int64Data != null && e.hasOwnProperty(`int64Data`)) {
                          if (!Array.isArray(e.int64Data)) return `int64Data: array expected`;
                          for (t = 0; t < e.int64Data.length; ++t)
                            if (
                              !(
                                l.isInteger(e.int64Data[t]) ||
                                (e.int64Data[t] && l.isInteger(e.int64Data[t].low) && l.isInteger(e.int64Data[t].high))
                              )
                            )
                              return `int64Data: integer|Long[] expected`;
                        }
                        if (e.name != null && e.hasOwnProperty(`name`) && !l.isString(e.name))
                          return `name: string expected`;
                        if (e.docString != null && e.hasOwnProperty(`docString`) && !l.isString(e.docString))
                          return `docString: string expected`;
                        if (
                          e.rawData != null &&
                          e.hasOwnProperty(`rawData`) &&
                          !((e.rawData && typeof e.rawData.length == `number`) || l.isString(e.rawData))
                        )
                          return `rawData: buffer expected`;
                        if (e.externalData != null && e.hasOwnProperty(`externalData`)) {
                          if (!Array.isArray(e.externalData)) return `externalData: array expected`;
                          for (t = 0; t < e.externalData.length; ++t) {
                            var n;
                            if ((n = u.onnx.StringStringEntryProto.verify(e.externalData[t])))
                              return `externalData.` + n;
                          }
                        }
                        if (e.dataLocation != null && e.hasOwnProperty(`dataLocation`))
                          switch (e.dataLocation) {
                            default:
                              return `dataLocation: enum value expected`;
                            case 0:
                            case 1:
                          }
                        if (e.doubleData != null && e.hasOwnProperty(`doubleData`)) {
                          if (!Array.isArray(e.doubleData)) return `doubleData: array expected`;
                          for (t = 0; t < e.doubleData.length; ++t)
                            if (typeof e.doubleData[t] != `number`) return `doubleData: number[] expected`;
                        }
                        if (e.uint64Data != null && e.hasOwnProperty(`uint64Data`)) {
                          if (!Array.isArray(e.uint64Data)) return `uint64Data: array expected`;
                          for (t = 0; t < e.uint64Data.length; ++t)
                            if (
                              !(
                                l.isInteger(e.uint64Data[t]) ||
                                (e.uint64Data[t] &&
                                  l.isInteger(e.uint64Data[t].low) &&
                                  l.isInteger(e.uint64Data[t].high))
                              )
                            )
                              return `uint64Data: integer|Long[] expected`;
                        }
                        return null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.TensorProto) return e;
                        var t = new u.onnx.TensorProto();
                        if (e.dims) {
                          if (!Array.isArray(e.dims)) throw TypeError(`.onnx.TensorProto.dims: array expected`);
                          t.dims = [];
                          for (var n = 0; n < e.dims.length; ++n)
                            l.Long
                              ? ((t.dims[n] = l.Long.fromValue(e.dims[n])).unsigned = !1)
                              : typeof e.dims[n] == `string`
                                ? (t.dims[n] = parseInt(e.dims[n], 10))
                                : typeof e.dims[n] == `number`
                                  ? (t.dims[n] = e.dims[n])
                                  : typeof e.dims[n] == `object` &&
                                    (t.dims[n] = new l.LongBits(e.dims[n].low >>> 0, e.dims[n].high >>> 0).toNumber());
                        }
                        if ((e.dataType != null && (t.dataType = 0 | e.dataType), e.segment != null)) {
                          if (typeof e.segment != `object`)
                            throw TypeError(`.onnx.TensorProto.segment: object expected`);
                          t.segment = u.onnx.TensorProto.Segment.fromObject(e.segment);
                        }
                        if (e.floatData) {
                          if (!Array.isArray(e.floatData))
                            throw TypeError(`.onnx.TensorProto.floatData: array expected`);
                          for (t.floatData = [], n = 0; n < e.floatData.length; ++n)
                            t.floatData[n] = Number(e.floatData[n]);
                        }
                        if (e.int32Data) {
                          if (!Array.isArray(e.int32Data))
                            throw TypeError(`.onnx.TensorProto.int32Data: array expected`);
                          for (t.int32Data = [], n = 0; n < e.int32Data.length; ++n)
                            t.int32Data[n] = 0 | e.int32Data[n];
                        }
                        if (e.stringData) {
                          if (!Array.isArray(e.stringData))
                            throw TypeError(`.onnx.TensorProto.stringData: array expected`);
                          for (t.stringData = [], n = 0; n < e.stringData.length; ++n)
                            typeof e.stringData[n] == `string`
                              ? l.base64.decode(
                                  e.stringData[n],
                                  (t.stringData[n] = l.newBuffer(l.base64.length(e.stringData[n]))),
                                  0,
                                )
                              : e.stringData[n].length && (t.stringData[n] = e.stringData[n]);
                        }
                        if (e.int64Data) {
                          if (!Array.isArray(e.int64Data))
                            throw TypeError(`.onnx.TensorProto.int64Data: array expected`);
                          for (t.int64Data = [], n = 0; n < e.int64Data.length; ++n)
                            l.Long
                              ? ((t.int64Data[n] = l.Long.fromValue(e.int64Data[n])).unsigned = !1)
                              : typeof e.int64Data[n] == `string`
                                ? (t.int64Data[n] = parseInt(e.int64Data[n], 10))
                                : typeof e.int64Data[n] == `number`
                                  ? (t.int64Data[n] = e.int64Data[n])
                                  : typeof e.int64Data[n] == `object` &&
                                    (t.int64Data[n] = new l.LongBits(
                                      e.int64Data[n].low >>> 0,
                                      e.int64Data[n].high >>> 0,
                                    ).toNumber());
                        }
                        if (
                          (e.name != null && (t.name = String(e.name)),
                          e.docString != null && (t.docString = String(e.docString)),
                          e.rawData != null &&
                            (typeof e.rawData == `string`
                              ? l.base64.decode(e.rawData, (t.rawData = l.newBuffer(l.base64.length(e.rawData))), 0)
                              : e.rawData.length && (t.rawData = e.rawData)),
                          e.externalData)
                        ) {
                          if (!Array.isArray(e.externalData))
                            throw TypeError(`.onnx.TensorProto.externalData: array expected`);
                          for (t.externalData = [], n = 0; n < e.externalData.length; ++n) {
                            if (typeof e.externalData[n] != `object`)
                              throw TypeError(`.onnx.TensorProto.externalData: object expected`);
                            t.externalData[n] = u.onnx.StringStringEntryProto.fromObject(e.externalData[n]);
                          }
                        }
                        switch (e.dataLocation) {
                          case `DEFAULT`:
                          case 0:
                            t.dataLocation = 0;
                            break;
                          case `EXTERNAL`:
                          case 1:
                            t.dataLocation = 1;
                        }
                        if (e.doubleData) {
                          if (!Array.isArray(e.doubleData))
                            throw TypeError(`.onnx.TensorProto.doubleData: array expected`);
                          for (t.doubleData = [], n = 0; n < e.doubleData.length; ++n)
                            t.doubleData[n] = Number(e.doubleData[n]);
                        }
                        if (e.uint64Data) {
                          if (!Array.isArray(e.uint64Data))
                            throw TypeError(`.onnx.TensorProto.uint64Data: array expected`);
                          for (t.uint64Data = [], n = 0; n < e.uint64Data.length; ++n)
                            l.Long
                              ? ((t.uint64Data[n] = l.Long.fromValue(e.uint64Data[n])).unsigned = !0)
                              : typeof e.uint64Data[n] == `string`
                                ? (t.uint64Data[n] = parseInt(e.uint64Data[n], 10))
                                : typeof e.uint64Data[n] == `number`
                                  ? (t.uint64Data[n] = e.uint64Data[n])
                                  : typeof e.uint64Data[n] == `object` &&
                                    (t.uint64Data[n] = new l.LongBits(
                                      e.uint64Data[n].low >>> 0,
                                      e.uint64Data[n].high >>> 0,
                                    ).toNumber(!0));
                        }
                        return t;
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        if (
                          ((t.arrays || t.defaults) &&
                            ((n.dims = []),
                            (n.floatData = []),
                            (n.int32Data = []),
                            (n.stringData = []),
                            (n.int64Data = []),
                            (n.doubleData = []),
                            (n.uint64Data = []),
                            (n.externalData = [])),
                          t.defaults &&
                            ((n.dataType = 0),
                            (n.segment = null),
                            (n.name = ``),
                            t.bytes === String
                              ? (n.rawData = ``)
                              : ((n.rawData = []), t.bytes !== Array && (n.rawData = l.newBuffer(n.rawData))),
                            (n.docString = ``),
                            (n.dataLocation = t.enums === String ? `DEFAULT` : 0)),
                          e.dims && e.dims.length)
                        ) {
                          n.dims = [];
                          for (var r = 0; r < e.dims.length; ++r)
                            typeof e.dims[r] == `number`
                              ? (n.dims[r] = t.longs === String ? String(e.dims[r]) : e.dims[r])
                              : (n.dims[r] =
                                  t.longs === String
                                    ? l.Long.prototype.toString.call(e.dims[r])
                                    : t.longs === Number
                                      ? new l.LongBits(e.dims[r].low >>> 0, e.dims[r].high >>> 0).toNumber()
                                      : e.dims[r]);
                        }
                        if (
                          (e.dataType != null && e.hasOwnProperty(`dataType`) && (n.dataType = e.dataType),
                          e.segment != null &&
                            e.hasOwnProperty(`segment`) &&
                            (n.segment = u.onnx.TensorProto.Segment.toObject(e.segment, t)),
                          e.floatData && e.floatData.length)
                        )
                          for (n.floatData = [], r = 0; r < e.floatData.length; ++r)
                            n.floatData[r] =
                              t.json && !isFinite(e.floatData[r]) ? String(e.floatData[r]) : e.floatData[r];
                        if (e.int32Data && e.int32Data.length)
                          for (n.int32Data = [], r = 0; r < e.int32Data.length; ++r) n.int32Data[r] = e.int32Data[r];
                        if (e.stringData && e.stringData.length)
                          for (n.stringData = [], r = 0; r < e.stringData.length; ++r)
                            n.stringData[r] =
                              t.bytes === String
                                ? l.base64.encode(e.stringData[r], 0, e.stringData[r].length)
                                : t.bytes === Array
                                  ? Array.prototype.slice.call(e.stringData[r])
                                  : e.stringData[r];
                        if (e.int64Data && e.int64Data.length)
                          for (n.int64Data = [], r = 0; r < e.int64Data.length; ++r)
                            typeof e.int64Data[r] == `number`
                              ? (n.int64Data[r] = t.longs === String ? String(e.int64Data[r]) : e.int64Data[r])
                              : (n.int64Data[r] =
                                  t.longs === String
                                    ? l.Long.prototype.toString.call(e.int64Data[r])
                                    : t.longs === Number
                                      ? new l.LongBits(e.int64Data[r].low >>> 0, e.int64Data[r].high >>> 0).toNumber()
                                      : e.int64Data[r]);
                        if (
                          (e.name != null && e.hasOwnProperty(`name`) && (n.name = e.name),
                          e.rawData != null &&
                            e.hasOwnProperty(`rawData`) &&
                            (n.rawData =
                              t.bytes === String
                                ? l.base64.encode(e.rawData, 0, e.rawData.length)
                                : t.bytes === Array
                                  ? Array.prototype.slice.call(e.rawData)
                                  : e.rawData),
                          e.doubleData && e.doubleData.length)
                        )
                          for (n.doubleData = [], r = 0; r < e.doubleData.length; ++r)
                            n.doubleData[r] =
                              t.json && !isFinite(e.doubleData[r]) ? String(e.doubleData[r]) : e.doubleData[r];
                        if (e.uint64Data && e.uint64Data.length)
                          for (n.uint64Data = [], r = 0; r < e.uint64Data.length; ++r)
                            typeof e.uint64Data[r] == `number`
                              ? (n.uint64Data[r] = t.longs === String ? String(e.uint64Data[r]) : e.uint64Data[r])
                              : (n.uint64Data[r] =
                                  t.longs === String
                                    ? l.Long.prototype.toString.call(e.uint64Data[r])
                                    : t.longs === Number
                                      ? new l.LongBits(e.uint64Data[r].low >>> 0, e.uint64Data[r].high >>> 0).toNumber(
                                          !0,
                                        )
                                      : e.uint64Data[r]);
                        if (
                          (e.docString != null && e.hasOwnProperty(`docString`) && (n.docString = e.docString),
                          e.externalData && e.externalData.length)
                        )
                          for (n.externalData = [], r = 0; r < e.externalData.length; ++r)
                            n.externalData[r] = u.onnx.StringStringEntryProto.toObject(e.externalData[r], t);
                        return (
                          e.dataLocation != null &&
                            e.hasOwnProperty(`dataLocation`) &&
                            (n.dataLocation =
                              t.enums === String ? u.onnx.TensorProto.DataLocation[e.dataLocation] : e.dataLocation),
                          n
                        );
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      (e.DataType = (function () {
                        var e = {},
                          t = Object.create(e);
                        return (
                          (t[(e[0] = `UNDEFINED`)] = 0),
                          (t[(e[1] = `FLOAT`)] = 1),
                          (t[(e[2] = `UINT8`)] = 2),
                          (t[(e[3] = `INT8`)] = 3),
                          (t[(e[4] = `UINT16`)] = 4),
                          (t[(e[5] = `INT16`)] = 5),
                          (t[(e[6] = `INT32`)] = 6),
                          (t[(e[7] = `INT64`)] = 7),
                          (t[(e[8] = `STRING`)] = 8),
                          (t[(e[9] = `BOOL`)] = 9),
                          (t[(e[10] = `FLOAT16`)] = 10),
                          (t[(e[11] = `DOUBLE`)] = 11),
                          (t[(e[12] = `UINT32`)] = 12),
                          (t[(e[13] = `UINT64`)] = 13),
                          (t[(e[14] = `COMPLEX64`)] = 14),
                          (t[(e[15] = `COMPLEX128`)] = 15),
                          (t[(e[16] = `BFLOAT16`)] = 16),
                          t
                        );
                      })()),
                      (e.Segment = (function () {
                        function e(e) {
                          if (e)
                            for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                              e[t[n]] != null && (this[t[n]] = e[t[n]]);
                        }
                        return (
                          (e.prototype.begin = l.Long ? l.Long.fromBits(0, 0, !1) : 0),
                          (e.prototype.end = l.Long ? l.Long.fromBits(0, 0, !1) : 0),
                          (e.create = function (t) {
                            return new e(t);
                          }),
                          (e.encode = function (e, t) {
                            return (
                              (t ||= c.create()),
                              e.begin != null && e.hasOwnProperty(`begin`) && t.uint32(8).int64(e.begin),
                              e.end != null && e.hasOwnProperty(`end`) && t.uint32(16).int64(e.end),
                              t
                            );
                          }),
                          (e.encodeDelimited = function (e, t) {
                            return this.encode(e, t).ldelim();
                          }),
                          (e.decode = function (e, t) {
                            e instanceof s || (e = s.create(e));
                            for (
                              var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.TensorProto.Segment();
                              e.pos < n;
                            ) {
                              var i = e.uint32();
                              switch (i >>> 3) {
                                case 1:
                                  r.begin = e.int64();
                                  break;
                                case 2:
                                  r.end = e.int64();
                                  break;
                                default:
                                  e.skipType(7 & i);
                              }
                            }
                            return r;
                          }),
                          (e.decodeDelimited = function (e) {
                            return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                          }),
                          (e.verify = function (e) {
                            return typeof e != `object` || !e
                              ? `object expected`
                              : e.begin != null &&
                                  e.hasOwnProperty(`begin`) &&
                                  !(
                                    l.isInteger(e.begin) ||
                                    (e.begin && l.isInteger(e.begin.low) && l.isInteger(e.begin.high))
                                  )
                                ? `begin: integer|Long expected`
                                : e.end != null &&
                                    e.hasOwnProperty(`end`) &&
                                    !(
                                      l.isInteger(e.end) ||
                                      (e.end && l.isInteger(e.end.low) && l.isInteger(e.end.high))
                                    )
                                  ? `end: integer|Long expected`
                                  : null;
                          }),
                          (e.fromObject = function (e) {
                            if (e instanceof u.onnx.TensorProto.Segment) return e;
                            var t = new u.onnx.TensorProto.Segment();
                            return (
                              e.begin != null &&
                                (l.Long
                                  ? ((t.begin = l.Long.fromValue(e.begin)).unsigned = !1)
                                  : typeof e.begin == `string`
                                    ? (t.begin = parseInt(e.begin, 10))
                                    : typeof e.begin == `number`
                                      ? (t.begin = e.begin)
                                      : typeof e.begin == `object` &&
                                        (t.begin = new l.LongBits(e.begin.low >>> 0, e.begin.high >>> 0).toNumber())),
                              e.end != null &&
                                (l.Long
                                  ? ((t.end = l.Long.fromValue(e.end)).unsigned = !1)
                                  : typeof e.end == `string`
                                    ? (t.end = parseInt(e.end, 10))
                                    : typeof e.end == `number`
                                      ? (t.end = e.end)
                                      : typeof e.end == `object` &&
                                        (t.end = new l.LongBits(e.end.low >>> 0, e.end.high >>> 0).toNumber())),
                              t
                            );
                          }),
                          (e.toObject = function (e, t) {
                            t ||= {};
                            var n = {};
                            if (t.defaults) {
                              if (l.Long) {
                                var r = new l.Long(0, 0, !1);
                                n.begin = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
                              } else n.begin = t.longs === String ? `0` : 0;
                              l.Long
                                ? ((r = new l.Long(0, 0, !1)),
                                  (n.end = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r))
                                : (n.end = t.longs === String ? `0` : 0);
                            }
                            return (
                              e.begin != null &&
                                e.hasOwnProperty(`begin`) &&
                                (typeof e.begin == `number`
                                  ? (n.begin = t.longs === String ? String(e.begin) : e.begin)
                                  : (n.begin =
                                      t.longs === String
                                        ? l.Long.prototype.toString.call(e.begin)
                                        : t.longs === Number
                                          ? new l.LongBits(e.begin.low >>> 0, e.begin.high >>> 0).toNumber()
                                          : e.begin)),
                              e.end != null &&
                                e.hasOwnProperty(`end`) &&
                                (typeof e.end == `number`
                                  ? (n.end = t.longs === String ? String(e.end) : e.end)
                                  : (n.end =
                                      t.longs === String
                                        ? l.Long.prototype.toString.call(e.end)
                                        : t.longs === Number
                                          ? new l.LongBits(e.end.low >>> 0, e.end.high >>> 0).toNumber()
                                          : e.end)),
                              n
                            );
                          }),
                          (e.prototype.toJSON = function () {
                            return this.constructor.toObject(this, o.util.toJSONOptions);
                          }),
                          e
                        );
                      })()),
                      (e.DataLocation = (function () {
                        var e = {},
                          t = Object.create(e);
                        return ((t[(e[0] = `DEFAULT`)] = 0), (t[(e[1] = `EXTERNAL`)] = 1), t);
                      })()),
                      e
                    );
                  })()),
                  (a.TensorShapeProto = (function () {
                    function e(e) {
                      if (((this.dim = []), e))
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.dim = l.emptyArray),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        if (((t ||= c.create()), e.dim != null && e.dim.length))
                          for (var n = 0; n < e.dim.length; ++n)
                            u.onnx.TensorShapeProto.Dimension.encode(e.dim[n], t.uint32(10).fork()).ldelim();
                        return t;
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.TensorShapeProto(); e.pos < n; ) {
                          var i = e.uint32();
                          i >>> 3 == 1
                            ? ((r.dim && r.dim.length) || (r.dim = []),
                              r.dim.push(u.onnx.TensorShapeProto.Dimension.decode(e, e.uint32())))
                            : e.skipType(7 & i);
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (e.dim != null && e.hasOwnProperty(`dim`)) {
                          if (!Array.isArray(e.dim)) return `dim: array expected`;
                          for (var t = 0; t < e.dim.length; ++t) {
                            var n = u.onnx.TensorShapeProto.Dimension.verify(e.dim[t]);
                            if (n) return `dim.` + n;
                          }
                        }
                        return null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.TensorShapeProto) return e;
                        var t = new u.onnx.TensorShapeProto();
                        if (e.dim) {
                          if (!Array.isArray(e.dim)) throw TypeError(`.onnx.TensorShapeProto.dim: array expected`);
                          t.dim = [];
                          for (var n = 0; n < e.dim.length; ++n) {
                            if (typeof e.dim[n] != `object`)
                              throw TypeError(`.onnx.TensorShapeProto.dim: object expected`);
                            t.dim[n] = u.onnx.TensorShapeProto.Dimension.fromObject(e.dim[n]);
                          }
                        }
                        return t;
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        if (((t.arrays || t.defaults) && (n.dim = []), e.dim && e.dim.length)) {
                          n.dim = [];
                          for (var r = 0; r < e.dim.length; ++r)
                            n.dim[r] = u.onnx.TensorShapeProto.Dimension.toObject(e.dim[r], t);
                        }
                        return n;
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      (e.Dimension = (function () {
                        function e(e) {
                          if (e)
                            for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                              e[t[n]] != null && (this[t[n]] = e[t[n]]);
                        }
                        var t;
                        return (
                          (e.prototype.dimValue = l.Long ? l.Long.fromBits(0, 0, !1) : 0),
                          (e.prototype.dimParam = ``),
                          (e.prototype.denotation = ``),
                          Object.defineProperty(e.prototype, `value`, {
                            get: l.oneOfGetter((t = [`dimValue`, `dimParam`])),
                            set: l.oneOfSetter(t),
                          }),
                          (e.create = function (t) {
                            return new e(t);
                          }),
                          (e.encode = function (e, t) {
                            return (
                              (t ||= c.create()),
                              e.dimValue != null && e.hasOwnProperty(`dimValue`) && t.uint32(8).int64(e.dimValue),
                              e.dimParam != null && e.hasOwnProperty(`dimParam`) && t.uint32(18).string(e.dimParam),
                              e.denotation != null &&
                                e.hasOwnProperty(`denotation`) &&
                                t.uint32(26).string(e.denotation),
                              t
                            );
                          }),
                          (e.encodeDelimited = function (e, t) {
                            return this.encode(e, t).ldelim();
                          }),
                          (e.decode = function (e, t) {
                            e instanceof s || (e = s.create(e));
                            for (
                              var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.TensorShapeProto.Dimension();
                              e.pos < n;
                            ) {
                              var i = e.uint32();
                              switch (i >>> 3) {
                                case 1:
                                  r.dimValue = e.int64();
                                  break;
                                case 2:
                                  r.dimParam = e.string();
                                  break;
                                case 3:
                                  r.denotation = e.string();
                                  break;
                                default:
                                  e.skipType(7 & i);
                              }
                            }
                            return r;
                          }),
                          (e.decodeDelimited = function (e) {
                            return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                          }),
                          (e.verify = function (e) {
                            if (typeof e != `object` || !e) return `object expected`;
                            var t = {};
                            if (
                              e.dimValue != null &&
                              e.hasOwnProperty(`dimValue`) &&
                              ((t.value = 1),
                              !(
                                l.isInteger(e.dimValue) ||
                                (e.dimValue && l.isInteger(e.dimValue.low) && l.isInteger(e.dimValue.high))
                              ))
                            )
                              return `dimValue: integer|Long expected`;
                            if (e.dimParam != null && e.hasOwnProperty(`dimParam`)) {
                              if (t.value === 1) return `value: multiple values`;
                              if (((t.value = 1), !l.isString(e.dimParam))) return `dimParam: string expected`;
                            }
                            return e.denotation != null && e.hasOwnProperty(`denotation`) && !l.isString(e.denotation)
                              ? `denotation: string expected`
                              : null;
                          }),
                          (e.fromObject = function (e) {
                            if (e instanceof u.onnx.TensorShapeProto.Dimension) return e;
                            var t = new u.onnx.TensorShapeProto.Dimension();
                            return (
                              e.dimValue != null &&
                                (l.Long
                                  ? ((t.dimValue = l.Long.fromValue(e.dimValue)).unsigned = !1)
                                  : typeof e.dimValue == `string`
                                    ? (t.dimValue = parseInt(e.dimValue, 10))
                                    : typeof e.dimValue == `number`
                                      ? (t.dimValue = e.dimValue)
                                      : typeof e.dimValue == `object` &&
                                        (t.dimValue = new l.LongBits(
                                          e.dimValue.low >>> 0,
                                          e.dimValue.high >>> 0,
                                        ).toNumber())),
                              e.dimParam != null && (t.dimParam = String(e.dimParam)),
                              e.denotation != null && (t.denotation = String(e.denotation)),
                              t
                            );
                          }),
                          (e.toObject = function (e, t) {
                            t ||= {};
                            var n = {};
                            return (
                              t.defaults && (n.denotation = ``),
                              e.dimValue != null &&
                                e.hasOwnProperty(`dimValue`) &&
                                (typeof e.dimValue == `number`
                                  ? (n.dimValue = t.longs === String ? String(e.dimValue) : e.dimValue)
                                  : (n.dimValue =
                                      t.longs === String
                                        ? l.Long.prototype.toString.call(e.dimValue)
                                        : t.longs === Number
                                          ? new l.LongBits(e.dimValue.low >>> 0, e.dimValue.high >>> 0).toNumber()
                                          : e.dimValue),
                                t.oneofs && (n.value = `dimValue`)),
                              e.dimParam != null &&
                                e.hasOwnProperty(`dimParam`) &&
                                ((n.dimParam = e.dimParam), t.oneofs && (n.value = `dimParam`)),
                              e.denotation != null && e.hasOwnProperty(`denotation`) && (n.denotation = e.denotation),
                              n
                            );
                          }),
                          (e.prototype.toJSON = function () {
                            return this.constructor.toObject(this, o.util.toJSONOptions);
                          }),
                          e
                        );
                      })()),
                      e
                    );
                  })()),
                  (a.TypeProto = (function () {
                    function e(e) {
                      if (e)
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    var t;
                    return (
                      (e.prototype.tensorType = null),
                      (e.prototype.denotation = ``),
                      Object.defineProperty(e.prototype, `value`, {
                        get: l.oneOfGetter((t = [`tensorType`])),
                        set: l.oneOfSetter(t),
                      }),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        return (
                          (t ||= c.create()),
                          e.tensorType != null &&
                            e.hasOwnProperty(`tensorType`) &&
                            u.onnx.TypeProto.Tensor.encode(e.tensorType, t.uint32(10).fork()).ldelim(),
                          e.denotation != null && e.hasOwnProperty(`denotation`) && t.uint32(50).string(e.denotation),
                          t
                        );
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.TypeProto(); e.pos < n; ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              r.tensorType = u.onnx.TypeProto.Tensor.decode(e, e.uint32());
                              break;
                            case 6:
                              r.denotation = e.string();
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        if (typeof e != `object` || !e) return `object expected`;
                        if (e.tensorType != null && e.hasOwnProperty(`tensorType`)) {
                          var t = u.onnx.TypeProto.Tensor.verify(e.tensorType);
                          if (t) return `tensorType.` + t;
                        }
                        return e.denotation != null && e.hasOwnProperty(`denotation`) && !l.isString(e.denotation)
                          ? `denotation: string expected`
                          : null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.TypeProto) return e;
                        var t = new u.onnx.TypeProto();
                        if (e.tensorType != null) {
                          if (typeof e.tensorType != `object`)
                            throw TypeError(`.onnx.TypeProto.tensorType: object expected`);
                          t.tensorType = u.onnx.TypeProto.Tensor.fromObject(e.tensorType);
                        }
                        return (e.denotation != null && (t.denotation = String(e.denotation)), t);
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        return (
                          t.defaults && (n.denotation = ``),
                          e.tensorType != null &&
                            e.hasOwnProperty(`tensorType`) &&
                            ((n.tensorType = u.onnx.TypeProto.Tensor.toObject(e.tensorType, t)),
                            t.oneofs && (n.value = `tensorType`)),
                          e.denotation != null && e.hasOwnProperty(`denotation`) && (n.denotation = e.denotation),
                          n
                        );
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      (e.Tensor = (function () {
                        function e(e) {
                          if (e)
                            for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                              e[t[n]] != null && (this[t[n]] = e[t[n]]);
                        }
                        return (
                          (e.prototype.elemType = 0),
                          (e.prototype.shape = null),
                          (e.create = function (t) {
                            return new e(t);
                          }),
                          (e.encode = function (e, t) {
                            return (
                              (t ||= c.create()),
                              e.elemType != null && e.hasOwnProperty(`elemType`) && t.uint32(8).int32(e.elemType),
                              e.shape != null &&
                                e.hasOwnProperty(`shape`) &&
                                u.onnx.TensorShapeProto.encode(e.shape, t.uint32(18).fork()).ldelim(),
                              t
                            );
                          }),
                          (e.encodeDelimited = function (e, t) {
                            return this.encode(e, t).ldelim();
                          }),
                          (e.decode = function (e, t) {
                            e instanceof s || (e = s.create(e));
                            for (
                              var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.TypeProto.Tensor();
                              e.pos < n;
                            ) {
                              var i = e.uint32();
                              switch (i >>> 3) {
                                case 1:
                                  r.elemType = e.int32();
                                  break;
                                case 2:
                                  r.shape = u.onnx.TensorShapeProto.decode(e, e.uint32());
                                  break;
                                default:
                                  e.skipType(7 & i);
                              }
                            }
                            return r;
                          }),
                          (e.decodeDelimited = function (e) {
                            return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                          }),
                          (e.verify = function (e) {
                            if (typeof e != `object` || !e) return `object expected`;
                            if (e.elemType != null && e.hasOwnProperty(`elemType`) && !l.isInteger(e.elemType))
                              return `elemType: integer expected`;
                            if (e.shape != null && e.hasOwnProperty(`shape`)) {
                              var t = u.onnx.TensorShapeProto.verify(e.shape);
                              if (t) return `shape.` + t;
                            }
                            return null;
                          }),
                          (e.fromObject = function (e) {
                            if (e instanceof u.onnx.TypeProto.Tensor) return e;
                            var t = new u.onnx.TypeProto.Tensor();
                            if ((e.elemType != null && (t.elemType = 0 | e.elemType), e.shape != null)) {
                              if (typeof e.shape != `object`)
                                throw TypeError(`.onnx.TypeProto.Tensor.shape: object expected`);
                              t.shape = u.onnx.TensorShapeProto.fromObject(e.shape);
                            }
                            return t;
                          }),
                          (e.toObject = function (e, t) {
                            t ||= {};
                            var n = {};
                            return (
                              t.defaults && ((n.elemType = 0), (n.shape = null)),
                              e.elemType != null && e.hasOwnProperty(`elemType`) && (n.elemType = e.elemType),
                              e.shape != null &&
                                e.hasOwnProperty(`shape`) &&
                                (n.shape = u.onnx.TensorShapeProto.toObject(e.shape, t)),
                              n
                            );
                          }),
                          (e.prototype.toJSON = function () {
                            return this.constructor.toObject(this, o.util.toJSONOptions);
                          }),
                          e
                        );
                      })()),
                      e
                    );
                  })()),
                  (a.OperatorSetIdProto = (function () {
                    function e(e) {
                      if (e)
                        for (var t = Object.keys(e), n = 0; n < t.length; ++n)
                          e[t[n]] != null && (this[t[n]] = e[t[n]]);
                    }
                    return (
                      (e.prototype.domain = ``),
                      (e.prototype.version = l.Long ? l.Long.fromBits(0, 0, !1) : 0),
                      (e.create = function (t) {
                        return new e(t);
                      }),
                      (e.encode = function (e, t) {
                        return (
                          (t ||= c.create()),
                          e.domain != null && e.hasOwnProperty(`domain`) && t.uint32(10).string(e.domain),
                          e.version != null && e.hasOwnProperty(`version`) && t.uint32(16).int64(e.version),
                          t
                        );
                      }),
                      (e.encodeDelimited = function (e, t) {
                        return this.encode(e, t).ldelim();
                      }),
                      (e.decode = function (e, t) {
                        e instanceof s || (e = s.create(e));
                        for (
                          var n = t === void 0 ? e.len : e.pos + t, r = new u.onnx.OperatorSetIdProto();
                          e.pos < n;
                        ) {
                          var i = e.uint32();
                          switch (i >>> 3) {
                            case 1:
                              r.domain = e.string();
                              break;
                            case 2:
                              r.version = e.int64();
                              break;
                            default:
                              e.skipType(7 & i);
                          }
                        }
                        return r;
                      }),
                      (e.decodeDelimited = function (e) {
                        return (e instanceof s || (e = new s(e)), this.decode(e, e.uint32()));
                      }),
                      (e.verify = function (e) {
                        return typeof e != `object` || !e
                          ? `object expected`
                          : e.domain != null && e.hasOwnProperty(`domain`) && !l.isString(e.domain)
                            ? `domain: string expected`
                            : e.version != null &&
                                e.hasOwnProperty(`version`) &&
                                !(
                                  l.isInteger(e.version) ||
                                  (e.version && l.isInteger(e.version.low) && l.isInteger(e.version.high))
                                )
                              ? `version: integer|Long expected`
                              : null;
                      }),
                      (e.fromObject = function (e) {
                        if (e instanceof u.onnx.OperatorSetIdProto) return e;
                        var t = new u.onnx.OperatorSetIdProto();
                        return (
                          e.domain != null && (t.domain = String(e.domain)),
                          e.version != null &&
                            (l.Long
                              ? ((t.version = l.Long.fromValue(e.version)).unsigned = !1)
                              : typeof e.version == `string`
                                ? (t.version = parseInt(e.version, 10))
                                : typeof e.version == `number`
                                  ? (t.version = e.version)
                                  : typeof e.version == `object` &&
                                    (t.version = new l.LongBits(e.version.low >>> 0, e.version.high >>> 0).toNumber())),
                          t
                        );
                      }),
                      (e.toObject = function (e, t) {
                        t ||= {};
                        var n = {};
                        if (t.defaults)
                          if (((n.domain = ``), l.Long)) {
                            var r = new l.Long(0, 0, !1);
                            n.version = t.longs === String ? r.toString() : t.longs === Number ? r.toNumber() : r;
                          } else n.version = t.longs === String ? `0` : 0;
                        return (
                          e.domain != null && e.hasOwnProperty(`domain`) && (n.domain = e.domain),
                          e.version != null &&
                            e.hasOwnProperty(`version`) &&
                            (typeof e.version == `number`
                              ? (n.version = t.longs === String ? String(e.version) : e.version)
                              : (n.version =
                                  t.longs === String
                                    ? l.Long.prototype.toString.call(e.version)
                                    : t.longs === Number
                                      ? new l.LongBits(e.version.low >>> 0, e.version.high >>> 0).toNumber()
                                      : e.version)),
                          n
                        );
                      }),
                      (e.prototype.toJSON = function () {
                        return this.constructor.toObject(this, o.util.toJSONOptions);
                      }),
                      e
                    );
                  })()),
                  a)),
                  (e.exports = u));
              },
              2100: (e, t, n) => {
                'use strict';
                e.exports = n(9482);
              },
              9482: (e, t, n) => {
                'use strict';
                var r = t;
                function i() {
                  (r.util._configure(), r.Writer._configure(r.BufferWriter), r.Reader._configure(r.BufferReader));
                }
                ((r.build = `minimal`),
                  (r.Writer = n(1173)),
                  (r.BufferWriter = n(3155)),
                  (r.Reader = n(1408)),
                  (r.BufferReader = n(593)),
                  (r.util = n(9693)),
                  (r.rpc = n(5994)),
                  (r.roots = n(5054)),
                  (r.configure = i),
                  i());
              },
              1408: (e, t, n) => {
                'use strict';
                e.exports = c;
                var r,
                  i = n(9693),
                  a = i.LongBits,
                  o = i.utf8;
                function s(e, t) {
                  return RangeError(`index out of range: ` + e.pos + ` + ` + (t || 1) + ` > ` + e.len);
                }
                function c(e) {
                  ((this.buf = e), (this.pos = 0), (this.len = e.length));
                }
                var l,
                  u =
                    typeof Uint8Array < `u`
                      ? function (e) {
                          if (e instanceof Uint8Array || Array.isArray(e)) return new c(e);
                          throw Error(`illegal buffer`);
                        }
                      : function (e) {
                          if (Array.isArray(e)) return new c(e);
                          throw Error(`illegal buffer`);
                        },
                  d = function () {
                    return i.Buffer
                      ? function (e) {
                          return (c.create = function (e) {
                            return i.Buffer.isBuffer(e) ? new r(e) : u(e);
                          })(e);
                        }
                      : u;
                  };
                function f() {
                  var e = new a(0, 0),
                    t = 0;
                  if (!(this.len - this.pos > 4)) {
                    for (; t < 3; ++t) {
                      if (this.pos >= this.len) throw s(this);
                      if (((e.lo = (e.lo | ((127 & this.buf[this.pos]) << (7 * t))) >>> 0), this.buf[this.pos++] < 128))
                        return e;
                    }
                    return ((e.lo = (e.lo | ((127 & this.buf[this.pos++]) << (7 * t))) >>> 0), e);
                  }
                  for (; t < 4; ++t)
                    if (((e.lo = (e.lo | ((127 & this.buf[this.pos]) << (7 * t))) >>> 0), this.buf[this.pos++] < 128))
                      return e;
                  if (
                    ((e.lo = (e.lo | ((127 & this.buf[this.pos]) << 28)) >>> 0),
                    (e.hi = (e.hi | ((127 & this.buf[this.pos]) >> 4)) >>> 0),
                    this.buf[this.pos++] < 128)
                  )
                    return e;
                  if (((t = 0), this.len - this.pos > 4)) {
                    for (; t < 5; ++t)
                      if (
                        ((e.hi = (e.hi | ((127 & this.buf[this.pos]) << (7 * t + 3))) >>> 0),
                        this.buf[this.pos++] < 128)
                      )
                        return e;
                  } else
                    for (; t < 5; ++t) {
                      if (this.pos >= this.len) throw s(this);
                      if (
                        ((e.hi = (e.hi | ((127 & this.buf[this.pos]) << (7 * t + 3))) >>> 0),
                        this.buf[this.pos++] < 128)
                      )
                        return e;
                    }
                  throw Error(`invalid varint encoding`);
                }
                function p(e, t) {
                  return (e[t - 4] | (e[t - 3] << 8) | (e[t - 2] << 16) | (e[t - 1] << 24)) >>> 0;
                }
                function m() {
                  if (this.pos + 8 > this.len) throw s(this, 8);
                  return new a(p(this.buf, (this.pos += 4)), p(this.buf, (this.pos += 4)));
                }
                ((c.create = d()),
                  (c.prototype._slice = i.Array.prototype.subarray || i.Array.prototype.slice),
                  (c.prototype.uint32 =
                    ((l = 4294967295),
                    function () {
                      if (
                        ((l = (127 & this.buf[this.pos]) >>> 0),
                        this.buf[this.pos++] < 128 ||
                          ((l = (l | ((127 & this.buf[this.pos]) << 7)) >>> 0), this.buf[this.pos++] < 128) ||
                          ((l = (l | ((127 & this.buf[this.pos]) << 14)) >>> 0), this.buf[this.pos++] < 128) ||
                          ((l = (l | ((127 & this.buf[this.pos]) << 21)) >>> 0), this.buf[this.pos++] < 128) ||
                          ((l = (l | ((15 & this.buf[this.pos]) << 28)) >>> 0), this.buf[this.pos++] < 128))
                      )
                        return l;
                      if ((this.pos += 5) > this.len) throw ((this.pos = this.len), s(this, 10));
                      return l;
                    })),
                  (c.prototype.int32 = function () {
                    return 0 | this.uint32();
                  }),
                  (c.prototype.sint32 = function () {
                    var e = this.uint32();
                    return ((e >>> 1) ^ -(1 & e)) | 0;
                  }),
                  (c.prototype.bool = function () {
                    return this.uint32() !== 0;
                  }),
                  (c.prototype.fixed32 = function () {
                    if (this.pos + 4 > this.len) throw s(this, 4);
                    return p(this.buf, (this.pos += 4));
                  }),
                  (c.prototype.sfixed32 = function () {
                    if (this.pos + 4 > this.len) throw s(this, 4);
                    return 0 | p(this.buf, (this.pos += 4));
                  }),
                  (c.prototype.float = function () {
                    if (this.pos + 4 > this.len) throw s(this, 4);
                    var e = i.float.readFloatLE(this.buf, this.pos);
                    return ((this.pos += 4), e);
                  }),
                  (c.prototype.double = function () {
                    if (this.pos + 8 > this.len) throw s(this, 4);
                    var e = i.float.readDoubleLE(this.buf, this.pos);
                    return ((this.pos += 8), e);
                  }),
                  (c.prototype.bytes = function () {
                    var e = this.uint32(),
                      t = this.pos,
                      n = this.pos + e;
                    if (n > this.len) throw s(this, e);
                    return (
                      (this.pos += e),
                      Array.isArray(this.buf)
                        ? this.buf.slice(t, n)
                        : t === n
                          ? new this.buf.constructor(0)
                          : this._slice.call(this.buf, t, n)
                    );
                  }),
                  (c.prototype.string = function () {
                    var e = this.bytes();
                    return o.read(e, 0, e.length);
                  }),
                  (c.prototype.skip = function (e) {
                    if (typeof e == `number`) {
                      if (this.pos + e > this.len) throw s(this, e);
                      this.pos += e;
                    } else
                      do if (this.pos >= this.len) throw s(this);
                      while (128 & this.buf[this.pos++]);
                    return this;
                  }),
                  (c.prototype.skipType = function (e) {
                    switch (e) {
                      case 0:
                        this.skip();
                        break;
                      case 1:
                        this.skip(8);
                        break;
                      case 2:
                        this.skip(this.uint32());
                        break;
                      case 3:
                        for (; (e = 7 & this.uint32()) != 4; ) this.skipType(e);
                        break;
                      case 5:
                        this.skip(4);
                        break;
                      default:
                        throw Error(`invalid wire type ` + e + ` at offset ` + this.pos);
                    }
                    return this;
                  }),
                  (c._configure = function (e) {
                    ((r = e), (c.create = d()), r._configure());
                    var t = i.Long ? `toLong` : `toNumber`;
                    i.merge(c.prototype, {
                      int64: function () {
                        return f.call(this)[t](!1);
                      },
                      uint64: function () {
                        return f.call(this)[t](!0);
                      },
                      sint64: function () {
                        return f.call(this).zzDecode()[t](!1);
                      },
                      fixed64: function () {
                        return m.call(this)[t](!0);
                      },
                      sfixed64: function () {
                        return m.call(this)[t](!1);
                      },
                    });
                  }));
              },
              593: (e, t, n) => {
                'use strict';
                e.exports = a;
                var r = n(1408);
                (a.prototype = Object.create(r.prototype)).constructor = a;
                var i = n(9693);
                function a(e) {
                  r.call(this, e);
                }
                ((a._configure = function () {
                  i.Buffer && (a.prototype._slice = i.Buffer.prototype.slice);
                }),
                  (a.prototype.string = function () {
                    var e = this.uint32();
                    return this.buf.utf8Slice
                      ? this.buf.utf8Slice(this.pos, (this.pos = Math.min(this.pos + e, this.len)))
                      : this.buf.toString(`utf-8`, this.pos, (this.pos = Math.min(this.pos + e, this.len)));
                  }),
                  a._configure());
              },
              5054: (e) => {
                'use strict';
                e.exports = {};
              },
              5994: (e, t, n) => {
                'use strict';
                t.Service = n(7948);
              },
              7948: (e, t, n) => {
                'use strict';
                e.exports = i;
                var r = n(9693);
                function i(e, t, n) {
                  if (typeof e != `function`) throw TypeError(`rpcImpl must be a function`);
                  (r.EventEmitter.call(this),
                    (this.rpcImpl = e),
                    (this.requestDelimited = !!t),
                    (this.responseDelimited = !!n));
                }
                (((i.prototype = Object.create(r.EventEmitter.prototype)).constructor = i),
                  (i.prototype.rpcCall = function e(t, n, i, a, o) {
                    if (!a) throw TypeError(`request must be specified`);
                    var s = this;
                    if (!o) return r.asPromise(e, s, t, n, i, a);
                    if (s.rpcImpl)
                      try {
                        return s.rpcImpl(
                          t,
                          n[s.requestDelimited ? `encodeDelimited` : `encode`](a).finish(),
                          function (e, n) {
                            if (e) return (s.emit(`error`, e, t), o(e));
                            if (n !== null) {
                              if (!(n instanceof i))
                                try {
                                  n = i[s.responseDelimited ? `decodeDelimited` : `decode`](n);
                                } catch (e) {
                                  return (s.emit(`error`, e, t), o(e));
                                }
                              return (s.emit(`data`, n, t), o(null, n));
                            }
                            s.end(!0);
                          },
                        );
                      } catch (e) {
                        (s.emit(`error`, e, t),
                          setTimeout(function () {
                            o(e);
                          }, 0));
                        return;
                      }
                    else
                      setTimeout(function () {
                        o(Error(`already ended`));
                      }, 0);
                  }),
                  (i.prototype.end = function (e) {
                    return (
                      this.rpcImpl &&
                        (e || this.rpcImpl(null, null, null), (this.rpcImpl = null), this.emit(`end`).off()),
                      this
                    );
                  }));
              },
              1945: (e, t, n) => {
                'use strict';
                e.exports = i;
                var r = n(9693);
                function i(e, t) {
                  ((this.lo = e >>> 0), (this.hi = t >>> 0));
                }
                var a = (i.zero = new i(0, 0));
                ((a.toNumber = function () {
                  return 0;
                }),
                  (a.zzEncode = a.zzDecode =
                    function () {
                      return this;
                    }),
                  (a.length = function () {
                    return 1;
                  }));
                var o = (i.zeroHash = `\0\0\0\0\0\0\0\0`);
                ((i.fromNumber = function (e) {
                  if (e === 0) return a;
                  var t = e < 0;
                  t && (e = -e);
                  var n = e >>> 0,
                    r = ((e - n) / 4294967296) >>> 0;
                  return (
                    t && ((r = ~r >>> 0), (n = ~n >>> 0), ++n > 4294967295 && ((n = 0), ++r > 4294967295 && (r = 0))),
                    new i(n, r)
                  );
                }),
                  (i.from = function (e) {
                    if (typeof e == `number`) return i.fromNumber(e);
                    if (r.isString(e)) {
                      if (!r.Long) return i.fromNumber(parseInt(e, 10));
                      e = r.Long.fromString(e);
                    }
                    return e.low || e.high ? new i(e.low >>> 0, e.high >>> 0) : a;
                  }),
                  (i.prototype.toNumber = function (e) {
                    if (!e && this.hi >>> 31) {
                      var t = (1 + ~this.lo) >>> 0,
                        n = ~this.hi >>> 0;
                      return (t || (n = (n + 1) >>> 0), -(t + 4294967296 * n));
                    }
                    return this.lo + 4294967296 * this.hi;
                  }),
                  (i.prototype.toLong = function (e) {
                    return r.Long
                      ? new r.Long(0 | this.lo, 0 | this.hi, !!e)
                      : { low: 0 | this.lo, high: 0 | this.hi, unsigned: !!e };
                  }));
                var s = String.prototype.charCodeAt;
                ((i.fromHash = function (e) {
                  return e === o
                    ? a
                    : new i(
                        (s.call(e, 0) | (s.call(e, 1) << 8) | (s.call(e, 2) << 16) | (s.call(e, 3) << 24)) >>> 0,
                        (s.call(e, 4) | (s.call(e, 5) << 8) | (s.call(e, 6) << 16) | (s.call(e, 7) << 24)) >>> 0,
                      );
                }),
                  (i.prototype.toHash = function () {
                    return String.fromCharCode(
                      255 & this.lo,
                      (this.lo >>> 8) & 255,
                      (this.lo >>> 16) & 255,
                      this.lo >>> 24,
                      255 & this.hi,
                      (this.hi >>> 8) & 255,
                      (this.hi >>> 16) & 255,
                      this.hi >>> 24,
                    );
                  }),
                  (i.prototype.zzEncode = function () {
                    var e = this.hi >> 31;
                    return (
                      (this.hi = (((this.hi << 1) | (this.lo >>> 31)) ^ e) >>> 0),
                      (this.lo = ((this.lo << 1) ^ e) >>> 0),
                      this
                    );
                  }),
                  (i.prototype.zzDecode = function () {
                    var e = -(1 & this.lo);
                    return (
                      (this.lo = (((this.lo >>> 1) | (this.hi << 31)) ^ e) >>> 0),
                      (this.hi = ((this.hi >>> 1) ^ e) >>> 0),
                      this
                    );
                  }),
                  (i.prototype.length = function () {
                    var e = this.lo,
                      t = ((this.lo >>> 28) | (this.hi << 4)) >>> 0,
                      n = this.hi >>> 24;
                    return n === 0
                      ? t === 0
                        ? e < 16384
                          ? e < 128
                            ? 1
                            : 2
                          : e < 2097152
                            ? 3
                            : 4
                        : t < 16384
                          ? t < 128
                            ? 5
                            : 6
                          : t < 2097152
                            ? 7
                            : 8
                      : n < 128
                        ? 9
                        : 10;
                  }));
              },
              9693: function (e, t, n) {
                'use strict';
                var r = t;
                function i(e, t, n) {
                  for (var r = Object.keys(t), i = 0; i < r.length; ++i)
                    (e[r[i]] !== void 0 && n) || (e[r[i]] = t[r[i]]);
                  return e;
                }
                function a(e) {
                  function t(e, n) {
                    if (!(this instanceof t)) return new t(e, n);
                    (Object.defineProperty(this, `message`, {
                      get: function () {
                        return e;
                      },
                    }),
                      Error.captureStackTrace
                        ? Error.captureStackTrace(this, t)
                        : Object.defineProperty(this, `stack`, { value: Error().stack || `` }),
                      n && i(this, n));
                  }
                  return (
                    ((t.prototype = Object.create(Error.prototype)).constructor = t),
                    Object.defineProperty(t.prototype, `name`, {
                      get: function () {
                        return e;
                      },
                    }),
                    (t.prototype.toString = function () {
                      return this.name + `: ` + this.message;
                    }),
                    t
                  );
                }
                ((r.asPromise = n(4537)),
                  (r.base64 = n(7419)),
                  (r.EventEmitter = n(9211)),
                  (r.float = n(945)),
                  (r.inquire = n(7199)),
                  (r.utf8 = n(4997)),
                  (r.pool = n(6662)),
                  (r.LongBits = n(1945)),
                  (r.isNode = !!(
                    n.g !== void 0 &&
                    n.g &&
                    n.g.process &&
                    n.g.process.versions &&
                    n.g.process.versions.node
                  )),
                  (r.global =
                    (r.isNode && n.g) || (typeof window < `u` && window) || (typeof self < `u` && self) || this),
                  (r.emptyArray = Object.freeze ? Object.freeze([]) : []),
                  (r.emptyObject = Object.freeze ? Object.freeze({}) : {}),
                  (r.isInteger =
                    Number.isInteger ||
                    function (e) {
                      return typeof e == `number` && isFinite(e) && Math.floor(e) === e;
                    }),
                  (r.isString = function (e) {
                    return typeof e == `string` || e instanceof String;
                  }),
                  (r.isObject = function (e) {
                    return e && typeof e == `object`;
                  }),
                  (r.isset = r.isSet =
                    function (e, t) {
                      var n = e[t];
                      return (
                        !(n == null || !e.hasOwnProperty(t)) &&
                        (typeof n != `object` || (Array.isArray(n) ? n.length : Object.keys(n).length) > 0)
                      );
                    }),
                  (r.Buffer = (function () {
                    try {
                      var e = r.inquire(`buffer`).Buffer;
                      return e.prototype.utf8Write ? e : null;
                    } catch {
                      return null;
                    }
                  })()),
                  (r._Buffer_from = null),
                  (r._Buffer_allocUnsafe = null),
                  (r.newBuffer = function (e) {
                    return typeof e == `number`
                      ? r.Buffer
                        ? r._Buffer_allocUnsafe(e)
                        : new r.Array(e)
                      : r.Buffer
                        ? r._Buffer_from(e)
                        : typeof Uint8Array > `u`
                          ? e
                          : new Uint8Array(e);
                  }),
                  (r.Array = typeof Uint8Array < `u` ? Uint8Array : Array),
                  (r.Long = (r.global.dcodeIO && r.global.dcodeIO.Long) || r.global.Long || r.inquire(`long`)),
                  (r.key2Re = /^true|false|0|1$/),
                  (r.key32Re = /^-?(?:0|[1-9][0-9]*)$/),
                  (r.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/),
                  (r.longToHash = function (e) {
                    return e ? r.LongBits.from(e).toHash() : r.LongBits.zeroHash;
                  }),
                  (r.longFromHash = function (e, t) {
                    var n = r.LongBits.fromHash(e);
                    return r.Long ? r.Long.fromBits(n.lo, n.hi, t) : n.toNumber(!!t);
                  }),
                  (r.merge = i),
                  (r.lcFirst = function (e) {
                    return e.charAt(0).toLowerCase() + e.substring(1);
                  }),
                  (r.newError = a),
                  (r.ProtocolError = a(`ProtocolError`)),
                  (r.oneOfGetter = function (e) {
                    for (var t = {}, n = 0; n < e.length; ++n) t[e[n]] = 1;
                    return function () {
                      for (var e = Object.keys(this), n = e.length - 1; n > -1; --n)
                        if (t[e[n]] === 1 && this[e[n]] !== void 0 && this[e[n]] !== null) return e[n];
                    };
                  }),
                  (r.oneOfSetter = function (e) {
                    return function (t) {
                      for (var n = 0; n < e.length; ++n) e[n] !== t && delete this[e[n]];
                    };
                  }),
                  (r.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }),
                  (r._configure = function () {
                    var e = r.Buffer;
                    e
                      ? ((r._Buffer_from =
                          (e.from !== Uint8Array.from && e.from) ||
                          function (t, n) {
                            return new e(t, n);
                          }),
                        (r._Buffer_allocUnsafe =
                          e.allocUnsafe ||
                          function (t) {
                            return new e(t);
                          }))
                      : (r._Buffer_from = r._Buffer_allocUnsafe = null);
                  }));
              },
              1173: (e, t, n) => {
                'use strict';
                e.exports = d;
                var r,
                  i = n(9693),
                  a = i.LongBits,
                  o = i.base64,
                  s = i.utf8;
                function c(e, t, n) {
                  ((this.fn = e), (this.len = t), (this.next = void 0), (this.val = n));
                }
                function l() {}
                function u(e) {
                  ((this.head = e.head), (this.tail = e.tail), (this.len = e.len), (this.next = e.states));
                }
                function d() {
                  ((this.len = 0), (this.head = new c(l, 0, 0)), (this.tail = this.head), (this.states = null));
                }
                var f = function () {
                  return i.Buffer
                    ? function () {
                        return (d.create = function () {
                          return new r();
                        })();
                      }
                    : function () {
                        return new d();
                      };
                };
                function p(e, t, n) {
                  t[n] = 255 & e;
                }
                function m(e, t) {
                  ((this.len = e), (this.next = void 0), (this.val = t));
                }
                function h(e, t, n) {
                  for (; e.hi; )
                    ((t[n++] = (127 & e.lo) | 128), (e.lo = ((e.lo >>> 7) | (e.hi << 25)) >>> 0), (e.hi >>>= 7));
                  for (; e.lo > 127; ) ((t[n++] = (127 & e.lo) | 128), (e.lo >>>= 7));
                  t[n++] = e.lo;
                }
                function g(e, t, n) {
                  ((t[n] = 255 & e),
                    (t[n + 1] = (e >>> 8) & 255),
                    (t[n + 2] = (e >>> 16) & 255),
                    (t[n + 3] = e >>> 24));
                }
                ((d.create = f()),
                  (d.alloc = function (e) {
                    return new i.Array(e);
                  }),
                  i.Array !== Array && (d.alloc = i.pool(d.alloc, i.Array.prototype.subarray)),
                  (d.prototype._push = function (e, t, n) {
                    return ((this.tail = this.tail.next = new c(e, t, n)), (this.len += t), this);
                  }),
                  (m.prototype = Object.create(c.prototype)),
                  (m.prototype.fn = function (e, t, n) {
                    for (; e > 127; ) ((t[n++] = (127 & e) | 128), (e >>>= 7));
                    t[n] = e;
                  }),
                  (d.prototype.uint32 = function (e) {
                    return (
                      (this.len += (this.tail = this.tail.next =
                        new m((e >>>= 0) < 128 ? 1 : e < 16384 ? 2 : e < 2097152 ? 3 : e < 268435456 ? 4 : 5, e)).len),
                      this
                    );
                  }),
                  (d.prototype.int32 = function (e) {
                    return e < 0 ? this._push(h, 10, a.fromNumber(e)) : this.uint32(e);
                  }),
                  (d.prototype.sint32 = function (e) {
                    return this.uint32(((e << 1) ^ (e >> 31)) >>> 0);
                  }),
                  (d.prototype.uint64 = function (e) {
                    var t = a.from(e);
                    return this._push(h, t.length(), t);
                  }),
                  (d.prototype.int64 = d.prototype.uint64),
                  (d.prototype.sint64 = function (e) {
                    var t = a.from(e).zzEncode();
                    return this._push(h, t.length(), t);
                  }),
                  (d.prototype.bool = function (e) {
                    return this._push(p, 1, +!!e);
                  }),
                  (d.prototype.fixed32 = function (e) {
                    return this._push(g, 4, e >>> 0);
                  }),
                  (d.prototype.sfixed32 = d.prototype.fixed32),
                  (d.prototype.fixed64 = function (e) {
                    var t = a.from(e);
                    return this._push(g, 4, t.lo)._push(g, 4, t.hi);
                  }),
                  (d.prototype.sfixed64 = d.prototype.fixed64),
                  (d.prototype.float = function (e) {
                    return this._push(i.float.writeFloatLE, 4, e);
                  }),
                  (d.prototype.double = function (e) {
                    return this._push(i.float.writeDoubleLE, 8, e);
                  }));
                var _ = i.Array.prototype.set
                  ? function (e, t, n) {
                      t.set(e, n);
                    }
                  : function (e, t, n) {
                      for (var r = 0; r < e.length; ++r) t[n + r] = e[r];
                    };
                ((d.prototype.bytes = function (e) {
                  var t = e.length >>> 0;
                  if (!t) return this._push(p, 1, 0);
                  if (i.isString(e)) {
                    var n = d.alloc((t = o.length(e)));
                    (o.decode(e, n, 0), (e = n));
                  }
                  return this.uint32(t)._push(_, t, e);
                }),
                  (d.prototype.string = function (e) {
                    var t = s.length(e);
                    return t ? this.uint32(t)._push(s.write, t, e) : this._push(p, 1, 0);
                  }),
                  (d.prototype.fork = function () {
                    return (
                      (this.states = new u(this)),
                      (this.head = this.tail = new c(l, 0, 0)),
                      (this.len = 0),
                      this
                    );
                  }),
                  (d.prototype.reset = function () {
                    return (
                      this.states
                        ? ((this.head = this.states.head),
                          (this.tail = this.states.tail),
                          (this.len = this.states.len),
                          (this.states = this.states.next))
                        : ((this.head = this.tail = new c(l, 0, 0)), (this.len = 0)),
                      this
                    );
                  }),
                  (d.prototype.ldelim = function () {
                    var e = this.head,
                      t = this.tail,
                      n = this.len;
                    return (
                      this.reset().uint32(n),
                      n && ((this.tail.next = e.next), (this.tail = t), (this.len += n)),
                      this
                    );
                  }),
                  (d.prototype.finish = function () {
                    for (var e = this.head.next, t = this.constructor.alloc(this.len), n = 0; e; )
                      (e.fn(e.val, t, n), (n += e.len), (e = e.next));
                    return t;
                  }),
                  (d._configure = function (e) {
                    ((r = e), (d.create = f()), r._configure());
                  }));
              },
              3155: (e, t, n) => {
                'use strict';
                e.exports = a;
                var r = n(1173);
                (a.prototype = Object.create(r.prototype)).constructor = a;
                var i = n(9693);
                function a() {
                  r.call(this);
                }
                function o(e, t, n) {
                  e.length < 40 ? i.utf8.write(e, t, n) : t.utf8Write ? t.utf8Write(e, n) : t.write(e, n);
                }
                ((a._configure = function () {
                  ((a.alloc = i._Buffer_allocUnsafe),
                    (a.writeBytesBuffer =
                      i.Buffer && i.Buffer.prototype instanceof Uint8Array && i.Buffer.prototype.set.name === `set`
                        ? function (e, t, n) {
                            t.set(e, n);
                          }
                        : function (e, t, n) {
                            if (e.copy) e.copy(t, n, 0, e.length);
                            else for (var r = 0; r < e.length; ) t[n++] = e[r++];
                          }));
                }),
                  (a.prototype.bytes = function (e) {
                    i.isString(e) && (e = i._Buffer_from(e, `base64`));
                    var t = e.length >>> 0;
                    return (this.uint32(t), t && this._push(a.writeBytesBuffer, t, e), this);
                  }),
                  (a.prototype.string = function (e) {
                    var t = i.Buffer.byteLength(e);
                    return (this.uint32(t), t && this._push(o, t, e), this);
                  }),
                  a._configure());
              },
              7714: (e, t, n) => {
                'use strict';
                t.R = void 0;
                let r = n(6919),
                  i = n(7448);
                t.R = new (class {
                  async init() {}
                  async createSessionHandler(e, t) {
                    let n = new r.Session(t);
                    return (await n.loadModel(e), new i.OnnxjsSessionHandler(n));
                  }
                })();
              },
              4200: (e, t, n) => {
                'use strict';
                t.c8 = t.rX = void 0;
                let r = n(1670),
                  i = n(5381),
                  a = n(2157),
                  o = n(2306);
                ((t.rX = () => {
                  if (
                    ((typeof r.env.wasm.initTimeout != `number` || r.env.wasm.initTimeout < 0) &&
                      (r.env.wasm.initTimeout = 0),
                    typeof r.env.wasm.simd != `boolean` && (r.env.wasm.simd = !0),
                    typeof r.env.wasm.proxy != `boolean` && (r.env.wasm.proxy = !1),
                    typeof r.env.wasm.numThreads != `number` ||
                      !Number.isInteger(r.env.wasm.numThreads) ||
                      r.env.wasm.numThreads <= 0)
                  ) {
                    let e = typeof navigator > `u` ? (0, i.cpus)().length : navigator.hardwareConcurrency;
                    r.env.wasm.numThreads = Math.min(4, Math.ceil((e || 1) / 2));
                  }
                }),
                  (t.c8 = new (class {
                    async init() {
                      ((0, t.rX)(), await (0, a.initWasm)());
                    }
                    async createSessionHandler(e, t) {
                      let n = new o.OnnxruntimeWebAssemblySessionHandler();
                      return (await n.loadModel(e, t), Promise.resolve(n));
                    }
                  })()));
              },
              6018: function (e, t, n) {
                'use strict';
                var r =
                    (this && this.__createBinding) ||
                    (Object.create
                      ? function (e, t, n, r) {
                          r === void 0 && (r = n);
                          var i = Object.getOwnPropertyDescriptor(t, n);
                          ((i && !(`get` in i ? !t.__esModule : i.writable || i.configurable)) ||
                            (i = {
                              enumerable: !0,
                              get: function () {
                                return t[n];
                              },
                            }),
                            Object.defineProperty(e, r, i));
                        }
                      : function (e, t, n, r) {
                          (r === void 0 && (r = n), (e[r] = t[n]));
                        }),
                  i =
                    (this && this.__exportStar) ||
                    function (e, t) {
                      for (var n in e) n === `default` || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
                    };
                (Object.defineProperty(t, `__esModule`, { value: !0 }), i(n(1670), t));
                let a = n(1670);
                {
                  let e = n(7714).R;
                  (0, a.registerBackend)(`webgl`, e, -10);
                }
                {
                  let e = n(4200).c8;
                  ((0, a.registerBackend)(`cpu`, e, 10),
                    (0, a.registerBackend)(`wasm`, e, 10),
                    (0, a.registerBackend)(`xnnpack`, e, 9));
                }
              },
              246: (e, t) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.createAttributeWithCacheKey = void 0));
                class n {
                  constructor(e) {
                    Object.assign(this, e);
                  }
                  get cacheKey() {
                    return (
                      (this._cacheKey ||= Object.getOwnPropertyNames(this)
                        .sort()
                        .map((e) => `${this[e]}`)
                        .join(`;`)),
                      this._cacheKey
                    );
                  }
                }
                t.createAttributeWithCacheKey = (e) => new n(e);
              },
              7778: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.Attribute = void 0));
                let r = n(1446),
                  i = n(9395),
                  a = n(9162),
                  o = n(2517);
                var s = i.onnxruntime.experimental.fbs;
                class c {
                  constructor(e) {
                    if (((this._attributes = new Map()), e != null)) {
                      for (let t of e)
                        t instanceof r.onnx.AttributeProto
                          ? this._attributes.set(t.name, [c.getValue(t), c.getType(t)])
                          : t instanceof s.Attribute && this._attributes.set(t.name(), [c.getValue(t), c.getType(t)]);
                      if (this._attributes.size < e.length) throw Error(`duplicated attribute names`);
                    }
                  }
                  set(e, t, n) {
                    this._attributes.set(e, [n, t]);
                  }
                  delete(e) {
                    this._attributes.delete(e);
                  }
                  getFloat(e, t) {
                    return this.get(e, `float`, t);
                  }
                  getInt(e, t) {
                    return this.get(e, `int`, t);
                  }
                  getString(e, t) {
                    return this.get(e, `string`, t);
                  }
                  getTensor(e, t) {
                    return this.get(e, `tensor`, t);
                  }
                  getFloats(e, t) {
                    return this.get(e, `floats`, t);
                  }
                  getInts(e, t) {
                    return this.get(e, `ints`, t);
                  }
                  getStrings(e, t) {
                    return this.get(e, `strings`, t);
                  }
                  getTensors(e, t) {
                    return this.get(e, `tensors`, t);
                  }
                  get(e, t, n) {
                    let r = this._attributes.get(e);
                    if (r === void 0) {
                      if (n !== void 0) return n;
                      throw Error(`required attribute not found: ${e}`);
                    }
                    if (r[1] !== t) throw Error(`type mismatch: expected ${t} but got ${r[1]}`);
                    return r[0];
                  }
                  static getType(e) {
                    let t = e instanceof r.onnx.AttributeProto ? e.type : e.type();
                    switch (t) {
                      case r.onnx.AttributeProto.AttributeType.FLOAT:
                        return `float`;
                      case r.onnx.AttributeProto.AttributeType.INT:
                        return `int`;
                      case r.onnx.AttributeProto.AttributeType.STRING:
                        return `string`;
                      case r.onnx.AttributeProto.AttributeType.TENSOR:
                        return `tensor`;
                      case r.onnx.AttributeProto.AttributeType.FLOATS:
                        return `floats`;
                      case r.onnx.AttributeProto.AttributeType.INTS:
                        return `ints`;
                      case r.onnx.AttributeProto.AttributeType.STRINGS:
                        return `strings`;
                      case r.onnx.AttributeProto.AttributeType.TENSORS:
                        return `tensors`;
                      default:
                        throw Error(`attribute type is not supported yet: ${r.onnx.AttributeProto.AttributeType[t]}`);
                    }
                  }
                  static getValue(e) {
                    let t = e instanceof r.onnx.AttributeProto ? e.type : e.type();
                    if (
                      t === r.onnx.AttributeProto.AttributeType.GRAPH ||
                      t === r.onnx.AttributeProto.AttributeType.GRAPHS
                    )
                      throw Error(`graph attribute is not supported yet`);
                    let n = this.getValueNoCheck(e);
                    if (t === r.onnx.AttributeProto.AttributeType.INT && o.LongUtil.isLong(n))
                      return o.LongUtil.longToNumber(n);
                    if (t === r.onnx.AttributeProto.AttributeType.INTS) {
                      let e = n,
                        t = Array(e.length);
                      for (let n = 0; n < e.length; n++) {
                        let r = e[n];
                        t[n] = o.LongUtil.longToNumber(r);
                      }
                      return t;
                    }
                    if (t === r.onnx.AttributeProto.AttributeType.TENSOR)
                      return e instanceof r.onnx.AttributeProto ? a.Tensor.fromProto(n) : a.Tensor.fromOrtTensor(n);
                    if (t === r.onnx.AttributeProto.AttributeType.TENSORS) {
                      if (e instanceof r.onnx.AttributeProto) return n.map((e) => a.Tensor.fromProto(e));
                      if (e instanceof s.Attribute) return n.map((e) => a.Tensor.fromOrtTensor(e));
                    }
                    if (t === r.onnx.AttributeProto.AttributeType.STRING && e instanceof r.onnx.AttributeProto) {
                      let e = n;
                      return (0, o.decodeUtf8String)(e);
                    }
                    return t === r.onnx.AttributeProto.AttributeType.STRINGS && e instanceof r.onnx.AttributeProto
                      ? n.map(o.decodeUtf8String)
                      : n;
                  }
                  static getValueNoCheck(e) {
                    return e instanceof r.onnx.AttributeProto
                      ? this.getValueNoCheckFromOnnxFormat(e)
                      : this.getValueNoCheckFromOrtFormat(e);
                  }
                  static getValueNoCheckFromOnnxFormat(e) {
                    switch (e.type) {
                      case r.onnx.AttributeProto.AttributeType.FLOAT:
                        return e.f;
                      case r.onnx.AttributeProto.AttributeType.INT:
                        return e.i;
                      case r.onnx.AttributeProto.AttributeType.STRING:
                        return e.s;
                      case r.onnx.AttributeProto.AttributeType.TENSOR:
                        return e.t;
                      case r.onnx.AttributeProto.AttributeType.GRAPH:
                        return e.g;
                      case r.onnx.AttributeProto.AttributeType.FLOATS:
                        return e.floats;
                      case r.onnx.AttributeProto.AttributeType.INTS:
                        return e.ints;
                      case r.onnx.AttributeProto.AttributeType.STRINGS:
                        return e.strings;
                      case r.onnx.AttributeProto.AttributeType.TENSORS:
                        return e.tensors;
                      case r.onnx.AttributeProto.AttributeType.GRAPHS:
                        return e.graphs;
                      default:
                        throw Error(`unsupported attribute type: ${r.onnx.AttributeProto.AttributeType[e.type]}`);
                    }
                  }
                  static getValueNoCheckFromOrtFormat(e) {
                    switch (e.type()) {
                      case s.AttributeType.FLOAT:
                        return e.f();
                      case s.AttributeType.INT:
                        return e.i();
                      case s.AttributeType.STRING:
                        return e.s();
                      case s.AttributeType.TENSOR:
                        return e.t();
                      case s.AttributeType.GRAPH:
                        return e.g();
                      case s.AttributeType.FLOATS:
                        return e.floatsArray();
                      case s.AttributeType.INTS: {
                        let t = [];
                        for (let n = 0; n < e.intsLength(); n++) t.push(e.ints(n));
                        return t;
                      }
                      case s.AttributeType.STRINGS: {
                        let t = [];
                        for (let n = 0; n < e.stringsLength(); n++) t.push(e.strings(n));
                        return t;
                      }
                      case s.AttributeType.TENSORS: {
                        let t = [];
                        for (let n = 0; n < e.tensorsLength(); n++) t.push(e.tensors(n));
                        return t;
                      }
                      default:
                        throw Error(`unsupported attribute type: ${s.AttributeType[e.type()]}`);
                    }
                  }
                }
                t.Attribute = c;
              },
              7091: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.resolveBackend = t.backend = void 0));
                let r = n(5038),
                  i = new Map();
                async function a(e) {
                  let n = t.backend;
                  if (
                    n[e] !== void 0 &&
                    (function (e) {
                      let t = e;
                      return (
                        `initialize` in t &&
                        typeof t.initialize == `function` &&
                        `createSessionHandler` in t &&
                        typeof t.createSessionHandler == `function` &&
                        `dispose` in t &&
                        typeof t.dispose == `function`
                      );
                    })(n[e])
                  ) {
                    let t = n[e],
                      r = t.initialize();
                    if ((typeof r == `object` && `then` in r && (r = await r), r)) return (i.set(e, t), t);
                  }
                }
                ((t.backend = { webgl: new r.WebGLBackend() }),
                  (t.resolveBackend = async function e(t) {
                    if (!t) return e([`webgl`]);
                    {
                      let e = typeof t == `string` ? [t] : t;
                      for (let t of e) {
                        let e = i.get(t);
                        if (e) return e;
                        let n = await a(t);
                        if (n) return n;
                      }
                    }
                    throw Error(`no available backend to use`);
                  }));
              },
              5038: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.WebGLBackend = void 0));
                let r = n(1670),
                  i = n(6231),
                  a = n(6416),
                  o = n(7305);
                t.WebGLBackend = class {
                  get contextId() {
                    return r.env.webgl.contextId;
                  }
                  set contextId(e) {
                    r.env.webgl.contextId = e;
                  }
                  get matmulMaxBatchSize() {
                    return r.env.webgl.matmulMaxBatchSize;
                  }
                  set matmulMaxBatchSize(e) {
                    r.env.webgl.matmulMaxBatchSize = e;
                  }
                  get textureCacheMode() {
                    return r.env.webgl.textureCacheMode;
                  }
                  set textureCacheMode(e) {
                    r.env.webgl.textureCacheMode = e;
                  }
                  get pack() {
                    return r.env.webgl.pack;
                  }
                  set pack(e) {
                    r.env.webgl.pack = e;
                  }
                  get async() {
                    return r.env.webgl.async;
                  }
                  set async(e) {
                    r.env.webgl.async = e;
                  }
                  initialize() {
                    try {
                      return (
                        (this.glContext = (0, o.createWebGLContext)(this.contextId)),
                        typeof this.matmulMaxBatchSize != `number` && (this.matmulMaxBatchSize = 16),
                        typeof this.textureCacheMode != `string` && (this.textureCacheMode = `full`),
                        typeof this.pack != `boolean` && (this.pack = !1),
                        typeof this.async != `boolean` && (this.async = !1),
                        i.Logger.setWithEnv(r.env),
                        i.Logger.verbose(
                          `WebGLBackend`,
                          `Created WebGLContext: ${typeof this.glContext} with matmulMaxBatchSize: ${this.matmulMaxBatchSize}; textureCacheMode: ${this.textureCacheMode}; pack: ${this.pack}; async: ${this.async}.`,
                        ),
                        !0
                      );
                    } catch (e) {
                      return (i.Logger.warning(`WebGLBackend`, `Unable to initialize WebGLBackend. ${e}`), !1);
                    }
                  }
                  createSessionHandler(e) {
                    return new a.WebGLSessionHandler(this, e);
                  }
                  dispose() {
                    this.glContext.dispose();
                  }
                };
              },
              5107: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.CoordsGlslLib = void 0));
                let r = n(2517),
                  i = n(8520),
                  a = n(5060),
                  o = n(7859),
                  s = n(9390);
                class c extends i.GlslLib {
                  constructor(e) {
                    super(e);
                  }
                  getFunctions() {
                    return Object.assign(
                      Object.assign(
                        Object.assign(
                          Object.assign(
                            Object.assign(
                              Object.assign(Object.assign({}, this.offsetToCoords()), this.coordsToOffset()),
                              this.toVec(),
                            ),
                            this.valueFrom(),
                          ),
                          this.getCommonUtilFuncs(),
                        ),
                        this.getInputsSamplingSnippets(),
                      ),
                      this.getOutputSamplingSnippet(),
                    );
                  }
                  getCustomTypes() {
                    return {};
                  }
                  offsetToCoords() {
                    return {
                      offsetToCoords: new i.GlslLibRoutine(`
      vec2 offsetToCoords(int offset, int width, int height) {
        int t = offset / width;
        int s = offset - t*width;
        vec2 coords = (vec2(s,t) + vec2(0.5,0.5)) / vec2(width, height);
        return coords;
      }
      `),
                    };
                  }
                  coordsToOffset() {
                    return {
                      coordsToOffset: new i.GlslLibRoutine(`
      int coordsToOffset(vec2 coords, int width, int height) {
        float s = coords.s * float(width);
        float t = coords.t * float(height);
        int offset = int(t) * width + int(s);
        return offset;
      }
      `),
                    };
                  }
                  getOutputSamplingSnippet() {
                    let e = this.context.outputTextureLayout;
                    return e.isPacked
                      ? this.getPackedOutputSamplingSnippet(e)
                      : this.getUnpackedOutputSamplingSnippet(e);
                  }
                  getPackedOutputSamplingSnippet(e) {
                    let t = e.unpackedShape,
                      n = [e.width, e.height],
                      r = {},
                      o = `getOutputCoords`;
                    switch (t.length) {
                      case 0:
                        r[o] = this.getOutputScalarCoords();
                        break;
                      case 1:
                        r[o] = this.getOutputPacked1DCoords(t, n);
                        break;
                      case 2:
                        r[o] = this.getOutputPacked2DCoords(t, n);
                        break;
                      case 3:
                        r[o] = this.getOutputPacked3DCoords(t, n);
                        break;
                      default:
                        r[o] = this.getOutputPackedNDCoords(t, n);
                    }
                    let s = `\n      void setOutput(vec4 val) {\n        ${(0, a.getGlsl)(this.context.glContext.version).output} = val;\n      }\n    `;
                    return ((r.floatTextureSetRGBA = new i.GlslLibRoutine(s)), r);
                  }
                  getUnpackedOutputSamplingSnippet(e) {
                    let t = e.unpackedShape,
                      n = [e.width, e.height],
                      r = {},
                      o = `getOutputCoords`;
                    switch (t.length) {
                      case 0:
                        r[o] = this.getOutputScalarCoords();
                        break;
                      case 1:
                        r[o] = this.getOutputUnpacked1DCoords(t, n);
                        break;
                      case 2:
                        r[o] = this.getOutputUnpacked2DCoords(t, n);
                        break;
                      case 3:
                        r[o] = this.getOutputUnpacked3DCoords(t, n);
                        break;
                      case 4:
                        r[o] = this.getOutputUnpacked4DCoords(t, n);
                        break;
                      case 5:
                        r[o] = this.getOutputUnpacked5DCoords(t, n);
                        break;
                      case 6:
                        r[o] = this.getOutputUnpacked6DCoords(t, n);
                        break;
                      default:
                        throw Error(`Unsupported output dimensionality: ${t.length}`);
                    }
                    let s = `\n        void setOutput(float val) {\n          ${(0, a.getGlsl)(this.context.glContext.version).output} = vec4(val, 0, 0, 0);\n        }\n    `;
                    return ((r.floatTextureSetR = new i.GlslLibRoutine(s)), r);
                  }
                  getOutputScalarCoords() {
                    return new i.GlslLibRoutine(`
      int getOutputCoords() {
        return 0;
      }
    `);
                  }
                  getOutputPacked1DCoords(e, t) {
                    let n = t,
                      r = ``;
                    return n[0] === 1
                      ? ((r = `\n          int getOutputCoords() {\n            return 2 * int(TexCoords.y * ${n[1]}.0);\n          }\n        `),
                        new i.GlslLibRoutine(r))
                      : n[1] === 1
                        ? ((r = `\n          int getOutputCoords() {\n            return 2 * int(TexCoords.x * ${n[0]}.0);\n          }\n        `),
                          new i.GlslLibRoutine(r))
                        : ((r = `\n        int getOutputCoords() {\n          ivec2 resTexRC = ivec2(TexCoords.xy *\n                                 vec2(${n[0]}, ${n[1]}));\n          return 2 * (resTexRC.y * ${n[0]} + resTexRC.x);\n        }\n      `),
                          new i.GlslLibRoutine(r));
                  }
                  getOutputPacked2DCoords(e, t) {
                    let n = ``;
                    if (r.ArrayUtil.arraysEqual(e, t))
                      return (
                        (n = `\n        ivec2 getOutputCoords() {\n          return 2 * ivec2(TexCoords.xy * vec2(${t[0]}, ${t[1]}));\n        }\n      `),
                        new i.GlslLibRoutine(n)
                      );
                    let a = t,
                      o = Math.ceil(e[1] / 2);
                    return (
                      (n = `\n        ivec2 getOutputCoords() {\n          ivec2 resTexRC = ivec2(TexCoords.xy *\n                                vec2(${a[0]}, ${a[1]}));\n\n          int index = resTexRC.y * ${a[0]} + resTexRC.x;\n\n          // reverse r and c order for packed texture\n          int r = imod(index, ${o}) * 2;\n          int c = 2 * (index / ${o});\n\n          return ivec2(r, c);\n        }\n      `),
                      new i.GlslLibRoutine(n)
                    );
                  }
                  getOutputPacked3DCoords(e, t) {
                    let n = [t[0], t[1]],
                      r = Math.ceil(e[2] / 2),
                      a = r * Math.ceil(e[1] / 2),
                      o = `\n        ivec3 getOutputCoords() {\n          ivec2 resTexRC = ivec2(TexCoords.xy *\n                                vec2(${n[0]}, ${n[1]}));\n          int index = resTexRC.y * ${n[0]} + resTexRC.x;\n\n          int b = index / ${a};\n          index -= b * ${a};\n\n          // reverse r and c order for packed texture\n          int r = imod(index, ${r}) * 2;\n          int c = 2 * (index / ${r});\n\n          return ivec3(b, r, c);\n        }\n      `;
                    return new i.GlslLibRoutine(o);
                  }
                  getOutputPackedNDCoords(e, t) {
                    let n = [t[0], t[1]],
                      r = Math.ceil(e[e.length - 1] / 2),
                      a = r * Math.ceil(e[e.length - 2] / 2),
                      o = a,
                      s = ``,
                      c = `b, r, c`;
                    for (let t = 2; t < e.length - 1; t++)
                      ((o *= e[e.length - t - 1]),
                        (s = `\n      int b${t} = index / ${o};\n      index -= b${t} * ${o};\n    ` + s),
                        (c = `b${t}, ` + c));
                    let l = `\n      ivec${e.length} getOutputCoords() {\n        ivec2 resTexRC = ivec2(TexCoords.xy *\n                              vec2(${n[0]}, ${n[1]}));\n        int index = resTexRC.y * ${n[0]} + resTexRC.x;\n\n        ${s}\n\n        int b = index / ${a};\n        index -= b * ${a};\n\n        // reverse r and c order for packed texture\n        int r = imod(index, ${r}) * 2;\n        int c = 2 * (index / ${r});\n\n        return ivec${e.length}(${c});\n      }\n    `;
                    return new i.GlslLibRoutine(l);
                  }
                  getOutputUnpacked1DCoords(e, t) {
                    let n = `\n        int getOutputCoords() {\n          ivec2 resTexRC = ivec2(TexCoords.xy *\n                                vec2(${t[0]}, ${t[1]}));\n          return resTexRC.y * ${t[0]} + resTexRC.x;\n        }\n      `;
                    return new i.GlslLibRoutine(n);
                  }
                  getOutputUnpacked2DCoords(e, t) {
                    let n = `\n        ivec2 getOutputCoords() {\n          ivec2 resTexRC = ivec2(TexCoords.xy *\n                                vec2(${t[0]}, ${t[1]}));\n          int index = resTexRC.y * ${t[0]} + resTexRC.x;\n          int r = index / ${e[1]};\n          int c = index - r * ${e[1]};\n          return ivec2(r, c);\n        }\n      `;
                    return new i.GlslLibRoutine(n);
                  }
                  getOutputUnpacked3DCoords(e, t) {
                    let n = ``,
                      r = e.length,
                      a = null;
                    (r < 2 && (a = []), (a = Array(r - 1)), (a[r - 2] = e[r - 1]));
                    for (let t = r - 3; t >= 0; --t) a[t] = a[t + 1] * e[t + 1];
                    let o = [`r`, `c`, `d`],
                      s = a
                        .map(
                          (e, t) =>
                            `int ${o[t]} = index / ${e}; ${t === a.length - 1 ? `int ${o[t + 1]} = index - ${o[t]} * ${e}` : `index -= ${o[t]} * ${e}`};`,
                        )
                        .join(``);
                    return (
                      (n = `\n        ivec3 getOutputCoords() {\n          ivec2 resTexRC = ivec2(TexCoords.xy *\n                                vec2(${t[0]}, ${t[1]}));\n          int index = resTexRC.y * ${t[0]} + resTexRC.x;\n          ${s}\n          return ivec3(r, c, d);\n        }\n      `),
                      new i.GlslLibRoutine(n)
                    );
                  }
                  getOutputUnpacked4DCoords(e, t) {
                    let n = ``,
                      r = e.length,
                      a = null;
                    (r < 2 && (a = []), (a = Array(r - 1)), (a[r - 2] = e[r - 1]));
                    for (let t = r - 3; t >= 0; --t) a[t] = a[t + 1] * e[t + 1];
                    let o = [`r`, `c`, `d`, `d2`],
                      s = a
                        .map(
                          (e, t) =>
                            `int ${o[t]} = index / ${e}; ${t === a.length - 1 ? `int ${o[t + 1]} = index - ${o[t]} * ${e}` : `index -= ${o[t]} * ${e}`};`,
                        )
                        .join(``);
                    return (
                      (n = `\n      ivec4 getOutputCoords() {\n          ivec2 resTexRC = ivec2(TexCoords.xy *\n                                vec2(${t[0]}, ${t[1]}));\n          int index = resTexRC.y * ${t[0]} + resTexRC.x;\n          ${s}\n          return ivec4(r, c, d, d2);\n        }\n      `),
                      new i.GlslLibRoutine(n)
                    );
                  }
                  getOutputUnpacked5DCoords(e, t) {
                    let n = ``,
                      r = e.length,
                      a = null;
                    (r < 2 && (a = []), (a = Array(r - 1)), (a[r - 2] = e[r - 1]));
                    for (let t = r - 3; t >= 0; --t) a[t] = a[t + 1] * e[t + 1];
                    let o = [`r`, `c`, `d`, `d2`, `d3`],
                      s = a
                        .map(
                          (e, t) =>
                            `int ${o[t]} = index / ${e}; ${t === a.length - 1 ? `int ${o[t + 1]} = index - ${o[t]} * ${e}` : `index -= ${o[t]} * ${e}`};`,
                        )
                        .join(``);
                    return (
                      (n = `\n      ivec5 getOutputCoords() {\n          ivec2 resTexRC = ivec2(TexCoords.xy *\n                                vec2(${t[0]}, ${t[1]}));\n          int index = resTexRC.y * ${t[0]} + resTexRC.x;\n          ${s}\n          return ivec5(r, c, d, d2, d3);\n        }\n      `),
                      new i.GlslLibRoutine(n)
                    );
                  }
                  getOutputUnpacked6DCoords(e, t) {
                    let n = ``,
                      r = e.length,
                      a = null;
                    (r < 2 && (a = []), (a = Array(r - 1)), (a[r - 2] = e[r - 1]));
                    for (let t = r - 3; t >= 0; --t) a[t] = a[t + 1] * e[t + 1];
                    let o = [`r`, `c`, `d`, `d2`, `d3`, `d4`],
                      s = a
                        .map(
                          (e, t) =>
                            `int ${o[t]} = index / ${e}; ${t === a.length - 1 ? `int ${o[t + 1]} = index - ${o[t]} * ${e}` : `index -= ${o[t]} * ${e}`};`,
                        )
                        .join(``);
                    return (
                      (n = `\n     ivec6 getOutputCoords() {\n         ivec2 resTexRC = ivec2(TexCoords.xy *\n                               vec2(${t[0]}, ${t[1]}));\n         int index = resTexRC.y * ${t[0]} + resTexRC.x;\n         ${s}\n         return ivec6(r, c, d, d2, d3, d4);\n       }\n     `),
                      new i.GlslLibRoutine(n)
                    );
                  }
                  getCommonUtilFuncs() {
                    let e = {},
                      t = `uvFromFlat`;
                    ((e[t] = new i.GlslLibRoutine(`
    vec2 uvFromFlat(int texNumR, int texNumC, int index) {
      int texC = index / texNumR;
      int texR = index - texC * texNumR;
      // TODO: swap texR, texC order in following function so row is corresponding to u and column is corresponding to
      //       v.
      return (vec2(texR, texC) + halfCR) / vec2(texNumR, texNumC);
    }
    `)),
                      (t = `packedUVfrom1D`),
                      (e[t] = new i.GlslLibRoutine(`
      vec2 packedUVfrom1D(int texNumR, int texNumC, int index) {
        int texelIndex = index / 2;
        int texR = texelIndex / texNumC;
        int texC = texelIndex - texR * texNumC;
        return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
      }
      `)),
                      (t = `packedUVfrom2D`),
                      (e[t] = new i.GlslLibRoutine(`
      vec2 packedUVfrom2D(int texNumR, int texNumC, int texelsInLogicalRow, int row, int col) {
        int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);
        int texR = texelIndex / texNumC;
        int texC = texelIndex - texR * texNumC;
        return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
      }
      `)),
                      (t = `packedUVfrom3D`),
                      (e[t] = new i.GlslLibRoutine(`
      vec2 packedUVfrom3D(int texNumR, int texNumC,
          int texelsInBatch, int texelsInLogicalRow, int b,
          int row, int col) {
        int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);
        int texR = index / texNumC;
        int texC = index - texR * texNumC;
        return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
      }
      `)),
                      (t = `sampleTexture`));
                    let n = (0, a.getGlsl)(this.context.glContext.version);
                    return (
                      (e[t] = new i.GlslLibRoutine(
                        `\n        float sampleTexture(sampler2D textureSampler, vec2 uv) {\n            return ${n.texture2D}(textureSampler, uv).r;\n        }`,
                      )),
                      e
                    );
                  }
                  getInputsSamplingSnippets() {
                    let e = {},
                      t = this.context.outputTextureLayout;
                    return (
                      this.context.programInfo.inputNames.forEach((n, r) => {
                        let i = this.context.inputTextureLayouts[r],
                          a = (0, s.generateShaderFuncNameFromInputSamplerName)(n);
                        i.isPacked
                          ? (e[a] = this.getPackedSamplerFromInput(a, n, i))
                          : (e[a] = this.getUnpackedSamplerFromInput(a, n, i));
                        let o = (0, s.generateShaderFuncNameFromInputSamplerNameAtOutCoords)(n);
                        i.unpackedShape.length <= t.unpackedShape.length &&
                          (i.isPacked
                            ? (e[o] = this.getPackedSamplerAtOutputCoords(o, i, t, n))
                            : (e[o] = this.getUnpackedSamplerAtOutputCoords(o, i, t, n)));
                      }),
                      e
                    );
                  }
                  getPackedSamplerAtOutputCoords(e, t, n, a) {
                    let o = t.unpackedShape,
                      c = n.unpackedShape,
                      l = a,
                      u = (0, s.generateShaderFuncNameFromInputSamplerName)(l),
                      d = o.length,
                      f = c.length,
                      p = r.BroadcastUtil.getBroadcastDims(o, c),
                      m = (0, s.getCoordsDataType)(f),
                      h = f - d,
                      g,
                      _ = (0, s.getGlChannels)();
                    g =
                      d === 0
                        ? ``
                        : f < 2 && p.length >= 1
                          ? `coords = 0;`
                          : p.map((e) => `coords.${_[e + h]} = 0;`).join(`
`);
                    let v = ``;
                    v = f < 2 && d > 0 ? `coords` : o.map((e, t) => `coords.${_[t + h]}`).join(`, `);
                    let y = `return outputValue;`,
                      b = r.ShapeUtil.size(o) === 1,
                      x = r.ShapeUtil.size(c) === 1;
                    if (d !== 1 || b || x) {
                      if (b && !x)
                        y =
                          f === 1
                            ? `
          return vec4(outputValue.x, outputValue.x, 0., 0.);
        `
                            : `
          return vec4(outputValue.x);
        `;
                      else if (p.length) {
                        let e = d - 2,
                          t = d - 1;
                        p.indexOf(e) > -1 && p.indexOf(t) > -1
                          ? (y = `return vec4(outputValue.x);`)
                          : p.indexOf(e) > -1
                            ? (y = `return vec4(outputValue.x, outputValue.y, outputValue.x, outputValue.y);`)
                            : p.indexOf(t) > -1 && (y = `return vec4(outputValue.xx, outputValue.zz);`);
                      }
                    } else
                      y = `
        return vec4(outputValue.xy, outputValue.xy);
      `;
                    let S = `\n      vec4 ${e}() {\n        ${m} coords = getOutputCoords();\n        \n        int lastDim = coords.${_[f - 1]};\n        coords.${_[f - 1]} = coords.${_[f - 2]};\n        coords.${_[f - 2]} = lastDim;\n      \n        ${g}\n        vec4 outputValue = ${u}(${v});\n        ${y}\n      }\n    `;
                    return new i.GlslLibRoutine(S, [`coordinates.getOutputCoords`]);
                  }
                  getUnpackedSamplerAtOutputCoords(e, t, n, a) {
                    let o = [n.width, n.height],
                      c = [t.width, t.height],
                      l = t.unpackedShape.length,
                      u = n.unpackedShape.length,
                      d = t.unpackedShape,
                      f = n.unpackedShape,
                      p = (0, s.generateShaderFuncNameFromInputSamplerName)(a);
                    if (l === u && r.ArrayUtil.arraysEqual(c, o)) {
                      let t = `\n          float ${e}() {\n            return sampleTexture(${a}, TexCoords);\n          }\n        `;
                      return new i.GlslLibRoutine(t, [`coordinates.sampleTexture`]);
                    }
                    let m = (0, s.getCoordsDataType)(u),
                      h = r.BroadcastUtil.getBroadcastDims(d, f),
                      g = u - l,
                      _,
                      v = (0, s.getGlChannels)();
                    _ =
                      l === 0
                        ? ``
                        : u < 2 && h.length >= 1
                          ? `coords = 0;`
                          : h.map((e) => `coords.${v[e + g]} = 0;`).join(`
`);
                    let y = ``;
                    y = u < 2 && l > 0 ? `coords` : t.unpackedShape.map((e, t) => `coords.${v[t + g]}`).join(`, `);
                    let b = `\n        float ${e}() {\n          ${m} coords = getOutputCoords();\n          ${_}\n          return ${p}(${y});\n        }\n      `;
                    return new i.GlslLibRoutine(b, [`coordinates.getOutputCoords`]);
                  }
                  getPackedSamplerFromInput(e, t, n) {
                    switch (n.unpackedShape.length) {
                      case 0:
                        return this.getPackedSamplerScalar(e, t);
                      case 1:
                        return this.getPackedSampler1D(e, t, n);
                      case 2:
                        return this.getPackedSampler2D(e, t, n);
                      case 3:
                        return this.getPackedSampler3D(e, t, n);
                      default:
                        return this.getPackedSamplerND(e, t, n);
                    }
                  }
                  getUnpackedSamplerFromInput(e, t, n) {
                    let r = n.unpackedShape;
                    switch (r.length) {
                      case 0:
                        return this.getUnpackedSamplerScalar(e, t, n);
                      case 1:
                        return this.getUnpackedSampler1D(e, t, n);
                      case 2:
                        return this.getUnpackedSampler2D(e, t, n);
                      case 3:
                        return this.getUnpackedSampler3D(e, t, n);
                      case 4:
                        return this.getUnpackedSampler4D(e, t, n);
                      case 5:
                        return this.getUnpackedSampler5D(e, t, n);
                      case 6:
                        return this.getUnpackedSampler6D(e, t, n);
                      default:
                        throw Error(`Unsupported dimension ${r.length}-D`);
                    }
                  }
                  getPackedSamplerScalar(e, t) {
                    let n = `\n          vec4 ${e}() {\n            return ${(0, a.getGlsl)(this.context.glContext.version).texture2D}(${t}, halfCR);\n          }\n        `;
                    return new i.GlslLibRoutine(n);
                  }
                  getPackedSampler1D(e, t, n) {
                    let r = [n.width, n.height],
                      o = [r[1], r[0]],
                      s = (0, a.getGlsl)(this.context.glContext.version),
                      c = `vec4 ${e}(int index) {\n      vec2 uv = packedUVfrom1D(\n      ${o[0]}, ${o[1]}, index);\n      return ${s.texture2D}(${t}, uv);\n    }`;
                    return new i.GlslLibRoutine(c, [`coordinates.packedUVfrom1D`]);
                  }
                  getPackedSampler2D(e, t, n) {
                    let o = n.unpackedShape,
                      s = [n.width, n.height],
                      c = (0, a.getGlsl)(this.context.glContext.version),
                      l = s[0],
                      u = s[1];
                    if (s != null && r.ArrayUtil.arraysEqual(o, s)) {
                      let n = `vec4 ${e}(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(${u}.0, ${l}.0);\n        return ${c.texture2D}(${t}, uv);\n      }`;
                      return new i.GlslLibRoutine(n);
                    }
                    let d = s,
                      f = Math.ceil(o[1] / 2),
                      p = `vec4 ${e}(int row, int col) {\n      vec2 uv = packedUVfrom2D(${d[1]}, ${d[0]}, ${f}, row, col);\n      return ${c.texture2D}(${t}, uv);\n    }`;
                    return new i.GlslLibRoutine(p, [`coordinates.packedUVfrom2D`]);
                  }
                  getPackedSampler3D(e, t, n) {
                    let r = n.unpackedShape,
                      o = [n.width, n.height],
                      c = [o[0], o[1]],
                      l = (0, a.getGlsl)(this.context.glContext.version);
                    if (r[0] === 1) {
                      let a = r.slice(1),
                        o = [1, 2],
                        c = (0, s.squeezeInputShape)(r, a),
                        l = [`b`, `row`, `col`],
                        u = JSON.parse(JSON.stringify(n));
                      u.unpackedShape = c;
                      let d = this.getPackedSamplerFromInput(e, t, u),
                        f = `${d.routineBody}\n      vec4 ${e}(int b, int row, int col) {\n        return ${e}(${(0, s.getSqueezedParams)(l, o)});\n      } `;
                      return new i.GlslLibRoutine(f, d.dependencies);
                    }
                    let u = c[0],
                      d = c[1],
                      f = Math.ceil(r[2] / 2),
                      p = `vec4 ${e}(int b, int row, int col) {\n      vec2 uv = packedUVfrom3D(\n        ${d}, ${u}, ${f * Math.ceil(r[1] / 2)}, ${f}, b, row, col);\n      return ${l.texture2D}(${t}, uv);}`;
                    return new i.GlslLibRoutine(p, [`coordinates.packedUVfrom3D`]);
                  }
                  getPackedSamplerND(e, t, n) {
                    let r = n.unpackedShape,
                      o = r.length,
                      s = [n.width, n.height],
                      c = (0, a.getGlsl)(this.context.glContext.version),
                      l = [s[0], s[1]],
                      u = l[1],
                      d = l[0],
                      f = Math.ceil(r[o - 1] / 2),
                      p = f * Math.ceil(r[o - 2] / 2),
                      m = `int b, int row, int col`,
                      h = `b * ${p} + (row / 2) * ${f} + (col / 2)`;
                    for (let e = 2; e < o - 1; e++)
                      ((m = `int b${e}, ` + m), (p *= r[o - e - 1]), (h = `b${e} * ${p} + ` + h));
                    let g = `vec4 ${e}(${m}) {\n      int index = ${h};\n      int texR = index / ${d};\n      int texC = index - texR * ${d};\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${d}, ${u});\n      return ${c.texture2D}(${t}, uv);\n    }`;
                    return new i.GlslLibRoutine(g);
                  }
                  getUnpackedSamplerScalar(e, t, n) {
                    let [r, a] = [n.width, n.height];
                    if (r === 1 && a === 1) {
                      let n = `\n          float ${e}() {\n            return sampleTexture(${t}, halfCR);\n          }\n        `;
                      return new i.GlslLibRoutine(n, [`coordinates.sampleTexture`]);
                    }
                    let o = `\n        float ${e}() {\n          int offset_${t} = coordsToOffset(TexCoords, ${r}, ${a});\n          vec2 uv = uvFromFlat(${r}, ${a}, offset_${t});\n          return sampleTexture(${t}, uv);\n        }\n      `;
                    return new i.GlslLibRoutine(o, [
                      `coordinates.uvFromFlat`,
                      `coordinates.sampleTexture`,
                      `coordinates.coordsToOffset`,
                    ]);
                  }
                  getUnpackedSampler1D(e, t, n) {
                    let r = n.width,
                      a = n.height;
                    if (a === 1 && r === 1) {
                      let n = `\n        float ${e}(int index) {\n          return sampleTexture(${t}, halfCR);\n        }\n      `;
                      return new i.GlslLibRoutine(n, [`coordinates.sampleTexture`]);
                    }
                    if (a === 1) {
                      let n = `\n          float ${e}(int index) {\n            vec2 uv = vec2((float(index) + 0.5) / ${r}.0, 0.5);\n            return sampleTexture(${t}, uv);\n          }\n        `;
                      return new i.GlslLibRoutine(n, [`coordinates.sampleTexture`]);
                    }
                    if (r === 1) {
                      let n = `\n          float ${e}(int index) {\n            vec2 uv = vec2(0.5, (float(index) + 0.5) / ${a}.0);\n            return sampleTexture(${t}, uv);\n          }\n        `;
                      return new i.GlslLibRoutine(n, [`coordinates.sampleTexture`]);
                    }
                    let o = `\n        float ${e}(int index) {\n          vec2 uv = uvFromFlat(${r}, ${a}, index);\n          return sampleTexture(${t}, uv);\n        }\n      `;
                    return new i.GlslLibRoutine(o, [`coordinates.uvFromFlat`, `coordinates.sampleTexture`]);
                  }
                  getUnpackedSampler2D(e, t, n) {
                    let a = n.unpackedShape,
                      c = [n.height, n.width];
                    if (c != null && r.ArrayUtil.arraysEqual(a, c)) {
                      let n = `\n          float ${e}(int row, int col) {\n            vec2 uv = (vec2(row, col) + halfCR) / vec2(${c[1]}.0, ${c[0]}.0);\n            return sampleTexture(${t}, uv);\n          }\n        `;
                      return new i.GlslLibRoutine(n, [`coordinates.sampleTexture`]);
                    }
                    let { newShape: l, keptDims: u } = (0, o.squeezeShape)(a),
                      d = l;
                    if (d.length < a.length) {
                      let r = (0, s.squeezeInputShape)(a, d),
                        o = JSON.parse(JSON.stringify(n));
                      o.unpackedShape = r;
                      let c = `\n          ${this.getUnpackedSamplerFromInput(e, t, o).routineBody}\n          float ${e}(int row, int col) {\n            return ${e}(${(0, s.getSqueezedParams)([`col`, `row`], u)});\n          }\n        `;
                      return new i.GlslLibRoutine(c, [`coordinates.sampleTexture`]);
                    }
                    let f = c[1],
                      p = c[0];
                    if (p === 1) {
                      let n = `\n          float ${e}(int row, int col) {\n            int offset_${t} = coordsToOffset(TexCoords, ${f}, ${p});\n            float index = dot(vec3(row, col, offset_${t}), vec3(${a[1]}, 1, 1));\n            vec2 uv = vec2(0.5, (index + 0.5) / ${f}.0);\n            return sampleTexture(${t}, uv);\n          }\n        `;
                      return new i.GlslLibRoutine(n, [`coordinates.sampleTexture`, `coordinates.coordsToOffset`]);
                    }
                    if (f === 1) {
                      let n = `\n          float ${e}(int row, int col) {\n            int offset_${t} = coordsToOffset(TexCoords, ${f}, ${p});\n            float index = dot(vec3(row, col, offset_${t}), vec3(${a[1]}, 1, 1));\n            vec2 uv = vec2((index + 0.5) / ${p}.0, 0.5);\n            return sampleTexture(${t}, uv);\n          }\n        `;
                      return new i.GlslLibRoutine(n, [`coordinates.sampleTexture`, `coordinates.coordsToOffset`]);
                    }
                    let m = `\n        float ${e}(int row, int col) {\n          int index = col * ${a[1]} + row;\n          vec2 uv = uvFromFlat(${f}, ${p}, index);\n          return sampleTexture(${t}, uv);\n        }\n      `;
                    return new i.GlslLibRoutine(m, [
                      `coordinates.uvFromFlat`,
                      `coordinates.sampleTexture`,
                      `coordinates.coordsToOffset`,
                    ]);
                  }
                  getUnpackedSampler3D(e, t, n) {
                    let r = n.unpackedShape,
                      a = r[1] * r[2],
                      c = r[2],
                      { newShape: l, keptDims: u } = (0, o.squeezeShape)(r),
                      d = l;
                    if (d.length < r.length) {
                      let a = (0, s.squeezeInputShape)(r, d),
                        o = [`batch`, `col`, `row`],
                        c = JSON.parse(JSON.stringify(n));
                      c.unpackedShape = a;
                      let l = this.getUnpackedSamplerFromInput(e, t, c),
                        f = u.reverse(),
                        p = `\n          ${l.routineBody}\n          float ${e}(int batch, int row, int col) {\n            return ${e}(${(0, s.getSqueezedParams)(o, f)});\n          }\n        `;
                      return new i.GlslLibRoutine(p, l.dependencies);
                    }
                    let f = `\n          float ${e}(int depth, int row, int col) {\n            // Explicitly use integer operations as dot() only works on floats.\n            int index = depth * ${a} + col * ${c} + row;\n            vec2 uv = uvFromFlat(${n.width}, ${n.height}, index);\n            return sampleTexture(${t}, uv);\n          }\n      `;
                    return new i.GlslLibRoutine(f, [
                      `coordinates.uvFromFlat`,
                      `coordinates.sampleTexture`,
                      `coordinates.coordsToOffset`,
                    ]);
                  }
                  getUnpackedSampler4D(e, t, n) {
                    let r = n.unpackedShape,
                      a = r[3],
                      o = r[2] * a,
                      s = `\n        float ${e}(int row, int col, int depth, int depth2) {\n          int index = row * ${r[1] * o} + col * ${o} +\n              depth2 * ${a} + depth;\n          vec2 uv = uvFromFlat(${n.width}, ${n.height}, index);\n          return sampleTexture(${t}, uv);\n        }\n      `;
                    return new i.GlslLibRoutine(s, [`coordinates.uvFromFlat`, `coordinates.sampleTexture`]);
                  }
                  getUnpackedSampler5D(e, t, n) {
                    let r = n.unpackedShape,
                      a = r[4],
                      c = r[3] * a,
                      l = r[2] * c,
                      u = r[1] * l,
                      { newShape: d, keptDims: f } = (0, o.squeezeShape)(r);
                    if (d.length < r.length) {
                      let a = (0, s.squeezeInputShape)(r, d),
                        o = [`row`, `col`, `depth`, `depth2`, `depth3`],
                        c = JSON.parse(JSON.stringify(n));
                      c.unpackedShape = a;
                      let l = `\n          ${this.getUnpackedSamplerFromInput(e, t, c).routineBody}\n          float ${e}(int row, int col, int depth, int depth2, int depth3) {\n            return ${e}(${(0, s.getSqueezedParams)(o, f)});\n          }\n        `;
                      return new i.GlslLibRoutine(l, [`coordinates.sampleTexture`, `coordinates.uvFromFlat`]);
                    }
                    let p = `\n        float ${e}(int row, int col, int depth, int depth2, int depth3) {\n          int index = row * ${u} + col * ${l} + depth * ${c} +\n          depth3 * ${a} + depth2;\n          vec2 uv = uvFromFlat(${n.width}, ${n.height}, index);\n          return sampleTexture(${t}, uv);\n        }\n      `;
                    return new i.GlslLibRoutine(p, [`coordinates.sampleTexture`, `coordinates.uvFromFlat`]);
                  }
                  getUnpackedSampler6D(e, t, n) {
                    let r = n.unpackedShape,
                      a = r[5],
                      c = r[4] * a,
                      l = r[3] * c,
                      u = r[2] * l,
                      d = r[1] * u,
                      { newShape: f, keptDims: p } = (0, o.squeezeShape)(r);
                    if (f.length < r.length) {
                      let a = (0, s.squeezeInputShape)(r, f),
                        o = [`row`, `col`, `depth`, `depth2`, `depth3`, `depth4`],
                        c = JSON.parse(JSON.stringify(n));
                      c.unpackedShape = a;
                      let l = `\n            ${this.getUnpackedSamplerFromInput(e, t, c).routineBody}\n            float ${e}(int row, int col, int depth,\n              int depth2, int depth3, int depth4) {\n              return ${e}(${(0, s.getSqueezedParams)(o, p)});\n            }\n          `;
                      return new i.GlslLibRoutine(l, [`coordinates.sampleTexture`, `coordinates.uvFromFlat`]);
                    }
                    let m = `\n          float ${e}(int row, int col, int depth,\n            int depth2, int depth3, int depth4) {\n            int index = row * ${d} + col * ${u} + depth * ${l} +\n            depth2 * ${c} + depth3 * ${a} + depth4;\n            vec2 uv = uvFromFlat(${n.width}, ${n.height}, index);\n            return sampleTexture(${t}, uv);\n          }\n        `;
                    return new i.GlslLibRoutine(m, [
                      `coordinates.uvFromFlat`,
                      `coordinates.sampleTexture`,
                      `coordinates.coordsToOffset`,
                    ]);
                  }
                  toVec() {
                    let e = this.context.outputTextureLayout,
                      t = e.shape.length,
                      n = e.strides,
                      r = e.width,
                      a = e.height,
                      o = [];
                    for (let e = 0; e < t - 1; ++e)
                      (o.push(`\n        c[${e}] = offset / ${n[e]};`),
                        o.push(`\n        offset -= c[${e}] * ${n[e]};`));
                    o.push(`\n        c[${t - 1}] = offset;`);
                    let s = `\n      void toVec(vec2 texCoords, out int c[${t}]) {\n        int offset = coordsToOffset(texCoords, ${r}, ${a});\n        ${o.join(``)}\n      }\n      void toVec(int offset, out int c[${t}]) {\n        ${o.join(``)}\n      }\n    `;
                    return { toVec: new i.GlslLibRoutine(s, [`coordinates.coordsToOffset`]) };
                  }
                  valueFrom() {
                    let e = {};
                    return (
                      this.context.programInfo.inputNames.forEach((t, n) => {
                        let r = this.context.inputTextureLayouts[n],
                          a = (r.unpackedShape.length > 0 ? r.unpackedShape : r.shape).length,
                          o = `_${t}`;
                        ((e[o] = new i.GlslLibRoutine(this.getValueFromSingle(t, a, r.width, r.height, !1), [
                          `shapeUtils.indicesToOffset${o}`,
                          `coordinates.offsetToCoords`,
                          `fragcolor.getColorAsFloat`,
                        ])),
                          (o += `_T`),
                          (e[o] = new i.GlslLibRoutine(this.getValueFromSingle(t, a, r.width, r.height, !0), [
                            `shapeUtils.indicesToOffset${o}`,
                            `coordinates.offsetToCoords`,
                            `fragcolor.getColorAsFloat`,
                          ])));
                      }),
                      e
                    );
                  }
                  getValueFromSingle(e, t, n, r, i) {
                    let o = `_${e}`;
                    return (
                      i && (o += `_T`),
                      `\n        float ${o}(int m[${t}]) {\n          int offset = indicesToOffset${o}(m);\n          vec2 coords = offsetToCoords(offset, ${n}, ${r});\n          float value = getColorAsFloat(${(0, a.getGlsl)(this.context.glContext.version).texture2D}(${e}, coords));\n          return value;\n        }\n        `
                    );
                  }
                  getPackedValueFrom(e, t, n, r, i) {
                    let o = `_${e}_Pack`;
                    return (
                      i && (o += `_T`),
                      `\n        vec4 ${o}(int m[${t}]) {\n          int offset = indicesToOffset_${e}(m);\n          vec2 coords = offsetToCoords(offset, ${n}, ${r});\n          return ${(0, a.getGlsl)(this.context.glContext.version).texture2D}(${e}, coords);\n        }\n        `
                    );
                  }
                }
                t.CoordsGlslLib = c;
              },
              8520: (e, t) => {
                'use strict';
                var n;
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.TopologicalSortGlslRoutines =
                    t.GlslLibRoutineNode =
                    t.GlslLibRoutine =
                    t.GlslLib =
                    t.GlslContext =
                    t.FunctionType =
                      void 0),
                  ((n = t.FunctionType ||= {})[(n.ValueBased = 0)] = `ValueBased`),
                  (n[(n.Positional = 1)] = `Positional`),
                  (t.GlslContext = class {
                    constructor(e, t, n, r) {
                      ((this.glContext = e),
                        (this.programInfo = t),
                        (this.inputTextureLayouts = n),
                        (this.outputTextureLayout = r));
                    }
                  }),
                  (t.GlslLib = class {
                    constructor(e) {
                      this.context = e;
                    }
                  }),
                  (t.GlslLibRoutine = class {
                    constructor(e, t) {
                      ((this.routineBody = e), (this.dependencies = t));
                    }
                  }),
                  (t.GlslLibRoutineNode = class {
                    constructor(e, t, n) {
                      ((this.name = e), (this.dependencies = n || []), t && (this.routineBody = t));
                    }
                    addDependency(e) {
                      e && this.dependencies.push(e);
                    }
                  }),
                  (t.TopologicalSortGlslRoutines = class {
                    static returnOrderedNodes(e) {
                      if (!e || e.length === 0) return [];
                      if (e.length === 1) return e;
                      let t = new Set(),
                        n = new Set(),
                        r = [];
                      return (this.createOrderedNodes(e, t, n, r), r);
                    }
                    static createOrderedNodes(e, t, n, r) {
                      for (let i = 0; i < e.length; ++i) this.dfsTraverse(e[i], t, n, r);
                    }
                    static dfsTraverse(e, t, n, r) {
                      if (!e || n.has(e.name)) return;
                      if (t.has(e.name))
                        throw Error(`Cyclic dependency detected. Can't topologically sort routines needed for shader.`);
                      t.add(e.name);
                      let i = e.dependencies;
                      if (i && i.length > 0) for (let e = 0; e < i.length; ++e) this.dfsTraverse(i[e], t, n, r);
                      (r.push(e), n.add(e.name), t.delete(e.name));
                    }
                  }));
              },
              7341: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.EncodingGlslLib = void 0));
                let r = n(8520);
                class i extends r.GlslLib {
                  constructor(e) {
                    super(e);
                  }
                  getFunctions() {
                    return Object.assign(Object.assign({}, this.encodeFloat32()), this.decodeFloat32());
                  }
                  getCustomTypes() {
                    return {};
                  }
                  encodeFloat32() {
                    return {
                      encode: new r.GlslLibRoutine(`highp vec4 encode(highp float f) {
        return vec4(f, 0.0, 0.0, 0.0);
      }
        `),
                    };
                  }
                  decodeFloat32() {
                    return {
                      decode: new r.GlslLibRoutine(`highp float decode(highp vec4 rgba) {
        return rgba.r;
      }
        `),
                    };
                  }
                  encodeUint8() {
                    let e = i.isLittleEndian() ? `rgba.rgba=rgba.abgr;` : ``;
                    return {
                      encode: new r.GlslLibRoutine(
                        `\n      highp vec4 encode(highp float f) {\n        highp float F = abs(f);\n        highp float Sign = step(0.0,-f);\n        highp float Exponent = floor(log2(F));\n        highp float Mantissa = (exp2(- Exponent) * F);\n        Exponent = floor(log2(F) + 127.0) + floor(log2(Mantissa));\n        highp vec4 rgba;\n        rgba[0] = 128.0 * Sign  + floor(Exponent*exp2(-1.0));\n        rgba[1] = 128.0 * mod(Exponent,2.0) + mod(floor(Mantissa*128.0),128.0);\n        rgba[2] = floor(mod(floor(Mantissa*exp2(23.0 -8.0)),exp2(8.0)));\n        rgba[3] = floor(exp2(23.0)*mod(Mantissa,exp2(-15.0)));\n        ${e}\n        rgba = rgba / 255.0; // values need to be normalized to [0,1]\n        return rgba;\n    }\n        `,
                      ),
                    };
                  }
                  decodeUint8() {
                    let e = i.isLittleEndian() ? `rgba.rgba=rgba.abgr;` : ``;
                    return {
                      decode: new r.GlslLibRoutine(
                        `\n        highp float decode(highp vec4 rgba) {\n          rgba = rgba * 255.0; // values need to be de-normalized from [0,1] to [0,255]\n          ${e}\n          highp float Sign = 1.0 - step(128.0,rgba[0])*2.0;\n          highp float Exponent = 2.0 * mod(rgba[0],128.0) + step(128.0,rgba[1]) - 127.0;\n          highp float Mantissa = mod(rgba[1],128.0)*65536.0 + rgba[2]*256.0 +rgba[3] + float(0x800000);\n          highp float Result =  Sign * exp2(Exponent) * (Mantissa * exp2(-23.0 ));\n          return Result;\n      }\n        `,
                      ),
                    };
                  }
                  static isLittleEndian() {
                    let e = new ArrayBuffer(4),
                      t = new Uint32Array(e),
                      n = new Uint8Array(e);
                    if (((t[0] = 3735928559), n[0] === 239)) return !0;
                    if (n[0] === 222) return !1;
                    throw Error(`unknown endianness`);
                  }
                }
                t.EncodingGlslLib = i;
              },
              9894: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.FragColorGlslLib = void 0));
                let r = n(8520),
                  i = n(5060);
                class a extends r.GlslLib {
                  constructor(e) {
                    super(e);
                  }
                  getFunctions() {
                    return Object.assign(Object.assign({}, this.setFragColor()), this.getColorAsFloat());
                  }
                  getCustomTypes() {
                    return {};
                  }
                  setFragColor() {
                    let e = (0, i.getGlsl)(this.context.glContext.version);
                    return {
                      setFragColor: new r.GlslLibRoutine(
                        `\n        void setFragColor(float value) {\n            ${e.output} = encode(value);\n        }\n        `,
                        [`encoding.encode`],
                      ),
                    };
                  }
                  getColorAsFloat() {
                    return {
                      getColorAsFloat: new r.GlslLibRoutine(
                        `
        float getColorAsFloat(vec4 color) {
            return decode(color);
        }
        `,
                        [`encoding.decode`],
                      ),
                    };
                  }
                }
                t.FragColorGlslLib = a;
              },
              2848: (e, t) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.replaceInlines = void 0));
                let n = /@inline[\s\n\r]+(\w+)[\s\n\r]+([0-9a-zA-Z_]+)\s*\(([^)]*)\)\s*{(([^}]|[\n\r])*)}/gm;
                t.replaceInlines = function (e) {
                  let t = {},
                    r;
                  for (; (r = n.exec(e)) !== null; ) {
                    let e = r[3]
                      .split(`,`)
                      .map((e) => {
                        let t = e.trim().split(` `);
                        return t && t.length === 2 ? { type: t[0], name: t[1] } : null;
                      })
                      .filter((e) => e !== null);
                    t[r[2]] = { params: e, body: r[4] };
                  }
                  for (let n in t) {
                    let i = `(\\w+)?\\s+([_0-9a-zA-Z]+)\\s+=\\s+__FUNC__\\((.*)\\)\\s*;`.replace(`__FUNC__`, n),
                      a = new RegExp(i, `gm`);
                    for (; (r = a.exec(e)) !== null; ) {
                      let i = r[1],
                        a = r[2],
                        o = r[3].split(`,`),
                        s = i ? `${i} ${a};` : ``,
                        c = t[n].body,
                        l = ``;
                      (t[n].params.forEach((e, t) => {
                        e && (l += `${e.type} ${e.name} = ${o[t]};\n`);
                      }),
                        (c = `${l}\n ${c}`),
                        (c = c.replace(`return`, `${a} = `)));
                      let u = `\n      ${s}\n      {\n        ${c}\n      }\n      `;
                      e = e.replace(r[0], u);
                    }
                  }
                  return e.replace(n, ``);
                };
              },
              8879: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.GlslPreprocessor = void 0));
                let r = n(8520),
                  i = n(2848),
                  a = n(5483),
                  o = n(5060);
                t.GlslPreprocessor = class {
                  constructor(e, t, n, i) {
                    ((this.libs = {}),
                      (this.glslLibRoutineDependencyGraph = {}),
                      (this.context = new r.GlslContext(e, t, n, i)),
                      Object.keys(a.glslRegistry).forEach((e) => {
                        let t = new a.glslRegistry[e](this.context);
                        this.libs[e] = t;
                      }));
                    let o = this.glslLibRoutineDependencyGraph;
                    for (let e in this.libs) {
                      let t = this.libs[e].getFunctions();
                      for (let n in t) {
                        let i = e + `.` + n,
                          a;
                        o[i]
                          ? ((a = o[i]), (a.routineBody = t[n].routineBody))
                          : ((a = new r.GlslLibRoutineNode(i, t[n].routineBody)), (o[i] = a));
                        let s = t[n].dependencies;
                        if (s)
                          for (let e = 0; e < s.length; ++e)
                            if (o[s[e]]) a.addDependency(o[s[e]]);
                            else {
                              let t = new r.GlslLibRoutineNode(s[e]);
                              ((o[s[e]] = t), a.addDependency(t));
                            }
                      }
                    }
                  }
                  preprocess() {
                    let e = this.context.programInfo,
                      t = e.shaderSource;
                    return (
                      this.context.programInfo.hasMain ||
                        (t = `${t}\n      ${(0, o.getDefaultFragShaderMain)(this.context.glContext.version, this.context.outputTextureLayout.shape.length)}`),
                      (t = (0, i.replaceInlines)(t)),
                      `${(0, o.getFragShaderPreamble)(this.context.glContext.version)}\n    ${this.getUniforms(e.inputNames, e.variables)}\n    ${this.getImports(t)}\n    ${t}`
                    );
                  }
                  getImports(e) {
                    let t = this.selectGlslLibRoutinesToBeIncluded(e);
                    if (t.length === 0) return ``;
                    let n = ``;
                    for (let e = 0; e < t.length; ++e) {
                      if (!t[e].routineBody) throw Error(`Missing body for the Glsl Library routine: ${t[e].name}`);
                      n +=
                        t[e].routineBody +
                        `
`;
                    }
                    return n;
                  }
                  selectGlslLibRoutinesToBeIncluded(e) {
                    let t = [];
                    return (
                      Object.keys(this.glslLibRoutineDependencyGraph).forEach((n) => {
                        let r = n.split(`.`)[1];
                        e.indexOf(r) !== -1 && t.push(this.glslLibRoutineDependencyGraph[n]);
                      }),
                      r.TopologicalSortGlslRoutines.returnOrderedNodes(t)
                    );
                  }
                  getUniforms(e, t) {
                    let n = [];
                    if (e) for (let t of e) n.push(`uniform sampler2D ${t};`);
                    if (t)
                      for (let e of t)
                        n.push(`uniform ${e.type} ${e.name}${e.arrayLength ? `[${e.arrayLength}]` : ``};`);
                    return n.join(`
`);
                  }
                };
              },
              5483: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.glslRegistry = void 0));
                let r = n(5107),
                  i = n(7341),
                  a = n(9894),
                  o = n(2655),
                  s = n(3891);
                t.glslRegistry = {
                  encoding: i.EncodingGlslLib,
                  fragcolor: a.FragColorGlslLib,
                  vec: s.VecGlslLib,
                  shapeUtils: o.ShapeUtilsGlslLib,
                  coordinates: r.CoordsGlslLib,
                };
              },
              2655: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.ShapeUtilsGlslLib = void 0));
                let r = n(8520);
                class i extends r.GlslLib {
                  constructor(e) {
                    super(e);
                  }
                  getFunctions() {
                    return Object.assign(
                      Object.assign(
                        Object.assign(
                          Object.assign(Object.assign({}, this.bcastIndex()), this.bcastMatmulIndex()),
                          this.offsetToIndices(),
                        ),
                        this.indicesToOffset(),
                      ),
                      this.incrementIndices(),
                    );
                  }
                  getCustomTypes() {
                    return {};
                  }
                  bcastIndex() {
                    let e = this.context.outputTextureLayout.shape.length,
                      t = {};
                    return (
                      this.context.programInfo.inputNames.forEach((n, i) => {
                        let a = this.context.inputTextureLayouts[i].unpackedShape;
                        if (a.length <= e) {
                          let i = a.length,
                            o = e - i,
                            s = `bcastIndices_${n}`,
                            c = ``;
                          for (let e = 0; e < i; ++e)
                            c += `\n          realIndices[${e}] = int( mod(float(bcastedIndices[${o + e}]), ${a[e]}.0) );\n          `;
                          let l = `\n        void ${s} (int bcastedIndices[${e}], out int realIndices[${i}]) {\n          ${c}\n        }\n        `;
                          t[s] = new r.GlslLibRoutine(l);
                        }
                      }),
                      t
                    );
                  }
                  bcastMatmulIndex() {
                    let e = this.context.outputTextureLayout.shape.length,
                      t = {};
                    return (
                      this.context.programInfo.inputNames.forEach((n, i) => {
                        let a = this.context.inputTextureLayouts[i].shape;
                        if (!(a.length < 2 || a.length > e)) {
                          let i = a.length,
                            o = e - i,
                            s = `bcastMatmulIndices_${n}`,
                            c = ``;
                          for (let e = 0; e < i - 2; ++e)
                            c += `\n          realIndices[${e}] = int( mod(float(bcastedIndices[${o + e}]), ${a[e]}.0) );\n          `;
                          let l = `\n        void ${s}(int bcastedIndices[${e}], out int realIndices[${i}]) {\n          ${c}\n          realIndices[${i - 1}] = bcastedIndices[${e - 1}];\n          realIndices[${i - 2}] = bcastedIndices[${e - 2}];\n        }\n        `;
                          t[s] = new r.GlslLibRoutine(l);
                        }
                      }),
                      t
                    );
                  }
                  indicesToOffset() {
                    let e = {};
                    return (
                      this.context.programInfo.inputNames.forEach((t, n) => {
                        let a = this.context.inputTextureLayouts[n].shape,
                          o = this.context.inputTextureLayouts[n].strides,
                          s = a.length,
                          c = `indicesToOffset_${t}`;
                        ((e[c] = new r.GlslLibRoutine(i.indexToOffsetSingle(c, s, o))),
                          (c = `indicesToOffset_${t}_T`),
                          (e[c] = new r.GlslLibRoutine(i.indexToOffsetSingle(c, s, o.slice().reverse()))));
                      }),
                      e
                    );
                  }
                  static indexToOffsetSingle(e, t, n) {
                    let r = ``;
                    for (let e = t - 1; e >= 0; --e) r += `\n        offset += indices[${e}] * ${n[e]};\n        `;
                    return `\n      int ${e}(int indices[${t}]) {\n        int offset = 0;\n        ${r}\n        return offset;\n      }\n      `;
                  }
                  offsetToIndices() {
                    let e = {};
                    return (
                      this.context.programInfo.inputNames.forEach((t, n) => {
                        let a = this.context.inputTextureLayouts[n].shape,
                          o = this.context.inputTextureLayouts[n].strides,
                          s = a.length,
                          c = `offsetToIndices_${t}`;
                        ((e[c] = new r.GlslLibRoutine(i.offsetToIndicesSingle(c, s, o))),
                          (c = `offsetToIndices_${t}_T`),
                          (e[c] = new r.GlslLibRoutine(i.offsetToIndicesSingle(c, s, o.slice().reverse()))));
                      }),
                      e
                    );
                  }
                  static offsetToIndicesSingle(e, t, n) {
                    let r = [];
                    for (let e = 0; e < t - 1; ++e)
                      (r.push(`\n      indices[${e}] = offset / ${n[e]};`),
                        r.push(`\n        offset -= indices[${e}] * ${n[e]};`));
                    return (
                      r.push(`\n      indices[${t - 1}] = offset;`),
                      `\n      void ${e}(int offset, out int indices[${t}]) {\n        ${r.join(``)}\n      }\n      `
                    );
                  }
                  incrementIndices() {
                    let e = {};
                    return (
                      this.context.programInfo.inputNames.forEach((t, n) => {
                        let i = this.context.inputTextureLayouts[n].shape,
                          a = i.length,
                          o = `incrementIndices_${t}`,
                          s = ``;
                        for (let e = 0; e < a; ++e) s += `\n        shape[${e}] = ${i[e]};`;
                        let c = `\n        void ${o}(int axis, out int indices[${a}]) {\n          int shape[${a}];\n          ${s};\n          for(int i = ${a} -1 ; i >= 0; --i) {\n            if(i > axis) continue;\n            indices[i] += 1;\n            if(indices[i] < shape[i]) {\n              break;\n            }\n            indices[i] = 0;\n          }\n        }\n        `;
                        e[o] = new r.GlslLibRoutine(c);
                      }),
                      e
                    );
                  }
                }
                t.ShapeUtilsGlslLib = i;
              },
              5060: (e, t) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.getDefaultFragShaderMain =
                    t.getFragShaderPreamble =
                    t.getVertexShaderSource =
                    t.getGlsl =
                      void 0));
                let n = {
                    version: ``,
                    attribute: `attribute`,
                    varyingVertex: `varying`,
                    varyingFrag: `varying`,
                    texture2D: `texture2D`,
                    output: `gl_FragColor`,
                    outputDeclaration: ``,
                  },
                  r = {
                    version: `#version 300 es`,
                    attribute: `in`,
                    varyingVertex: `out`,
                    varyingFrag: `in`,
                    texture2D: `texture`,
                    output: `outputColor`,
                    outputDeclaration: `out vec4 outputColor;`,
                  };
                function i(e) {
                  return e === 1 ? n : r;
                }
                ((t.getGlsl = i),
                  (t.getVertexShaderSource = function (e) {
                    let t = i(e);
                    return `${t.version}\n      precision highp float;\n      ${t.attribute} vec3 position;\n      ${t.attribute} vec2 textureCoord;\n\n      ${t.varyingVertex} vec2 TexCoords;\n\n      void main()\n      {\n          gl_Position = vec4(position, 1.0);\n          TexCoords = textureCoord;\n      }`;
                  }),
                  (t.getFragShaderPreamble = function (e) {
                    let t = i(e);
                    return `${t.version}\n    precision highp float;\n    precision highp int;\n    precision highp sampler2D;\n    ${t.varyingFrag} vec2 TexCoords;\n    ${t.outputDeclaration}\n    const vec2 halfCR = vec2(0.5, 0.5);\n\n    // Custom vector types to handle higher dimenalities.\n    struct ivec5\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n    };\n\n    struct ivec6\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n      int v;\n    };\n\n    int imod(int x, int y) {\n      return x - y * (x / y);\n    }\n\n    `;
                  }),
                  (t.getDefaultFragShaderMain = function (e, t) {
                    return `\n  void main() {\n    int indices[${t}];\n    toVec(TexCoords, indices);\n    vec4 result = vec4(process(indices));\n    ${i(e).output} = result;\n  }\n  `;
                  }));
              },
              3891: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.VecGlslLib = void 0));
                let r = n(8520);
                class i extends r.GlslLib {
                  constructor(e) {
                    super(e);
                  }
                  getCustomTypes() {
                    return {};
                  }
                  getFunctions() {
                    return Object.assign(
                      Object.assign(
                        Object.assign(Object.assign({}, this.binaryVecFunctions()), this.copyVec()),
                        this.setVecItem(),
                      ),
                      this.getVecItem(),
                    );
                  }
                  binaryVecFunctions() {
                    let e = this.context.outputTextureLayout.shape.length,
                      t = { add: `+=`, sub: `-=`, mul: `*=`, div: `/=` },
                      n = {};
                    for (let i in t) {
                      let a = `${i}Vec`,
                        o = ``;
                      for (let n = 0; n < e; ++n) o += `\n          dest[${n}] ${t[i]} src[${n}];\n          `;
                      let s = `\n        void ${a}(int src[${e}], out int dest[${e}]) {\n          ${o}\n        }\n        `;
                      n[a] = new r.GlslLibRoutine(s);
                    }
                    return n;
                  }
                  copyVec() {
                    let e = this.context.outputTextureLayout.shape.length,
                      t = ``;
                    for (let n = 0; n < e; ++n) t += `\n        dest[${n}] = src[${n}];\n        `;
                    let n = `\n      void copyVec(int src[${e}], out int dest[${e}]) {\n        ${t}\n      }\n      `;
                    return { copyVec: new r.GlslLibRoutine(n) };
                  }
                  setVecItem() {
                    let e = this.context.outputTextureLayout.shape.length,
                      t = `\n        if(index < 0)\n            index =${e} + index;\n        if (index == 0)\n            m[0] = value;\n        `;
                    for (let n = 1; n < e - 1; ++n)
                      t += `\n        else if (index == ${n})\n            m[${n}] = value;\n            `;
                    t += `\n        else\n            m[${e - 1}] = value;\n        `;
                    let n = `\n      void setVecItem(out int m[${e}], int index, int value) {\n        ${t}\n      }\n        `;
                    return { setVecItem: new r.GlslLibRoutine(n) };
                  }
                  getVecItem() {
                    let e = this.context.outputTextureLayout.shape.length,
                      t = `\n        if(index < 0)\n            index = ${e} + index;\n        if (index == 0)\n            return m[0];\n      `;
                    for (let n = 1; n < e - 1; ++n)
                      t += `\n        else if (index == ${n})\n            return m[${n}];\n      `;
                    t += `\n        else\n            return m[${e - 1}];\n        `;
                    let n = `\n      int getVecItem(int m[${e}], int index) {\n        ${t}\n      }\n    `;
                    return { getVecItem: new r.GlslLibRoutine(n) };
                  }
                }
                t.VecGlslLib = i;
              },
              8316: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.WebGLInferenceHandler = void 0));
                let r = n(6231),
                  i = n(9162),
                  a = n(2517),
                  o = n(2403),
                  s = n(7019),
                  c = n(8710),
                  l = n(5611),
                  u = n(4057),
                  d = n(2039);
                t.WebGLInferenceHandler = class {
                  constructor(e) {
                    ((this.session = e),
                      (this.packedTextureDataCache = new Map()),
                      (this.unpackedTextureDataCache = new Map()));
                  }
                  calculateTextureWidthAndHeight(e, t) {
                    return (0, u.calculateTextureWidthAndHeight)(this.session.layoutStrategy, e, t);
                  }
                  executeProgram(e, t) {
                    if (t.length < e.inputNames.length)
                      throw Error(`Input size mustn't be less than ${e.inputNames.length}.`);
                    if (e.inputNames.length !== e.inputTypes.length)
                      throw Error(`input names size does not match input types`);
                    let n = [];
                    for (let r = 0; r < e.inputNames.length; ++r)
                      n[r] = this.getOrCreateTextureData(t[r], e.inputTypes[r]);
                    let r = ((e, t) => {
                        let n = t.map((e) => `${e.unpackedShape.join(`,`)};${e.width}x${e.height}`).join(`_`),
                          r = e.name;
                        return (e.cacheHint && (r += `[` + e.cacheHint + `]`), (r += `:` + n), r);
                      })(e, n),
                      i = this.session.programManager.getArtifact(r),
                      a = i ? i.programInfo : typeof e.get == `function` ? e.get() : e,
                      o = (0, u.createTextureLayoutFromTextureType)(
                        this.session.layoutStrategy,
                        a.output.dims,
                        a.output.textureType,
                      ),
                      s = this.createTextureData(o, a.output.type);
                    return (
                      i ||
                        ((i = this.session.programManager.build(a, n, s)),
                        this.session.programManager.setArtifact(r, i)),
                      this.runProgram(i, n, s),
                      s
                    );
                  }
                  run(e, t) {
                    return this.executeProgram(e, t).tensor;
                  }
                  runProgram(e, t, n) {
                    for (let n = 0; n < t.length; ++n)
                      if (!!t[n].isPacked != (e.programInfo.inputTypes[n] === d.TextureType.packed))
                        throw Error(`input[${n}] property packed inconsistent`);
                    if (!!n.isPacked != (e.programInfo.output.textureType === d.TextureType.packed))
                      throw Error(`output property packed inconsistent`);
                    this.session.programManager.run(e, t, n);
                  }
                  getOrCreateTextureData(e, t) {
                    let n = this.getTextureData(e.dataId, t === d.TextureType.packed);
                    if (!n && ((n = this.getTextureData(e.dataId, t !== d.TextureType.packed)), n))
                      return t === d.TextureType.packed ? this.pack(n) : this.unpack(n);
                    if (!n) {
                      let r = (0, u.createTextureLayoutFromTextureType)(this.session.layoutStrategy, e.dims, t);
                      if (t === d.TextureType.packedLastDimension) {
                        let n = 1,
                          r = 4,
                          i = e.dims;
                        if (i.length === 4) {
                          let n = [i[0], Math.ceil((i[1] * i[2] * i[3]) / 4)],
                            r = (0, u.createTextureLayoutFromTextureType)(this.session.layoutStrategy, n, t),
                            a = e.numberData;
                          if ((i[1] * i[2] * i[3]) % 4 != 0) {
                            let t = i[0],
                              n = i[1] * i[2] * i[3],
                              r = Math.ceil((n * 1) / 4) * 4;
                            a = new Float32Array(t * r);
                            for (let i = 0; i < t; ++i) {
                              let t = i * n,
                                o = i * r + (i % 1) * n;
                              a.set(e.numberData.subarray(t, t + n), o);
                            }
                          }
                          return this.createTextureData(r, e.type, a, e, 1);
                        }
                      }
                      if (t === d.TextureType.packed) {
                        let t = (0, u.createTextureLayoutFromShape)(this.session.layoutStrategy, e.dims, 1, [], {
                            reverseWH: !0,
                          }),
                          r = this.createTextureData(t, e.type, e.numberData, e, 1);
                        n = this.pack(r);
                      } else n = this.createTextureData(r, e.type, e.numberData, e, 1);
                    }
                    return n;
                  }
                  createTextureDataFromLayoutBindTensor(e, t, n, r) {
                    return this.createTextureData(e, t, n, r, 1);
                  }
                  createTextureData(e, t, n, i, a) {
                    r.Logger.verbose(`InferenceHandler`, `Creating TextureData: layout:[${JSON.stringify(e)}]`);
                    let o = this.session.textureManager.createTextureFromLayout(t, e, n, a);
                    return this.createTextureDataFromTexture(e, t, o, i);
                  }
                  reshapeUnpacked(e, t) {
                    let n = this.getOrCreateTextureData(e, d.TextureType.unpacked),
                      r = {
                        channels: n.channels,
                        height: n.height,
                        width: n.width,
                        shape: t.length === 0 ? [1] : t,
                        strides: a.ShapeUtil.computeStrides(t),
                        unpackedShape: t,
                      };
                    return this.createTextureDataFromTexture(r, e.type, n.texture).tensor;
                  }
                  reshapePacked(e, t) {
                    let n = this.getOrCreateTextureData(e, d.TextureType.packed);
                    if ((0, s.isReshapeCheap)(e.dims, t)) {
                      let r = {
                        channels: n.channels,
                        height: n.height,
                        width: n.width,
                        shape: t.length === 0 ? [1] : t,
                        strides: a.ShapeUtil.computeStrides(t),
                        unpackedShape: t,
                        isPacked: !0,
                      };
                      return this.createTextureDataFromTexture(r, e.type, n.texture).tensor;
                    }
                    let r = (0, s.processDims3D)(e.dims),
                      i = (0, s.processDims3D)(t),
                      o = this.reshapePacked(e, r),
                      c = this.run((0, s.createPackedReshape3DProgramInfoLoader)(this, o, i), [o]);
                    return this.reshapePacked(c, t);
                  }
                  cast(e, t) {
                    let n = this.getOrCreateTextureData(e, d.TextureType.unpacked);
                    return this.createTextureDataFromTexture(n, t, n.texture).tensor;
                  }
                  createTextureDataFromTexture(e, t, n, r, a) {
                    let o = Object.assign(Object.assign({}, e), {
                      tensor:
                        r ||
                        new i.Tensor(
                          e.unpackedShape,
                          t,
                          (e) => this.readTexture(o),
                          async (e) => this.readTextureAsync(o),
                          void 0,
                          a,
                        ),
                      texture: n,
                    });
                    return (this.setTextureData(o.tensor.dataId, o, e.isPacked), o);
                  }
                  getTextureData(e, t = !1) {
                    return this.session.isInitializer(e)
                      ? this.session.getTextureData(e, t)
                      : t
                        ? this.packedTextureDataCache.get(e)
                        : this.unpackedTextureDataCache.get(e);
                  }
                  setTextureData(e, t, n = !1) {
                    this.session.isInitializer(e)
                      ? this.session.setTextureData(e, t, n)
                      : (n ? this.packedTextureDataCache : this.unpackedTextureDataCache).set(e, t);
                  }
                  isTextureLayoutCached(e, t = !1) {
                    return !!this.getTextureData(e.dataId, t);
                  }
                  dispose() {
                    (this.session.textureManager.clearActiveTextures(),
                      this.packedTextureDataCache.forEach((e) => this.session.textureManager.releaseTexture(e)),
                      (this.packedTextureDataCache = new Map()),
                      this.unpackedTextureDataCache.forEach((e) => this.session.textureManager.releaseTexture(e)),
                      (this.unpackedTextureDataCache = new Map()));
                  }
                  readTexture(e) {
                    return e.isPacked
                      ? this.readTexture(this.unpack(e))
                      : this.session.backend.glContext.isFloat32DownloadSupported
                        ? this.session.textureManager.readTexture(e, e.tensor.type, e.channels)
                        : this.session.textureManager.readUint8TextureAsFloat((0, c.encodeAsUint8)(this, e));
                  }
                  async readTextureAsync(e) {
                    return e.isPacked
                      ? this.readTextureAsync(this.unpack(e))
                      : this.session.backend.glContext.isFloat32DownloadSupported
                        ? this.session.textureManager.readTextureAsync(e, e.tensor.type, e.channels)
                        : this.session.textureManager.readUint8TextureAsFloat((0, c.encodeAsUint8)(this, e));
                  }
                  pack(e) {
                    return this.executeProgram((0, o.createPackProgramInfoLoader)(this, e.tensor), [e.tensor]);
                  }
                  unpack(e) {
                    return this.executeProgram((0, l.createUnpackProgramInfoLoader)(this, e.tensor), [e.tensor]);
                  }
                };
              },
              1640: function (e, t, n) {
                'use strict';
                var r =
                    (this && this.__createBinding) ||
                    (Object.create
                      ? function (e, t, n, r) {
                          r === void 0 && (r = n);
                          var i = Object.getOwnPropertyDescriptor(t, n);
                          ((i && !(`get` in i ? !t.__esModule : i.writable || i.configurable)) ||
                            (i = {
                              enumerable: !0,
                              get: function () {
                                return t[n];
                              },
                            }),
                            Object.defineProperty(e, r, i));
                        }
                      : function (e, t, n, r) {
                          (r === void 0 && (r = n), (e[r] = t[n]));
                        }),
                  i =
                    (this && this.__setModuleDefault) ||
                    (Object.create
                      ? function (e, t) {
                          Object.defineProperty(e, `default`, { enumerable: !0, value: t });
                        }
                      : function (e, t) {
                          e.default = t;
                        }),
                  a =
                    (this && this.__importStar) ||
                    function (e) {
                      if (e && e.__esModule) return e;
                      var t = {};
                      if (e != null)
                        for (var n in e) n !== `default` && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
                      return (i(t, e), t);
                    };
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.WEBGL_OP_RESOLVE_RULES = void 0));
                let o = n(2898),
                  s = a(n(7839)),
                  c = n(4196),
                  l = n(2069),
                  u = n(8138),
                  d = n(9663),
                  f = n(5193),
                  p = n(7992),
                  m = n(1253),
                  h = n(4776),
                  g = n(6572),
                  _ = n(3346),
                  v = n(5623),
                  y = n(2870),
                  b = n(2143),
                  x = n(4939),
                  S = n(718),
                  C = n(2268),
                  w = n(8117),
                  T = n(2278),
                  E = n(5524),
                  D = n(5975),
                  O = n(3933),
                  k = n(6558),
                  A = n(5723),
                  j = n(3738),
                  M = a(n(4909)),
                  N = n(8428),
                  P = n(9793);
                t.WEBGL_OP_RESOLVE_RULES = [
                  [`Abs`, ``, `6+`, M.abs],
                  [`Acos`, ``, `7+`, M.acos],
                  [`Add`, ``, `7+`, s.add],
                  [`And`, ``, `7+`, s.and],
                  [`Asin`, ``, `7+`, M.asin],
                  [`Atan`, ``, `7+`, M.atan],
                  [`AveragePool`, ``, `7+`, b.averagePool, b.parseAveragePoolAttributes],
                  [`BatchNormalization`, ``, `7+`, o.batchNormalization, o.parseBatchNormalizationAttributes],
                  [`Cast`, ``, `6+`, c.cast, c.parseCastAttributes],
                  [`Ceil`, ``, `6+`, M.ceil],
                  [`Clip`, ``, `6-10`, M.clip, M.parseClipAttributes],
                  [`Clip`, ``, `11+`, M.clipV11],
                  [`Concat`, ``, `4+`, l.concat, l.parseConcatAttributes],
                  [`Conv`, ``, `1+`, u.conv, u.parseConvAttributes],
                  [`ConvTranspose`, ``, `1+`, d.convTranspose, d.parseConvTransposeAttributes],
                  [`Cos`, ``, `7+`, M.cos],
                  [`Div`, ``, `7+`, s.div],
                  [`Dropout`, ``, `7+`, M.identity],
                  [`DepthToSpace`, ``, `1+`, f.depthToSpace, f.parseDepthToSpaceAttributes],
                  [`Equal`, ``, `7+`, s.equal],
                  [`Elu`, ``, `6+`, M.elu, M.parseEluAttributes],
                  [`Exp`, ``, `6+`, M.exp],
                  [`Flatten`, ``, `1+`, p.flatten, p.parseFlattenAttributes],
                  [`Floor`, ``, `6+`, M.floor],
                  [`FusedConv`, `com.microsoft`, `1+`, u.conv, u.parseConvAttributes],
                  [`Gather`, ``, `1+`, m.gather, m.parseGatherAttributes],
                  [`Gemm`, ``, `7-10`, h.gemm, h.parseGemmAttributesV7],
                  [`Gemm`, ``, `11+`, h.gemm, h.parseGemmAttributesV11],
                  [`GlobalAveragePool`, ``, `1+`, b.globalAveragePool, b.parseGlobalAveragePoolAttributes],
                  [`GlobalMaxPool`, ``, `1+`, b.globalMaxPool],
                  [`Greater`, ``, `7+`, s.greater],
                  [`Identity`, ``, `1+`, M.identity],
                  [`ImageScaler`, ``, `1+`, g.imageScaler, g.parseImageScalerAttributes],
                  [`InstanceNormalization`, ``, `6+`, _.instanceNormalization, _.parseInstanceNormalizationAttributes],
                  [`LeakyRelu`, ``, `6+`, M.leakyRelu, M.parseLeakyReluAttributes],
                  [`Less`, ``, `7+`, s.less],
                  [`Log`, ``, `6+`, M.log],
                  [`MatMul`, ``, `1+`, v.matMul, v.parseMatMulAttributes],
                  [`MaxPool`, ``, `1+`, b.maxPool, b.parseMaxPoolAttributes],
                  [`Mul`, ``, `7+`, s.mul],
                  [`Neg`, ``, `6+`, M.neg],
                  [`Not`, ``, `1+`, M.not],
                  [`Or`, ``, `7+`, s.or],
                  [`Pad`, ``, `2-10`, y.padV2, y.parsePadAttributesV2],
                  [`Pad`, ``, `11+`, y.padV11, y.parsePadAttributesV11],
                  [`Pow`, ``, `7+`, s.pow],
                  [`PRelu`, ``, `7+`, s.pRelu],
                  [`ReduceLogSum`, ``, `1+`, x.reduceLogSum, x.parseReduceAttributes],
                  [`ReduceMax`, ``, `1+`, x.reduceMax, x.parseReduceAttributes],
                  [`ReduceMean`, ``, `1+`, x.reduceMean, x.parseReduceAttributes],
                  [`ReduceMin`, ``, `1+`, x.reduceMin, x.parseReduceAttributes],
                  [`ReduceProd`, ``, `1+`, x.reduceProd, x.parseReduceAttributes],
                  [`ReduceSum`, ``, `1-12`, x.reduceSum, x.parseReduceAttributes],
                  [`ReduceSumSquare`, ``, `1+`, x.reduceLogSumSquare, x.parseReduceAttributes],
                  [`Relu`, ``, `6+`, M.relu],
                  [`Reshape`, ``, `5+`, S.reshape],
                  [`Resize`, ``, `10`, C.resize, C.parseResizeAttributesV10],
                  [`Resize`, ``, `11+`, C.resize, C.parseResizeAttributesV11],
                  [`Shape`, ``, `1+`, w.shape],
                  [`Sigmoid`, ``, `6+`, M.sigmoid],
                  [`Sin`, ``, `7+`, M.sin],
                  [`Slice`, ``, `10+`, T.sliceV10],
                  [`Slice`, ``, `1-9`, T.slice, T.parseSliceAttributes],
                  [`Softmax`, ``, `1-12`, E.softmax, E.parseSoftmaxAttributes],
                  [`Softmax`, ``, `13+`, E.softmaxV13, E.parseSoftmaxAttributesV13],
                  [`Split`, ``, `2-12`, D.split, D.parseSplitAttributes],
                  [`Sqrt`, ``, `6+`, M.sqrt],
                  [`Squeeze`, ``, `1-12`, O.squeeze, O.parseSqueezeAttributes],
                  [`Squeeze`, ``, `13+`, O.squeezeV13],
                  [`Sub`, ``, `7+`, s.sub],
                  [`Sum`, ``, `6+`, k.sum],
                  [`Tan`, ``, `7+`, M.tan],
                  [`Tanh`, ``, `6+`, M.tanh],
                  [`Tile`, ``, `6+`, A.tile],
                  [`Transpose`, ``, `1+`, j.transpose, j.parseTransposeAttributes],
                  [`Upsample`, ``, `7-8`, P.upsample, P.parseUpsampleAttributesV7],
                  [`Upsample`, ``, `9`, P.upsample, P.parseUpsampleAttributesV9],
                  [`Unsqueeze`, ``, `1-12`, N.unsqueeze, N.parseUnsqueezeAttributes],
                  [`Unsqueeze`, ``, `13+`, N.unsqueezeV13],
                  [`Xor`, ``, `7+`, s.xor],
                ];
              },
              2898: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseBatchNormalizationAttributes = t.batchNormalization = void 0));
                let r = n(246),
                  i = n(5060),
                  a = n(2039),
                  o = {
                    name: `BatchNormalization`,
                    inputNames: [`A`, `Scale`, `B`, `Mean`, `Variance`],
                    inputTypes: [
                      a.TextureType.unpacked,
                      a.TextureType.unpacked,
                      a.TextureType.unpacked,
                      a.TextureType.unpacked,
                      a.TextureType.unpacked,
                    ],
                  };
                ((t.batchNormalization = (e, t, n) => (
                  c(t),
                  [e.run(Object.assign(Object.assign({}, o), { cacheHint: n.cacheKey, get: () => s(e, t, n) }), t)]
                )),
                  (t.parseBatchNormalizationAttributes = (e) => {
                    let t = e.attributes.getFloat(`epsilon`, 1e-5),
                      n = e.attributes.getFloat(`momentum`, 0.9),
                      i = e.attributes.getInt(`spatial`, 1);
                    return (0, r.createAttributeWithCacheKey)({ epsilon: t, momentum: n, spatial: i });
                  }));
                let s = (e, t, n) => {
                    let r = (0, i.getGlsl)(e.session.backend.glContext.version),
                      s = t[0].dims.length,
                      [c, l] = e.calculateTextureWidthAndHeight(t[1].dims, a.TextureType.unpacked),
                      u = `\n  float process(int[${s}] indices) {\n    vec2 position = offsetToCoords(indices[1], ${c}, ${l});\n    float scale = getColorAsFloat(${r.texture2D}(Scale, position));\n    float mean = getColorAsFloat(${r.texture2D}(Mean, position));\n    float variance = getColorAsFloat(${r.texture2D}(Variance, position));\n    float b = getColorAsFloat(${r.texture2D}(B, position));\n\n    return scale * ( (_A(indices) - mean) / sqrt(variance + float(${n.epsilon})) ) + b;\n  }`;
                    return Object.assign(Object.assign({}, o), {
                      output: { dims: t[0].dims, type: t[0].type, textureType: a.TextureType.unpacked },
                      shaderSource: u,
                    });
                  },
                  c = (e) => {
                    if (!e || e.length !== 5) throw Error(`BatchNormalization requires 5 inputs.`);
                    let t = e[0],
                      n = e[1],
                      r = e[2],
                      i = e[3],
                      a = e[4];
                    if (
                      t.dims.length < 3 ||
                      n.dims.length !== 1 ||
                      r.dims.length !== 1 ||
                      i.dims.length !== 1 ||
                      a.dims.length !== 1 ||
                      n.dims[0] !== t.dims[1] ||
                      r.dims[0] !== t.dims[1] ||
                      i.dims[0] !== t.dims[1] ||
                      a.dims[0] !== t.dims[1]
                    )
                      throw Error(`invalid input shape.`);
                    if (
                      (t.type !== `float32` && t.type !== `float64`) ||
                      (n.type !== `float32` && n.type !== `float64`) ||
                      (r.type !== `float32` && r.type !== `float64`) ||
                      (i.type !== `float32` && i.type !== `float64`) ||
                      (a.type !== `float32` && a.type !== `float64`)
                    )
                      throw Error(`invalid input tensor types.`);
                  };
              },
              7839: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.xor =
                    t.sub =
                    t.pRelu =
                    t.pow =
                    t.or =
                    t.mul =
                    t.less =
                    t.greater =
                    t.equal =
                    t.div =
                    t.and =
                    t.add =
                    t.glslPRelu =
                    t.glslPow =
                    t.glslXor =
                    t.glslOr =
                    t.glslAnd =
                    t.glslLess =
                    t.glslGreater =
                    t.glslEqual =
                    t.glslSub =
                    t.glslMul =
                    t.glslDiv =
                    t.glslAdd =
                      void 0));
                let r = n(2517),
                  i = n(8520),
                  a = n(5060),
                  o = n(2039);
                function s() {
                  let e = `add_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return a + b;\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    return v1 + v2;\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function c() {
                  let e = `div_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return a / b;\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    return v1 / v2;\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function l() {
                  let e = `mul_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return a * b;\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    return v1 * v2;\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function u() {
                  let e = `sub_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return a - b;\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    return v1 - v2;\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function d() {
                  let e = `equal_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return float(a == b);\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    return vec4(equal(v1, v2));\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function f() {
                  let e = `greater_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return float(a > b);\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    return vec4( v1.r > v2.r ,\n      v1.g > v2.g,\n      v1.b > v2.b,\n      v1.a > v2.a );\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function p() {
                  let e = `less_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return float(a < b);\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    return vec4( v1.r < v2.r ,\n                v1.g < v2.g,\n                v1.b < v2.b,\n                v1.a < v2.a );\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function m() {
                  let e = `and_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return float( bool(a) && bool(b) );\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    bvec4 b1 = bvec4(v1);\n    bvec4 b2 = bvec4(v2);\n    return vec4( b1.r && b2.r ,\n                b1.g && b2.g,\n                b1.b && b2.b,\n                b1.a && b2.a );\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function h() {
                  let e = `or_`;
                  return {
                    body: `
  float or_(float a, float b) {
    return float( bool(a) || bool(b) );
  }
  vec4 or_(vec4 v1, vec4 v2) {
    bvec4 b1 = bvec4(v1);
    bvec4 b2 = bvec4(v2);
    return vec4( b1.r || b2.r ,
                b1.g || b2.g,
                b1.b || b2.b,
                b1.a || b2.a );
  }
  `,
                    name: `or_`,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function g() {
                  let e = `xor_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return float( bool(a) ^^ bool(b) );\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    bvec4 b1 = bvec4(v1);\n    bvec4 b2 = bvec4(v2);\n    return vec4( b1.r ^^ b2.r ,\n                b1.g ^^ b2.g,\n                b1.b ^^ b2.b,\n                b1.a ^^ b2.a );\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                function _() {
                  return (function (e) {
                    let t = `${e}_`;
                    return {
                      body: `\n  float ${t}(float a, float b) {\n    return ${e}(a, b);\n  }\n  vec4 ${t}(vec4 v1, vec4 v2) {\n    return ${e}(v1, v2);\n  }\n  `,
                      name: t,
                      type: i.FunctionType.ValueBased,
                    };
                  })(`pow`);
                }
                function v() {
                  let e = `prelu_`;
                  return {
                    body: `\n  float ${e}(float a, float b) {\n    return a < 0.0 ? a * b: a;\n  }\n  vec4 ${e}(vec4 v1, vec4 v2) {\n    return vec4(\n      v1.r < 0.0 ? v1.r * v2.r: v1.r,\n      v1.g < 0.0 ? v1.g * v2.g: v1.g,\n      v1.b < 0.0 ? v1.b * v2.b: v1.b,\n      v1.a < 0.0 ? v1.a * v2.a: v1.a\n      );\n  }\n  `,
                    name: e,
                    type: i.FunctionType.ValueBased,
                  };
                }
                ((t.glslAdd = s),
                  (t.glslDiv = c),
                  (t.glslMul = l),
                  (t.glslSub = u),
                  (t.glslEqual = d),
                  (t.glslGreater = f),
                  (t.glslLess = p),
                  (t.glslAnd = m),
                  (t.glslOr = h),
                  (t.glslXor = g),
                  (t.glslPow = _),
                  (t.glslPRelu = v));
                let y = (e, t, n, r = t[0].type, i) => {
                    let a = e.session.pack ? o.TextureType.packed : o.TextureType.unpacked;
                    return {
                      name: n.name,
                      inputNames: [`A`, `B`],
                      inputTypes: [a, a],
                      cacheHint: i,
                      get: () => b(e, t, n, r),
                    };
                  },
                  b = (e, t, n, i = t[0].type) => {
                    let s = e.session.pack ? o.TextureType.packed : o.TextureType.unpacked,
                      c = !r.ShapeUtil.areEqual(t[0].dims, t[1].dims),
                      l = t[0].dims,
                      u = e.session.pack;
                    if (c) {
                      let o = r.BroadcastUtil.calcShape(t[0].dims, t[1].dims, !1);
                      if (!o) throw Error(`Can't perform binary op on the given tensors`);
                      l = o;
                      let c = l.length,
                        d = t[0].dims.length === 0 ? 1 : t[0].dims.length,
                        f = t[1].dims.length === 0 ? 1 : t[1].dims.length,
                        p = t[0].dims.length === 0 ? `aindices[0] = 0;` : `bcastIndices_A(indices, aindices);`,
                        m = t[1].dims.length === 0 ? `bindices[0] = 0;` : `bcastIndices_B(indices, bindices);`,
                        h = (0, a.getGlsl)(e.session.backend.glContext.version),
                        g = u
                          ? `\n      ${n.body}\n      void main() {\n        vec4 a = getAAtOutCoords();\n        vec4 b = getBAtOutCoords();\n        vec4 result = ${n.name}(a, b);\n        ${h.output} = result;\n      }`
                          : `\n      ${n.body}\n      float process(int indices[${c}]) {\n        int aindices[${d}];\n        int bindices[${f}];\n        ${p}\n        ${m}\n        return ${n.name}(_A(aindices), _B(bindices));\n      }`;
                      return {
                        name: n.name,
                        inputNames: [`A`, `B`],
                        inputTypes: [s, s],
                        output: { dims: l, type: i, textureType: s },
                        shaderSource: g,
                        hasMain: u,
                      };
                    }
                    let d = (0, a.getGlsl)(e.session.backend.glContext.version),
                      f = `\n    ${n.body}\n    void main() {\n      vec4 v1 = ${d.texture2D}(A, TexCoords);\n      vec4 v2 = ${d.texture2D}(B, TexCoords);\n      vec4 result = ${n.name}(v1, v2);\n      ${d.output} = result;\n    }\n    `;
                    return {
                      name: n.name,
                      inputNames: [`A`, `B`],
                      inputTypes: [s, s],
                      output: { dims: t[0].dims, type: i, textureType: s },
                      shaderSource: f,
                      hasMain: !0,
                    };
                  };
                ((t.add = (e, t) => [e.run(y(e, t, s()), t)]),
                  (t.and = (e, t) => [e.run(y(e, t, m(), `bool`), t)]),
                  (t.div = (e, t) => [e.run(y(e, t, c()), t)]),
                  (t.equal = (e, t) => [e.run(y(e, t, d(), `bool`), t)]),
                  (t.greater = (e, t) => [e.run(y(e, t, f(), `bool`), t)]),
                  (t.less = (e, t) => [e.run(y(e, t, p(), `bool`), t)]),
                  (t.mul = (e, t) => [e.run(y(e, t, l()), t)]),
                  (t.or = (e, t) => [e.run(y(e, t, h(), `bool`), t)]),
                  (t.pow = (e, t) => [e.run(y(e, t, _()), t)]),
                  (t.pRelu = (e, t) => [e.run(y(e, t, v()), t)]),
                  (t.sub = (e, t) => [e.run(y(e, t, u()), t)]),
                  (t.xor = (e, t) => [e.run(y(e, t, g(), `bool`), t)]));
              },
              4196: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.parseCastAttributes = t.cast = void 0));
                let r = n(2517);
                ((t.cast = (e, t, n) => (i(t), [e.cast(t[0], n)])),
                  (t.parseCastAttributes = (e) => r.ProtoUtil.tensorDataTypeFromProto(e.attributes.getInt(`to`))));
                let i = (e) => {
                  if (!e || e.length !== 1) throw Error(`Cast requires 1 input.`);
                  if (e[0].type === `string`) throw Error(`Invalid input type.`);
                };
              },
              1163: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.createPackedConcatProgramInfoLoader = void 0));
                let r = n(5060),
                  i = n(2039),
                  a = n(9390),
                  o = n(2827);
                t.createPackedConcatProgramInfoLoader = (e, t, n) => {
                  let c =
                    ((l = t.length),
                    (u = n.cacheKey),
                    {
                      name: `Concat (packed)`,
                      inputNames: Array.from({ length: l }, (e, t) => `X${t}`),
                      inputTypes: Array(l).fill(i.TextureType.packed),
                      cacheHint: u,
                    });
                  var l, u;
                  return Object.assign(Object.assign({}, c), {
                    get: () =>
                      ((e, t, n, c) => {
                        let l = n[0].dims.slice();
                        if (c >= l.length || c < -1 * l.length)
                          throw Error(`axis specified for concat doesn't match input dimensionality`);
                        c < 0 && (c = l.length + c);
                        let u = l.slice(0);
                        for (let e = 1; e < n.length; e++) {
                          let t = n[e].dims.slice();
                          for (let e = 0; e < l.length; e++)
                            if (e === c) u[c] += t[e];
                            else if (l[e] !== t[e]) throw Error(`non concat dimensions must match`);
                        }
                        let d = u.length,
                          f = (0, o.getChannels)(`coords`, d),
                          p = (0, a.getCoordsDataType)(d),
                          m = (0, o.unpackFromChannel)(),
                          h = n.map((e) => e.dims),
                          g = (0, a.getGlChannels)(d),
                          _ = Array(h.length - 1);
                        _[0] = h[0][c];
                        for (let e = 1; e < _.length; e++) _[e] = _[e - 1] + h[e][c];
                        let v = g[c],
                          y = g.slice(-2),
                          b = g.join(),
                          x = `if (${v} < ${_[0]}) {\n        return getChannel(\n            getX0(${b}), vec2(${y.join()}));\n        }`;
                        for (let e = 1; e < _.length; e++) {
                          let t = _[e - 1];
                          x += `\n            if (${v} < ${_[e]}  && ${v} >= ${_[e - 1]}) {\n              return getChannel(\n                getX${e}(${s(g, v, t)}),\n                vec2(${s(y, v, t)}));\n            }`;
                        }
                        let S = _.length,
                          C = _[_.length - 1];
                        x += `\n            return getChannel(\n              getX${S}(${s(g, v, C)}),\n              vec2(${s(y, v, C)}));`;
                        let w = (0, r.getGlsl)(e.session.backend.glContext.version),
                          T = `\n          ${m}\n          float getValue(${g.map((e) => `int ` + e)}) {\n            ${x}\n          }\n\n          void main() {\n            ${p} coords = getOutputCoords();\n            int lastDim = coords.${g[d - 1]};\n            coords.${g[d - 1]} = coords.${g[d - 2]};\n            coords.${g[d - 2]} = lastDim;\n\n            vec4 result = vec4(getValue(${f}), 0., 0., 0.);\n\n            ${f[d - 1]} = ${f[d - 1]} + 1;\n            if (${f[d - 1]} < ${u[d - 1]}) {\n              result.g = getValue(${f});\n            }\n\n            ${f[d - 2]} = ${f[d - 2]} + 1;\n            if (${f[d - 2]} < ${u[d - 2]}) {\n              result.a = getValue(${f});\n            }\n\n            ${f[d - 1]} = ${f[d - 1]} - 1;\n            if (${f[d - 2]} < ${u[d - 2]} &&\n                ${f[d - 1]} < ${u[d - 1]}) {\n              result.b = getValue(${f});\n            }\n            ${w.output} = result;\n          }\n        `;
                        return Object.assign(Object.assign({}, t), {
                          output: { dims: u, type: n[0].type, textureType: i.TextureType.packed },
                          shaderSource: T,
                          hasMain: !0,
                        });
                      })(e, c, t, n.axis),
                  });
                };
                let s = (e, t, n) => {
                  let r = e.indexOf(t);
                  return e.map((e, t) => (t === r ? `${e} - ${n}` : e)).join();
                };
              },
              2069: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.parseConcatAttributes = t.concat = void 0));
                let r = n(246),
                  i = n(2039),
                  a = n(1163);
                t.concat = (e, t, n) => (
                  d(t),
                  e.session.pack && t[0].dims.length > 1
                    ? [e.run((0, a.createPackedConcatProgramInfoLoader)(e, t, n), t)]
                    : [e.run(o(e, t, n), t)]
                );
                let o = (e, t, n) => {
                    let r =
                      ((a = t.length),
                      (o = n.cacheKey),
                      {
                        name: `Concat`,
                        inputNames: Array.from({ length: a }, (e, t) => `X${t}`),
                        inputTypes: Array(a).fill(i.TextureType.unpacked),
                        cacheHint: o,
                      });
                    var a, o;
                    return Object.assign(Object.assign({}, r), {
                      get: () =>
                        ((e, t, n, r) => {
                          let a = n[0].dims.slice();
                          if (r >= a.length || r < -1 * a.length)
                            throw Error(`axis specified for concat doesn't match input dimensionality`);
                          r < 0 && (r = a.length + r);
                          let o = a.slice(0);
                          for (let e = 1; e < n.length; e++) {
                            let t = n[e].dims.slice();
                            for (let e = 0; e < a.length; e++)
                              if (e === r) o[r] += t[e];
                              else if (a[e] !== t[e]) throw Error(`non concat dimensions must match`);
                          }
                          let d = o.length,
                            f = Array(n.length),
                            p = 0;
                          for (let e = 0; e < f.length; ++e) ((p += n[e].dims[r]), (f[e] = p));
                          let m = ``;
                          m = n.length < 5 ? s(f) : c(f);
                          let h = `\n        ${l(n.length, d)}\n        ${u(f)}\n        ${m}\n        float process(int indices[${d}]) {\n          int textureIndex = getTextureWhereDataResides (indices[${r}]);\n\n          if(textureIndex != 0) {\n            indices[${r}] = indices[${r}] - int(getSizeInConcatAxisValueFromIndex(textureIndex-int(1)));\n          }\n\n          return fetchDataFromCorrectTexture(textureIndex, indices);\n        }`;
                          return Object.assign(Object.assign({}, t), {
                            output: { dims: o, type: n[0].type, textureType: i.TextureType.unpacked },
                            shaderSource: h,
                          });
                        })(0, r, t, n.axis),
                    });
                  },
                  s = (e) =>
                    `int getTextureWhereDataResides(int index) {\n      ${e.map((e, t) => `if(index<${e}) {return ${t};}\n`).join(``)}\n    }`,
                  c = (e) => s(e),
                  l = (e, t) => {
                    let n = [`float fetchDataFromCorrectTexture(int textureIndex, int indices[${t}]) {`];
                    for (let t = 0; t < e; ++t)
                      t === 0
                        ? n.push(`\tif (textureIndex == ${t}) { return _X${t}(indices); }`)
                        : t === e - 1
                          ? n.push(`\telse { return _X${t}(indices); }`)
                          : n.push(`\telse if (textureIndex == ${t}) { return _X${t}(indices); }`);
                    return (
                      n.push(`	}`),
                      n.join(`
`)
                    );
                  },
                  u = (e) => {
                    let t = [`int getSizeInConcatAxisValueFromIndex(int index) {`];
                    for (let n = 0; n < e.length; ++n)
                      n === 0
                        ? t.push(`\tif (index == ${n}) { return ${e[n]}; }`)
                        : n === e.length - 1
                          ? t.push(`\telse { return ${e[n]}; }`)
                          : t.push(`\telse if (index == ${n}) { return ${e[n]}; }`);
                    return (
                      t.push(`	}`),
                      t.join(`
`)
                    );
                  };
                t.parseConcatAttributes = (e) =>
                  (0, r.createAttributeWithCacheKey)({ axis: e.attributes.getInt(`axis`) });
                let d = (e) => {
                  if (!e || e.length < 1) throw Error(`too few inputs`);
                  let t = e[0].type,
                    n = e[0].dims.length;
                  if (t === `string`) throw Error(`string tensor is not supported yet`);
                  for (let r of e) {
                    if (r.type !== t) throw Error(`input tensors should be one type`);
                    if (r.dims.length !== n) throw Error(`input tensors should have the same shape`);
                  }
                };
              },
              4770: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.createUnpackedGroupedConvProgramInfoLoader = void 0));
                let r = n(6231),
                  i = n(5060),
                  a = n(2039),
                  o = n(8138),
                  s = n(2823);
                t.createUnpackedGroupedConvProgramInfoLoader = (e, t, n) => {
                  let c =
                    ((l = t.length > 2),
                    (u = n.cacheKey),
                    {
                      name: `GroupedConv`,
                      inputNames: l ? [`X`, `W`, `Bias`] : [`X`, `W`],
                      inputTypes: l
                        ? [a.TextureType.unpacked, a.TextureType.unpacked, a.TextureType.unpacked]
                        : [a.TextureType.unpacked, a.TextureType.unpacked],
                      cacheHint: u,
                    });
                  var l, u;
                  return Object.assign(Object.assign({}, c), {
                    get: () =>
                      ((e, t, n, c) => {
                        let l = t.length > 2 ? `value += getBias(output_channel);` : ``,
                          u = t[0].dims.slice(),
                          d = t[1].dims.slice(),
                          f = d[0] / c.group;
                        r.Logger.verbose(
                          `GroupedConv`,
                          `autpPad:${c.autoPad}, dilations:${c.dilations}, group:${c.group}, kernelShape:${c.kernelShape}, pads:${c.pads}, strides:${c.strides}`,
                        );
                        let p = (0, o.calculateOutputShape)(u, d, c.dilations, c.pads, c.strides),
                          m = (0, i.getGlsl)(e.session.backend.glContext.version),
                          { activationFunction: h, applyActivation: g } = (0, s.getActivationSnippet)(c),
                          _ = `\n  const ivec2 strides = ivec2(${c.strides[0]}, ${c.strides[1]});\n  const ivec2 pads = ivec2(${c.pads[0]}, ${c.pads[1]});\n  ${h}\n  void main() {\n    ivec4 coords = getOutputCoords();\n    int batch = coords.x;\n    int output_channel = coords.y;\n    ivec2 xRCCorner = coords.zw * strides - pads;\n    int group_id = output_channel / ${f};\n\n    float value = 0.0;\n    for (int wInChannel = 0; wInChannel < ${d[1]}; wInChannel++) {\n      int input_channel = group_id * ${d[1]} + wInChannel;\n      for (int wHeight = 0; wHeight < ${d[2]}; wHeight++) {\n        int xHeight = xRCCorner.x + wHeight * ${c.dilations[0]};\n\n        if (xHeight < 0 || xHeight >= ${u[2]}) {\n          continue;\n        }\n\n        for (int wWidth = 0; wWidth < ${d[3]}; wWidth++) {\n          int xWidth = xRCCorner.y + wWidth * ${c.dilations[1]};\n          if (xWidth < 0 || xWidth >= ${u[3]}) {\n            continue;\n          }\n\n          float xVal = getX(batch, input_channel, xWidth, xHeight);\n          float wVal = getW(output_channel, wInChannel, wWidth, wHeight);\n          value += xVal*wVal;\n        }\n      }\n    }\n    ${l}\n    ${g}\n    ${m.output} = vec4(value, .0, .0, .0);\n  }\n`;
                        return Object.assign(Object.assign({}, n), {
                          output: { dims: p, type: t[0].type, textureType: a.TextureType.unpacked },
                          shaderSource: _,
                          hasMain: !0,
                        });
                      })(e, t, c, n),
                  });
                };
              },
              1386: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.conv2DPacked = t.conv2DPackedPointwise = void 0));
                let r = n(8138),
                  i = n(8555),
                  a = n(708);
                ((t.conv2DPackedPointwise = (e, t, n) => {
                  let i = t[0].dims,
                    o = t[1].dims,
                    s = (0, r.calculateOutputShape)(i, o, n.dilations, n.pads, n.strides),
                    c = e.reshapePacked(t[0], [i[1], i[2] * i[3]]),
                    l = e.reshapePacked(t[1], [o[0], o[1]]),
                    u = t.length > 2 ? [l, c, t[2]] : [l, c],
                    d = e.run((0, a.createPackedMatmulProgramInfoLoader)(e, u, n), u);
                  return e.reshapePacked(d, s);
                }),
                  (t.conv2DPacked = (e, t, n) => {
                    let o = t[0].dims,
                      s = t[1].dims,
                      c = (0, r.calculateOutputShape)(o, s, n.dilations, n.pads, n.strides),
                      l = e.run((0, i.createPackedIm2ColProgramInfoLoader)(e, t[0], t[1], c, n), [t[0]]),
                      u = e.reshapePacked(t[1], [s[0], s[1] * s[2] * s[3]]),
                      d = t.length === 3 ? [u, l, t[2]] : [u, l],
                      f = e.run((0, a.createPackedMatmulProgramInfoLoader)(e, d, n), d);
                    return e.reshapePacked(f, c);
                  }));
              },
              9663: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseConvTransposeAttributes = t.convTranspose = void 0));
                let r = n(246),
                  i = n(5060),
                  a = n(2039),
                  o = n(2823),
                  s = (e, t, n, r, i, a) => (e - 1) * t + n + (r - 1) * i + 1 - a,
                  c = (e, t, n, r, i) => {
                    let a = Math.floor(e / 2);
                    t === `SAME_UPPER`
                      ? ((n[r] = a), (n[i] = e - a))
                      : t === `SAME_LOWER` && ((n[r] = e - a), (n[i] = a));
                  };
                t.convTranspose = (e, t, n) => (f(t, n), l(e, t, n));
                let l = (e, t, n) => [u(e, t, d(n, t))],
                  u = (e, t, n) =>
                    e.run(
                      ((e, t, n) => {
                        let r =
                          ((s = t.length > 2),
                          (c = n.cacheKey),
                          {
                            name: `ConvTranspose`,
                            inputNames: s ? [`X`, `W`, `B`] : [`X`, `W`],
                            inputTypes: s
                              ? [a.TextureType.unpacked, a.TextureType.unpacked, a.TextureType.unpacked]
                              : [a.TextureType.unpacked, a.TextureType.unpacked],
                            cacheHint: c,
                          });
                        var s, c;
                        return Object.assign(Object.assign({}, r), {
                          get: () =>
                            ((e, t, n, r) => {
                              let s = t.length > 2 ? `getB(output_channel)` : `0.0`,
                                c = t[0].dims,
                                l = t[1].dims,
                                u = l[1],
                                d = l[0] / r.group,
                                f = [t[0].dims[0], t[1].dims[1] * r.group, ...r.outputShape],
                                p = (0, i.getGlsl)(e.session.backend.glContext.version),
                                { activationFunction: m, applyActivation: h } = (0, o.getActivationSnippet)(r),
                                g = `\n  const ivec2 strides = ivec2(${r.strides[0]}, ${r.strides[1]});\n  const ivec2 pads = ivec2(${r.pads[0]}, ${r.pads[1]});\n  ${m}\n  void main() {\n    ivec4 coords = getOutputCoords();\n    int batch = coords.x;\n    int output_channel = coords.y;\n\n    ivec2 loc = coords.zw + pads;\n\n    int group_id = output_channel / ${u};\n    int wOutChannel = output_channel - group_id * ${u};\n\n    float value = ${s};\n    for (int inChannelOffset = 0; inChannelOffset < ${d}; inChannelOffset++) {\n      int input_channel = group_id * ${d} + inChannelOffset;\n      for (int wWOff = 0; wWOff < ${l[2]}; wWOff++) {\n        for (int wHOff = 0; wHOff < ${l[3]}; wHOff++) {\n          ivec2 wOff = ivec2(wWOff * ${r.dilations[0]}, wHOff * ${r.dilations[1]});\n          ivec2 wLoc = loc - wOff;\n          ivec2 wLocIn = wLoc / strides;\n          if (\n            wLocIn * strides == wLoc &&\n            wLocIn.x >= 0 && wLocIn.x < ${c[2]} &&\n            wLocIn.y >= 0 && wLocIn.y < ${c[3]}\n          ) {\n            float xVal = getX(batch, input_channel, wLocIn.y, wLocIn.x);\n            float wVal = getW(input_channel, wOutChannel, wHOff, wWOff);\n            value += xVal * wVal;\n          }\n        }\n      }\n    }\n    ${h}\n    ${p.output} = vec4(value, .0, .0, .0);\n  }\n`;
                              return Object.assign(Object.assign({}, n), {
                                output: { dims: f, type: t[0].type, textureType: a.TextureType.unpacked },
                                shaderSource: g,
                                hasMain: !0,
                              });
                            })(e, t, r, n),
                        });
                      })(e, t, n),
                      t,
                    ),
                  d = (e, t) => {
                    let n = e.kernelShape.slice();
                    if (e.kernelShape.length === 0) for (let e = 2; e < t[1].dims.length; ++e) n.push(t[1].dims[e]);
                    let r = e.pads.slice(),
                      i = e.outputShape.slice();
                    ((e, t, n, r, i, a, o, l) => {
                      let u = e.length - 2,
                        d = l.length === 0;
                      for (let f = 0; f < u; ++f) {
                        let p = d ? e[f + 2] * a[f] : l[f];
                        (c(s(e[f + 2], a[f], i[f], t[f], n[f], p), r, i, f, f + u),
                          d && l.push(a[f] * (e[f + 2] - 1) + o[f] + (t[f] - 1) * n[f] + 1 - i[f] - i[f + u]));
                      }
                    })(t[0].dims, n, e.dilations, e.autoPad, r, e.strides, e.outputPadding, i);
                    let a = Object.assign({}, e);
                    return (Object.assign(a, { kernelShape: n, pads: r, outputShape: i, cacheKey: e.cacheKey }), a);
                  };
                t.parseConvTransposeAttributes = (e) => {
                  let t = e.attributes,
                    n = (0, o.parseInternalActivationAttributes)(t),
                    i = t.getString(`auto_pad`, `NOTSET`),
                    a = t.getInts(`dilations`, [1, 1]),
                    s = t.getInt(`group`, 1),
                    c = t.getInts(`kernel_shape`, []),
                    l = t.getInts(`output_padding`, [0, 0]),
                    u = t.getInts(`output_shape`, []),
                    d = t.getInts(`pads`, [0, 0, 0, 0]),
                    f = t.getInts(`strides`, [1, 1]);
                  return (0, r.createAttributeWithCacheKey)(
                    Object.assign(
                      {
                        autoPad: i,
                        dilations: a,
                        group: s,
                        kernelShape: c,
                        outputPadding: l,
                        outputShape: u,
                        pads: d,
                        strides: f,
                      },
                      n,
                    ),
                  );
                };
                let f = (e, t) => {
                  if (!e || (e.length !== 2 && e.length !== 3)) throw Error(`Conv requires 2 or 3 inputs`);
                  if (e[0].dims.length !== 4 || e[1].dims.length !== 4)
                    throw Error(`currently only support 2-dimensional conv`);
                  if (e[0].dims[1] !== e[1].dims[0]) throw Error(`FILTER_IN_CHANNEL should be equal to DATA_CHANNEL`);
                  let n = e[1].dims[1] * t.group;
                  if (e.length === 3 && (e[2].dims.length !== 1 || e[2].dims[0] !== n)) throw Error(`invalid bias`);
                  let r = e[0].dims.length - 2;
                  if (t.dilations.length !== r) throw Error(`dilations should be ${r}D`);
                  if (t.strides.length !== r) throw Error(`strides should be ${r}D`);
                  if (t.pads.length !== 2 * r) throw Error(`pads should be ${2 * r}D`);
                  if (t.outputPadding.length !== r) throw Error(`output_padding should be ${r}D`);
                  if (t.kernelShape.length !== 0 && t.kernelShape.length !== e[1].dims.length - 2)
                    throw Error(`invalid kernel shape`);
                  if (t.outputShape.length !== 0 && t.outputShape.length !== e[0].dims.length - 2)
                    throw Error(`invalid output shape`);
                  if (e[0].type !== `float32` || e[1].type !== `float32`)
                    throw Error(`ConvTranspose input(X,W) should be float tensor`);
                  if (e.length === 3 && e[2].type !== `float32`)
                    throw Error(`ConvTranspose input(bias) should be float tensor`);
                };
              },
              8138: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseConvAttributes = t.conv = t.calculateOutputShape = void 0));
                let r = n(246),
                  i = n(2517),
                  a = n(4770),
                  o = n(1386),
                  s = n(9828),
                  c = n(2823),
                  l = n(3248),
                  u = n(5623);
                ((t.calculateOutputShape = (e, t, n, r, i) => {
                  let a = e[0],
                    o = e.slice(2),
                    s = o.length,
                    c = t[0],
                    l = t.slice(2).map((e, t) => e + (e - 1) * (n[t] - 1)),
                    u = o.map((e, t) => e + r[t] + r[t + s]).map((e, t) => Math.floor((e - l[t] + i[t]) / i[t]));
                  return [a, c].concat(...u);
                }),
                  (t.conv = (e, t, n) => (h(t, n), d(e, t, n))));
                let d = (e, t, n) => {
                    let r = m(n, t),
                      i = e.session.pack,
                      s = r.kernelShape[0] === 1 && r.kernelShape[1] === 1;
                    return r.group > 1
                      ? [e.run((0, a.createUnpackedGroupedConvProgramInfoLoader)(e, t, r), t)]
                      : s && i
                        ? [f(e, t, r)]
                        : i && t[0].dims.length === 4 && t[0].dims[0] === 1 && !s
                          ? [(0, o.conv2DPacked)(e, t, r)]
                          : [p(e, t, r)];
                  },
                  f = (e, n, r) => {
                    let i = n[0].dims,
                      a = n[1].dims,
                      o = (0, t.calculateOutputShape)(i, a, r.dilations, r.pads, r.strides),
                      s = e.reshapeUnpacked(n[0], [i[1], i[2] * i[3]]),
                      c = e.reshapeUnpacked(n[1], [a[0], a[1]]),
                      l = n.length > 2 ? [c, s, n[2]] : [c, s],
                      d = e.run((0, u.createMatmulProgramInfoLoader)(l, r), l);
                    return e.reshapeUnpacked(d, o);
                  },
                  p = (e, n, r) => {
                    let i = n[0].dims,
                      a = n[1].dims,
                      o = (0, t.calculateOutputShape)(i, a, r.dilations, r.pads, r.strides),
                      c = e.run((0, l.createIm2ColProgramInfoLoader)(e, n[0], n[1], o, r), [n[0]]),
                      u = n.length === 3 ? [c, n[1], n[2]] : [c, n[1]];
                    return e.run((0, s.createDotProductProgramInfoLoader)(e, n, o, r), u);
                  },
                  m = (e, t) => {
                    let n = e.kernelShape.slice();
                    if (e.kernelShape.length === 0) for (let e = 2; e < t[1].dims.length; ++e) n.push(t[1].dims[e]);
                    let r = e.pads.slice();
                    i.PoolConvUtil.adjustPadsBasedOnAutoPad(t[0].dims, e.strides, e.dilations, n, r, e.autoPad);
                    let a = Object.assign({}, e);
                    return (Object.assign(a, { kernelShape: n, pads: r, cacheKey: e.cacheKey }), a);
                  };
                t.parseConvAttributes = (e) => {
                  let t = e.attributes,
                    n = (0, c.parseInternalActivationAttributes)(t),
                    i = t.getString(`auto_pad`, `NOTSET`),
                    a = t.getInts(`dilations`, [1, 1]),
                    o = t.getInt(`group`, 1),
                    s = t.getInts(`kernel_shape`, []),
                    l = t.getInts(`pads`, [0, 0, 0, 0]),
                    u = t.getInts(`strides`, [1, 1]);
                  return (0, r.createAttributeWithCacheKey)(
                    Object.assign({ autoPad: i, dilations: a, group: o, kernelShape: s, pads: l, strides: u }, n),
                  );
                };
                let h = (e, t) => {
                  if (!e || (e.length !== 2 && e.length !== 3)) throw Error(`Conv requires 2 or 3 inputs`);
                  if (e[0].dims.length !== 4 || e[1].dims.length !== 4)
                    throw Error(`currently only support 2-dimensional conv`);
                  if (e[0].dims[1] !== e[1].dims[1] * t.group)
                    throw Error(`FILTER_IN_CHANNEL should be equal to DATA_CHANNEL`);
                  if (e.length === 3 && (e[2].dims.length !== 1 || e[1].dims[0] !== e[2].dims[0]))
                    throw Error(`invalid bias`);
                  let n = e[0].dims.length - 2;
                  if (t.dilations.length !== n) throw Error(`dilations should be ${n}D`);
                  if (t.strides.length !== n) throw Error(`strides should be ${n}D`);
                  if (t.pads.length !== 2 * n) throw Error(`pads should be ${2 * n}D`);
                  if (t.kernelShape.length !== 0 && t.kernelShape.length !== e[1].dims.length - 2)
                    throw Error(`invalid kernel shape`);
                  if (e[0].type !== `float32` || e[1].type !== `float32`)
                    throw Error(`Conv input(X,W) should be float tensor`);
                  if (e.length === 3 && e[2].type !== `float32`) throw Error(`Conv input(bias) should be float tensor`);
                };
              },
              5193: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseDepthToSpaceAttributes = t.depthToSpace = void 0));
                let r = n(3738);
                ((t.depthToSpace = (e, t, n) => {
                  i(t);
                  let a = n.blocksize,
                    o = a * a,
                    s = n.mode === `DCR` ? [0, 3, 4, 1, 5, 2] : [0, 1, 4, 2, 5, 3],
                    c =
                      n.mode === `DCR`
                        ? [t[0].dims[0], a, a, t[0].dims[1] / o, t[0].dims[2], t[0].dims[3]]
                        : [t[0].dims[0], t[0].dims[1] / o, a, a, t[0].dims[2], t[0].dims[3]],
                    l = e.reshapeUnpacked(t[0], c),
                    u = { perm: s, cacheKey: `${s}` },
                    [d] = (0, r.transpose)(e, [l], u),
                    f = [t[0].dims[0], t[0].dims[1] / o, t[0].dims[2] * a, t[0].dims[3] * a];
                  return [e.reshapeUnpacked(d, f)];
                }),
                  (t.parseDepthToSpaceAttributes = (e) => {
                    let t = e.attributes.getInt(`blocksize`);
                    if (t < 1) throw Error(`blocksize must be >= 1, but got : ${t} for DepthToSpace`);
                    let n = e.attributes.getString(`mode`, `DCR`);
                    if (n !== `DCR` && n !== `CRD`) throw Error(`unrecognized mode: ${n} for DepthToSpace`);
                    return { mode: n, blocksize: t };
                  }));
                let i = (e) => {
                  if (e.length !== 1) throw Error(`DepthToSpace expect 1 inputs, but got ${e.length}`);
                  if (e[0].type === `string` || e[0].dims.length !== 4)
                    throw TypeError(`DepthToSpace input should be a 4-D numeric tensor`);
                };
              },
              9828: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.createDotProductProgramInfoLoader = void 0));
                let r = n(2517),
                  i = n(5060),
                  a = n(2039),
                  o = n(2823),
                  s = n(3248);
                t.createDotProductProgramInfoLoader = (e, t, n, c) => {
                  let l = ((e, t) => ({
                    name: `ConvDotProduct`,
                    inputNames: e ? [`Im2Col`, `K`, `B`] : [`Im2Col`, `K`],
                    inputTypes: e
                      ? [a.TextureType.unpacked, a.TextureType.packedLastDimension, a.TextureType.unpacked]
                      : [a.TextureType.unpacked, a.TextureType.packedLastDimension],
                    cacheKey: t.activationCacheKey,
                  }))(t.length > 2, c);
                  return Object.assign(Object.assign({}, l), {
                    get: () =>
                      ((e, t, n, c, l) => {
                        let u = n[0].dims,
                          d = n[1].dims,
                          f = [d[0], Math.ceil((u[1] * d[2] * d[3]) / 4)],
                          p = (0, s.calculateIm2ColDims)(u, d, c),
                          [m, h] = e.calculateTextureWidthAndHeight(f, a.TextureType.packedLastDimension),
                          g = r.ShapeUtil.computeStrides(p),
                          [_, v] = e.calculateTextureWidthAndHeight(p, a.TextureType.packedLastDimension),
                          y = c.length,
                          b = n.length < 3 ? `0.0` : `_B(b)`,
                          x = Math.ceil((u[1] * d[2] * d[3]) / 4),
                          { activationFunction: S, applyActivation: C } = (0, o.getActivationSnippet)(l),
                          w = (0, i.getGlsl)(e.session.backend.glContext.version),
                          T = `\n${S}\nfloat process(int indices[${y}]) {\n  int b[1];\n  b[0] = indices[1];\n  int im2col[4];\n  im2col[0] = indices[0];\n  im2col[1] = indices[2];\n  im2col[2] = indices[3];\n  int im2colOffset = im2col[0] * ${g[0]} + im2col[1] * ${g[1]} + im2col[2] * ${g[2]};\n  int kernelOffset = indices[1] * ${f[1]};\n  float value = ${b};\n  for (int i = 0; i < ${x}; ++i) {\n    vec2 im2colCoords = offsetToCoords(im2colOffset, ${_}, ${v});\n    vec2 kernelCoords = offsetToCoords(kernelOffset, ${m}, ${h});\n    value += dot(${w.texture2D}(Im2Col, im2colCoords), ${w.texture2D}(K, kernelCoords));\n    ++im2colOffset;\n    ++kernelOffset;\n  }\n  ${C}\n  return value;\n}`;
                        return Object.assign(Object.assign({}, t), {
                          output: { dims: c, type: n[0].type, textureType: a.TextureType.unpacked },
                          shaderSource: T,
                        });
                      })(e, l, t, n, c),
                  });
                };
              },
              7992: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseFlattenAttributes = t.flatten = void 0));
                let r = n(2517);
                ((t.flatten = (e, t, n) => {
                  i(t, n);
                  let a = r.ShapeUtil.flattenShape(t[0].dims, n);
                  return [e.reshapeUnpacked(t[0], a)];
                }),
                  (t.parseFlattenAttributes = (e) => e.attributes.getInt(`axis`, 1)));
                let i = (e, t) => {
                  if (!e || e.length !== 1) throw Error(`Flatten requires 1 input.`);
                  let n = e[0].dims.length;
                  if (n === 0) throw Error(`scalar tensor is not supported.`);
                  if (t < -n || t > n) throw Error(`Invalid axis`);
                  if (e[0].type === `string`) throw Error(`string tensor is not supported.`);
                };
              },
              2823: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseInternalActivationAttributes = t.getActivationSnippet = void 0));
                let r = n(2517),
                  i = n(4909);
                ((t.getActivationSnippet = function (e) {
                  let t;
                  switch (e.activation) {
                    case `Relu`:
                      t = (0, i.glslRelu)();
                      break;
                    case `Sigmoid`:
                      t = (0, i.glslSigmoid)();
                      break;
                    case `Clip`:
                      t = (0, i.glslClip)(e.clipMin, e.clipMax);
                      break;
                    default:
                      return { activationFunction: ``, applyActivation: `` };
                  }
                  let n = t.name;
                  return { activationFunction: t.body, applyActivation: `value = ${n}_(value);` };
                }),
                  (t.parseInternalActivationAttributes = (e) => {
                    let t = e.getString(`activation`, ``);
                    if (t === `Clip`) {
                      let [n, i] = e.getFloats(`activation_params`, [r.MIN_CLIP, r.MAX_CLIP]);
                      return { activation: t, clipMax: i, clipMin: n, activationCacheKey: `${t}:${n},${i}` };
                    }
                    return { activation: t, activationCacheKey: t };
                  }));
              },
              1253: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.parseGatherAttributes = t.gather = void 0));
                let r = n(246),
                  i = n(782),
                  a = n(2517),
                  o = n(2039);
                ((t.gather = (e, t, n) => (l(t, n.axis), [e.run(c(e, t, n), t)])),
                  (t.parseGatherAttributes = (e) =>
                    (0, r.createAttributeWithCacheKey)({ axis: e.attributes.getInt(`axis`, 0) })));
                let s = {
                    name: `Gather`,
                    inputNames: [`A`, `B`],
                    inputTypes: [o.TextureType.unpacked, o.TextureType.unpacked],
                  },
                  c = (e, t, n) => {
                    let r = Object.assign(Object.assign({}, s), { cacheHint: n.cacheKey });
                    return Object.assign(Object.assign({}, r), {
                      get: () =>
                        ((e, t, n, r) => {
                          let i = n[0].dims.slice(),
                            s = n[1].dims.slice(),
                            c = Array(i.length + s.length - 1);
                          r = a.ShapeUtil.normalizeAxis(r, i.length);
                          let l = [];
                          for (let e = 0; e < c.length; e++)
                            e < r
                              ? ((c[e] = i[e]), l.push(`inputIdx[${e}] = outputIdx[${e}];`))
                              : e < r + s.length
                                ? ((c[e] = s[e - r]), l.push(`indexDataIdx[${e - r}] = outputIdx[${e}];`))
                                : ((c[e] = i[e - s.length + 1]),
                                  l.push(`inputIdx[${e - s.length + 1}] = outputIdx[${e}];`));
                          let u = `\n      float process(int outputIdx[${c.length || 1}]) {\n        int inputIdx[${i.length}];\n        int indexDataIdx[${s.length || 1}];\n        indexDataIdx[0] = 0;\n        ${l.join(`
        `)}\n        int idx = int(_B(indexDataIdx));\n        inputIdx[${r}] = idx < 0 ? idx + ${i[r]} : idx;\n        return _A(inputIdx);\n      }`;
                          return Object.assign(Object.assign({}, t), {
                            output: { dims: c, type: n[0].type, textureType: o.TextureType.unpacked },
                            shaderSource: u,
                          });
                        })(0, r, t, n.axis),
                    });
                  },
                  l = (e, t) => {
                    if (!e || e.length !== 2) throw Error(`Gather requires 2 inputs.`);
                    let n = e[0].dims.length;
                    if (n < 1) throw Error(`Invalid input shape.`);
                    if (t < -n || t > n - 1) throw Error(`Invalid axis.`);
                    if (i.NUMBER_TYPES.indexOf(e[0].type) === -1 || (e[1].type !== `int32` && e[1].type !== `int16`))
                      throw Error(`Invaid input type.`);
                  };
              },
              4776: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseGemmAttributesV11 = t.parseGemmAttributesV7 = t.gemm = void 0));
                let r = n(246),
                  i = n(2517),
                  a = n(2039);
                t.gemm = (e, t, n) => (l(t, n), [e.run(s(t, n), t)]);
                let o = (e, t) => {
                  let n = e.attributes.getInt(`transA`, 0) !== 0,
                    i = e.attributes.getInt(`transB`, 0) !== 0,
                    a = e.attributes.getFloat(`alpha`, 1),
                    o = e.attributes.getFloat(`beta`, 1);
                  return (0, r.createAttributeWithCacheKey)({
                    transA: n,
                    transB: i,
                    alpha: a,
                    beta: o,
                    isOptionalC: t,
                  });
                };
                ((t.parseGemmAttributesV7 = (e) => o(e, !1)), (t.parseGemmAttributesV11 = (e) => o(e, !0)));
                let s = (e, t) => {
                    let n = {
                      name: `Gemm`,
                      inputNames: e.length === 3 ? [`A`, `B`, `C`] : [`A`, `B`],
                      inputTypes:
                        e.length === 3
                          ? [a.TextureType.unpacked, a.TextureType.unpacked, a.TextureType.unpacked]
                          : [a.TextureType.unpacked, a.TextureType.unpacked],
                      key: t.cacheKey,
                    };
                    return Object.assign(Object.assign({}, n), { get: () => c(n, e, t) });
                  },
                  c = (e, t, n) => {
                    let r = t[0].dims.slice(),
                      o = t[1].dims.slice(),
                      [s, c] = i.GemmUtil.getShapeOfGemmResult(
                        r,
                        n.transA,
                        o,
                        n.transB,
                        t.length === 3 ? t[2].dims : void 0,
                      ),
                      l = [s, c];
                    if (!l) throw Error(`Can't use gemm on the given tensors`);
                    let u = r[r.length - 1],
                      d = ``;
                    (n.transA && (u = r[0]),
                      n.transA && n.transB
                        ? (d = `value += _A_T(a) * _B_T(b);`)
                        : n.transA && !n.transB
                          ? (d = `value += _A_T(a) * _B(b);`)
                          : !n.transA && n.transB
                            ? (d = `value += _A(a) * _B_T(b);`)
                            : n.transA || n.transB || (d = `value += _A(a) * _B(b);`));
                    let f = l.length,
                      p = `\n      float process(int indices[${f}]) {\n          int a[${f}];\n          int b[${f}];\n          ${t.length === 3 ? `int c[${t[2].dims.length}];` : ``}\n\n          copyVec(indices, a);\n          copyVec(indices, b);\n          ${t.length === 3 ? `bcastIndices_C(indices, c);` : ``}\n\n          float value = 0.0;\n          for (int k=0; k<${u}; ++k) {\n              a[${f - 1}] = k;\n              b[${f - 2}] = k;\n              ${d}\n          }\n\n          value = value * alpha;\n          ${t.length === 3 ? `value += beta * _C(c);` : ``}\n          return value;\n      }`;
                    return Object.assign(Object.assign({}, e), {
                      output: { dims: l, type: t[0].type, textureType: a.TextureType.unpacked },
                      variables: [
                        { name: `alpha`, type: `float`, data: n.alpha },
                        { name: `beta`, type: `float`, data: n.beta },
                      ],
                      shaderSource: p,
                    });
                  },
                  l = (e, t) => {
                    if (!e) throw Error(`Input is missing`);
                    if (t.isOptionalC && (e.length < 2 || e.length > 3)) throw Error(`Invaid input shape.`);
                    if (!t.isOptionalC && e.length !== 3) throw Error(`Gemm requires 3 inputs`);
                    if (e.length === 3 && e[2].dims.length !== 1 && e[2].dims.length !== 2)
                      throw Error(`Invalid input shape of C`);
                    if (
                      (e[0].type !== `float32` && e[0].type !== `float64`) ||
                      (e[1].type !== `float32` && e[1].type !== `float64`) ||
                      (e.length === 3 && e[2].type !== `float32` && e[2].type !== `float64`)
                    )
                      throw Error(`Invalid input type.`);
                    if (e[0].type !== e[1].type || (e.length === 3 && e[0].type !== e[2].type))
                      throw Error(`Input types are mismatched`);
                  };
              },
              8555: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.createPackedIm2ColProgramInfoLoader = void 0));
                let r = n(5060),
                  i = n(2039),
                  a = n(2827);
                t.createPackedIm2ColProgramInfoLoader = (e, t, n, o, s) => {
                  let c =
                    ((l = s.cacheKey),
                    { name: `Im2Col (packed)`, inputNames: [`A`], inputTypes: [i.TextureType.packed], cacheHint: l });
                  var l;
                  return Object.assign(Object.assign({}, c), {
                    get: () =>
                      ((e, t, n, o, s, c) => {
                        let l = n.dims,
                          u = o.dims,
                          d = s.length,
                          f = [u[1] * u[2] * u[3], s[2] * s[3]],
                          p = u[2] * u[3],
                          m = (0, a.unpackFromChannel)(),
                          h = (0, r.getGlsl)(e.session.backend.glContext.version),
                          g = ``;
                        for (let e = 0; e <= 1; e++)
                          for (let t = 0; t <= 1; t++)
                            g += `\n            blockIndex = rc.x + ${t};\n            pos = rc.y + ${e};\n\n            if(blockIndex < ${f[1]} && pos < ${f[0]}) {\n              offsetY = int(blockIndex / (${s[d - 1]})) * ${c.strides[0]} -\n                ${c.pads[0]};\n              d0 = offsetY + ${c.dilations[0]} * (imod(pos, ${p}) / ${u[2]});\n\n              if(d0 < ${l[2]} && d0 >= 0) {\n                offsetX = imod(blockIndex, ${s[d - 1]}) * ${c.strides[1]} -\n                  ${c.pads[1]};\n                d1 = offsetX + ${c.dilations[1]} * imod(imod(pos, ${p}), ${u[2]});\n\n                if(d1 < ${l[3]} && d1 >= 0) {\n\n                  ch = int(float(pos)/ ${p}.);\n                    innerDims = vec2(d0, d1);\n                    result[${2 * e + t}] = getChannel(\n                      getA(0, ch, int(innerDims.x),\n                      int(innerDims.y)), innerDims);\n                }\n              }\n            }\n\n          `;
                        let _ = `\n      ${m}\n\n      void main() {\n        ivec2 rc = getOutputCoords();\n          vec4 result = vec4(0.0);\n          int blockIndex, pos, offsetY, d0, offsetX, d1, ch;\n          vec2 innerDims;\n          ${g}\n          ${h.output} = result;\n      }\n            `;
                        return Object.assign(Object.assign({}, t), {
                          output: { dims: f, type: n.type, textureType: i.TextureType.packed },
                          shaderSource: _,
                          hasMain: !0,
                        });
                      })(e, c, t, n, o, s),
                  });
                };
              },
              3248: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.calculateIm2ColDims = t.createIm2ColProgramInfoLoader = void 0));
                let r = n(2039);
                ((t.createIm2ColProgramInfoLoader = (e, n, i, a, o) => {
                  let s =
                    ((c = o.cacheKey),
                    { name: `Im2Col`, inputNames: [`X`], inputTypes: [r.TextureType.unpacked], cacheHint: c });
                  var c;
                  return Object.assign(Object.assign({}, s), {
                    get: () =>
                      ((e, n, i, a, o, s) => {
                        let c = i.dims,
                          l = a.dims,
                          u = o.length,
                          d = (0, t.calculateIm2ColDims)(c, l, o, 4),
                          f = `\n        const int XC = ${c[1]};\n        const int XH = ${c[2]};\n        const int XW = ${c[3]};\n        const int KH = ${s.kernelShape[0]};\n        const int KW = ${s.kernelShape[1]};\n        const int dilationH = ${s.dilations[0]};\n        const int dilationW = ${s.dilations[1]};\n        const int strideH = ${s.strides[0]};\n        const int strideW = ${s.strides[1]};\n        const int padH = ${s.pads[0]};\n        const int padW = ${s.pads[1]};\n        const int KHKW = KH*KW;\n        const int XCKHKW = XC * KHKW;\n        const int outputChannels = 4;\n        vec4 process(int indices[${u}]) {\n          int b  = indices[0]; // batch size\n          int oh = indices[1] * strideH - padH; //output height\n          int ow = indices[2] * strideW - padW; //output width\n          int p = indices[3] * outputChannels; //patch\n          vec4 value = vec4(0.0);\n          for(int i=0; i < outputChannels; ++i) {\n            if(p < XCKHKW) {\n              int patchC = p / KHKW;\n              int patchH = (p - patchC*KHKW) / KW;\n              int patchW = (p - patchC*KHKW) - patchH * KW;\n              int xh2 = oh + patchH * dilationH;\n              int xw2 = ow + patchW * dilationW;\n              int x[${c.length}];\n              x[0] = b;\n              x[1] = patchC;\n              x[2] = xh2;\n              x[3] = xw2;\n              if(xh2 >= 0 &&\n                  xh2 < XH &&\n                  xw2 >= 0 &&\n                  xw2 < XW) {\n                value[i] = _X(x);\n              }\n            }\n            ++p;\n          }\n          return value;\n        }\n        `;
                        return Object.assign(Object.assign({}, n), {
                          output: { dims: d, type: i.type, textureType: r.TextureType.packedLastDimension },
                          shaderSource: f,
                        });
                      })(0, s, n, i, a, o),
                  });
                }),
                  (t.calculateIm2ColDims = (e, t, n, r = 4) => [
                    n[0],
                    n[2],
                    n[3],
                    Math.ceil((e[1] * t[2] * t[3]) / r),
                  ]));
              },
              6572: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseImageScalerAttributes = t.imageScaler = void 0));
                let r = n(246),
                  i = n(2039);
                ((t.imageScaler = (e, t, n) => (c(t), [e.run(o(e, t, n), t)])),
                  (t.parseImageScalerAttributes = (e) => {
                    let t = e.attributes.getFloat(`scale`),
                      n = e.attributes.getFloats(`bias`);
                    return (0, r.createAttributeWithCacheKey)({ scale: t, bias: n });
                  }));
                let a = { name: `ImageScaler`, inputNames: [`X`], inputTypes: [i.TextureType.unpacked] },
                  o = (e, t, n) => {
                    let r = Object.assign(Object.assign({}, a), { cacheHint: n.cacheKey });
                    return Object.assign(Object.assign({}, r), {
                      get: () =>
                        ((e, t, n, r) => {
                          let a = n[0].dims.slice(),
                            o = a.length,
                            c = `\n      ${s(r.bias.length)}\n      float process(int indices[${o}]) {\n        return _X(indices) * scale + getBias(bias, indices[1]);\n      }`;
                          return Object.assign(Object.assign({}, t), {
                            output: { dims: a, type: n[0].type, textureType: i.TextureType.unpacked },
                            variables: [
                              { name: `bias`, type: `float`, arrayLength: r.bias.length, data: r.bias },
                              { name: `scale`, type: `float`, data: r.scale },
                            ],
                            shaderSource: c,
                          });
                        })(0, r, t, n),
                    });
                  },
                  s = (e) => {
                    let t = [`float getBias(float bias[${e}], int channel) {`];
                    for (let n = 0; n < e; ++n)
                      n === 0
                        ? t.push(`\tif (channel == ${n}) { return bias[${n}]; }`)
                        : n === e - 1
                          ? t.push(`\telse { return bias[${n}]; }`)
                          : t.push(`\telse if (channel == ${n}) { return bias[${n}]; }`);
                    return (
                      t.push(`	}`),
                      t.join(`
`)
                    );
                  },
                  c = (e) => {
                    if (!e || e.length !== 1) throw Error(`ImageScaler requires 1 input.`);
                    if (e[0].dims.length !== 4) throw Error(`Invalid input shape.`);
                    if (e[0].type !== `float32` && e[0].type !== `float64`) throw Error(`Invalid input type.`);
                  };
              },
              3346: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseInstanceNormalizationAttributes = t.instanceNormalization = void 0));
                let r = n(5060),
                  i = n(2039);
                ((t.instanceNormalization = (e, t, n) => {
                  l(t);
                  let r = e.run(o(t[0]), t);
                  return [e.run(c(e, t[0], n, r.dims), [t[0], r, t[1], t[2]])];
                }),
                  (t.parseInstanceNormalizationAttributes = (e) => e.attributes.getFloat(`epsilon`, 1e-5)));
                let a = {
                    name: `InstanceNormalization_MeanAndVariance`,
                    inputNames: [`X`],
                    inputTypes: [i.TextureType.unpacked],
                  },
                  o = (e) =>
                    Object.assign(Object.assign({}, a), {
                      get: () =>
                        ((e, t) => {
                          let n = t.dims.slice(),
                            r = n[1],
                            a = n[2] * n[3],
                            o = [n[0], r],
                            s = `\n      vec4 process(int[2] indices) {\n        vec4 v = vec4(0.0);\n        int a[4];\n        a[0] = indices[0];\n        a[1] = indices[1];\n        float temp = 0.0;\n        for(int a2=0; a2<${n[2]}; a2++) {\n          a[2] = a2;\n          for(int a3=0; a3<${n[3]}; a3++) {\n            a[3] = a3;\n            float x = _X(a);\n            temp += x;\n          }\n        }\n        float mean = temp / float(${a});\n        temp = 0.0;\n        for(int a2=0; a2<${n[2]}; a2++) {\n          a[2] = a2;\n          for(int a3=0; a3<${n[3]}; a3++) {\n            a[3] = a3;\n            float x = _X(a);\n            temp += (x - mean) * (x - mean);\n          }\n        }\n        v.r = mean;\n        v.g = temp / float(${a});\n\n        return v;\n      }`;
                          return Object.assign(Object.assign({}, e), {
                            output: { dims: o, type: t.type, textureType: i.TextureType.packedLastDimension },
                            shaderSource: s,
                          });
                        })(a, e),
                    }),
                  s = {
                    name: `InstanceNormalization_ComputeOutput`,
                    inputNames: [`X`, `MeanAndVariance`, `Scale`, `B`],
                    inputTypes: [
                      i.TextureType.unpacked,
                      i.TextureType.packedLastDimension,
                      i.TextureType.unpacked,
                      i.TextureType.unpacked,
                    ],
                  },
                  c = (e, t, n, a) => {
                    let o = Object.assign(Object.assign({}, s), { cacheHint: `${n}` });
                    return Object.assign(Object.assign({}, o), {
                      get: () =>
                        ((e, t, n, a, o) => {
                          let s = (0, r.getGlsl)(e.session.backend.glContext.version),
                            [c, l] = e.calculateTextureWidthAndHeight(o, i.TextureType.packedLastDimension),
                            [u, d] = [c / 4, l],
                            f = `\n      vec4 get_MeanAndVariance(int[2] mv) {\n        int offset = indicesToOffset_MeanAndVariance(mv);\n        vec2 coords = offsetToCoords(offset, ${u}, ${d});\n        return ${s.texture2D}(MeanAndVariance, coords);\n      }\n\n      float process(int[4] indices) {\n        int mv[2];\n        mv[0] = indices[0];\n        mv[1] = indices[1];\n        vec4 mean_and_variance = get_MeanAndVariance(mv);\n        float mean = mean_and_variance.r;\n        float variance = mean_and_variance.g;\n\n        int sb[1];\n        sb[0] = indices[1];\n        float scale = _Scale(sb);\n        float b = _B(sb);\n\n        return scale * (_X(indices) - mean) / sqrt(variance + epsilon) + b;\n      }`;
                          return Object.assign(Object.assign({}, t), {
                            output: { dims: n.dims, type: n.type, textureType: i.TextureType.unpacked },
                            variables: [{ name: `epsilon`, type: `float`, data: a }],
                            shaderSource: f,
                          });
                        })(e, o, t, n, a),
                    });
                  },
                  l = (e) => {
                    if (!e || e.length !== 3) throw Error(`InstanceNormalization requires 3 inputs.`);
                    let t = e[0],
                      n = e[1],
                      r = e[2];
                    if (t.dims.length < 3 || n.dims.length !== 1 || r.dims.length !== 1)
                      throw Error(`Invalid input shape.`);
                    if (n.dims[0] !== t.dims[1] || r.dims[0] !== t.dims[1]) throw Error(`Input shapes are mismatched.`);
                    if (
                      (t.type !== `float32` && t.type !== `float64`) ||
                      (n.type !== `float32` && n.type !== `float64`) ||
                      (r.type !== `float32` && r.type !== `float64`)
                    )
                      throw Error(`Invalid input type.`);
                    if (e[0].dims.length !== 4) throw Error(`Only support 4-D input shape.`);
                  };
              },
              708: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.createPackedMatmulProgramInfoLoader = void 0));
                let r = n(2517),
                  i = n(5060),
                  a = n(2039),
                  o = n(9390),
                  s = n(2823),
                  c = n(5623);
                t.createPackedMatmulProgramInfoLoader = (e, t, n) => {
                  let l =
                    ((u = t.length > 2),
                    (d = n.activationCacheKey),
                    {
                      name: `MatMul (packed)`,
                      inputNames: u ? [`A`, `B`, `Bias`] : [`A`, `B`],
                      inputTypes: u
                        ? [a.TextureType.packed, a.TextureType.packed, a.TextureType.packed]
                        : [a.TextureType.packed, a.TextureType.packed],
                      cacheHint: d,
                    });
                  var u, d;
                  return Object.assign(Object.assign({}, l), {
                    get: () =>
                      ((e, t, n, l) => {
                        let u = n.length > 2,
                          d = u ? `value += getBiasForMatmul();` : ``,
                          f = n[0].dims,
                          p = n[1].dims,
                          m = r.BroadcastUtil.calcShape(f, p, !0),
                          h = !r.ShapeUtil.areEqual(n[0].dims, n[1].dims);
                        if (!m) throw Error(`Can't use matmul on the given tensors`);
                        let g = f[f.length - 1],
                          _ = Math.ceil(g / 2),
                          v = f.length,
                          y = p.length,
                          b = (0, i.getGlsl)(e.session.backend.glContext.version),
                          x = (0, o.getCoordsDataType)(m.length),
                          S = m.length,
                          C = (0, o.getGlChannels)(),
                          { activationFunction: w, applyActivation: T } = (0, s.getActivationSnippet)(l),
                          E = u ? `${(0, c.getBiasForMatmul)(x, C, n[2].dims, m, !0)}` : ``,
                          D = h
                            ? `${(function (e, t, n, i) {
                                let a = [],
                                  o = [],
                                  s = n[0].dims,
                                  c = n[1].dims,
                                  l = s.length,
                                  u = c.length,
                                  d = i.length,
                                  f = d - l,
                                  p = d - u;
                                ((a = s.map((e, n) => `coords.${t[n + f]}`)),
                                  (a[l - 1] = `i*2`),
                                  a.join(`, `),
                                  (o = c.map((e, n) => `coords.${t[n + p]}`)),
                                  (o[u - 2] = `i*2`),
                                  o.join(`, `));
                                let m = r.BroadcastUtil.getBroadcastDims(s, i),
                                  h = r.BroadcastUtil.getBroadcastDims(c, i),
                                  g = m.map((e) => `coords.${t[e + f]} = 0;`).join(`
`),
                                  _ = h.map((e) => `coords.${t[e + p]} = 0;`).join(`
`),
                                  v = `int lastDim = coords.${t[d - 1]};\n  coords.${t[d - 1]} = coords.${t[d - 2]};\n  coords.${t[d - 2]} = lastDim;`;
                                return `\nvec4 getAAtOutCoordsMatmul(int i) {\n  ${e} coords = getOutputCoords();\n  ${v}\n  ${g}\n  vec4 outputValue = getA(${a});\n  return outputValue;\n}\n\nvec4 getBAtOutCoordsMatmul(int i) {\n  ${e} coords = getOutputCoords();\n  ${v}\n  ${_}\n  vec4 outputValue = getB(${o});\n  return outputValue;\n}`;
                              })(x, C, n, m)}`
                            : ``,
                          O = h
                            ? `getAAtOutCoordsMatmul(i)`
                            : `getA(${(function (e, t) {
                                let n = ``;
                                for (let r = 0; r < t - 2; r++) n += `rc.${e[r]}, `;
                                return ((n += `rc.${e[t - 2]}, i*2`), n);
                              })(C, v)})`,
                          k = h
                            ? `getBAtOutCoordsMatmul(i)`
                            : `getB(${(function (e, t) {
                                let n = ``;
                                for (let r = 0; r < t - 2; r++) n += `rc.${e[r]}, `;
                                return ((n += `i*2, rc.${e[t - 1]}`), n);
                              })(C, y)})`,
                          A = `\n            ${D}\n            ${E}\n            ${w}\n            void main() {\n              ${h ? `` : `${x} rc =\n          getOutputCoords(); int lastDim = rc.${C[S - 1]}; rc.${C[S - 1]} =\n          rc.${C[S - 2]}; rc.${C[S - 2]} = lastDim;\n      `}\n\n              vec4 value = vec4(0);\n              for (int i = 0; i < ${_}; i++) {\n                vec4 a = ${O};\n                vec4 b = ${k};\n\n                value += (a.rrbb * b.rgrg);\n                value += (a.ggaa * b.baba);\n              }\n              ${d}\n              ${T}\n              ${b.output} = value;\n            }`;
                        return Object.assign(Object.assign({}, t), {
                          output: { dims: m, type: n[0].type, textureType: a.TextureType.packed },
                          shaderSource: A,
                          hasMain: !0,
                        });
                      })(e, l, t, n),
                  });
                };
              },
              5623: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.getBiasForMatmul = t.createMatmulProgramInfoLoader = t.parseMatMulAttributes = t.matMul = void 0));
                let r = n(2517),
                  i = n(2039),
                  a = n(9390),
                  o = n(2823),
                  s = n(708);
                function c(e, t) {
                  let n =
                    ((s = e.length > 2),
                    (c = t.activationCacheKey),
                    {
                      name: `MatMul`,
                      inputNames: s ? [`A`, `B`, `Bias`] : [`A`, `B`],
                      inputTypes: s
                        ? [i.TextureType.unpacked, i.TextureType.unpacked, i.TextureType.unpacked]
                        : [i.TextureType.unpacked, i.TextureType.unpacked],
                      cacheHint: c,
                    });
                  var s, c;
                  return Object.assign(Object.assign({}, n), {
                    get: () =>
                      (function (e, t, n) {
                        let s = t[0].dims,
                          c = t[1].dims,
                          l = r.BroadcastUtil.calcShape(s, c, !0);
                        if (!l) throw Error(`Can't use matmul on the given tensors`);
                        let d = (0, a.getCoordsDataType)(l.length),
                          f = (0, a.getGlChannels)(),
                          { activationFunction: p, applyActivation: m } = (0, o.getActivationSnippet)(n),
                          h = t.length > 2,
                          g = h ? `value += getBiasForMatmul();` : ``,
                          _ = h ? `${u(d, f, t[2].dims, l, !1)}` : ``,
                          v = l.length,
                          y = s.length,
                          b = c.length,
                          x = `\n    ${p}\n    ${_}\n    float process(int indices[${v}]) {\n        int a[${y}];\n        int b[${b}];\n        bcastMatmulIndices_A(indices, a);\n        bcastMatmulIndices_B(indices, b);\n\n        float value;\n        for (int k=0; k<${s[s.length - 1]}; ++k) {\n            a[${y - 1}] = k;\n            b[${b - 2}] = k;\n            value += _A(a) * _B(b);\n        }\n        ${g}\n        ${m}\n        return value;\n    }`;
                        return Object.assign(Object.assign({}, e), {
                          output: { dims: l, type: t[0].type, textureType: i.TextureType.unpacked },
                          shaderSource: x,
                        });
                      })(n, e, t),
                  });
                }
                ((t.matMul = (e, t, n) => (
                  l(t),
                  e.session.pack ? [e.run((0, s.createPackedMatmulProgramInfoLoader)(e, t, n), t)] : [e.run(c(t, n), t)]
                )),
                  (t.parseMatMulAttributes = (e) => (0, o.parseInternalActivationAttributes)(e.attributes)),
                  (t.createMatmulProgramInfoLoader = c));
                let l = (e) => {
                  if (!e || e.length !== 2) throw Error(`MatMul requires 2 inputs.`);
                  if (e[0].dims[e[0].dims.length - 1] !== e[1].dims[e[1].dims.length - 2])
                    throw Error(`shared dimension does not match.`);
                  if (
                    (e[0].type !== `float32` && e[0].type !== `float64`) ||
                    (e[1].type !== `float32` && e[1].type !== `float64`)
                  )
                    throw Error(`inputs should be float type`);
                  if (e[0].type !== e[1].type) throw Error(`inputs types should match`);
                };
                function u(e, t, n, i, a) {
                  let o = ``,
                    s = n.length,
                    c = i.length,
                    l = c - s;
                  o = c < 2 && s > 0 ? `coords` : n.map((e, n) => `coords.${t[n + l]}`).join(`, `);
                  let u = r.BroadcastUtil.getBroadcastDims(n, i).map((e) => `coords.${t[e + l]} = 0;`).join(`
`),
                    d = `vec4(outputValue.xx, outputValue.yy)`;
                  return (
                    r.ShapeUtil.size(n) === 1 && (d = `vec4(outputValue.x)`),
                    a
                      ? `\nvec4 getBiasForMatmul() {\n  ${e} coords = getOutputCoords();\n  ${u}\n  vec4 outputValue = getBias(${o});\n  return ${d};\n}`
                      : `\nfloat getBiasForMatmul() {\n  ${e} coords = getOutputCoords();\n  ${u}\n  return getBias(coords.x);\n}`
                  );
                }
                t.getBiasForMatmul = u;
              },
              2403: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.createPackProgramInfoLoader = void 0));
                let r = n(5060),
                  i = n(2039),
                  a = n(9390),
                  o = n(2827),
                  s = { name: `pack`, inputNames: [`A`], inputTypes: [i.TextureType.unpackedReversed] };
                t.createPackProgramInfoLoader = (e, t) =>
                  Object.assign(Object.assign({}, s), {
                    get: () =>
                      ((e, t) => {
                        let n = (0, r.getGlsl)(e.session.backend.glContext.version),
                          c = t.dims,
                          l = c.length,
                          u = t.dims.length,
                          d = (0, a.getCoordsDataType)(u),
                          f = (0, o.getChannels)(`rc`, u),
                          p =
                            ((m = u),
                            (h = f),
                            (g = c[c.length - 2]),
                            (_ = c[c.length - 1]),
                            m === 0 || m === 1
                              ? ``
                              : `\n    int r = ${h[m - 2]};\n    int c = ${h[m - 1]};\n    int rp1 = ${h[m - 2]} + 1;\n    int cp1 = ${h[m - 1]} + 1;\n    bool rEdge = rp1 >= ${_};\n    bool cEdge = cp1 >= ${g};\n    `);
                        var m, h, g, _;
                        let v;
                        v = l === 0 ? [1, 1] : l === 1 ? [c[0], 1] : [c[u - 1], c[u - 2]];
                        let y = (function (e, t, n) {
                            if (e === 0) return `false`;
                            if (e === 1) return `rc > ${t[0]}`;
                            let r = ``;
                            for (let i = e - 2; i < e; i++)
                              ((r += `${n[i]} >= ${t[i - e + 2]}`), i < e - 1 && (r += `||`));
                            return r;
                          })(u, v, f),
                          b = (function (e, t) {
                            let n = e.length;
                            if (n === 0) return `getA(), 0, 0, 0`;
                            if (n === 1)
                              return `getA(rc),\n            rc + 1 >= ${e[0]} ? 0. : getA(rc + 1),\n            0, 0`;
                            let r = ``;
                            if (n > 2) for (let e = 0; e < n - 2; ++e) r += `${t[e]},`;
                            return `getA(${r}r, c),\n          rEdge ? 0. : getA(${r}rp1, c),\n          cEdge ? 0. : getA(${r}r, cp1),\n          rEdge || cEdge ? 0. : getA(${r}rp1, cp1)`;
                          })(c, f),
                          x = `\n        void main() {\n          ${d} rc = getOutputCoords();\n\n          if(${y}) {\n            ${n.output} = vec4(0);\n          } else {\n            ${p}\n\n            ${n.output} = vec4(${b});\n          }\n        }\n      `;
                        return Object.assign(Object.assign({}, s), {
                          hasMain: !0,
                          output: { dims: t.dims, type: t.type, textureType: i.TextureType.packed },
                          shaderSource: x,
                        });
                      })(e, t),
                  });
              },
              2827: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.unpackFromChannel = t.getChannels = t.getVecChannels = void 0));
                let r = n(9390);
                function i(e, t) {
                  return (0, r.getGlChannels)(t).map((t) => `${e}.${t}`);
                }
                ((t.getVecChannels = i),
                  (t.getChannels = function (e, t) {
                    return t === 1 ? [e] : i(e, t);
                  }),
                  (t.unpackFromChannel = function () {
                    return `
    float getChannel(vec4 frag, int dim) {
      int modCoord = imod(dim, 2);
      return modCoord == 0 ? frag.r : frag.g;
    }

    float getChannel(vec4 frag, vec2 innerDims) {
      vec2 modCoord = mod(innerDims, 2.);
      return modCoord.x == 0. ?
        (modCoord.y == 0. ? frag.r : frag.g) :
        (modCoord.y == 0. ? frag.b : frag.a);
    }
  `;
                  }));
              },
              2870: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parsePadAttributesV11 = t.padV11 = t.parsePadAttributesV2 = t.padV2 = void 0));
                let r = n(246),
                  i = n(2517),
                  a = n(5060),
                  o = n(2039),
                  s = { name: `Pad`, inputNames: [`A`], inputTypes: [o.TextureType.unpacked] };
                ((t.padV2 = (e, t, n) => (
                  u(t),
                  [e.run(Object.assign(Object.assign({}, s), { cacheHint: n.cacheKey, get: () => l(e, t[0], n) }), t)]
                )),
                  (t.parsePadAttributesV2 = (e) => {
                    let t = e.attributes.getString(`mode`, `constant`),
                      n = e.attributes.getFloat(`value`, 0),
                      i = e.attributes.getInts(`pads`);
                    return (0, r.createAttributeWithCacheKey)({ mode: t, value: n, pads: i });
                  }),
                  (t.padV11 = (e, n, r) => {
                    d(n);
                    let i = c(e, n, r);
                    return (0, t.padV2)(e, [n[0]], i);
                  }),
                  (t.parsePadAttributesV11 = (e) => e.attributes.getString(`mode`, `constant`)));
                let c = (e, t, n) => {
                    if (
                      !e.session.isInitializer(t[1].dataId) ||
                      (t.length >= 3 && !e.session.isInitializer(t[2].dataId))
                    )
                      throw Error(`dynamic pad attributes are not allowed`);
                    let i = Array.from(t[1].integerData),
                      a = t.length >= 3 ? t[2].floatData[0] : 0;
                    return (0, r.createAttributeWithCacheKey)({ mode: n, pads: i, value: a });
                  },
                  l = (e, t, n) => {
                    let r = i.ShapeUtil.padShape(t.dims.slice(), n.pads),
                      a = r.length,
                      s = `\n      ${f(e, t, n)}\n      float process(int[${a}] indices) {\n          return padA(indices);\n      }`;
                    return {
                      name: `Pad`,
                      inputNames: [`A`],
                      inputTypes: [o.TextureType.unpacked],
                      output: { dims: r, type: t.type, textureType: o.TextureType.unpacked },
                      shaderSource: s,
                    };
                  },
                  u = (e) => {
                    if (!e || e.length !== 1) throw Error(`Pad requires 1 input`);
                    if (e[0].type !== `float32` && e[0].type !== `float64`) throw Error(`Invalid input type.`);
                  },
                  d = (e) => {
                    if (!e || (e.length !== 2 && e.length !== 3)) throw Error(`Pad requires 2 or 3 inputs`);
                    if (e[1].type !== `int32` || (e.length >= 3 && e[2].type === `string`))
                      throw Error(`Invalid input type.`);
                  },
                  f = (e, t, n) => {
                    let r = (0, a.getGlsl)(e.session.backend.glContext.version),
                      [s, c] = e.calculateTextureWidthAndHeight(t.dims, o.TextureType.unpacked),
                      l = i.ShapeUtil.computeStrides(t.dims);
                    switch (n.mode) {
                      case `constant`:
                        return p(r, t.dims, l, s, c, n.pads, n.value);
                      case `reflect`:
                        return m(r, t.dims, l, s, c, n.pads);
                      case `edge`:
                        return h(r, t.dims, l, s, c, n.pads);
                      default:
                        throw Error(`Invalid mode`);
                    }
                  },
                  p = (e, t, n, r, i, a, o) => {
                    let s = t.length,
                      c = ``;
                    for (let e = s - 1; e >= 0; --e)
                      c += `\n        k = m[${e}] - ${a[e]};\n        if (k < 0)  return constant;\n        if (k >= ${t[e]}) return constant;\n        offset += k * ${n[e]};\n        `;
                    return `\n      float padA(int m[${s}]) {\n        const float constant = float(${o});\n        int offset = 0;\n        int k = 0;\n        ${c}\n        vec2 coords = offsetToCoords(offset, ${r}, ${i});\n        float value = getColorAsFloat(${e.texture2D}(A, coords));\n        return value;\n      }\n      `;
                  },
                  m = (e, t, n, r, i, a) => {
                    let o = t.length,
                      s = ``;
                    for (let e = o - 1; e >= 0; --e)
                      s += `\n        k = m[${e}] - ${a[e]};\n        if (k < 0) { k = -k; }\n        {\n          const int _2n_1 = ${2 * (t[e] - 1)};\n          k = int( mod( float(k), float(_2n_1) ) ) ;\n          if(k >= ${t[e]}) { k = _2n_1 - k; }\n        }\n        offset += k * ${n[e]};\n        `;
                    return `\n      float padA(int m[${o}]) {\n        int offset = 0;\n        int k = 0;\n        ${s}\n        vec2 coords = offsetToCoords(offset, ${r}, ${i});\n        float value = getColorAsFloat(${e.texture2D}(A, coords));\n        return value;\n      }\n      `;
                  },
                  h = (e, t, n, r, i, a) => {
                    let o = t.length,
                      s = ``;
                    for (let e = o - 1; e >= 0; --e)
                      s += `\n        k = m[${e}] - ${a[e]};\n        if (k < 0)  k = 0;\n        if (k >= ${t[e]}) k = ${t[e] - 1};\n        offset += k * ${n[e]};\n      `;
                    return `\n      float padA(int m[${o}]) {\n        int offset = 0;\n        int k = 0;\n        ${s}\n        vec2 coords = offsetToCoords(offset, ${r}, ${i});\n        float value = getColorAsFloat(${e.texture2D}(A, coords));\n        return value;\n      }\n      `;
                  };
              },
              2143: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.globalMaxPool =
                    t.parseMaxPoolAttributes =
                    t.maxPool =
                    t.parseGlobalAveragePoolAttributes =
                    t.globalAveragePool =
                    t.parseAveragePoolAttributes =
                    t.averagePool =
                      void 0));
                let r = n(246),
                  i = n(2517),
                  a = n(2039);
                ((t.averagePool = (e, t, n) => {
                  d(t);
                  let r = {
                    name: `AveragePool`,
                    inputNames: [`X`],
                    inputTypes: [a.TextureType.unpacked],
                    cacheHint: n.cacheKey,
                  };
                  return [e.run(Object.assign(Object.assign({}, r), { get: () => o(t, r, !1, n) }), t)];
                }),
                  (t.parseAveragePoolAttributes = (e) => {
                    let t = e.attributes.getString(`auto_pad`, `NOTSET`),
                      n = e.attributes.getInt(`ceil_mode`, 0),
                      i = e.attributes.getInt(`count_include_pad`, 0) !== 0,
                      a = e.attributes.getInts(`kernel_shape`),
                      o = e.attributes.getInts(`strides`, []),
                      s = e.attributes.getInts(`pads`, []);
                    if (n !== 0) throw Error(`using ceil() in shape computation is not yet supported for AveragePool`);
                    return (0, r.createAttributeWithCacheKey)({
                      autoPad: t,
                      ceilMode: n,
                      countIncludePad: i,
                      kernelShape: a,
                      strides: o,
                      pads: s,
                    });
                  }));
                let o = (e, t, n, r) => {
                  let [o, s] = c(e, r, n),
                    l = i.ShapeUtil.size(o.kernelShape),
                    u = ``;
                  o.countIncludePad ? (u += `value /= float(${l});`) : (u += `value /= float(${l} - pad);`);
                  let d = `\n        ${f(e[0].dims, o, `value += _X(x);`, u, `0.0`)}\n      `;
                  return Object.assign(Object.assign({}, t), {
                    output: { dims: s, type: e[0].type, textureType: a.TextureType.unpacked },
                    shaderSource: d,
                  });
                };
                ((t.globalAveragePool = (e, t, n) => {
                  d(t);
                  let r = {
                    name: `GlobalAveragePool`,
                    inputNames: [`X`],
                    inputTypes: [a.TextureType.unpacked],
                    cacheHint: `${n.countIncludePad}`,
                  };
                  return [e.run(Object.assign(Object.assign({}, r), { get: () => o(t, r, !0, n) }), t)];
                }),
                  (t.parseGlobalAveragePoolAttributes = (e) => {
                    let t = e.attributes.getInt(`count_include_pad`, 0) !== 0;
                    return (0, r.createAttributeWithCacheKey)({
                      autoPad: ``,
                      ceilMode: 0,
                      countIncludePad: t,
                      kernelShape: [],
                      strides: [],
                      pads: [],
                    });
                  }),
                  (t.maxPool = (e, t, n) => {
                    d(t);
                    let r = {
                      name: `MaxPool`,
                      inputNames: [`X`],
                      inputTypes: [a.TextureType.unpacked],
                      cacheHint: n.cacheKey,
                    };
                    return [e.run(Object.assign(Object.assign({}, r), { get: () => s(t, r, !1, n) }), t)];
                  }),
                  (t.parseMaxPoolAttributes = (e) => {
                    let t = e.attributes.getString(`auto_pad`, `NOTSET`),
                      n = e.attributes.getInt(`ceil_mode`, 0),
                      i = e.attributes.getInts(`kernel_shape`),
                      a = e.attributes.getInts(`strides`, []),
                      o = e.attributes.getInts(`pads`, []),
                      s = e.attributes.getInt(`storage_order`, 0),
                      c = e.attributes.getInts(`dilations`, []);
                    if (s !== 0) throw Error(`column major storage order is not yet supported for MaxPool`);
                    if (n !== 0) throw Error(`using ceil() in shape computation is not yet supported for MaxPool`);
                    return (0, r.createAttributeWithCacheKey)({
                      autoPad: t,
                      ceilMode: n,
                      countIncludePad: !1,
                      kernelShape: i,
                      strides: a,
                      pads: o,
                      storageOrder: s,
                      dilations: c,
                    });
                  }));
                let s = (e, t, n, r) => {
                    let [i, o] = c(e, r, n),
                      s = `\n      ${f(
                        e[0].dims,
                        i,
                        `
      value = max(_X(x), value);
    `,
                        ``,
                        `-1e5`,
                      )}\n    `;
                    return Object.assign(Object.assign({}, t), {
                      output: { dims: o, type: e[0].type, textureType: a.TextureType.unpacked },
                      shaderSource: s,
                    });
                  },
                  c = (e, t, n) => {
                    let r = e[0].dims.slice(),
                      a = Object.hasOwnProperty.call(t, `dilations`),
                      o = t.kernelShape.slice(),
                      s = t.strides.slice(),
                      c = a ? t.dilations.slice() : [],
                      l = t.pads.slice();
                    i.PoolConvUtil.adjustPoolAttributes(n, r, o, s, c, l);
                    let u = i.PoolConvUtil.computePoolOutputShape(n, r, s, c, o, l, t.autoPad),
                      d = Object.assign({}, t);
                    return (
                      a
                        ? Object.assign(d, { kernelShape: o, strides: s, pads: l, dilations: c, cacheKey: t.cacheKey })
                        : Object.assign(d, { kernelShape: o, strides: s, pads: l, cacheKey: t.cacheKey }),
                      [d, u]
                    );
                  },
                  l = {
                    autoPad: ``,
                    ceilMode: 0,
                    countIncludePad: !1,
                    kernelShape: [],
                    strides: [],
                    pads: [],
                    storageOrder: 0,
                    dilations: [],
                    cacheKey: ``,
                  },
                  u = { name: `GlobalMaxPool`, inputNames: [`X`], inputTypes: [a.TextureType.unpacked] };
                t.globalMaxPool = (e, t) => (
                  d(t),
                  [e.run(Object.assign(Object.assign({}, u), { get: () => s(t, u, !0, l) }), t)]
                );
                let d = (e) => {
                    if (!e || e.length !== 1) throw Error(`Pool ops requires 1 input.`);
                    if (e[0].type !== `float32` && e[0].type !== `float64`) throw Error(`Invalid input type.`);
                  },
                  f = (e, t, n, r, a) => {
                    let o = e.length;
                    if (t.kernelShape.length <= 2) {
                      let i = t.kernelShape[t.kernelShape.length - 1],
                        s = t.strides[t.strides.length - 1],
                        c = t.pads[t.pads.length / 2 - 1],
                        l = t.pads[t.pads.length - 1],
                        u = e[o - 1],
                        d = ``,
                        f = ``,
                        p = ``;
                      if (
                        ((d =
                          c + l === 0
                            ? `\n          for (int i = 0; i < ${i}; i++) {\n            x[${o} - 1] = indices[${o} - 1] * ${s} - ${c} + i;\n            ${n}\n          }`
                            : `\n          for (int i = 0; i < ${i}; i++) {\n            x[${o} - 1] = indices[${o} - 1] * ${s} - ${c} + i;\n            if (x[${o} - 1] < 0 || x[${o} - 1] >= ${u}) {\n              pad++;\n              continue;\n            }\n            ${n}\n          }`),
                        t.kernelShape.length === 2)
                      ) {
                        let n = t.kernelShape[t.kernelShape.length - 2],
                          r = t.strides[t.strides.length - 2],
                          a = t.pads[t.pads.length / 2 - 2],
                          s = t.pads[t.pads.length - 2],
                          c = e[o - 2];
                        ((f =
                          a + s === 0
                            ? `\n            for (int j = 0; j < ${n}; j++) {\n              x[${o} - 2] = indices[${o} - 2] * ${r} - ${a} + j;\n            `
                            : `\n            for (int j = 0; j < ${n}; j++) {\n              x[${o} - 2] = indices[${o} - 2] * ${r} - ${a} + j;\n              if (x[${o} - 2] < 0 || x[${o} - 2] >= ${c}) {\n                pad+= ${i};\n                continue;\n              }\n          `),
                          (p = `
          }
        `));
                      }
                      return `\n        float process(int indices[${o}]) {\n          int x[${o}];\n          copyVec(indices, x);\n\n          float value = ${a};\n          int pad = 0;\n          ${f}\n          ${d}\n          ${p}\n          ${r}\n          return value;\n        }\n      `;
                    }
                    {
                      let s = i.ShapeUtil.size(t.kernelShape),
                        c = i.ShapeUtil.computeStrides(t.kernelShape),
                        l = c.length,
                        u = t.pads.length,
                        d = m(l),
                        f = p(e, `inputDims`),
                        h = p(t.pads, `pads`),
                        g = p(c, `kernelStrides`),
                        _ = p(t.strides, `strides`),
                        v = ``;
                      return (
                        (v = t.pads.reduce((e, t) => e + t)
                          ? `\n            if (x[j] >= inputDims[j] || x[j] < 0) {\n              pad++;\n              isPad = true;\n              break;\n            }\n          }\n          if (!isPad) {\n            ${n}\n          }`
                          : `\n          }\n          ${n}\n        `),
                        `\n        ${d}\n        float process(int indices[${o}]) {\n          int x[${o}];\n          copyVec(indices, x);\n          int offset[${l}];\n          int pads[${u}];\n          int inputDims[${o}];\n          int kernelStrides[${l}];\n          int strides[${l}];\n          ${h}\n          ${f}\n          ${_}\n          ${g}\n\n          float value = ${a};\n          int pad = 0;\n          bool isPad = false;\n          for (int i = 0; i < ${s}; i++) {\n            offsetToIndices(i, kernelStrides, offset);\n            isPad = false;\n            for (int j = ${o} - ${l}; j < ${o}; j++) {\n              x[j] = indices[j] * strides[j - ${o} + ${l}]\n                + offset[j - ${o} + ${l}] - pads[j - 2];\n              ${v}\n          }\n          ${r}\n\n          return value;\n        }\n      `
                      );
                    }
                  },
                  p = (e, t) => {
                    let n = ``;
                    for (let r = 0; r < e.length; r++) n += `\n      ${t}[${r}] = ${e[r]};\n    `;
                    return n;
                  },
                  m = (e) =>
                    `\n  void offsetToIndices(int offset, int[${e}] strides, out int[${e}] indices) {\n    if (${e} == 0) {\n      return;\n    }\n    for (int i = 0; i < ${e} - 1; ++i) {\n      indices[i] = offset / strides[i];\n      offset -= indices[i] * strides[i];\n    }\n    indices[${e} - 1] = offset;\n  }`;
              },
              4939: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.reduceLogSumSquare =
                    t.reduceLogSum =
                    t.reduceProd =
                    t.reduceMin =
                    t.reduceMax =
                    t.reduceMean =
                    t.reduceSum =
                    t.parseReduceAttributes =
                      void 0));
                let r = n(246),
                  i = n(782),
                  a = n(2517),
                  o = n(2039),
                  s = (e, t, n, r, i) => {
                    l(t);
                    let a = { name: r, inputNames: [`A`], inputTypes: [o.TextureType.unpacked] };
                    return [
                      e.run(
                        Object.assign(Object.assign({}, a), { cacheHint: n.cacheKey, get: () => c(e, t, n, r, i, a) }),
                        t,
                      ),
                    ];
                  };
                t.parseReduceAttributes = (e) => {
                  let t = e.attributes.getInts(`axes`, []),
                    n = e.attributes.getInt(`keepdims`, 1) === 1;
                  return (0, r.createAttributeWithCacheKey)({ axes: t, keepDims: n });
                };
                let c = (e, t, n, r, i, s) => {
                    let c = [],
                      l = t[0].dims.length || 1,
                      u = [],
                      d = a.ShapeUtil.normalizeAxes(n.axes, t[0].dims.length),
                      f = i(t, d),
                      p = f[1];
                    for (let e = 0; e < t[0].dims.length; e++)
                      d.indexOf(e) >= 0 || d.length === 0
                        ? (n.keepDims && c.push(1),
                          (p = `\n          for(int j${e} = 0; j${e} < ${t[0].dims[e]}; j${e}++) {\n            inputIdx[${e}] = j${e};\n            ${p}\n          }`))
                        : (u.push(`inputIdx[${e}] = outputIdx[${c.length}];`), c.push(t[0].dims[e]));
                    let m = `\n      float process(int outputIdx[${c.length || 1}]) {\n        float value;                 // final result\n        int inputIdx[${l}];      // addressing input data\n        ${u.join(`
`)}\n        ${f[0]}       // init ops for reduce max/min\n        ${p}\n        ${f[2]}       // final computation for reduce mean\n        return value;\n      }`;
                    return Object.assign(Object.assign({}, s), {
                      output: { dims: c, type: t[0].type, textureType: o.TextureType.unpacked },
                      shaderSource: m,
                    });
                  },
                  l = (e) => {
                    if (!e || e.length !== 1) throw Error(`Reduce op requires 1 input.`);
                    if (i.NUMBER_TYPES.indexOf(e[0].type) === -1) throw Error(`Invalid input type.`);
                  };
                ((t.reduceSum = (e, t, n) =>
                  s(e, t, n, `ReduceSum`, () => [`value = 0.0;`, `value += _A(inputIdx);`, ``])),
                  (t.reduceMean = (e, t, n) =>
                    s(e, t, n, `ReduceMean`, (e, t) => {
                      let n = 1;
                      for (let r = 0; r < e[0].dims.length; r++)
                        (t.indexOf(r) >= 0 || t.length === 0) && (n *= e[0].dims[r]);
                      return [`value = 0.0;`, `value += _A(inputIdx);`, `value /= ${n}.;`];
                    })),
                  (t.reduceMax = (e, t, n) =>
                    s(e, t, n, `ReduceMax`, (e, t) => {
                      let n = [];
                      for (let r = 0; r < e[0].dims.length; r++)
                        (t.indexOf(r) >= 0 || t.length === 0) && n.push(`inputIdx[${r}] = 0;`);
                      return [
                        `${n.join(`
`)}\nvalue = _A(inputIdx);`,
                        `value = max(value, _A(inputIdx));`,
                        ``,
                      ];
                    })),
                  (t.reduceMin = (e, t, n) =>
                    s(e, t, n, `ReduceMin`, (e, t) => {
                      let n = [];
                      for (let r = 0; r < e[0].dims.length; r++)
                        (t.indexOf(r) >= 0 || t.length === 0) && n.push(`inputIdx[${r}] = 0;`);
                      return [
                        `${n.join(`
`)}\nvalue = _A(inputIdx);`,
                        `value = min(value, _A(inputIdx));`,
                        ``,
                      ];
                    })),
                  (t.reduceProd = (e, t, n) =>
                    s(e, t, n, `ReduceProd`, () => [`value = 1.0;`, `value *= _A(inputIdx);`, ``])),
                  (t.reduceLogSum = (e, t, n) =>
                    s(e, t, n, `ReduceLogSum`, () => [
                      `value = 0.0;`,
                      `value += _A(inputIdx);`,
                      `value = log(value);`,
                    ])),
                  (t.reduceLogSumSquare = (e, t, n) =>
                    s(e, t, n, `ReduceLogSumSquare`, () => [
                      `float t; value = 0.0;`,
                      `t = _A(inputIdx); value += t * t;`,
                      ``,
                    ])));
              },
              7019: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.isReshapeCheap = t.processDims3D = t.createPackedReshape3DProgramInfoLoader = void 0));
                let r = n(2517),
                  i = n(5060),
                  a = n(2039),
                  o = n(2827);
                ((t.createPackedReshape3DProgramInfoLoader = (e, t, n) => {
                  let s = ((e) => ({
                    name: `Reshape (packed)`,
                    inputTypes: [a.TextureType.packed],
                    inputNames: [`A`],
                    cacheHint: `${e}`,
                  }))(n);
                  return Object.assign(Object.assign({}, s), {
                    get: () =>
                      ((e, t, n, s) => {
                        let c = t.dims,
                          l = s,
                          u = ``;
                        for (let e = 0; e < 4; e++) {
                          let t = ``;
                          switch (e) {
                            case 0:
                              t = `outputCoords = rc;`;
                              break;
                            case 1:
                              t = `outputCoords = ivec3(rc.x, rc.y+1, rc.z);`;
                              break;
                            case 2:
                              t = `outputCoords = ivec3(rc.x, rc.y, rc.z+1);`;
                              break;
                            case 3:
                              t = `outputCoords = ivec3(rc.x, rc.y+1, rc.z+1);`;
                              break;
                            default:
                              throw Error();
                          }
                          u += `\n        ${t}\n        ${e > 0 ? `if(outputCoords.y < rows && outputCoords.z < cols){` : ``}\n          int flattenedIndex = getFlattenedIndex(outputCoords);\n\n          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flattenedIndex);\n          vec2 innerDims = vec2(float(inputRC.y),float(inputRC.z));\n\n          result[${e}] = getChannel(getA(inputRC.x, inputRC.y, inputRC.z), innerDims);\n\n        ${e > 0 ? `}` : ``}\n      `;
                        }
                        let d = (0, i.getGlsl)(e.session.backend.glContext.version),
                          f = `\n      ${(function (e) {
                            let t = r.ShapeUtil.computeStrides(e),
                              n = [`b`, `r`, `c`],
                              i = `index`;
                            return `\n    ivec3 inputCoordsFromReshapedOutCoords(int index) {\n      ${t.map((e, r) => `int ${n[r]} = ${i} / ${e}; ${r === t.length - 1 ? `int ${n[r + 1]} = ${i} - ${n[r]} * ${e}` : `index -= ${n[r]} * ${e}`};`).join(``)}\n      return ivec3(b, r, c);\n    }\n  `;
                          })(c)}\n      ${(function (e) {
                            let t = r.ShapeUtil.computeStrides(e);
                            return `\n  int getFlattenedIndex(ivec3 coords) {\n    // reverse y, z order\n    return coords.x * ${t[0]} + coords.z * ${t[1]} + coords.y;\n  }\n`;
                          })(
                            l,
                          )}\n      ${(0, o.unpackFromChannel)()}\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0.0);\n\n        ivec3 outputCoords;\n        int rows = ${l[2]};\n        int cols = ${l[1]};\n\n        ${u}\n        ${d.output} = result;\n      }\n    `;
                        return Object.assign(Object.assign({}, n), {
                          output: { dims: l, type: t.type, textureType: a.TextureType.packed },
                          shaderSource: f,
                          hasMain: !0,
                        });
                      })(e, t, s, n),
                  });
                }),
                  (t.processDims3D = function (e) {
                    if (e.length === 0) return [1, 1, 1];
                    let t = 1;
                    for (let n = 0; n < e.length - 2; ++n) t *= e[n];
                    return [t, e.length > 1 ? e[e.length - 2] : 1, e[e.length - 1]];
                  }),
                  (t.isReshapeCheap = function (e, t) {
                    let n = !1;
                    return (
                      (n =
                        e.length === 0 ||
                        t.length === 0 ||
                        (e.length < 2 || t.length < 2
                          ? e[e.length - 1] === t[t.length - 1]
                          : e[e.length - 1] === t[t.length - 1] && e[e.length - 2] === t[t.length - 2])),
                      n
                    );
                  }));
              },
              718: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.reshape = void 0));
                let r = n(2517);
                t.reshape = (e, t) => {
                  let n = r.ShapeUtil.calculateReshapedDims(t[0].dims, t[1].integerData);
                  return e.session.pack ? [e.reshapePacked(t[0], n)] : [e.reshapeUnpacked(t[0], n)];
                };
              },
              2268: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseResizeAttributesV11 = t.parseResizeAttributesV10 = t.resize = void 0));
                let r = n(5060),
                  i = n(2039),
                  a = n(9390),
                  o = n(2827),
                  s = n(9793),
                  c = { name: `Resize`, inputNames: [`A`], inputTypes: [i.TextureType.packed] };
                ((t.resize = (e, t, n) => (
                  (0, s.validateInputs)(t, n),
                  [e.run(Object.assign(Object.assign({}, c), { cacheHint: n.cacheKey, get: () => l(e, t, n) }), t)]
                )),
                  (t.parseResizeAttributesV10 = (e) => (0, s.parseUpsampleAttributes)(e, 10)),
                  (t.parseResizeAttributesV11 = (e) => (0, s.parseUpsampleAttributes)(e, 11)));
                let l = (e, t, n) => {
                    let s = (0, r.getGlsl)(e.session.backend.glContext.version),
                      [l, d] = u(t, n);
                    if (l.every((e) => e === 1) && n.coordinateTransformMode !== `tf_crop_and_resize`)
                      return Object.assign(Object.assign({}, c), {
                        output: { dims: d, type: t[0].type, textureType: i.TextureType.packed },
                        hasMain: !0,
                        shaderSource: `void main() {\n                    vec4 v = ${s.texture2D}(X, TexCoords);\n                    ${s.output} = v;\n                }`,
                      });
                    let f = d.length;
                    if (f < 2) throw Error(`output dimension should be at least 2, but got ${f}`);
                    let p = d[f - 2],
                      m = d[f - 1],
                      h = t[0].dims;
                    if (f !== h.length) throw Error(`output dimension should match input ${h.length}, but got ${f}`);
                    let g = h[f - 2],
                      _ = h[f - 1],
                      v = l[f - 2],
                      y = l[f - 1],
                      b = ``;
                    if (n.mode !== `linear`) throw Error(`resize (packed) does not support mode: '${n.mode}'`);
                    switch (n.coordinateTransformMode) {
                      case `asymmetric`:
                        b = `
                    vec4 getSourceFracIndex(ivec4 coords) {
                        return vec4(coords) / scaleWHWH;
                    }
                `;
                        break;
                      case `half_pixel`:
                        b = `
                    vec4 getSourceFracIndex(ivec4 coords) {
                        return (vec4(coords) + 0.5) / scaleWHWH - 0.5;
                    }
                `;
                        break;
                      case `pytorch_half_pixel`:
                        b = `\n                    vec4 getSourceFracIndex(ivec4 coords) {\n                        vec4 fcoords = vec4(coords);\n                        return vec4(\n                            ${m}.0 > 1.0 ? (fcoords.x + 0.5) / scaleWHWH.x - 0.5 : 0.0,\n                            ${p}.0 > 1.0 ? (fcoords.y + 0.5) / scaleWHWH.y - 0.5 : 0.0,\n                            ${m}.0 > 1.0 ? (fcoords.z + 0.5) / scaleWHWH.z - 0.5 : 0.0,\n                            ${p}.0 > 1.0 ? (fcoords.w + 0.5) / scaleWHWH.w - 0.5 : 0.0\n                          );\n                    }\n                `;
                        break;
                      case `align_corners`:
                        b = `\n                    vec4 getSourceFracIndex(ivec4 coords) {\n                        vec4 resized = vec4(${m}.0 - 1.0, ${p}.0 - 1.0, ${m}.0 - 1.0,\n                            ${p}.0 - 1.0);\n                        vec4 original = vec4(${_}.0 - 1.0, ${g}.0 - 1.0, ${_}.0 - 1.0,\n                            ${g}.0 - 1.0);\n                        vec4 new_scale = original / resized;\n                        return vec4(coords) * new_scale;\n                    }\n                `;
                        break;
                      default:
                        throw Error(
                          `resize (packed) does not support coordinateTransformMode:                                 '${n.coordinateTransformMode}'`,
                        );
                    }
                    let x = (0, a.getCoordsDataType)(f),
                      S = `\n            const vec2 inputWH = vec2(${g}.0, ${_}.0);\n            const vec4 scaleWHWH = vec4(float(${v}), float(${y}), float(${v}), float(${y}));\n            ${(0, o.unpackFromChannel)()}\n            ${b}\n            float getAValue(int x10, int r, int c, int d) {\n                return getChannel(getA(x10, r, c, d), vec2(c, d));\n            }\n            void main() {\n                ${x} rc = getOutputCoords();\n\n                int batch = rc[0];\n                int depth = rc[1];\n\n                // retrieve the 4 coordinates that is used in the 4 packed output values.\n                ivec4 coords = ivec4(rc.wz, rc.w + 1, rc.z + 1);\n\n                // calculate the source index in fraction\n                vec4 sourceFrac = getSourceFracIndex(coords);\n\n                // get the lower and upper bound of the 4 values that will be packed into one texel.\n                ivec4 x00 = ivec4(max(sourceFrac.xy, vec2(0.0)), min(inputWH - 1.0, ceil(sourceFrac.xy)));\n                ivec4 x01 = ivec4(max(sourceFrac.xw, vec2(0.0)), min(inputWH - 1.0, ceil(sourceFrac.xw)));\n                ivec4 x10 = ivec4(max(sourceFrac.zy, vec2(0.0)), min(inputWH - 1.0, ceil(sourceFrac.zy)));\n                ivec4 x11 = ivec4(max(sourceFrac.zw, vec2(0.0)), min(inputWH - 1.0, ceil(sourceFrac.zw)));\n\n                bool hasNextRow = rc.w < ${p - 1};\n                bool hasNextCol = rc.z < ${m - 1};\n\n                // pack x00, x01, x10, x11's top-left corner into one vec4 structure\n                vec4 topLeft = vec4(\n                    getAValue(batch, depth, x00.x, x00.y),\n                    hasNextCol ? getAValue(batch, depth, x01.x, x01.y) : 0.0,\n                    hasNextRow ? getAValue(batch, depth, x10.x, x10.y) : 0.0,\n                    (hasNextRow && hasNextCol) ? getAValue(batch, depth, x11.x, x11.y) : 0.0);\n\n                // pack x00, x01, x10, x11's top-right corner into one vec4 structure\n                vec4 topRight = vec4(\n                    getAValue(batch, depth, x00.x, x00.w),\n                    hasNextCol ? getAValue(batch, depth, x01.x, x01.w) : 0.0,\n                    hasNextRow ? getAValue(batch, depth, x10.x, x10.w) : 0.0,\n                    (hasNextRow && hasNextCol) ? getAValue(batch, depth, x11.x, x11.w) : 0.0);\n\n                // pack x00, x01, x10, x11's bottom-left corner into one vec4 structure\n                vec4 bottomLeft = vec4(\n                    getAValue(batch, depth, x00.z, x00.y),\n                    hasNextCol ? getAValue(batch, depth, x01.z, x01.y) : 0.0,\n                    hasNextRow ? getAValue(batch, depth, x10.z, x10.y) : 0.0,\n                    (hasNextRow && hasNextCol) ? getAValue(batch, depth, x11.z, x11.y) : 0.0);\n\n                // pack x00, x01, x10, x11's bottom-right corner into one vec4 structure\n                vec4 bottomRight = vec4(\n                    getAValue(batch, depth, x00.z, x00.w),\n                    hasNextCol ? getAValue(batch, depth, x01.z, x01.w) : 0.0,\n                    hasNextRow ? getAValue(batch, depth, x10.z, x10.w) : 0.0,\n                    (hasNextRow && hasNextCol) ? getAValue(batch, depth, x11.z, x11.w) : 0.0);\n\n                // calculate the interpolation fraction on u and v direction\n                vec4 frac = vec4(sourceFrac) - floor(sourceFrac);\n                vec4 clampFrac = clamp(frac, vec4(0.0), vec4(1.0));\n\n                vec4 top = mix(topLeft, topRight, clampFrac.ywyw);\n                vec4 bottom = mix(bottomLeft, bottomRight, clampFrac.ywyw);\n                vec4 newValue = mix(top, bottom, clampFrac.xxzz);\n\n                ${s.output} = vec4(newValue);\n            }\n        `;
                    return Object.assign(Object.assign({}, c), {
                      output: { dims: d, type: t[0].type, textureType: i.TextureType.packed },
                      hasMain: !0,
                      shaderSource: S,
                    });
                  },
                  u = (e, t) => {
                    let n = e[0].dims,
                      r,
                      i = t.scales;
                    if (i.length === 0) {
                      let a = e[t.scalesInputIdx];
                      if (a && a.size !== 0) {
                        if (e[t.sizesInputIdx]) throw Error(`Only one of scales or sizes must be provided as input.`);
                        i = d(a, t.mode, t.isResize);
                      } else {
                        let a = e[t.sizesInputIdx];
                        if (!a || a.size === 0) throw Error(`Either scales or sizes MUST be provided as input.`);
                        ((r = Array.from(a.integerData)), (i = f(r, n, t.mode, t.isResize)));
                      }
                    } else if (e[t.sizesInputIdx])
                      throw Error(`Only one of scales or sizes must be provided as input.`);
                    let a = r || n.map((e, t) => Math.floor(e * i[t]));
                    return [i, a];
                  },
                  d = (e, t, n) => {
                    let r = Array.from(e.floatData);
                    return ((0, s.scalesValidation)(r, t, n), r);
                  },
                  f = (e, t, n, r) => {
                    let i = t.length,
                      a = Array(i);
                    for (let n = 0, r = i; n < r; n++)
                      if (t[n] === 0) {
                        if (e[n] !== 0) throw Error(`Input dim is zero but required output dim is non-zero.`);
                        a[n] = 1;
                      } else a[n] = e[n] / t[n];
                    return ((0, s.scalesValidation)(a, n, r), a);
                  };
              },
              8117: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.shape = void 0));
                let r = n(9162);
                t.shape = (e, t) => (
                  i(t),
                  [new r.Tensor([t[0].dims.length], `int32`, void 0, void 0, new Int32Array(t[0].dims))]
                );
                let i = (e) => {
                  if (!e || e.length !== 1) throw Error(`Shape requires 1 input.`);
                };
              },
              2278: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.sliceV10 = t.parseSliceAttributes = t.slice = void 0));
                let r = n(246),
                  i = n(782),
                  a = n(2517),
                  o = n(2039),
                  s = { name: `Slice`, inputNames: [`A`], inputTypes: [o.TextureType.unpacked] };
                ((t.slice = (e, t, n) => (
                  l(t),
                  [e.run(Object.assign(Object.assign({}, s), { cacheHint: n.cacheKey, get: () => c(e, t[0], n) }), t)]
                )),
                  (t.parseSliceAttributes = (e) => {
                    let t = e.attributes.getInts(`starts`),
                      n = e.attributes.getInts(`ends`),
                      i = e.attributes.getInts(`axes`, []);
                    return (0, r.createAttributeWithCacheKey)({ starts: t, ends: n, axes: i });
                  }));
                let c = (e, t, n) => {
                    let r = n.axes.length === 0 ? t.dims.slice(0).map((e, t) => t) : n.axes,
                      i = a.ShapeUtil.normalizeAxes(r, t.dims.length),
                      c = n.starts.map((e, n) =>
                        e > t.dims[i[n]] - 1 ? t.dims[i[n]] : a.ShapeUtil.normalizeAxis(e, t.dims[i[n]]),
                      ),
                      l = n.ends.map((e, n) =>
                        e > t.dims[i[n]] - 1 ? t.dims[i[n]] : a.ShapeUtil.normalizeAxis(e, t.dims[i[n]]),
                      ),
                      u = t.dims.slice(),
                      d = [];
                    for (let e = 0; e < i.length; e++)
                      ((u[i[e]] = l[e] - c[e]), c[e] > 0 && d.push(`outputIdx[${i[e]}] += ${c[e]};`));
                    let f = `\n      float process(int outputIdx[${u.length}]) {\n        ${d.join(`
      `)}\n        return _A(outputIdx);\n      }`;
                    return Object.assign(Object.assign({}, s), {
                      output: { dims: u, type: t.type, textureType: o.TextureType.unpacked },
                      shaderSource: f,
                    });
                  },
                  l = (e) => {
                    if (!e || e.length !== 1) throw Error(`Slice requires 1 input.`);
                    if (i.NUMBER_TYPES.indexOf(e[0].type) === -1) throw Error(`Invalid input type.`);
                  };
                t.sliceV10 = (e, t) => {
                  d(t);
                  let n = u(e, t);
                  return [
                    e.run(Object.assign(Object.assign({}, s), { cacheHint: n.cacheKey, get: () => c(e, t[0], n) }), [
                      t[0],
                    ]),
                  ];
                };
                let u = (e, t) => {
                    if (
                      !e.session.isInitializer(t[1].dataId) ||
                      !e.session.isInitializer(t[2].dataId) ||
                      (t.length >= 4 && !e.session.isInitializer(t[3].dataId)) ||
                      (t.length >= 5 && !e.session.isInitializer(t[4].dataId))
                    )
                      throw Error(`dynamic slice attributes are not allowed`);
                    if (t.length >= 5 && t[4].integerData.some((e) => e !== 1))
                      throw Error(`currently non-1 steps is not supported for Slice`);
                    let n = Array.from(t[1].integerData),
                      r = Array.from(t[2].integerData),
                      i = t.length >= 4 ? Array.from(t[3].integerData) : [];
                    return { starts: n, ends: r, axes: i, cacheKey: `${i};${n};${r}` };
                  },
                  d = (e) => {
                    if (!e || e.length < 3 || e.length > 5) throw Error(`Invalid input number.`);
                    if (
                      e[1].type !== `int32` ||
                      e[1].dims.length !== 1 ||
                      e[2].type !== `int32` ||
                      e[2].dims.length !== 1 ||
                      (e.length >= 4 && (e[3].type !== `int32` || e[3].dims.length !== 1)) ||
                      (e.length >= 5 && (e[4].type !== `int32` || e[4].dims.length !== 1))
                    )
                      throw Error(`Invalid input type.`);
                  };
              },
              5524: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.softmaxV13 = t.parseSoftmaxAttributesV13 = t.parseSoftmaxAttributes = t.softmax = void 0));
                let r = n(246),
                  i = n(2517),
                  a = n(5060),
                  o = n(2039),
                  s = n(3738),
                  c = { name: `SoftmaxComputeMax`, inputNames: [`A`], inputTypes: [o.TextureType.unpacked] },
                  l = {
                    name: `SoftmaxComputeScale`,
                    inputNames: [`A`, `Max`],
                    inputTypes: [o.TextureType.unpacked, o.TextureType.unpacked],
                  },
                  u = {
                    name: `SoftMax`,
                    inputNames: [`A`, `Max`, `Norm`],
                    inputTypes: [o.TextureType.unpacked, o.TextureType.unpacked, o.TextureType.unpacked],
                  };
                ((t.softmax = (e, t, n) => {
                  h(t);
                  let r = t[0].dims.slice(),
                    a = i.ShapeUtil.normalizeAxis(n.axis, r.length);
                  return d(e, t, n, i.ShapeUtil.sizeToDimension(r, a), i.ShapeUtil.sizeFromDimension(r, a));
                }),
                  (t.parseSoftmaxAttributes = (e) =>
                    (0, r.createAttributeWithCacheKey)({ axis: e.attributes.getInt(`axis`, 1) })),
                  (t.parseSoftmaxAttributesV13 = (e) =>
                    (0, r.createAttributeWithCacheKey)({ axis: e.attributes.getInt(`axis`, -1) })),
                  (t.softmaxV13 = (e, t, n) => {
                    h(t);
                    let a = t[0].dims.slice(),
                      o = i.ShapeUtil.normalizeAxis(n.axis, a.length),
                      c = a.length,
                      l = o !== c - 1,
                      u = [],
                      f,
                      p = [],
                      m = [];
                    l &&
                      ((p = Array.from({ length: c }).map((e, t) => t)),
                      (p[o] = c - 1),
                      (p[c - 1] = o),
                      p.map((e) => u.push(a[e])),
                      (f = (0, r.createAttributeWithCacheKey)({ perm: p })),
                      (m = (0, s.transpose)(e, t, f)));
                    let g = l ? i.ShapeUtil.sizeToDimension(u, c - 1) : i.ShapeUtil.sizeToDimension(a, c - 1),
                      _ = l ? i.ShapeUtil.sizeFromDimension(u, c - 1) : i.ShapeUtil.sizeFromDimension(a, c - 1),
                      v = d(e, l ? m : t, n, g, _);
                    return l ? (0, s.transpose)(e, v, f) : v;
                  }));
                let d = (e, t, n, r, i) => {
                    let a = f(e, t[0], r, i, [r]),
                      o = e.run(Object.assign(Object.assign({}, c), { cacheHint: n.cacheKey, get: () => a }), t),
                      s = p(e, t[0], r, i, a.output.dims, [r]),
                      d = e.run(Object.assign(Object.assign({}, l), { cacheHint: n.cacheKey, get: () => s }), [
                        t[0],
                        o,
                      ]),
                      h = m(e, t[0], r, i, a.output.dims, s.output.dims);
                    return [
                      e.run(Object.assign(Object.assign({}, u), { cacheHint: n.cacheKey, get: () => h }), [t[0], o, d]),
                    ];
                  },
                  f = (e, t, n, r, i) => {
                    let [s, l] = e.calculateTextureWidthAndHeight(t.dims, o.TextureType.unpacked),
                      u = i.length;
                    if (n < 1 || r < 1)
                      throw Error(`Logical row count N and feature count D must be greater than or equal to 1`);
                    if (i.length !== 1) throw Error(`Dimensionality of the output should be 1`);
                    if (i[0] !== n) throw Error(`Shape of the output should be equal to logical row count`);
                    let d = (0, a.getGlsl)(e.session.backend.glContext.version),
                      f = `\n      float process(int[${u}] indices) {\n        int logical_row_start_offset = indices[0] * ${r};\n\n        float max = getColorAsFloat(${d.texture2D}(A, offsetToCoords(logical_row_start_offset, ${s},\n        ${l} )));\n        for(int i=1; i<${r}; ++i)\n        {\n          float current = getColorAsFloat(${d.texture2D}(A, offsetToCoords(logical_row_start_offset + i,\n            ${s}, ${l})));\n          if(current > max)\n          max = current;\n        }\n\n        return max;\n      }`;
                    return Object.assign(Object.assign({}, c), {
                      output: { dims: i, type: t.type, textureType: o.TextureType.unpacked },
                      shaderSource: f,
                    });
                  },
                  p = (e, t, n, r, i, s) => {
                    let [c, u] = e.calculateTextureWidthAndHeight(t.dims, o.TextureType.unpacked),
                      d = s.length;
                    if (n < 1 || r < 1)
                      throw Error(`Logical row count N and feature count D must be greater than or equal to 1`);
                    if (s.length !== 1) throw Error(`Dimensionality of the output should be 1`);
                    if (s[0] !== n) throw Error(`Shape of the output should be equal to logical row count`);
                    if (i.length !== 1) throw Error(`Dimensionality of the intermediate results should be 1`);
                    if (i[0] !== n)
                      throw Error(`Shape of the intermediate results should be equal to logical row count`);
                    let f = `\n      float process(int[${d}] indices) {\n        int logical_row_start_offset = indices[0] * ${r};\n\n        float norm_factor = 0.0;\n        float max = _Max(indices);\n        for(int i=0; i<${r}; ++i)\n        {\n          norm_factor += exp(getColorAsFloat(${(0, a.getGlsl)(e.session.backend.glContext.version).texture2D}(A, offsetToCoords(logical_row_start_offset + i,\n            ${c}, ${u}))) - max);\n        }\n\n        return norm_factor;\n      }`;
                    return Object.assign(Object.assign({}, l), {
                      output: { dims: s, type: t.type, textureType: o.TextureType.unpacked },
                      shaderSource: f,
                    });
                  },
                  m = (e, t, n, r, i, a) => {
                    let [s, c] = e.calculateTextureWidthAndHeight(t.dims, o.TextureType.unpacked),
                      l = t.dims.length;
                    if (n < 1 || r < 1)
                      throw Error(`Logical row count N and feature count D must be greater than or equal to 1`);
                    if (i.length !== 1 || a.length !== 1)
                      throw Error(`Dimensionality of the intermediate results should be 1`);
                    if (i[0] !== n || a[0] !== n)
                      throw Error(`Shape of the intermediate results should be equal to logical row count`);
                    let d = `\n      float process(int[${l}] indices) {\n\n      // get offset of current logical tensor index from the 2-D texture coordinates (TexCoords)\n      int offset = coordsToOffset(TexCoords, ${s}, ${c});\n\n      //determine the logical row for this index\n      int logical_row_index[1];\n      logical_row_index[0] = offset / ${r};\n\n      float norm_factor = _Norm(logical_row_index);\n\n      // avoid possible division by 0\n      // if norm_facor is 0, all elements are zero\n      // if so, return 0\n      if(norm_factor == 0.0)\n        return 0.0;\n\n      return exp(_A(indices) - _Max(logical_row_index)) / norm_factor;\n    }`;
                    return Object.assign(Object.assign({}, u), {
                      output: { dims: t.dims, type: t.type, textureType: o.TextureType.unpacked },
                      shaderSource: d,
                    });
                  },
                  h = (e) => {
                    if (!e || e.length !== 1) throw Error(`Softmax requires 1 input.`);
                    if (e[0].type !== `float32` && e[0].type !== `float64`) throw Error(`Invalid input type`);
                  };
              },
              5975: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.parseSplitAttributes = t.split = void 0));
                let r = n(246),
                  i = n(2517),
                  a = n(2039),
                  o = { name: `Split`, inputNames: [`A`], inputTypes: [a.TextureType.unpacked] };
                ((t.split = (e, t, n) => {
                  l(t);
                  let r = i.ShapeUtil.normalizeAxis(n.axis, t[0].dims.length),
                    a = s(e, t, r, n),
                    u = [];
                  for (let i = 0; i < a; ++i)
                    u.push(
                      e.run(
                        Object.assign(Object.assign({}, o), {
                          cacheHint: `${n.cacheKey};${i}`,
                          get: () => c(e, t[0], n, r, i),
                        }),
                        t,
                      ),
                    );
                  return u;
                }),
                  (t.parseSplitAttributes = (e) => {
                    let t = e.attributes.getInt(`axis`, 0),
                      n = e.attributes.getInts(`split`, []),
                      i = e.outputs.length;
                    return (0, r.createAttributeWithCacheKey)({ axis: t, split: n, numOutputs: i });
                  }));
                let s = (e, t, n, r) => {
                    let [, a] = i.SplitUtil.splitShape(t[0].dims, n, r.split, r.numOutputs);
                    return a.length;
                  },
                  c = (e, t, n, r, s) => {
                    let [c, l] = i.SplitUtil.splitShape(t.dims, r, n.split, n.numOutputs),
                      u = l[s],
                      d = c[s],
                      f = `\n      float process(int indices[${d.length}]) {\n        indices[${r}] += ${u};\n        return _A(indices);\n      }\n    `;
                    return Object.assign(Object.assign({}, o), {
                      cacheHint: `${n.cacheKey}:${s}`,
                      output: { dims: d, type: t.type, textureType: a.TextureType.unpacked },
                      shaderSource: f,
                    });
                  },
                  l = (e) => {
                    if (!e || e.length !== 1) throw Error(`Split requires one input.`);
                    if (
                      e[0].type !== `int8` &&
                      e[0].type !== `uint8` &&
                      e[0].type !== `int16` &&
                      e[0].type !== `uint16` &&
                      e[0].type !== `int32` &&
                      e[0].type !== `uint32` &&
                      e[0].type !== `float32` &&
                      e[0].type !== `float64` &&
                      e[0].type !== `bool`
                    )
                      throw Error(`Invalid input type.`);
                  };
              },
              3933: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseSqueezeAttributes = t.squeezeV13 = t.squeeze = void 0));
                let r = n(2517);
                ((t.squeeze = (e, t, n) => {
                  i(t);
                  let a = r.ShapeUtil.squeezeShape(t[0].dims, n);
                  return [e.reshapeUnpacked(t[0], a)];
                }),
                  (t.squeezeV13 = (e, n) => (a(n), (0, t.squeeze)(e, [n[0]], Array.from(n[1].integerData)))),
                  (t.parseSqueezeAttributes = (e) => e.attributes.getInts(`axes`)));
                let i = (e) => {
                    if (!e || e.length !== 1) throw Error(`Squeeze requires 1 input.`);
                    if (e[0].type === `string`) throw Error(`invalid input tensor types.`);
                  },
                  a = (e) => {
                    if (!e || e.length !== 2) throw Error(`Squeeze requires 2 inputs.`);
                    if (e[1].type !== `int32`) throw Error(`Invalid input type.`);
                  };
              },
              6558: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.sum = void 0));
                let r = n(5060),
                  i = n(2039);
                t.sum = (e, t) => {
                  o(t);
                  let n = {
                    name: `Sum`,
                    inputNames: t.map((e, t) => `X${t}`),
                    inputTypes: Array(t.length).fill(i.TextureType.unpacked),
                  };
                  return [e.run(Object.assign(Object.assign({}, n), { get: () => a(e, t, n) }), t)];
                };
                let a = (e, t, n) => {
                    let a = (0, r.getGlsl)(e.session.backend.glContext.version),
                      o = t[0].dims.slice(),
                      s = `\n      void main() {\n        vec4 result = ${t.map((e, t) => `${a.texture2D}(X${t},TexCoords)`).join(` + `)};\n        ${a.output} = result;\n      }\n    `;
                    return Object.assign(Object.assign({}, n), {
                      output: { dims: o, type: t[0].type, textureType: i.TextureType.unpacked },
                      hasMain: !0,
                      shaderSource: s,
                    });
                  },
                  o = (e) => {
                    if (!e || e.length === 0) throw Error(`Sum requires inputs.`);
                    let t = e[0].dims.length;
                    for (let n = 1; n < e.length; n++) {
                      if (t !== e[n].dims.length) throw Error(`Input shapes are mismatched.`);
                      for (let r = 0; r < t; r++)
                        if (e[0].dims[r] !== e[n].dims[r]) throw Error(`Input shapes are not matched.`);
                    }
                    if (e[0].type !== `float32` && e[0].type !== `float64`) throw Error(`Invalid input type.`);
                    for (let t = 1; t < e.length; t++)
                      if (e[0].type !== e[t].type) throw Error(`Input types are not matched.`);
                  };
              },
              5723: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.tile = void 0));
                let r = n(782),
                  i = n(2039);
                t.tile = (e, t) => {
                  o(t);
                  let n = { name: `Tile`, inputNames: [`A`], inputTypes: [i.TextureType.unpacked] };
                  return [e.run(Object.assign(Object.assign({}, n), { get: () => a(e, t, n) }), t)];
                };
                let a = (e, t, n) => {
                    let r = t[0].dims.slice(),
                      a = Array(r.length),
                      o = [];
                    for (let e = 0; e < r.length; e++)
                      ((a[e] = r[e] * t[1].numberData[e]),
                        o.push(`inputIdx[${e}] = int(mod(float(outputIdx[${e}]), ${r[e]}.));`));
                    let s = a.length,
                      c = `\n      float process(int outputIdx[${s}]) {\n        int inputIdx[${s}];\n        ${o.join(`
`)}\n        return _A(inputIdx);\n      }\n    `;
                    return Object.assign(Object.assign({}, n), {
                      output: { dims: a, type: t[0].type, textureType: i.TextureType.unpacked },
                      shaderSource: c,
                    });
                  },
                  o = (e) => {
                    if (!e || e.length !== 2) throw Error(`Tile requires 2 input.`);
                    if (e[1].dims.length !== 1) throw Error(`The second input shape must 1 dimension.`);
                    if (e[1].dims[0] !== e[0].dims.length) throw Error(`Invalid input shape.`);
                    if (r.NUMBER_TYPES.indexOf(e[0].type) === -1) throw Error(`Invalid input type.`);
                    if (e[1].type !== `int32` && e[1].type !== `int16`) throw Error(`Invalid repeat type.`);
                  };
              },
              3738: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseTransposeAttributes = t.transpose = void 0));
                let r = n(246),
                  i = n(2517),
                  a = n(2039),
                  o = { name: `Transpose`, inputNames: [`A`], inputTypes: [a.TextureType.unpacked] };
                ((t.transpose = (e, t, n) => (
                  d(t),
                  [
                    e.run(
                      Object.assign(Object.assign({}, o), { cacheHint: n.cacheKey, get: () => s(e, t[0], n.perm) }),
                      t,
                    ),
                  ]
                )),
                  (t.parseTransposeAttributes = (e) =>
                    (0, r.createAttributeWithCacheKey)({ perm: e.attributes.getInts(`perm`, []) })));
                let s = (e, t, n) => {
                    let r = t.dims;
                    n = c(r, n);
                    let i = l(r, n),
                      s = r.length,
                      d = `\n      ${u(`perm`, n, s)}\n      float process(int indices[${s}]) {\n        int a[${s}];\n        perm(a, indices);\n        return _A(a);\n      }`;
                    return Object.assign(Object.assign({}, o), {
                      output: { dims: i, type: t.type, textureType: a.TextureType.unpacked },
                      shaderSource: d,
                    });
                  },
                  c = (e, t) => (t && t.length !== e.length && (t = [...e.keys()].reverse()), t),
                  l = (e, t) => ((t = c(e, t)), i.ShapeUtil.sortBasedOnPerm(e, t)),
                  u = (e, t, n) => {
                    let r = [];
                    r.push(`void ${e}(out int a[${n}], int src[${n}]) {`);
                    for (let e = 0; e < n; ++e) r.push(`\ta[${t[e]}]=src[${e}];`);
                    return (
                      r.push(`	}`),
                      r.join(`
`)
                    );
                  },
                  d = (e) => {
                    if (!e || e.length !== 1) throw Error(`Transpose requires 1 input.`);
                    if (e[0].type !== `float32` && e[0].type !== `float64`) throw Error(`input should be float tensor`);
                  };
              },
              8710: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.encodeAsUint8 = void 0));
                let r = n(5060),
                  i = n(2039);
                t.encodeAsUint8 = (e, t) => {
                  let n = t.shape,
                    a = (0, r.getGlsl)(e.session.backend.glContext.version),
                    o = `\n    const float FLOAT_MAX = 1.70141184e38;\n    const float FLOAT_MIN = 1.17549435e-38;\n\n    bool isNaN(float val) {\n      return (val < 1.0 || 0.0 < val || val == 0.0) ? false : true;\n    }\n\n    highp vec4 encodeAsUint8(highp float v) {\n      if (isNaN(v)) {\n        return vec4(255, 255, 255, 255);\n      }\n\n      highp float av = abs(v);\n\n      if(av < FLOAT_MIN) {\n        return vec4(0.0, 0.0, 0.0, 0.0);\n      } else if(v > FLOAT_MAX) {\n        return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n      } else if(v < -FLOAT_MAX) {\n        return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n      }\n\n      highp vec4 c = vec4(0,0,0,0);\n\n      highp float e = floor(log2(av));\n      highp float m = exp2(fract(log2(av))) - 1.0;\n\n      c[2] = floor(128.0 * m);\n      m -= c[2] / 128.0;\n      c[1] = floor(32768.0 * m);\n      m -= c[1] / 32768.0;\n      c[0] = floor(8388608.0 * m);\n\n      highp float ebias = e + 127.0;\n      c[3] = floor(ebias / 2.0);\n      ebias -= c[3] * 2.0;\n      c[2] += floor(ebias) * 128.0;\n\n      c[3] += 128.0 * step(0.0, -v);\n\n      return c / 255.0;\n    }\n\n    void main() {\n      float value = ${a.texture2D}(X,TexCoords).r;\n      ${a.output} = encodeAsUint8(value);\n    }`,
                    s = {
                      name: `Uint8Encode`,
                      inputTypes: [i.TextureType.unpacked],
                      inputNames: [`X`],
                      output: { dims: n, type: t.tensor.type, textureType: i.TextureType.downloadUint8AsFloat },
                      shaderSource: o,
                      hasMain: !0,
                    };
                  return e.executeProgram(s, [t.tensor]);
                };
              },
              4909: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.tanh =
                    t.tan =
                    t.sqrt =
                    t.sin =
                    t.sigmoid =
                    t.relu =
                    t.not =
                    t.neg =
                    t.log =
                    t.parseLeakyReluAttributes =
                    t.leakyRelu =
                    t.identity =
                    t.floor =
                    t.exp =
                    t.parseEluAttributes =
                    t.elu =
                    t.cos =
                    t.ceil =
                    t.clipV11 =
                    t.parseClipAttributes =
                    t.clip =
                    t.atan =
                    t.asin =
                    t.acos =
                    t.abs =
                    t.glslTanh =
                    t.glslTan =
                    t.glslSqrt =
                    t.glslSigmoid =
                    t.glslRelu =
                    t.glslSin =
                    t.glslNot =
                    t.glslNeg =
                    t.glslLog =
                    t.glslLeakyRelu =
                    t.glslIdentity =
                    t.glslClip =
                    t.glslFloor =
                    t.glslExp =
                    t.glslElu =
                    t.glslCos =
                    t.glslCeil =
                    t.glslAtan =
                    t.glslAsin =
                    t.glslAcos =
                    t.glslAbs =
                      void 0));
                let r = n(246),
                  i = n(2517),
                  a = n(8520),
                  o = n(5060),
                  s = n(2039);
                function c() {
                  return k(`abs`);
                }
                function l() {
                  return k(`acos`);
                }
                function u() {
                  return k(`asin`);
                }
                function d() {
                  return k(`atan`);
                }
                function f() {
                  return k(`ceil`);
                }
                function p() {
                  return k(`cos`);
                }
                function m(e) {
                  let t = `elu`;
                  return {
                    body: `\n  const float alpha = float(${e});\n\n  float elu_(float a) {\n    return a >= 0.0 ? a: (exp(a) - 1.0) * alpha;\n  }\n  vec4 elu_(vec4 v) {\n    return vec4(elu_(v.x), elu_(v.y), elu_(v.z), elu_(v.w));\n  }\n  `,
                    name: `elu`,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function h() {
                  return k(`exp`);
                }
                function g() {
                  return k(`floor`);
                }
                function _(e, t) {
                  let n = `clip`;
                  return {
                    body: `\n  const float min = float(${e});\n  const float max = float(${t});\n\n  float ${n}_(float a) {\n    return clamp(a, min, max);\n  }\n  vec4 ${n}_(vec4 v) {\n    return clamp(v, min, max);\n  }\n  `,
                    name: n,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function v() {
                  let e = `indentity`;
                  return {
                    body: `\n  float ${e}_(float a) {\n    return a;\n  }\n  vec4 ${e}_(vec4 v) {\n    return v;\n  }\n  `,
                    name: e,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function y(e) {
                  let t = `leakyRelu`;
                  return {
                    body: `\n  const float alpha = float(${e});\n\n  float ${t}_(float a) {\n    return a < 0.0 ? a * alpha : a;\n  }\n  vec4 ${t}_(vec4 v) {\n    return vec4(${t}_(v.x), ${t}_(v.y), ${t}_(v.z), ${t}_(v.w));\n  }\n  `,
                    name: t,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function b() {
                  return k(`log`);
                }
                function x() {
                  let e = `neg`;
                  return {
                    body: `
  float neg_(float a) {
    return -a;
  }
  vec4 neg_(vec4 v) {
    return -v;
  }
  `,
                    name: `neg`,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function S() {
                  let e = `not`;
                  return {
                    body: `
  float not_(float a) {
    return float( ! bool(a) );
  }
  bool not_(bool a) {
    return !a;
  }
  vec4 not_(vec4 v) {
    return vec4(!bool(v.x), !bool(v.y), !bool(v.z), !bool(v.w));
  }
  bvec4 not_(bvec4 v) {
    return bvec4(!v.x, !v.y, !v.z, !v.w);
  }
  `,
                    name: `not`,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function C() {
                  return k(`sin`);
                }
                function w() {
                  let e = `relu`;
                  return {
                    body: `\n  float ${e}_(float a) {\n    return max( a, 0.0 );\n  }\n  vec4 ${e}_(vec4 v) {\n    return max( v, 0.0 );\n  }\n  `,
                    name: e,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function T() {
                  let e = `sigmoid`;
                  return {
                    body: `\n  float ${e}_(float a) {\n    return 1.0 / (1.0 + exp(-a));\n  }\n  vec4 ${e}_(vec4 v) {\n    return 1.0 / (1.0 + exp(-v));\n  }\n  `,
                    name: e,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function E() {
                  return k(`sqrt`);
                }
                function D() {
                  return k(`tan`);
                }
                function O() {
                  let e = `tanh`;
                  return {
                    body: `\n  float ${e}_(float a) {\n    a = clamp(a, -10., 10.);\n    a = exp(2.*a);\n    return (a - 1.) / (a + 1.);\n  }\n  vec4 ${e}_(vec4 v) {\n    v = clamp(v, -10., 10.);\n    v = exp(2.*v);\n    return (v - 1.) / (v + 1.);\n  }\n  `,
                    name: e,
                    type: a.FunctionType.ValueBased,
                  };
                }
                function k(e) {
                  return {
                    body: `\n  float ${e}_(float a) {\n    return ${e}(a);\n  }\n  vec4 ${e}_(vec4 v) {\n    return ${e}(v);\n  }\n  `,
                    name: e,
                    type: a.FunctionType.ValueBased,
                  };
                }
                ((t.glslAbs = c),
                  (t.glslAcos = l),
                  (t.glslAsin = u),
                  (t.glslAtan = d),
                  (t.glslCeil = f),
                  (t.glslCos = p),
                  (t.glslElu = m),
                  (t.glslExp = h),
                  (t.glslFloor = g),
                  (t.glslClip = _),
                  (t.glslIdentity = v),
                  (t.glslLeakyRelu = y),
                  (t.glslLog = b),
                  (t.glslNeg = x),
                  (t.glslNot = S),
                  (t.glslSin = C),
                  (t.glslRelu = w),
                  (t.glslSigmoid = T),
                  (t.glslSqrt = E),
                  (t.glslTan = D),
                  (t.glslTanh = O));
                let A = (e, t, n, r) => {
                  let i = e.session.pack ? s.TextureType.packed : s.TextureType.unpacked,
                    a = { name: n.name, inputTypes: [i], inputNames: [`A`], cacheHint: r };
                  return Object.assign(Object.assign({}, a), {
                    get: () =>
                      ((e, t, n, r) => {
                        let i = e.session.pack ? s.TextureType.packed : s.TextureType.unpacked,
                          a = (0, o.getGlsl)(e.session.backend.glContext.version);
                        return Object.assign(Object.assign({}, t), {
                          output: { dims: n.dims, type: n.type, textureType: i },
                          shaderSource: `\n     ${r.body}\n     void main() {\n       vec4 v = ${a.texture2D}(A, TexCoords);\n       v = ${r.name}_(v);\n       ${a.output} = v;\n     }\n     `,
                          hasMain: !0,
                        });
                      })(e, a, t, n),
                  });
                };
                ((t.abs = (e, t) => [e.run(A(e, t[0], c()), t)]),
                  (t.acos = (e, t) => [e.run(A(e, t[0], l()), t)]),
                  (t.asin = (e, t) => [e.run(A(e, t[0], u()), t)]),
                  (t.atan = (e, t) => [e.run(A(e, t[0], d()), t)]),
                  (t.clip = (e, t, n) => [e.run(A(e, t[0], _(n.min, n.max), n.cacheKey), t)]),
                  (t.parseClipAttributes = (e) =>
                    (0, r.createAttributeWithCacheKey)({
                      min: e.attributes.getFloat(`min`, i.MIN_CLIP),
                      max: e.attributes.getFloat(`max`, i.MAX_CLIP),
                    })),
                  (t.clipV11 = (e, n) => {
                    let r = j(e, n);
                    return (0, t.clip)(e, [n[0]], r);
                  }));
                let j = (e, t) => {
                  if (t.length >= 3 && (!e.session.isInitializer(t[1].dataId) || !e.session.isInitializer(t[2].dataId)))
                    throw Error(`dynamic clip attributes are not allowed`);
                  let n = t.length >= 3 ? t[1].numberData[0] : i.MIN_CLIP,
                    a = t.length >= 3 ? t[2].numberData[0] : i.MAX_CLIP;
                  return (0, r.createAttributeWithCacheKey)({ min: n, max: a });
                };
                ((t.ceil = (e, t) => [e.run(A(e, t[0], f()), t)]),
                  (t.cos = (e, t) => [e.run(A(e, t[0], p()), t)]),
                  (t.elu = (e, t, n) => [e.run(A(e, t[0], m(n.alpha), n.cacheKey), t)]),
                  (t.parseEluAttributes = (e) =>
                    (0, r.createAttributeWithCacheKey)({ alpha: e.attributes.getFloat(`alpha`, 1) })),
                  (t.exp = (e, t) => [e.run(A(e, t[0], h()), t)]),
                  (t.floor = (e, t) => [e.run(A(e, t[0], g()), t)]),
                  (t.identity = (e, t) => [e.run(A(e, t[0], v()), t)]),
                  (t.leakyRelu = (e, t, n) => [e.run(A(e, t[0], y(n.alpha), n.cacheKey), t)]),
                  (t.parseLeakyReluAttributes = (e) =>
                    (0, r.createAttributeWithCacheKey)({ alpha: e.attributes.getFloat(`alpha`, 0.01) })),
                  (t.log = (e, t) => [e.run(A(e, t[0], b()), t)]),
                  (t.neg = (e, t) => [e.run(A(e, t[0], x()), t)]),
                  (t.not = (e, t) => [e.run(A(e, t[0], S()), t)]),
                  (t.relu = (e, t) => [e.run(A(e, t[0], w()), t)]),
                  (t.sigmoid = (e, t) => [e.run(A(e, t[0], T()), t)]),
                  (t.sin = (e, t) => [e.run(A(e, t[0], C()), t)]),
                  (t.sqrt = (e, t) => [e.run(A(e, t[0], E()), t)]),
                  (t.tan = (e, t) => [e.run(A(e, t[0], D()), t)]),
                  (t.tanh = (e, t) => [e.run(A(e, t[0], O()), t)]));
              },
              5611: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.createUnpackProgramInfoLoader = t.createUnpackProgramInfo = void 0));
                let r = n(5060),
                  i = n(2039),
                  a = n(9390),
                  o = n(2827),
                  s = { name: `unpack`, inputNames: [`A`], inputTypes: [i.TextureType.packed] };
                ((t.createUnpackProgramInfo = (e, t) => {
                  let n = t.dims.length,
                    c = (0, o.getChannels)(`rc`, n),
                    l = c.slice(-2),
                    u = (0, a.getCoordsDataType)(n),
                    d = (0, o.unpackFromChannel)(),
                    f =
                      t.dims.length === 0
                        ? ``
                        : (function (e, t) {
                            if (e === 1) return `rc`;
                            let n = ``;
                            for (let r = 0; r < e; r++) ((n += t[r]), r < e - 1 && (n += `,`));
                            return n;
                          })(n, c),
                    p = n <= 1 ? `rc` : `vec2(${l.join(`,`)})`,
                    m = `\n    ${d}\n    void main() {\n      ${u} rc = getOutputCoords();\n\n       // Sample the texture with the coords to get the rgba channel value.\n       vec4 packedInput = getA(${f});\n\n       ${(0, r.getGlsl)(e.session.backend.glContext.version).output} = vec4(getChannel(packedInput, ${p}), 0, 0, 0);\n     }\n   `;
                  return Object.assign(Object.assign({}, s), {
                    hasMain: !0,
                    output: { dims: t.dims, type: t.type, textureType: i.TextureType.unpacked },
                    shaderSource: m,
                  });
                }),
                  (t.createUnpackProgramInfoLoader = (e, n) =>
                    Object.assign(Object.assign({}, s), { get: () => (0, t.createUnpackProgramInfo)(e, n) })));
              },
              8428: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.parseUnsqueezeAttributes = t.unsqueezeV13 = t.unsqueeze = void 0));
                let r = n(2517);
                ((t.unsqueeze = (e, t, n) => {
                  i(t);
                  let a = r.ShapeUtil.unsqueezeShape(t[0].dims, n);
                  return [e.reshapeUnpacked(t[0], a)];
                }),
                  (t.unsqueezeV13 = (e, n) => (a(n), (0, t.unsqueeze)(e, [n[0]], Array.from(n[1].integerData)))),
                  (t.parseUnsqueezeAttributes = (e) => e.attributes.getInts(`axes`)));
                let i = (e) => {
                    if (!e || e.length !== 1) throw Error(`Unsqueeze requires 1 input.`);
                    if (e[0].type === `string`) throw Error(`invalid input tensor types.`);
                  },
                  a = (e) => {
                    if (!e || e.length !== 2) throw Error(`Unsqueeze requires 2 inputs.`);
                    if (e[1].type !== `int32`) throw Error(`Invalid input type.`);
                  };
              },
              9793: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.scalesValidation =
                    t.validateInputs =
                    t.parseUpsampleAttributes =
                    t.parseUpsampleAttributesV9 =
                    t.parseUpsampleAttributesV7 =
                    t.upsample =
                      void 0));
                let r = n(246),
                  i = n(5060),
                  a = n(2039),
                  o = { name: `Upsample`, inputNames: [`X`], inputTypes: [a.TextureType.unpacked] };
                ((t.upsample = (e, n, r) => (
                  (0, t.validateInputs)(n, r),
                  [e.run(Object.assign(Object.assign({}, o), { cacheHint: r.cacheKey, get: () => s(e, n, r) }), n)]
                )),
                  (t.parseUpsampleAttributesV7 = (e) => (0, t.parseUpsampleAttributes)(e, 7)),
                  (t.parseUpsampleAttributesV9 = (e) => (0, t.parseUpsampleAttributes)(e, 9)),
                  (t.parseUpsampleAttributes = (e, n) => {
                    let i = n >= 10,
                      a = e.attributes.getString(`mode`, `nearest`);
                    if (a !== `nearest` && a !== `linear` && (n < 11 || a !== `cubic`))
                      throw Error(`unrecognized mode: ${a}`);
                    let o = [];
                    n < 9 && ((o = e.attributes.getFloats(`scales`)), (0, t.scalesValidation)(o, a, i));
                    let s = e.attributes.getFloat(`extrapolation_value`, 0),
                      c =
                        n > 10 ? e.attributes.getString(`coordinate_transformation_mode`, `half_pixel`) : `asymmetric`;
                    if (
                      [
                        `asymmetric`,
                        `pytorch_half_pixel`,
                        `tf_half_pixel_for_nn`,
                        `align_corners`,
                        `tf_crop_and_resize`,
                        `half_pixel`,
                      ].indexOf(c) === -1
                    )
                      throw Error(`coordinate_transform_mode '${c}' is not supported`);
                    let l = c === `tf_crop_and_resize`,
                      u = l,
                      d =
                        a === `nearest` && n >= 11 ? e.attributes.getString(`nearest_mode`, `round_prefer_floor`) : ``;
                    if ([`round_prefer_floor`, `round_prefer_ceil`, `floor`, `ceil`, ``].indexOf(d) === -1)
                      throw Error(`nearest_mode '${d}' is not supported`);
                    let f = e.attributes.getFloat(`cubic_coeff_a`, -0.75),
                      p = e.attributes.getInt(`exclude_outside`, 0) !== 0;
                    if (p && a !== `cubic`) throw Error(`exclude_outside can be set to 1 only when mode is CUBIC.`);
                    let m = n < 11 || (a === `nearest` && c === `asymmetric` && d === `floor`),
                      h = 0,
                      g = 0,
                      _ = 0;
                    return (
                      n > 10
                        ? e.inputs.length > 2
                          ? ((h = 1), (g = 2), (_ = 3))
                          : ((g = 1), (_ = 2))
                        : n === 9 && (g = 1),
                      (0, r.createAttributeWithCacheKey)({
                        opset: n,
                        isResize: i,
                        mode: a,
                        scales: o,
                        extrapolationValue: s,
                        coordinateTransformMode: c,
                        useExtrapolation: u,
                        needRoiInput: l,
                        nearestMode: d,
                        cubicCoefficientA: f,
                        excludeOutside: p,
                        useNearest2xOptimization: m,
                        roiInputIdx: h,
                        scalesInputIdx: g,
                        sizesInputIdx: _,
                      })
                    );
                  }));
                let s = (e, t, n) => {
                  let r = (0, i.getGlsl)(e.session.backend.glContext.version),
                    [s, c] = e.calculateTextureWidthAndHeight(t[0].dims, a.TextureType.unpacked),
                    l = t[0].dims.map((e, t) => Math.floor(e * n.scales[t])),
                    [u, d] = e.calculateTextureWidthAndHeight(l, a.TextureType.unpacked),
                    f = l.length,
                    p = Array(f),
                    m = Array(f),
                    h = `\n      int output_pitches[${f}];\n      int input_pitches[${f}];\n      `;
                  for (let e = f - 1; e >= 0; e--)
                    ((p[e] = e === f - 1 ? 1 : p[e + 1] * l[e + 1]),
                      (m[e] = e === f - 1 ? 1 : m[e + 1] * t[0].dims[e + 1]),
                      (h += `\n        output_pitches[${e}] = ${p[e]};\n        input_pitches[${e}] = ${m[e]};\n        `));
                  let g = `\n      float getInputFloat(int index) {\n        vec2 coords = offsetToCoords(index, ${s}, ${c});\n        float value = getColorAsFloat(${r.texture2D}(X, coords));\n        return value;\n      }\n      `,
                    _ =
                      n.mode === `nearest`
                        ? `\n    ${g}\n    float process(int indices[${f}]) {\n      int input_index = 0;\n      int output_index = coordsToOffset(TexCoords, ${u}, ${d});\n\n      ${h}\n\n      int d, m;\n      for (int dim = 0; dim < ${f}; ++dim) {\n        d = output_index / output_pitches[dim];\n        m = output_index - d * output_pitches[dim];\n        output_index = m;\n\n        if (scales[dim] != 1 && d > 0) {\n          int d2 = d / scales[dim];\n          m = d - d2 * scales[dim];\n          d = d2;\n        }\n        input_index += input_pitches[dim] * d;\n      }\n\n      return getInputFloat(input_index);\n    }`
                        : f === 4
                          ? `\n    ${g}\n    float process(int indices[4]) {\n      int input_index = 0;\n      int output_index = coordsToOffset(TexCoords, ${u}, ${d});\n\n      ${h}\n\n      int m;\n      int index_of_dim0, index_of_dim1, index_of_dim2, index_of_dim3;\n      index_of_dim0 = output_index / output_pitches[0];\n      m = output_index - index_of_dim0 * output_pitches[0];\n      index_of_dim1 = m / output_pitches[1];\n      m = m - index_of_dim1 * output_pitches[1];\n      index_of_dim2 = m / output_pitches[2];\n      m = m - index_of_dim2 * output_pitches[2];\n      index_of_dim3 = m;\n\n      int index_of_input_dim2, index_of_input_dim3, x_offset, y_offset;\n      index_of_input_dim2 = index_of_dim2 / scales[2];\n      y_offset = index_of_dim2 - index_of_input_dim2 * scales[2];\n      index_of_input_dim3 = index_of_dim3 / scales[3];\n      x_offset = index_of_dim3 - index_of_input_dim3 * scales[3];\n\n      input_index = index_of_dim0 * input_pitches[0] +\n            index_of_dim1 * input_pitches[1] +\n            index_of_input_dim2 * input_pitches[2] +\n            index_of_input_dim3;\n\n      float x00 = getInputFloat(input_index);\n      float x10, x01, x11;\n\n      bool end_of_dim2 = false;\n      if (index_of_input_dim2 == (${t[0].dims[2]} - 1)) {\n        // It's the end in dimension 2\n        x01 = x00;\n        end_of_dim2 = true;\n      } else {\n        x01 = getInputFloat(input_index + input_pitches[2]);\n      }\n\n      if (index_of_input_dim3 == (input_pitches[2] - 1)) {\n        // It's the end in dimension 3\n        x10 = x00;\n        x11 = x01;\n      }\n      else {\n        x10 = getInputFloat(input_index + 1);\n        x11 = end_of_dim2 ? x10 : getInputFloat(input_index + input_pitches[2] + 1);\n      }\n\n      float y0 = x00 + float(y_offset) * (x01 - x00) / float(scales[2]);\n      float y1 = x10 + float(y_offset) * (x11 - x10) / float(scales[2]);\n      return y0 + float(x_offset) * (y1 - y0) / float(scales[3]);\n    }`
                          : `\n    ${g}\n    float process(int indices[2]) {\n      int input_index = 0;\n      int output_index = coordsToOffset(TexCoords, ${u}, ${d});\n\n      ${h}\n\n      int m;\n      int index_of_dim0, index_of_dim1;\n      index_of_dim0 = output_index / output_pitches[0];\n      m = output_index - index_of_dim0 * output_pitches[0];\n      index_of_dim1 = m;\n\n      int index_of_input_dim0, index_of_input_dim1, x_offset, y_offset;\n      index_of_input_dim0 = index_of_dim0 / scales[0];\n      y_offset = index_of_dim0 - index_of_input_dim0 * scales[0];\n      index_of_input_dim1 = index_of_dim1 / scales[1];\n      x_offset = index_of_dim1 - index_of_input_dim1 * scales[1];\n\n      input_index = index_of_input_dim0 * input_pitches[0] + index_of_input_dim1;\n\n      float x00 = getInputFloat(input_index);\n      float x10, x01, x11;\n\n      bool end_of_dim0 = false;\n      if (index_of_input_dim0 == (${t[0].dims[0]} - 1)) {\n        // It's the end in dimension 0\n        x01 = x00;\n        end_of_dim0 = true;\n      } else {\n        x01 = getInputFloat(input_index + input_pitches[0]);\n      }\n\n      if (index_of_input_dim1 == (input_pitches[0] - 1)) {\n        // It's the end in dimension 1\n        x10 = x00;\n        x11 = x01;\n      }\n      else {\n        x10 = getInputFloat(input_index + 1);\n        x11 = end_of_dim0 ? x10 : getInputFloat(input_index + input_pitches[0] + 1);\n      }\n\n      float y0 = x00 + float(y_offset) * (x01 - x00) / float(scales[0]);\n      float y1 = x10 + float(y_offset) * (x11 - x10) / float(scales[0]);\n      return y0 + float(x_offset) * (y1 - y0) / float(scales[1]);\n    }`;
                  return Object.assign(Object.assign({}, o), {
                    output: { dims: l, type: t[0].type, textureType: a.TextureType.unpacked },
                    shaderSource: _,
                    variables: [
                      {
                        name: `scales`,
                        type: `int`,
                        arrayLength: n.scales.length,
                        data: n.scales.map((e) => Math.ceil(e)),
                      },
                    ],
                  });
                };
                ((t.validateInputs = (e, t) => {
                  if (
                    !e ||
                    (t.opset < 9 && e.length !== 1) ||
                    (t.opset >= 9 && t.opset < 11 && e.length !== 2) ||
                    (t.opset >= 11 && e.length < 2)
                  )
                    throw Error(`invalid inputs.`);
                  if (t.scales.length > 0 && e[0].dims.length !== t.scales.length) throw Error(`Invalid input shape.`);
                  if (e[0].type === `string`) throw Error(`Invalid input tensor types.`);
                }),
                  (t.scalesValidation = (e, t, n) => {
                    if (n) {
                      for (let t of e) if (t <= 0) throw Error(`Scale value should be greater than 0.`);
                    } else for (let t of e) if (t < 1) throw Error(`Scale value should be greater than or equal to 1.`);
                    if (
                      !(
                        (t !== `linear` && t !== `cubic`) ||
                        e.length === 2 ||
                        (e.length === 4 && e[0] === 1 && e[1] === 1)
                      )
                    )
                      throw Error(
                        `'Linear' mode and 'Cubic' mode only support 2-D inputs ('Bilinear', 'Bicubic')         or 4-D inputs with the corresponding outermost 2 scale values being 1         in the ${n ? `Resize` : `Upsample`} opeartor.`,
                      );
                  }));
              },
              1958: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.ProgramManager = void 0));
                let r = n(1670),
                  i = n(6231),
                  a = n(8879),
                  o = n(5060);
                t.ProgramManager = class {
                  constructor(e, t, n) {
                    ((this.profiler = e),
                      (this.glContext = t),
                      (this.textureLayoutStrategy = n),
                      (this.repo = new Map()),
                      (this.attributesBound = !1));
                  }
                  getArtifact(e) {
                    return this.repo.get(e);
                  }
                  setArtifact(e, t) {
                    this.repo.set(e, t);
                  }
                  run(e, t, n) {
                    var r;
                    this.profiler.event(
                      `op`,
                      `ProgramManager.run ${e.programInfo.name ?? `unknown kernel`}`,
                      () => {
                        var r;
                        let a = this.glContext.gl,
                          o = e.program;
                        a.useProgram(o);
                        try {
                          (this.bindOutput(n),
                            this.attributesBound || this.bindAttributes(e.attribLocations),
                            this.bindUniforms(e.uniformLocations, e.programInfo.variables ?? [], t));
                        } catch (t) {
                          throw (i.Logger.error(`ProgramManager`, e.programInfo.shaderSource), t);
                        }
                        this.profiler.event(`backend`, `GlContext.draw()`, () => {
                          this.glContext.draw();
                        });
                      },
                      this.glContext,
                    );
                  }
                  dispose() {
                    (this.vertexShader && this.glContext.deleteShader(this.vertexShader),
                      this.repo.forEach((e) => this.glContext.deleteProgram(e.program)));
                  }
                  build(e, t, n) {
                    return this.profiler.event(`backend`, `ProgramManager.build`, () => {
                      let r = new a.GlslPreprocessor(this.glContext, e, t, n),
                        i = r.preprocess(),
                        o = this.compile(i);
                      return {
                        programInfo: e,
                        program: o,
                        uniformLocations: this.getUniformLocations(
                          o,
                          r.context.programInfo.inputNames,
                          r.context.programInfo.variables,
                        ),
                        attribLocations: this.getAttribLocations(o),
                      };
                    });
                  }
                  compile(e) {
                    if (!this.vertexShader) {
                      i.Logger.verbose(`ProrgramManager`, `Compiling and caching Vertex shader for the first time`);
                      let e = (0, o.getVertexShaderSource)(this.glContext.version);
                      this.vertexShader = this.glContext.compileShader(e, this.glContext.gl.VERTEX_SHADER);
                    }
                    r.env.debug && i.Logger.verbose(`ProrgramManager`, `FragShader:\n${e}\n`);
                    let t = this.glContext.compileShader(e, this.glContext.gl.FRAGMENT_SHADER),
                      n = this.glContext.createProgram(this.vertexShader, t);
                    return (this.glContext.deleteShader(t), n);
                  }
                  bindOutput(e) {
                    let t = e.width,
                      n = e.height;
                    (i.Logger.verbose(
                      `ProrgramManager`,
                      `Binding output texture to Framebuffer: w/h=${t}/${n}, shape=${e.shape}, type=${e.tensor.type}`,
                    ),
                      this.glContext.attachFramebuffer(e.texture, t, n));
                  }
                  bindAttributes(e) {
                    let t = e.position,
                      n = e.textureCoord;
                    (this.glContext.setVertexAttributes(t, n), (this.attributesBound = !0));
                  }
                  bindUniforms(e, t, n) {
                    var r;
                    let i = this.glContext.gl,
                      a = 0;
                    for (let { name: r, type: o, location: s, arrayLength: c } of e) {
                      let e = t.find((e) => e.name === r)?.data;
                      if (o !== `sampler2D` && !e)
                        throw Error(`variable '${r}' does not have data defined in program info`);
                      switch (o) {
                        case `sampler2D`:
                          (this.bindTexture(n[a], s, a), a++);
                          break;
                        case `float`:
                          c ? i.uniform1fv(s, e) : i.uniform1f(s, e);
                          break;
                        case `int`:
                          c ? i.uniform1iv(s, e) : i.uniform1i(s, e);
                          break;
                        default:
                          throw Error(`Uniform not implemented: ${o}`);
                      }
                    }
                  }
                  bindTexture(e, t, n) {
                    this.glContext.bindTextureToUniform(e.texture, n, t);
                  }
                  getAttribLocations(e) {
                    return {
                      position: this.getAttribLocation(e, `position`),
                      textureCoord: this.getAttribLocation(e, `textureCoord`),
                    };
                  }
                  getUniformLocations(e, t, n) {
                    let r = [];
                    if (t)
                      for (let n of t) r.push({ name: n, type: `sampler2D`, location: this.getUniformLocation(e, n) });
                    if (n)
                      for (let t of n)
                        r.push(Object.assign(Object.assign({}, t), { location: this.getUniformLocation(e, t.name) }));
                    return r;
                  }
                  getUniformLocation(e, t) {
                    let n = this.glContext.gl.getUniformLocation(e, t);
                    if (n === null) throw Error(`Uniform ${t} not found.`);
                    return n;
                  }
                  getAttribLocation(e, t) {
                    return this.glContext.gl.getAttribLocation(e, t);
                  }
                };
              },
              6416: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.WebGLSessionHandler = void 0));
                let r = n(6231),
                  i = n(1047),
                  a = n(8316),
                  o = n(1640),
                  s = n(1958),
                  c = n(7859),
                  l = n(5702);
                t.WebGLSessionHandler = class {
                  constructor(e, t) {
                    ((this.backend = e),
                      (this.context = t),
                      (this.layoutStrategy = new c.PreferLogicalStrategy(e.glContext.maxTextureSize)),
                      (this.programManager = new s.ProgramManager(
                        this.context.profiler,
                        e.glContext,
                        this.layoutStrategy,
                      )),
                      (this.textureManager = new l.TextureManager(
                        e.glContext,
                        this.layoutStrategy,
                        this.context.profiler,
                        { reuseTextures: e.textureCacheMode === `full` },
                      )),
                      (this.packedTextureDataCache = new Map()),
                      (this.unpackedTextureDataCache = new Map()),
                      (this.pack = e.pack),
                      (this.pack2unpackMap = new Map()),
                      (this.unpack2packMap = new Map()));
                  }
                  createInferenceHandler() {
                    return new a.WebGLInferenceHandler(this);
                  }
                  onGraphInitialized(e) {
                    let t = e
                      .getValues()
                      .filter((e) => e.from === -1 && e.tensor)
                      .map((e) => e.tensor.dataId);
                    this.initializers = new Set(t);
                  }
                  isInitializer(e) {
                    return !!this.initializers && this.initializers.has(e);
                  }
                  addInitializer(e) {
                    this.initializers.add(e);
                  }
                  getTextureData(e, t) {
                    return t ? this.packedTextureDataCache.get(e) : this.unpackedTextureDataCache.get(e);
                  }
                  setTextureData(e, t, n = !1) {
                    (r.Logger.verbose(`WebGLSessionHandler`, `Storing Texture data in cache`),
                      n ? this.packedTextureDataCache.set(e, t) : this.unpackedTextureDataCache.set(e, t));
                  }
                  dispose() {
                    (this.programManager.dispose(),
                      this.textureManager.clearActiveTextures(),
                      this.packedTextureDataCache.forEach((e) => this.textureManager.releaseTexture(e, !0)),
                      (this.packedTextureDataCache = new Map()),
                      this.unpackedTextureDataCache.forEach((e) => this.textureManager.releaseTexture(e, !0)),
                      (this.unpackedTextureDataCache = new Map()));
                  }
                  resolve(e, t, n) {
                    let r = (0, i.resolveOperator)(e, t, o.WEBGL_OP_RESOLVE_RULES);
                    return { impl: r.opImpl, context: r.opInit ? r.opInit(e, n) : e };
                  }
                };
              },
              7769: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.Uint8DataEncoder = t.RGBAFloatDataEncoder = t.RedFloat32DataEncoder = void 0));
                let r = n(6231);
                ((t.RedFloat32DataEncoder = class {
                  constructor(e, t = 1) {
                    if (t === 1)
                      ((this.internalFormat = e.R32F),
                        (this.format = e.RED),
                        (this.textureType = e.FLOAT),
                        (this.channelSize = t));
                    else {
                      if (t !== 4) throw Error(`Invalid number of channels: ${t}`);
                      ((this.internalFormat = e.RGBA32F),
                        (this.format = e.RGBA),
                        (this.textureType = e.FLOAT),
                        (this.channelSize = t));
                    }
                  }
                  encode(e, t) {
                    let n, i;
                    return (
                      e.constructor !== Float32Array &&
                        (r.Logger.warning(`Encoder`, `data was not of type Float32; creating new Float32Array`),
                        (i = new Float32Array(e))),
                      t * this.channelSize > e.length
                        ? (r.Logger.warning(`Encoder`, `Source data too small. Allocating larger array`),
                          (i = e),
                          (n = this.allocate(t * this.channelSize)),
                          i.forEach((e, t) => (n[t] = e)))
                        : ((i = e), (n = i)),
                      n
                    );
                  }
                  allocate(e) {
                    return new Float32Array(4 * e);
                  }
                  decode(e, t) {
                    return this.channelSize === 1 ? e.filter((e, t) => t % 4 == 0).subarray(0, t) : e.subarray(0, t);
                  }
                }),
                  (t.RGBAFloatDataEncoder = class {
                    constructor(e, t = 1, n) {
                      if (t !== 1 && t !== 4) throw Error(`Invalid number of channels: ${t}`);
                      ((this.internalFormat = e.RGBA),
                        (this.format = e.RGBA),
                        (this.channelSize = t),
                        (this.textureType = n || e.FLOAT));
                    }
                    encode(e, t) {
                      let n = e;
                      return (
                        this.channelSize === 1 &&
                          (r.Logger.verbose(`Encoder`, `Exploding into a larger array`),
                          (n = this.allocate(t)),
                          e.forEach((e, t) => (n[4 * t] = e))),
                        n
                      );
                    }
                    allocate(e) {
                      return new Float32Array(4 * e);
                    }
                    decode(e, t) {
                      return this.channelSize === 1 ? e.filter((e, t) => t % 4 == 0).subarray(0, t) : e.subarray(0, t);
                    }
                  }),
                  (t.Uint8DataEncoder = class {
                    constructor(e, t = 1) {
                      if (((this.channelSize = 4), t === 1))
                        ((this.internalFormat = e.ALPHA),
                          (this.format = e.ALPHA),
                          (this.textureType = e.UNSIGNED_BYTE),
                          (this.channelSize = t));
                      else {
                        if (t !== 4) throw Error(`Invalid number of channels: ${t}`);
                        ((this.internalFormat = e.RGBA),
                          (this.format = e.RGBA),
                          (this.textureType = e.UNSIGNED_BYTE),
                          (this.channelSize = t));
                      }
                    }
                    encode(e, t) {
                      return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
                    }
                    allocate(e) {
                      return new Uint8Array(e * this.channelSize);
                    }
                    decode(e, t) {
                      if (e instanceof Uint8Array) return e.subarray(0, t);
                      throw Error(`Invalid array type: ${e.constructor}`);
                    }
                  }));
              },
              7859: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.getBatchDim =
                    t.sizeToSquarishShape =
                    t.getRowsCols =
                    t.sizeFromShape =
                    t.isInt =
                    t.parseAxisParam =
                    t.squeezeShape =
                    t.PreferLogicalStrategy =
                    t.AlwaysKeepOriginalSizeStrategy =
                      void 0));
                let r = n(6231),
                  i = n(2517);
                function a(e, t) {
                  let n = [],
                    r = [],
                    i = t != null && Array.isArray(t) && t.length === 0,
                    a = t == null || i ? null : o(t, e).sort(),
                    s = 0;
                  for (let t = 0; t < e.length; ++t) {
                    if (a != null) {
                      if (a[s] === t && e[t] !== 1)
                        throw Error(`Can't squeeze axis ${t} since its dim '${e[t]}' is not 1`);
                      ((a[s] == null || a[s] > t) && e[t] === 1 && (n.push(e[t]), r.push(t)), a[s] <= t && s++);
                    }
                    e[t] !== 1 && (n.push(e[t]), r.push(t));
                  }
                  return { newShape: n, keptDims: r };
                }
                function o(e, t) {
                  let n = t.length;
                  return (
                    (e = e == null ? t.map((e, t) => t) : [].concat(e)),
                    (0, i.assert)(
                      e.every((e) => e >= -n && e < n),
                      () => `All values in axis param must be in range [-${n}, ${n}) but got axis ${e}`,
                    ),
                    (0, i.assert)(e.every(s), () => `All values in axis param must be integers but got axis ${e}`),
                    e.map((e) => (e < 0 ? n + e : e))
                  );
                }
                function s(e) {
                  return e % 1 == 0;
                }
                function c(e) {
                  if (e.length === 0) return 1;
                  let t = e[0];
                  for (let n = 1; n < e.length; n++) t *= e[n];
                  return t;
                }
                function l(e) {
                  let t = Math.ceil(Math.sqrt(e));
                  return [t, Math.ceil(e / t)];
                }
                ((t.AlwaysKeepOriginalSizeStrategy = class {
                  constructor(e) {
                    this.maxTextureSize = e;
                  }
                  computeTextureWH(e, t) {
                    if (e.length === 0) return [1, 1];
                    let n = this.maxTextureSize;
                    if (t && t.breakAxis !== void 0) {
                      let i = t.breakAxis >= e.length ? 1 : e.slice(t.breakAxis).reduce((e, t) => e * t),
                        a = t.breakAxis <= 0 ? 1 : e.slice(0, t.breakAxis).reduce((e, t) => e * t);
                      if (!(i > n || a > n)) return [i, a];
                      r.Logger.verbose(
                        `TextureLayout`,
                        `Given width/height preferences were unattainable: shape:${e}, breakAxis:${t.breakAxis}`,
                      );
                    }
                    let i = e.reduce((e, t) => e * t),
                      a = Math.floor(Math.sqrt(i));
                    for (; a < n && a < i && i % a != 0; a++);
                    if (a >= n || i % a != 0)
                      throw Error(`The given dimensions are outside this GPU's boundaries: ${e}`);
                    return [a, i / a];
                  }
                }),
                  (t.PreferLogicalStrategy = class {
                    constructor(e) {
                      this.maxTextureSize = e;
                    }
                    computeTextureWH(e, t) {
                      let n = this.computeTexture(e, t);
                      return (t && t.isPacked && ((n[0] /= 2), (n[1] /= 2)), t && t.reverseWH ? [n[1], n[0]] : n);
                    }
                    computeTexture(e, t) {
                      let n = t && t.isPacked;
                      if (e.length === 0) return n ? [2, 2] : [1, 1];
                      let i = this.maxTextureSize;
                      if (t && t.breakAxis !== void 0) {
                        let n = t.breakAxis >= e.length ? 1 : e.slice(t.breakAxis).reduce((e, t) => e * t),
                          a = t.breakAxis <= 0 ? 1 : e.slice(0, t.breakAxis).reduce((e, t) => e * t);
                        if (!(n > i || a > i)) return [n, a];
                        r.Logger.verbose(
                          `TextureLayout`,
                          `Given width/height preferences were unattainable: shape:${e}, breakAxis:${t.breakAxis}`,
                        );
                      }
                      let o = e.slice(0);
                      (n &&
                        ((i *= 2),
                        (o = o.map((e, t) => (t >= o.length - 2 ? (o[t] % 2 == 0 ? o[t] : o[t] + 1) : o[t]))),
                        o.length === 1 && (o = [2, o[0]])),
                        o.length !== 2 && (o = a(o).newShape));
                      let s = c(o);
                      return o.length <= 1 && s <= i
                        ? [1, s]
                        : o.length === 2 && o[0] <= i && o[1] <= i
                          ? o
                          : o.length === 3 && o[0] * o[1] <= i && o[2] <= i
                            ? [o[0] * o[1], o[2]]
                            : o.length === 3 && o[0] <= i && o[1] * o[2] <= i
                              ? [o[0], o[1] * o[2]]
                              : o.length === 4 && o[0] * o[1] * o[2] <= i && o[3] <= i
                                ? [o[0] * o[1] * o[2], o[3]]
                                : o.length === 4 && o[0] <= i && o[1] * o[2] * o[3] <= i
                                  ? [o[0], o[1] * o[2] * o[3]]
                                  : n
                                    ? l(s / 4).map((e) => 2 * e)
                                    : l(s);
                    }
                  }),
                  (t.squeezeShape = a),
                  (t.parseAxisParam = o),
                  (t.isInt = s),
                  (t.sizeFromShape = c),
                  (t.getRowsCols = function (e) {
                    if (e.length === 0) throw Error(`Cannot get rows and columns of an empty shape array.`);
                    return [e.length > 1 ? e[e.length - 2] : 1, e[e.length - 1]];
                  }),
                  (t.sizeToSquarishShape = l),
                  (t.getBatchDim = function (e, t = 2) {
                    return c(e.slice(0, e.length - t));
                  }));
              },
              4057: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.createTextureLayoutFromShape =
                    t.calculateTextureWidthAndHeight =
                    t.createTextureLayoutFromTextureType =
                      void 0));
                let r = n(2517),
                  i = n(2039);
                ((t.createTextureLayoutFromTextureType = (e, n, r) => {
                  let a = r === i.TextureType.unpacked || r === i.TextureType.unpackedReversed ? 1 : 4,
                    o = r === i.TextureType.packed,
                    s = r === i.TextureType.unpackedReversed || r === i.TextureType.packed,
                    c = r === i.TextureType.packedLastDimension ? n.length - 1 : void 0,
                    l =
                      r === i.TextureType.packedLastDimension
                        ? n.map((e, t) => (t === n.length - 1 ? 4 * e : e))
                        : void 0;
                  return (0, t.createTextureLayoutFromShape)(e, n, a, l, { isPacked: o, reverseWH: s, breakAxis: c });
                }),
                  (t.calculateTextureWidthAndHeight = (e, n, r) => {
                    let i = (0, t.createTextureLayoutFromTextureType)(e, n, r);
                    return [i.width, i.height];
                  }),
                  (t.createTextureLayoutFromShape = (e, t, n = 1, i, a) => {
                    let o = !(!a || !a.isPacked),
                      [s, c] = e.computeTextureWH((o && i) || t, a),
                      l = t.length,
                      u = t.slice(0);
                    if ((l === 0 && (u = [1]), n === 1)) i = t;
                    else if (o) {
                      if (n !== 4) throw Error(`a packed texture must be 4-channel`);
                      ((i = t),
                        l > 0 && (u[l - 1] = Math.ceil(u[l - 1] / 2)),
                        l > 1 && (u[l - 2] = Math.ceil(u[l - 2] / 2)));
                    } else if (!i) throw Error(`Unpacked shape is needed when using channels > 1`);
                    return {
                      width: s,
                      height: c,
                      channels: n,
                      isPacked: o,
                      shape: u,
                      strides: r.ShapeUtil.computeStrides(u),
                      unpackedShape: i,
                      reversedWH: a && a.reverseWH,
                    };
                  }));
              },
              5702: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.TextureManager = void 0));
                let r = n(6231);
                t.TextureManager = class {
                  constructor(e, t, n, r) {
                    ((this.glContext = e),
                      (this.layoutStrategy = t),
                      (this.profiler = n),
                      (this.config = r),
                      (this.pendingRead = new Map()),
                      r.reuseTextures &&
                        ((this.inUseTextures = new Map()),
                        (this.idleTextures = new Map()),
                        (this.textureLookup = new Map())));
                  }
                  createTextureFromLayout(e, t, n, i) {
                    let a = this.toEncoderType(e),
                      o = this.glContext.getEncoder(a, t.channels || 1, i);
                    if (t.isPacked && i === 1) throw Error(`not implemented`);
                    let s = t.width,
                      c = t.height,
                      l,
                      u;
                    if (this.config.reuseTextures) {
                      ((l = `${s}x${c}_${o.format}_${o.internalFormat}_${o.textureType}`),
                        (u = this.inUseTextures.get(l)),
                        u || ((u = []), this.inUseTextures.set(l, u)));
                      let t = this.idleTextures.get(l);
                      if (t && t.length > 0) {
                        let r = t.pop();
                        return (
                          u.push(r),
                          i === 1 && this.glContext.updateTexture(r, s, c, o, this.toTextureData(e, n)),
                          r
                        );
                      }
                    }
                    r.Logger.verbose(`TextureManager`, `Creating new texture of size ${t.width}x${t.height}`);
                    let d = this.glContext.allocateTexture(s, c, o, this.toTextureData(e, n));
                    return (this.config.reuseTextures && (u.push(d), this.textureLookup.set(d, l)), d);
                  }
                  readTexture(e, t, n) {
                    return (
                      (n ||= 1),
                      this.profiler.event(`backend`, `TextureManager.readTexture`, () => {
                        let r = e.shape.reduce((e, t) => e * t) * n,
                          i = this.glContext.readTexture(e.texture, e.width, e.height, r, this.toEncoderType(t), n);
                        return this.toTensorData(t, i);
                      })
                    );
                  }
                  async readTextureAsync(e, t, n) {
                    let r = e.tensor.dataId;
                    if (((n ||= 1), this.pendingRead.has(r))) {
                      let e = this.pendingRead.get(r);
                      return new Promise((t) => e?.push(t));
                    }
                    return this.profiler.event(`backend`, `TextureManager.readTextureAsync`, async () => {
                      this.pendingRead.set(r, []);
                      let i = e.shape.reduce((e, t) => e * t) * n;
                      await this.glContext.createAndWaitForFence();
                      let a = this.glContext.readTexture(e.texture, e.width, e.height, i, this.toEncoderType(t), n),
                        o = this.toTensorData(t, a),
                        s = this.pendingRead.get(r);
                      return (this.pendingRead.delete(r), s?.forEach((e) => e(o)), o);
                    });
                  }
                  readUint8TextureAsFloat(e) {
                    return this.profiler.event(`backend`, `TextureManager.readUint8TextureAsFloat`, () => {
                      let t = e.shape.reduce((e, t) => e * t),
                        n = this.glContext.readTexture(e.texture, e.width, e.height, 4 * t, `byte`, 4);
                      return new Float32Array(n.buffer, n.byteOffset, t);
                    });
                  }
                  releaseTexture(e, t) {
                    let n;
                    if (this.config.reuseTextures && ((n = this.textureLookup.get(e.texture)), n)) {
                      t && this.textureLookup.delete(n);
                      let r = this.inUseTextures.get(n);
                      if (r) {
                        let t = r.indexOf(e.texture);
                        if (t !== -1) {
                          r.splice(t, 1);
                          let i = this.idleTextures.get(n);
                          (i || ((i = []), this.idleTextures.set(n, i)), i.push(e.texture));
                        }
                      }
                    }
                    (n && !t) ||
                      (r.Logger.verbose(`TextureManager`, `Deleting texture of size ${e.width}x${e.height}`),
                      this.glContext.deleteTexture(e.texture));
                  }
                  toTensorData(e, t) {
                    switch (e) {
                      case `int16`:
                        return t instanceof Int16Array ? t : Int16Array.from(t);
                      case `int32`:
                        return t instanceof Int32Array ? t : Int32Array.from(t);
                      case `int8`:
                        return t instanceof Int8Array ? t : Int8Array.from(t);
                      case `uint16`:
                        return t instanceof Uint16Array ? t : Uint16Array.from(t);
                      case `uint32`:
                        return t instanceof Uint32Array ? t : Uint32Array.from(t);
                      case `uint8`:
                      case `bool`:
                        return t instanceof Uint8Array ? t : Uint8Array.from(t);
                      case `float32`:
                        return t instanceof Float32Array ? t : Float32Array.from(t);
                      case `float64`:
                        return t instanceof Float64Array ? t : Float64Array.from(t);
                      default:
                        throw Error(`TensorData type ${e} is not supported`);
                    }
                  }
                  toTextureData(e, t) {
                    if (t) return t instanceof Float32Array ? t : new Float32Array(t);
                  }
                  toEncoderType(e) {
                    return `float`;
                  }
                  clearActiveTextures() {
                    this.glContext.clearActiveTextures();
                  }
                };
              },
              2039: (e, t) => {
                'use strict';
                var n;
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.TextureType = void 0),
                  ((n = t.TextureType ||= {})[(n.unpacked = 0)] = `unpacked`),
                  (n[(n.unpackedReversed = 1)] = `unpackedReversed`),
                  (n[(n.packed = 2)] = `packed`),
                  (n[(n.downloadUint8AsFloat = 3)] = `downloadUint8AsFloat`),
                  (n[(n.packedLastDimension = 4)] = `packedLastDimension`));
              },
              9390: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.getGlChannels =
                    t.getCoordsDataType =
                    t.getSqueezedParams =
                    t.squeezeInputShape =
                    t.generateShaderFuncNameFromInputSamplerNameAtOutCoords =
                    t.generateShaderFuncNameFromInputSamplerName =
                    t.repeatedTry =
                    t.getPackedShape =
                      void 0));
                let r = n(2517);
                ((t.getPackedShape = function (e) {
                  let t = e.length;
                  return e.slice(0, t - 1).concat(e[t - 1] / 4);
                }),
                  (t.repeatedTry = async function (e, t = (e) => 0, n) {
                    return new Promise((r, i) => {
                      let a = 0,
                        o = () => {
                          if (e()) return void r();
                          a++;
                          let s = t(a);
                          n != null && a >= n ? i() : setTimeout(o, s);
                        };
                      o();
                    });
                  }),
                  (t.generateShaderFuncNameFromInputSamplerName = function (e) {
                    return (
                      (0, r.assert)(e !== void 0 && e.length !== 0, () => `empty string found for sampler name`),
                      `get` + e.charAt(0).toUpperCase() + e.slice(1)
                    );
                  }),
                  (t.generateShaderFuncNameFromInputSamplerNameAtOutCoords = function (e) {
                    return (
                      (0, r.assert)(e !== void 0 && e.length !== 0, () => `empty string found for sampler name`),
                      `get` + e.charAt(0).toUpperCase() + e.slice(1) + `AtOutCoords`
                    );
                  }),
                  (t.squeezeInputShape = function (e, t) {
                    let n = JSON.parse(JSON.stringify(e));
                    return ((n = t), n);
                  }),
                  (t.getSqueezedParams = function (e, t) {
                    return t.map((t) => e[t]).join(`, `);
                  }),
                  (t.getCoordsDataType = function (e) {
                    if (e <= 1) return `int`;
                    if (e === 2) return `ivec2`;
                    if (e === 3) return `ivec3`;
                    if (e === 4) return `ivec4`;
                    if (e === 5) return `ivec5`;
                    if (e === 6) return `ivec6`;
                    throw Error(`GPU for rank ${e} is not yet supported`);
                  }),
                  (t.getGlChannels = function (e = 6) {
                    return [`x`, `y`, `z`, `w`, `u`, `v`].slice(0, e);
                  }));
              },
              7305: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.createNewWebGLContext = t.createWebGLContext = void 0));
                let r = n(6231),
                  i = n(1713),
                  a = {};
                function o(e) {
                  let t = (function () {
                      if (typeof document > `u`) {
                        if (typeof OffscreenCanvas > `u`)
                          throw TypeError(`failed to create canvas: OffscreenCanvas is not supported`);
                        return new OffscreenCanvas(1, 1);
                      }
                      let e = document.createElement(`canvas`);
                      return ((e.width = 1), (e.height = 1), e);
                    })(),
                    n,
                    a = {
                      alpha: !1,
                      depth: !1,
                      antialias: !1,
                      stencil: !1,
                      preserveDrawingBuffer: !1,
                      premultipliedAlpha: !1,
                      failIfMajorPerformanceCaveat: !1,
                    };
                  if ((!e || e === `webgl2`) && ((n = t.getContext(`webgl2`, a)), n))
                    try {
                      return new i.WebGLContext(n, 2);
                    } catch (e) {
                      r.Logger.warning(
                        `GlContextFactory`,
                        `failed to create WebGLContext using contextId 'webgl2'. Error: ${e}`,
                      );
                    }
                  if (
                    (!e || e === `webgl`) &&
                    ((n = t.getContext(`webgl`, a) || t.getContext(`experimental-webgl`, a)), n)
                  )
                    try {
                      return new i.WebGLContext(n, 1);
                    } catch (e) {
                      r.Logger.warning(
                        `GlContextFactory`,
                        `failed to create WebGLContext using contextId 'webgl' or 'experimental-webgl'. Error: ${e}`,
                      );
                    }
                  throw Error(`WebGL is not supported`);
                }
                ((t.createWebGLContext = function e(t) {
                  let n;
                  ((t && t !== `webgl2`) || !(`webgl2` in a)
                    ? (t && t !== `webgl`) || !(`webgl` in a) || (n = a.webgl)
                    : (n = a.webgl2),
                    (n ||= o(t)),
                    (t = t || n.version === 1 ? `webgl` : `webgl2`));
                  let r = n.gl;
                  return (
                    (a[t] = n),
                    r.isContextLost()
                      ? (delete a[t], e(t))
                      : (r.disable(r.DEPTH_TEST),
                        r.disable(r.STENCIL_TEST),
                        r.disable(r.BLEND),
                        r.disable(r.DITHER),
                        r.disable(r.POLYGON_OFFSET_FILL),
                        r.disable(r.SAMPLE_COVERAGE),
                        r.enable(r.SCISSOR_TEST),
                        r.enable(r.CULL_FACE),
                        r.cullFace(r.BACK),
                        n)
                  );
                }),
                  (t.createNewWebGLContext = o));
              },
              1713: function (e, t, n) {
                'use strict';
                var r =
                    (this && this.__createBinding) ||
                    (Object.create
                      ? function (e, t, n, r) {
                          r === void 0 && (r = n);
                          var i = Object.getOwnPropertyDescriptor(t, n);
                          ((i && !(`get` in i ? !t.__esModule : i.writable || i.configurable)) ||
                            (i = {
                              enumerable: !0,
                              get: function () {
                                return t[n];
                              },
                            }),
                            Object.defineProperty(e, r, i));
                        }
                      : function (e, t, n, r) {
                          (r === void 0 && (r = n), (e[r] = t[n]));
                        }),
                  i =
                    (this && this.__setModuleDefault) ||
                    (Object.create
                      ? function (e, t) {
                          Object.defineProperty(e, `default`, { enumerable: !0, value: t });
                        }
                      : function (e, t) {
                          e.default = t;
                        }),
                  a =
                    (this && this.__importStar) ||
                    function (e) {
                      if (e && e.__esModule) return e;
                      var t = {};
                      if (e != null)
                        for (var n in e) n !== `default` && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
                      return (i(t, e), t);
                    };
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.WebGLContext = t.linearSearchLastTrue = void 0));
                let o = n(1670),
                  s = a(n(7769)),
                  c = n(9390);
                function l(e) {
                  let t = 0;
                  for (; t < e.length && e[t](); ++t);
                  return t - 1;
                }
                ((t.linearSearchLastTrue = l),
                  (t.WebGLContext = class {
                    constructor(e, t) {
                      ((this.frameBufferBound = !1),
                        (this.itemsToPoll = []),
                        (this.gl = e),
                        (this.version = t),
                        this.getExtensions(),
                        (this.vertexbuffer = this.createVertexbuffer()),
                        (this.framebuffer = this.createFramebuffer()),
                        this.queryVitalParameters());
                    }
                    allocateTexture(e, t, n, r) {
                      let i = this.gl,
                        a = i.createTexture();
                      (i.bindTexture(i.TEXTURE_2D, a),
                        i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, i.NEAREST),
                        i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, i.NEAREST),
                        i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, i.CLAMP_TO_EDGE),
                        i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, i.CLAMP_TO_EDGE));
                      let o = r ? n.encode(r, e * t) : null;
                      return (
                        i.texImage2D(i.TEXTURE_2D, 0, n.internalFormat, e, t, 0, n.format, n.textureType, o),
                        this.checkError(),
                        a
                      );
                    }
                    updateTexture(e, t, n, r, i) {
                      let a = this.gl;
                      a.bindTexture(a.TEXTURE_2D, e);
                      let o = r.encode(i, t * n);
                      (a.texSubImage2D(a.TEXTURE_2D, 0, 0, 0, t, n, r.format, r.textureType, o), this.checkError());
                    }
                    attachFramebuffer(e, t, n) {
                      let r = this.gl;
                      (r.bindTexture(r.TEXTURE_2D, e),
                        r.bindFramebuffer(r.FRAMEBUFFER, this.framebuffer),
                        r.framebufferTexture2D(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, e, 0),
                        this.checkError(),
                        r.viewport(0, 0, t, n),
                        r.scissor(0, 0, t, n));
                    }
                    readTexture(e, t, n, r, i, a) {
                      let o = this.gl;
                      ((a ||= 1), this.frameBufferBound || this.attachFramebuffer(e, t, n));
                      let s = this.getEncoder(i, a),
                        c = s.allocate(t * n);
                      return (
                        o.bindTexture(o.TEXTURE_2D, e),
                        o.framebufferTexture2D(o.FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, e, 0),
                        o.readPixels(0, 0, t, n, o.RGBA, s.textureType, c),
                        this.checkError(),
                        s.decode(c, r)
                      );
                    }
                    isFramebufferReady() {
                      return !0;
                    }
                    getActiveTexture() {
                      let e = this.gl;
                      return `TEXTURE` + (e.getParameter(this.gl.ACTIVE_TEXTURE) - e.TEXTURE0);
                    }
                    getTextureBinding() {
                      return this.gl.getParameter(this.gl.TEXTURE_BINDING_2D);
                    }
                    getFramebufferBinding() {
                      return this.gl.getParameter(this.gl.FRAMEBUFFER_BINDING);
                    }
                    setVertexAttributes(e, t) {
                      let n = this.gl;
                      (n.vertexAttribPointer(e, 3, n.FLOAT, !1, 20, 0),
                        n.enableVertexAttribArray(e),
                        t !== -1 && (n.vertexAttribPointer(t, 2, n.FLOAT, !1, 20, 12), n.enableVertexAttribArray(t)),
                        this.checkError());
                    }
                    createProgram(e, t) {
                      let n = this.gl,
                        r = n.createProgram();
                      return (n.attachShader(r, e), n.attachShader(r, t), n.linkProgram(r), r);
                    }
                    compileShader(e, t) {
                      let n = this.gl,
                        r = n.createShader(t);
                      if (!r) throw Error(`createShader() returned null with type ${t}`);
                      if ((n.shaderSource(r, e), n.compileShader(r), !1 === n.getShaderParameter(r, n.COMPILE_STATUS)))
                        throw Error(`Failed to compile shader: ${n.getShaderInfoLog(r)}\nShader source:\n${e}`);
                      return r;
                    }
                    deleteShader(e) {
                      this.gl.deleteShader(e);
                    }
                    bindTextureToUniform(e, t, n) {
                      let r = this.gl;
                      (r.activeTexture(r.TEXTURE0 + t),
                        this.checkError(),
                        r.bindTexture(r.TEXTURE_2D, e),
                        this.checkError(),
                        r.uniform1i(n, t),
                        this.checkError());
                    }
                    draw() {
                      (this.gl.drawArrays(this.gl.TRIANGLE_STRIP, 0, 4), this.checkError());
                    }
                    checkError() {
                      if (o.env.debug) {
                        let e = this.gl,
                          t = e.getError(),
                          n = ``;
                        switch (t) {
                          case e.NO_ERROR:
                            return;
                          case e.INVALID_ENUM:
                            n = `INVALID_ENUM`;
                            break;
                          case e.INVALID_VALUE:
                            n = `INVALID_VALUE`;
                            break;
                          case e.INVALID_OPERATION:
                            n = `INVALID_OPERATION`;
                            break;
                          case e.INVALID_FRAMEBUFFER_OPERATION:
                            n = `INVALID_FRAMEBUFFER_OPERATION`;
                            break;
                          case e.OUT_OF_MEMORY:
                            n = `OUT_OF_MEMORY`;
                            break;
                          case e.CONTEXT_LOST_WEBGL:
                            n = `CONTEXT_LOST_WEBGL`;
                            break;
                          default:
                            n = `Unknown WebGL Error: ${t.toString(16)}`;
                        }
                        throw Error(n);
                      }
                    }
                    deleteTexture(e) {
                      this.gl.deleteTexture(e);
                    }
                    deleteProgram(e) {
                      this.gl.deleteProgram(e);
                    }
                    getEncoder(e, t, n = 0) {
                      if (this.version === 2) return new s.RedFloat32DataEncoder(this.gl, t);
                      switch (e) {
                        case `float`:
                          return n === 1 || this.isRenderFloat32Supported
                            ? new s.RGBAFloatDataEncoder(this.gl, t)
                            : new s.RGBAFloatDataEncoder(this.gl, t, this.textureHalfFloatExtension.HALF_FLOAT_OES);
                        case `int`:
                          throw Error(`not implemented`);
                        case `byte`:
                          return new s.Uint8DataEncoder(this.gl, t);
                        default:
                          throw Error(`Invalid dataType: ${e}`);
                      }
                    }
                    clearActiveTextures() {
                      let e = this.gl;
                      for (let t = 0; t < this.maxTextureImageUnits; ++t)
                        (e.activeTexture(e.TEXTURE0 + t), e.bindTexture(e.TEXTURE_2D, null));
                    }
                    dispose() {
                      if (this.disposed) return;
                      let e = this.gl;
                      (e.bindFramebuffer(e.FRAMEBUFFER, null),
                        e.deleteFramebuffer(this.framebuffer),
                        e.bindBuffer(e.ARRAY_BUFFER, null),
                        e.deleteBuffer(this.vertexbuffer),
                        e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, null),
                        e.finish(),
                        (this.disposed = !0));
                    }
                    createDefaultGeometry() {
                      return new Float32Array([-1, 1, 0, 0, 1, -1, -1, 0, 0, 0, 1, 1, 0, 1, 1, 1, -1, 0, 1, 0]);
                    }
                    createVertexbuffer() {
                      let e = this.gl,
                        t = e.createBuffer();
                      if (!t) throw Error(`createBuffer() returned null`);
                      let n = this.createDefaultGeometry();
                      return (
                        e.bindBuffer(e.ARRAY_BUFFER, t),
                        e.bufferData(e.ARRAY_BUFFER, n, e.STATIC_DRAW),
                        this.checkError(),
                        t
                      );
                    }
                    createFramebuffer() {
                      let e = this.gl.createFramebuffer();
                      if (!e) throw Error(`createFramebuffer returned null`);
                      return e;
                    }
                    queryVitalParameters() {
                      let e = this.gl;
                      if (
                        ((this.isFloatTextureAttachableToFrameBuffer = this.checkFloatTextureAttachableToFrameBuffer()),
                        (this.isRenderFloat32Supported = this.checkRenderFloat32()),
                        (this.isFloat32DownloadSupported = this.checkFloat32Download()),
                        this.version === 1 && !this.textureHalfFloatExtension && !this.isRenderFloat32Supported)
                      )
                        throw Error(`both float32 and float16 TextureType are not supported`);
                      ((this.isBlendSupported = !this.isRenderFloat32Supported || this.checkFloat32Blend()),
                        (this.maxTextureSize = e.getParameter(e.MAX_TEXTURE_SIZE)),
                        (this.maxTextureImageUnits = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS)),
                        this.version);
                    }
                    getExtensions() {
                      this.version === 2
                        ? ((this.colorBufferFloatExtension = this.gl.getExtension(`EXT_color_buffer_float`)),
                          (this.disjointTimerQueryWebgl2Extension = this.gl.getExtension(
                            `EXT_disjoint_timer_query_webgl2`,
                          )))
                        : ((this.textureFloatExtension = this.gl.getExtension(`OES_texture_float`)),
                          (this.textureHalfFloatExtension = this.gl.getExtension(`OES_texture_half_float`)));
                    }
                    checkFloatTextureAttachableToFrameBuffer() {
                      let e = this.gl,
                        t = e.createTexture();
                      e.bindTexture(e.TEXTURE_2D, t);
                      let n = this.version === 2 ? e.RGBA32F : e.RGBA;
                      e.texImage2D(e.TEXTURE_2D, 0, n, 1, 1, 0, e.RGBA, e.FLOAT, null);
                      let r = e.createFramebuffer();
                      (e.bindFramebuffer(e.FRAMEBUFFER, r),
                        e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0));
                      let i = e.checkFramebufferStatus(e.FRAMEBUFFER) === e.FRAMEBUFFER_COMPLETE;
                      return (
                        e.bindTexture(e.TEXTURE_2D, null),
                        e.bindFramebuffer(e.FRAMEBUFFER, null),
                        e.deleteTexture(t),
                        e.deleteFramebuffer(r),
                        i
                      );
                    }
                    checkRenderFloat32() {
                      if (this.version === 2) {
                        if (!this.colorBufferFloatExtension) return !1;
                      } else if (!this.textureFloatExtension) return !1;
                      return this.isFloatTextureAttachableToFrameBuffer;
                    }
                    checkFloat32Download() {
                      if (this.version === 2) {
                        if (!this.colorBufferFloatExtension) return !1;
                      } else if (!this.textureFloatExtension || !this.gl.getExtension(`WEBGL_color_buffer_float`))
                        return !1;
                      return this.isFloatTextureAttachableToFrameBuffer;
                    }
                    checkFloat32Blend() {
                      let e = this.gl,
                        t,
                        n,
                        r,
                        i,
                        a;
                      try {
                        ((t = e.createTexture()), (n = e.createFramebuffer()), e.bindTexture(e.TEXTURE_2D, t));
                        let o = this.version === 2 ? e.RGBA32F : e.RGBA;
                        return (
                          e.texImage2D(e.TEXTURE_2D, 0, o, 1, 1, 0, e.RGBA, e.FLOAT, null),
                          e.bindFramebuffer(e.FRAMEBUFFER, n),
                          e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0),
                          e.enable(e.BLEND),
                          (r = e.createShader(e.VERTEX_SHADER)),
                          !!r &&
                            (e.shaderSource(r, `void main(){}`),
                            e.compileShader(r),
                            (i = e.createShader(e.FRAGMENT_SHADER)),
                            !!i &&
                              (e.shaderSource(i, `precision highp float;void main(){gl_FragColor=vec4(0.5);}`),
                              e.compileShader(i),
                              (a = e.createProgram()),
                              !!a &&
                                (e.attachShader(a, r),
                                e.attachShader(a, i),
                                e.linkProgram(a),
                                e.useProgram(a),
                                e.drawArrays(e.POINTS, 0, 1),
                                e.getError() === e.NO_ERROR)))
                        );
                      } finally {
                        (e.disable(e.BLEND),
                          a && e.deleteProgram(a),
                          r && e.deleteShader(r),
                          i && e.deleteShader(i),
                          n && (e.bindFramebuffer(e.FRAMEBUFFER, null), e.deleteFramebuffer(n)),
                          t && (e.bindTexture(e.TEXTURE_2D, null), e.deleteTexture(t)));
                      }
                    }
                    beginTimer() {
                      if (this.version === 2 && this.disjointTimerQueryWebgl2Extension) {
                        let e = this.gl,
                          t = this.disjointTimerQueryWebgl2Extension,
                          n = e.createQuery();
                        return (e.beginQuery(t.TIME_ELAPSED_EXT, n), n);
                      }
                      throw Error(`WebGL1 profiling currently not supported.`);
                    }
                    endTimer() {
                      if (this.version !== 2 || !this.disjointTimerQueryWebgl2Extension)
                        throw Error(`WebGL1 profiling currently not supported`);
                      {
                        let e = this.gl,
                          t = this.disjointTimerQueryWebgl2Extension;
                        e.endQuery(t.TIME_ELAPSED_EXT);
                      }
                    }
                    isTimerResultAvailable(e) {
                      let t = !1,
                        n = !1;
                      if (this.version !== 2 || !this.disjointTimerQueryWebgl2Extension)
                        throw Error(`WebGL1 profiling currently not supported`);
                      {
                        let r = this.gl,
                          i = this.disjointTimerQueryWebgl2Extension;
                        ((t = r.getQueryParameter(e, r.QUERY_RESULT_AVAILABLE)),
                          (n = r.getParameter(i.GPU_DISJOINT_EXT)));
                      }
                      return t && !n;
                    }
                    getTimerResult(e) {
                      let t = 0;
                      if (this.version !== 2) throw Error(`WebGL1 profiling currently not supported`);
                      {
                        let n = this.gl;
                        ((t = n.getQueryParameter(e, n.QUERY_RESULT)), n.deleteQuery(e));
                      }
                      return t / 1e6;
                    }
                    async waitForQueryAndGetTime(e) {
                      return (await (0, c.repeatedTry)(() => this.isTimerResultAvailable(e)), this.getTimerResult(e));
                    }
                    async createAndWaitForFence() {
                      let e = this.createFence(this.gl);
                      return this.pollFence(e);
                    }
                    createFence(e) {
                      let t,
                        n = e,
                        r = n.fenceSync(n.SYNC_GPU_COMMANDS_COMPLETE, 0);
                      return (
                        e.flush(),
                        (t =
                          r === null
                            ? () => !0
                            : () => {
                                let e = n.clientWaitSync(r, 0, 0);
                                return e === n.ALREADY_SIGNALED || e === n.CONDITION_SATISFIED;
                              }),
                        { query: r, isFencePassed: t }
                      );
                    }
                    async pollFence(e) {
                      return new Promise((t) => {
                        this.addItemToPoll(
                          () => e.isFencePassed(),
                          () => t(),
                        );
                      });
                    }
                    pollItems() {
                      let e = l(this.itemsToPoll.map((e) => e.isDoneFn));
                      for (let t = 0; t <= e; ++t) {
                        let { resolveFn: e } = this.itemsToPoll[t];
                        e();
                      }
                      this.itemsToPoll = this.itemsToPoll.slice(e + 1);
                    }
                    async addItemToPoll(e, t) {
                      (this.itemsToPoll.push({ isDoneFn: e, resolveFn: t }),
                        this.itemsToPoll.length > 1 ||
                          (await (0, c.repeatedTry)(() => (this.pollItems(), this.itemsToPoll.length === 0))));
                    }
                  }));
              },
              1036: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.ExecutionPlan = void 0));
                let r = n(6231);
                class i {
                  constructor(e, t) {
                    ((this.op = e), (this.node = t));
                  }
                }
                t.ExecutionPlan = class {
                  constructor(e, t, n) {
                    ((this.graph = e), (this.profiler = n), this.initialize(t));
                  }
                  initialize(e) {
                    this.profiler.event(`session`, `ExecutionPlan.initialize`, () => {
                      let t = this.graph.getNodes();
                      if (t.length !== e.length) throw Error(`The size of nodes and OPs do not match.`);
                      ((this._ops = e.map((e, n) => new i(e, t[n]))),
                        this.reset(),
                        (this._starter = []),
                        this._ops.forEach((e, t) => {
                          let n = !0;
                          for (let t of e.node.inputs)
                            if (!this._values[t] && this.graph.getInputIndices().indexOf(t) === -1) {
                              n = !1;
                              break;
                            }
                          n && this._starter.push(t);
                        }));
                    });
                  }
                  reset() {
                    this._values = this.graph.getValues().map((e) => e.tensor);
                  }
                  async execute(e, t) {
                    return this.profiler.event(`session`, `ExecutionPlan.execute`, async () => {
                      this.reset();
                      let n = e.createInferenceHandler(),
                        i = this.graph.getInputIndices();
                      if (t.length !== i.length)
                        throw Error(
                          `number of input tensors don't match the number of inputs to the model: actual: ${t.length} expected: ${i.length}`,
                        );
                      t.forEach((e, t) => {
                        let n = i[t];
                        this._values[n] = e;
                      });
                      let a = this._starter.slice(0),
                        o = this.graph.getValues(),
                        s = this.graph.getNodes(),
                        c = 0;
                      for (; c < a.length; ) {
                        let e = a[c++],
                          t = this._ops[e],
                          i = t.node.inputs.map((e) => this._values[e]);
                        if (i.indexOf(void 0) !== -1) throw Error(`unresolved input detected: op: ${t.node}`);
                        let l = i;
                        r.Logger.verbose(
                          `ExecPlan`,
                          `Runing op:${t.node.name} (${l.map((e, n) => `'${t.node.inputs[n]}': ${e.type}[${e.dims.join(`,`)}]`).join(`, `)})`,
                        );
                        let u = await this.profiler.event(`node`, t.node.name, async () =>
                          t.op.impl(n, l, t.op.context),
                        );
                        if (u.length !== t.node.outputs.length)
                          throw Error(`the size of output does not match model definition.`);
                        u.forEach((e, n) => {
                          let r = t.node.outputs[n];
                          if (this._values[r]) throw Error(`output [${r}] already has value: op:${t.node.name}`);
                          this._values[r] = e;
                        });
                        let d = new Set();
                        (u.forEach((e, n) => {
                          let r = t.node.outputs[n];
                          for (let e of o[r].to) {
                            let t = s[e],
                              n = !0;
                            for (let e of t.inputs)
                              if (!this._values[e]) {
                                n = !1;
                                break;
                              }
                            n && d.add(e);
                          }
                        }),
                          a.push(...d));
                      }
                      let l = [];
                      for (let e = 0; e < this.graph.getOutputIndices().length; e++) {
                        let t = this.graph.getOutputIndices()[e],
                          n = this._values[t];
                        if (n === void 0) throw Error(`required output [${t}] does not have value`);
                        (t === 0 ? await n.getData() : n.data, l.push(n));
                      }
                      return (r.Logger.verbose(`ExecPlan`, `disposing of inferenceHandler`), n.dispose(), l);
                    });
                  }
                };
              },
              7070: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.Graph = void 0));
                let r = n(1446),
                  i = n(7778),
                  a = n(9395),
                  o = n(9162),
                  s = n(2517);
                var c = a.onnxruntime.experimental.fbs;
                t.Graph = { from: (e, t) => new d(e, t) };
                class l {
                  constructor(e) {
                    ((this._from = void 0),
                      (this._to = []),
                      (this.tensor = void 0),
                      (this.type = void 0),
                      e && (this.type = s.ProtoUtil.tensorValueTypeFromProto(e.type.tensorType)));
                  }
                  get from() {
                    return this._from;
                  }
                  get to() {
                    return this._to;
                  }
                }
                class u {
                  constructor(e, t) {
                    (e instanceof r.onnx.NodeProto
                      ? ((this.name = e.name),
                        (this.opType = e.opType),
                        (this.attributes = new i.Attribute(e.attribute)))
                      : e instanceof c.Node &&
                        ((this.name = t ?? e.name()),
                        (this.opType = e.opType()),
                        (this.attributes = new i.Attribute(s.ProtoUtil.tensorAttributesFromORTFormat(e)))),
                      (this.inputs = []),
                      (this.outputs = []),
                      (this.executeNode = !0));
                  }
                }
                class d {
                  constructor(e, t) {
                    if (!e) throw TypeError(`graph is empty`);
                    (this.buildGraph(e), this.transformGraph(t), this.checkIsAcyclic());
                  }
                  getInputIndices() {
                    return this._allInputIndices;
                  }
                  getInputNames() {
                    return this._allInputNames;
                  }
                  getOutputIndices() {
                    return this._allOutputIndices;
                  }
                  getOutputNames() {
                    return this._allOutputNames;
                  }
                  getValues() {
                    return this._allData;
                  }
                  getNodes() {
                    return this._nodes;
                  }
                  buildGraph(e) {
                    if (e instanceof r.onnx.GraphProto) this.buildGraphFromOnnxFormat(e);
                    else {
                      if (!(e instanceof c.Graph)) throw TypeError(`Graph type is not supported.`);
                      this.buildGraphFromOrtFormat(e);
                    }
                  }
                  buildGraphFromOnnxFormat(e) {
                    let t = new Map();
                    ((this._allData = []),
                      (this._allInputIndices = []),
                      (this._allInputNames = []),
                      (this._allOutputIndices = []),
                      (this._allOutputNames = []),
                      (this._nodes = []));
                    let n = new Map();
                    if (!e.input) throw Error(`missing information in graph: input`);
                    let r = [];
                    for (let n of e.input) {
                      if (t.has(n.name)) throw Error(`duplicated input name: ${n.name}`);
                      let e = this._allData.push(new l(n)) - 1;
                      (t.set(n.name, e), r.push(n.name));
                    }
                    if (!e.initializer) throw Error(`missing information in graph: initializer`);
                    for (let n of e.initializer) {
                      let e = t.get(n.name);
                      if (e === void 0) {
                        let r = new l();
                        ((r.type = {
                          shape: { dims: s.ProtoUtil.tensorDimsFromProto(n.dims) },
                          tensorType: s.ProtoUtil.tensorDataTypeFromProto(n.dataType),
                        }),
                          (e = this._allData.push(r) - 1),
                          t.set(n.name, e));
                      }
                      ((this._allData[e]._from = -1), (this._allData[e].tensor = o.Tensor.fromProto(n)));
                    }
                    for (let e = 0; e < this._allData.length; e++)
                      this._allData[e].tensor || (this._allInputIndices.push(e), this._allInputNames.push(r[e]));
                    if (!e.output) throw Error(`missing information in graph: output`);
                    for (let n of e.output) {
                      if (t.has(n.name)) throw Error(`duplicated output name: ${n.name}`);
                      let e = this._allData.push(new l(n)) - 1;
                      (t.set(n.name, e), this._allOutputIndices.push(e), this._allOutputNames.push(n.name));
                    }
                    if (!e.node) throw Error(`missing information in graph: node`);
                    for (let t of e.node) {
                      if (!t.name)
                        for (let e = 0; ; e++) {
                          let r = `unnamed_${t.opType}_${e}`;
                          if (!n.has(r)) {
                            t.name = r;
                            break;
                          }
                        }
                      if (n.has(t.name)) throw Error(`duplicated node name: ${t.name}`);
                      let e = this._nodes.push(new u(t)) - 1;
                      n.set(t.name, e);
                    }
                    for (let n = 0; n < this._nodes.length; n++) {
                      let r = this._nodes[n],
                        i = e.node[n];
                      if (!i.output) throw Error(`missing output for node: ${i.name}`);
                      for (let e of i.output) {
                        let a = t.get(e);
                        if (
                          (a === void 0 && ((a = this._allData.push(new l()) - 1), t.set(e, a)),
                          r.outputs.push(a),
                          this._allData[a]._from !== void 0)
                        )
                          throw Error(`multiple nodes output to one data value: ${a}`);
                        if (((this._allData[a]._from = n), i.opType === `Constant`)) {
                          if (!i.attribute || i.attribute.length !== 1 || !i.attribute[0].t)
                            throw Error(
                              `missing attributes or missing tensor value in attributes for this Constant operator`,
                            );
                          if (!i.output || i.output.length !== 1)
                            throw Error(`missing output or incorrect number of outputs for this Constant operator`);
                          (r.outputs.pop(),
                            (r.executeNode = !1),
                            (this._allData[a]._from = -1),
                            (this._allData[a].tensor = o.Tensor.fromProto(i.attribute[0].t)));
                        }
                      }
                    }
                    for (let n = 0; n < this._nodes.length; n++) {
                      let r = this._nodes[n],
                        i = e.node[n];
                      if (!i.input) throw Error(`missing input for node: ${i.name}`);
                      for (let e of i.input) {
                        let a = t.get(e);
                        if (a === void 0) {
                          if (e === `` && i.input.length === 3 && i.opType === `Resize`) continue;
                          throw Error(`unrecognized input '${e}' for node: ${i.name}`);
                        }
                        (r.inputs.push(a), this._allData[a]._to.push(n));
                      }
                    }
                    return !0;
                  }
                  buildGraphFromOrtFormat(e) {
                    var t, n, r;
                    let i = new Map();
                    ((this._allData = []),
                      (this._allInputIndices = []),
                      (this._allInputNames = []),
                      (this._allOutputIndices = []),
                      (this._allOutputNames = []),
                      (this._nodes = []));
                    let a = new Map(),
                      d = [];
                    for (let t = 0; t < e.inputsLength(); t++) {
                      let n = e.inputs(t);
                      if (i.has(n)) throw Error(`duplicated input name: ${n}`);
                      for (let t = 0; t < e.nodeArgsLength(); t++)
                        if (e.nodeArgs(t)?.name() === n) {
                          let r = new l();
                          if (e.nodeArgs(t)?.type()?.valueType() !== c.TypeInfoValue.tensor_type)
                            throw Error(`Unexpected value type for the nodeArg.`);
                          let a = e.nodeArgs(t).type().value(new c.TensorTypeAndShape()),
                            o = s.ProtoUtil.tensorDataTypeFromProto(a.elemType()),
                            u = a.shape(),
                            f = [];
                          for (let e = 0; e < u.dimLength(); e++)
                            f.push(s.LongUtil.longToNumber(u.dim(e).value().dimValue()));
                          r.type = { shape: { dims: f }, tensorType: o };
                          let p = this._allData.push(r) - 1;
                          (i.set(n, p), d.push(n));
                        }
                    }
                    for (let t = 0; t < e.initializersLength(); t++) {
                      let n = e.initializers(t),
                        r = i.get(n.name());
                      if (r === void 0) {
                        let e = new l(),
                          t = s.ProtoUtil.tensorDimsFromORTFormat(n),
                          a = s.ProtoUtil.tensorDataTypeFromProto(n.dataType());
                        ((e.type = { shape: { dims: t }, tensorType: a }),
                          (r = this._allData.push(e) - 1),
                          i.set(n.name(), r));
                      }
                      ((this._allData[r]._from = -1), (this._allData[r].tensor = o.Tensor.fromOrtTensor(n)));
                    }
                    for (let e = 0; e < this._allData.length; e++)
                      this._allData[e].tensor || (this._allInputIndices.push(e), this._allInputNames.push(d[e]));
                    for (let t = 0; t < e.outputsLength(); t++) {
                      let n = e.outputs(t);
                      if (i.has(n)) throw Error(`duplicated output name: ${n}`);
                      let r = this._allData.push(new l()) - 1;
                      (i.set(n, r), this._allOutputIndices.push(r), this._allOutputNames.push(n));
                    }
                    if (!e.nodes) throw Error(`missing information in graph: node`);
                    for (let t = 0; t < e.nodesLength(); t++) {
                      let n = e.nodes(t),
                        r = n.name();
                      if (!r) for (let e = 0; (r = `unnamed_${n.opType()}_${e}`), a.has(r); e++);
                      if (a.has(r)) throw Error(`duplicated node name: ${r}`);
                      let i = this._nodes.push(new u(n, r)) - 1;
                      a.set(r, i);
                    }
                    for (let t = 0; t < this._nodes.length; t++) {
                      let n = this._nodes[t],
                        r = e.nodes(t);
                      if (r == null) throw Error(`No node exists at index ${t}`);
                      if (r?.outputsLength() === 0) throw Error(`missing output for node: ${r.name}`);
                      for (let e = 0; e < r?.outputsLength(); e++) {
                        let a = r?.outputs(e),
                          s = i.get(a);
                        if (
                          (s === void 0 && ((s = this._allData.push(new l()) - 1), i.set(a, s)),
                          n.outputs.push(s),
                          this._allData[s]._from !== void 0)
                        )
                          throw Error(`multiple nodes output to one data value: ${s}`);
                        if (((this._allData[s]._from = t), r.opType() === `Constant`)) {
                          if (r.attributesLength() !== 1 || !r.attributes(0).t())
                            throw Error(
                              `missing attributes or missing tensor value in attributes for this Constant operator`,
                            );
                          if (r.outputsLength() !== 1)
                            throw Error(`missing output or incorrect number of outputs for this Constant operator`);
                          (n.outputs.pop(),
                            (n.executeNode = !1),
                            (this._allData[s]._from = -1),
                            (this._allData[s].tensor = o.Tensor.fromOrtTensor(r.attributes(0).t())));
                        }
                      }
                    }
                    for (let t = 0; t < this._nodes.length; t++) {
                      let n = this._nodes[t],
                        r = e.nodes(t);
                      if (r.inputsLength() === 0) throw Error(`missing input for node: ${r.name}`);
                      for (let e = 0; e < r.inputsLength(); e++) {
                        let a = r.inputs(e),
                          o = i.get(a);
                        if (o === void 0) throw Error(`unrecognized input '${a}' for node: ${r.name()}`);
                        (n.inputs.push(o), this._allData[o]._to.push(t));
                      }
                    }
                  }
                  checkIsAcyclic() {
                    let e = new Set();
                    this._allInputIndices.forEach((t) => {
                      this._allData[t]._to.forEach((t) => {
                        e.add(t);
                      });
                    });
                    let t = Array.from(e),
                      n = Array(this._nodes.length).fill(`white`);
                    for (; t.length > 0; ) {
                      let e = t.pop();
                      n[e] === `gray`
                        ? (n[e] = `black`)
                        : (t.push(e),
                          (n[e] = `gray`),
                          this._nodes[e].outputs.forEach((r) => {
                            let i = this._allData[r];
                            if (i.tensor !== void 0) throw Error(`node outputs should not be initialized`);
                            if (i._from !== e)
                              throw Error(
                                `from property of the Value object doesn't match index of Node being processed`,
                              );
                            i._to.forEach((e) => {
                              if (n[e] === `gray`) throw Error(`model graph is cyclic`);
                              n[e] === `white` && t.push(e);
                            });
                          }));
                    }
                  }
                  transformGraph(e) {
                    (this.removeAllIdentityNodes(),
                      this.removeAllDropoutNodes(),
                      this.fuseConvActivationNodes(),
                      e && e.transformGraph(this),
                      this.finalizeGraph());
                  }
                  finalizeGraph() {
                    let e = 0;
                    for (let t = 0; t < this._nodes.length; t++)
                      this._nodes[t].executeNode
                        ? e > 0 &&
                          (this._nodes[t].inputs.forEach((n) => {
                            let r = this._allData[n]._to.indexOf(t + e);
                            r !== -1 && (this._allData[n]._to[r] = t);
                          }),
                          this._nodes[t].outputs.forEach((n) => {
                            this._allData[n]._from && this._allData[n]._from === t + e && (this._allData[n]._from = t);
                          }))
                        : (e++,
                          this._nodes[t].outputs.forEach((e) => {
                            this._allData[e]._from = -2;
                          }),
                          this._nodes.splice(t, 1),
                          t--);
                    e = 0;
                    for (let t = 0; t < this._allData.length; t++)
                      if (this._allData[t].from !== -2 || this._allOutputIndices.indexOf(t + e) !== -1) {
                        if (e > 0) {
                          let n = -1;
                          (this._allData[t].from !== void 0 && this._allData[t].from !== -1
                            ? ((n = this._nodes[this._allData[t].from].outputs.indexOf(t + e)),
                              n !== -1 && (this._nodes[this._allData[t].from].outputs[n] = t))
                            : ((n = this._allInputIndices.indexOf(t + e)), n !== -1 && (this._allInputIndices[n] = t)),
                            this._allData[t].to.forEach((r) => {
                              ((n = this._nodes[r].inputs.indexOf(t + e)), n !== -1 && (this._nodes[r].inputs[n] = t));
                            }),
                            this._allData[t].to.length === 0 &&
                              ((n = this._allOutputIndices.indexOf(t + e)),
                              n !== -1 && (this._allOutputIndices[n] = t)));
                        }
                      } else (e++, this._allData.splice(t, 1), t--);
                  }
                  deleteNode(e) {
                    let t = this._nodes[e];
                    if (t.outputs.length > 1) {
                      for (let e = 1; e < t.outputs.length; e++)
                        if (this._allData[t.outputs[e]].to.length > 0)
                          throw Error(
                            `Node deletion with more than one output connected to other nodes is not supported. `,
                          );
                    }
                    t.executeNode = !1;
                    let n = t.inputs[0],
                      r = t.outputs[0],
                      i = this._allData[r].to,
                      a = this._allData[n].to.indexOf(e);
                    if (a === -1) throw Error(`The Value object doesn't have the current Node in it's 'to' property `);
                    (this._allData[n].to.splice(a, 1), (this._allData[r]._to = []));
                    let o = this._allOutputIndices.indexOf(r);
                    if ((o !== -1 && (this._allOutputIndices[o] = n), i && i.length > 0))
                      for (let e of i) {
                        let t = this._nodes[e].inputs.indexOf(r);
                        if (t === -1)
                          throw Error(`The Node object doesn't have the output Value in it's 'inputs' property `);
                        ((this._nodes[e].inputs[t] = n), this._allData[n].to.push(e));
                      }
                  }
                  removeAllDropoutNodes() {
                    let e = 0;
                    for (let t of this._nodes) {
                      if (t.opType === `Dropout`) {
                        if (t.inputs.length !== 1) throw Error(`Dropout nodes should only contain one input. `);
                        if (t.outputs.length !== 1 && t.outputs.length !== 2)
                          throw Error(`Dropout nodes should contain either 1 or 2 output(s)`);
                        if (t.outputs.length === 2 && this._allData[t.outputs[1]]._to.length !== 0)
                          throw Error(`Dropout nodes's second output should not be referenced by other nodes`);
                        this.deleteNode(e);
                      }
                      e++;
                    }
                  }
                  removeAllIdentityNodes() {
                    let e = 0;
                    for (let t of this._nodes) (t.opType === `Identity` && this.deleteNode(e), e++);
                  }
                  isActivation(e) {
                    switch (e.opType) {
                      case `Relu`:
                      case `Sigmoid`:
                      case `Clip`:
                        return !0;
                      default:
                        return !1;
                    }
                  }
                  fuseConvActivationNodes() {
                    for (let e of this._nodes)
                      if (e.opType === `Conv`) {
                        let t = this._allData[e.outputs[0]]._to;
                        if (t.length === 1 && this.isActivation(this._nodes[t[0]])) {
                          let n = this._nodes[t[0]];
                          if (n.opType === `Clip`)
                            if (n.inputs.length === 1)
                              try {
                                e.attributes.set(`activation_params`, `floats`, [
                                  n.attributes.getFloat(`min`),
                                  n.attributes.getFloat(`max`),
                                ]);
                              } catch {
                                e.attributes.set(`activation_params`, `floats`, [s.MIN_CLIP, s.MAX_CLIP]);
                              }
                            else {
                              if (
                                !(
                                  n.inputs.length >= 3 &&
                                  this._allData[n.inputs[1]].tensor !== void 0 &&
                                  this._allData[n.inputs[2]].tensor !== void 0
                                )
                              )
                                continue;
                              e.attributes.set(`activation_params`, `floats`, [
                                this._allData[n.inputs[1]].tensor.floatData[0],
                                this._allData[n.inputs[2]].tensor.floatData[0],
                              ]);
                            }
                          (e.attributes.set(`activation`, `string`, n.opType), this.deleteNode(t[0]));
                        }
                      }
                  }
                }
              },
              6231: (e, t) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.now = t.Profiler = t.Logger = void 0));
                let n = { verbose: 1e3, info: 2e3, warning: 4e3, error: 5e3, fatal: 6e3 },
                  r = {
                    none: new (class {
                      log(e, t, n) {}
                    })(),
                    console: new (class {
                      log(e, t, n) {
                        console.log(`${this.color(e)} ${n ? `\x1B[35m` + n + `\x1B[0m ` : ``}${t}`);
                      }
                      color(e) {
                        switch (e) {
                          case `verbose`:
                            return `\x1B[34;40mv\x1B[0m`;
                          case `info`:
                            return `\x1B[32mi\x1B[0m`;
                          case `warning`:
                            return `\x1B[30;43mw\x1B[0m`;
                          case `error`:
                            return `\x1B[31;40me\x1B[0m`;
                          case `fatal`:
                            return `\x1B[101mf\x1B[0m`;
                          default:
                            throw Error(`unsupported severity: ${e}`);
                        }
                      }
                    })(),
                  },
                  i = { provider: `console`, minimalSeverity: `warning`, logDateTime: !0, logSourceLocation: !1 },
                  a = { '': i };
                function o(e, t, n, r) {
                  if (t === void 0)
                    return (
                      (i = e),
                      {
                        verbose: o.verbose.bind(null, i),
                        info: o.info.bind(null, i),
                        warning: o.warning.bind(null, i),
                        error: o.error.bind(null, i),
                        fatal: o.fatal.bind(null, i),
                      }
                    );
                  if (n === void 0) s(e, t);
                  else if (typeof n == `number` && r === void 0) s(e, t);
                  else if (typeof n == `string` && r === void 0) s(e, n, 0, t);
                  else {
                    if (typeof n != `string` || typeof r != `number`) throw TypeError(`input is valid`);
                    s(e, n, 0, t);
                  }
                  var i;
                }
                function s(e, t, i, o) {
                  let s = a[o || ``] || a[``];
                  n[e] < n[s.minimalSeverity] ||
                    (s.logDateTime && (t = `${new Date().toISOString()}|${t}`),
                    s.logSourceLocation,
                    r[s.provider].log(e, t, o));
                }
                ((function (e) {
                  function t(e) {
                    ((a = {}), n(``, e || {}));
                  }
                  function n(e, n) {
                    if (e === `*`) t(n);
                    else {
                      let t = a[e] || i;
                      a[e] = {
                        provider: n.provider || t.provider,
                        minimalSeverity: n.minimalSeverity || t.minimalSeverity,
                        logDateTime: n.logDateTime === void 0 ? t.logDateTime : n.logDateTime,
                        logSourceLocation: n.logSourceLocation === void 0 ? t.logSourceLocation : n.logSourceLocation,
                      };
                    }
                  }
                  ((e.verbose = function (t, n) {
                    e(`verbose`, t, n);
                  }),
                    (e.info = function (t, n) {
                      e(`info`, t, n);
                    }),
                    (e.warning = function (t, n) {
                      e(`warning`, t, n);
                    }),
                    (e.error = function (t, n) {
                      e(`error`, t, n);
                    }),
                    (e.fatal = function (t, n) {
                      e(`fatal`, t, n);
                    }),
                    (e.reset = t),
                    (e.set = n),
                    (e.setWithEnv = function (e) {
                      let t = {};
                      (e.logLevel && (t.minimalSeverity = e.logLevel), n(``, t));
                    }));
                })((o ||= {})),
                  (t.Logger = o));
                class c {
                  constructor(e, t, n, r, i, a) {
                    ((this.category = e),
                      (this.name = t),
                      (this.startTime = n),
                      (this.endCallback = r),
                      (this.timer = i),
                      (this.ctx = a));
                  }
                  end() {
                    return this.endCallback(this);
                  }
                  async checkTimer() {
                    if (this.ctx === void 0 || this.timer === void 0) throw Error(`No webgl timer found`);
                    return (this.ctx.endTimer(), this.ctx.waitForQueryAndGetTime(this.timer));
                  }
                }
                class l {
                  constructor(e, t, n, r) {
                    ((this.category = e), (this.name = t), (this.startTime = n), (this.endTime = r));
                  }
                }
                ((t.Profiler = class {
                  static create(e) {
                    return e === void 0
                      ? new this()
                      : new this(e.maxNumberEvents, e.flushBatchSize, e.flushIntervalInMilliseconds);
                  }
                  constructor(e, t, n) {
                    ((this._started = !1),
                      (this._flushPointer = 0),
                      (this._started = !1),
                      (this._maxNumberEvents = e === void 0 ? 1e4 : e),
                      (this._flushBatchSize = t === void 0 ? 10 : t),
                      (this._flushIntervalInMilliseconds = n === void 0 ? 5e3 : n));
                  }
                  start() {
                    ((this._started = !0),
                      (this._timingEvents = []),
                      (this._flushTime = (0, t.now)()),
                      (this._flushPointer = 0));
                  }
                  stop() {
                    for (this._started = !1; this._flushPointer < this._timingEvents.length; this._flushPointer++)
                      this.logOneEvent(this._timingEvents[this._flushPointer]);
                  }
                  event(e, t, n, r) {
                    let i = this._started ? this.begin(e, t, r) : void 0,
                      a = !1,
                      o = n();
                    if (o && typeof o.then == `function`)
                      return (
                        (a = !0),
                        new Promise((e, t) => {
                          o.then(
                            async (t) => {
                              (i && (await i.end()), e(t));
                            },
                            async (e) => {
                              (i && (await i.end()), t(e));
                            },
                          );
                        })
                      );
                    if (!a && i) {
                      let e = i.end();
                      if (e && typeof e.then == `function`)
                        return new Promise((t, n) => {
                          e.then(
                            () => {
                              t(o);
                            },
                            (e) => {
                              n(e);
                            },
                          );
                        });
                    }
                    return o;
                  }
                  begin(e, n, r) {
                    if (!this._started) throw Error(`profiler is not started yet`);
                    if (r === void 0) {
                      let r = (0, t.now)();
                      return (this.flush(r), new c(e, n, r, (e) => this.endSync(e)));
                    }
                    return new c(e, n, 0, async (e) => this.end(e), r.beginTimer(), r);
                  }
                  async end(e) {
                    let t = await e.checkTimer();
                    this._timingEvents.length < this._maxNumberEvents &&
                      (this._timingEvents.push(new l(e.category, e.name, e.startTime, t)), this.flush(t));
                  }
                  endSync(e) {
                    let n = (0, t.now)();
                    this._timingEvents.length < this._maxNumberEvents &&
                      (this._timingEvents.push(new l(e.category, e.name, e.startTime, n)), this.flush(n));
                  }
                  logOneEvent(e) {
                    t.Logger.verbose(
                      `Profiler.${e.category}`,
                      `${(e.endTime - e.startTime).toFixed(2)}ms on event '${e.name}' at ${e.endTime.toFixed(2)}`,
                    );
                  }
                  flush(e) {
                    if (
                      this._timingEvents.length - this._flushPointer >= this._flushBatchSize ||
                      e - this._flushTime >= this._flushIntervalInMilliseconds
                    ) {
                      for (
                        let e = this._flushPointer;
                        this._flushPointer < e + this._flushBatchSize && this._flushPointer < this._timingEvents.length;
                        this._flushPointer++
                      )
                        this.logOneEvent(this._timingEvents[this._flushPointer]);
                      this._flushTime = (0, t.now)();
                    }
                  }
                  get started() {
                    return this._started;
                  }
                }),
                  (t.now = typeof performance < `u` && performance.now ? () => performance.now() : Date.now));
              },
              2644: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.Model = void 0));
                let r = n(5686),
                  i = n(1446),
                  a = n(7070),
                  o = n(9395),
                  s = n(2517);
                var c = o.onnxruntime.experimental.fbs;
                t.Model = class {
                  constructor() {}
                  load(e, t, n) {
                    if (!n)
                      try {
                        this.loadFromOnnxFormat(e, t);
                        return;
                      } catch (e) {
                        if (n !== void 0) throw e;
                      }
                    this.loadFromOrtFormat(e, t);
                  }
                  loadFromOnnxFormat(e, t) {
                    let n = i.onnx.ModelProto.decode(e);
                    if (s.LongUtil.longToNumber(n.irVersion) < 3)
                      throw Error(`only support ONNX model with IR_VERSION>=3`);
                    ((this._opsets = n.opsetImport.map((e) => ({
                      domain: e.domain,
                      version: s.LongUtil.longToNumber(e.version),
                    }))),
                      (this._graph = a.Graph.from(n.graph, t)));
                  }
                  loadFromOrtFormat(e, t) {
                    let n = new r.flatbuffers.ByteBuffer(e),
                      i = c.InferenceSession.getRootAsInferenceSession(n).model();
                    if (s.LongUtil.longToNumber(i.irVersion()) < 3)
                      throw Error(`only support ONNX model with IR_VERSION>=3`);
                    this._opsets = [];
                    for (let e = 0; e < i.opsetImportLength(); e++) {
                      let t = i.opsetImport(e);
                      this._opsets.push({ domain: t?.domain(), version: s.LongUtil.longToNumber(t.version()) });
                    }
                    this._graph = a.Graph.from(i.graph(), t);
                  }
                  get graph() {
                    return this._graph;
                  }
                  get opsets() {
                    return this._opsets;
                  }
                };
              },
              782: (e, t) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.FLOAT_TYPES = t.INT_TYPES = t.NUMBER_TYPES = void 0),
                  (t.NUMBER_TYPES = [`float32`, `float64`, `int32`, `int16`, `int8`, `uint16`, `uint32`, `uint8`]),
                  (t.INT_TYPES = [`int32`, `int16`, `int8`, `uint16`, `uint32`, `uint8`]),
                  (t.FLOAT_TYPES = [`float32`, `float64`]));
              },
              1047: (e, t) => {
                'use strict';
                function n(e, t) {
                  if (t.endsWith(`+`)) {
                    let n = Number.parseInt(t.substring(0, t.length - 1), 10);
                    return !isNaN(n) && n <= e;
                  }
                  if (t.split(`-`).length === 2) {
                    let n = t.split(`-`),
                      r = Number.parseInt(n[0], 10),
                      i = Number.parseInt(n[1], 10);
                    return !isNaN(r) && !isNaN(i) && r <= e && e <= i;
                  }
                  return Number.parseInt(t, 10) === e;
                }
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.resolveOperator = void 0),
                  (t.resolveOperator = function (e, t, r) {
                    for (let i of r) {
                      let r = i[0],
                        a = i[1],
                        o = i[2],
                        s = i[3],
                        c = i[4];
                      if (e.opType === r) {
                        for (let e of t)
                          if ((e.domain === a || (e.domain === `ai.onnx` && a === ``)) && n(e.version, o))
                            return { opImpl: s, opInit: c };
                      }
                    }
                    throw TypeError(
                      `cannot resolve operator '${e.opType}' with opsets: ${t.map((e) => `${e.domain || `ai.onnx`} v${e.version}`).join(`, `)}`,
                    );
                  }));
              },
              9395: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.onnxruntime = void 0));
                let r = n(5686);
                var i = (t.onnxruntime ||= {}),
                  a;
                ((function (e) {
                  let t;
                  (function (e) {
                    ((e[(e.UNDEFINED = 0)] = `UNDEFINED`),
                      (e[(e.FLOAT = 1)] = `FLOAT`),
                      (e[(e.INT = 2)] = `INT`),
                      (e[(e.STRING = 3)] = `STRING`),
                      (e[(e.TENSOR = 4)] = `TENSOR`),
                      (e[(e.GRAPH = 5)] = `GRAPH`),
                      (e[(e.FLOATS = 6)] = `FLOATS`),
                      (e[(e.INTS = 7)] = `INTS`),
                      (e[(e.STRINGS = 8)] = `STRINGS`),
                      (e[(e.TENSORS = 9)] = `TENSORS`),
                      (e[(e.GRAPHS = 10)] = `GRAPHS`),
                      (e[(e.SPARSE_TENSOR = 11)] = `SPARSE_TENSOR`),
                      (e[(e.SPARSE_TENSORS = 12)] = `SPARSE_TENSORS`));
                  })((e.AttributeType ||= {}));
                })((a = i.experimental ||= {}).fbs || (a.fbs = {})),
                  (function (e) {
                    (function (e) {
                      (function (e) {
                        let t;
                        (function (e) {
                          ((e[(e.UNKNOWN = 0)] = `UNKNOWN`),
                            (e[(e.VALUE = 1)] = `VALUE`),
                            (e[(e.PARAM = 2)] = `PARAM`));
                        })((e.DimensionValueType ||= {}));
                      })((e.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (e) {
                      (function (e) {
                        let t;
                        (function (e) {
                          ((e[(e.UNDEFINED = 0)] = `UNDEFINED`),
                            (e[(e.FLOAT = 1)] = `FLOAT`),
                            (e[(e.UINT8 = 2)] = `UINT8`),
                            (e[(e.INT8 = 3)] = `INT8`),
                            (e[(e.UINT16 = 4)] = `UINT16`),
                            (e[(e.INT16 = 5)] = `INT16`),
                            (e[(e.INT32 = 6)] = `INT32`),
                            (e[(e.INT64 = 7)] = `INT64`),
                            (e[(e.STRING = 8)] = `STRING`),
                            (e[(e.BOOL = 9)] = `BOOL`),
                            (e[(e.FLOAT16 = 10)] = `FLOAT16`),
                            (e[(e.DOUBLE = 11)] = `DOUBLE`),
                            (e[(e.UINT32 = 12)] = `UINT32`),
                            (e[(e.UINT64 = 13)] = `UINT64`),
                            (e[(e.COMPLEX64 = 14)] = `COMPLEX64`),
                            (e[(e.COMPLEX128 = 15)] = `COMPLEX128`),
                            (e[(e.BFLOAT16 = 16)] = `BFLOAT16`));
                        })((e.TensorDataType ||= {}));
                      })((e.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (e) {
                      (function (e) {
                        let t;
                        (function (e) {
                          ((e[(e.Primitive = 0)] = `Primitive`), (e[(e.Fused = 1)] = `Fused`));
                        })((e.NodeType ||= {}));
                      })((e.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (e) {
                      (function (e) {
                        let t;
                        (function (e) {
                          ((e[(e.NONE = 0)] = `NONE`),
                            (e[(e.tensor_type = 1)] = `tensor_type`),
                            (e[(e.sequence_type = 2)] = `sequence_type`),
                            (e[(e.map_type = 3)] = `map_type`));
                        })((e.TypeInfoValue ||= {}));
                      })((e.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsShape(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsShape(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          dim(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 4);
                            return r
                              ? (n || new e.experimental.fbs.Dimension()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          dimLength() {
                            let e = this.bb.__offset(this.bb_pos, 4);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startShape(e) {
                            e.startObject(1);
                          }
                          static addDim(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static createDimVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startDimVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static endShape(e) {
                            return e.endObject();
                          }
                          static createShape(e, t) {
                            return (n.startShape(e), n.addDim(e, t), n.endShape(e));
                          }
                        }
                        t.Shape = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsDimension(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsDimension(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          value(t) {
                            let n = this.bb.__offset(this.bb_pos, 4);
                            return n
                              ? (t || new e.experimental.fbs.DimensionValue()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          denotation(e) {
                            let t = this.bb.__offset(this.bb_pos, 6);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          static startDimension(e) {
                            e.startObject(2);
                          }
                          static addValue(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addDenotation(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static endDimension(e) {
                            return e.endObject();
                          }
                          static createDimension(e, t, r) {
                            return (n.startDimension(e), n.addValue(e, t), n.addDenotation(e, r), n.endDimension(e));
                          }
                        }
                        t.Dimension = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsDimensionValue(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsDimensionValue(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          dimType() {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t
                              ? this.bb.readInt8(this.bb_pos + t)
                              : e.experimental.fbs.DimensionValueType.UNKNOWN;
                          }
                          dimValue() {
                            let e = this.bb.__offset(this.bb_pos, 6);
                            return e ? this.bb.readInt64(this.bb_pos + e) : this.bb.createLong(0, 0);
                          }
                          dimParam(e) {
                            let t = this.bb.__offset(this.bb_pos, 8);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          static startDimensionValue(e) {
                            e.startObject(3);
                          }
                          static addDimType(t, n) {
                            t.addFieldInt8(0, n, e.experimental.fbs.DimensionValueType.UNKNOWN);
                          }
                          static addDimValue(e, t) {
                            e.addFieldInt64(1, t, e.createLong(0, 0));
                          }
                          static addDimParam(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static endDimensionValue(e) {
                            return e.endObject();
                          }
                          static createDimensionValue(e, t, r, i) {
                            return (
                              n.startDimensionValue(e),
                              n.addDimType(e, t),
                              n.addDimValue(e, r),
                              n.addDimParam(e, i),
                              n.endDimensionValue(e)
                            );
                          }
                        }
                        t.DimensionValue = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsTensorTypeAndShape(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsTensorTypeAndShape(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          elemType() {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.readInt32(this.bb_pos + t) : e.experimental.fbs.TensorDataType.UNDEFINED;
                          }
                          shape(t) {
                            let n = this.bb.__offset(this.bb_pos, 6);
                            return n
                              ? (t || new e.experimental.fbs.Shape()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          static startTensorTypeAndShape(e) {
                            e.startObject(2);
                          }
                          static addElemType(t, n) {
                            t.addFieldInt32(0, n, e.experimental.fbs.TensorDataType.UNDEFINED);
                          }
                          static addShape(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static endTensorTypeAndShape(e) {
                            return e.endObject();
                          }
                          static createTensorTypeAndShape(e, t, r) {
                            return (
                              n.startTensorTypeAndShape(e),
                              n.addElemType(e, t),
                              n.addShape(e, r),
                              n.endTensorTypeAndShape(e)
                            );
                          }
                        }
                        t.TensorTypeAndShape = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsMapType(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsMapType(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          keyType() {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.readInt32(this.bb_pos + t) : e.experimental.fbs.TensorDataType.UNDEFINED;
                          }
                          valueType(t) {
                            let n = this.bb.__offset(this.bb_pos, 6);
                            return n
                              ? (t || new e.experimental.fbs.TypeInfo()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          static startMapType(e) {
                            e.startObject(2);
                          }
                          static addKeyType(t, n) {
                            t.addFieldInt32(0, n, e.experimental.fbs.TensorDataType.UNDEFINED);
                          }
                          static addValueType(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static endMapType(e) {
                            return e.endObject();
                          }
                          static createMapType(e, t, r) {
                            return (n.startMapType(e), n.addKeyType(e, t), n.addValueType(e, r), n.endMapType(e));
                          }
                        }
                        t.MapType = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsSequenceType(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsSequenceType(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          elemType(t) {
                            let n = this.bb.__offset(this.bb_pos, 4);
                            return n
                              ? (t || new e.experimental.fbs.TypeInfo()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          static startSequenceType(e) {
                            e.startObject(1);
                          }
                          static addElemType(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static endSequenceType(e) {
                            return e.endObject();
                          }
                          static createSequenceType(e, t) {
                            return (n.startSequenceType(e), n.addElemType(e, t), n.endSequenceType(e));
                          }
                        }
                        t.SequenceType = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (e) {
                      (e.fbs ||= {}).EdgeEnd = class {
                        constructor() {
                          ((this.bb = null), (this.bb_pos = 0));
                        }
                        __init(e, t) {
                          return ((this.bb_pos = e), (this.bb = t), this);
                        }
                        nodeIndex() {
                          return this.bb.readUint32(this.bb_pos);
                        }
                        srcArgIndex() {
                          return this.bb.readInt32(this.bb_pos + 4);
                        }
                        dstArgIndex() {
                          return this.bb.readInt32(this.bb_pos + 8);
                        }
                        static createEdgeEnd(e, t, n, r) {
                          return (e.prep(4, 12), e.writeInt32(r), e.writeInt32(n), e.writeInt32(t), e.offset());
                        }
                      };
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsNodeEdge(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsNodeEdge(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          nodeIndex() {
                            let e = this.bb.__offset(this.bb_pos, 4);
                            return e ? this.bb.readUint32(this.bb_pos + e) : 0;
                          }
                          inputEdges(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 6);
                            return r
                              ? (n || new e.experimental.fbs.EdgeEnd()).__init(
                                  this.bb.__vector(this.bb_pos + r) + 12 * t,
                                  this.bb,
                                )
                              : null;
                          }
                          inputEdgesLength() {
                            let e = this.bb.__offset(this.bb_pos, 6);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          outputEdges(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 8);
                            return r
                              ? (n || new e.experimental.fbs.EdgeEnd()).__init(
                                  this.bb.__vector(this.bb_pos + r) + 12 * t,
                                  this.bb,
                                )
                              : null;
                          }
                          outputEdgesLength() {
                            let e = this.bb.__offset(this.bb_pos, 8);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startNodeEdge(e) {
                            e.startObject(3);
                          }
                          static addNodeIndex(e, t) {
                            e.addFieldInt32(0, t, 0);
                          }
                          static addInputEdges(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static startInputEdgesVector(e, t) {
                            e.startVector(12, t, 4);
                          }
                          static addOutputEdges(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static startOutputEdgesVector(e, t) {
                            e.startVector(12, t, 4);
                          }
                          static endNodeEdge(e) {
                            return e.endObject();
                          }
                          static createNodeEdge(e, t, r, i) {
                            return (
                              n.startNodeEdge(e),
                              n.addNodeIndex(e, t),
                              n.addInputEdges(e, r),
                              n.addOutputEdges(e, i),
                              n.endNodeEdge(e)
                            );
                          }
                        }
                        t.NodeEdge = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsNode(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsNode(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          name(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          docString(e) {
                            let t = this.bb.__offset(this.bb_pos, 6);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          domain(e) {
                            let t = this.bb.__offset(this.bb_pos, 8);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          sinceVersion() {
                            let e = this.bb.__offset(this.bb_pos, 10);
                            return e ? this.bb.readInt32(this.bb_pos + e) : 0;
                          }
                          index() {
                            let e = this.bb.__offset(this.bb_pos, 12);
                            return e ? this.bb.readUint32(this.bb_pos + e) : 0;
                          }
                          opType(e) {
                            let t = this.bb.__offset(this.bb_pos, 14);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          type() {
                            let t = this.bb.__offset(this.bb_pos, 16);
                            return t ? this.bb.readInt32(this.bb_pos + t) : e.experimental.fbs.NodeType.Primitive;
                          }
                          executionProviderType(e) {
                            let t = this.bb.__offset(this.bb_pos, 18);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          inputs(e, t) {
                            let n = this.bb.__offset(this.bb_pos, 20);
                            return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * e, t) : null;
                          }
                          inputsLength() {
                            let e = this.bb.__offset(this.bb_pos, 20);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          outputs(e, t) {
                            let n = this.bb.__offset(this.bb_pos, 22);
                            return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * e, t) : null;
                          }
                          outputsLength() {
                            let e = this.bb.__offset(this.bb_pos, 22);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          attributes(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 24);
                            return r
                              ? (n || new e.experimental.fbs.Attribute()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          attributesLength() {
                            let e = this.bb.__offset(this.bb_pos, 24);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          inputArgCounts(e) {
                            let t = this.bb.__offset(this.bb_pos, 26);
                            return t ? this.bb.readInt32(this.bb.__vector(this.bb_pos + t) + 4 * e) : 0;
                          }
                          inputArgCountsLength() {
                            let e = this.bb.__offset(this.bb_pos, 26);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          inputArgCountsArray() {
                            let e = this.bb.__offset(this.bb_pos, 26);
                            return e
                              ? new Int32Array(
                                  this.bb.bytes().buffer,
                                  this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + e),
                                  this.bb.__vector_len(this.bb_pos + e),
                                )
                              : null;
                          }
                          implicitInputs(e, t) {
                            let n = this.bb.__offset(this.bb_pos, 28);
                            return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * e, t) : null;
                          }
                          implicitInputsLength() {
                            let e = this.bb.__offset(this.bb_pos, 28);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startNode(e) {
                            e.startObject(13);
                          }
                          static addName(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addDocString(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static addDomain(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static addSinceVersion(e, t) {
                            e.addFieldInt32(3, t, 0);
                          }
                          static addIndex(e, t) {
                            e.addFieldInt32(4, t, 0);
                          }
                          static addOpType(e, t) {
                            e.addFieldOffset(5, t, 0);
                          }
                          static addType(t, n) {
                            t.addFieldInt32(6, n, e.experimental.fbs.NodeType.Primitive);
                          }
                          static addExecutionProviderType(e, t) {
                            e.addFieldOffset(7, t, 0);
                          }
                          static addInputs(e, t) {
                            e.addFieldOffset(8, t, 0);
                          }
                          static createInputsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startInputsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addOutputs(e, t) {
                            e.addFieldOffset(9, t, 0);
                          }
                          static createOutputsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startOutputsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addAttributes(e, t) {
                            e.addFieldOffset(10, t, 0);
                          }
                          static createAttributesVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startAttributesVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addInputArgCounts(e, t) {
                            e.addFieldOffset(11, t, 0);
                          }
                          static createInputArgCountsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addInt32(t[n]);
                            return e.endVector();
                          }
                          static startInputArgCountsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addImplicitInputs(e, t) {
                            e.addFieldOffset(12, t, 0);
                          }
                          static createImplicitInputsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startImplicitInputsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static endNode(e) {
                            return e.endObject();
                          }
                          static createNode(e, t, r, i, a, o, s, c, l, u, d, f, p, m) {
                            return (
                              n.startNode(e),
                              n.addName(e, t),
                              n.addDocString(e, r),
                              n.addDomain(e, i),
                              n.addSinceVersion(e, a),
                              n.addIndex(e, o),
                              n.addOpType(e, s),
                              n.addType(e, c),
                              n.addExecutionProviderType(e, l),
                              n.addInputs(e, u),
                              n.addOutputs(e, d),
                              n.addAttributes(e, f),
                              n.addInputArgCounts(e, p),
                              n.addImplicitInputs(e, m),
                              n.endNode(e)
                            );
                          }
                        }
                        t.Node = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsValueInfo(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsValueInfo(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          name(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          docString(e) {
                            let t = this.bb.__offset(this.bb_pos, 6);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          type(t) {
                            let n = this.bb.__offset(this.bb_pos, 8);
                            return n
                              ? (t || new e.experimental.fbs.TypeInfo()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          static startValueInfo(e) {
                            e.startObject(3);
                          }
                          static addName(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addDocString(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static addType(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static endValueInfo(e) {
                            return e.endObject();
                          }
                          static createValueInfo(e, t, r, i) {
                            return (
                              n.startValueInfo(e),
                              n.addName(e, t),
                              n.addDocString(e, r),
                              n.addType(e, i),
                              n.endValueInfo(e)
                            );
                          }
                        }
                        t.ValueInfo = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsTypeInfo(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsTypeInfo(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          denotation(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          valueType() {
                            let t = this.bb.__offset(this.bb_pos, 6);
                            return t ? this.bb.readUint8(this.bb_pos + t) : e.experimental.fbs.TypeInfoValue.NONE;
                          }
                          value(e) {
                            let t = this.bb.__offset(this.bb_pos, 8);
                            return t ? this.bb.__union(e, this.bb_pos + t) : null;
                          }
                          static startTypeInfo(e) {
                            e.startObject(3);
                          }
                          static addDenotation(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addValueType(t, n) {
                            t.addFieldInt8(1, n, e.experimental.fbs.TypeInfoValue.NONE);
                          }
                          static addValue(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static endTypeInfo(e) {
                            return e.endObject();
                          }
                          static createTypeInfo(e, t, r, i) {
                            return (
                              n.startTypeInfo(e),
                              n.addDenotation(e, t),
                              n.addValueType(e, r),
                              n.addValue(e, i),
                              n.endTypeInfo(e)
                            );
                          }
                        }
                        t.TypeInfo = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (e) {
                      (function (e) {
                        class t {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsOperatorSetId(e, n) {
                            return (n || new t()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsOperatorSetId(e, n) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (n || new t()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          domain(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          version() {
                            let e = this.bb.__offset(this.bb_pos, 6);
                            return e ? this.bb.readInt64(this.bb_pos + e) : this.bb.createLong(0, 0);
                          }
                          static startOperatorSetId(e) {
                            e.startObject(2);
                          }
                          static addDomain(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addVersion(e, t) {
                            e.addFieldInt64(1, t, e.createLong(0, 0));
                          }
                          static endOperatorSetId(e) {
                            return e.endObject();
                          }
                          static createOperatorSetId(e, n, r) {
                            return (
                              t.startOperatorSetId(e),
                              t.addDomain(e, n),
                              t.addVersion(e, r),
                              t.endOperatorSetId(e)
                            );
                          }
                        }
                        e.OperatorSetId = t;
                      })((e.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsTensor(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsTensor(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          name(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          docString(e) {
                            let t = this.bb.__offset(this.bb_pos, 6);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          dims(e) {
                            let t = this.bb.__offset(this.bb_pos, 8);
                            return t
                              ? this.bb.readInt64(this.bb.__vector(this.bb_pos + t) + 8 * e)
                              : this.bb.createLong(0, 0);
                          }
                          dimsLength() {
                            let e = this.bb.__offset(this.bb_pos, 8);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          dataType() {
                            let t = this.bb.__offset(this.bb_pos, 10);
                            return t ? this.bb.readInt32(this.bb_pos + t) : e.experimental.fbs.TensorDataType.UNDEFINED;
                          }
                          rawData(e) {
                            let t = this.bb.__offset(this.bb_pos, 12);
                            return t ? this.bb.readUint8(this.bb.__vector(this.bb_pos + t) + e) : 0;
                          }
                          rawDataLength() {
                            let e = this.bb.__offset(this.bb_pos, 12);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          rawDataArray() {
                            let e = this.bb.__offset(this.bb_pos, 12);
                            return e
                              ? new Uint8Array(
                                  this.bb.bytes().buffer,
                                  this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + e),
                                  this.bb.__vector_len(this.bb_pos + e),
                                )
                              : null;
                          }
                          stringData(e, t) {
                            let n = this.bb.__offset(this.bb_pos, 14);
                            return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * e, t) : null;
                          }
                          stringDataLength() {
                            let e = this.bb.__offset(this.bb_pos, 14);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startTensor(e) {
                            e.startObject(6);
                          }
                          static addName(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addDocString(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static addDims(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static createDimsVector(e, t) {
                            e.startVector(8, t.length, 8);
                            for (let n = t.length - 1; n >= 0; n--) e.addInt64(t[n]);
                            return e.endVector();
                          }
                          static startDimsVector(e, t) {
                            e.startVector(8, t, 8);
                          }
                          static addDataType(t, n) {
                            t.addFieldInt32(3, n, e.experimental.fbs.TensorDataType.UNDEFINED);
                          }
                          static addRawData(e, t) {
                            e.addFieldOffset(4, t, 0);
                          }
                          static createRawDataVector(e, t) {
                            e.startVector(1, t.length, 1);
                            for (let n = t.length - 1; n >= 0; n--) e.addInt8(t[n]);
                            return e.endVector();
                          }
                          static startRawDataVector(e, t) {
                            e.startVector(1, t, 1);
                          }
                          static addStringData(e, t) {
                            e.addFieldOffset(5, t, 0);
                          }
                          static createStringDataVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startStringDataVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static endTensor(e) {
                            return e.endObject();
                          }
                          static createTensor(e, t, r, i, a, o, s) {
                            return (
                              n.startTensor(e),
                              n.addName(e, t),
                              n.addDocString(e, r),
                              n.addDims(e, i),
                              n.addDataType(e, a),
                              n.addRawData(e, o),
                              n.addStringData(e, s),
                              n.endTensor(e)
                            );
                          }
                        }
                        t.Tensor = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsSparseTensor(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsSparseTensor(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          values(t) {
                            let n = this.bb.__offset(this.bb_pos, 4);
                            return n
                              ? (t || new e.experimental.fbs.Tensor()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          indices(t) {
                            let n = this.bb.__offset(this.bb_pos, 6);
                            return n
                              ? (t || new e.experimental.fbs.Tensor()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          dims(e) {
                            let t = this.bb.__offset(this.bb_pos, 8);
                            return t
                              ? this.bb.readInt64(this.bb.__vector(this.bb_pos + t) + 8 * e)
                              : this.bb.createLong(0, 0);
                          }
                          dimsLength() {
                            let e = this.bb.__offset(this.bb_pos, 8);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startSparseTensor(e) {
                            e.startObject(3);
                          }
                          static addValues(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addIndices(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static addDims(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static createDimsVector(e, t) {
                            e.startVector(8, t.length, 8);
                            for (let n = t.length - 1; n >= 0; n--) e.addInt64(t[n]);
                            return e.endVector();
                          }
                          static startDimsVector(e, t) {
                            e.startVector(8, t, 8);
                          }
                          static endSparseTensor(e) {
                            return e.endObject();
                          }
                          static createSparseTensor(e, t, r, i) {
                            return (
                              n.startSparseTensor(e),
                              n.addValues(e, t),
                              n.addIndices(e, r),
                              n.addDims(e, i),
                              n.endSparseTensor(e)
                            );
                          }
                        }
                        t.SparseTensor = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsAttribute(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsAttribute(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          name(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          docString(e) {
                            let t = this.bb.__offset(this.bb_pos, 6);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          type() {
                            let t = this.bb.__offset(this.bb_pos, 8);
                            return t ? this.bb.readInt32(this.bb_pos + t) : e.experimental.fbs.AttributeType.UNDEFINED;
                          }
                          f() {
                            let e = this.bb.__offset(this.bb_pos, 10);
                            return e ? this.bb.readFloat32(this.bb_pos + e) : 0;
                          }
                          i() {
                            let e = this.bb.__offset(this.bb_pos, 12);
                            return e ? this.bb.readInt64(this.bb_pos + e) : this.bb.createLong(0, 0);
                          }
                          s(e) {
                            let t = this.bb.__offset(this.bb_pos, 14);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          t(t) {
                            let n = this.bb.__offset(this.bb_pos, 16);
                            return n
                              ? (t || new e.experimental.fbs.Tensor()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          g(t) {
                            let n = this.bb.__offset(this.bb_pos, 18);
                            return n
                              ? (t || new e.experimental.fbs.Graph()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          floats(e) {
                            let t = this.bb.__offset(this.bb_pos, 20);
                            return t ? this.bb.readFloat32(this.bb.__vector(this.bb_pos + t) + 4 * e) : 0;
                          }
                          floatsLength() {
                            let e = this.bb.__offset(this.bb_pos, 20);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          floatsArray() {
                            let e = this.bb.__offset(this.bb_pos, 20);
                            return e
                              ? new Float32Array(
                                  this.bb.bytes().buffer,
                                  this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + e),
                                  this.bb.__vector_len(this.bb_pos + e),
                                )
                              : null;
                          }
                          ints(e) {
                            let t = this.bb.__offset(this.bb_pos, 22);
                            return t
                              ? this.bb.readInt64(this.bb.__vector(this.bb_pos + t) + 8 * e)
                              : this.bb.createLong(0, 0);
                          }
                          intsLength() {
                            let e = this.bb.__offset(this.bb_pos, 22);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          strings(e, t) {
                            let n = this.bb.__offset(this.bb_pos, 24);
                            return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * e, t) : null;
                          }
                          stringsLength() {
                            let e = this.bb.__offset(this.bb_pos, 24);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          tensors(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 26);
                            return r
                              ? (n || new e.experimental.fbs.Tensor()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          tensorsLength() {
                            let e = this.bb.__offset(this.bb_pos, 26);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          graphs(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 28);
                            return r
                              ? (n || new e.experimental.fbs.Graph()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          graphsLength() {
                            let e = this.bb.__offset(this.bb_pos, 28);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startAttribute(e) {
                            e.startObject(13);
                          }
                          static addName(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addDocString(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static addType(t, n) {
                            t.addFieldInt32(2, n, e.experimental.fbs.AttributeType.UNDEFINED);
                          }
                          static addF(e, t) {
                            e.addFieldFloat32(3, t, 0);
                          }
                          static addI(e, t) {
                            e.addFieldInt64(4, t, e.createLong(0, 0));
                          }
                          static addS(e, t) {
                            e.addFieldOffset(5, t, 0);
                          }
                          static addT(e, t) {
                            e.addFieldOffset(6, t, 0);
                          }
                          static addG(e, t) {
                            e.addFieldOffset(7, t, 0);
                          }
                          static addFloats(e, t) {
                            e.addFieldOffset(8, t, 0);
                          }
                          static createFloatsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addFloat32(t[n]);
                            return e.endVector();
                          }
                          static startFloatsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addInts(e, t) {
                            e.addFieldOffset(9, t, 0);
                          }
                          static createIntsVector(e, t) {
                            e.startVector(8, t.length, 8);
                            for (let n = t.length - 1; n >= 0; n--) e.addInt64(t[n]);
                            return e.endVector();
                          }
                          static startIntsVector(e, t) {
                            e.startVector(8, t, 8);
                          }
                          static addStrings(e, t) {
                            e.addFieldOffset(10, t, 0);
                          }
                          static createStringsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startStringsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addTensors(e, t) {
                            e.addFieldOffset(11, t, 0);
                          }
                          static createTensorsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startTensorsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addGraphs(e, t) {
                            e.addFieldOffset(12, t, 0);
                          }
                          static createGraphsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startGraphsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static endAttribute(e) {
                            return e.endObject();
                          }
                          static createAttribute(e, t, r, i, a, o, s, c, l, u, d, f, p, m) {
                            return (
                              n.startAttribute(e),
                              n.addName(e, t),
                              n.addDocString(e, r),
                              n.addType(e, i),
                              n.addF(e, a),
                              n.addI(e, o),
                              n.addS(e, s),
                              n.addT(e, c),
                              n.addG(e, l),
                              n.addFloats(e, u),
                              n.addInts(e, d),
                              n.addStrings(e, f),
                              n.addTensors(e, p),
                              n.addGraphs(e, m),
                              n.endAttribute(e)
                            );
                          }
                        }
                        t.Attribute = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsGraph(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsGraph(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          initializers(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 4);
                            return r
                              ? (n || new e.experimental.fbs.Tensor()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          initializersLength() {
                            let e = this.bb.__offset(this.bb_pos, 4);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          nodeArgs(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 6);
                            return r
                              ? (n || new e.experimental.fbs.ValueInfo()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          nodeArgsLength() {
                            let e = this.bb.__offset(this.bb_pos, 6);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          nodes(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 8);
                            return r
                              ? (n || new e.experimental.fbs.Node()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          nodesLength() {
                            let e = this.bb.__offset(this.bb_pos, 8);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          maxNodeIndex() {
                            let e = this.bb.__offset(this.bb_pos, 10);
                            return e ? this.bb.readUint32(this.bb_pos + e) : 0;
                          }
                          nodeEdges(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 12);
                            return r
                              ? (n || new e.experimental.fbs.NodeEdge()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          nodeEdgesLength() {
                            let e = this.bb.__offset(this.bb_pos, 12);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          inputs(e, t) {
                            let n = this.bb.__offset(this.bb_pos, 14);
                            return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * e, t) : null;
                          }
                          inputsLength() {
                            let e = this.bb.__offset(this.bb_pos, 14);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          outputs(e, t) {
                            let n = this.bb.__offset(this.bb_pos, 16);
                            return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * e, t) : null;
                          }
                          outputsLength() {
                            let e = this.bb.__offset(this.bb_pos, 16);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          sparseInitializers(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 18);
                            return r
                              ? (n || new e.experimental.fbs.SparseTensor()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          sparseInitializersLength() {
                            let e = this.bb.__offset(this.bb_pos, 18);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startGraph(e) {
                            e.startObject(8);
                          }
                          static addInitializers(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static createInitializersVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startInitializersVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addNodeArgs(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static createNodeArgsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startNodeArgsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addNodes(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static createNodesVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startNodesVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addMaxNodeIndex(e, t) {
                            e.addFieldInt32(3, t, 0);
                          }
                          static addNodeEdges(e, t) {
                            e.addFieldOffset(4, t, 0);
                          }
                          static createNodeEdgesVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startNodeEdgesVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addInputs(e, t) {
                            e.addFieldOffset(5, t, 0);
                          }
                          static createInputsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startInputsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addOutputs(e, t) {
                            e.addFieldOffset(6, t, 0);
                          }
                          static createOutputsVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startOutputsVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addSparseInitializers(e, t) {
                            e.addFieldOffset(7, t, 0);
                          }
                          static createSparseInitializersVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startSparseInitializersVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static endGraph(e) {
                            return e.endObject();
                          }
                          static createGraph(e, t, r, i, a, o, s, c, l) {
                            return (
                              n.startGraph(e),
                              n.addInitializers(e, t),
                              n.addNodeArgs(e, r),
                              n.addNodes(e, i),
                              n.addMaxNodeIndex(e, a),
                              n.addNodeEdges(e, o),
                              n.addInputs(e, s),
                              n.addOutputs(e, c),
                              n.addSparseInitializers(e, l),
                              n.endGraph(e)
                            );
                          }
                        }
                        t.Graph = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsModel(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsModel(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          irVersion() {
                            let e = this.bb.__offset(this.bb_pos, 4);
                            return e ? this.bb.readInt64(this.bb_pos + e) : this.bb.createLong(0, 0);
                          }
                          opsetImport(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 6);
                            return r
                              ? (n || new e.experimental.fbs.OperatorSetId()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          opsetImportLength() {
                            let e = this.bb.__offset(this.bb_pos, 6);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          producerName(e) {
                            let t = this.bb.__offset(this.bb_pos, 8);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          producerVersion(e) {
                            let t = this.bb.__offset(this.bb_pos, 10);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          domain(e) {
                            let t = this.bb.__offset(this.bb_pos, 12);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          modelVersion() {
                            let e = this.bb.__offset(this.bb_pos, 14);
                            return e ? this.bb.readInt64(this.bb_pos + e) : this.bb.createLong(0, 0);
                          }
                          docString(e) {
                            let t = this.bb.__offset(this.bb_pos, 16);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          graph(t) {
                            let n = this.bb.__offset(this.bb_pos, 18);
                            return n
                              ? (t || new e.experimental.fbs.Graph()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          graphDocString(e) {
                            let t = this.bb.__offset(this.bb_pos, 20);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          static startModel(e) {
                            e.startObject(9);
                          }
                          static addIrVersion(e, t) {
                            e.addFieldInt64(0, t, e.createLong(0, 0));
                          }
                          static addOpsetImport(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static createOpsetImportVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startOpsetImportVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addProducerName(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static addProducerVersion(e, t) {
                            e.addFieldOffset(3, t, 0);
                          }
                          static addDomain(e, t) {
                            e.addFieldOffset(4, t, 0);
                          }
                          static addModelVersion(e, t) {
                            e.addFieldInt64(5, t, e.createLong(0, 0));
                          }
                          static addDocString(e, t) {
                            e.addFieldOffset(6, t, 0);
                          }
                          static addGraph(e, t) {
                            e.addFieldOffset(7, t, 0);
                          }
                          static addGraphDocString(e, t) {
                            e.addFieldOffset(8, t, 0);
                          }
                          static endModel(e) {
                            return e.endObject();
                          }
                          static createModel(e, t, r, i, a, o, s, c, l, u) {
                            return (
                              n.startModel(e),
                              n.addIrVersion(e, t),
                              n.addOpsetImport(e, r),
                              n.addProducerName(e, i),
                              n.addProducerVersion(e, a),
                              n.addDomain(e, o),
                              n.addModelVersion(e, s),
                              n.addDocString(e, c),
                              n.addGraph(e, l),
                              n.addGraphDocString(e, u),
                              n.endModel(e)
                            );
                          }
                        }
                        t.Model = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (e) {
                      (function (e) {
                        class t {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsKernelCreateInfos(e, n) {
                            return (n || new t()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsKernelCreateInfos(e, n) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (n || new t()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          nodeIndices(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.readUint32(this.bb.__vector(this.bb_pos + t) + 4 * e) : 0;
                          }
                          nodeIndicesLength() {
                            let e = this.bb.__offset(this.bb_pos, 4);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          nodeIndicesArray() {
                            let e = this.bb.__offset(this.bb_pos, 4);
                            return e
                              ? new Uint32Array(
                                  this.bb.bytes().buffer,
                                  this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + e),
                                  this.bb.__vector_len(this.bb_pos + e),
                                )
                              : null;
                          }
                          kernelDefHashes(e) {
                            let t = this.bb.__offset(this.bb_pos, 6);
                            return t
                              ? this.bb.readUint64(this.bb.__vector(this.bb_pos + t) + 8 * e)
                              : this.bb.createLong(0, 0);
                          }
                          kernelDefHashesLength() {
                            let e = this.bb.__offset(this.bb_pos, 6);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startKernelCreateInfos(e) {
                            e.startObject(2);
                          }
                          static addNodeIndices(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static createNodeIndicesVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addInt32(t[n]);
                            return e.endVector();
                          }
                          static startNodeIndicesVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static addKernelDefHashes(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static createKernelDefHashesVector(e, t) {
                            e.startVector(8, t.length, 8);
                            for (let n = t.length - 1; n >= 0; n--) e.addInt64(t[n]);
                            return e.endVector();
                          }
                          static startKernelDefHashesVector(e, t) {
                            e.startVector(8, t, 8);
                          }
                          static endKernelCreateInfos(e) {
                            return e.endObject();
                          }
                          static createKernelCreateInfos(e, n, r) {
                            return (
                              t.startKernelCreateInfos(e),
                              t.addNodeIndices(e, n),
                              t.addKernelDefHashes(e, r),
                              t.endKernelCreateInfos(e)
                            );
                          }
                        }
                        e.KernelCreateInfos = t;
                      })((e.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsSubGraphSessionState(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsSubGraphSessionState(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          graphId(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          sessionState(t) {
                            let n = this.bb.__offset(this.bb_pos, 6);
                            return n
                              ? (t || new e.experimental.fbs.SessionState()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          static startSubGraphSessionState(e) {
                            e.startObject(2);
                          }
                          static addGraphId(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addSessionState(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static endSubGraphSessionState(e) {
                            let t = e.endObject();
                            return (e.requiredField(t, 4), t);
                          }
                          static createSubGraphSessionState(e, t, r) {
                            return (
                              n.startSubGraphSessionState(e),
                              n.addGraphId(e, t),
                              n.addSessionState(e, r),
                              n.endSubGraphSessionState(e)
                            );
                          }
                        }
                        t.SubGraphSessionState = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsSessionState(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsSessionState(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          kernels(t) {
                            let n = this.bb.__offset(this.bb_pos, 4);
                            return n
                              ? (t || new e.experimental.fbs.KernelCreateInfos()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          subGraphSessionStates(t, n) {
                            let r = this.bb.__offset(this.bb_pos, 6);
                            return r
                              ? (n || new e.experimental.fbs.SubGraphSessionState()).__init(
                                  this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t),
                                  this.bb,
                                )
                              : null;
                          }
                          subGraphSessionStatesLength() {
                            let e = this.bb.__offset(this.bb_pos, 6);
                            return e ? this.bb.__vector_len(this.bb_pos + e) : 0;
                          }
                          static startSessionState(e) {
                            e.startObject(2);
                          }
                          static addKernels(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addSubGraphSessionStates(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static createSubGraphSessionStatesVector(e, t) {
                            e.startVector(4, t.length, 4);
                            for (let n = t.length - 1; n >= 0; n--) e.addOffset(t[n]);
                            return e.endVector();
                          }
                          static startSubGraphSessionStatesVector(e, t) {
                            e.startVector(4, t, 4);
                          }
                          static endSessionState(e) {
                            return e.endObject();
                          }
                          static createSessionState(e, t, r) {
                            return (
                              n.startSessionState(e),
                              n.addKernels(e, t),
                              n.addSubGraphSessionStates(e, r),
                              n.endSessionState(e)
                            );
                          }
                        }
                        t.SessionState = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})),
                  (function (e) {
                    (function (t) {
                      (function (t) {
                        class n {
                          constructor() {
                            ((this.bb = null), (this.bb_pos = 0));
                          }
                          __init(e, t) {
                            return ((this.bb_pos = e), (this.bb = t), this);
                          }
                          static getRootAsInferenceSession(e, t) {
                            return (t || new n()).__init(e.readInt32(e.position()) + e.position(), e);
                          }
                          static getSizePrefixedRootAsInferenceSession(e, t) {
                            return (
                              e.setPosition(e.position() + r.flatbuffers.SIZE_PREFIX_LENGTH),
                              (t || new n()).__init(e.readInt32(e.position()) + e.position(), e)
                            );
                          }
                          static bufferHasIdentifier(e) {
                            return e.__has_identifier(`ORTM`);
                          }
                          ortVersion(e) {
                            let t = this.bb.__offset(this.bb_pos, 4);
                            return t ? this.bb.__string(this.bb_pos + t, e) : null;
                          }
                          model(t) {
                            let n = this.bb.__offset(this.bb_pos, 6);
                            return n
                              ? (t || new e.experimental.fbs.Model()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          sessionState(t) {
                            let n = this.bb.__offset(this.bb_pos, 8);
                            return n
                              ? (t || new e.experimental.fbs.SessionState()).__init(
                                  this.bb.__indirect(this.bb_pos + n),
                                  this.bb,
                                )
                              : null;
                          }
                          static startInferenceSession(e) {
                            e.startObject(3);
                          }
                          static addOrtVersion(e, t) {
                            e.addFieldOffset(0, t, 0);
                          }
                          static addModel(e, t) {
                            e.addFieldOffset(1, t, 0);
                          }
                          static addSessionState(e, t) {
                            e.addFieldOffset(2, t, 0);
                          }
                          static endInferenceSession(e) {
                            return e.endObject();
                          }
                          static finishInferenceSessionBuffer(e, t) {
                            e.finish(t, `ORTM`);
                          }
                          static finishSizePrefixedInferenceSessionBuffer(e, t) {
                            e.finish(t, `ORTM`, !0);
                          }
                          static createInferenceSession(e, t, r, i) {
                            return (
                              n.startInferenceSession(e),
                              n.addOrtVersion(e, t),
                              n.addModel(e, r),
                              n.addSessionState(e, i),
                              n.endInferenceSession(e)
                            );
                          }
                        }
                        t.InferenceSession = n;
                      })((t.fbs ||= {}));
                    })((e.experimental ||= {}));
                  })((t.onnxruntime ||= {})));
              },
              7448: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.OnnxjsSessionHandler = void 0));
                let r = n(1670),
                  i = n(9162);
                t.OnnxjsSessionHandler = class {
                  constructor(e) {
                    ((this.session = e),
                      (this.inputNames = this.session.inputNames),
                      (this.outputNames = this.session.outputNames));
                  }
                  async dispose() {}
                  async run(e, t, n) {
                    let a = new Map();
                    for (let t in e)
                      if (Object.hasOwnProperty.call(e, t)) {
                        let n = e[t];
                        a.set(t, new i.Tensor(n.dims, n.type, void 0, void 0, n.data));
                      }
                    let o = await this.session.run(a),
                      s = {};
                    return (
                      o.forEach((e, t) => {
                        s[t] = new r.Tensor(e.type, e.data, e.dims);
                      }),
                      s
                    );
                  }
                  startProfiling() {
                    this.session.startProfiling();
                  }
                  endProfiling() {
                    this.session.endProfiling();
                  }
                };
              },
              6919: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.Session = void 0));
                let r = n(7067),
                  i = n(1296),
                  a = n(7091),
                  o = n(1036),
                  s = n(6231),
                  c = n(2644);
                t.Session = class {
                  constructor(e = {}) {
                    ((this._initialized = !1),
                      (this.backendHint = e.backendHint),
                      (this.profiler = s.Profiler.create(e.profiler)),
                      (this.context = { profiler: this.profiler, graphInputTypes: [], graphInputDims: [] }));
                  }
                  get inputNames() {
                    return this._model.graph.getInputNames();
                  }
                  get outputNames() {
                    return this._model.graph.getOutputNames();
                  }
                  startProfiling() {
                    this.profiler.start();
                  }
                  endProfiling() {
                    this.profiler.stop();
                  }
                  async loadModel(e, t, n) {
                    await this.profiler.event(`session`, `Session.loadModel`, async () => {
                      let o = await (0, a.resolveBackend)(this.backendHint);
                      if (
                        ((this.sessionHandler = o.createSessionHandler(this.context)),
                        (this._model = new c.Model()),
                        typeof e == `string`)
                      ) {
                        let t = e.endsWith(`.ort`);
                        if (typeof fetch > `u`) {
                          let n = await (0, i.promisify)(r.readFile)(e);
                          this.initialize(n, t);
                        } else {
                          let n = await (await fetch(e)).arrayBuffer();
                          this.initialize(new Uint8Array(n), t);
                        }
                      } else if (ArrayBuffer.isView(e)) this.initialize(e);
                      else {
                        let r = new Uint8Array(e, t || 0, n || e.byteLength);
                        this.initialize(r);
                      }
                    });
                  }
                  initialize(e, t) {
                    if (this._initialized) throw Error(`already initialized`);
                    (this.profiler.event(`session`, `Session.initialize`, () => {
                      let n = this.sessionHandler.transformGraph ? this.sessionHandler : void 0;
                      (this._model.load(e, n, t),
                        this.sessionHandler.onGraphInitialized &&
                          this.sessionHandler.onGraphInitialized(this._model.graph),
                        this.initializeOps(this._model.graph),
                        (this._executionPlan = new o.ExecutionPlan(this._model.graph, this._ops, this.profiler)));
                    }),
                      (this._initialized = !0));
                  }
                  async run(e) {
                    if (!this._initialized) throw Error(`session not initialized yet`);
                    return this.profiler.event(`session`, `Session.run`, async () => {
                      let t = this.normalizeAndValidateInputs(e),
                        n = await this._executionPlan.execute(this.sessionHandler, t);
                      return this.createOutput(n);
                    });
                  }
                  normalizeAndValidateInputs(e) {
                    let t = this._model.graph.getInputNames();
                    if (Array.isArray(e)) {
                      if (e.length !== t.length)
                        throw Error(`incorrect input array length: expected ${t.length} but got ${e.length}`);
                    } else {
                      if (e.size !== t.length)
                        throw Error(`incorrect input map size: expected ${t.length} but got ${e.size}`);
                      let n = Array(e.size),
                        r = 0;
                      for (let i = 0; i < t.length; ++i) {
                        let a = e.get(t[i]);
                        if (!a) throw Error(`missing input tensor for: '${name}'`);
                        n[r++] = a;
                      }
                      e = n;
                    }
                    if (
                      this.context.graphInputTypes &&
                      this.context.graphInputTypes.length !== 0 &&
                      this.context.graphInputDims &&
                      this.context.graphInputDims.length !== 0
                    )
                      this.validateInputTensorDims(this.context.graphInputDims, e, !1);
                    else {
                      let t = this._model.graph.getInputIndices(),
                        n = this._model.graph.getValues(),
                        r = Array(t.length);
                      for (let i = 0; i < t.length; ++i) {
                        let a = n[t[i]];
                        ((r[i] = a.type.shape.dims),
                          this.context.graphInputTypes.push(a.type.tensorType),
                          this.context.graphInputDims.push(e[i].dims));
                      }
                      this.validateInputTensorDims(r, e, !0);
                    }
                    return (this.validateInputTensorTypes(this.context.graphInputTypes, e), e);
                  }
                  validateInputTensorTypes(e, t) {
                    for (let n = 0; n < t.length; n++) {
                      let r = e[n],
                        i = t[n].type;
                      if (r !== i) throw Error(`input tensor[${n}] check failed: expected type '${r}' but got ${i}`);
                    }
                  }
                  validateInputTensorDims(e, t, n) {
                    for (let r = 0; r < t.length; r++) {
                      let i = e[r],
                        a = t[r].dims;
                      if (!this.compareTensorDims(i, a, n))
                        throw Error(
                          `input tensor[${r}] check failed: expected shape '[${i.join(`,`)}]' but got [${a.join(`,`)}]`,
                        );
                    }
                  }
                  compareTensorDims(e, t, n) {
                    if (e.length !== t.length) return !1;
                    for (let r = 0; r < e.length; ++r) if (e[r] !== t[r] && (!n || e[r] !== 0)) return !1;
                    return !0;
                  }
                  createOutput(e) {
                    let t = this._model.graph.getOutputNames();
                    if (e.length !== t.length)
                      throw Error(`expected number of outputs do not match number of generated outputs`);
                    let n = new Map();
                    for (let r = 0; r < t.length; ++r) n.set(t[r], e[r]);
                    return n;
                  }
                  initializeOps(e) {
                    let t = e.getNodes();
                    this._ops = Array(t.length);
                    for (let n = 0; n < t.length; n++)
                      this._ops[n] = this.sessionHandler.resolve(t[n], this._model.opsets, e);
                  }
                };
              },
              9162: function (e, t, n) {
                'use strict';
                var r =
                  (this && this.__importDefault) ||
                  function (e) {
                    return e && e.__esModule ? e : { default: e };
                  };
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.Tensor = void 0));
                let i = n(3442),
                  a = r(n(3720)),
                  o = n(1446),
                  s = n(9395),
                  c = n(2517);
                var l = s.onnxruntime.experimental.fbs;
                class u {
                  get data() {
                    if (this.cache === void 0) {
                      let e = this.dataProvider(this.dataId);
                      if (e.length !== this.size)
                        throw Error(
                          `Length of data provided by the Data Provider is inconsistent with the dims of this Tensor.`,
                        );
                      this.cache = e;
                    }
                    return this.cache;
                  }
                  get stringData() {
                    if (this.type !== `string`) throw TypeError(`data type is not string`);
                    return this.data;
                  }
                  get integerData() {
                    switch (this.type) {
                      case `uint8`:
                      case `int8`:
                      case `uint16`:
                      case `int16`:
                      case `int32`:
                      case `uint32`:
                      case `bool`:
                        return this.data;
                      default:
                        throw TypeError(`data type is not integer (uint8, int8, uint16, int16, int32, uint32, bool)`);
                    }
                  }
                  get floatData() {
                    switch (this.type) {
                      case `float32`:
                      case `float64`:
                        return this.data;
                      default:
                        throw TypeError(`data type is not float (float32, float64)`);
                    }
                  }
                  get numberData() {
                    if (this.type !== `string`) return this.data;
                    throw TypeError(`type cannot be non-number (string)`);
                  }
                  get(e) {
                    return this.data[c.ShapeUtil.indicesToOffset(e, this.strides)];
                  }
                  set(e, t) {
                    this.data[c.ShapeUtil.indicesToOffset(e, this.strides)] = t;
                  }
                  async getData() {
                    return (
                      this.cache === void 0 && (this.cache = await this.asyncDataProvider(this.dataId)),
                      this.cache
                    );
                  }
                  get strides() {
                    return ((this._strides ||= c.ShapeUtil.computeStrides(this.dims)), this._strides);
                  }
                  constructor(e, t, n, r, a, o = i.Guid.create()) {
                    ((this.dims = e),
                      (this.type = t),
                      (this.dataProvider = n),
                      (this.asyncDataProvider = r),
                      (this.cache = a),
                      (this.dataId = o),
                      (this.size = c.ShapeUtil.validateDimsAndCalcSize(e)));
                    let s = this.size,
                      l = n === void 0 && r === void 0 && a === void 0;
                    if (a !== void 0 && a.length !== s) throw RangeError(`Input dims doesn't match data length.`);
                    if (t === `string`) {
                      if (!(a === void 0 || (Array.isArray(a) && a.every((e) => typeof e == `string`))))
                        throw TypeError(`cache should be a string array`);
                      l && (this.cache = Array(s));
                    } else {
                      if (a !== void 0) {
                        let e = f(t);
                        if (!(a instanceof e)) throw TypeError(`cache should be type ${e.name}`);
                      }
                      if (l) {
                        let e = new ArrayBuffer(
                          s *
                            (function (e) {
                              switch (e) {
                                case `bool`:
                                case `int8`:
                                case `uint8`:
                                  return 1;
                                case `int16`:
                                case `uint16`:
                                  return 2;
                                case `int32`:
                                case `uint32`:
                                case `float32`:
                                  return 4;
                                case `float64`:
                                  return 8;
                                default:
                                  throw Error(`cannot calculate sizeof() on type ${e}`);
                              }
                            })(t),
                        );
                        this.cache = (function (e, t) {
                          return new (f(t))(e);
                        })(e, t);
                      }
                    }
                  }
                  static fromProto(e) {
                    if (!e) throw Error(`cannot construct Value from an empty tensor`);
                    let t = c.ProtoUtil.tensorDataTypeFromProto(e.dataType),
                      n = new u(c.ProtoUtil.tensorDimsFromProto(e.dims), t);
                    if (t === `string`)
                      e.stringData.forEach((e, t) => {
                        n.data[t] = (0, c.decodeUtf8String)(e);
                      });
                    else if (e.rawData && typeof e.rawData.byteLength == `number` && e.rawData.byteLength > 0) {
                      let t = n.data,
                        r = new DataView(e.rawData.buffer, e.rawData.byteOffset, e.rawData.byteLength),
                        i = d(e.dataType),
                        a = e.rawData.byteLength / i;
                      if (e.rawData.byteLength % i != 0) throw Error(`invalid buffer length`);
                      if (t.length !== a) throw Error(`buffer length mismatch`);
                      for (let n = 0; n < a; n++) t[n] = m(r, e.dataType, n * i);
                    } else {
                      let t;
                      switch (e.dataType) {
                        case o.onnx.TensorProto.DataType.FLOAT:
                          t = e.floatData;
                          break;
                        case o.onnx.TensorProto.DataType.INT32:
                        case o.onnx.TensorProto.DataType.INT16:
                        case o.onnx.TensorProto.DataType.UINT16:
                        case o.onnx.TensorProto.DataType.INT8:
                        case o.onnx.TensorProto.DataType.UINT8:
                        case o.onnx.TensorProto.DataType.BOOL:
                          t = e.int32Data;
                          break;
                        case o.onnx.TensorProto.DataType.INT64:
                          t = e.int64Data;
                          break;
                        case o.onnx.TensorProto.DataType.DOUBLE:
                          t = e.doubleData;
                          break;
                        case o.onnx.TensorProto.DataType.UINT32:
                        case o.onnx.TensorProto.DataType.UINT64:
                          t = e.uint64Data;
                          break;
                        default:
                          throw Error(`unspecific error`);
                      }
                      if (t == null) throw Error(`failed to populate data from a tensorproto value`);
                      let r = n.data;
                      if (r.length !== t.length) throw Error(`array length mismatch`);
                      for (let n = 0; n < t.length; n++) {
                        let i = t[n];
                        a.default.isLong(i) ? (r[n] = p(i, e.dataType)) : (r[n] = i);
                      }
                    }
                    return n;
                  }
                  static fromData(e, t, n) {
                    return new u(t, n, void 0, void 0, e);
                  }
                  static fromOrtTensor(e) {
                    if (!e) throw Error(`cannot construct Value from an empty tensor`);
                    let t = c.ProtoUtil.tensorDimsFromORTFormat(e),
                      n = c.ProtoUtil.tensorDataTypeFromProto(e.dataType()),
                      r = new u(t, n);
                    if (n === `string`) for (let t = 0; t < e.stringDataLength(); t++) r.data[t] = e.stringData(t);
                    else if (e.rawDataArray() && typeof e.rawDataLength() == `number` && e.rawDataLength() > 0) {
                      let t = r.data,
                        n = new DataView(e.rawDataArray().buffer, e.rawDataArray().byteOffset, e.rawDataLength()),
                        i = d(e.dataType()),
                        a = e.rawDataLength() / i;
                      if (e.rawDataLength() % i != 0) throw Error(`invalid buffer length`);
                      if (t.length !== a) throw Error(`buffer length mismatch`);
                      for (let r = 0; r < a; r++) t[r] = m(n, e.dataType(), r * i);
                    }
                    return r;
                  }
                }
                function d(e) {
                  switch (e) {
                    case o.onnx.TensorProto.DataType.UINT8:
                    case o.onnx.TensorProto.DataType.INT8:
                    case o.onnx.TensorProto.DataType.BOOL:
                      return 1;
                    case o.onnx.TensorProto.DataType.UINT16:
                    case o.onnx.TensorProto.DataType.INT16:
                      return 2;
                    case o.onnx.TensorProto.DataType.FLOAT:
                    case o.onnx.TensorProto.DataType.INT32:
                    case o.onnx.TensorProto.DataType.UINT32:
                      return 4;
                    case o.onnx.TensorProto.DataType.INT64:
                    case o.onnx.TensorProto.DataType.DOUBLE:
                    case o.onnx.TensorProto.DataType.UINT64:
                      return 8;
                    default:
                      throw Error(`cannot calculate sizeof() on type ${o.onnx.TensorProto.DataType[e]}`);
                  }
                }
                function f(e) {
                  switch (e) {
                    case `bool`:
                    case `uint8`:
                      return Uint8Array;
                    case `int8`:
                      return Int8Array;
                    case `int16`:
                      return Int16Array;
                    case `uint16`:
                      return Uint16Array;
                    case `int32`:
                      return Int32Array;
                    case `uint32`:
                      return Uint32Array;
                    case `float32`:
                      return Float32Array;
                    case `float64`:
                      return Float64Array;
                    default:
                      throw Error(`unspecified error`);
                  }
                }
                function p(e, t) {
                  if (t === o.onnx.TensorProto.DataType.INT64 || t === l.TensorDataType.INT64) {
                    if (e.greaterThanOrEqual(2147483648) || e.lessThan(-2147483648))
                      throw TypeError(`int64 is not supported`);
                  } else {
                    if (
                      t !== o.onnx.TensorProto.DataType.UINT32 &&
                      t !== l.TensorDataType.UINT32 &&
                      t !== o.onnx.TensorProto.DataType.UINT64 &&
                      t !== l.TensorDataType.UINT64
                    )
                      throw TypeError(`not a LONG type: ${o.onnx.TensorProto.DataType[t]}`);
                    if (e.greaterThanOrEqual(4294967296) || e.lessThan(0)) throw TypeError(`uint64 is not supported`);
                  }
                  return e.toNumber();
                }
                function m(e, t, n) {
                  switch (t) {
                    case o.onnx.TensorProto.DataType.BOOL:
                    case o.onnx.TensorProto.DataType.UINT8:
                      return e.getUint8(n);
                    case o.onnx.TensorProto.DataType.INT8:
                      return e.getInt8(n);
                    case o.onnx.TensorProto.DataType.UINT16:
                      return e.getUint16(n, !0);
                    case o.onnx.TensorProto.DataType.INT16:
                      return e.getInt16(n, !0);
                    case o.onnx.TensorProto.DataType.FLOAT:
                      return e.getFloat32(n, !0);
                    case o.onnx.TensorProto.DataType.INT32:
                      return e.getInt32(n, !0);
                    case o.onnx.TensorProto.DataType.UINT32:
                      return e.getUint32(n, !0);
                    case o.onnx.TensorProto.DataType.INT64:
                      return p(a.default.fromBits(e.getUint32(n, !0), e.getUint32(n + 4, !0), !1), t);
                    case o.onnx.TensorProto.DataType.DOUBLE:
                      return e.getFloat64(n, !0);
                    case o.onnx.TensorProto.DataType.UINT64:
                      return p(a.default.fromBits(e.getUint32(n, !0), e.getUint32(n + 4, !0), !0), t);
                    default:
                      throw Error(`cannot read from DataView for type ${o.onnx.TensorProto.DataType[t]}`);
                  }
                }
                t.Tensor = u;
              },
              2517: function (e, t, n) {
                'use strict';
                var r =
                  (this && this.__importDefault) ||
                  function (e) {
                    return e && e.__esModule ? e : { default: e };
                  };
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.decodeUtf8String =
                    t.MAX_CLIP =
                    t.MIN_CLIP =
                    t.PoolConvUtil =
                    t.ReduceUtil =
                    t.SplitUtil =
                    t.MathUtil =
                    t.ShapeUtil =
                    t.LongUtil =
                    t.ProtoUtil =
                    t.GemmUtil =
                    t.arrayCopyHelper =
                    t.BroadcastUtil =
                    t.MatMulUtil =
                    t.ArrayUtil =
                    t.assert =
                    t.checkInputsShape =
                      void 0));
                let i = n(5686),
                  a = r(n(3720)),
                  o = n(1446),
                  s = n(9162);
                ((t.checkInputsShape = function (e, ...t) {
                  if (!e || e.length !== t.length) return !1;
                  for (let n = 0; n < e.length; n++) if (!e[n].dims || e[n].dims.length !== t[n]) return !1;
                  return !0;
                }),
                  (t.assert = function (e, t) {
                    if (!e) throw Error(typeof t == `string` ? t : t());
                  }),
                  (t.ArrayUtil = class {
                    static arraysEqual(e, t) {
                      if (e.length !== t.length) return !1;
                      for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
                      return !0;
                    }
                  }));
                class c {
                  static preprocessInputShapes(e, t) {
                    return [e.length === 1 ? [1, e[0]] : e, t.length === 1 ? [t[0], 1] : t];
                  }
                  static postprocessOutputShape(e, t, n) {
                    (t === 1 && e.splice(e.length - 2, 1), n === 1 && e.pop());
                  }
                  static calcMatMulShape(e, t) {
                    return e[1] === t[0] ? [e[0], t[1]] : void 0;
                  }
                }
                t.MatMulUtil = c;
                class l {
                  static calcShape(e, t, n = !1) {
                    let r = e.length,
                      i = t.length;
                    if (r === 0) return t;
                    if (i === 0) return e;
                    let a = Math.max(e.length, t.length),
                      o = Array(a);
                    if (n) {
                      if (r < 2 || i < 2) return;
                      let n = c.calcMatMulShape([e[r - 2], e[r - 1]], [t[i - 2], t[i - 1]]);
                      if (n === void 0) return;
                      [o[a - 2], o[a - 1]] = n;
                    }
                    for (let s = n ? 3 : 1; s <= a; s++) {
                      let n = r - s < 0 ? 1 : e[r - s],
                        c = i - s < 0 ? 1 : t[i - s];
                      if (n !== c && n > 1 && c > 1) return;
                      o[a - s] = Math.max(n, c);
                    }
                    return o;
                  }
                  static index(e, t) {
                    let n = Array(t.length);
                    return (l.fillIndex(e, t, n), n);
                  }
                  static fillIndex(e, t, n) {
                    let r = e.length - t.length;
                    for (let i = 0; i < t.length; i++) n[i] = e[r + i] % t[i];
                  }
                  static calc(e, t, n, r, i) {
                    let a = l.calcShape(e.dims, t.dims);
                    if (a) {
                      if (r && !f.areEqual(a, e.dims)) return;
                      let o = f.size(a),
                        c = r ? e : new s.Tensor(a, i || e.type);
                      if (a.length === 0) c.set([], n(e.get([]), t.get([])));
                      else {
                        let r = Array(a.length),
                          i = Array(e.dims.length),
                          s = Array(t.dims.length),
                          u,
                          d = 0,
                          f = 0,
                          p = !1,
                          m = !1;
                        (e.dims.length === 0 && ((d = e.get([])), (p = !0)),
                          t.dims.length === 0 && ((f = t.get([])), (m = !0)));
                        for (let h = 0; h < o; h++) {
                          u = h;
                          for (let e = a.length - 1; e >= 0; e--) ((r[e] = u % a[e]), (u = Math.floor(u / a[e])));
                          (p || (l.fillIndex(r, e.dims, i), (d = e.get(i))),
                            m || (l.fillIndex(r, t.dims, s), (f = t.get(s))),
                            c.set(r, n(d, f)));
                        }
                      }
                      return c;
                    }
                  }
                  static isValidBroadcast(e, t) {
                    let n = e.length,
                      r = t.length;
                    if (n > r) return !1;
                    for (let i = 1; i <= n; i++) if (e[n - i] !== 1 && e[n - i] !== t[r - i]) return !1;
                    return !0;
                  }
                  static getBroadcastDims(e, t) {
                    let n = e.length,
                      r = [];
                    for (let i = 0; i < n; i++) {
                      let a = n - 1 - i,
                        o = e[a] || 1;
                      (t[t.length - 1 - i] || 1) > 1 && o === 1 && r.unshift(a);
                    }
                    return r;
                  }
                }
                ((t.BroadcastUtil = l),
                  (t.arrayCopyHelper = function (e, t, n, r, i) {
                    if (r < 0 || r >= t.length) throw Error(`sourceIndex out of bounds`);
                    if (n < 0 || n >= e.length) throw Error(`targetIndex out of bounds`);
                    if (r + i > t.length) throw Error(`source indices to be copied are outside bounds`);
                    if (n + i > e.length) throw Error(`target array is too small to hold result`);
                    for (let a = 0; a < i; a++) e[n + a] = t[r + a];
                  }),
                  (t.GemmUtil = class {
                    static getShapeOfGemmResult(e, t, n, r, i) {
                      if (e.length !== 2 || n.length !== 2) throw Error(`shape need to be of size 2`);
                      let a, o, s;
                      t ? ((a = e[1]), (o = e[0])) : ((a = e[0]), (o = e[1]));
                      let c = -1;
                      if ((r ? ((s = n[0]), (c = 1)) : ((s = n[1]), (c = 0)), n[c] !== o))
                        throw Error(`dimension mismatch`);
                      if (a <= 0 || s <= 0 || o <= 0) throw Error(`invalid shape specified`);
                      if (i && !l.isValidBroadcast(i, [a, s])) throw Error(`gemm: invalid bias shape for broadcast`);
                      return [a, s, o];
                    }
                  }));
                class u {
                  static tensorDataTypeFromProto(e) {
                    switch (e) {
                      case o.onnx.TensorProto.DataType.INT8:
                        return `int8`;
                      case o.onnx.TensorProto.DataType.UINT8:
                        return `uint8`;
                      case o.onnx.TensorProto.DataType.BOOL:
                        return `bool`;
                      case o.onnx.TensorProto.DataType.INT16:
                        return `int16`;
                      case o.onnx.TensorProto.DataType.UINT16:
                        return `uint16`;
                      case o.onnx.TensorProto.DataType.INT32:
                        return `int32`;
                      case o.onnx.TensorProto.DataType.UINT32:
                        return `uint32`;
                      case o.onnx.TensorProto.DataType.FLOAT:
                        return `float32`;
                      case o.onnx.TensorProto.DataType.DOUBLE:
                        return `float64`;
                      case o.onnx.TensorProto.DataType.STRING:
                        return `string`;
                      case o.onnx.TensorProto.DataType.INT64:
                        return `int32`;
                      case o.onnx.TensorProto.DataType.UINT64:
                        return `uint32`;
                      default:
                        throw Error(`unsupported data type: ${o.onnx.TensorProto.DataType[e]}`);
                    }
                  }
                  static tensorDataTypeStringToEnum(e) {
                    switch (e) {
                      case `int8`:
                        return o.onnx.TensorProto.DataType.INT8;
                      case `uint8`:
                        return o.onnx.TensorProto.DataType.UINT8;
                      case `bool`:
                        return o.onnx.TensorProto.DataType.BOOL;
                      case `int16`:
                        return o.onnx.TensorProto.DataType.INT16;
                      case `uint16`:
                        return o.onnx.TensorProto.DataType.UINT16;
                      case `int32`:
                        return o.onnx.TensorProto.DataType.INT32;
                      case `uint32`:
                        return o.onnx.TensorProto.DataType.UINT32;
                      case `float32`:
                        return o.onnx.TensorProto.DataType.FLOAT;
                      case `float64`:
                        return o.onnx.TensorProto.DataType.DOUBLE;
                      case `string`:
                        return o.onnx.TensorProto.DataType.STRING;
                      case `int64`:
                        return o.onnx.TensorProto.DataType.INT64;
                      case `uint64`:
                        return o.onnx.TensorProto.DataType.UINT64;
                      default:
                        throw Error(`unsupported data type: ${e}`);
                    }
                  }
                  static tensorDimsFromProto(e) {
                    return e.map((e) => (a.default.isLong(e) ? e.toNumber() : e));
                  }
                  static tensorValueTypeFromProto(e) {
                    return {
                      tensorType: u.tensorDataTypeFromProto(e.elemType),
                      shape: { dims: u.tensorDimsFromProto(e.shape.dim.map((e) => e.dimValue)) },
                    };
                  }
                  static tensorDimsFromORTFormat(e) {
                    let t = [];
                    for (let n = 0; n < e.dimsLength(); n++) t.push(d.longToNumber(e.dims(n)));
                    return t;
                  }
                  static tensorAttributesFromORTFormat(e) {
                    let t = [];
                    for (let n = 0; n < e.attributesLength(); n++) t.push(e.attributes(n));
                    return t;
                  }
                }
                t.ProtoUtil = u;
                class d {
                  static longToNumber(e, t) {
                    return a.default.isLong(e)
                      ? e.toNumber()
                      : e instanceof i.flatbuffers.Long
                        ? a.default.fromValue({ low: e.low, high: e.high, unsigned: t != null && t }).toNumber()
                        : e;
                  }
                  static isLong(e) {
                    return a.default.isLong(e) || e instanceof i.flatbuffers.Long;
                  }
                }
                t.LongUtil = d;
                class f {
                  static size(e) {
                    return f.getSizeFromDimensionRange(e, 0, e.length);
                  }
                  static sizeFromDimension(e, t) {
                    if (t < 0 || t > e.length)
                      throw Error(
                        `invalid dimension of ${t} for sizeFromDimension as Tensor has ${e.length} dimensions.`,
                      );
                    return f.getSizeFromDimensionRange(e, t, e.length);
                  }
                  static sizeToDimension(e, t) {
                    if (t < 0 || t > e.length)
                      throw Error(
                        `invalid dimension of ${t} for sizeToDimension as Tensor has ${e.length} dimensions.`,
                      );
                    return f.getSizeFromDimensionRange(e, 0, t);
                  }
                  static getSizeFromDimensionRange(e, t, n) {
                    let r = 1;
                    for (let i = t; i < n; i++) {
                      if (e[i] <= 0)
                        throw Error(
                          `cannot get valid size from specified dimension range. Most likely the range contains 0 or negative values in them.`,
                        );
                      r *= e[i];
                    }
                    return r;
                  }
                  static computeStrides(e) {
                    let t = e.length;
                    if (t === 0) return [];
                    if (t === 1) return [1];
                    let n = Array(t);
                    ((n[t - 1] = 1), (n[t - 2] = e[t - 1]));
                    for (let r = t - 3; r >= 0; --r) n[r] = n[r + 1] * e[r + 1];
                    return n;
                  }
                  static transpose(e) {
                    return e.slice().reverse();
                  }
                  static indicesToOffset(e, t, n) {
                    n === void 0 && (n = e.length);
                    let r = 0;
                    for (let i = 0; i < n; ++i) r += t[i] * e[i];
                    return r;
                  }
                  static offsetToIndices(e, t) {
                    let n = t.length;
                    if (n === 0) return [];
                    if (n === 1) return [e * t[0]];
                    let r = Array(t.length);
                    for (let n = 0; n < r.length - 1; ++n) ((r[n] = Math.floor(e / t[n])), (e -= r[n] * t[n]));
                    return ((r[r.length - 1] = e), r);
                  }
                  static normalizeAxis(e, t) {
                    if (e < -t && e >= t) throw Error(`unsupported axis for this operation.`);
                    return e < 0 ? e + t : e;
                  }
                  static normalizeAxes(e, t) {
                    return e.map((e) => this.normalizeAxis(e, t));
                  }
                  static incrementIndex(e, t, n) {
                    if (t.length === 0 || e.length === 0)
                      throw Error(`Index incrementing unsupported for scalar Tensor`);
                    if (n === void 0) n = t.length;
                    else if (n <= 0 || n > t.length) throw Error(`Incorrect axis to increment on`);
                    for (let r = n - 1; r >= 0 && (e[r]++, !(e[r] < t[r])); --r) e[r] = 0;
                  }
                  static calculateReshapedDims(e, t) {
                    if (t.length === 0) {
                      if (e.length === 0 || f.size(e) === 1) return [];
                      throw Error(`cannot reshape to a scalar Tensor`);
                    }
                    let n = t.length,
                      r = Array(n),
                      i = -1,
                      a = 1;
                    for (let o = 0; o < n; o++) {
                      if (t[o] < -1) throw Error(`a dimension in shape hints cannot be less than -1`);
                      if (t[o] === -1) {
                        if (i !== -1) throw Error(`at most one dimension in shape hints can be -1`);
                        i = o;
                      } else {
                        if (t[o] === 0) {
                          if (o >= e.length)
                            throw Error(`the dimension with value zero exceeds the dimension size of the input tensor`);
                          r[o] = e[o];
                        } else r[o] = t[o];
                        a *= r[o];
                      }
                    }
                    let o = f.size(e);
                    if (i !== -1) {
                      if (o % a != 0)
                        throw Error(
                          `the input tensor cannot be reshaped to the requested shape. Input shape: [${e}] Output shape: [${t}]`,
                        );
                      r[i] = o / a;
                    } else if (a !== o) throw Error(`reshapedDims and originalDims don't have matching sizes`);
                    return r;
                  }
                  static sortBasedOnPerm(e, t) {
                    return t ? t.map((t) => e[t]) : e.slice().reverse();
                  }
                  static padShape(e, t) {
                    let n = e.length;
                    return e.map((e, r) => e + t[r] + t[r + n]);
                  }
                  static areEqual(e, t) {
                    return e.length === t.length && e.every((e, n) => e === t[n]);
                  }
                  static validateDimsAndCalcSize(e) {
                    if (e.length > 6) throw TypeError(`Only rank 0 to 6 is supported for tensor shape.`);
                    let t = 1;
                    for (let n of e) {
                      if (!Number.isInteger(n)) throw TypeError(`Invalid shape: ${n} is not an integer`);
                      if (n < 0 || n > 2147483647) throw TypeError(`Invalid shape: length ${n} is not allowed`);
                      t *= n;
                    }
                    return t;
                  }
                  static flattenShape(e, t) {
                    t < 0 && (t += e.length);
                    let n = e.reduce((e, t) => e * t, 1),
                      r = e.slice(t).reduce((e, t) => e * t, 1);
                    return [n / r, r];
                  }
                  static squeezeShape(e, t) {
                    let n = [];
                    t = f.normalizeAxes(t, e.length);
                    for (let r = 0; r < e.length; r++) {
                      let i = t.indexOf(r) >= 0;
                      if (i && e[r] !== 1) throw Error(`squeeze an axis of size different than 1`);
                      ((t.length === 0 && e[r] > 1) || (t.length > 0 && !i)) && n.push(e[r]);
                    }
                    return n;
                  }
                  static unsqueezeShape(e, t) {
                    let n = Array(e.length + t.length);
                    n.fill(0);
                    for (let e = 0; e < t.length; e++) {
                      let r = f.normalizeAxis(t[e], n.length);
                      if (r >= n.length) throw Error(`'axes' has an out of range axis`);
                      if (n[r] !== 0) throw Error(`'axes' has a duplicate axis`);
                      n[r] = 1;
                    }
                    let r = 0;
                    for (let t = 0; t < n.length; t++) n[t] === 0 && (n[t] = e[r++]);
                    if (r !== e.length) throw Error(`the unsqueezed dimension could not be established`);
                    return n;
                  }
                }
                ((t.ShapeUtil = f),
                  (t.MathUtil = class {
                    static sqr(e, t, n, r, i) {
                      if (r < 0 || r >= t.length) throw Error(`sourceIndex out of bounds`);
                      if (n < 0 || n >= e.length) throw Error(`targetIndex out of bounds`);
                      if (r + i > t.length) throw Error(`source indices to be copied are outside bounds`);
                      if (n + i > e.length) throw Error(`target array is too small to hold result`);
                      for (let a = 0; a < i; a++) e[n + a] += t[r + a] ** 2;
                    }
                    static axpy(e, t, n, r, i, a) {
                      if (r < 0 || r >= t.length) throw Error(`sourceIndex out of bounds`);
                      if (n < 0 || n >= e.length) throw Error(`targetIndex out of bounds`);
                      if (r + i > t.length) throw Error(`source indices to be copied are outside bounds`);
                      if (n + i > e.length) throw Error(`target array is too small to hold result`);
                      for (let o = 0; o < i; o++) e[n + o] += a * t[r + o];
                    }
                    static powx(e, t, n, r, i, a) {
                      if (r < 0 || r >= t.length) throw Error(`sourceIndex out of bounds`);
                      if (n < 0 || n >= e.length) throw Error(`targetIndex out of bounds`);
                      if (r + i > t.length) throw Error(`source indices to be copied are outside bounds`);
                      if (n + i > e.length) throw Error(`target array is too small to hold result`);
                      for (let o = 0; o < i; o++) e[n + o] = t[r + o] ** +a;
                    }
                    static mul(e, t, n, r, i) {
                      if (r < 0 || r >= t.length) throw Error(`sourceIndex out of bounds`);
                      if (n < 0 || n >= e.length) throw Error(`targetIndex out of bounds`);
                      if (r + i > t.length) throw Error(`source indices to be copied are outside bounds`);
                      if (n + i > e.length) throw Error(`target array is too small to hold result`);
                      for (let a = 0; a < i; a++) e[n + a] = t[r + a] * e[n + a];
                    }
                  }));
                class p {
                  static splitShape(e, t, n, r) {
                    if (n.length === 0) {
                      if (!r) throw Error(`need to know number of outputs when the 'split' attribute is not specified`);
                      p.determineSplit(e[t], r, n);
                    }
                    let i = [],
                      a = [0];
                    for (let r = 0; r < n.length; ++r) {
                      r !== 0 && a.push(a[r - 1] + n[r - 1]);
                      let o = e.slice();
                      ((o[t] = n[r]), i.push(o));
                    }
                    return [i, a];
                  }
                  static determineSplit(e, t, n) {
                    if (e % t != 0) throw Error(`cannot split tensor to equal sized parts`);
                    for (let r = 0; r < t; ++r) n.push(e / t);
                  }
                }
                t.SplitUtil = p;
                class m {
                  static calcReduce(e, t, n, r, i) {
                    let a = e.dims.slice(0);
                    t.length === 0 && a.forEach((e, n) => t.push(n));
                    let o = m.calcReduceShape(a, t, !0),
                      c = f.size(o),
                      u = new s.Tensor(o, e.type),
                      d = f.computeStrides(o),
                      p = f.computeStrides(a),
                      h = Array(a.length);
                    for (let n = 0; n < c; n++) {
                      let o = f.offsetToIndices(n, d);
                      (l.fillIndex(o, a, h),
                        u.set(o, m.calcReduceByAxis(e.numberData, t, a, 0, f.indicesToOffset(h, p), r, i)));
                    }
                    return n ? u : new s.Tensor(m.calcReduceShape(a, t, n), u.type, void 0, void 0, u.data, u.dataId);
                  }
                  static calcReduceByAxis(e, t, n, r, i, a, o) {
                    let s = 0;
                    if (r >= t.length) return a(e[i]);
                    let c = t[r],
                      l = c >= n.length ? 1 : f.size(n.slice(c + 1));
                    for (let u = 0; u < n[c]; u++)
                      ((s =
                        u === 0
                          ? m.calcReduceByAxis(e, t, n, r + 1, i, a, o)
                          : o(s, m.calcReduceByAxis(e, t, n, r + 1, i, a, o))),
                        (i += l));
                    return s;
                  }
                  static calcReduceShape(e, t, n) {
                    let r = e.slice();
                    for (let e = 0; e < t.length; e++) r[t[e]] = +!!n;
                    return r.filter((e) => e !== 0);
                  }
                }
                t.ReduceUtil = m;
                class h {
                  static adjustPoolAttributes(e, t, n, r, i, a) {
                    if (!e && n.length !== t.length - 2)
                      throw Error(`length of specified kernel shapes should be 2 less than length of input dimensions`);
                    if (e) for (let e = 0; e < t.length - 2; e++) e >= n.length ? n.push(t[e + 2]) : (n[e] = t[e + 2]);
                    for (let e = 0; e < n.length; e++)
                      if (e < r.length) {
                        if (r[e] < 0) throw Error(`strides should be greater than or equal to 1`);
                      } else r.push(1);
                    for (let e = 0; e < n.length; e++)
                      if (e < i.length) {
                        if (i[e] < 0) throw Error(`dilations should be greater than or equal to 1`);
                      } else i.push(1);
                    for (let e = 0; e < 2 * n.length; e++)
                      if (e < a.length) {
                        if (a[e] < 0) throw Error(`pad should be greater than or equal to 1`);
                      } else a.push(0);
                    for (let e = 0; e < n.length; e++) {
                      if (n[e] <= 0) throw Error(`kernel shapes need to be greater than 0`);
                      if (a[e] >= n[e] || a[e + n.length] >= n[e]) throw Error(`pads should be smaller than kernel`);
                    }
                  }
                  static adjustPadsBasedOnAutoPad(e, t, n, r, i, a) {
                    if (a) {
                      if (i.length !== 2 * (e.length - 2))
                        throw Error(`length of pads should be twice the length of data dimensions`);
                      if (t.length !== e.length - 2)
                        throw Error(`length of strides should be the length of data dimensions`);
                      if (r.length !== e.length - 2)
                        throw Error(`length of kernel shapes should be the length of data dimensions`);
                      for (let o = 0; o < e.length - 2; o++)
                        h.adjustPadAndReturnShape(e[o + 2], t[o], n[o], r[o], i, o, o + e.length - 2, a);
                    }
                  }
                  static computePoolOutputShape(e, t, n, r, i, a, o) {
                    if (t.length <= 0) throw Error(`input shape must be of size greater than 0`);
                    let s = [t[0], t[1]];
                    return (h.computeShapeHelper(e, t, s, n, r, i, a, o), s);
                  }
                  static computeConvOutputShape(e, t, n, r, i, a, o) {
                    if (e.length <= 0 || t.length <= 0)
                      throw Error(`invalid input tensor dims or invalid filter tensor dims`);
                    let s = [e[0], t[0]];
                    return (h.computeShapeHelper(!1, e, s, n, r, i, a, o), s);
                  }
                  static computeShapeHelper(e, t, n, r, i, a, o, s) {
                    if (e) for (let e = 0; e < t.length - 2; e++) n.push(1);
                    else
                      for (let e = 0; e < t.length - 2; e++)
                        n.push(h.adjustPadAndReturnShape(t[e + 2], r[e], i[e], a[e], o, e, e + t.length - 2, s));
                  }
                  static adjustPadAndReturnShape(e, t, n, r, i, a, o, s) {
                    let c = n * (r - 1) + 1;
                    if (!s || s === `NOTSET`) return Math.floor((e + i[a] + i[o] - c) / t + 1);
                    switch (s) {
                      case `VALID`:
                        return ((i[a] = 0), (i[o] = 0), Math.floor((e - c) / t + 1));
                      case `SAME_LOWER`:
                      case `SAME_UPPER`:
                        if (n !== 1) throw Error(`Dilation not supported for SAME_UPPER or SAME_LOWER`);
                        {
                          let n = ((e + t - 1) / t - 1) * t + r - e;
                          return (
                            (i[a] = Math.floor(s === `SAME_LOWER` ? (n + 1) / 2 : n / 2)),
                            (i[o] = n - i[a]),
                            Math.floor((e + n - r) / t + 1)
                          );
                        }
                      default:
                        throw Error(`Unsupported AutoPad type`);
                    }
                  }
                }
                ((t.PoolConvUtil = h),
                  (t.MIN_CLIP = -34028234663852886e22),
                  (t.MAX_CLIP = 34028234663852886e22),
                  (t.decodeUtf8String = function (e) {
                    return new TextDecoder().decode(e);
                  }));
              },
              7967: (e, t) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.iterateExtraOptions = void 0),
                  (t.iterateExtraOptions = (e, n, r, i) => {
                    if (typeof e == `object` && e) {
                      if (r.has(e)) throw Error(`Circular reference in options`);
                      r.add(e);
                    }
                    Object.entries(e).forEach(([e, a]) => {
                      let o = n ? n + e : e;
                      if (typeof a == `object`) (0, t.iterateExtraOptions)(a, o + `.`, r, i);
                      else if (typeof a == `string` || typeof a == `number`) i(o, a.toString());
                      else {
                        if (typeof a != `boolean`) throw Error(`Can't handle extra config type: ` + typeof a);
                        i(o, a ? `1` : `0`);
                      }
                    });
                  }));
              },
              2157: function (e, t, n) {
                'use strict';
                var r,
                  i =
                    (this && this.__createBinding) ||
                    (Object.create
                      ? function (e, t, n, r) {
                          r === void 0 && (r = n);
                          var i = Object.getOwnPropertyDescriptor(t, n);
                          ((i && !(`get` in i ? !t.__esModule : i.writable || i.configurable)) ||
                            (i = {
                              enumerable: !0,
                              get: function () {
                                return t[n];
                              },
                            }),
                            Object.defineProperty(e, r, i));
                        }
                      : function (e, t, n, r) {
                          (r === void 0 && (r = n), (e[r] = t[n]));
                        }),
                  a =
                    (this && this.__setModuleDefault) ||
                    (Object.create
                      ? function (e, t) {
                          Object.defineProperty(e, `default`, { enumerable: !0, value: t });
                        }
                      : function (e, t) {
                          e.default = t;
                        }),
                  o =
                    (this && this.__importStar) ||
                    function (e) {
                      if (e && e.__esModule) return e;
                      var t = {};
                      if (e != null)
                        for (var n in e) n !== `default` && Object.prototype.hasOwnProperty.call(e, n) && i(t, e, n);
                      return (a(t, e), t);
                    };
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.endProfiling =
                    t.run =
                    t.releaseSession =
                    t.createSession =
                    t.createSessionFinalize =
                    t.createSessionAllocate =
                    t.initOrt =
                    t.initWasm =
                      void 0));
                let s = n(1670),
                  c = o(n(349)),
                  l = n(6361),
                  u = () => !!s.env.wasm.proxy && typeof document < `u`,
                  d,
                  f,
                  p,
                  m = !1,
                  h = !1,
                  g = !1,
                  _ = [],
                  v = [],
                  y = [],
                  b = [],
                  x = [],
                  S = [],
                  C = () => {
                    if (m || !h || g || !d) throw Error(`worker not ready`);
                  },
                  w = (e) => {
                    switch (e.data.type) {
                      case `init-wasm`:
                        ((m = !1), e.data.err ? ((g = !0), f[1](e.data.err)) : ((h = !0), f[0]()));
                        break;
                      case `init-ort`:
                        e.data.err ? p[1](e.data.err) : p[0]();
                        break;
                      case `create_allocate`:
                        e.data.err ? _.shift()[1](e.data.err) : _.shift()[0](e.data.out);
                        break;
                      case `create_finalize`:
                        e.data.err ? v.shift()[1](e.data.err) : v.shift()[0](e.data.out);
                        break;
                      case `create`:
                        e.data.err ? y.shift()[1](e.data.err) : y.shift()[0](e.data.out);
                        break;
                      case `release`:
                        e.data.err ? b.shift()[1](e.data.err) : b.shift()[0]();
                        break;
                      case `run`:
                        e.data.err ? x.shift()[1](e.data.err) : x.shift()[0](e.data.out);
                        break;
                      case `end-profiling`:
                        e.data.err ? S.shift()[1](e.data.err) : S.shift()[0]();
                    }
                  },
                  T = typeof document < `u` ? (document == null ? void 0 : document.currentScript)?.src : void 0;
                ((t.initWasm = async () => {
                  if (u()) {
                    if (h) return;
                    if (m) throw Error(`multiple calls to 'initWasm()' detected.`);
                    if (g) throw Error(`previous call to 'initWasm()' failed.`);
                    return (
                      (m = !0),
                      s.env.wasm.wasmPaths === void 0 &&
                        T &&
                        T.indexOf(`blob:`) !== 0 &&
                        (s.env.wasm.wasmPaths = T.substr(0, +T.lastIndexOf(`/`) + 1)),
                      new Promise((e, t) => {
                        (d?.terminate(), (d = n(9710).Z()), (d.onmessage = w), (f = [e, t]));
                        let r = { type: `init-wasm`, in: s.env.wasm };
                        d.postMessage(r);
                      })
                    );
                  }
                  return (0, l.initializeWebAssembly)(s.env.wasm);
                }),
                  (t.initOrt = async (e, t) => {
                    if (u())
                      return (
                        C(),
                        new Promise((n, r) => {
                          p = [n, r];
                          let i = { type: `init-ort`, in: { numThreads: e, loggingLevel: t } };
                          d.postMessage(i);
                        })
                      );
                    c.initOrt(e, t);
                  }),
                  (t.createSessionAllocate = async (e) =>
                    u()
                      ? (C(),
                        new Promise((t, n) => {
                          _.push([t, n]);
                          let r = { type: `create_allocate`, in: { model: e } };
                          d.postMessage(r, [e.buffer]);
                        }))
                      : c.createSessionAllocate(e)),
                  (t.createSessionFinalize = async (e, t) =>
                    u()
                      ? (C(),
                        new Promise((n, r) => {
                          v.push([n, r]);
                          let i = { type: `create_finalize`, in: { modeldata: e, options: t } };
                          d.postMessage(i);
                        }))
                      : c.createSessionFinalize(e, t)),
                  (t.createSession = async (e, t) =>
                    u()
                      ? (C(),
                        new Promise((n, r) => {
                          y.push([n, r]);
                          let i = { type: `create`, in: { model: e, options: t } };
                          d.postMessage(i, [e.buffer]);
                        }))
                      : c.createSession(e, t)),
                  (t.releaseSession = async (e) => {
                    if (u())
                      return (
                        C(),
                        new Promise((t, n) => {
                          b.push([t, n]);
                          let r = { type: `release`, in: e };
                          d.postMessage(r);
                        })
                      );
                    c.releaseSession(e);
                  }),
                  (t.run = async (e, t, n, r, i) =>
                    u()
                      ? (C(),
                        new Promise((a, o) => {
                          x.push([a, o]);
                          let s = {
                            type: `run`,
                            in: { sessionId: e, inputIndices: t, inputs: n, outputIndices: r, options: i },
                          };
                          d.postMessage(s, c.extractTransferableBuffers(n));
                        }))
                      : c.run(e, t, n, r, i)),
                  (t.endProfiling = async (e) => {
                    if (u())
                      return (
                        C(),
                        new Promise((t, n) => {
                          S.push([t, n]);
                          let r = { type: `end-profiling`, in: e };
                          d.postMessage(r);
                        })
                      );
                    c.endProfiling(e);
                  }));
              },
              586: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.setRunOptions = void 0));
                let r = n(7967),
                  i = n(4983),
                  a = n(6361);
                t.setRunOptions = (e) => {
                  let t = (0, a.getInstance)(),
                    n = 0,
                    o = [],
                    s = e || {};
                  try {
                    if (e?.logSeverityLevel === void 0) s.logSeverityLevel = 2;
                    else if (
                      typeof e.logSeverityLevel != `number` ||
                      !Number.isInteger(e.logSeverityLevel) ||
                      e.logSeverityLevel < 0 ||
                      e.logSeverityLevel > 4
                    )
                      throw Error(`log serverity level is not valid: ${e.logSeverityLevel}`);
                    if (e?.logVerbosityLevel === void 0) s.logVerbosityLevel = 0;
                    else if (typeof e.logVerbosityLevel != `number` || !Number.isInteger(e.logVerbosityLevel))
                      throw Error(`log verbosity level is not valid: ${e.logVerbosityLevel}`);
                    e?.terminate === void 0 && (s.terminate = !1);
                    let a = 0;
                    if (
                      (e?.tag !== void 0 && (a = (0, i.allocWasmString)(e.tag, o)),
                      (n = t._OrtCreateRunOptions(s.logSeverityLevel, s.logVerbosityLevel, !!s.terminate, a)),
                      n === 0)
                    )
                      throw Error(`Can't create run options`);
                    return (
                      e?.extra !== void 0 &&
                        (0, r.iterateExtraOptions)(e.extra, ``, new WeakSet(), (e, r) => {
                          let a = (0, i.allocWasmString)(e, o),
                            s = (0, i.allocWasmString)(r, o);
                          if (t._OrtAddRunConfigEntry(n, a, s) !== 0)
                            throw Error(`Can't set a run config entry: ${e} - ${r}`);
                        }),
                      [n, o]
                    );
                  } catch (e) {
                    throw (n !== 0 && t._OrtReleaseRunOptions(n), o.forEach(t._free), e);
                  }
                };
              },
              2306: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.OnnxruntimeWebAssemblySessionHandler = void 0));
                let r = n(2806),
                  i = n(1670),
                  a = n(2850),
                  o = n(2157),
                  s;
                t.OnnxruntimeWebAssemblySessionHandler = class {
                  async createSessionAllocate(e) {
                    let t = await (await fetch(e)).arrayBuffer();
                    return (0, o.createSessionAllocate)(new Uint8Array(t));
                  }
                  async loadModel(e, t) {
                    if (
                      ((s ||=
                        (await (0, o.initOrt)(
                          i.env.wasm.numThreads,
                          ((e) => {
                            switch (e) {
                              case `verbose`:
                                return 0;
                              case `info`:
                                return 1;
                              case `warning`:
                                return 2;
                              case `error`:
                                return 3;
                              case `fatal`:
                                return 4;
                              default:
                                throw Error(`unsupported logging level: ${e}`);
                            }
                          })(i.env.logLevel),
                        ),
                        !0)),
                      typeof e == `string`)
                    )
                      if (typeof fetch > `u`) {
                        let n = await (0, a.promisify)(r.readFile)(e);
                        [this.sessionId, this.inputNames, this.outputNames] = await (0, o.createSession)(n, t);
                      } else {
                        let n = await this.createSessionAllocate(e);
                        [this.sessionId, this.inputNames, this.outputNames] = await (0, o.createSessionFinalize)(n, t);
                      }
                    else [this.sessionId, this.inputNames, this.outputNames] = await (0, o.createSession)(e, t);
                  }
                  async dispose() {
                    return (0, o.releaseSession)(this.sessionId);
                  }
                  async run(e, t, n) {
                    let r = [],
                      a = [];
                    Object.entries(e).forEach((e) => {
                      let t = e[0],
                        n = e[1],
                        i = this.inputNames.indexOf(t);
                      if (i === -1) throw Error(`invalid input '${t}'`);
                      (r.push(n), a.push(i));
                    });
                    let s = [];
                    Object.entries(t).forEach((e) => {
                      let t = e[0],
                        n = this.outputNames.indexOf(t);
                      if (n === -1) throw Error(`invalid output '${t}'`);
                      s.push(n);
                    });
                    let c = await (0, o.run)(
                        this.sessionId,
                        a,
                        r.map((e) => [e.type, e.dims, e.data]),
                        s,
                        n,
                      ),
                      l = {};
                    for (let e = 0; e < c.length; e++)
                      l[this.outputNames[s[e]]] = new i.Tensor(c[e][0], c[e][2], c[e][1]);
                    return l;
                  }
                  startProfiling() {}
                  endProfiling() {
                    (0, o.endProfiling)(this.sessionId);
                  }
                };
              },
              4919: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.setSessionOptions = void 0));
                let r = n(7967),
                  i = n(4983),
                  a = n(6361);
                t.setSessionOptions = (e) => {
                  let t = (0, a.getInstance)(),
                    n = 0,
                    o = [],
                    s = e || {};
                  ((e) => {
                    ((e.extra ||= {}), e.extra.session || (e.extra.session = {}));
                    let t = e.extra.session;
                    t.use_ort_model_bytes_directly ||= `1`;
                  })(s);
                  try {
                    e?.graphOptimizationLevel === void 0 && (s.graphOptimizationLevel = `all`);
                    let c = ((e) => {
                      switch (e) {
                        case `disabled`:
                          return 0;
                        case `basic`:
                          return 1;
                        case `extended`:
                          return 2;
                        case `all`:
                          return 99;
                        default:
                          throw Error(`unsupported graph optimization level: ${e}`);
                      }
                    })(s.graphOptimizationLevel);
                    (e?.enableCpuMemArena === void 0 && (s.enableCpuMemArena = !0),
                      e?.enableMemPattern === void 0 && (s.enableMemPattern = !0),
                      e?.executionMode === void 0 && (s.executionMode = `sequential`));
                    let l = ((e) => {
                        switch (e) {
                          case `sequential`:
                            return 0;
                          case `parallel`:
                            return 1;
                          default:
                            throw Error(`unsupported execution mode: ${e}`);
                        }
                      })(s.executionMode),
                      u = 0;
                    if (
                      (e?.logId !== void 0 && (u = (0, i.allocWasmString)(e.logId, o)), e?.logSeverityLevel === void 0)
                    )
                      s.logSeverityLevel = 2;
                    else if (
                      typeof e.logSeverityLevel != `number` ||
                      !Number.isInteger(e.logSeverityLevel) ||
                      e.logSeverityLevel < 0 ||
                      e.logSeverityLevel > 4
                    )
                      throw Error(`log serverity level is not valid: ${e.logSeverityLevel}`);
                    if (e?.logVerbosityLevel === void 0) s.logVerbosityLevel = 0;
                    else if (typeof e.logVerbosityLevel != `number` || !Number.isInteger(e.logVerbosityLevel))
                      throw Error(`log verbosity level is not valid: ${e.logVerbosityLevel}`);
                    if (
                      (e?.enableProfiling === void 0 && (s.enableProfiling = !1),
                      (n = t._OrtCreateSessionOptions(
                        c,
                        !!s.enableCpuMemArena,
                        !!s.enableMemPattern,
                        l,
                        !!s.enableProfiling,
                        0,
                        u,
                        s.logSeverityLevel,
                        s.logVerbosityLevel,
                      )),
                      n === 0)
                    )
                      throw Error(`Can't create session options`);
                    return (
                      e != null &&
                        e.executionProviders &&
                        ((e, t, n) => {
                          for (let r of t) {
                            let t = typeof r == `string` ? r : r.name;
                            switch (t) {
                              case `xnnpack`:
                                t = `XNNPACK`;
                                break;
                              case `wasm`:
                              case `cpu`:
                                continue;
                              default:
                                throw Error(`not supported EP: ${t}`);
                            }
                            let o = (0, i.allocWasmString)(t, n);
                            if ((0, a.getInstance)()._OrtAppendExecutionProvider(e, o) !== 0)
                              throw Error(`Can't append execution provider: ${t}`);
                          }
                        })(n, e.executionProviders, o),
                      e?.extra !== void 0 &&
                        (0, r.iterateExtraOptions)(e.extra, ``, new WeakSet(), (e, r) => {
                          let a = (0, i.allocWasmString)(e, o),
                            s = (0, i.allocWasmString)(r, o);
                          if (t._OrtAddSessionConfigEntry(n, a, s) !== 0)
                            throw Error(`Can't set a session config entry: ${e} - ${r}`);
                        }),
                      [n, o]
                    );
                  } catch (e) {
                    throw (n !== 0 && t._OrtReleaseSessionOptions(n), o.forEach(t._free), e);
                  }
                };
              },
              4983: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }), (t.allocWasmString = void 0));
                let r = n(6361);
                t.allocWasmString = (e, t) => {
                  let n = (0, r.getInstance)(),
                    i = n.lengthBytesUTF8(e) + 1,
                    a = n._malloc(i);
                  return (n.stringToUTF8(e, a, i), t.push(a), a);
                };
              },
              349: (e, t, n) => {
                'use strict';
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.extractTransferableBuffers =
                    t.endProfiling =
                    t.run =
                    t.releaseSession =
                    t.createSession =
                    t.createSessionFinalize =
                    t.createSessionAllocate =
                    t.initOrt =
                      void 0));
                let r = n(586),
                  i = n(4919),
                  a = n(4983),
                  o = n(6361);
                t.initOrt = (e, t) => {
                  let n = (0, o.getInstance)()._OrtInit(e, t);
                  if (n !== 0) throw Error(`Can't initialize onnxruntime. error code = ${n}`);
                };
                let s = new Map();
                ((t.createSessionAllocate = (e) => {
                  let t = (0, o.getInstance)(),
                    n = t._malloc(e.byteLength);
                  return (t.HEAPU8.set(e, n), [n, e.byteLength]);
                }),
                  (t.createSessionFinalize = (e, t) => {
                    let n = (0, o.getInstance)(),
                      r = 0,
                      a = 0,
                      c = [];
                    try {
                      if ((([a, c] = (0, i.setSessionOptions)(t)), (r = n._OrtCreateSession(e[0], e[1], a)), r === 0))
                        throw Error(`Can't create a session`);
                    } finally {
                      (n._free(e[0]), n._OrtReleaseSessionOptions(a), c.forEach(n._free));
                    }
                    let l = n._OrtGetInputCount(r),
                      u = n._OrtGetOutputCount(r),
                      d = [],
                      f = [],
                      p = [],
                      m = [];
                    for (let e = 0; e < l; e++) {
                      let t = n._OrtGetInputName(r, e);
                      if (t === 0) throw Error(`Can't get an input name`);
                      (f.push(t), d.push(n.UTF8ToString(t)));
                    }
                    for (let e = 0; e < u; e++) {
                      let t = n._OrtGetOutputName(r, e);
                      if (t === 0) throw Error(`Can't get an output name`);
                      (m.push(t), p.push(n.UTF8ToString(t)));
                    }
                    return (s.set(r, [r, f, m]), [r, d, p]);
                  }),
                  (t.createSession = (e, n) => {
                    let r = (0, t.createSessionAllocate)(e);
                    return (0, t.createSessionFinalize)(r, n);
                  }),
                  (t.releaseSession = (e) => {
                    let t = (0, o.getInstance)(),
                      n = s.get(e);
                    if (!n) throw Error(`invalid session id`);
                    let r = n[0],
                      i = n[1],
                      a = n[2];
                    (i.forEach(t._OrtFree), a.forEach(t._OrtFree), t._OrtReleaseSession(r), s.delete(e));
                  }));
                let c = (e) => {
                    switch (e) {
                      case `int8`:
                        return 3;
                      case `uint8`:
                        return 2;
                      case `bool`:
                        return 9;
                      case `int16`:
                        return 5;
                      case `uint16`:
                        return 4;
                      case `int32`:
                        return 6;
                      case `uint32`:
                        return 12;
                      case `float32`:
                        return 1;
                      case `float64`:
                        return 11;
                      case `string`:
                        return 8;
                      case `int64`:
                        return 7;
                      case `uint64`:
                        return 13;
                      default:
                        throw Error(`unsupported data type: ${e}`);
                    }
                  },
                  l = (e) => {
                    switch (e) {
                      case 3:
                        return `int8`;
                      case 2:
                        return `uint8`;
                      case 9:
                        return `bool`;
                      case 5:
                        return `int16`;
                      case 4:
                        return `uint16`;
                      case 6:
                        return `int32`;
                      case 12:
                        return `uint32`;
                      case 1:
                        return `float32`;
                      case 11:
                        return `float64`;
                      case 8:
                        return `string`;
                      case 7:
                        return `int64`;
                      case 13:
                        return `uint64`;
                      default:
                        throw Error(`unsupported data type: ${e}`);
                    }
                  },
                  u = (e) => {
                    switch (e) {
                      case `float32`:
                        return Float32Array;
                      case `uint8`:
                      case `bool`:
                        return Uint8Array;
                      case `int8`:
                        return Int8Array;
                      case `uint16`:
                        return Uint16Array;
                      case `int16`:
                        return Int16Array;
                      case `int32`:
                        return Int32Array;
                      case `float64`:
                        return Float64Array;
                      case `uint32`:
                        return Uint32Array;
                      case `int64`:
                        return BigInt64Array;
                      case `uint64`:
                        return BigUint64Array;
                      default:
                        throw Error(`unsupported type: ${e}`);
                    }
                  };
                ((t.run = (e, t, n, i, d) => {
                  let f = (0, o.getInstance)(),
                    p = s.get(e);
                  if (!p) throw Error(`invalid session id`);
                  let m = p[0],
                    h = p[1],
                    g = p[2],
                    _ = t.length,
                    v = i.length,
                    y = 0,
                    b = [],
                    x = [],
                    S = [];
                  try {
                    [y, b] = (0, r.setRunOptions)(d);
                    for (let e = 0; e < _; e++) {
                      let t = n[e][0],
                        r = n[e][1],
                        i = n[e][2],
                        o,
                        s;
                      if (Array.isArray(i)) {
                        ((s = 4 * i.length), (o = f._malloc(s)), S.push(o));
                        let e = o / 4;
                        for (let t = 0; t < i.length; t++) {
                          if (typeof i[t] != `string`) throw TypeError(`tensor data at index ${t} is not a string`);
                          f.HEAPU32[e++] = (0, a.allocWasmString)(i[t], S);
                        }
                      } else
                        ((s = i.byteLength),
                          (o = f._malloc(s)),
                          S.push(o),
                          f.HEAPU8.set(new Uint8Array(i.buffer, i.byteOffset, s), o));
                      let l = f.stackSave(),
                        u = f.stackAlloc(4 * r.length);
                      try {
                        let e = u / 4;
                        r.forEach((t) => (f.HEAP32[e++] = t));
                        let n = f._OrtCreateTensor(c(t), o, s, u, r.length);
                        if (n === 0) throw Error(`Can't create a tensor`);
                        x.push(n);
                      } finally {
                        f.stackRestore(l);
                      }
                    }
                    let e = f.stackSave(),
                      o = f.stackAlloc(4 * _),
                      s = f.stackAlloc(4 * _),
                      p = f.stackAlloc(4 * v),
                      C = f.stackAlloc(4 * v);
                    try {
                      let e = o / 4,
                        n = s / 4,
                        r = p / 4,
                        a = C / 4;
                      for (let r = 0; r < _; r++) ((f.HEAPU32[e++] = x[r]), (f.HEAPU32[n++] = h[t[r]]));
                      for (let e = 0; e < v; e++) ((f.HEAPU32[r++] = 0), (f.HEAPU32[a++] = g[i[e]]));
                      let c = f._OrtRun(m, s, o, _, C, v, p, y),
                        d = [];
                      if (c === 0)
                        for (let e = 0; e < v; e++) {
                          let t = f.HEAPU32[p / 4 + e],
                            n = f.stackSave(),
                            r = f.stackAlloc(16),
                            i,
                            a = 0;
                          try {
                            if (((c = f._OrtGetTensorData(t, r, r + 4, r + 8, r + 12)), c !== 0))
                              throw Error(`Can't access output tensor data. error code = ${c}`);
                            let e = r / 4,
                              n = f.HEAPU32[e++];
                            a = f.HEAPU32[e++];
                            let o = f.HEAPU32[e++],
                              s = f.HEAPU32[e++],
                              p = [];
                            for (let e = 0; e < s; e++) p.push(f.HEAPU32[o / 4 + e]);
                            f._OrtFree(o);
                            let m = p.length === 0 ? 1 : p.reduce((e, t) => e * t);
                            if (((i = l(n)), i === `string`)) {
                              let e = [],
                                t = a / 4;
                              for (let n = 0; n < m; n++) {
                                let r = f.HEAPU32[t++],
                                  i = n === m - 1 ? void 0 : f.HEAPU32[t] - r;
                                e.push(f.UTF8ToString(r, i));
                              }
                              d.push([i, p, e]);
                            } else {
                              let e = new (u(i))(m);
                              (new Uint8Array(e.buffer, e.byteOffset, e.byteLength).set(
                                f.HEAPU8.subarray(a, a + e.byteLength),
                              ),
                                d.push([i, p, e]));
                            }
                          } finally {
                            (f.stackRestore(n), i === `string` && a && f._free(a), f._OrtReleaseTensor(t));
                          }
                        }
                      if (c === 0) return d;
                      throw Error(`failed to call OrtRun(). error code = ${c}.`);
                    } finally {
                      f.stackRestore(e);
                    }
                  } finally {
                    (x.forEach(f._OrtReleaseTensor),
                      S.forEach(f._free),
                      f._OrtReleaseRunOptions(y),
                      b.forEach(f._free));
                  }
                }),
                  (t.endProfiling = (e) => {
                    let t = (0, o.getInstance)(),
                      n = s.get(e);
                    if (!n) throw Error(`invalid session id`);
                    let r = n[0],
                      i = t._OrtEndProfiling(r);
                    if (i === 0) throw Error(`Can't get an profile file name`);
                    t._OrtFree(i);
                  }),
                  (t.extractTransferableBuffers = (e) => {
                    let t = [];
                    for (let n of e) {
                      let e = n[2];
                      !Array.isArray(e) && e.buffer && t.push(e.buffer);
                    }
                    return t;
                  }));
              },
              6361: function (e, t, n) {
                'use strict';
                var r =
                    (this && this.__createBinding) ||
                    (Object.create
                      ? function (e, t, n, r) {
                          r === void 0 && (r = n);
                          var i = Object.getOwnPropertyDescriptor(t, n);
                          ((i && !(`get` in i ? !t.__esModule : i.writable || i.configurable)) ||
                            (i = {
                              enumerable: !0,
                              get: function () {
                                return t[n];
                              },
                            }),
                            Object.defineProperty(e, r, i));
                        }
                      : function (e, t, n, r) {
                          (r === void 0 && (r = n), (e[r] = t[n]));
                        }),
                  i =
                    (this && this.__setModuleDefault) ||
                    (Object.create
                      ? function (e, t) {
                          Object.defineProperty(e, `default`, { enumerable: !0, value: t });
                        }
                      : function (e, t) {
                          e.default = t;
                        }),
                  a =
                    (this && this.__importStar) ||
                    function (e) {
                      if (e && e.__esModule) return e;
                      var t = {};
                      if (e != null)
                        for (var n in e) n !== `default` && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
                      return (i(t, e), t);
                    },
                  o =
                    (this && this.__importDefault) ||
                    function (e) {
                      return e && e.__esModule ? e : { default: e };
                    };
                (Object.defineProperty(t, `__esModule`, { value: !0 }),
                  (t.dispose = t.getInstance = t.initializeWebAssembly = void 0));
                let s = a(n(6449)),
                  c = o(n(932)),
                  l = n(3474),
                  u,
                  d = !1,
                  f = !1,
                  p = !1,
                  m = (e, t) =>
                    t
                      ? e
                        ? `ort-wasm-simd-threaded.wasm`
                        : `ort-wasm-threaded.wasm`
                      : e
                        ? `ort-wasm-simd.wasm`
                        : `ort-wasm.wasm`;
                ((t.initializeWebAssembly = async (e) => {
                  if (d) return Promise.resolve();
                  if (f) throw Error(`multiple calls to 'initializeWebAssembly()' detected.`);
                  if (p) throw Error(`previous call to 'initializeWebAssembly()' failed.`);
                  f = !0;
                  let t = e.initTimeout,
                    r = e.numThreads,
                    i = e.simd,
                    a =
                      r > 1 &&
                      (() => {
                        try {
                          return (
                            typeof SharedArrayBuffer < `u` &&
                            (typeof MessageChannel < `u` &&
                              new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)),
                            WebAssembly.validate(
                              new Uint8Array([
                                0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 5, 4, 1, 3, 1, 1, 10, 11, 1,
                                9, 0, 65, 0, 254, 16, 2, 0, 26, 11,
                              ]),
                            ))
                          );
                        } catch {
                          return !1;
                        }
                      })(),
                    o =
                      i &&
                      (() => {
                        try {
                          return WebAssembly.validate(
                            new Uint8Array([
                              0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 30, 1, 28, 0, 65, 0, 253,
                              15, 253, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 253, 186, 1, 26, 11,
                            ]),
                          );
                        } catch {
                          return !1;
                        }
                      })(),
                    h = typeof e.wasmPaths == `string` ? e.wasmPaths : void 0,
                    g = m(!1, a),
                    _ = m(o, a),
                    v = typeof e.wasmPaths == `object` ? e.wasmPaths[_] : void 0,
                    y = !1,
                    b = [];
                  if (
                    (t > 0 &&
                      b.push(
                        new Promise((e) => {
                          setTimeout(() => {
                            ((y = !0), e());
                          }, t);
                        }),
                      ),
                    b.push(
                      new Promise((e, t) => {
                        let r = a ? l : c.default,
                          i = {
                            locateFile: (e, t) =>
                              a && e.endsWith(`.worker.js`) && typeof Blob < `u`
                                ? URL.createObjectURL(new Blob([n(4154)], { type: `text/javascript` }))
                                : e === g
                                  ? (v ?? (h ?? t) + _)
                                  : t + e,
                          };
                        if (a)
                          if (typeof Blob > `u`) i.mainScriptUrlOrBlob = s.join(`/`, `ort-wasm-threaded.js`);
                          else {
                            let e = `var ortWasmThreaded=(function(){var _scriptDir;return ${r.toString()}})();`;
                            i.mainScriptUrlOrBlob = new Blob([e], { type: `text/javascript` });
                          }
                        r(i).then(
                          (t) => {
                            ((f = !1), (d = !0), (u = t), e());
                          },
                          (e) => {
                            ((f = !1), (p = !0), t(e));
                          },
                        );
                      }),
                    ),
                    await Promise.race(b),
                    y)
                  )
                    throw Error(`WebAssembly backend initializing failed due to timeout: ${t}ms`);
                }),
                  (t.getInstance = () => {
                    if (d && u) return u;
                    throw Error(`WebAssembly is not initialized yet.`);
                  }),
                  (t.dispose = () => {
                    var e;
                    !d ||
                      f ||
                      p ||
                      ((f = !0),
                      (e = u.PThread) == null || e.terminateAllThreads(),
                      (u = void 0),
                      (f = !1),
                      (d = !1),
                      (p = !0));
                  }));
              },
              9710: (e, t, n) => {
                'use strict';
                n.d(t, { Z: () => a });
                var r = n(477),
                  i = n.n(r);
                function a() {
                  return i()(
                    '/*!\n* ONNX Runtime Web v1.14.0\n* Copyright (c) Microsoft Corporation. All rights reserved.\n* Licensed under the MIT License.\n*/\n(()=>{var t={474:(t,e,n)=>{var _scriptDir,r=(_scriptDir=(_scriptDir="undefined"!=typeof document&&document.currentScript?document.currentScript.src:void 0)||"/index.js",function(t){function e(){return j.buffer!=D&&N(j.buffer),P}function r(){return j.buffer!=D&&N(j.buffer),U}function a(){return j.buffer!=D&&N(j.buffer),F}function i(){return j.buffer!=D&&N(j.buffer),I}function o(){return j.buffer!=D&&N(j.buffer),W}var u,c,s;t=t||{},u||(u=void 0!==t?t:{}),u.ready=new Promise((function(t,e){c=t,s=e}));var l,f,p,h,d,y,b=Object.assign({},u),m="./this.program",g=(t,e)=>{throw e},v="object"==typeof window,w="function"==typeof importScripts,_="object"==typeof process&&"object"==typeof process.versions&&"string"==typeof process.versions.node,O=u.ENVIRONMENT_IS_PTHREAD||!1,A="";function S(t){return u.locateFile?u.locateFile(t,A):A+t}if(_){let e;A=w?n(908).dirname(A)+"/":"//",y=()=>{d||(h=n(384),d=n(908))},l=function(t,e){return y(),t=d.normalize(t),h.readFileSync(t,e?void 0:"utf8")},p=t=>((t=l(t,!0)).buffer||(t=new Uint8Array(t)),t),f=(t,e,n)=>{y(),t=d.normalize(t),h.readFile(t,(function(t,r){t?n(t):e(r.buffer)}))},1<process.argv.length&&(m=process.argv[1].replace(/\\\\/g,"/")),process.argv.slice(2),process.on("uncaughtException",(function(t){if(!(t instanceof ct))throw t})),process.on("unhandledRejection",(function(t){throw t})),g=(t,e)=>{if(Q())throw process.exitCode=t,e;e instanceof ct||x("exiting due to exception: "+e),process.exit(t)},u.inspect=function(){return"[Emscripten Module object]"};try{e=n(925)}catch(t){throw console.error(\'The "worker_threads" module is not supported in this node.js build - perhaps a newer version is needed?\'),t}n.g.Worker=e.Worker}else(v||w)&&(w?A=self.location.href:"undefined"!=typeof document&&document.currentScript&&(A=document.currentScript.src),_scriptDir&&(A=_scriptDir),A=0!==A.indexOf("blob:")?A.substr(0,A.replace(/[?#].*/,"").lastIndexOf("/")+1):"",_||(l=t=>{var e=new XMLHttpRequest;return e.open("GET",t,!1),e.send(null),e.responseText},w&&(p=t=>{var e=new XMLHttpRequest;return e.open("GET",t,!1),e.responseType="arraybuffer",e.send(null),new Uint8Array(e.response)}),f=(t,e,n)=>{var r=new XMLHttpRequest;r.open("GET",t,!0),r.responseType="arraybuffer",r.onload=()=>{200==r.status||0==r.status&&r.response?e(r.response):n()},r.onerror=n,r.send(null)}));_&&"undefined"==typeof performance&&(n.g.performance=n(953).performance);var T=console.log.bind(console),E=console.warn.bind(console);_&&(y(),T=t=>h.writeSync(1,t+"\\n"),E=t=>h.writeSync(2,t+"\\n"));var M,C=u.print||T,x=u.printErr||E;Object.assign(u,b),b=null,u.thisProgram&&(m=u.thisProgram),u.quit&&(g=u.quit),u.wasmBinary&&(M=u.wasmBinary);var R=u.noExitRuntime||!1;"object"!=typeof WebAssembly&&at("no native wasm support detected");var j,k,D,P,U,F,I,W,H=!1,L="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0;function z(t,e,n){var r=(e>>>=0)+n;for(n=e;t[n]&&!(n>=r);)++n;if(16<n-e&&t.buffer&&L)return L.decode(t.buffer instanceof SharedArrayBuffer?t.slice(e,n):t.subarray(e,n));for(r="";e<n;){var a=t[e++];if(128&a){var i=63&t[e++];if(192==(224&a))r+=String.fromCharCode((31&a)<<6|i);else{var o=63&t[e++];65536>(a=224==(240&a)?(15&a)<<12|i<<6|o:(7&a)<<18|i<<12|o<<6|63&t[e++])?r+=String.fromCharCode(a):(a-=65536,r+=String.fromCharCode(55296|a>>10,56320|1023&a))}}else r+=String.fromCharCode(a)}return r}function Y(t,e){return(t>>>=0)?z(r(),t,e):""}function B(t,e,n,r){if(!(0<r))return 0;var a=n>>>=0;r=n+r-1;for(var i=0;i<t.length;++i){var o=t.charCodeAt(i);if(55296<=o&&57343>=o&&(o=65536+((1023&o)<<10)|1023&t.charCodeAt(++i)),127>=o){if(n>=r)break;e[n++>>>0]=o}else{if(2047>=o){if(n+1>=r)break;e[n++>>>0]=192|o>>6}else{if(65535>=o){if(n+2>=r)break;e[n++>>>0]=224|o>>12}else{if(n+3>=r)break;e[n++>>>0]=240|o>>18,e[n++>>>0]=128|o>>12&63}e[n++>>>0]=128|o>>6&63}e[n++>>>0]=128|63&o}}return e[n>>>0]=0,n-a}function G(t){for(var e=0,n=0;n<t.length;++n){var r=t.charCodeAt(n);127>=r?e++:2047>=r?e+=2:55296<=r&&57343>=r?(e+=4,++n):e+=3}return e}function N(t){D=t,u.HEAP8=P=new Int8Array(t),u.HEAP16=new Int16Array(t),u.HEAP32=F=new Int32Array(t),u.HEAPU8=U=new Uint8Array(t),u.HEAPU16=new Uint16Array(t),u.HEAPU32=I=new Uint32Array(t),u.HEAPF32=new Float32Array(t),u.HEAPF64=W=new Float64Array(t)}O&&(D=u.buffer);var V=u.INITIAL_MEMORY||16777216;if(O)j=u.wasmMemory,D=u.buffer;else if(u.wasmMemory)j=u.wasmMemory;else if(!((j=new WebAssembly.Memory({initial:V/65536,maximum:65536,shared:!0})).buffer instanceof SharedArrayBuffer))throw x("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag"),_&&console.log("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and also use a recent version)"),Error("bad memory");j&&(D=j.buffer),V=D.byteLength,N(D);var $,q=[],X=[],J=[],Z=[];function Q(){return R||!1}function K(){var t=u.preRun.shift();q.unshift(t)}var tt,et=0,nt=null,rt=null;function at(t){throw O?postMessage({cmd:"onAbort",arg:t}):u.onAbort&&u.onAbort(t),x(t="Aborted("+t+")"),H=!0,t=new WebAssembly.RuntimeError(t+". Build with -sASSERTIONS for more info."),s(t),t}function it(){return tt.startsWith("data:application/octet-stream;base64,")}function ot(){var t=tt;try{if(t==tt&&M)return new Uint8Array(M);if(p)return p(t);throw"both async and sync fetching of the wasm failed"}catch(t){at(t)}}tt="ort-wasm-threaded.wasm",it()||(tt=S(tt));var ut={};function ct(t){this.name="ExitStatus",this.message="Program terminated with exit("+t+")",this.status=t}function st(t){(t=ht.Vb[t])||at(),ht.mc(t)}function lt(t){var e=ht.Cc();if(!e)return 6;ht.ac.push(e),ht.Vb[t.Ub]=e,e.Ub=t.Ub;var n={cmd:"run",start_routine:t.Ic,arg:t.zc,pthread_ptr:t.Ub};return e.$b=()=>{n.time=performance.now(),e.postMessage(n,t.Nc)},e.loaded&&(e.$b(),delete e.$b),0}function ft(t){if(O)return $t(1,1,t);Q()||(ht.oc(),u.onExit&&u.onExit(t),H=!0),g(t,new ct(t))}function pt(t,e){if(!e&&O)throw bt(t),"unwind";Q()||O||(me(),dt(J),be(0),re[1].length&&ae(1,10),re[2].length&&ae(2,10),ht.oc()),ft(t)}var ht={Yb:[],ac:[],qc:[],Vb:{},fc:function(){O&&ht.Ec()},Pc:function(){},Ec:function(){ht.receiveObjectTransfer=ht.Gc,ht.threadInitTLS=ht.pc,ht.setExitStatus=ht.nc,R=!1},nc:function(){},oc:function(){for(var t of Object.values(ht.Vb))ht.mc(t);for(t of ht.Yb)t.terminate();ht.Yb=[]},mc:function(t){var e=t.Ub;delete ht.Vb[e],ht.Yb.push(t),ht.ac.splice(ht.ac.indexOf(t),1),t.Ub=0,Oe(e)},Gc:function(){},pc:function(){ht.qc.forEach((t=>t()))},Fc:function(t,e){t.onmessage=n=>{var r=(n=n.data).cmd;if(t.Ub&&(ht.Bc=t.Ub),n.targetThread&&n.targetThread!=he()){var a=ht.Vb[n.Qc];a?a.postMessage(n,n.transferList):x(\'Internal error! Worker sent a message "\'+r+\'" to target pthread \'+n.targetThread+", but that thread no longer exists!")}else"processProxyingQueue"===r?zt(n.queue):"spawnThread"===r?lt(n):"cleanupThread"===r?st(n.thread):"killThread"===r?(n=n.thread,r=ht.Vb[n],delete ht.Vb[n],r.terminate(),Oe(n),ht.ac.splice(ht.ac.indexOf(r),1),r.Ub=0):"cancelThread"===r?ht.Vb[n.thread].postMessage({cmd:"cancel"}):"loaded"===r?(t.loaded=!0,e&&e(t),t.$b&&(t.$b(),delete t.$b)):"print"===r?C("Thread "+n.threadId+": "+n.text):"printErr"===r?x("Thread "+n.threadId+": "+n.text):"alert"===r?alert("Thread "+n.threadId+": "+n.text):"setimmediate"===n.target?t.postMessage(n):"onAbort"===r?u.onAbort&&u.onAbort(n.arg):r&&x("worker sent an unknown command "+r);ht.Bc=void 0},t.onerror=t=>{throw x("worker sent an error! "+t.filename+":"+t.lineno+": "+t.message),t},_&&(t.on("message",(function(e){t.onmessage({data:e})})),t.on("error",(function(e){t.onerror(e)})),t.on("detachedExit",(function(){}))),t.postMessage({cmd:"load",urlOrBlob:u.mainScriptUrlOrBlob||_scriptDir,wasmMemory:j,wasmModule:k})},yc:function(){var t=S("ort-wasm-threaded.worker.js");ht.Yb.push(new Worker(t))},Cc:function(){return 0==ht.Yb.length&&(ht.yc(),ht.Fc(ht.Yb[0])),ht.Yb.pop()}};function dt(t){for(;0<t.length;)t.shift()(u)}function yt(t){var e=Ee();return t=t(),Me(e),t}function bt(t){if(O)return $t(2,0,t);try{pt(t)}catch(t){t instanceof ct||"unwind"==t||g(1,t)}}u.PThread=ht,u.establishStackSpace=function(){var t=he(),e=a()[t+44>>2>>>0];t=a()[t+48>>2>>>0],Te(e,e-t),Me(e)};var mt=[];function gt(t){var e=mt[t];return e||(t>=mt.length&&(mt.length=t+1),mt[t]=e=$.get(t)),e}u.invokeEntryPoint=function(t,e){t=gt(t)(e),Q()?ht.nc(t):Ae(t)};var vt,wt,_t=[],Ot=0,At=0;function St(t){this.Zb=t,this.Sb=t-24,this.xc=function(t){i()[this.Sb+4>>2>>>0]=t},this.bc=function(){return i()[this.Sb+4>>2>>>0]},this.wc=function(t){i()[this.Sb+8>>2>>>0]=t},this.Dc=function(){return i()[this.Sb+8>>2>>>0]},this.rc=function(){a()[this.Sb>>2>>>0]=0},this.hc=function(t){t=t?1:0,e()[this.Sb+12>>0>>>0]=t},this.uc=function(){return 0!=e()[this.Sb+12>>0>>>0]},this.ic=function(t){t=t?1:0,e()[this.Sb+13>>0>>>0]=t},this.kc=function(){return 0!=e()[this.Sb+13>>0>>>0]},this.fc=function(t,e){this.cc(0),this.xc(t),this.wc(e),this.rc(),this.hc(!1),this.ic(!1)},this.sc=function(){Atomics.add(a(),this.Sb>>2,1)},this.Hc=function(){return 1===Atomics.sub(a(),this.Sb>>2,1)},this.cc=function(t){i()[this.Sb+16>>2>>>0]=t},this.tc=function(){return i()[this.Sb+16>>2>>>0]},this.vc=function(){if(Re(this.bc()))return i()[this.Zb>>2>>>0];var t=this.tc();return 0!==t?t:this.Zb}}function Tt(t){return ye(new St(t).Sb)}function Et(t,e,n,r){return O?$t(3,1,t,e,n,r):Mt(t,e,n,r)}function Mt(t,e,n,r){if("undefined"==typeof SharedArrayBuffer)return x("Current environment does not support SharedArrayBuffer, pthreads are not available!"),6;var a=[];return O&&0===a.length?Et(t,e,n,r):(t={Ic:n,Ub:t,zc:r,Nc:a},O?(t.Oc="spawnThread",postMessage(t,a),0):lt(t))}function Ct(t,e,n){return O?$t(4,1,t,e,n):0}function xt(t,e){if(O)return $t(5,1,t,e)}function Rt(t,e){if(O)return $t(6,1,t,e)}function jt(t,e,n){if(O)return $t(7,1,t,e,n)}function kt(t,e,n){return O?$t(8,1,t,e,n):0}function Dt(t,e){if(O)return $t(9,1,t,e)}function Pt(t,e,n){if(O)return $t(10,1,t,e,n)}function Ut(t,e,n,r){if(O)return $t(11,1,t,e,n,r)}function Ft(t,e,n,r){if(O)return $t(12,1,t,e,n,r)}function It(t,e,n,r){if(O)return $t(13,1,t,e,n,r)}function Wt(t){if(O)return $t(14,1,t)}function Ht(t,e){if(O)return $t(15,1,t,e)}function Lt(t,e,n){if(O)return $t(16,1,t,e,n)}function zt(t){Atomics.store(a(),t>>2,1),he()&&_e(t),Atomics.compareExchange(a(),t>>2,1,0)}function Yt(t){return i()[t>>>2]+4294967296*a()[t+4>>>2]}function Bt(t,e,n,r,a,i){return O?$t(17,1,t,e,n,r,a,i):-52}function Gt(t,e,n,r,a,i){if(O)return $t(18,1,t,e,n,r,a,i)}function Nt(t){var n=G(t)+1,r=de(n);return r&&B(t,e(),r,n),r}function Vt(t,e,n){function r(t){return(t=t.toTimeString().match(/\\(([A-Za-z ]+)\\)$/))?t[1]:"GMT"}if(O)return $t(19,1,t,e,n);var o=(new Date).getFullYear(),u=new Date(o,0,1),c=new Date(o,6,1);o=u.getTimezoneOffset();var s=c.getTimezoneOffset(),l=Math.max(o,s);a()[t>>2>>>0]=60*l,a()[e>>2>>>0]=Number(o!=s),t=r(u),e=r(c),t=Nt(t),e=Nt(e),s<o?(i()[n>>2>>>0]=t,i()[n+4>>2>>>0]=e):(i()[n>>2>>>0]=e,i()[n+4>>2>>>0]=t)}function $t(t,e){var n=arguments.length-2,r=arguments;return yt((()=>{for(var a=Ce(8*n),i=a>>3,u=0;u<n;u++){var c=r[2+u];o()[i+u>>>0]=c}return we(t,n,a,e)}))}u.executeNotifiedProxyingQueue=zt,wt=_?()=>{var t=process.hrtime();return 1e3*t[0]+t[1]/1e6}:O?()=>performance.now()-u.__performance_now_clock_drift:()=>performance.now();var qt,Xt=[],Jt={};function Zt(){if(!qt){var t,e={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:("object"==typeof navigator&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",_:m||"./this.program"};for(t in Jt)void 0===Jt[t]?delete e[t]:e[t]=Jt[t];var n=[];for(t in e)n.push(t+"="+e[t]);qt=n}return qt}function Qt(t,n){if(O)return $t(20,1,t,n);var r=0;return Zt().forEach((function(a,o){var u=n+r;for(o=i()[t+4*o>>2>>>0]=u,u=0;u<a.length;++u)e()[o++>>0>>>0]=a.charCodeAt(u);e()[o>>0>>>0]=0,r+=a.length+1})),0}function Kt(t,e){if(O)return $t(21,1,t,e);var n=Zt();i()[t>>2>>>0]=n.length;var r=0;return n.forEach((function(t){r+=t.length+1})),i()[e>>2>>>0]=r,0}function te(t){return O?$t(22,1,t):52}function ee(t,e,n,r){return O?$t(23,1,t,e,n,r):52}function ne(t,e,n,r,a){return O?$t(24,1,t,e,n,r,a):70}var re=[null,[],[]];function ae(t,e){var n=re[t];0===e||10===e?((1===t?C:x)(z(n,0)),n.length=0):n.push(e)}function ie(t,e,n,a){if(O)return $t(25,1,t,e,n,a);for(var o=0,u=0;u<n;u++){var c=i()[e>>2>>>0],s=i()[e+4>>2>>>0];e+=8;for(var l=0;l<s;l++)ae(t,r()[c+l>>>0]);o+=s}return i()[a>>2>>>0]=o,0}var oe=0;function ue(t){return 0==t%4&&(0!=t%100||0==t%400)}var ce=[31,29,31,30,31,30,31,31,30,31,30,31],se=[31,28,31,30,31,30,31,31,30,31,30,31];function le(t,n,r,i){function o(t,e,n){for(t="number"==typeof t?t.toString():t||"";t.length<e;)t=n[0]+t;return t}function u(t,e){return o(t,e,"0")}function c(t,e){function n(t){return 0>t?-1:0<t?1:0}var r;return 0===(r=n(t.getFullYear()-e.getFullYear()))&&0===(r=n(t.getMonth()-e.getMonth()))&&(r=n(t.getDate()-e.getDate())),r}function s(t){switch(t.getDay()){case 0:return new Date(t.getFullYear()-1,11,29);case 1:return t;case 2:return new Date(t.getFullYear(),0,3);case 3:return new Date(t.getFullYear(),0,2);case 4:return new Date(t.getFullYear(),0,1);case 5:return new Date(t.getFullYear()-1,11,31);case 6:return new Date(t.getFullYear()-1,11,30)}}function l(t){var e=t.Wb;for(t=new Date(new Date(t.Xb+1900,0,1).getTime());0<e;){var n=t.getMonth(),r=(ue(t.getFullYear())?ce:se)[n];if(!(e>r-t.getDate())){t.setDate(t.getDate()+e);break}e-=r-t.getDate()+1,t.setDate(1),11>n?t.setMonth(n+1):(t.setMonth(0),t.setFullYear(t.getFullYear()+1))}return n=new Date(t.getFullYear()+1,0,4),e=s(new Date(t.getFullYear(),0,4)),n=s(n),0>=c(e,t)?0>=c(n,t)?t.getFullYear()+1:t.getFullYear():t.getFullYear()-1}var f=a()[i+40>>2>>>0];for(var p in i={Lc:a()[i>>2>>>0],Kc:a()[i+4>>2>>>0],dc:a()[i+8>>2>>>0],jc:a()[i+12>>2>>>0],ec:a()[i+16>>2>>>0],Xb:a()[i+20>>2>>>0],Tb:a()[i+24>>2>>>0],Wb:a()[i+28>>2>>>0],Rc:a()[i+32>>2>>>0],Jc:a()[i+36>>2>>>0],Mc:f?Y(f):""},r=Y(r),f={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S","%Ec":"%c","%EC":"%C","%Ex":"%m/%d/%y","%EX":"%H:%M:%S","%Ey":"%y","%EY":"%Y","%Od":"%d","%Oe":"%e","%OH":"%H","%OI":"%I","%Om":"%m","%OM":"%M","%OS":"%S","%Ou":"%u","%OU":"%U","%OV":"%V","%Ow":"%w","%OW":"%W","%Oy":"%y"})r=r.replace(new RegExp(p,"g"),f[p]);var h="Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),d="January February March April May June July August September October November December".split(" ");for(p in f={"%a":function(t){return h[t.Tb].substring(0,3)},"%A":function(t){return h[t.Tb]},"%b":function(t){return d[t.ec].substring(0,3)},"%B":function(t){return d[t.ec]},"%C":function(t){return u((t.Xb+1900)/100|0,2)},"%d":function(t){return u(t.jc,2)},"%e":function(t){return o(t.jc,2," ")},"%g":function(t){return l(t).toString().substring(2)},"%G":function(t){return l(t)},"%H":function(t){return u(t.dc,2)},"%I":function(t){return 0==(t=t.dc)?t=12:12<t&&(t-=12),u(t,2)},"%j":function(t){for(var e=0,n=0;n<=t.ec-1;e+=(ue(t.Xb+1900)?ce:se)[n++]);return u(t.jc+e,3)},"%m":function(t){return u(t.ec+1,2)},"%M":function(t){return u(t.Kc,2)},"%n":function(){return"\\n"},"%p":function(t){return 0<=t.dc&&12>t.dc?"AM":"PM"},"%S":function(t){return u(t.Lc,2)},"%t":function(){return"\\t"},"%u":function(t){return t.Tb||7},"%U":function(t){return u(Math.floor((t.Wb+7-t.Tb)/7),2)},"%V":function(t){var e=Math.floor((t.Wb+7-(t.Tb+6)%7)/7);if(2>=(t.Tb+371-t.Wb-2)%7&&e++,e)53==e&&(4==(n=(t.Tb+371-t.Wb)%7)||3==n&&ue(t.Xb)||(e=1));else{e=52;var n=(t.Tb+7-t.Wb-1)%7;(4==n||5==n&&ue(t.Xb%400-1))&&e++}return u(e,2)},"%w":function(t){return t.Tb},"%W":function(t){return u(Math.floor((t.Wb+7-(t.Tb+6)%7)/7),2)},"%y":function(t){return(t.Xb+1900).toString().substring(2)},"%Y":function(t){return t.Xb+1900},"%z":function(t){var e=0<=(t=t.Jc);return t=Math.abs(t)/60,(e?"+":"-")+String("0000"+(t/60*100+t%60)).slice(-4)},"%Z":function(t){return t.Mc},"%%":function(){return"%"}},r=r.replace(/%%/g,"\\0\\0"),f)r.includes(p)&&(r=r.replace(new RegExp(p,"g"),f[p](i)));return p=function(t){var e=Array(G(t)+1);return B(t,e,0,e.length),e}(r=r.replace(/\\0\\0/g,"%")),p.length>n?0:(function(t,n){e().set(t,n>>>0)}(p,t),p.length-1)}ht.fc();var fe=[null,ft,bt,Et,Ct,xt,Rt,jt,kt,Dt,Pt,Ut,Ft,It,Wt,Ht,Lt,Bt,Gt,Vt,Qt,Kt,te,ee,ne,ie],pe={b:function(t){return de(t+24)+24},n:function(t){return(t=new St(t)).uc()||(t.hc(!0),Ot--),t.ic(!1),_t.push(t),t.sc(),t.vc()},ma:function(t){throw x("Unexpected exception thrown, this is not properly supported - aborting"),H=!0,t},x:function(){Se(0);var t=_t.pop();if(t.Hc()&&!t.kc()){var e=t.Dc();e&&gt(e)(t.Zb),Tt(t.Zb)}At=0},e:function(){var t=At;if(!t)return oe=0;var e=new St(t);e.cc(t);var n=e.bc();if(!n)return oe=0,t;for(var r=Array.prototype.slice.call(arguments),a=0;a<r.length;a++){var i=r[a];if(0===i||i===n)break;if(xe(i,n,e.Sb+16))return oe=i,t}return oe=n,t},l:function(){var t=At;if(!t)return oe=0;var e=new St(t);e.cc(t);var n=e.bc();if(!n)return oe=0,t;for(var r=Array.prototype.slice.call(arguments),a=0;a<r.length;a++){var i=r[a];if(0===i||i===n)break;if(xe(i,n,e.Sb+16))return oe=i,t}return oe=n,t},h:function(){var t=At;if(!t)return oe=0;var e=new St(t);e.cc(t);var n=e.bc();if(!n)return oe=0,t;for(var r=Array.prototype.slice.call(arguments),a=0;a<r.length;a++){var i=r[a];if(0===i||i===n)break;if(xe(i,n,e.Sb+16))return oe=i,t}return oe=n,t},t:Tt,M:function(){var t=_t.pop();t||at("no exception to throw");var e=t.Zb;throw t.kc()||(_t.push(t),t.ic(!0),t.hc(!1),Ot++),At=e,e},c:function(t,e,n){throw new St(t).fc(e,n),At=t,Ot++,t},pa:function(){return Ot},Fa:function(t){ge(t,!w,1,!v),ht.pc()},T:function(t){O?postMessage({cmd:"cleanupThread",thread:t}):st(t)},xa:Mt,j:function(t){throw At||(At=t),t},H:Ct,Ma:xt,ua:Rt,wa:jt,oa:kt,Ka:Dt,Ca:Pt,Ja:Ut,V:Ft,va:It,sa:Wt,La:Ht,ta:Lt,Ta:function(){},X:function(){at("To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking")},Ua:function(){at("To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking")},W:function(){return Date.now()},ya:function(){return 2097152},Oa:function(){return!0},za:function(t,e,n,r){if(t==e)setTimeout((()=>zt(r)));else if(O)postMessage({targetThread:t,cmd:"processProxyingQueue",queue:r});else{if(!(t=ht.Vb[t]))return;t.postMessage({cmd:"processProxyingQueue",queue:r})}return 1},Ea:function(){return-1},Pa:function(t,e){t=new Date(1e3*Yt(t)),a()[e>>2>>>0]=t.getUTCSeconds(),a()[e+4>>2>>>0]=t.getUTCMinutes(),a()[e+8>>2>>>0]=t.getUTCHours(),a()[e+12>>2>>>0]=t.getUTCDate(),a()[e+16>>2>>>0]=t.getUTCMonth(),a()[e+20>>2>>>0]=t.getUTCFullYear()-1900,a()[e+24>>2>>>0]=t.getUTCDay(),t=(t.getTime()-Date.UTC(t.getUTCFullYear(),0,1,0,0,0,0))/864e5|0,a()[e+28>>2>>>0]=t},Qa:function(t,e){t=new Date(1e3*Yt(t)),a()[e>>2>>>0]=t.getSeconds(),a()[e+4>>2>>>0]=t.getMinutes(),a()[e+8>>2>>>0]=t.getHours(),a()[e+12>>2>>>0]=t.getDate(),a()[e+16>>2>>>0]=t.getMonth(),a()[e+20>>2>>>0]=t.getFullYear()-1900,a()[e+24>>2>>>0]=t.getDay();var n=new Date(t.getFullYear(),0,1),r=(t.getTime()-n.getTime())/864e5|0;a()[e+28>>2>>>0]=r,a()[e+36>>2>>>0]=-60*t.getTimezoneOffset(),r=new Date(t.getFullYear(),6,1).getTimezoneOffset(),t=0|(r!=(n=n.getTimezoneOffset())&&t.getTimezoneOffset()==Math.min(n,r)),a()[e+32>>2>>>0]=t},Ra:function(t){var e=new Date(a()[t+20>>2>>>0]+1900,a()[t+16>>2>>>0],a()[t+12>>2>>>0],a()[t+8>>2>>>0],a()[t+4>>2>>>0],a()[t>>2>>>0],0),n=a()[t+32>>2>>>0],r=e.getTimezoneOffset(),i=new Date(e.getFullYear(),0,1),o=new Date(e.getFullYear(),6,1).getTimezoneOffset(),u=i.getTimezoneOffset(),c=Math.min(u,o);return 0>n?a()[t+32>>2>>>0]=Number(o!=u&&c==r):0<n!=(c==r)&&(o=Math.max(u,o),e.setTime(e.getTime()+6e4*((0<n?c:o)-r))),a()[t+24>>2>>>0]=e.getDay(),n=(e.getTime()-i.getTime())/864e5|0,a()[t+28>>2>>>0]=n,a()[t>>2>>>0]=e.getSeconds(),a()[t+4>>2>>>0]=e.getMinutes(),a()[t+8>>2>>>0]=e.getHours(),a()[t+12>>2>>>0]=e.getDate(),a()[t+16>>2>>>0]=e.getMonth(),e.getTime()/1e3|0},Aa:Bt,Ba:Gt,Sa:function t(e,n,r){t.Ac||(t.Ac=!0,Vt(e,n,r))},y:function(){at("")},U:function(){if(!_&&!w){var t="Blocking on the main thread is very dangerous, see https://emscripten.org/docs/porting/pthreads.html#blocking-on-the-main-browser-thread";vt||(vt={}),vt[t]||(vt[t]=1,_&&(t="warning: "+t),x(t))}},ra:function(){return 4294901760},B:wt,Ia:function(t,e,n){r().copyWithin(t>>>0,e>>>0,e+n>>>0)},F:function(){return _?n(993).cpus().length:navigator.hardwareConcurrency},Da:function(t,e,n){Xt.length=e,n>>=3;for(var r=0;r<e;r++)Xt[r]=o()[n+r>>>0];return(0>t?ut[-t-1]:fe[t]).apply(null,Xt)},qa:function(t){var e=r().length;if((t>>>=0)<=e||4294901760<t)return!1;for(var n=1;4>=n;n*=2){var a=e*(1+.2/n);a=Math.min(a,t+100663296);var i=Math;a=Math.max(t,a),i=i.min.call(i,4294901760,a+(65536-a%65536)%65536);t:{try{j.grow(i-D.byteLength+65535>>>16),N(j.buffer);var o=1;break t}catch(t){}o=void 0}if(o)return!0}return!1},Na:function(){throw"unwind"},Ga:Qt,Ha:Kt,J:pt,I:te,S:ee,ga:ne,R:ie,d:function(){return oe},na:function t(r,a){t.lc||(t.lc=function(){if("object"==typeof crypto&&"function"==typeof crypto.getRandomValues){var t=new Uint8Array(1);return()=>(crypto.getRandomValues(t),t[0])}if(_)try{var e=n(Object(function(){var t=new Error("Cannot find module \'crypto\'");throw t.code="MODULE_NOT_FOUND",t}()));return()=>e.randomBytes(1)[0]}catch(t){}return()=>at("randomDevice")}());for(var i=0;i<a;i++)e()[r+i>>0>>>0]=t.lc();return 0},ia:function(t,e,n){var r=Ee();try{return gt(t)(e,n)}catch(t){if(Me(r),t!==t+0)throw t;Se(1,0)}},ja:function(t,e,n){var r=Ee();try{return gt(t)(e,n)}catch(t){if(Me(r),t!==t+0)throw t;Se(1,0)}},K:function(t){var e=Ee();try{return gt(t)()}catch(t){if(Me(e),t!==t+0)throw t;Se(1,0)}},f:function(t,e){var n=Ee();try{return gt(t)(e)}catch(t){if(Me(n),t!==t+0)throw t;Se(1,0)}},P:function(t,e,n){var r=Ee();try{return gt(t)(e,n)}catch(t){if(Me(r),t!==t+0)throw t;Se(1,0)}},Q:function(t,e,n){var r=Ee();try{return gt(t)(e,n)}catch(t){if(Me(r),t!==t+0)throw t;Se(1,0)}},k:function(t,e,n){var r=Ee();try{return gt(t)(e,n)}catch(t){if(Me(r),t!==t+0)throw t;Se(1,0)}},p:function(t,e,n,r){var a=Ee();try{return gt(t)(e,n,r)}catch(t){if(Me(a),t!==t+0)throw t;Se(1,0)}},q:function(t,e,n,r,a){var i=Ee();try{return gt(t)(e,n,r,a)}catch(t){if(Me(i),t!==t+0)throw t;Se(1,0)}},N:function(t,e,n,r,a,i){var o=Ee();try{return gt(t)(e,n,r,a,i)}catch(t){if(Me(o),t!==t+0)throw t;Se(1,0)}},s:function(t,e,n,r,a,i){var o=Ee();try{return gt(t)(e,n,r,a,i)}catch(t){if(Me(o),t!==t+0)throw t;Se(1,0)}},w:function(t,e,n,r,a,i,o){var u=Ee();try{return gt(t)(e,n,r,a,i,o)}catch(t){if(Me(u),t!==t+0)throw t;Se(1,0)}},L:function(t,e,n,r,a,i,o,u){var c=Ee();try{return gt(t)(e,n,r,a,i,o,u)}catch(t){if(Me(c),t!==t+0)throw t;Se(1,0)}},E:function(t,e,n,r,a,i,o,u,c,s,l,f){var p=Ee();try{return gt(t)(e,n,r,a,i,o,u,c,s,l,f)}catch(t){if(Me(p),t!==t+0)throw t;Se(1,0)}},aa:function(t,e,n,r,a,i,o,u){var c=Ee();try{return He(t,e,n,r,a,i,o,u)}catch(t){if(Me(c),t!==t+0)throw t;Se(1,0)}},_:function(t,e,n,r,a,i,o){var u=Ee();try{return ke(t,e,n,r,a,i,o)}catch(t){if(Me(u),t!==t+0)throw t;Se(1,0)}},Z:function(t,e,n,r,a){var i=Ee();try{return Le(t,e,n,r,a)}catch(t){if(Me(i),t!==t+0)throw t;Se(1,0)}},ca:function(t,e,n,r){var a=Ee();try{return Ie(t,e,n,r)}catch(t){if(Me(a),t!==t+0)throw t;Se(1,0)}},$:function(t){var e=Ee();try{return je(t)}catch(t){if(Me(e),t!==t+0)throw t;Se(1,0)}},ba:function(t,e){var n=Ee();try{return We(t,e)}catch(t){if(Me(n),t!==t+0)throw t;Se(1,0)}},Y:function(t,e,n){var r=Ee();try{return De(t,e,n)}catch(t){if(Me(r),t!==t+0)throw t;Se(1,0)}},g:function(t){var e=Ee();try{gt(t)()}catch(t){if(Me(e),t!==t+0)throw t;Se(1,0)}},r:function(t,e){var n=Ee();try{gt(t)(e)}catch(t){if(Me(n),t!==t+0)throw t;Se(1,0)}},i:function(t,e,n){var r=Ee();try{gt(t)(e,n)}catch(t){if(Me(r),t!==t+0)throw t;Se(1,0)}},ha:function(t,e,n,r){var a=Ee();try{gt(t)(e,n,r)}catch(t){if(Me(a),t!==t+0)throw t;Se(1,0)}},m:function(t,e,n,r){var a=Ee();try{gt(t)(e,n,r)}catch(t){if(Me(a),t!==t+0)throw t;Se(1,0)}},v:function(t,e,n,r,a){var i=Ee();try{gt(t)(e,n,r,a)}catch(t){if(Me(i),t!==t+0)throw t;Se(1,0)}},u:function(t,e,n,r,a,i){var o=Ee();try{gt(t)(e,n,r,a,i)}catch(t){if(Me(o),t!==t+0)throw t;Se(1,0)}},O:function(t,e,n,r,a,i,o){var u=Ee();try{gt(t)(e,n,r,a,i,o)}catch(t){if(Me(u),t!==t+0)throw t;Se(1,0)}},A:function(t,e,n,r,a,i,o,u){var c=Ee();try{gt(t)(e,n,r,a,i,o,u)}catch(t){if(Me(c),t!==t+0)throw t;Se(1,0)}},ka:function(t,e,n,r,a,i,o,u,c){var s=Ee();try{gt(t)(e,n,r,a,i,o,u,c)}catch(t){if(Me(s),t!==t+0)throw t;Se(1,0)}},C:function(t,e,n,r,a,i,o,u,c,s,l){var f=Ee();try{gt(t)(e,n,r,a,i,o,u,c,s,l)}catch(t){if(Me(f),t!==t+0)throw t;Se(1,0)}},D:function(t,e,n,r,a,i,o,u,c,s,l,f,p,h,d,y){var b=Ee();try{gt(t)(e,n,r,a,i,o,u,c,s,l,f,p,h,d,y)}catch(t){if(Me(b),t!==t+0)throw t;Se(1,0)}},fa:function(t,e,n,r,a,i,o,u){var c=Ee();try{Pe(t,e,n,r,a,i,o,u)}catch(t){if(Me(c),t!==t+0)throw t;Se(1,0)}},da:function(t,e,n,r,a,i,o,u,c,s,l,f){var p=Ee();try{Fe(t,e,n,r,a,i,o,u,c,s,l,f)}catch(t){if(Me(p),t!==t+0)throw t;Se(1,0)}},ea:function(t,e,n,r,a,i){var o=Ee();try{Ue(t,e,n,r,a,i)}catch(t){if(Me(o),t!==t+0)throw t;Se(1,0)}},o:function(t){return t},a:j||u.wasmMemory,G:function(t){oe=t},la:le,z:function(t,e,n,r){return le(t,e,n,r)}};!function(){function t(t,e){u.asm=t.exports,ht.qc.push(u.asm.sb),$=u.asm.ub,X.unshift(u.asm.Va),k=e,O||(et--,u.monitorRunDependencies&&u.monitorRunDependencies(et),0==et&&(null!==nt&&(clearInterval(nt),nt=null),rt&&(t=rt,rt=null,t())))}function e(e){t(e.instance,e.module)}function n(t){return function(){if(!M&&(v||w)){if("function"==typeof fetch&&!tt.startsWith("file://"))return fetch(tt,{credentials:"same-origin"}).then((function(t){if(!t.ok)throw"failed to load wasm binary file at \'"+tt+"\'";return t.arrayBuffer()})).catch((function(){return ot()}));if(f)return new Promise((function(t,e){f(tt,(function(e){t(new Uint8Array(e))}),e)}))}return Promise.resolve().then((function(){return ot()}))}().then((function(t){return WebAssembly.instantiate(t,r)})).then((function(t){return t})).then(t,(function(t){x("failed to asynchronously prepare wasm: "+t),at(t)}))}var r={a:pe};if(O||(et++,u.monitorRunDependencies&&u.monitorRunDependencies(et)),u.instantiateWasm)try{return u.instantiateWasm(r,t)}catch(t){return x("Module.instantiateWasm callback failed with error: "+t),!1}(M||"function"!=typeof WebAssembly.instantiateStreaming||it()||tt.startsWith("file://")||_||"function"!=typeof fetch?n(e):fetch(tt,{credentials:"same-origin"}).then((function(t){return WebAssembly.instantiateStreaming(t,r).then(e,(function(t){return x("wasm streaming compile failed: "+t),x("falling back to ArrayBuffer instantiation"),n(e)}))}))).catch(s)}(),u.___wasm_call_ctors=function(){return(u.___wasm_call_ctors=u.asm.Va).apply(null,arguments)},u._OrtInit=function(){return(u._OrtInit=u.asm.Wa).apply(null,arguments)},u._OrtCreateSessionOptions=function(){return(u._OrtCreateSessionOptions=u.asm.Xa).apply(null,arguments)},u._OrtAppendExecutionProvider=function(){return(u._OrtAppendExecutionProvider=u.asm.Ya).apply(null,arguments)},u._OrtAddSessionConfigEntry=function(){return(u._OrtAddSessionConfigEntry=u.asm.Za).apply(null,arguments)},u._OrtReleaseSessionOptions=function(){return(u._OrtReleaseSessionOptions=u.asm._a).apply(null,arguments)},u._OrtCreateSession=function(){return(u._OrtCreateSession=u.asm.$a).apply(null,arguments)},u._OrtReleaseSession=function(){return(u._OrtReleaseSession=u.asm.ab).apply(null,arguments)},u._OrtGetInputCount=function(){return(u._OrtGetInputCount=u.asm.bb).apply(null,arguments)},u._OrtGetOutputCount=function(){return(u._OrtGetOutputCount=u.asm.cb).apply(null,arguments)},u._OrtGetInputName=function(){return(u._OrtGetInputName=u.asm.db).apply(null,arguments)},u._OrtGetOutputName=function(){return(u._OrtGetOutputName=u.asm.eb).apply(null,arguments)},u._OrtFree=function(){return(u._OrtFree=u.asm.fb).apply(null,arguments)},u._OrtCreateTensor=function(){return(u._OrtCreateTensor=u.asm.gb).apply(null,arguments)},u._OrtGetTensorData=function(){return(u._OrtGetTensorData=u.asm.hb).apply(null,arguments)},u._OrtReleaseTensor=function(){return(u._OrtReleaseTensor=u.asm.ib).apply(null,arguments)},u._OrtCreateRunOptions=function(){return(u._OrtCreateRunOptions=u.asm.jb).apply(null,arguments)},u._OrtAddRunConfigEntry=function(){return(u._OrtAddRunConfigEntry=u.asm.kb).apply(null,arguments)},u._OrtReleaseRunOptions=function(){return(u._OrtReleaseRunOptions=u.asm.lb).apply(null,arguments)},u._OrtRun=function(){return(u._OrtRun=u.asm.mb).apply(null,arguments)},u._OrtEndProfiling=function(){return(u._OrtEndProfiling=u.asm.nb).apply(null,arguments)};var he=u._pthread_self=function(){return(he=u._pthread_self=u.asm.ob).apply(null,arguments)},de=u._malloc=function(){return(de=u._malloc=u.asm.pb).apply(null,arguments)},ye=u._free=function(){return(ye=u._free=u.asm.qb).apply(null,arguments)},be=u._fflush=function(){return(be=u._fflush=u.asm.rb).apply(null,arguments)};u.__emscripten_tls_init=function(){return(u.__emscripten_tls_init=u.asm.sb).apply(null,arguments)};var me=u.___funcs_on_exit=function(){return(me=u.___funcs_on_exit=u.asm.tb).apply(null,arguments)},ge=u.__emscripten_thread_init=function(){return(ge=u.__emscripten_thread_init=u.asm.vb).apply(null,arguments)};u.__emscripten_thread_crashed=function(){return(u.__emscripten_thread_crashed=u.asm.wb).apply(null,arguments)};var ve,we=u._emscripten_run_in_main_runtime_thread_js=function(){return(we=u._emscripten_run_in_main_runtime_thread_js=u.asm.xb).apply(null,arguments)},_e=u.__emscripten_proxy_execute_task_queue=function(){return(_e=u.__emscripten_proxy_execute_task_queue=u.asm.yb).apply(null,arguments)},Oe=u.__emscripten_thread_free_data=function(){return(Oe=u.__emscripten_thread_free_data=u.asm.zb).apply(null,arguments)},Ae=u.__emscripten_thread_exit=function(){return(Ae=u.__emscripten_thread_exit=u.asm.Ab).apply(null,arguments)},Se=u._setThrew=function(){return(Se=u._setThrew=u.asm.Bb).apply(null,arguments)},Te=u._emscripten_stack_set_limits=function(){return(Te=u._emscripten_stack_set_limits=u.asm.Cb).apply(null,arguments)},Ee=u.stackSave=function(){return(Ee=u.stackSave=u.asm.Db).apply(null,arguments)},Me=u.stackRestore=function(){return(Me=u.stackRestore=u.asm.Eb).apply(null,arguments)},Ce=u.stackAlloc=function(){return(Ce=u.stackAlloc=u.asm.Fb).apply(null,arguments)},xe=u.___cxa_can_catch=function(){return(xe=u.___cxa_can_catch=u.asm.Gb).apply(null,arguments)},Re=u.___cxa_is_pointer_type=function(){return(Re=u.___cxa_is_pointer_type=u.asm.Hb).apply(null,arguments)},je=u.dynCall_j=function(){return(je=u.dynCall_j=u.asm.Ib).apply(null,arguments)},ke=u.dynCall_iiiiij=function(){return(ke=u.dynCall_iiiiij=u.asm.Jb).apply(null,arguments)},De=u.dynCall_jii=function(){return(De=u.dynCall_jii=u.asm.Kb).apply(null,arguments)},Pe=u.dynCall_viiiiij=function(){return(Pe=u.dynCall_viiiiij=u.asm.Lb).apply(null,arguments)},Ue=u.dynCall_vjji=function(){return(Ue=u.dynCall_vjji=u.asm.Mb).apply(null,arguments)},Fe=u.dynCall_viiijjjii=function(){return(Fe=u.dynCall_viiijjjii=u.asm.Nb).apply(null,arguments)},Ie=u.dynCall_iij=function(){return(Ie=u.dynCall_iij=u.asm.Ob).apply(null,arguments)},We=u.dynCall_ji=function(){return(We=u.dynCall_ji=u.asm.Pb).apply(null,arguments)},He=u.dynCall_iiiiiij=function(){return(He=u.dynCall_iiiiiij=u.asm.Qb).apply(null,arguments)},Le=u.dynCall_iiij=function(){return(Le=u.dynCall_iiij=u.asm.Rb).apply(null,arguments)};function ze(){function t(){if(!ve&&(ve=!0,u.calledRun=!0,!H)&&(O||dt(X),c(u),u.onRuntimeInitialized&&u.onRuntimeInitialized(),!O)){if(u.postRun)for("function"==typeof u.postRun&&(u.postRun=[u.postRun]);u.postRun.length;){var t=u.postRun.shift();Z.unshift(t)}dt(Z)}}if(!(0<et))if(O)c(u),O||dt(X),postMessage({cmd:"loaded"});else{if(u.preRun)for("function"==typeof u.preRun&&(u.preRun=[u.preRun]);u.preRun.length;)K();dt(q),0<et||(u.setStatus?(u.setStatus("Running..."),setTimeout((function(){setTimeout((function(){u.setStatus("")}),1),t()}),1)):t())}}if(u.UTF8ToString=Y,u.stringToUTF8=function(t,e,n){return B(t,r(),e,n)},u.lengthBytesUTF8=G,u.keepRuntimeAlive=Q,u.wasmMemory=j,u.stackSave=Ee,u.stackRestore=Me,u.stackAlloc=Ce,u.ExitStatus=ct,u.PThread=ht,rt=function t(){ve||ze(),ve||(rt=t)},u.preInit)for("function"==typeof u.preInit&&(u.preInit=[u.preInit]);0<u.preInit.length;)u.preInit.pop()();return ze(),t.ready});t.exports=r},932:(t,e,n)=>{var _scriptDir,r=(_scriptDir=(_scriptDir="undefined"!=typeof document&&document.currentScript?document.currentScript.src:void 0)||"/index.js",function(t){var e,r,a;t=t||{},e||(e=void 0!==t?t:{}),e.ready=new Promise((function(t,e){r=t,a=e}));var i,o,u,c,s,l,f=Object.assign({},e),p="./this.program",h=(t,e)=>{throw e},d="object"==typeof window,y="function"==typeof importScripts,b="object"==typeof process&&"object"==typeof process.versions&&"string"==typeof process.versions.node,m="";b?(m=y?n(908).dirname(m)+"/":"//",l=()=>{s||(c=n(384),s=n(908))},i=function(t,e){return l(),t=s.normalize(t),c.readFileSync(t,e?void 0:"utf8")},u=t=>((t=i(t,!0)).buffer||(t=new Uint8Array(t)),t),o=(t,e,n)=>{l(),t=s.normalize(t),c.readFile(t,(function(t,r){t?n(t):e(r.buffer)}))},1<process.argv.length&&(p=process.argv[1].replace(/\\\\/g,"/")),process.argv.slice(2),process.on("uncaughtException",(function(t){if(!(t instanceof J))throw t})),process.on("unhandledRejection",(function(t){throw t})),h=(t,e)=>{if(_||0<L)throw process.exitCode=t,e;e instanceof J||w("exiting due to exception: "+e),process.exit(t)},e.inspect=function(){return"[Emscripten Module object]"}):(d||y)&&(y?m=self.location.href:"undefined"!=typeof document&&document.currentScript&&(m=document.currentScript.src),_scriptDir&&(m=_scriptDir),m=0!==m.indexOf("blob:")?m.substr(0,m.replace(/[?#].*/,"").lastIndexOf("/")+1):"",i=t=>{var e=new XMLHttpRequest;return e.open("GET",t,!1),e.send(null),e.responseText},y&&(u=t=>{var e=new XMLHttpRequest;return e.open("GET",t,!1),e.responseType="arraybuffer",e.send(null),new Uint8Array(e.response)}),o=(t,e,n)=>{var r=new XMLHttpRequest;r.open("GET",t,!0),r.responseType="arraybuffer",r.onload=()=>{200==r.status||0==r.status&&r.response?e(r.response):n()},r.onerror=n,r.send(null)});var g,v=e.print||console.log.bind(console),w=e.printErr||console.warn.bind(console);Object.assign(e,f),f=null,e.thisProgram&&(p=e.thisProgram),e.quit&&(h=e.quit),e.wasmBinary&&(g=e.wasmBinary);var _=e.noExitRuntime||!1;"object"!=typeof WebAssembly&&V("no native wasm support detected");var O,A,S,T,E,M,C=!1,x="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0;function R(t,e,n){var r=(e>>>=0)+n;for(n=e;t[n]&&!(n>=r);)++n;if(16<n-e&&t.buffer&&x)return x.decode(t.subarray(e,n));for(r="";e<n;){var a=t[e++];if(128&a){var i=63&t[e++];if(192==(224&a))r+=String.fromCharCode((31&a)<<6|i);else{var o=63&t[e++];65536>(a=224==(240&a)?(15&a)<<12|i<<6|o:(7&a)<<18|i<<12|o<<6|63&t[e++])?r+=String.fromCharCode(a):(a-=65536,r+=String.fromCharCode(55296|a>>10,56320|1023&a))}}else r+=String.fromCharCode(a)}return r}function j(t,e){return(t>>>=0)?R(T,t,e):""}function k(t,e,n,r){if(!(0<r))return 0;var a=n>>>=0;r=n+r-1;for(var i=0;i<t.length;++i){var o=t.charCodeAt(i);if(55296<=o&&57343>=o&&(o=65536+((1023&o)<<10)|1023&t.charCodeAt(++i)),127>=o){if(n>=r)break;e[n++>>>0]=o}else{if(2047>=o){if(n+1>=r)break;e[n++>>>0]=192|o>>6}else{if(65535>=o){if(n+2>=r)break;e[n++>>>0]=224|o>>12}else{if(n+3>=r)break;e[n++>>>0]=240|o>>18,e[n++>>>0]=128|o>>12&63}e[n++>>>0]=128|o>>6&63}e[n++>>>0]=128|63&o}}return e[n>>>0]=0,n-a}function D(t){for(var e=0,n=0;n<t.length;++n){var r=t.charCodeAt(n);127>=r?e++:2047>=r?e+=2:55296<=r&&57343>=r?(e+=4,++n):e+=3}return e}function P(){var t=O.buffer;A=t,e.HEAP8=S=new Int8Array(t),e.HEAP16=new Int16Array(t),e.HEAP32=E=new Int32Array(t),e.HEAPU8=T=new Uint8Array(t),e.HEAPU16=new Uint16Array(t),e.HEAPU32=M=new Uint32Array(t),e.HEAPF32=new Float32Array(t),e.HEAPF64=new Float64Array(t)}var U,F=[],I=[],W=[],H=[],L=0;function z(){var t=e.preRun.shift();F.unshift(t)}var Y,B=0,G=null,N=null;function V(t){throw e.onAbort&&e.onAbort(t),w(t="Aborted("+t+")"),C=!0,t=new WebAssembly.RuntimeError(t+". Build with -sASSERTIONS for more info."),a(t),t}function $(){return Y.startsWith("data:application/octet-stream;base64,")}if(Y="ort-wasm.wasm",!$()){var q=Y;Y=e.locateFile?e.locateFile(q,m):m+q}function X(){var t=Y;try{if(t==Y&&g)return new Uint8Array(g);if(u)return u(t);throw"both async and sync fetching of the wasm failed"}catch(t){V(t)}}function J(t){this.name="ExitStatus",this.message="Program terminated with exit("+t+")",this.status=t}function Z(t){for(;0<t.length;)t.shift()(e)}var Q=[],K=0,tt=0;function et(t){this.Db=t,this.zb=t-24,this.Ub=function(t){M[this.zb+4>>2>>>0]=t},this.Eb=function(){return M[this.zb+4>>2>>>0]},this.Sb=function(t){M[this.zb+8>>2>>>0]=t},this.Wb=function(){return M[this.zb+8>>2>>>0]},this.Tb=function(){E[this.zb>>2>>>0]=0},this.Ib=function(t){S[this.zb+12>>0>>>0]=t?1:0},this.Pb=function(){return 0!=S[this.zb+12>>0>>>0]},this.Jb=function(t){S[this.zb+13>>0>>>0]=t?1:0},this.Lb=function(){return 0!=S[this.zb+13>>0>>>0]},this.Rb=function(t,e){this.Fb(0),this.Ub(t),this.Sb(e),this.Tb(),this.Ib(!1),this.Jb(!1)},this.Nb=function(){E[this.zb>>2>>>0]+=1},this.Xb=function(){var t=E[this.zb>>2>>>0];return E[this.zb>>2>>>0]=t-1,1===t},this.Fb=function(t){M[this.zb+16>>2>>>0]=t},this.Ob=function(){return M[this.zb+16>>2>>>0]},this.Qb=function(){if(Mt(this.Eb()))return M[this.Db>>2>>>0];var t=this.Ob();return 0!==t?t:this.Db}}function nt(t){return vt(new et(t).zb)}var rt=[];function at(t){var e=rt[t];return e||(t>=rt.length&&(rt.length=t+1),rt[t]=e=U.get(t)),e}function it(t){var e=D(t)+1,n=gt(e);return n&&k(t,S,n,e),n}var ot={};function ut(){if(!ct){var t,e={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:("object"==typeof navigator&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",_:p||"./this.program"};for(t in ot)void 0===ot[t]?delete e[t]:e[t]=ot[t];var n=[];for(t in e)n.push(t+"="+e[t]);ct=n}return ct}var ct,st=[null,[],[]];function lt(t,e){var n=st[t];0===e||10===e?((1===t?v:w)(R(n,0)),n.length=0):n.push(e)}var ft=0;function pt(t){return 0==t%4&&(0!=t%100||0==t%400)}var ht=[31,29,31,30,31,30,31,31,30,31,30,31],dt=[31,28,31,30,31,30,31,31,30,31,30,31];function yt(t,e,n,r){function a(t,e,n){for(t="number"==typeof t?t.toString():t||"";t.length<e;)t=n[0]+t;return t}function i(t,e){return a(t,e,"0")}function o(t,e){function n(t){return 0>t?-1:0<t?1:0}var r;return 0===(r=n(t.getFullYear()-e.getFullYear()))&&0===(r=n(t.getMonth()-e.getMonth()))&&(r=n(t.getDate()-e.getDate())),r}function u(t){switch(t.getDay()){case 0:return new Date(t.getFullYear()-1,11,29);case 1:return t;case 2:return new Date(t.getFullYear(),0,3);case 3:return new Date(t.getFullYear(),0,2);case 4:return new Date(t.getFullYear(),0,1);case 5:return new Date(t.getFullYear()-1,11,31);case 6:return new Date(t.getFullYear()-1,11,30)}}function c(t){var e=t.Bb;for(t=new Date(new Date(t.Cb+1900,0,1).getTime());0<e;){var n=t.getMonth(),r=(pt(t.getFullYear())?ht:dt)[n];if(!(e>r-t.getDate())){t.setDate(t.getDate()+e);break}e-=r-t.getDate()+1,t.setDate(1),11>n?t.setMonth(n+1):(t.setMonth(0),t.setFullYear(t.getFullYear()+1))}return n=new Date(t.getFullYear()+1,0,4),e=u(new Date(t.getFullYear(),0,4)),n=u(n),0>=o(e,t)?0>=o(n,t)?t.getFullYear()+1:t.getFullYear():t.getFullYear()-1}var s=E[r+40>>2>>>0];for(var l in r={$b:E[r>>2>>>0],Zb:E[r+4>>2>>>0],Gb:E[r+8>>2>>>0],Kb:E[r+12>>2>>>0],Hb:E[r+16>>2>>>0],Cb:E[r+20>>2>>>0],Ab:E[r+24>>2>>>0],Bb:E[r+28>>2>>>0],bc:E[r+32>>2>>>0],Yb:E[r+36>>2>>>0],ac:s?j(s):""},n=j(n),s={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S","%Ec":"%c","%EC":"%C","%Ex":"%m/%d/%y","%EX":"%H:%M:%S","%Ey":"%y","%EY":"%Y","%Od":"%d","%Oe":"%e","%OH":"%H","%OI":"%I","%Om":"%m","%OM":"%M","%OS":"%S","%Ou":"%u","%OU":"%U","%OV":"%V","%Ow":"%w","%OW":"%W","%Oy":"%y"})n=n.replace(new RegExp(l,"g"),s[l]);var f="Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),p="January February March April May June July August September October November December".split(" ");for(l in s={"%a":function(t){return f[t.Ab].substring(0,3)},"%A":function(t){return f[t.Ab]},"%b":function(t){return p[t.Hb].substring(0,3)},"%B":function(t){return p[t.Hb]},"%C":function(t){return i((t.Cb+1900)/100|0,2)},"%d":function(t){return i(t.Kb,2)},"%e":function(t){return a(t.Kb,2," ")},"%g":function(t){return c(t).toString().substring(2)},"%G":function(t){return c(t)},"%H":function(t){return i(t.Gb,2)},"%I":function(t){return 0==(t=t.Gb)?t=12:12<t&&(t-=12),i(t,2)},"%j":function(t){for(var e=0,n=0;n<=t.Hb-1;e+=(pt(t.Cb+1900)?ht:dt)[n++]);return i(t.Kb+e,3)},"%m":function(t){return i(t.Hb+1,2)},"%M":function(t){return i(t.Zb,2)},"%n":function(){return"\\n"},"%p":function(t){return 0<=t.Gb&&12>t.Gb?"AM":"PM"},"%S":function(t){return i(t.$b,2)},"%t":function(){return"\\t"},"%u":function(t){return t.Ab||7},"%U":function(t){return i(Math.floor((t.Bb+7-t.Ab)/7),2)},"%V":function(t){var e=Math.floor((t.Bb+7-(t.Ab+6)%7)/7);if(2>=(t.Ab+371-t.Bb-2)%7&&e++,e)53==e&&(4==(n=(t.Ab+371-t.Bb)%7)||3==n&&pt(t.Cb)||(e=1));else{e=52;var n=(t.Ab+7-t.Bb-1)%7;(4==n||5==n&&pt(t.Cb%400-1))&&e++}return i(e,2)},"%w":function(t){return t.Ab},"%W":function(t){return i(Math.floor((t.Bb+7-(t.Ab+6)%7)/7),2)},"%y":function(t){return(t.Cb+1900).toString().substring(2)},"%Y":function(t){return t.Cb+1900},"%z":function(t){var e=0<=(t=t.Yb);return t=Math.abs(t)/60,(e?"+":"-")+String("0000"+(t/60*100+t%60)).slice(-4)},"%Z":function(t){return t.ac},"%%":function(){return"%"}},n=n.replace(/%%/g,"\\0\\0"),s)n.includes(l)&&(n=n.replace(new RegExp(l,"g"),s[l](r)));return l=function(t){var e=Array(D(t)+1);return k(t,e,0,e.length),e}(n=n.replace(/\\0\\0/g,"%")),l.length>e?0:(S.set(l,t>>>0),l.length-1)}var bt={a:function(t){return gt(t+24)+24},m:function(t){return(t=new et(t)).Pb()||(t.Ib(!0),K--),t.Jb(!1),Q.push(t),t.Nb(),t.Qb()},ia:function(t){throw w("Unexpected exception thrown, this is not properly supported - aborting"),C=!0,t},w:function(){Ot(0);var t=Q.pop();if(t.Xb()&&!t.Lb()){var e=t.Wb();e&&at(e)(t.Db),nt(t.Db)}tt=0},d:function(){var t=tt;if(!t)return ft=0;var e=new et(t);e.Fb(t);var n=e.Eb();if(!n)return ft=0,t;for(var r=Array.prototype.slice.call(arguments),a=0;a<r.length;a++){var i=r[a];if(0===i||i===n)break;if(Et(i,n,e.zb+16))return ft=i,t}return ft=n,t},k:function(){var t=tt;if(!t)return ft=0;var e=new et(t);e.Fb(t);var n=e.Eb();if(!n)return ft=0,t;for(var r=Array.prototype.slice.call(arguments),a=0;a<r.length;a++){var i=r[a];if(0===i||i===n)break;if(Et(i,n,e.zb+16))return ft=i,t}return ft=n,t},g:function(){var t=tt;if(!t)return ft=0;var e=new et(t);e.Fb(t);var n=e.Eb();if(!n)return ft=0,t;for(var r=Array.prototype.slice.call(arguments),a=0;a<r.length;a++){var i=r[a];if(0===i||i===n)break;if(Et(i,n,e.zb+16))return ft=i,t}return ft=n,t},s:nt,L:function(){var t=Q.pop();t||V("no exception to throw");var e=t.Db;throw t.Lb()||(Q.push(t),t.Jb(!0),t.Ib(!1),K++),tt=e,e},b:function(t,e,n){throw new et(t).Rb(e,n),tt=t,K++,t},la:function(){return K},i:function(t){throw tt||(tt=t),t},H:function(){return 0},Ba:function(){},pa:function(){},ra:function(){},ka:function(){return 0},za:function(){},ua:function(){},ya:function(){},R:function(){},qa:function(){},na:function(){},Aa:function(){},oa:function(){},Ha:function(){},Ja:function(){V("To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking")},Ia:function(){V("To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking")},S:function(){return Date.now()},Ca:function(){return!0},Da:function(t,e){t=new Date(1e3*(M[t>>>2]+4294967296*E[t+4>>>2])),E[e>>2>>>0]=t.getUTCSeconds(),E[e+4>>2>>>0]=t.getUTCMinutes(),E[e+8>>2>>>0]=t.getUTCHours(),E[e+12>>2>>>0]=t.getUTCDate(),E[e+16>>2>>>0]=t.getUTCMonth(),E[e+20>>2>>>0]=t.getUTCFullYear()-1900,E[e+24>>2>>>0]=t.getUTCDay(),E[e+28>>2>>>0]=(t.getTime()-Date.UTC(t.getUTCFullYear(),0,1,0,0,0,0))/864e5|0},Ea:function(t,e){t=new Date(1e3*(M[t>>>2]+4294967296*E[t+4>>>2])),E[e>>2>>>0]=t.getSeconds(),E[e+4>>2>>>0]=t.getMinutes(),E[e+8>>2>>>0]=t.getHours(),E[e+12>>2>>>0]=t.getDate(),E[e+16>>2>>>0]=t.getMonth(),E[e+20>>2>>>0]=t.getFullYear()-1900,E[e+24>>2>>>0]=t.getDay();var n=new Date(t.getFullYear(),0,1);E[e+28>>2>>>0]=(t.getTime()-n.getTime())/864e5|0,E[e+36>>2>>>0]=-60*t.getTimezoneOffset();var r=new Date(t.getFullYear(),6,1).getTimezoneOffset();n=n.getTimezoneOffset(),E[e+32>>2>>>0]=0|(r!=n&&t.getTimezoneOffset()==Math.min(n,r))},Fa:function(t){var e=new Date(E[t+20>>2>>>0]+1900,E[t+16>>2>>>0],E[t+12>>2>>>0],E[t+8>>2>>>0],E[t+4>>2>>>0],E[t>>2>>>0],0),n=E[t+32>>2>>>0],r=e.getTimezoneOffset(),a=new Date(e.getFullYear(),0,1),i=new Date(e.getFullYear(),6,1).getTimezoneOffset(),o=a.getTimezoneOffset(),u=Math.min(o,i);return 0>n?E[t+32>>2>>>0]=Number(i!=o&&u==r):0<n!=(u==r)&&(i=Math.max(o,i),e.setTime(e.getTime()+6e4*((0<n?u:i)-r))),E[t+24>>2>>>0]=e.getDay(),E[t+28>>2>>>0]=(e.getTime()-a.getTime())/864e5|0,E[t>>2>>>0]=e.getSeconds(),E[t+4>>2>>>0]=e.getMinutes(),E[t+8>>2>>>0]=e.getHours(),E[t+12>>2>>>0]=e.getDate(),E[t+16>>2>>>0]=e.getMonth(),e.getTime()/1e3|0},sa:function(){return-52},ta:function(){},Ga:function t(e,n,r){t.Vb||(t.Vb=!0,function(t,e,n){function r(t){return(t=t.toTimeString().match(/\\(([A-Za-z ]+)\\)$/))?t[1]:"GMT"}var a=(new Date).getFullYear(),i=new Date(a,0,1),o=new Date(a,6,1);a=i.getTimezoneOffset();var u=o.getTimezoneOffset();E[t>>2>>>0]=60*Math.max(a,u),E[e>>2>>>0]=Number(a!=u),t=r(i),e=r(o),t=it(t),e=it(e),u<a?(M[n>>2>>>0]=t,M[n+4>>2>>>0]=e):(M[n>>2>>>0]=e,M[n+4>>2>>>0]=t)}(e,n,r))},B:function(){V("")},ma:function(){return 4294901760},I:b?()=>{var t=process.hrtime();return 1e3*t[0]+t[1]/1e6}:()=>performance.now(),xa:function(t,e,n){T.copyWithin(t>>>0,e>>>0,e+n>>>0)},G:function(t){var e=T.length;if(4294901760<(t>>>=0))return!1;for(var n=1;4>=n;n*=2){var r=e*(1+.2/n);r=Math.min(r,t+100663296);var a=Math;r=Math.max(t,r),a=a.min.call(a,4294901760,r+(65536-r%65536)%65536);t:{try{O.grow(a-A.byteLength+65535>>>16),P();var i=1;break t}catch(t){}i=void 0}if(i)return!0}return!1},va:function(t,e){var n=0;return ut().forEach((function(r,a){var i=e+n;for(a=M[t+4*a>>2>>>0]=i,i=0;i<r.length;++i)S[a++>>0>>>0]=r.charCodeAt(i);S[a>>0>>>0]=0,n+=r.length+1})),0},wa:function(t,e){var n=ut();M[t>>2>>>0]=n.length;var r=0;return n.forEach((function(t){r+=t.length+1})),M[e>>2>>>0]=r,0},ba:function(t){_||0<L||(_t(),Z(W),wt(0),st[1].length&&lt(1,10),st[2].length&&lt(2,10)),_||0<L||(e.onExit&&e.onExit(t),C=!0),h(t,new J(t))},E:function(){return 52},Q:function(){return 52},ca:function(){return 70},P:function(t,e,n,r){for(var a=0,i=0;i<n;i++){var o=M[e>>2>>>0],u=M[e+4>>2>>>0];e+=8;for(var c=0;c<u;c++)lt(t,T[o+c>>>0]);a+=u}return M[r>>2>>>0]=a,0},c:function(){return ft},ja:function t(e,r){t.Mb||(t.Mb=function(){if("object"==typeof crypto&&"function"==typeof crypto.getRandomValues){var t=new Uint8Array(1);return()=>(crypto.getRandomValues(t),t[0])}if(b)try{var e=n(Object(function(){var t=new Error("Cannot find module \'crypto\'");throw t.code="MODULE_NOT_FOUND",t}()));return()=>e.randomBytes(1)[0]}catch(t){}return()=>V("randomDevice")}());for(var a=0;a<r;a++)S[e+a>>0>>>0]=t.Mb();return 0},ea:function(t,e,n){var r=At();try{return at(t)(e,n)}catch(t){if(St(r),t!==t+0)throw t;Ot(1,0)}},fa:function(t,e,n){var r=At();try{return at(t)(e,n)}catch(t){if(St(r),t!==t+0)throw t;Ot(1,0)}},J:function(t){var e=At();try{return at(t)()}catch(t){if(St(e),t!==t+0)throw t;Ot(1,0)}},e:function(t,e){var n=At();try{return at(t)(e)}catch(t){if(St(n),t!==t+0)throw t;Ot(1,0)}},N:function(t,e,n){var r=At();try{return at(t)(e,n)}catch(t){if(St(r),t!==t+0)throw t;Ot(1,0)}},O:function(t,e,n){var r=At();try{return at(t)(e,n)}catch(t){if(St(r),t!==t+0)throw t;Ot(1,0)}},j:function(t,e,n){var r=At();try{return at(t)(e,n)}catch(t){if(St(r),t!==t+0)throw t;Ot(1,0)}},o:function(t,e,n,r){var a=At();try{return at(t)(e,n,r)}catch(t){if(St(a),t!==t+0)throw t;Ot(1,0)}},p:function(t,e,n,r,a){var i=At();try{return at(t)(e,n,r,a)}catch(t){if(St(i),t!==t+0)throw t;Ot(1,0)}},M:function(t,e,n,r,a,i){var o=At();try{return at(t)(e,n,r,a,i)}catch(t){if(St(o),t!==t+0)throw t;Ot(1,0)}},r:function(t,e,n,r,a,i){var o=At();try{return at(t)(e,n,r,a,i)}catch(t){if(St(o),t!==t+0)throw t;Ot(1,0)}},v:function(t,e,n,r,a,i,o){var u=At();try{return at(t)(e,n,r,a,i,o)}catch(t){if(St(u),t!==t+0)throw t;Ot(1,0)}},K:function(t,e,n,r,a,i,o,u){var c=At();try{return at(t)(e,n,r,a,i,o,u)}catch(t){if(St(c),t!==t+0)throw t;Ot(1,0)}},D:function(t,e,n,r,a,i,o,u,c,s,l,f){var p=At();try{return at(t)(e,n,r,a,i,o,u,c,s,l,f)}catch(t){if(St(p),t!==t+0)throw t;Ot(1,0)}},X:function(t,e,n,r,a,i,o,u){var c=At();try{return Ft(t,e,n,r,a,i,o,u)}catch(t){if(St(c),t!==t+0)throw t;Ot(1,0)}},V:function(t,e,n,r,a,i,o){var u=At();try{return xt(t,e,n,r,a,i,o)}catch(t){if(St(u),t!==t+0)throw t;Ot(1,0)}},U:function(t,e,n,r,a){var i=At();try{return It(t,e,n,r,a)}catch(t){if(St(i),t!==t+0)throw t;Ot(1,0)}},Z:function(t,e,n,r){var a=At();try{return Pt(t,e,n,r)}catch(t){if(St(a),t!==t+0)throw t;Ot(1,0)}},W:function(t){var e=At();try{return Ct(t)}catch(t){if(St(e),t!==t+0)throw t;Ot(1,0)}},Y:function(t,e){var n=At();try{return Ut(t,e)}catch(t){if(St(n),t!==t+0)throw t;Ot(1,0)}},T:function(t,e,n){var r=At();try{return Rt(t,e,n)}catch(t){if(St(r),t!==t+0)throw t;Ot(1,0)}},f:function(t){var e=At();try{at(t)()}catch(t){if(St(e),t!==t+0)throw t;Ot(1,0)}},q:function(t,e){var n=At();try{at(t)(e)}catch(t){if(St(n),t!==t+0)throw t;Ot(1,0)}},h:function(t,e,n){var r=At();try{at(t)(e,n)}catch(t){if(St(r),t!==t+0)throw t;Ot(1,0)}},da:function(t,e,n,r){var a=At();try{at(t)(e,n,r)}catch(t){if(St(a),t!==t+0)throw t;Ot(1,0)}},l:function(t,e,n,r){var a=At();try{at(t)(e,n,r)}catch(t){if(St(a),t!==t+0)throw t;Ot(1,0)}},t:function(t,e,n,r,a){var i=At();try{at(t)(e,n,r,a)}catch(t){if(St(i),t!==t+0)throw t;Ot(1,0)}},u:function(t,e,n,r,a,i){var o=At();try{at(t)(e,n,r,a,i)}catch(t){if(St(o),t!==t+0)throw t;Ot(1,0)}},x:function(t,e,n,r,a,i,o){var u=At();try{at(t)(e,n,r,a,i,o)}catch(t){if(St(u),t!==t+0)throw t;Ot(1,0)}},z:function(t,e,n,r,a,i,o,u){var c=At();try{at(t)(e,n,r,a,i,o,u)}catch(t){if(St(c),t!==t+0)throw t;Ot(1,0)}},ga:function(t,e,n,r,a,i,o,u,c){var s=At();try{at(t)(e,n,r,a,i,o,u,c)}catch(t){if(St(s),t!==t+0)throw t;Ot(1,0)}},A:function(t,e,n,r,a,i,o,u,c,s,l){var f=At();try{at(t)(e,n,r,a,i,o,u,c,s,l)}catch(t){if(St(f),t!==t+0)throw t;Ot(1,0)}},C:function(t,e,n,r,a,i,o,u,c,s,l,f,p,h,d,y){var b=At();try{at(t)(e,n,r,a,i,o,u,c,s,l,f,p,h,d,y)}catch(t){if(St(b),t!==t+0)throw t;Ot(1,0)}},aa:function(t,e,n,r,a,i,o,u){var c=At();try{jt(t,e,n,r,a,i,o,u)}catch(t){if(St(c),t!==t+0)throw t;Ot(1,0)}},_:function(t,e,n,r,a,i,o,u,c,s,l,f){var p=At();try{Dt(t,e,n,r,a,i,o,u,c,s,l,f)}catch(t){if(St(p),t!==t+0)throw t;Ot(1,0)}},$:function(t,e,n,r,a,i){var o=At();try{kt(t,e,n,r,a,i)}catch(t){if(St(o),t!==t+0)throw t;Ot(1,0)}},n:function(t){return t},F:function(t){ft=t},ha:yt,y:function(t,e,n,r){return yt(t,e,n,r)}};!function(){function t(t){e.asm=t.exports,O=e.asm.Ka,P(),U=e.asm.ib,I.unshift(e.asm.La),B--,e.monitorRunDependencies&&e.monitorRunDependencies(B),0==B&&(null!==G&&(clearInterval(G),G=null),N&&(t=N,N=null,t()))}function n(e){t(e.instance)}function r(t){return function(){if(!g&&(d||y)){if("function"==typeof fetch&&!Y.startsWith("file://"))return fetch(Y,{credentials:"same-origin"}).then((function(t){if(!t.ok)throw"failed to load wasm binary file at \'"+Y+"\'";return t.arrayBuffer()})).catch((function(){return X()}));if(o)return new Promise((function(t,e){o(Y,(function(e){t(new Uint8Array(e))}),e)}))}return Promise.resolve().then((function(){return X()}))}().then((function(t){return WebAssembly.instantiate(t,i)})).then((function(t){return t})).then(t,(function(t){w("failed to asynchronously prepare wasm: "+t),V(t)}))}var i={a:bt};if(B++,e.monitorRunDependencies&&e.monitorRunDependencies(B),e.instantiateWasm)try{return e.instantiateWasm(i,t)}catch(t){return w("Module.instantiateWasm callback failed with error: "+t),!1}(g||"function"!=typeof WebAssembly.instantiateStreaming||$()||Y.startsWith("file://")||b||"function"!=typeof fetch?r(n):fetch(Y,{credentials:"same-origin"}).then((function(t){return WebAssembly.instantiateStreaming(t,i).then(n,(function(t){return w("wasm streaming compile failed: "+t),w("falling back to ArrayBuffer instantiation"),r(n)}))}))).catch(a)}(),e.___wasm_call_ctors=function(){return(e.___wasm_call_ctors=e.asm.La).apply(null,arguments)},e._OrtInit=function(){return(e._OrtInit=e.asm.Ma).apply(null,arguments)},e._OrtCreateSessionOptions=function(){return(e._OrtCreateSessionOptions=e.asm.Na).apply(null,arguments)},e._OrtAppendExecutionProvider=function(){return(e._OrtAppendExecutionProvider=e.asm.Oa).apply(null,arguments)},e._OrtAddSessionConfigEntry=function(){return(e._OrtAddSessionConfigEntry=e.asm.Pa).apply(null,arguments)},e._OrtReleaseSessionOptions=function(){return(e._OrtReleaseSessionOptions=e.asm.Qa).apply(null,arguments)},e._OrtCreateSession=function(){return(e._OrtCreateSession=e.asm.Ra).apply(null,arguments)},e._OrtReleaseSession=function(){return(e._OrtReleaseSession=e.asm.Sa).apply(null,arguments)},e._OrtGetInputCount=function(){return(e._OrtGetInputCount=e.asm.Ta).apply(null,arguments)},e._OrtGetOutputCount=function(){return(e._OrtGetOutputCount=e.asm.Ua).apply(null,arguments)},e._OrtGetInputName=function(){return(e._OrtGetInputName=e.asm.Va).apply(null,arguments)},e._OrtGetOutputName=function(){return(e._OrtGetOutputName=e.asm.Wa).apply(null,arguments)},e._OrtFree=function(){return(e._OrtFree=e.asm.Xa).apply(null,arguments)},e._OrtCreateTensor=function(){return(e._OrtCreateTensor=e.asm.Ya).apply(null,arguments)},e._OrtGetTensorData=function(){return(e._OrtGetTensorData=e.asm.Za).apply(null,arguments)},e._OrtReleaseTensor=function(){return(e._OrtReleaseTensor=e.asm._a).apply(null,arguments)},e._OrtCreateRunOptions=function(){return(e._OrtCreateRunOptions=e.asm.$a).apply(null,arguments)},e._OrtAddRunConfigEntry=function(){return(e._OrtAddRunConfigEntry=e.asm.ab).apply(null,arguments)},e._OrtReleaseRunOptions=function(){return(e._OrtReleaseRunOptions=e.asm.bb).apply(null,arguments)},e._OrtRun=function(){return(e._OrtRun=e.asm.cb).apply(null,arguments)},e._OrtEndProfiling=function(){return(e._OrtEndProfiling=e.asm.db).apply(null,arguments)};var mt,gt=e._malloc=function(){return(gt=e._malloc=e.asm.eb).apply(null,arguments)},vt=e._free=function(){return(vt=e._free=e.asm.fb).apply(null,arguments)},wt=e._fflush=function(){return(wt=e._fflush=e.asm.gb).apply(null,arguments)},_t=e.___funcs_on_exit=function(){return(_t=e.___funcs_on_exit=e.asm.hb).apply(null,arguments)},Ot=e._setThrew=function(){return(Ot=e._setThrew=e.asm.jb).apply(null,arguments)},At=e.stackSave=function(){return(At=e.stackSave=e.asm.kb).apply(null,arguments)},St=e.stackRestore=function(){return(St=e.stackRestore=e.asm.lb).apply(null,arguments)},Tt=e.stackAlloc=function(){return(Tt=e.stackAlloc=e.asm.mb).apply(null,arguments)},Et=e.___cxa_can_catch=function(){return(Et=e.___cxa_can_catch=e.asm.nb).apply(null,arguments)},Mt=e.___cxa_is_pointer_type=function(){return(Mt=e.___cxa_is_pointer_type=e.asm.ob).apply(null,arguments)},Ct=e.dynCall_j=function(){return(Ct=e.dynCall_j=e.asm.pb).apply(null,arguments)},xt=e.dynCall_iiiiij=function(){return(xt=e.dynCall_iiiiij=e.asm.qb).apply(null,arguments)},Rt=e.dynCall_jii=function(){return(Rt=e.dynCall_jii=e.asm.rb).apply(null,arguments)},jt=e.dynCall_viiiiij=function(){return(jt=e.dynCall_viiiiij=e.asm.sb).apply(null,arguments)},kt=e.dynCall_vjji=function(){return(kt=e.dynCall_vjji=e.asm.tb).apply(null,arguments)},Dt=e.dynCall_viiijjjii=function(){return(Dt=e.dynCall_viiijjjii=e.asm.ub).apply(null,arguments)},Pt=e.dynCall_iij=function(){return(Pt=e.dynCall_iij=e.asm.vb).apply(null,arguments)},Ut=e.dynCall_ji=function(){return(Ut=e.dynCall_ji=e.asm.wb).apply(null,arguments)},Ft=e.dynCall_iiiiiij=function(){return(Ft=e.dynCall_iiiiiij=e.asm.xb).apply(null,arguments)},It=e.dynCall_iiij=function(){return(It=e.dynCall_iiij=e.asm.yb).apply(null,arguments)};function Wt(){function t(){if(!mt&&(mt=!0,e.calledRun=!0,!C)){if(Z(I),r(e),e.onRuntimeInitialized&&e.onRuntimeInitialized(),e.postRun)for("function"==typeof e.postRun&&(e.postRun=[e.postRun]);e.postRun.length;){var t=e.postRun.shift();H.unshift(t)}Z(H)}}if(!(0<B)){if(e.preRun)for("function"==typeof e.preRun&&(e.preRun=[e.preRun]);e.preRun.length;)z();Z(F),0<B||(e.setStatus?(e.setStatus("Running..."),setTimeout((function(){setTimeout((function(){e.setStatus("")}),1),t()}),1)):t())}}if(e.UTF8ToString=j,e.stringToUTF8=function(t,e,n){return k(t,T,e,n)},e.lengthBytesUTF8=D,e.stackSave=At,e.stackRestore=St,e.stackAlloc=Tt,N=function t(){mt||Wt(),mt||(N=t)},e.preInit)for("function"==typeof e.preInit&&(e.preInit=[e.preInit]);0<e.preInit.length;)e.preInit.pop()();return Wt(),t.ready});t.exports=r},967:(t,e)=>{"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.iterateExtraOptions=void 0,e.iterateExtraOptions=(t,n,r,a)=>{if("object"==typeof t&&null!==t){if(r.has(t))throw new Error("Circular reference in options");r.add(t)}Object.entries(t).forEach((([t,i])=>{const o=n?n+t:t;if("object"==typeof i)(0,e.iterateExtraOptions)(i,o+".",r,a);else if("string"==typeof i||"number"==typeof i)a(o,i.toString());else{if("boolean"!=typeof i)throw new Error("Can\'t handle extra config type: "+typeof i);a(o,i?"1":"0")}}))}},586:(t,e,n)=>{"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.setRunOptions=void 0;const r=n(967),a=n(983),i=n(361);e.setRunOptions=t=>{const e=(0,i.getInstance)();let n=0;const o=[],u=t||{};try{if(void 0===(null==t?void 0:t.logSeverityLevel))u.logSeverityLevel=2;else if("number"!=typeof t.logSeverityLevel||!Number.isInteger(t.logSeverityLevel)||t.logSeverityLevel<0||t.logSeverityLevel>4)throw new Error(`log serverity level is not valid: ${t.logSeverityLevel}`);if(void 0===(null==t?void 0:t.logVerbosityLevel))u.logVerbosityLevel=0;else if("number"!=typeof t.logVerbosityLevel||!Number.isInteger(t.logVerbosityLevel))throw new Error(`log verbosity level is not valid: ${t.logVerbosityLevel}`);void 0===(null==t?void 0:t.terminate)&&(u.terminate=!1);let i=0;if(void 0!==(null==t?void 0:t.tag)&&(i=(0,a.allocWasmString)(t.tag,o)),n=e._OrtCreateRunOptions(u.logSeverityLevel,u.logVerbosityLevel,!!u.terminate,i),0===n)throw new Error("Can\'t create run options");return void 0!==(null==t?void 0:t.extra)&&(0,r.iterateExtraOptions)(t.extra,"",new WeakSet,((t,r)=>{const i=(0,a.allocWasmString)(t,o),u=(0,a.allocWasmString)(r,o);if(0!==e._OrtAddRunConfigEntry(n,i,u))throw new Error(`Can\'t set a run config entry: ${t} - ${r}`)})),[n,o]}catch(t){throw 0!==n&&e._OrtReleaseRunOptions(n),o.forEach(e._free),t}}},919:(t,e,n)=>{"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.setSessionOptions=void 0;const r=n(967),a=n(983),i=n(361);e.setSessionOptions=t=>{const e=(0,i.getInstance)();let n=0;const o=[],u=t||{};(t=>{t.extra||(t.extra={}),t.extra.session||(t.extra.session={});const e=t.extra.session;e.use_ort_model_bytes_directly||(e.use_ort_model_bytes_directly="1")})(u);try{void 0===(null==t?void 0:t.graphOptimizationLevel)&&(u.graphOptimizationLevel="all");const c=(t=>{switch(t){case"disabled":return 0;case"basic":return 1;case"extended":return 2;case"all":return 99;default:throw new Error(`unsupported graph optimization level: ${t}`)}})(u.graphOptimizationLevel);void 0===(null==t?void 0:t.enableCpuMemArena)&&(u.enableCpuMemArena=!0),void 0===(null==t?void 0:t.enableMemPattern)&&(u.enableMemPattern=!0),void 0===(null==t?void 0:t.executionMode)&&(u.executionMode="sequential");const s=(t=>{switch(t){case"sequential":return 0;case"parallel":return 1;default:throw new Error(`unsupported execution mode: ${t}`)}})(u.executionMode);let l=0;if(void 0!==(null==t?void 0:t.logId)&&(l=(0,a.allocWasmString)(t.logId,o)),void 0===(null==t?void 0:t.logSeverityLevel))u.logSeverityLevel=2;else if("number"!=typeof t.logSeverityLevel||!Number.isInteger(t.logSeverityLevel)||t.logSeverityLevel<0||t.logSeverityLevel>4)throw new Error(`log serverity level is not valid: ${t.logSeverityLevel}`);if(void 0===(null==t?void 0:t.logVerbosityLevel))u.logVerbosityLevel=0;else if("number"!=typeof t.logVerbosityLevel||!Number.isInteger(t.logVerbosityLevel))throw new Error(`log verbosity level is not valid: ${t.logVerbosityLevel}`);if(void 0===(null==t?void 0:t.enableProfiling)&&(u.enableProfiling=!1),n=e._OrtCreateSessionOptions(c,!!u.enableCpuMemArena,!!u.enableMemPattern,s,!!u.enableProfiling,0,l,u.logSeverityLevel,u.logVerbosityLevel),0===n)throw new Error("Can\'t create session options");return(null==t?void 0:t.executionProviders)&&((t,e,n)=>{for(const r of e){let e="string"==typeof r?r:r.name;switch(e){case"xnnpack":e="XNNPACK";break;case"wasm":case"cpu":continue;default:throw new Error(`not supported EP: ${e}`)}const o=(0,a.allocWasmString)(e,n);if(0!==(0,i.getInstance)()._OrtAppendExecutionProvider(t,o))throw new Error(`Can\'t append execution provider: ${e}`)}})(n,t.executionProviders,o),void 0!==(null==t?void 0:t.extra)&&(0,r.iterateExtraOptions)(t.extra,"",new WeakSet,((t,r)=>{const i=(0,a.allocWasmString)(t,o),u=(0,a.allocWasmString)(r,o);if(0!==e._OrtAddSessionConfigEntry(n,i,u))throw new Error(`Can\'t set a session config entry: ${t} - ${r}`)})),[n,o]}catch(t){throw 0!==n&&e._OrtReleaseSessionOptions(n),o.forEach(e._free),t}}},983:(t,e,n)=>{"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.allocWasmString=void 0;const r=n(361);e.allocWasmString=(t,e)=>{const n=(0,r.getInstance)(),a=n.lengthBytesUTF8(t)+1,i=n._malloc(a);return n.stringToUTF8(t,i,a),e.push(i),i}},349:(t,e,n)=>{"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.extractTransferableBuffers=e.endProfiling=e.run=e.releaseSession=e.createSession=e.createSessionFinalize=e.createSessionAllocate=e.initOrt=void 0;const r=n(586),a=n(919),i=n(983),o=n(361);e.initOrt=(t,e)=>{const n=(0,o.getInstance)()._OrtInit(t,e);if(0!==n)throw new Error(`Can\'t initialize onnxruntime. error code = ${n}`)};const u=new Map;e.createSessionAllocate=t=>{const e=(0,o.getInstance)(),n=e._malloc(t.byteLength);return e.HEAPU8.set(t,n),[n,t.byteLength]},e.createSessionFinalize=(t,e)=>{const n=(0,o.getInstance)();let r=0,i=0,c=[];try{if([i,c]=(0,a.setSessionOptions)(e),r=n._OrtCreateSession(t[0],t[1],i),0===r)throw new Error("Can\'t create a session")}finally{n._free(t[0]),n._OrtReleaseSessionOptions(i),c.forEach(n._free)}const s=n._OrtGetInputCount(r),l=n._OrtGetOutputCount(r),f=[],p=[],h=[],d=[];for(let t=0;t<s;t++){const e=n._OrtGetInputName(r,t);if(0===e)throw new Error("Can\'t get an input name");p.push(e),f.push(n.UTF8ToString(e))}for(let t=0;t<l;t++){const e=n._OrtGetOutputName(r,t);if(0===e)throw new Error("Can\'t get an output name");d.push(e),h.push(n.UTF8ToString(e))}return u.set(r,[r,p,d]),[r,f,h]},e.createSession=(t,n)=>{const r=(0,e.createSessionAllocate)(t);return(0,e.createSessionFinalize)(r,n)},e.releaseSession=t=>{const e=(0,o.getInstance)(),n=u.get(t);if(!n)throw new Error("invalid session id");const r=n[0],a=n[1],i=n[2];a.forEach(e._OrtFree),i.forEach(e._OrtFree),e._OrtReleaseSession(r),u.delete(t)};const c=t=>{switch(t){case"int8":return 3;case"uint8":return 2;case"bool":return 9;case"int16":return 5;case"uint16":return 4;case"int32":return 6;case"uint32":return 12;case"float32":return 1;case"float64":return 11;case"string":return 8;case"int64":return 7;case"uint64":return 13;default:throw new Error(`unsupported data type: ${t}`)}},s=t=>{switch(t){case 3:return"int8";case 2:return"uint8";case 9:return"bool";case 5:return"int16";case 4:return"uint16";case 6:return"int32";case 12:return"uint32";case 1:return"float32";case 11:return"float64";case 8:return"string";case 7:return"int64";case 13:return"uint64";default:throw new Error(`unsupported data type: ${t}`)}},l=t=>{switch(t){case"float32":return Float32Array;case"uint8":case"bool":return Uint8Array;case"int8":return Int8Array;case"uint16":return Uint16Array;case"int16":return Int16Array;case"int32":return Int32Array;case"float64":return Float64Array;case"uint32":return Uint32Array;case"int64":return BigInt64Array;case"uint64":return BigUint64Array;default:throw new Error(`unsupported type: ${t}`)}};e.run=(t,e,n,a,f)=>{const p=(0,o.getInstance)(),h=u.get(t);if(!h)throw new Error("invalid session id");const d=h[0],y=h[1],b=h[2],m=e.length,g=a.length;let v=0,w=[];const _=[],O=[];try{[v,w]=(0,r.setRunOptions)(f);for(let t=0;t<m;t++){const e=n[t][0],r=n[t][1],a=n[t][2];let o,u;if(Array.isArray(a)){u=4*a.length,o=p._malloc(u),O.push(o);let t=o/4;for(let e=0;e<a.length;e++){if("string"!=typeof a[e])throw new TypeError(`tensor data at index ${e} is not a string`);p.HEAPU32[t++]=(0,i.allocWasmString)(a[e],O)}}else u=a.byteLength,o=p._malloc(u),O.push(o),p.HEAPU8.set(new Uint8Array(a.buffer,a.byteOffset,u),o);const s=p.stackSave(),l=p.stackAlloc(4*r.length);try{let t=l/4;r.forEach((e=>p.HEAP32[t++]=e));const n=p._OrtCreateTensor(c(e),o,u,l,r.length);if(0===n)throw new Error("Can\'t create a tensor");_.push(n)}finally{p.stackRestore(s)}}const t=p.stackSave(),o=p.stackAlloc(4*m),u=p.stackAlloc(4*m),h=p.stackAlloc(4*g),A=p.stackAlloc(4*g);try{let n=o/4,r=u/4,i=h/4,c=A/4;for(let t=0;t<m;t++)p.HEAPU32[n++]=_[t],p.HEAPU32[r++]=y[e[t]];for(let t=0;t<g;t++)p.HEAPU32[i++]=0,p.HEAPU32[c++]=b[a[t]];let f=p._OrtRun(d,u,o,m,A,g,h,v);const w=[];if(0===f)for(let t=0;t<g;t++){const e=p.HEAPU32[h/4+t],n=p.stackSave(),r=p.stackAlloc(16);let a,i=0;try{if(f=p._OrtGetTensorData(e,r,r+4,r+8,r+12),0!==f)throw new Error(`Can\'t access output tensor data. error code = ${f}`);let t=r/4;const o=p.HEAPU32[t++];i=p.HEAPU32[t++];const u=p.HEAPU32[t++],c=p.HEAPU32[t++],h=[];for(let t=0;t<c;t++)h.push(p.HEAPU32[u/4+t]);p._OrtFree(u);const d=0===h.length?1:h.reduce(((t,e)=>t*e));if(a=s(o),"string"===a){const t=[];let e=i/4;for(let n=0;n<d;n++){const r=p.HEAPU32[e++],a=n===d-1?void 0:p.HEAPU32[e]-r;t.push(p.UTF8ToString(r,a))}w.push([a,h,t])}else{const t=new(l(a))(d);new Uint8Array(t.buffer,t.byteOffset,t.byteLength).set(p.HEAPU8.subarray(i,i+t.byteLength)),w.push([a,h,t])}}finally{p.stackRestore(n),"string"===a&&i&&p._free(i),p._OrtReleaseTensor(e)}}if(0===f)return w;throw new Error(`failed to call OrtRun(). error code = ${f}.`)}finally{p.stackRestore(t)}}finally{_.forEach(p._OrtReleaseTensor),O.forEach(p._free),p._OrtReleaseRunOptions(v),w.forEach(p._free)}},e.endProfiling=t=>{const e=(0,o.getInstance)(),n=u.get(t);if(!n)throw new Error("invalid session id");const r=n[0],a=e._OrtEndProfiling(r);if(0===a)throw new Error("Can\'t get an profile file name");e._OrtFree(a)},e.extractTransferableBuffers=t=>{const e=[];for(const n of t){const t=n[2];!Array.isArray(t)&&t.buffer&&e.push(t.buffer)}return e}},361:function(t,e,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(t,e,n,r){void 0===r&&(r=n);var a=Object.getOwnPropertyDescriptor(e,n);a&&!("get"in a?!e.__esModule:a.writable||a.configurable)||(a={enumerable:!0,get:function(){return e[n]}}),Object.defineProperty(t,r,a)}:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]}),a=this&&this.__setModuleDefault||(Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e})}:function(t,e){t.default=e}),i=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)"default"!==n&&Object.prototype.hasOwnProperty.call(t,n)&&r(e,t,n);return a(e,t),e},o=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.dispose=e.getInstance=e.initializeWebAssembly=void 0;const u=i(n(449)),c=o(n(932)),s=n(474);let l,f=!1,p=!1,h=!1;const d=(t,e)=>e?t?"ort-wasm-simd-threaded.wasm":"ort-wasm-threaded.wasm":t?"ort-wasm-simd.wasm":"ort-wasm.wasm";e.initializeWebAssembly=async t=>{if(f)return Promise.resolve();if(p)throw new Error("multiple calls to \'initializeWebAssembly()\' detected.");if(h)throw new Error("previous call to \'initializeWebAssembly()\' failed.");p=!0;const e=t.initTimeout,r=t.numThreads,a=t.simd,i=r>1&&(()=>{try{return"undefined"!=typeof SharedArrayBuffer&&("undefined"!=typeof MessageChannel&&(new MessageChannel).port1.postMessage(new SharedArrayBuffer(1)),WebAssembly.validate(new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,5,4,1,3,1,1,10,11,1,9,0,65,0,254,16,2,0,26,11])))}catch(t){return!1}})(),o=a&&(()=>{try{return WebAssembly.validate(new Uint8Array([0,97,115,109,1,0,0,0,1,4,1,96,0,0,3,2,1,0,10,30,1,28,0,65,0,253,15,253,12,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,253,186,1,26,11]))}catch(t){return!1}})(),y="string"==typeof t.wasmPaths?t.wasmPaths:void 0,b=d(!1,i),m=d(o,i),g="object"==typeof t.wasmPaths?t.wasmPaths[m]:void 0;let v=!1;const w=[];if(e>0&&w.push(new Promise((t=>{setTimeout((()=>{v=!0,t()}),e)}))),w.push(new Promise(((t,e)=>{const r=i?s:c.default,a={locateFile:(t,e)=>i&&t.endsWith(".worker.js")&&"undefined"!=typeof Blob?URL.createObjectURL(new Blob([n(154)],{type:"text/javascript"})):t===b?null!=g?g:(null!=y?y:e)+m:e+t};if(i)if("undefined"==typeof Blob)a.mainScriptUrlOrBlob=u.join("/","ort-wasm-threaded.js");else{const t=`var ortWasmThreaded=(function(){var _scriptDir;return ${r.toString()}})();`;a.mainScriptUrlOrBlob=new Blob([t],{type:"text/javascript"})}r(a).then((e=>{p=!1,f=!0,l=e,t()}),(t=>{p=!1,h=!0,e(t)}))}))),await Promise.race(w),v)throw new Error(`WebAssembly backend initializing failed due to timeout: ${e}ms`)},e.getInstance=()=>{if(f&&l)return l;throw new Error("WebAssembly is not initialized yet.")},e.dispose=()=>{var t;!f||p||h||(p=!0,null===(t=l.PThread)||void 0===t||t.terminateAllThreads(),l=void 0,p=!1,f=!1,h=!0)}},154:t=>{"use strict";t.exports=\'"use strict";var e={},t="object"==typeof process&&"object"==typeof process.versions&&"string"==typeof process.versions.node;if(t){var r=require("worker_threads"),a=r.parentPort;a.on("message",(e=>onmessage({data:e})));var o=require("fs");Object.assign(global,{self:global,require:require,Module:e,location:{href:__filename},Worker:r.Worker,importScripts:function(e){(0,eval)(o.readFileSync(e,"utf8"))},postMessage:function(e){a.postMessage(e)},performance:global.performance||{now:function(){return Date.now()}}})}var s=!1,n=[],i=function(){var e=Array.prototype.slice.call(arguments).join(" ");t?o.writeSync(2,e+"\\\\n"):console.error(e)};self.alert=function(){var t=Array.prototype.slice.call(arguments).join(" ");postMessage({cmd:"alert",text:t,threadId:e._pthread_self()})},e.instantiateWasm=(t,r)=>{var a=new WebAssembly.Instance(e.wasmModule,t);return r(a),e.wasmModule=null,a.exports},self.onunhandledrejection=e=>{throw e.reason??e},self.onmessage=t=>{try{if("load"===t.data.cmd){if(e.wasmModule=t.data.wasmModule,e.wasmMemory=t.data.wasmMemory,e.buffer=e.wasmMemory.buffer,e.ENVIRONMENT_IS_PTHREAD=!0,"string"==typeof t.data.urlOrBlob)importScripts(t.data.urlOrBlob);else{var r=URL.createObjectURL(t.data.urlOrBlob);importScripts(r),URL.revokeObjectURL(r)}ortWasmThreaded(e).then((function(t){e=t}))}else if("run"===t.data.cmd){e.__performance_now_clock_drift=performance.now()-t.data.time,e.__emscripten_thread_init(t.data.pthread_ptr,0,0,1),e.establishStackSpace(),e.PThread.receiveObjectTransfer(t.data),e.PThread.threadInitTLS(),s||(n.forEach((t=>{e.executeNotifiedProxyingQueue(t)})),n=[],s=!0);try{e.invokeEntryPoint(t.data.start_routine,t.data.arg)}catch(t){if("unwind"!=t){if(!(t instanceof e.ExitStatus))throw t;e.keepRuntimeAlive()||e.__emscripten_thread_exit(t.status)}}}else"cancel"===t.data.cmd?e._pthread_self()&&e.__emscripten_thread_exit(-1):"setimmediate"===t.data.target||("processProxyingQueue"===t.data.cmd?s?e.executeNotifiedProxyingQueue(t.data.queue):n.push(t.data.queue):(i("worker.js received unknown command "+t.data.cmd),i(t.data)))}catch(t){throw i("worker.js onmessage() captured an uncaught exception: "+t),t&&t.stack&&i(t.stack),e.__emscripten_thread_crashed&&e.__emscripten_thread_crashed(),t}};\\n\'},384:()=>{},993:()=>{},908:()=>{},953:()=>{},925:()=>{},449:()=>{}},e={};function n(r){var a=e[r];if(void 0!==a)return a.exports;var i=e[r]={exports:{}};return t[r].call(i.exports,i,i.exports,n),i.exports}n.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(t){if("object"==typeof window)return window}}(),(()=>{"use strict";const t=n(349),e=n(361);self.onmessage=n=>{switch(n.data.type){case"init-wasm":(0,e.initializeWebAssembly)(n.data.in).then((()=>postMessage({type:"init-wasm"})),(t=>postMessage({type:"init-wasm",err:t})));break;case"init-ort":try{const{numThreads:e,loggingLevel:r}=n.data.in;(0,t.initOrt)(e,r),postMessage({type:"init-ort"})}catch(t){postMessage({type:"init-ort",err:t})}break;case"create_allocate":try{const{model:e}=n.data.in,r=(0,t.createSessionAllocate)(e);postMessage({type:"create_allocate",out:r})}catch(t){postMessage({type:"create_allocate",err:t})}break;case"create_finalize":try{const{modeldata:e,options:r}=n.data.in,a=(0,t.createSessionFinalize)(e,r);postMessage({type:"create_finalize",out:a})}catch(t){postMessage({type:"create_finalize",err:t})}break;case"create":try{const{model:e,options:r}=n.data.in,a=(0,t.createSession)(e,r);postMessage({type:"create",out:a})}catch(t){postMessage({type:"create",err:t})}break;case"release":try{const e=n.data.in;(0,t.releaseSession)(e),postMessage({type:"release"})}catch(t){postMessage({type:"release",err:t})}break;case"run":try{const{sessionId:e,inputIndices:r,inputs:a,outputIndices:i,options:o}=n.data.in,u=(0,t.run)(e,r,a,i,o);postMessage({type:"run",out:u},(0,t.extractTransferableBuffers)(u))}catch(t){postMessage({type:"run",err:t})}break;case"end-profiling":try{const e=n.data.in;(0,t.endProfiling)(e),postMessage({type:"end-profiling"})}catch(t){postMessage({type:"end-profiling",err:t})}}}})()})();\n',
                    `Worker`,
                    void 0,
                    void 0,
                  );
                }
              },
              477: (e) => {
                'use strict';
                e.exports = function (e, t, n, r) {
                  var i = self || window;
                  try {
                    try {
                      var a;
                      try {
                        a = new i.Blob([e]);
                      } catch {
                        ((a = new (
                          i.BlobBuilder ||
                          i.WebKitBlobBuilder ||
                          i.MozBlobBuilder ||
                          i.MSBlobBuilder
                        )()).append(e),
                          (a = a.getBlob()));
                      }
                      var o = i.URL || i.webkitURL,
                        s = o.createObjectURL(a),
                        c = new i[t](s, n);
                      return (o.revokeObjectURL(s), c);
                    } catch {
                      return new i[t](`data:application/javascript,${encodeURIComponent(e)}`, n);
                    }
                  } catch {
                    if (!r) throw Error(`Inline worker is not supported`);
                    return new i[t](r, n);
                  }
                };
              },
              4154: (e) => {
                'use strict';
                e.exports = `"use strict";var e={},t="object"==typeof process&&"object"==typeof process.versions&&"string"==typeof process.versions.node;if(t){var r=require("worker_threads"),a=r.parentPort;a.on("message",(e=>onmessage({data:e})));var o=require("fs");Object.assign(global,{self:global,require:require,Module:e,location:{href:__filename},Worker:r.Worker,importScripts:function(e){(0,eval)(o.readFileSync(e,"utf8"))},postMessage:function(e){a.postMessage(e)},performance:global.performance||{now:function(){return Date.now()}}})}var s=!1,n=[],i=function(){var e=Array.prototype.slice.call(arguments).join(" ");t?o.writeSync(2,e+"\\n"):console.error(e)};self.alert=function(){var t=Array.prototype.slice.call(arguments).join(" ");postMessage({cmd:"alert",text:t,threadId:e._pthread_self()})},e.instantiateWasm=(t,r)=>{var a=new WebAssembly.Instance(e.wasmModule,t);return r(a),e.wasmModule=null,a.exports},self.onunhandledrejection=e=>{throw e.reason??e},self.onmessage=t=>{try{if("load"===t.data.cmd){if(e.wasmModule=t.data.wasmModule,e.wasmMemory=t.data.wasmMemory,e.buffer=e.wasmMemory.buffer,e.ENVIRONMENT_IS_PTHREAD=!0,"string"==typeof t.data.urlOrBlob)importScripts(t.data.urlOrBlob);else{var r=URL.createObjectURL(t.data.urlOrBlob);importScripts(r),URL.revokeObjectURL(r)}ortWasmThreaded(e).then((function(t){e=t}))}else if("run"===t.data.cmd){e.__performance_now_clock_drift=performance.now()-t.data.time,e.__emscripten_thread_init(t.data.pthread_ptr,0,0,1),e.establishStackSpace(),e.PThread.receiveObjectTransfer(t.data),e.PThread.threadInitTLS(),s||(n.forEach((t=>{e.executeNotifiedProxyingQueue(t)})),n=[],s=!0);try{e.invokeEntryPoint(t.data.start_routine,t.data.arg)}catch(t){if("unwind"!=t){if(!(t instanceof e.ExitStatus))throw t;e.keepRuntimeAlive()||e.__emscripten_thread_exit(t.status)}}}else"cancel"===t.data.cmd?e._pthread_self()&&e.__emscripten_thread_exit(-1):"setimmediate"===t.data.target||("processProxyingQueue"===t.data.cmd?s?e.executeNotifiedProxyingQueue(t.data.queue):n.push(t.data.queue):(i("worker.js received unknown command "+t.data.cmd),i(t.data)))}catch(t){throw i("worker.js onmessage() captured an uncaught exception: "+t),t&&t.stack&&i(t.stack),e.__emscripten_thread_crashed&&e.__emscripten_thread_crashed(),t}};
`;
              },
              1670: (e) => {
                'use strict';
                e.exports = __WEBPACK_EXTERNAL_MODULE__1670__;
              },
              7067: () => {},
              1296: () => {},
              1384: () => {},
              3993: () => {},
              908: () => {},
              6953: () => {},
              9925: () => {},
              2806: () => {},
              6449: () => {},
              2850: () => {},
              5381: () => {},
              5686: (e, t, n) => {
                'use strict';
                (n.r(t), n.d(t, { flatbuffers: () => r }));
                var r = {};
                (r.Offset,
                  r.Table,
                  (r.SIZEOF_SHORT = 2),
                  (r.SIZEOF_INT = 4),
                  (r.FILE_IDENTIFIER_LENGTH = 4),
                  (r.SIZE_PREFIX_LENGTH = 4),
                  (r.Encoding = { UTF8_BYTES: 1, UTF16_STRING: 2 }),
                  (r.int32 = new Int32Array(2)),
                  (r.float32 = new Float32Array(r.int32.buffer)),
                  (r.float64 = new Float64Array(r.int32.buffer)),
                  (r.isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1),
                  (r.Long = function (e, t) {
                    ((this.low = 0 | e), (this.high = 0 | t));
                  }),
                  (r.Long.create = function (e, t) {
                    return e == 0 && t == 0 ? r.Long.ZERO : new r.Long(e, t);
                  }),
                  (r.Long.prototype.toFloat64 = function () {
                    return (this.low >>> 0) + 4294967296 * this.high;
                  }),
                  (r.Long.prototype.equals = function (e) {
                    return this.low == e.low && this.high == e.high;
                  }),
                  (r.Long.ZERO = new r.Long(0, 0)),
                  (r.Builder = function (e) {
                    if (e) t = e;
                    else var t = 1024;
                    ((this.bb = r.ByteBuffer.allocate(t)),
                      (this.space = t),
                      (this.minalign = 1),
                      (this.vtable = null),
                      (this.vtable_in_use = 0),
                      (this.isNested = !1),
                      (this.object_start = 0),
                      (this.vtables = []),
                      (this.vector_num_elems = 0),
                      (this.force_defaults = !1));
                  }),
                  (r.Builder.prototype.clear = function () {
                    (this.bb.clear(),
                      (this.space = this.bb.capacity()),
                      (this.minalign = 1),
                      (this.vtable = null),
                      (this.vtable_in_use = 0),
                      (this.isNested = !1),
                      (this.object_start = 0),
                      (this.vtables = []),
                      (this.vector_num_elems = 0),
                      (this.force_defaults = !1));
                  }),
                  (r.Builder.prototype.forceDefaults = function (e) {
                    this.force_defaults = e;
                  }),
                  (r.Builder.prototype.dataBuffer = function () {
                    return this.bb;
                  }),
                  (r.Builder.prototype.asUint8Array = function () {
                    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
                  }),
                  (r.Builder.prototype.prep = function (e, t) {
                    e > this.minalign && (this.minalign = e);
                    for (var n = (1 + ~(this.bb.capacity() - this.space + t)) & (e - 1); this.space < n + e + t; ) {
                      var i = this.bb.capacity();
                      ((this.bb = r.Builder.growByteBuffer(this.bb)), (this.space += this.bb.capacity() - i));
                    }
                    this.pad(n);
                  }),
                  (r.Builder.prototype.pad = function (e) {
                    for (var t = 0; t < e; t++) this.bb.writeInt8(--this.space, 0);
                  }),
                  (r.Builder.prototype.writeInt8 = function (e) {
                    this.bb.writeInt8(--this.space, e);
                  }),
                  (r.Builder.prototype.writeInt16 = function (e) {
                    this.bb.writeInt16((this.space -= 2), e);
                  }),
                  (r.Builder.prototype.writeInt32 = function (e) {
                    this.bb.writeInt32((this.space -= 4), e);
                  }),
                  (r.Builder.prototype.writeInt64 = function (e) {
                    this.bb.writeInt64((this.space -= 8), e);
                  }),
                  (r.Builder.prototype.writeFloat32 = function (e) {
                    this.bb.writeFloat32((this.space -= 4), e);
                  }),
                  (r.Builder.prototype.writeFloat64 = function (e) {
                    this.bb.writeFloat64((this.space -= 8), e);
                  }),
                  (r.Builder.prototype.addInt8 = function (e) {
                    (this.prep(1, 0), this.writeInt8(e));
                  }),
                  (r.Builder.prototype.addInt16 = function (e) {
                    (this.prep(2, 0), this.writeInt16(e));
                  }),
                  (r.Builder.prototype.addInt32 = function (e) {
                    (this.prep(4, 0), this.writeInt32(e));
                  }),
                  (r.Builder.prototype.addInt64 = function (e) {
                    (this.prep(8, 0), this.writeInt64(e));
                  }),
                  (r.Builder.prototype.addFloat32 = function (e) {
                    (this.prep(4, 0), this.writeFloat32(e));
                  }),
                  (r.Builder.prototype.addFloat64 = function (e) {
                    (this.prep(8, 0), this.writeFloat64(e));
                  }),
                  (r.Builder.prototype.addFieldInt8 = function (e, t, n) {
                    (this.force_defaults || t != n) && (this.addInt8(t), this.slot(e));
                  }),
                  (r.Builder.prototype.addFieldInt16 = function (e, t, n) {
                    (this.force_defaults || t != n) && (this.addInt16(t), this.slot(e));
                  }),
                  (r.Builder.prototype.addFieldInt32 = function (e, t, n) {
                    (this.force_defaults || t != n) && (this.addInt32(t), this.slot(e));
                  }),
                  (r.Builder.prototype.addFieldInt64 = function (e, t, n) {
                    (!this.force_defaults && t.equals(n)) || (this.addInt64(t), this.slot(e));
                  }),
                  (r.Builder.prototype.addFieldFloat32 = function (e, t, n) {
                    (this.force_defaults || t != n) && (this.addFloat32(t), this.slot(e));
                  }),
                  (r.Builder.prototype.addFieldFloat64 = function (e, t, n) {
                    (this.force_defaults || t != n) && (this.addFloat64(t), this.slot(e));
                  }),
                  (r.Builder.prototype.addFieldOffset = function (e, t, n) {
                    (this.force_defaults || t != n) && (this.addOffset(t), this.slot(e));
                  }),
                  (r.Builder.prototype.addFieldStruct = function (e, t, n) {
                    t != n && (this.nested(t), this.slot(e));
                  }),
                  (r.Builder.prototype.nested = function (e) {
                    if (e != this.offset()) throw Error(`FlatBuffers: struct must be serialized inline.`);
                  }),
                  (r.Builder.prototype.notNested = function () {
                    if (this.isNested) throw Error(`FlatBuffers: object serialization must not be nested.`);
                  }),
                  (r.Builder.prototype.slot = function (e) {
                    this.vtable[e] = this.offset();
                  }),
                  (r.Builder.prototype.offset = function () {
                    return this.bb.capacity() - this.space;
                  }),
                  (r.Builder.growByteBuffer = function (e) {
                    var t = e.capacity();
                    if (3221225472 & t) throw Error(`FlatBuffers: cannot grow buffer beyond 2 gigabytes.`);
                    var n = t << 1,
                      i = r.ByteBuffer.allocate(n);
                    return (i.setPosition(n - t), i.bytes().set(e.bytes(), n - t), i);
                  }),
                  (r.Builder.prototype.addOffset = function (e) {
                    (this.prep(r.SIZEOF_INT, 0), this.writeInt32(this.offset() - e + r.SIZEOF_INT));
                  }),
                  (r.Builder.prototype.startObject = function (e) {
                    (this.notNested(), (this.vtable ??= []), (this.vtable_in_use = e));
                    for (var t = 0; t < e; t++) this.vtable[t] = 0;
                    ((this.isNested = !0), (this.object_start = this.offset()));
                  }),
                  (r.Builder.prototype.endObject = function () {
                    if (this.vtable == null || !this.isNested)
                      throw Error(`FlatBuffers: endObject called without startObject`);
                    this.addInt32(0);
                    for (var e = this.offset(), t = this.vtable_in_use - 1; t >= 0 && this.vtable[t] == 0; t--);
                    for (var n = t + 1; t >= 0; t--) this.addInt16(this.vtable[t] == 0 ? 0 : e - this.vtable[t]);
                    this.addInt16(e - this.object_start);
                    var i = (n + 2) * r.SIZEOF_SHORT;
                    this.addInt16(i);
                    var a = 0,
                      o = this.space;
                    t: for (t = 0; t < this.vtables.length; t++) {
                      var s = this.bb.capacity() - this.vtables[t];
                      if (i == this.bb.readInt16(s)) {
                        for (var c = r.SIZEOF_SHORT; c < i; c += r.SIZEOF_SHORT)
                          if (this.bb.readInt16(o + c) != this.bb.readInt16(s + c)) continue t;
                        a = this.vtables[t];
                        break;
                      }
                    }
                    return (
                      a
                        ? ((this.space = this.bb.capacity() - e), this.bb.writeInt32(this.space, a - e))
                        : (this.vtables.push(this.offset()),
                          this.bb.writeInt32(this.bb.capacity() - e, this.offset() - e)),
                      (this.isNested = !1),
                      e
                    );
                  }),
                  (r.Builder.prototype.finish = function (e, t, n) {
                    var i = n ? r.SIZE_PREFIX_LENGTH : 0;
                    if (t) {
                      var a = t;
                      if (
                        (this.prep(this.minalign, r.SIZEOF_INT + r.FILE_IDENTIFIER_LENGTH + i),
                        a.length != r.FILE_IDENTIFIER_LENGTH)
                      )
                        throw Error(`FlatBuffers: file identifier must be length ` + r.FILE_IDENTIFIER_LENGTH);
                      for (var o = r.FILE_IDENTIFIER_LENGTH - 1; o >= 0; o--) this.writeInt8(a.charCodeAt(o));
                    }
                    (this.prep(this.minalign, r.SIZEOF_INT + i),
                      this.addOffset(e),
                      i && this.addInt32(this.bb.capacity() - this.space),
                      this.bb.setPosition(this.space));
                  }),
                  (r.Builder.prototype.finishSizePrefixed = function (e, t) {
                    this.finish(e, t, !0);
                  }),
                  (r.Builder.prototype.requiredField = function (e, t) {
                    var n = this.bb.capacity() - e,
                      r = n - this.bb.readInt32(n);
                    if (this.bb.readInt16(r + t) == 0) throw Error(`FlatBuffers: field ` + t + ` must be set`);
                  }),
                  (r.Builder.prototype.startVector = function (e, t, n) {
                    (this.notNested(),
                      (this.vector_num_elems = t),
                      this.prep(r.SIZEOF_INT, e * t),
                      this.prep(n, e * t));
                  }),
                  (r.Builder.prototype.endVector = function () {
                    return (this.writeInt32(this.vector_num_elems), this.offset());
                  }),
                  (r.Builder.prototype.createString = function (e) {
                    if (e instanceof Uint8Array) var t = e;
                    else {
                      t = [];
                      for (var n = 0; n < e.length; ) {
                        var r,
                          i = e.charCodeAt(n++);
                        (r = i < 55296 || i >= 56320 ? i : (i << 10) + e.charCodeAt(n++) + -56613888) < 128
                          ? t.push(r)
                          : (r < 2048
                              ? t.push(((r >> 6) & 31) | 192)
                              : (r < 65536
                                  ? t.push(((r >> 12) & 15) | 224)
                                  : t.push(((r >> 18) & 7) | 240, ((r >> 12) & 63) | 128),
                                t.push(((r >> 6) & 63) | 128)),
                            t.push((63 & r) | 128));
                      }
                    }
                    (this.addInt8(0),
                      this.startVector(1, t.length, 1),
                      this.bb.setPosition((this.space -= t.length)),
                      (n = 0));
                    for (var a = this.space, o = this.bb.bytes(); n < t.length; n++) o[a++] = t[n];
                    return this.endVector();
                  }),
                  (r.Builder.prototype.createLong = function (e, t) {
                    return r.Long.create(e, t);
                  }),
                  (r.ByteBuffer = function (e) {
                    ((this.bytes_ = e), (this.position_ = 0));
                  }),
                  (r.ByteBuffer.allocate = function (e) {
                    return new r.ByteBuffer(new Uint8Array(e));
                  }),
                  (r.ByteBuffer.prototype.clear = function () {
                    this.position_ = 0;
                  }),
                  (r.ByteBuffer.prototype.bytes = function () {
                    return this.bytes_;
                  }),
                  (r.ByteBuffer.prototype.position = function () {
                    return this.position_;
                  }),
                  (r.ByteBuffer.prototype.setPosition = function (e) {
                    this.position_ = e;
                  }),
                  (r.ByteBuffer.prototype.capacity = function () {
                    return this.bytes_.length;
                  }),
                  (r.ByteBuffer.prototype.readInt8 = function (e) {
                    return (this.readUint8(e) << 24) >> 24;
                  }),
                  (r.ByteBuffer.prototype.readUint8 = function (e) {
                    return this.bytes_[e];
                  }),
                  (r.ByteBuffer.prototype.readInt16 = function (e) {
                    return (this.readUint16(e) << 16) >> 16;
                  }),
                  (r.ByteBuffer.prototype.readUint16 = function (e) {
                    return this.bytes_[e] | (this.bytes_[e + 1] << 8);
                  }),
                  (r.ByteBuffer.prototype.readInt32 = function (e) {
                    return (
                      this.bytes_[e] |
                      (this.bytes_[e + 1] << 8) |
                      (this.bytes_[e + 2] << 16) |
                      (this.bytes_[e + 3] << 24)
                    );
                  }),
                  (r.ByteBuffer.prototype.readUint32 = function (e) {
                    return this.readInt32(e) >>> 0;
                  }),
                  (r.ByteBuffer.prototype.readInt64 = function (e) {
                    return new r.Long(this.readInt32(e), this.readInt32(e + 4));
                  }),
                  (r.ByteBuffer.prototype.readUint64 = function (e) {
                    return new r.Long(this.readUint32(e), this.readUint32(e + 4));
                  }),
                  (r.ByteBuffer.prototype.readFloat32 = function (e) {
                    return ((r.int32[0] = this.readInt32(e)), r.float32[0]);
                  }),
                  (r.ByteBuffer.prototype.readFloat64 = function (e) {
                    return (
                      (r.int32[+!r.isLittleEndian] = this.readInt32(e)),
                      (r.int32[+!!r.isLittleEndian] = this.readInt32(e + 4)),
                      r.float64[0]
                    );
                  }),
                  (r.ByteBuffer.prototype.writeInt8 = function (e, t) {
                    this.bytes_[e] = t;
                  }),
                  (r.ByteBuffer.prototype.writeUint8 = function (e, t) {
                    this.bytes_[e] = t;
                  }),
                  (r.ByteBuffer.prototype.writeInt16 = function (e, t) {
                    ((this.bytes_[e] = t), (this.bytes_[e + 1] = t >> 8));
                  }),
                  (r.ByteBuffer.prototype.writeUint16 = function (e, t) {
                    ((this.bytes_[e] = t), (this.bytes_[e + 1] = t >> 8));
                  }),
                  (r.ByteBuffer.prototype.writeInt32 = function (e, t) {
                    ((this.bytes_[e] = t),
                      (this.bytes_[e + 1] = t >> 8),
                      (this.bytes_[e + 2] = t >> 16),
                      (this.bytes_[e + 3] = t >> 24));
                  }),
                  (r.ByteBuffer.prototype.writeUint32 = function (e, t) {
                    ((this.bytes_[e] = t),
                      (this.bytes_[e + 1] = t >> 8),
                      (this.bytes_[e + 2] = t >> 16),
                      (this.bytes_[e + 3] = t >> 24));
                  }),
                  (r.ByteBuffer.prototype.writeInt64 = function (e, t) {
                    (this.writeInt32(e, t.low), this.writeInt32(e + 4, t.high));
                  }),
                  (r.ByteBuffer.prototype.writeUint64 = function (e, t) {
                    (this.writeUint32(e, t.low), this.writeUint32(e + 4, t.high));
                  }),
                  (r.ByteBuffer.prototype.writeFloat32 = function (e, t) {
                    ((r.float32[0] = t), this.writeInt32(e, r.int32[0]));
                  }),
                  (r.ByteBuffer.prototype.writeFloat64 = function (e, t) {
                    ((r.float64[0] = t),
                      this.writeInt32(e, r.int32[+!r.isLittleEndian]),
                      this.writeInt32(e + 4, r.int32[+!!r.isLittleEndian]));
                  }),
                  (r.ByteBuffer.prototype.getBufferIdentifier = function () {
                    if (this.bytes_.length < this.position_ + r.SIZEOF_INT + r.FILE_IDENTIFIER_LENGTH)
                      throw Error(`FlatBuffers: ByteBuffer is too short to contain an identifier.`);
                    for (var e = ``, t = 0; t < r.FILE_IDENTIFIER_LENGTH; t++)
                      e += String.fromCharCode(this.readInt8(this.position_ + r.SIZEOF_INT + t));
                    return e;
                  }),
                  (r.ByteBuffer.prototype.__offset = function (e, t) {
                    var n = e - this.readInt32(e);
                    return t < this.readInt16(n) ? this.readInt16(n + t) : 0;
                  }),
                  (r.ByteBuffer.prototype.__union = function (e, t) {
                    return ((e.bb_pos = t + this.readInt32(t)), (e.bb = this), e);
                  }),
                  (r.ByteBuffer.prototype.__string = function (e, t) {
                    e += this.readInt32(e);
                    var n = this.readInt32(e),
                      i = ``,
                      a = 0;
                    if (((e += r.SIZEOF_INT), t === r.Encoding.UTF8_BYTES)) return this.bytes_.subarray(e, e + n);
                    for (; a < n; ) {
                      var o,
                        s = this.readUint8(e + a++);
                      if (s < 192) o = s;
                      else {
                        var c = this.readUint8(e + a++);
                        if (s < 224) o = ((31 & s) << 6) | (63 & c);
                        else {
                          var l = this.readUint8(e + a++);
                          o =
                            s < 240
                              ? ((15 & s) << 12) | ((63 & c) << 6) | (63 & l)
                              : ((7 & s) << 18) | ((63 & c) << 12) | ((63 & l) << 6) | (63 & this.readUint8(e + a++));
                        }
                      }
                      o < 65536
                        ? (i += String.fromCharCode(o))
                        : ((o -= 65536), (i += String.fromCharCode(55296 + (o >> 10), 56320 + (1023 & o))));
                    }
                    return i;
                  }),
                  (r.ByteBuffer.prototype.__indirect = function (e) {
                    return e + this.readInt32(e);
                  }),
                  (r.ByteBuffer.prototype.__vector = function (e) {
                    return e + this.readInt32(e) + r.SIZEOF_INT;
                  }),
                  (r.ByteBuffer.prototype.__vector_len = function (e) {
                    return this.readInt32(e + this.readInt32(e));
                  }),
                  (r.ByteBuffer.prototype.__has_identifier = function (e) {
                    if (e.length != r.FILE_IDENTIFIER_LENGTH)
                      throw Error(`FlatBuffers: file identifier must be length ` + r.FILE_IDENTIFIER_LENGTH);
                    for (var t = 0; t < r.FILE_IDENTIFIER_LENGTH; t++)
                      if (e.charCodeAt(t) != this.readInt8(this.position_ + r.SIZEOF_INT + t)) return !1;
                    return !0;
                  }),
                  (r.ByteBuffer.prototype.createLong = function (e, t) {
                    return r.Long.create(e, t);
                  }));
              },
            },
            __webpack_module_cache__ = {};
          function __webpack_require__(e) {
            var t = __webpack_module_cache__[e];
            if (t !== void 0) return t.exports;
            var n = (__webpack_module_cache__[e] = { exports: {} });
            return (__webpack_modules__[e].call(n.exports, n, n.exports, __webpack_require__), n.exports);
          }
          ((__webpack_require__.n = (e) => {
            var t = e && e.__esModule ? () => e.default : () => e;
            return (__webpack_require__.d(t, { a: t }), t);
          }),
            (__webpack_require__.d = (e, t) => {
              for (var n in t)
                __webpack_require__.o(t, n) &&
                  !__webpack_require__.o(e, n) &&
                  Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
            }),
            (__webpack_require__.g = (function () {
              if (typeof globalThis == `object`) return globalThis;
              try {
                return this || Function(`return this`)();
              } catch {
                if (typeof window == `object`) return window;
              }
            })()),
            (__webpack_require__.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
            (__webpack_require__.r = (e) => {
              (typeof Symbol < `u` &&
                Symbol.toStringTag &&
                Object.defineProperty(e, Symbol.toStringTag, { value: `Module` }),
                Object.defineProperty(e, `__esModule`, { value: !0 }));
            }));
          var __webpack_exports__ = __webpack_require__(6018);
          return __webpack_exports__;
        })(),
      );
    }),
    import___vite_browser_external = __toESM(require___vite_browser_external(), 1),
    import_ort_web_min = __toESM(require_ort_web_min(), 1);
  let ONNX;
  const executionProviders = [`wasm`];
  typeof process < `u` && process?.release?.name === `node`
    ? ((ONNX = import___vite_browser_external.default ?? import___vite_browser_external),
      executionProviders.unshift(`cpu`))
    : ((ONNX = import_ort_web_min.default ?? import_ort_web_min),
      typeof navigator < `u` &&
        /iP(hone|od|ad).+16_4.+AppleWebKit/.test(navigator.userAgent) &&
        (ONNX.env.wasm.simd = !1));
  const { env: onnx_env } = ONNX,
    VERSION = `2.17.2`,
    WEB_CACHE_AVAILABLE = typeof self < `u` && `caches` in self,
    FS_AVAILABLE = !isEmpty(import___vite_browser_external.default),
    PATH_AVAILABLE = !isEmpty(import___vite_browser_external.default),
    RUNNING_LOCALLY = FS_AVAILABLE && PATH_AVAILABLE,
    __dirname = RUNNING_LOCALLY
      ? import___vite_browser_external.default.dirname(
          import___vite_browser_external.default.dirname(
            import___vite_browser_external.default.fileURLToPath(self.location.href),
          ),
        )
      : `./`,
    DEFAULT_CACHE_DIR = RUNNING_LOCALLY ? import___vite_browser_external.default.join(__dirname, `/.cache/`) : null,
    DEFAULT_LOCAL_MODEL_PATH = `/models/`,
    localModelPath = RUNNING_LOCALLY
      ? import___vite_browser_external.default.join(__dirname, DEFAULT_LOCAL_MODEL_PATH)
      : DEFAULT_LOCAL_MODEL_PATH;
  onnx_env?.wasm &&
    (onnx_env.wasm.wasmPaths = RUNNING_LOCALLY
      ? import___vite_browser_external.default.join(__dirname, `/dist/`)
      : `https://cdn.jsdelivr.net/npm/@xenova/transformers@${VERSION}/dist/`);
  const env$1 = {
    backends: { onnx: onnx_env, tfjs: {} },
    __dirname,
    version: VERSION,
    allowRemoteModels: !0,
    remoteHost: `https://huggingface.co/`,
    remotePathTemplate: `{model}/resolve/{revision}/`,
    allowLocalModels: !0,
    localModelPath,
    useFS: FS_AVAILABLE,
    useBrowserCache: WEB_CACHE_AVAILABLE,
    useFSCache: FS_AVAILABLE,
    cacheDir: DEFAULT_CACHE_DIR,
    useCustomCache: !1,
    customCache: null,
  };
  function isEmpty(e) {
    return Object.keys(e).length === 0;
  }
  var FileResponse = class e {
    _CONTENT_TYPE_MAP = {
      txt: `text/plain`,
      html: `text/html`,
      css: `text/css`,
      js: `text/javascript`,
      json: `application/json`,
      png: `image/png`,
      jpg: `image/jpeg`,
      jpeg: `image/jpeg`,
      gif: `image/gif`,
    };
    constructor(e) {
      if (
        ((this.filePath = e),
        (this.headers = new Headers()),
        (this.exists = import___vite_browser_external.default.existsSync(e)),
        this.exists)
      ) {
        ((this.status = 200), (this.statusText = `OK`));
        let t = import___vite_browser_external.default.statSync(e);
        (this.headers.set(`content-length`, t.size.toString()), this.updateContentType());
        let n = this;
        this.body = new ReadableStream({
          start(e) {
            n.arrayBuffer().then((t) => {
              (e.enqueue(new Uint8Array(t)), e.close());
            });
          },
        });
      } else ((this.status = 404), (this.statusText = `Not Found`), (this.body = null));
    }
    updateContentType() {
      let e = this.filePath.toString().split(`.`).pop().toLowerCase();
      this.headers.set(`content-type`, this._CONTENT_TYPE_MAP[e] ?? `application/octet-stream`);
    }
    clone() {
      let t = new e(this.filePath);
      return (
        (t.exists = this.exists),
        (t.status = this.status),
        (t.statusText = this.statusText),
        (t.headers = new Headers(this.headers)),
        t
      );
    }
    async arrayBuffer() {
      return (await import___vite_browser_external.default.promises.readFile(this.filePath)).buffer;
    }
    async blob() {
      let e = await import___vite_browser_external.default.promises.readFile(this.filePath);
      return new Blob([e], { type: this.headers.get(`content-type`) });
    }
    async text() {
      return await import___vite_browser_external.default.promises.readFile(this.filePath, `utf8`);
    }
    async json() {
      return JSON.parse(await this.text());
    }
  };
  function isValidUrl(e, t = null, n = null) {
    let r;
    try {
      r = new URL(e);
    } catch {
      return !1;
    }
    return !((t && !t.includes(r.protocol)) || (n && !n.includes(r.hostname)));
  }
  async function getFile(e) {
    if (env$1.useFS && !isValidUrl(e, [`http:`, `https:`, `blob:`])) return new FileResponse(e);
    if (typeof process < `u` && process?.release?.name === `node`) {
      let t = !!{}?.TESTING_REMOTELY,
        n = env$1.version,
        r = new Headers();
      if (
        (r.set(`User-Agent`, `transformers.js/${n}; is_ci/${t};`),
        isValidUrl(e, [`http:`, `https:`], [`huggingface.co`, `hf.co`]))
      ) {
        let e = {}?.HF_TOKEN ?? {}?.HF_ACCESS_TOKEN;
        e && r.set(`Authorization`, `Bearer ${e}`);
      }
      return fetch(e, { headers: r });
    } else return fetch(e);
  }
  const ERROR_MAPPING = {
    400: `Bad request error occurred while trying to load file`,
    401: `Unauthorized access to file`,
    403: `Forbidden access to file`,
    404: `Could not locate file`,
    408: `Request timeout error occurred while trying to load file`,
    500: `Internal server error error occurred while trying to load file`,
    502: `Bad gateway error occurred while trying to load file`,
    503: `Service unavailable error occurred while trying to load file`,
    504: `Gateway timeout error occurred while trying to load file`,
  };
  function handleError(e, t, n) {
    if (!n) return null;
    let r = ERROR_MAPPING[e] ?? `Error (${e}) occurred while trying to load file`;
    throw Error(`${r}: "${t}".`);
  }
  var FileCache = class {
    constructor(e) {
      this.path = e;
    }
    async match(e) {
      let t = new FileResponse(import___vite_browser_external.default.join(this.path, e));
      if (t.exists) return t;
    }
    async put(e, t) {
      let n = Buffer.from(await t.arrayBuffer()),
        r = import___vite_browser_external.default.join(this.path, e);
      try {
        (await import___vite_browser_external.default.promises.mkdir(
          import___vite_browser_external.default.dirname(r),
          { recursive: !0 },
        ),
          await import___vite_browser_external.default.promises.writeFile(r, n));
      } catch (e) {
        console.warn(`An error occurred while writing the file to cache:`, e);
      }
    }
  };
  async function tryCache(e, ...t) {
    for (let n of t)
      try {
        let t = await e.match(n);
        if (t) return t;
      } catch {
        continue;
      }
  }
  async function getModelFile(e, t, n = !0, r = {}) {
    if (!env$1.allowLocalModels) {
      if (r.local_files_only)
        throw Error(
          'Invalid configuration detected: local models are disabled (`env.allowLocalModels=false`) but you have requested to only use local models (`local_files_only=true`).',
        );
      if (!env$1.allowRemoteModels)
        throw Error(
          'Invalid configuration detected: both local and remote models are disabled. Fix by setting `env.allowLocalModels` or `env.allowRemoteModels` to `true`.',
        );
    }
    dispatchCallback(r.progress_callback, { status: `initiate`, name: e, file: t });
    let i;
    if (!i && env$1.useBrowserCache) {
      if (typeof caches > `u`) throw Error(`Browser cache is not available in this environment.`);
      try {
        i = await caches.open(`transformers-cache`);
      } catch (e) {
        console.warn(`An error occurred while opening the browser cache:`, e);
      }
    }
    if ((!i && env$1.useFSCache && (i = new FileCache(r.cache_dir ?? env$1.cacheDir)), !i && env$1.useCustomCache)) {
      if (!env$1.customCache) throw Error('`env.useCustomCache=true`, but `env.customCache` is not defined.');
      if (!env$1.customCache.match || !env$1.customCache.put)
        throw Error(
          '`env.customCache` must be an object which implements the `match` and `put` functions of the Web Cache API. For more information, see https://developer.mozilla.org/en-US/docs/Web/API/Cache',
        );
      i = env$1.customCache;
    }
    let a = r.revision ?? `main`,
      o = pathJoin(e, t),
      s = pathJoin(env$1.localModelPath, o),
      c = pathJoin(
        env$1.remoteHost,
        env$1.remotePathTemplate.replaceAll(`{model}`, e).replaceAll(`{revision}`, encodeURIComponent(a)),
        t,
      ),
      l = a === `main` ? o : pathJoin(e, a, t),
      u,
      d = i instanceof FileCache ? l : c,
      f = !1,
      p;
    i && (p = await tryCache(i, s, d));
    let m = p !== void 0;
    if (p === void 0) {
      if (env$1.allowLocalModels) {
        if (!isValidUrl(o, [`http:`, `https:`]))
          try {
            ((p = await getFile(s)), (u = s));
          } catch (e) {
            console.warn(`Unable to load from local path "${s}": "${e}"`);
          }
        else if (r.local_files_only)
          throw Error(`\`local_files_only=true\`, but attempted to load a remote file from: ${o}.`);
        else if (!env$1.allowRemoteModels)
          throw Error(`\`env.allowRemoteModels=false\`, but attempted to load a remote file from: ${o}.`);
      }
      if (p === void 0 || p.status === 404) {
        if (r.local_files_only || !env$1.allowRemoteModels) {
          if (n)
            throw Error(
              `\`local_files_only=true\` or \`env.allowRemoteModels=false\` and file was not found locally at "${s}".`,
            );
          return null;
        }
        if (((p = await getFile(c)), p.status !== 200)) return handleError(p.status, c, n);
        u = d;
      }
      f = i && typeof Response < `u` && p instanceof Response && p.status === 200;
    }
    dispatchCallback(r.progress_callback, { status: `download`, name: e, file: t });
    let h = { status: `progress`, name: e, file: t },
      g;
    return (
      r.progress_callback
        ? m && typeof navigator < `u` && /firefox/i.test(navigator.userAgent)
          ? ((g = new Uint8Array(await p.arrayBuffer())),
            dispatchCallback(r.progress_callback, { ...h, progress: 100, loaded: g.length, total: g.length }))
          : (g = await readResponse(p, (e) => {
              dispatchCallback(r.progress_callback, { ...h, ...e });
            }))
        : (g = new Uint8Array(await p.arrayBuffer())),
      f &&
        u &&
        (await i.match(u)) === void 0 &&
        (await i.put(u, new Response(g, { headers: p.headers })).catch((e) => {
          console.warn(`Unable to add response to browser cache: ${e}.`);
        })),
      dispatchCallback(r.progress_callback, { status: `done`, name: e, file: t }),
      g
    );
  }
  async function getModelJSON(e, t, n = !0, r = {}) {
    let i = await getModelFile(e, t, n, r);
    if (i === null) return {};
    let a = new TextDecoder(`utf-8`).decode(i);
    return JSON.parse(a);
  }
  async function readResponse(e, t) {
    let n = e.headers.get(`Content-Length`);
    n === null &&
      console.warn(`Unable to determine content-length from response headers. Will expand buffer when needed.`);
    let r = parseInt(n ?? `0`),
      i = new Uint8Array(r),
      a = 0,
      o = e.body.getReader();
    async function s() {
      let { done: e, value: n } = await o.read();
      if (e) return;
      let c = a + n.length;
      if (c > r) {
        r = c;
        let e = new Uint8Array(r);
        (e.set(i), (i = e));
      }
      return (i.set(n, a), (a = c), t({ progress: (a / r) * 100, loaded: a, total: r }), s());
    }
    return (await s(), i);
  }
  function pathJoin(...e) {
    return (
      (e = e.map(
        (t, n) => (n && (t = t.replace(RegExp(`^/`), ``)), n !== e.length - 1 && (t = t.replace(RegExp(`/$`), ``)), t),
      )),
      e.join(`/`)
    );
  }
  function interpolate_data(e, [t, n, r], [i, a], o = `bilinear`, s = !1) {
    let c = a / r,
      l = i / n,
      u = new e.constructor(i * a * t),
      d = n * r,
      f = i * a;
    for (let o = 0; o < i; ++o)
      for (let i = 0; i < a; ++i) {
        let s = o * a + i,
          p = (i + 0.5) / c - 0.5,
          m = (o + 0.5) / l - 0.5,
          h = Math.floor(p),
          g = Math.floor(m),
          _ = Math.min(h + 1, r - 1),
          v = Math.min(g + 1, n - 1);
        ((h = Math.max(h, 0)), (g = Math.max(g, 0)));
        let y = p - h,
          b = m - g,
          x = (1 - y) * (1 - b),
          S = y * (1 - b),
          C = (1 - y) * b,
          w = y * b,
          T = g * r,
          E = v * r,
          D = T + h,
          O = T + _,
          k = E + h,
          A = E + _;
        for (let n = 0; n < t; ++n) {
          let t = n * d;
          u[n * f + s] = x * e[t + D] + S * e[t + O] + C * e[t + k] + w * e[t + A];
        }
      }
    return u;
  }
  function permute_data(e, t, n) {
    let r = Array(n.length),
      i = Array(n.length);
    for (let e = n.length - 1, a = 1; e >= 0; --e) ((i[e] = a), (r[e] = t[n[e]]), (a *= r[e]));
    let a = n.map((e, t) => i[n.indexOf(t)]),
      o = new e.constructor(e.length);
    for (let n = 0; n < e.length; ++n) {
      let r = 0;
      for (let e = t.length - 1, i = n; e >= 0; --e) ((r += (i % t[e]) * a[e]), (i = Math.floor(i / t[e])));
      o[r] = e[n];
    }
    return [o, r];
  }
  function softmax(e) {
    let t = max(e)[0],
      n = e.map((e) => Math.exp(e - t)),
      r = n.reduce((e, t) => e + t, 0);
    return n.map((e) => e / r);
  }
  function log_softmax(e) {
    return softmax(e).map((e) => Math.log(e));
  }
  function getTopItems(e, t = 0) {
    return (
      (e = Array.from(e)
        .map((e, t) => [t, e])
        .sort((e, t) => t[1] - e[1])),
      t !== null && t > 0 && (e = e.slice(0, t)),
      e
    );
  }
  function min(e) {
    if (e.length === 0) throw Error(`Array must not be empty`);
    let t = e[0],
      n = 0;
    for (let r = 1; r < e.length; ++r) e[r] < t && ((t = e[r]), (n = r));
    return [t, n];
  }
  function max(e) {
    if (e.length === 0) throw Error(`Array must not be empty`);
    let t = e[0],
      n = 0;
    for (let r = 1; r < e.length; ++r) e[r] > t && ((t = e[r]), (n = r));
    return [Number(t), n];
  }
  function isPowerOfTwo(e) {
    return e > 0 && (e & (e - 1)) == 0;
  }
  var P2FFT = class {
      constructor(e) {
        if (((this.size = e | 0), this.size <= 1 || !isPowerOfTwo(this.size)))
          throw Error(`FFT size must be a power of two larger than 1`);
        ((this._csize = e << 1), (this.table = new Float64Array(this.size * 2)));
        for (let e = 0; e < this.table.length; e += 2) {
          let t = (Math.PI * e) / this.size;
          ((this.table[e] = Math.cos(t)), (this.table[e + 1] = -Math.sin(t)));
        }
        let t = 0;
        for (let e = 1; this.size > e; e <<= 1) ++t;
        ((this._width = t % 2 == 0 ? t - 1 : t), (this._bitrev = new Int32Array(1 << this._width)));
        for (let e = 0; e < this._bitrev.length; ++e) {
          this._bitrev[e] = 0;
          for (let t = 0; t < this._width; t += 2) {
            let n = this._width - t - 2;
            this._bitrev[e] |= ((e >>> t) & 3) << n;
          }
        }
      }
      createComplexArray() {
        return new Float64Array(this._csize);
      }
      fromComplexArray(e, t) {
        let n = t || Array(e.length >>> 1);
        for (let t = 0; t < e.length; t += 2) n[t >>> 1] = e[t];
        return n;
      }
      toComplexArray(e, t) {
        let n = t || this.createComplexArray();
        for (let t = 0; t < n.length; t += 2) ((n[t] = e[t >>> 1]), (n[t + 1] = 0));
        return n;
      }
      transform(e, t) {
        if (e === t) throw Error(`Input and output buffers must be different`);
        this._transform4(e, t, 1);
      }
      realTransform(e, t) {
        if (e === t) throw Error(`Input and output buffers must be different`);
        this._realTransform4(e, t, 1);
      }
      inverseTransform(e, t) {
        if (e === t) throw Error(`Input and output buffers must be different`);
        this._transform4(e, t, -1);
        for (let t = 0; t < e.length; ++t) e[t] /= this.size;
      }
      _transform4(e, t, n) {
        let r = this._csize,
          i = 1 << this._width,
          a = (r / i) << 1,
          o,
          s,
          c = this._bitrev;
        if (a === 4)
          for (o = 0, s = 0; o < r; o += a, ++s) {
            let n = c[s];
            this._singleTransform2(t, e, o, n, i);
          }
        else
          for (o = 0, s = 0; o < r; o += a, ++s) {
            let r = c[s];
            this._singleTransform4(t, e, o, r, i, n);
          }
        let l = this.table;
        for (i >>= 2; i >= 2; i >>= 2) {
          a = (r / i) << 1;
          let t = a >>> 2;
          for (o = 0; o < r; o += a) {
            let r = o + t - 1;
            for (let a = o, s = 0; a < r; a += 2, s += i) {
              let r = a,
                i = r + t,
                o = i + t,
                c = o + t,
                u = e[r],
                d = e[r + 1],
                f = e[i],
                p = e[i + 1],
                m = e[o],
                h = e[o + 1],
                g = e[c],
                _ = e[c + 1],
                v = l[s],
                y = n * l[s + 1],
                b = f * v - p * y,
                x = f * y + p * v,
                S = l[2 * s],
                C = n * l[2 * s + 1],
                w = m * S - h * C,
                T = m * C + h * S,
                E = l[3 * s],
                D = n * l[3 * s + 1],
                O = g * E - _ * D,
                k = g * D + _ * E,
                A = u + w,
                j = d + T,
                M = u - w,
                N = d - T,
                P = b + O,
                F = x + k,
                ee = n * (b - O),
                te = n * (x - k);
              ((e[r] = A + P),
                (e[r + 1] = j + F),
                (e[i] = M + te),
                (e[i + 1] = N - ee),
                (e[o] = A - P),
                (e[o + 1] = j - F),
                (e[c] = M - te),
                (e[c + 1] = N + ee));
            }
          }
        }
      }
      _singleTransform2(e, t, n, r, i) {
        let a = e[r],
          o = e[r + 1],
          s = e[r + i],
          c = e[r + i + 1];
        ((t[n] = a + s), (t[n + 1] = o + c), (t[n + 2] = a - s), (t[n + 3] = o - c));
      }
      _singleTransform4(e, t, n, r, i, a) {
        let o = i * 2,
          s = i * 3,
          c = e[r],
          l = e[r + 1],
          u = e[r + i],
          d = e[r + i + 1],
          f = e[r + o],
          p = e[r + o + 1],
          m = e[r + s],
          h = e[r + s + 1],
          g = c + f,
          _ = l + p,
          v = c - f,
          y = l - p,
          b = u + m,
          x = d + h,
          S = a * (u - m),
          C = a * (d - h);
        ((t[n] = g + b),
          (t[n + 1] = _ + x),
          (t[n + 2] = v + C),
          (t[n + 3] = y - S),
          (t[n + 4] = g - b),
          (t[n + 5] = _ - x),
          (t[n + 6] = v - C),
          (t[n + 7] = y + S));
      }
      _realTransform4(e, t, n) {
        let r = this._csize,
          i = 1 << this._width,
          a = (r / i) << 1,
          o,
          s,
          c = this._bitrev;
        if (a === 4)
          for (o = 0, s = 0; o < r; o += a, ++s) {
            let n = c[s];
            this._singleRealTransform2(t, e, o, n >>> 1, i >>> 1);
          }
        else
          for (o = 0, s = 0; o < r; o += a, ++s) {
            let r = c[s];
            this._singleRealTransform4(t, e, o, r >>> 1, i >>> 1, n);
          }
        let l = this.table;
        for (i >>= 2; i >= 2; i >>= 2) {
          a = (r / i) << 1;
          let t = a >>> 1,
            s = t >>> 1,
            c = s >>> 1;
          for (o = 0; o < r; o += a)
            for (let r = 0, a = 0; r <= c; r += 2, a += i) {
              let i = o + r,
                u = i + s,
                d = u + s,
                f = d + s,
                p = e[i],
                m = e[i + 1],
                h = e[u],
                g = e[u + 1],
                _ = e[d],
                v = e[d + 1],
                y = e[f],
                b = e[f + 1],
                x = p,
                S = m,
                C = l[a],
                w = n * l[a + 1],
                T = h * C - g * w,
                E = h * w + g * C,
                D = l[2 * a],
                O = n * l[2 * a + 1],
                k = _ * D - v * O,
                A = _ * O + v * D,
                j = l[3 * a],
                M = n * l[3 * a + 1],
                N = y * j - b * M,
                P = y * M + b * j,
                F = x + k,
                ee = S + A,
                te = x - k,
                ne = S - A,
                re = T + N,
                ie = E + P,
                ae = n * (T - N),
                oe = n * (E - P);
              if (((e[i] = F + re), (e[i + 1] = ee + ie), (e[u] = te + oe), (e[u + 1] = ne - ae), r === 0)) {
                ((e[d] = F - re), (e[d + 1] = ee - ie));
                continue;
              }
              if (r === c) continue;
              let I = o + s - r,
                L = o + t - r;
              ((e[I] = te - n * oe), (e[I + 1] = -ne - n * ae), (e[L] = F - n * re), (e[L + 1] = -ee + n * ie));
            }
        }
        let u = r >>> 1;
        for (let t = 2; t < u; t += 2) ((e[r - t] = e[t]), (e[r - t + 1] = -e[t + 1]));
      }
      _singleRealTransform2(e, t, n, r, i) {
        let a = e[r],
          o = e[r + i];
        ((t[n] = a + o), (t[n + 1] = 0), (t[n + 2] = a - o), (t[n + 3] = 0));
      }
      _singleRealTransform4(e, t, n, r, i, a) {
        let o = i * 2,
          s = i * 3,
          c = e[r],
          l = e[r + i],
          u = e[r + o],
          d = e[r + s],
          f = c + u,
          p = c - u,
          m = l + d,
          h = a * (l - d);
        ((t[n] = f + m),
          (t[n + 1] = 0),
          (t[n + 2] = p),
          (t[n + 3] = -h),
          (t[n + 4] = f - m),
          (t[n + 5] = 0),
          (t[n + 6] = p),
          (t[n + 7] = h));
      }
    },
    NP2FFT = class {
      constructor(e) {
        let t = 2 * (e - 1),
          n = 2 * (2 * e - 1),
          r = 2 ** Math.ceil(Math.log2(n));
        ((this.bufferSize = r), (this._a = t));
        let i = new Float64Array(n),
          a = new Float64Array(r);
        ((this._chirpBuffer = new Float64Array(r)),
          (this._buffer1 = new Float64Array(r)),
          (this._buffer2 = new Float64Array(r)),
          (this._outBuffer1 = new Float64Array(r)),
          (this._outBuffer2 = new Float64Array(r)));
        let o = (-2 * Math.PI) / e,
          s = Math.cos(o),
          c = Math.sin(o);
        for (let t = 0; t < n >> 1; ++t) {
          let n = (t + 1 - e) ** 2 / 2,
            r = Math.sqrt(s ** 2 + c ** 2) ** n,
            o = n * Math.atan2(c, s),
            l = 2 * t;
          ((i[l] = r * Math.cos(o)), (i[l + 1] = r * Math.sin(o)), (a[l] = i[l]), (a[l + 1] = -i[l + 1]));
        }
        ((this._slicedChirpBuffer = i.subarray(t, n)),
          (this._f = new P2FFT(r >> 1)),
          this._f.transform(this._chirpBuffer, a));
      }
      _transform(e, t, n) {
        let r = this._buffer1,
          i = this._buffer2,
          a = this._outBuffer1,
          o = this._outBuffer2,
          s = this._chirpBuffer,
          c = this._slicedChirpBuffer,
          l = this._a;
        if (n)
          for (let e = 0; e < c.length; e += 2) {
            let n = e + 1,
              i = t[e >> 1];
            ((r[e] = i * c[e]), (r[n] = i * c[n]));
          }
        else
          for (let e = 0; e < c.length; e += 2) {
            let n = e + 1;
            ((r[e] = t[e] * c[e] - t[n] * c[n]), (r[n] = t[e] * c[n] + t[n] * c[e]));
          }
        this._f.transform(a, r);
        for (let e = 0; e < s.length; e += 2) {
          let t = e + 1;
          ((i[e] = a[e] * s[e] - a[t] * s[t]), (i[t] = a[e] * s[t] + a[t] * s[e]));
        }
        this._f.inverseTransform(o, i);
        for (let t = 0; t < o.length; t += 2) {
          let n = o[t + l],
            r = o[t + l + 1],
            i = c[t],
            a = c[t + 1];
          ((e[t] = n * i - r * a), (e[t + 1] = n * a + r * i));
        }
      }
      transform(e, t) {
        this._transform(e, t, !1);
      }
      realTransform(e, t) {
        this._transform(e, t, !0);
      }
    },
    FFT = class {
      constructor(e) {
        ((this.fft_length = e),
          (this.isPowerOfTwo = isPowerOfTwo(e)),
          this.isPowerOfTwo
            ? ((this.fft = new P2FFT(e)), (this.outputBufferSize = 2 * e))
            : ((this.fft = new NP2FFT(e)), (this.outputBufferSize = this.fft.bufferSize)));
      }
      realTransform(e, t) {
        this.fft.realTransform(e, t);
      }
      transform(e, t) {
        this.fft.transform(e, t);
      }
    };
  function medianFilter(e, t) {
    if (t % 2 == 0 || t <= 0) throw Error(`Window size must be a positive odd number`);
    let n = new e.constructor(e.length),
      r = new e.constructor(t),
      i = Math.floor(t / 2);
    for (let t = 0; t < e.length; ++t) {
      let a = 0;
      for (let n = -i; n <= i; ++n) {
        let i = t + n;
        (i < 0 ? (i = Math.abs(i)) : i >= e.length && (i = 2 * (e.length - 1) - i), (r[a++] = e[i]));
      }
      (r.sort(), (n[t] = r[i]));
    }
    return n;
  }
  function round(e, t) {
    let n = 10 ** t;
    return Math.round(e * n) / n;
  }
  function bankers_round(e) {
    let t = Math.round(e);
    return Math.abs(e) % 1 == 0.5 ? (t % 2 == 0 ? t : t - 1) : t;
  }
  const DataTypeMap = Object.freeze({
      float32: Float32Array,
      float64: Float64Array,
      string: Array,
      int8: Int8Array,
      uint8: Uint8Array,
      int16: Int16Array,
      uint16: Uint16Array,
      int32: Int32Array,
      uint32: Uint32Array,
      int64: BigInt64Array,
      uint64: BigUint64Array,
      bool: Uint8Array,
    }),
    ONNXTensor$1 = ONNX.Tensor;
  var Tensor = class e {
    dims;
    type;
    data;
    size;
    constructor(...e) {
      return (
        e[0] instanceof ONNXTensor$1
          ? Object.assign(this, e[0])
          : Object.assign(this, new ONNXTensor$1(e[0], e[1], e[2])),
        new Proxy(this, {
          get: (e, t) => {
            if (typeof t == `string`) {
              let n = Number(t);
              if (Number.isInteger(n)) return e._getitem(n);
            }
            return e[t];
          },
          set: (e, t, n) => (e[t] = n),
        })
      );
    }
    *[Symbol.iterator]() {
      let [e, ...t] = this.dims;
      if (t.length > 0) {
        let n = t.reduce((e, t) => e * t);
        for (let r = 0; r < e; ++r) yield this._subarray(r, n, t);
      } else yield* this.data;
    }
    _getitem(t) {
      let [n, ...r] = this.dims;
      if (((t = safeIndex(t, n)), r.length > 0)) {
        let e = r.reduce((e, t) => e * t);
        return this._subarray(t, e, r);
      } else return new e(this.type, [this.data[t]], r);
    }
    indexOf(e) {
      for (let t = 0; t < this.data.length; ++t) if (this.data[t] == e) return t;
      return -1;
    }
    _subarray(t, n, r) {
      let i = t * n,
        a = (t + 1) * n,
        o = `subarray` in this.data ? this.data.subarray(i, a) : this.data.slice(i, a);
      return new e(this.type, o, r);
    }
    item() {
      if (this.data.length !== 1)
        throw Error(`a Tensor with ${this.data.length} elements cannot be converted to Scalar`);
      return this.data[0];
    }
    tolist() {
      return reshape(this.data, this.dims);
    }
    sigmoid() {
      return this.clone().sigmoid_();
    }
    sigmoid_() {
      for (let e = 0; e < this.data.length; ++e) this.data[e] = 1 / (1 + Math.exp(-this.data[e]));
      return this;
    }
    mul(e) {
      return this.clone().mul_(e);
    }
    mul_(e) {
      for (let t = 0; t < this.data.length; ++t) this.data[t] *= e;
      return this;
    }
    add(e) {
      return this.clone().add_(e);
    }
    add_(e) {
      for (let t = 0; t < this.data.length; ++t) this.data[t] += e;
      return this;
    }
    clone() {
      return new e(this.type, this.data.slice(), this.dims.slice());
    }
    slice(...t) {
      let n = [],
        r = [];
      for (let e = 0; e < this.dims.length; ++e) {
        let i = t[e];
        if (i == null) (r.push([0, this.dims[e]]), n.push(this.dims[e]));
        else if (typeof i == `number`) ((i = safeIndex(i, this.dims[e], e)), r.push([i, i + 1]));
        else if (Array.isArray(i) && i.length === 2) {
          if (i[0] > i[1]) throw Error(`Invalid slice: ${i}`);
          let t = [Math.max(i[0], 0), Math.min(i[1], this.dims[e])];
          (r.push(t), n.push(t[1] - t[0]));
        } else throw Error(`Invalid slice: ${i}`);
      }
      let i = r.map(([e, t]) => t - e),
        a = i.reduce((e, t) => e * t),
        o = new this.data.constructor(a),
        s = this.stride();
      for (let e = 0; e < a; ++e) {
        let t = 0;
        for (let n = i.length - 1, a = e; n >= 0; --n) {
          let e = i[n];
          ((t += ((a % e) + r[n][0]) * s[n]), (a = Math.floor(a / e)));
        }
        o[e] = this.data[t];
      }
      return new e(this.type, o, n);
    }
    permute(...e) {
      return permute(this, e);
    }
    transpose(...e) {
      return this.permute(...e);
    }
    sum(e = null, t = !1) {
      return this.norm(1, e, t);
    }
    norm(t = `fro`, n = null, r = !1) {
      if (t === `fro`) t = 2;
      else if (typeof t == `string`) throw Error(`Unsupported norm: ${t}`);
      if (n === null) {
        let n = this.data.reduce((e, n) => e + n ** t, 0) ** (1 / t);
        return new e(this.type, [n], []);
      }
      n = safeIndex(n, this.dims.length);
      let i = this.dims.slice();
      i[n] = 1;
      let a = new this.data.constructor(this.data.length / this.dims[n]);
      for (let e = 0; e < this.data.length; ++e) {
        let r = 0;
        for (let t = this.dims.length - 1, a = e, o = 1; t >= 0; --t) {
          let e = this.dims[t];
          if (t !== n) {
            let n = a % e;
            ((r += n * o), (o *= i[t]));
          }
          a = Math.floor(a / e);
        }
        a[r] += this.data[e] ** t;
      }
      if (t !== 1) for (let e = 0; e < a.length; ++e) a[e] = a[e] ** (1 / t);
      return (r || i.splice(n, 1), new e(this.type, a, i));
    }
    normalize_(e = 2, t = 1) {
      t = safeIndex(t, this.dims.length);
      let n = this.norm(e, t, !0);
      for (let e = 0; e < this.data.length; ++e) {
        let r = 0;
        for (let n = this.dims.length - 1, i = e, a = 1; n >= 0; --n) {
          let e = this.dims[n];
          if (n !== t) {
            let t = i % e;
            ((r += t * a), (a *= this.dims[n]));
          }
          i = Math.floor(i / e);
        }
        this.data[e] /= n.data[r];
      }
      return this;
    }
    normalize(e = 2, t = 1) {
      return this.clone().normalize_(e, t);
    }
    stride() {
      return dimsToStride(this.dims);
    }
    squeeze(t = null) {
      return new e(this.type, this.data, calc_squeeze_dims(this.dims, t));
    }
    squeeze_(e = null) {
      return ((this.dims = calc_squeeze_dims(this.dims, e)), this);
    }
    unsqueeze(t = null) {
      return new e(this.type, this.data, calc_unsqueeze_dims(this.dims, t));
    }
    unsqueeze_(e = null) {
      return ((this.dims = calc_unsqueeze_dims(this.dims, e)), this);
    }
    flatten_(e = 0, t = -1) {
      t = (t + this.dims.length) % this.dims.length;
      let n = this.dims.slice(0, e),
        r = this.dims.slice(e, t + 1),
        i = this.dims.slice(t + 1);
      return ((this.dims = [...n, r.reduce((e, t) => e * t, 1), ...i]), this);
    }
    flatten(e = 0, t = -1) {
      return this.clone().flatten_(e, t);
    }
    view(...t) {
      let n = -1;
      for (let e = 0; e < t.length; ++e)
        if (t[e] === -1) {
          if (n !== -1) throw Error(`Only one dimension can be inferred`);
          n = e;
        }
      if (n !== -1) {
        let e = t.reduce((e, t, r) => (r === n ? e : e * t), 1);
        t[n] = this.data.length / e;
      }
      return new e(this.type, this.data, t);
    }
    neg_() {
      for (let e = 0; e < this.data.length; ++e) this.data[e] = -this.data[e];
      return this;
    }
    neg() {
      return this.clone().neg_();
    }
    clamp_(e, t) {
      for (let n = 0; n < this.data.length; ++n) this.data[n] = Math.min(Math.max(this.data[n], e), t);
      return this;
    }
    clamp(e, t) {
      return this.clone().clamp_(e, t);
    }
    round_() {
      for (let e = 0; e < this.data.length; ++e) this.data[e] = Math.round(this.data[e]);
      return this;
    }
    round() {
      return this.clone().round_();
    }
    to(t) {
      if (this.type === t) return this;
      if (!DataTypeMap.hasOwnProperty(t)) throw Error(`Unsupported type: ${t}`);
      return new e(t, DataTypeMap[t].from(this.data), this.dims);
    }
  };
  function reshape(e, t) {
    let n = e.length;
    if (n !== t.reduce((e, t) => e * t)) throw Error(`cannot reshape array of size ${n} into shape (${t})`);
    let r = e;
    for (let e = t.length - 1; e >= 0; e--)
      r = r.reduce(
        (n, r) => {
          let i = n[n.length - 1];
          return (i.length < t[e] ? i.push(r) : n.push([r]), n);
        },
        [[]],
      );
    return r[0];
  }
  function permute(e, t) {
    let [n, r] = permute_data(e.data, e.dims, t);
    return new Tensor(e.type, n, r);
  }
  function interpolate(e, [t, n], r = `bilinear`, i = !1) {
    let a = e.dims.at(-3) ?? 1,
      o = e.dims.at(-2),
      s = e.dims.at(-1),
      c = interpolate_data(e.data, [a, o, s], [t, n], r, i);
    return new Tensor(e.type, c, [a, t, n]);
  }
  function mean_pooling(e, t) {
    let n = [e.dims[0], e.dims[2]],
      r = new e.data.constructor(n[0] * n[1]),
      [i, a, o] = e.dims,
      s = 0;
    for (let n = 0; n < i; ++n) {
      let i = n * o * a;
      for (let c = 0; c < o; ++c) {
        let l = 0,
          u = 0,
          d = n * a,
          f = i + c;
        for (let n = 0; n < a; ++n) {
          let r = Number(t.data[d + n]);
          ((u += r), (l += e.data[f + n * o] * r));
        }
        let p = l / u;
        r[s++] = p;
      }
    }
    return new Tensor(e.type, r, n);
  }
  function calc_squeeze_dims(e, t) {
    return (
      (e = e.slice()),
      t === null
        ? (e = e.filter((e) => e !== 1))
        : typeof t == `number`
          ? e[t] === 1 && e.splice(t, 1)
          : Array.isArray(t) && (e = e.filter((e, n) => e !== 1 || !t.includes(n))),
      e
    );
  }
  function calc_unsqueeze_dims(e, t) {
    return ((t = safeIndex(t, e.length + 1)), (e = e.slice()), e.splice(t, 0, 1), e);
  }
  function safeIndex(e, t, n = null) {
    if (e < -t || e >= t)
      throw Error(`IndexError: index ${e} is out of bounds for dimension${n === null ? `` : ` ` + n} with size ${t}`);
    return (e < 0 && (e = ((e % t) + t) % t), e);
  }
  function cat(e, t = 0) {
    t = safeIndex(t, e[0].dims.length);
    let n = e[0].dims.slice();
    n[t] = e.reduce((e, n) => e + n.dims[t], 0);
    let r = n.reduce((e, t) => e * t, 1),
      i = new e[0].data.constructor(r),
      a = e[0].type;
    if (t === 0) {
      let t = 0;
      for (let n of e) (i.set(n.data, t), (t += n.data.length));
    } else {
      let r = 0;
      for (let a = 0; a < e.length; ++a) {
        let o = e[a];
        for (let e = 0; e < o.data.length; ++e) {
          let a = 0;
          for (let i = o.dims.length - 1, s = e, c = 1; i >= 0; --i) {
            let e = o.dims[i],
              l = s % e;
            (i === t && (l += r), (a += l * c), (c *= n[i]), (s = Math.floor(s / e)));
          }
          i[a] = o.data[e];
        }
        r += o.dims[t];
      }
    }
    return new Tensor(a, i, n);
  }
  function stack(e, t = 0) {
    return cat(
      e.map((e) => e.unsqueeze(t)),
      t,
    );
  }
  function std_mean(e, t = null, n = 1, r = !1) {
    if (t === null) {
      let t = e.data.reduce((e, t) => e + t, 0) / e.data.length,
        r = Math.sqrt(e.data.reduce((e, n) => e + (n - t) ** 2, 0) / (e.data.length - n)),
        i = new Tensor(e.type, [t], []);
      return [new Tensor(e.type, [r], []), i];
    }
    t = safeIndex(t, e.dims.length);
    let i = mean(e, t, r),
      a = e.dims.slice();
    a[t] = 1;
    let o = new e.data.constructor(e.data.length / e.dims[t]);
    for (let n = 0; n < e.data.length; ++n) {
      let r = 0;
      for (let i = e.dims.length - 1, o = n, s = 1; i >= 0; --i) {
        let n = e.dims[i];
        if (i !== t) {
          let e = o % n;
          ((r += e * s), (s *= a[i]));
        }
        o = Math.floor(o / n);
      }
      o[r] += (e.data[n] - i.data[r]) ** 2;
    }
    for (let r = 0; r < o.length; ++r) o[r] = Math.sqrt(o[r] / (e.dims[t] - n));
    return (r || a.splice(t, 1), [new Tensor(e.type, o, a), i]);
  }
  function mean(e, t = null, n = !1) {
    if (t === null) {
      let t = e.data.reduce((e, t) => e + t, 0);
      return new Tensor(e.type, [t / e.data.length], []);
    }
    t = safeIndex(t, e.dims.length);
    let r = e.dims.slice();
    r[t] = 1;
    let i = new e.data.constructor(e.data.length / e.dims[t]);
    for (let n = 0; n < e.data.length; ++n) {
      let a = 0;
      for (let i = e.dims.length - 1, o = n, s = 1; i >= 0; --i) {
        let n = e.dims[i];
        if (i !== t) {
          let e = o % n;
          ((a += e * s), (s *= r[i]));
        }
        o = Math.floor(o / n);
      }
      i[a] += e.data[n];
    }
    if (e.dims[t] !== 1) for (let n = 0; n < i.length; ++n) i[n] = i[n] / e.dims[t];
    return (n || r.splice(t, 1), new Tensor(e.type, i, r));
  }
  function dynamicTimeWarping(e) {
    let [t, n] = e.dims,
      r = [t + 1, n + 1],
      i = new Tensor(`float32`, new Float32Array(r[0] * r[1]).fill(1 / 0), r),
      a = new Tensor(`float32`, new Float32Array(r[0] * r[1]).fill(-1), r);
    i[0].data[0] = 0;
    for (let r = 1; r < n + 1; ++r)
      for (let n = 1; n < t + 1; ++n) {
        let t = i[n - 1][r - 1].item(),
          o = i[n - 1][r].item(),
          s = i[n][r - 1].item(),
          c,
          l;
        (t < o && t < s ? ((c = t), (l = 0)) : o < t && o < s ? ((c = o), (l = 1)) : ((c = s), (l = 2)),
          (i[n].data[r] = e[n - 1][r - 1].item() + c),
          (a[n].data[r] = l));
      }
    let o = t,
      s = n;
    a.data.fill(2, 0, r[1]);
    for (let e = 0; e < r[0]; ++e) a[e].data[0] = 1;
    let c = [],
      l = [];
    for (; o > 0 || s > 0; )
      switch ((c.push(o - 1), l.push(s - 1), a[o][s].item())) {
        case 0:
          (--o, --s);
          break;
        case 1:
          --o;
          break;
        case 2:
          --s;
          break;
        default:
          throw Error(
            `Internal error in dynamic time warping. Unexpected trace[${o}, ${s}]. Please file a bug report.`,
          );
      }
    return (c.reverse(), l.reverse(), [c, l]);
  }
  function dimsToStride(e) {
    let t = Array(e.length);
    for (let n = e.length - 1, r = 1; n >= 0; --n) ((t[n] = r), (r *= e[n]));
    return t;
  }
  function ones(e) {
    let t = e.reduce((e, t) => e * t, 1);
    return new Tensor(`int64`, new BigInt64Array(t).fill(1n), e);
  }
  function ones_like(e) {
    return ones(e.dims);
  }
  function quantize_embeddings(e, t) {
    if (e.dims.length !== 2) throw Error(`The tensor must have 2 dimensions`);
    if (e.dims.at(-1) % 8 != 0) throw Error(`The last dimension of the tensor must be a multiple of 8`);
    if (![`binary`, `ubinary`].includes(t)) throw Error(`The precision must be either 'binary' or 'ubinary'`);
    let n = t === `binary`,
      r = n ? `int8` : `uint8`,
      i = n ? Int8Array : Uint8Array,
      a = e.data,
      o = new i(a.length / 8);
    for (let e = 0; e < a.length; ++e) {
      let t = +(a[e] > 0),
        r = Math.floor(e / 8),
        i = e % 8;
      ((o[r] |= t << (7 - i)), n && i === 0 && (o[r] -= 128));
    }
    return new Tensor(r, o, [e.dims[0], e.dims[1] / 8]);
  }
  var PriorityQueue = class {
      constructor(e = (e, t) => e > t) {
        ((this._heap = []), (this._comparator = e));
      }
      get size() {
        return this._heap.length;
      }
      isEmpty() {
        return this.size === 0;
      }
      peek() {
        return this._heap[0];
      }
      push(...e) {
        return this.extend(e);
      }
      extend(e) {
        for (let t of e) (this._heap.push(t), this._siftUp());
        return this.size;
      }
      pop() {
        let e = this.peek(),
          t = this.size - 1;
        return (t > 0 && this._swap(0, t), this._heap.pop(), this._siftDown(), e);
      }
      replace(e) {
        let t = this.peek();
        return ((this._heap[0] = e), this._siftDown(), t);
      }
      _parent(e) {
        return ((e + 1) >>> 1) - 1;
      }
      _left(e) {
        return (e << 1) + 1;
      }
      _right(e) {
        return (e + 1) << 1;
      }
      _greater(e, t) {
        return this._comparator(this._heap[e], this._heap[t]);
      }
      _swap(e, t) {
        let n = this._heap[e];
        ((this._heap[e] = this._heap[t]), (this._heap[t] = n));
      }
      _siftUp() {
        let e = this.size - 1;
        for (; e > 0 && this._greater(e, this._parent(e)); ) (this._swap(e, this._parent(e)), (e = this._parent(e)));
      }
      _siftDown() {
        let e = 0;
        for (
          ;
          (this._left(e) < this.size && this._greater(this._left(e), e)) ||
          (this._right(e) < this.size && this._greater(this._right(e), e));
        ) {
          let t =
            this._right(e) < this.size && this._greater(this._right(e), this._left(e)) ? this._right(e) : this._left(e);
          (this._swap(e, t), (e = t));
        }
      }
    },
    CharTrie = class {
      constructor() {
        this.root = CharTrieNode.default();
      }
      extend(e) {
        for (let t of e) this.push(t);
      }
      push(e) {
        let t = this.root;
        for (let n of e) {
          let e = t.children.get(n);
          (e === void 0 && ((e = CharTrieNode.default()), t.children.set(n, e)), (t = e));
        }
        t.isLeaf = !0;
      }
      *commonPrefixSearch(e) {
        let t = this.root,
          n = ``;
        for (let r = 0; r < e.length && t !== void 0; ++r) {
          let i = e[r];
          ((n += i), (t = t.children.get(i)), t !== void 0 && t.isLeaf && (yield n));
        }
      }
    },
    CharTrieNode = class e {
      constructor(e, t) {
        ((this.isLeaf = e), (this.children = t));
      }
      static default() {
        return new e(!1, new Map());
      }
    },
    TokenLattice = class {
      constructor(e, t, n) {
        ((this.sentence = e),
          (this.len = e.length),
          (this.bosTokenId = t),
          (this.eosTokenId = n),
          (this.nodes = []),
          (this.beginNodes = Array.from({ length: this.len + 1 }, () => [])),
          (this.endNodes = Array.from({ length: this.len + 1 }, () => [])));
        let r = new TokenLatticeNode(this.bosTokenId, 0, 0, 0, 0),
          i = new TokenLatticeNode(this.eosTokenId, 1, this.len, 0, 0);
        (this.nodes.push(r.clone()),
          this.nodes.push(i.clone()),
          this.beginNodes[this.len].push(i),
          this.endNodes[0].push(r));
      }
      insert(e, t, n, r) {
        let i = this.nodes.length,
          a = new TokenLatticeNode(r, i, e, t, n);
        (this.beginNodes[e].push(a), this.endNodes[e + t].push(a), this.nodes.push(a));
      }
      viterbi() {
        let e = this.len,
          t = 0;
        for (; t <= e; ) {
          if (this.beginNodes[t].length == 0) return [];
          for (let e of this.beginNodes[t]) {
            e.prev = null;
            let n = 0,
              r = null;
            for (let i of this.endNodes[t]) {
              let t = i.backtraceScore + e.score;
              (r === null || t > n) && ((r = i.clone()), (n = t));
            }
            if (r !== null) ((e.prev = r), (e.backtraceScore = n));
            else return [];
          }
          ++t;
        }
        let n = [],
          r = this.beginNodes[e][0].prev;
        if (r === null) return [];
        let i = r.clone();
        for (; i.prev !== null; ) (n.push(i.clone()), (i = i.clone().prev.clone()));
        return (n.reverse(), n);
      }
      piece(e) {
        return this.sentence.slice(e.pos, e.pos + e.length);
      }
      tokens() {
        return this.viterbi().map((e) => this.piece(e));
      }
      tokenIds() {
        return this.viterbi().map((e) => e.tokenId);
      }
    },
    TokenLatticeNode = class e {
      constructor(e, t, n, r, i) {
        ((this.tokenId = e),
          (this.nodeId = t),
          (this.pos = n),
          (this.length = r),
          (this.score = i),
          (this.prev = null),
          (this.backtraceScore = 0));
      }
      clone() {
        let t = new e(this.tokenId, this.nodeId, this.pos, this.length, this.score);
        return ((t.prev = this.prev), (t.backtraceScore = this.backtraceScore), t);
      }
    },
    TOKEN_TYPES = Object.freeze({
      Text: `Text`,
      NumericLiteral: `NumericLiteral`,
      BooleanLiteral: `BooleanLiteral`,
      StringLiteral: `StringLiteral`,
      Identifier: `Identifier`,
      Equals: `Equals`,
      OpenParen: `OpenParen`,
      CloseParen: `CloseParen`,
      OpenStatement: `OpenStatement`,
      CloseStatement: `CloseStatement`,
      OpenExpression: `OpenExpression`,
      CloseExpression: `CloseExpression`,
      OpenSquareBracket: `OpenSquareBracket`,
      CloseSquareBracket: `CloseSquareBracket`,
      OpenCurlyBracket: `OpenCurlyBracket`,
      CloseCurlyBracket: `CloseCurlyBracket`,
      Comma: `Comma`,
      Dot: `Dot`,
      Colon: `Colon`,
      Pipe: `Pipe`,
      CallOperator: `CallOperator`,
      AdditiveBinaryOperator: `AdditiveBinaryOperator`,
      MultiplicativeBinaryOperator: `MultiplicativeBinaryOperator`,
      ComparisonBinaryOperator: `ComparisonBinaryOperator`,
      UnaryOperator: `UnaryOperator`,
      Set: `Set`,
      If: `If`,
      For: `For`,
      In: `In`,
      Is: `Is`,
      NotIn: `NotIn`,
      Else: `Else`,
      EndIf: `EndIf`,
      ElseIf: `ElseIf`,
      EndFor: `EndFor`,
      And: `And`,
      Or: `Or`,
      Not: `UnaryOperator`,
    }),
    KEYWORDS = Object.freeze({
      set: TOKEN_TYPES.Set,
      for: TOKEN_TYPES.For,
      in: TOKEN_TYPES.In,
      is: TOKEN_TYPES.Is,
      if: TOKEN_TYPES.If,
      else: TOKEN_TYPES.Else,
      endif: TOKEN_TYPES.EndIf,
      elif: TOKEN_TYPES.ElseIf,
      endfor: TOKEN_TYPES.EndFor,
      and: TOKEN_TYPES.And,
      or: TOKEN_TYPES.Or,
      not: TOKEN_TYPES.Not,
      'not in': TOKEN_TYPES.NotIn,
      true: TOKEN_TYPES.BooleanLiteral,
      false: TOKEN_TYPES.BooleanLiteral,
    }),
    Token = class {
      constructor(e, t) {
        ((this.value = e), (this.type = t));
      }
    };
  function isWord(e) {
    return /\w/.test(e);
  }
  function isInteger(e) {
    return /[0-9]/.test(e);
  }
  var ORDERED_MAPPING_TABLE = [
      [`{%`, TOKEN_TYPES.OpenStatement],
      [`%}`, TOKEN_TYPES.CloseStatement],
      [`{{`, TOKEN_TYPES.OpenExpression],
      [`}}`, TOKEN_TYPES.CloseExpression],
      [`(`, TOKEN_TYPES.OpenParen],
      [`)`, TOKEN_TYPES.CloseParen],
      [`{`, TOKEN_TYPES.OpenCurlyBracket],
      [`}`, TOKEN_TYPES.CloseCurlyBracket],
      [`[`, TOKEN_TYPES.OpenSquareBracket],
      [`]`, TOKEN_TYPES.CloseSquareBracket],
      [`,`, TOKEN_TYPES.Comma],
      [`.`, TOKEN_TYPES.Dot],
      [`:`, TOKEN_TYPES.Colon],
      [`|`, TOKEN_TYPES.Pipe],
      [`<=`, TOKEN_TYPES.ComparisonBinaryOperator],
      [`>=`, TOKEN_TYPES.ComparisonBinaryOperator],
      [`==`, TOKEN_TYPES.ComparisonBinaryOperator],
      [`!=`, TOKEN_TYPES.ComparisonBinaryOperator],
      [`<`, TOKEN_TYPES.ComparisonBinaryOperator],
      [`>`, TOKEN_TYPES.ComparisonBinaryOperator],
      [`+`, TOKEN_TYPES.AdditiveBinaryOperator],
      [`-`, TOKEN_TYPES.AdditiveBinaryOperator],
      [`*`, TOKEN_TYPES.MultiplicativeBinaryOperator],
      [`/`, TOKEN_TYPES.MultiplicativeBinaryOperator],
      [`%`, TOKEN_TYPES.MultiplicativeBinaryOperator],
      [`=`, TOKEN_TYPES.Equals],
    ],
    ESCAPE_CHARACTERS = new Map([
      [
        `n`,
        `
`,
      ],
      [`t`, `	`],
      [`r`, `\r`],
      [`b`, `\b`],
      [`f`, `\f`],
      [`v`, `\v`],
      [`'`, `'`],
      [`"`, `"`],
      [`\\`, `\\`],
    ]);
  function preprocess(e, t = {}) {
    return (
      e.endsWith(`
`) && (e = e.slice(0, -1)),
      (e = e.replace(/{#.*?#}/gs, `{##}`)),
      t.lstrip_blocks && (e = e.replace(/^[ \t]*({[#%])/gm, `$1`)),
      t.trim_blocks && (e = e.replace(/([#%]})\n/g, `$1`)),
      e
        .replace(/{##}/g, ``)
        .replace(/-%}\s*/g, `%}`)
        .replace(/\s*{%-/g, `{%`)
        .replace(/-}}\s*/g, `}}`)
        .replace(/\s*{{-/g, `{{`)
    );
  }
  function tokenize(e, t = {}) {
    let n = [],
      r = preprocess(e, t),
      i = 0,
      a = (e) => {
        let t = ``;
        for (; e(r[i]); ) {
          if (r[i] === `\\`) {
            if ((++i, i >= r.length)) throw SyntaxError(`Unexpected end of input`);
            let e = r[i++],
              n = ESCAPE_CHARACTERS.get(e);
            if (n === void 0) throw SyntaxError(`Unexpected escaped character: ${e}`);
            t += n;
            continue;
          }
          if (((t += r[i++]), i >= r.length)) throw SyntaxError(`Unexpected end of input`);
        }
        return t;
      };
    main: for (; i < r.length; ) {
      let e = n.at(-1)?.type;
      if (e === void 0 || e === TOKEN_TYPES.CloseStatement || e === TOKEN_TYPES.CloseExpression) {
        let e = ``;
        for (; i < r.length && !(r[i] === `{` && (r[i + 1] === `%` || r[i + 1] === `{`)); ) e += r[i++];
        if (e.length > 0) {
          n.push(new Token(e, TOKEN_TYPES.Text));
          continue;
        }
      }
      a((e) => /\s/.test(e));
      let t = r[i];
      if (t === `-` || t === `+`) {
        let e = n.at(-1)?.type;
        if (e === TOKEN_TYPES.Text || e === void 0) throw SyntaxError(`Unexpected character: ${t}`);
        switch (e) {
          case TOKEN_TYPES.Identifier:
          case TOKEN_TYPES.NumericLiteral:
          case TOKEN_TYPES.BooleanLiteral:
          case TOKEN_TYPES.StringLiteral:
          case TOKEN_TYPES.CloseParen:
          case TOKEN_TYPES.CloseSquareBracket:
            break;
          default: {
            ++i;
            let e = a(isInteger);
            n.push(new Token(`${t}${e}`, e.length > 0 ? TOKEN_TYPES.NumericLiteral : TOKEN_TYPES.UnaryOperator));
            continue;
          }
        }
      }
      for (let [e, t] of ORDERED_MAPPING_TABLE)
        if (r.slice(i, i + e.length) === e) {
          (n.push(new Token(e, t)), (i += e.length));
          continue main;
        }
      if (t === `'` || t === `"`) {
        ++i;
        let e = a((e) => e !== t);
        (n.push(new Token(e, TOKEN_TYPES.StringLiteral)), ++i);
        continue;
      }
      if (isInteger(t)) {
        let e = a(isInteger);
        n.push(new Token(e, TOKEN_TYPES.NumericLiteral));
        continue;
      }
      if (isWord(t)) {
        let e = a(isWord),
          t = Object.hasOwn(KEYWORDS, e) ? KEYWORDS[e] : TOKEN_TYPES.Identifier;
        t === TOKEN_TYPES.In && n.at(-1)?.type === TOKEN_TYPES.Not
          ? (n.pop(), n.push(new Token(`not in`, TOKEN_TYPES.NotIn)))
          : n.push(new Token(e, t));
        continue;
      }
      throw SyntaxError(`Unexpected character: ${t}`);
    }
    return n;
  }
  var Statement = class {
      type = `Statement`;
    },
    Program = class extends Statement {
      constructor(e) {
        (super(), (this.body = e));
      }
      type = `Program`;
    },
    If = class extends Statement {
      constructor(e, t, n) {
        (super(), (this.test = e), (this.body = t), (this.alternate = n));
      }
      type = `If`;
    },
    For = class extends Statement {
      constructor(e, t, n) {
        (super(), (this.loopvar = e), (this.iterable = t), (this.body = n));
      }
      type = `For`;
    },
    SetStatement = class extends Statement {
      constructor(e, t) {
        (super(), (this.assignee = e), (this.value = t));
      }
      type = `Set`;
    },
    Expression = class extends Statement {
      type = `Expression`;
    },
    MemberExpression = class extends Expression {
      constructor(e, t, n) {
        (super(), (this.object = e), (this.property = t), (this.computed = n));
      }
      type = `MemberExpression`;
    },
    CallExpression = class extends Expression {
      constructor(e, t) {
        (super(), (this.callee = e), (this.args = t));
      }
      type = `CallExpression`;
    },
    Identifier = class extends Expression {
      constructor(e) {
        (super(), (this.value = e));
      }
      type = `Identifier`;
    },
    Literal = class extends Expression {
      constructor(e) {
        (super(), (this.value = e));
      }
      type = `Literal`;
    },
    NumericLiteral = class extends Literal {
      type = `NumericLiteral`;
    },
    StringLiteral = class extends Literal {
      type = `StringLiteral`;
    },
    BooleanLiteral = class extends Literal {
      type = `BooleanLiteral`;
    },
    ArrayLiteral = class extends Literal {
      type = `ArrayLiteral`;
    },
    TupleLiteral = class extends Literal {
      type = `TupleLiteral`;
    },
    ObjectLiteral = class extends Literal {
      type = `ObjectLiteral`;
    },
    BinaryExpression = class extends Expression {
      constructor(e, t, n) {
        (super(), (this.operator = e), (this.left = t), (this.right = n));
      }
      type = `BinaryExpression`;
    },
    FilterExpression = class extends Expression {
      constructor(e, t) {
        (super(), (this.operand = e), (this.filter = t));
      }
      type = `FilterExpression`;
    },
    TestExpression = class extends Expression {
      constructor(e, t, n) {
        (super(), (this.operand = e), (this.negate = t), (this.test = n));
      }
      type = `TestExpression`;
    },
    UnaryExpression = class extends Expression {
      constructor(e, t) {
        (super(), (this.operator = e), (this.argument = t));
      }
      type = `UnaryExpression`;
    },
    SliceExpression = class extends Expression {
      constructor(e = void 0, t = void 0, n = void 0) {
        (super(), (this.start = e), (this.stop = t), (this.step = n));
      }
      type = `SliceExpression`;
    },
    KeywordArgumentExpression = class extends Expression {
      constructor(e, t) {
        (super(), (this.key = e), (this.value = t));
      }
      type = `KeywordArgumentExpression`;
    };
  function parse(e) {
    let t = new Program([]),
      n = 0;
    function r(t, r) {
      let i = e[n++];
      if (!i || i.type !== t) throw Error(`Parser Error: ${r}. ${i.type} !== ${t}.`);
      return i;
    }
    function i() {
      switch (e[n].type) {
        case TOKEN_TYPES.Text:
          return s();
        case TOKEN_TYPES.OpenStatement:
          return c();
        case TOKEN_TYPES.OpenExpression:
          return l();
        default:
          throw SyntaxError(`Unexpected token type: ${e[n].type}`);
      }
    }
    function a(...t) {
      return n + t.length <= e.length && t.some((t, r) => t !== e[n + r].type);
    }
    function o(...t) {
      return n + t.length <= e.length && t.every((t, r) => t === e[n + r].type);
    }
    function s() {
      return new StringLiteral(r(TOKEN_TYPES.Text, `Expected text token`).value);
    }
    function c() {
      r(TOKEN_TYPES.OpenStatement, `Expected opening statement token`);
      let t;
      switch (e[n].type) {
        case TOKEN_TYPES.Set:
          (++n, (t = u()), r(TOKEN_TYPES.CloseStatement, `Expected closing statement token`));
          break;
        case TOKEN_TYPES.If:
          (++n,
            (t = d()),
            r(TOKEN_TYPES.OpenStatement, `Expected {% token`),
            r(TOKEN_TYPES.EndIf, `Expected endif token`),
            r(TOKEN_TYPES.CloseStatement, `Expected %} token`));
          break;
        case TOKEN_TYPES.For:
          (++n,
            (t = p()),
            r(TOKEN_TYPES.OpenStatement, `Expected {% token`),
            r(TOKEN_TYPES.EndFor, `Expected endfor token`),
            r(TOKEN_TYPES.CloseStatement, `Expected %} token`));
          break;
        default:
          throw SyntaxError(`Unknown statement type: ${e[n].type}`);
      }
      return t;
    }
    function l() {
      r(TOKEN_TYPES.OpenExpression, `Expected opening expression token`);
      let e = m();
      return (r(TOKEN_TYPES.CloseExpression, `Expected closing expression token`), e);
    }
    function u() {
      let e = m();
      return o(TOKEN_TYPES.Equals) ? (++n, new SetStatement(e, u())) : e;
    }
    function d() {
      let t = m();
      r(TOKEN_TYPES.CloseStatement, `Expected closing statement token`);
      let a = [],
        s = [];
      for (
        ;
        !(
          e[n]?.type === TOKEN_TYPES.OpenStatement &&
          (e[n + 1]?.type === TOKEN_TYPES.ElseIf ||
            e[n + 1]?.type === TOKEN_TYPES.Else ||
            e[n + 1]?.type === TOKEN_TYPES.EndIf)
        );
      )
        a.push(i());
      if (e[n]?.type === TOKEN_TYPES.OpenStatement && e[n + 1]?.type !== TOKEN_TYPES.EndIf)
        if ((++n, o(TOKEN_TYPES.ElseIf))) (r(TOKEN_TYPES.ElseIf, `Expected elseif token`), s.push(d()));
        else
          for (
            r(TOKEN_TYPES.Else, `Expected else token`),
              r(TOKEN_TYPES.CloseStatement, `Expected closing statement token`);
            !(e[n]?.type === TOKEN_TYPES.OpenStatement && e[n + 1]?.type === TOKEN_TYPES.EndIf);
          )
            s.push(i());
      return new If(t, a, s);
    }
    function f(e = !1) {
      let t = e ? A : m,
        r = [t()],
        i = o(TOKEN_TYPES.Comma);
      for (; i && (++n, r.push(t()), o(TOKEN_TYPES.Comma)); );
      return i ? new TupleLiteral(r) : r[0];
    }
    function p() {
      let e = f(!0);
      if (!(e instanceof Identifier || e instanceof TupleLiteral))
        throw SyntaxError(`Expected identifier/tuple for the loop variable, got ${e.type} instead`);
      r(TOKEN_TYPES.In, 'Expected `in` keyword following loop variable');
      let t = m();
      r(TOKEN_TYPES.CloseStatement, `Expected closing statement token`);
      let n = [];
      for (; a(TOKEN_TYPES.OpenStatement, TOKEN_TYPES.EndFor); ) n.push(i());
      return new For(e, t, n);
    }
    function m() {
      return h();
    }
    function h() {
      let e = g();
      if (o(TOKEN_TYPES.If)) {
        ++n;
        let t = g();
        r(TOKEN_TYPES.Else, `Expected else token`);
        let i = g();
        return new If(t, [e], [i]);
      }
      return e;
    }
    function g() {
      let t = _();
      for (; o(TOKEN_TYPES.Or); ) {
        let r = e[n];
        ++n;
        let i = _();
        t = new BinaryExpression(r, t, i);
      }
      return t;
    }
    function _() {
      let t = v();
      for (; o(TOKEN_TYPES.And); ) {
        let r = e[n];
        ++n;
        let i = v();
        t = new BinaryExpression(r, t, i);
      }
      return t;
    }
    function v() {
      let t;
      for (; o(TOKEN_TYPES.Not); ) {
        let r = e[n];
        (++n, (t = new UnaryExpression(r, v())));
      }
      return t ?? y();
    }
    function y() {
      let t = b();
      for (; o(TOKEN_TYPES.ComparisonBinaryOperator) || o(TOKEN_TYPES.In) || o(TOKEN_TYPES.NotIn); ) {
        let r = e[n];
        ++n;
        let i = b();
        t = new BinaryExpression(r, t, i);
      }
      return t;
    }
    function b() {
      let t = D();
      for (; o(TOKEN_TYPES.AdditiveBinaryOperator); ) {
        let r = e[n];
        ++n;
        let i = D();
        t = new BinaryExpression(r, t, i);
      }
      return t;
    }
    function x() {
      let e = E();
      return o(TOKEN_TYPES.OpenParen) ? S(e) : e;
    }
    function S(e) {
      let t = new CallExpression(e, C());
      return (o(TOKEN_TYPES.OpenParen) && (t = S(t)), t);
    }
    function C() {
      r(TOKEN_TYPES.OpenParen, `Expected opening parenthesis for arguments list`);
      let e = w();
      return (r(TOKEN_TYPES.CloseParen, `Expected closing parenthesis for arguments list`), e);
    }
    function w() {
      let e = [];
      for (; !o(TOKEN_TYPES.CloseParen); ) {
        let t = m();
        if (o(TOKEN_TYPES.Equals)) {
          if ((++n, !(t instanceof Identifier))) throw SyntaxError(`Expected identifier for keyword argument`);
          let e = m();
          t = new KeywordArgumentExpression(t, e);
        }
        (e.push(t), o(TOKEN_TYPES.Comma) && ++n);
      }
      return e;
    }
    function T() {
      let e = [],
        t = !1;
      for (; !o(TOKEN_TYPES.CloseSquareBracket); )
        o(TOKEN_TYPES.Colon) ? (e.push(void 0), ++n, (t = !0)) : (e.push(m()), o(TOKEN_TYPES.Colon) && (++n, (t = !0)));
      if (e.length === 0) throw SyntaxError(`Expected at least one argument for member/slice expression`);
      if (t) {
        if (e.length > 3) throw SyntaxError(`Expected 0-3 arguments for slice expression`);
        return new SliceExpression(...e);
      }
      return e[0];
    }
    function E() {
      let t = A();
      for (; o(TOKEN_TYPES.Dot) || o(TOKEN_TYPES.OpenSquareBracket); ) {
        let i = e[n];
        ++n;
        let a,
          o = i.type !== TOKEN_TYPES.Dot;
        if (o) ((a = T()), r(TOKEN_TYPES.CloseSquareBracket, `Expected closing square bracket`));
        else if (((a = A()), a.type !== `Identifier`)) throw SyntaxError(`Expected identifier following dot operator`);
        t = new MemberExpression(t, a, o);
      }
      return t;
    }
    function D() {
      let t = O();
      for (; o(TOKEN_TYPES.MultiplicativeBinaryOperator); ) {
        let r = e[n];
        ++n;
        let i = O();
        t = new BinaryExpression(r, t, i);
      }
      return t;
    }
    function O() {
      let e = k();
      for (; o(TOKEN_TYPES.Is); ) {
        ++n;
        let t = o(TOKEN_TYPES.Not);
        t && ++n;
        let r = A();
        if ((r instanceof BooleanLiteral && (r = new Identifier(r.value.toString())), !(r instanceof Identifier)))
          throw SyntaxError(`Expected identifier for the test`);
        e = new TestExpression(e, t, r);
      }
      return e;
    }
    function k() {
      let e = x();
      for (; o(TOKEN_TYPES.Pipe); ) {
        ++n;
        let t = A();
        if (!(t instanceof Identifier)) throw SyntaxError(`Expected identifier for the filter`);
        (o(TOKEN_TYPES.OpenParen) && (t = S(t)), (e = new FilterExpression(e, t)));
      }
      return e;
    }
    function A() {
      let t = e[n];
      switch (t.type) {
        case TOKEN_TYPES.NumericLiteral:
          return (++n, new NumericLiteral(Number(t.value)));
        case TOKEN_TYPES.StringLiteral:
          return (++n, new StringLiteral(t.value));
        case TOKEN_TYPES.BooleanLiteral:
          return (++n, new BooleanLiteral(t.value === `true`));
        case TOKEN_TYPES.Identifier:
          return (++n, new Identifier(t.value));
        case TOKEN_TYPES.OpenParen: {
          ++n;
          let t = f();
          if (e[n].type !== TOKEN_TYPES.CloseParen)
            throw SyntaxError(`Expected closing parenthesis, got ${e[n].type} instead`);
          return (++n, t);
        }
        case TOKEN_TYPES.OpenSquareBracket: {
          ++n;
          let e = [];
          for (; !o(TOKEN_TYPES.CloseSquareBracket); ) (e.push(m()), o(TOKEN_TYPES.Comma) && ++n);
          return (++n, new ArrayLiteral(e));
        }
        case TOKEN_TYPES.OpenCurlyBracket: {
          ++n;
          let e = new Map();
          for (; !o(TOKEN_TYPES.CloseCurlyBracket); ) {
            let t = m();
            r(TOKEN_TYPES.Colon, `Expected colon between key and value in object literal`);
            let i = m();
            (e.set(t, i), o(TOKEN_TYPES.Comma) && ++n);
          }
          return (++n, new ObjectLiteral(e));
        }
        default:
          throw SyntaxError(`Unexpected token: ${t.type}`);
      }
    }
    for (; n < e.length; ) t.body.push(i());
    return t;
  }
  function range(e, t, n = 1) {
    t === void 0 && ((t = e), (e = 0));
    let r = [];
    for (let i = e; i < t; i += n) r.push(i);
    return r;
  }
  function slice(e, t, n, r = 1) {
    let i = Math.sign(r);
    i >= 0
      ? ((t = (t ??= 0) < 0 ? Math.max(e.length + t, 0) : Math.min(t, e.length)),
        (n = (n ??= e.length) < 0 ? Math.max(e.length + n, 0) : Math.min(n, e.length)))
      : ((t = (t ??= e.length - 1) < 0 ? Math.max(e.length + t, -1) : Math.min(t, e.length - 1)),
        (n = (n ??= -1) < -1 ? Math.max(e.length + n, -1) : Math.min(n, e.length - 1)));
    let a = [];
    for (let o = t; i * o < i * n; o += r) a.push(e[o]);
    return a;
  }
  function titleCase(e) {
    return e.replace(/\b\w/g, (e) => e.toUpperCase());
  }
  var RuntimeValue = class {
      type = `RuntimeValue`;
      value;
      builtins = new Map();
      constructor(e = void 0) {
        this.value = e;
      }
      __bool__() {
        return new BooleanValue(!!this.value);
      }
    },
    NumericValue = class extends RuntimeValue {
      type = `NumericValue`;
    },
    StringValue = class extends RuntimeValue {
      type = `StringValue`;
      builtins = new Map([
        [`upper`, new FunctionValue(() => new StringValue(this.value.toUpperCase()))],
        [`lower`, new FunctionValue(() => new StringValue(this.value.toLowerCase()))],
        [`strip`, new FunctionValue(() => new StringValue(this.value.trim()))],
        [`title`, new FunctionValue(() => new StringValue(titleCase(this.value)))],
        [`length`, new NumericValue(this.value.length)],
      ]);
    },
    BooleanValue = class extends RuntimeValue {
      type = `BooleanValue`;
    },
    ObjectValue = class extends RuntimeValue {
      type = `ObjectValue`;
      __bool__() {
        return new BooleanValue(this.value.size > 0);
      }
      builtins = new Map([
        [
          `get`,
          new FunctionValue(([e, t]) => {
            if (!(e instanceof StringValue)) throw Error(`Object key must be a string: got ${e.type}`);
            return this.value.get(e.value) ?? t ?? new NullValue();
          }),
        ],
        [
          `items`,
          new FunctionValue(
            () =>
              new ArrayValue(Array.from(this.value.entries()).map(([e, t]) => new ArrayValue([new StringValue(e), t]))),
          ),
        ],
      ]);
    },
    ArrayValue = class extends RuntimeValue {
      type = `ArrayValue`;
      builtins = new Map([[`length`, new NumericValue(this.value.length)]]);
      __bool__() {
        return new BooleanValue(this.value.length > 0);
      }
    },
    TupleValue = class extends ArrayValue {
      type = `TupleValue`;
    },
    FunctionValue = class extends RuntimeValue {
      type = `FunctionValue`;
    },
    NullValue = class extends RuntimeValue {
      type = `NullValue`;
    },
    UndefinedValue = class extends RuntimeValue {
      type = `UndefinedValue`;
    },
    Environment = class {
      constructor(e) {
        this.parent = e;
      }
      variables = new Map([
        [
          `namespace`,
          new FunctionValue((e) => {
            if (e.length === 0) return new ObjectValue(new Map());
            if (e.length !== 1 || !(e[0] instanceof ObjectValue))
              throw Error('`namespace` expects either zero arguments or a single object argument');
            return e[0];
          }),
        ],
      ]);
      tests = new Map([
        [`boolean`, (e) => e.type === `BooleanValue`],
        [`callable`, (e) => e instanceof FunctionValue],
        [
          `odd`,
          (e) => {
            if (e.type !== `NumericValue`) throw Error(`Cannot apply test "odd" to type: ${e.type}`);
            return e.value % 2 != 0;
          },
        ],
        [
          `even`,
          (e) => {
            if (e.type !== `NumericValue`) throw Error(`Cannot apply test "even" to type: ${e.type}`);
            return e.value % 2 == 0;
          },
        ],
        [`false`, (e) => e.type === `BooleanValue` && !e.value],
        [`true`, (e) => e.type === `BooleanValue` && e.value],
        [`number`, (e) => e.type === `NumericValue`],
        [`integer`, (e) => e.type === `NumericValue` && Number.isInteger(e.value)],
        [`iterable`, (e) => e instanceof ArrayValue || e instanceof StringValue],
        [
          `lower`,
          (e) => {
            let t = e.value;
            return e.type === `StringValue` && t === t.toLowerCase();
          },
        ],
        [
          `upper`,
          (e) => {
            let t = e.value;
            return e.type === `StringValue` && t === t.toUpperCase();
          },
        ],
        [`none`, (e) => e.type === `NullValue`],
        [`defined`, (e) => e.type !== `UndefinedValue`],
        [`undefined`, (e) => e.type === `UndefinedValue`],
        [`equalto`, (e, t) => e.value === t.value],
      ]);
      set(e, t) {
        return this.declareVariable(e, convertToRuntimeValues(t));
      }
      declareVariable(e, t) {
        if (this.variables.has(e)) throw SyntaxError(`Variable already declared: ${e}`);
        return (this.variables.set(e, t), t);
      }
      setVariable(e, t) {
        return (this.variables.set(e, t), t);
      }
      resolve(e) {
        if (this.variables.has(e)) return this;
        if (this.parent) return this.parent.resolve(e);
        throw Error(`Unknown variable: ${e}`);
      }
      lookupVariable(e) {
        try {
          return this.resolve(e).variables.get(e) ?? new UndefinedValue();
        } catch {
          return new UndefinedValue();
        }
      }
    },
    Interpreter = class {
      global;
      constructor(e) {
        this.global = e ?? new Environment();
      }
      run(e) {
        return this.evaluate(e, this.global);
      }
      evaluateBinaryExpression(e, t) {
        let n = this.evaluate(e.left, t);
        switch (e.operator.value) {
          case `and`:
            return n.__bool__().value ? this.evaluate(e.right, t) : n;
          case `or`:
            return n.__bool__().value ? n : this.evaluate(e.right, t);
        }
        let r = this.evaluate(e.right, t);
        switch (e.operator.value) {
          case `==`:
            return new BooleanValue(n.value == r.value);
          case `!=`:
            return new BooleanValue(n.value != r.value);
        }
        if (n instanceof UndefinedValue || r instanceof UndefinedValue)
          throw Error(`Cannot perform operation on undefined values`);
        if (n instanceof NullValue || r instanceof NullValue) throw Error(`Cannot perform operation on null values`);
        if (n instanceof NumericValue && r instanceof NumericValue)
          switch (e.operator.value) {
            case `+`:
              return new NumericValue(n.value + r.value);
            case `-`:
              return new NumericValue(n.value - r.value);
            case `*`:
              return new NumericValue(n.value * r.value);
            case `/`:
              return new NumericValue(n.value / r.value);
            case `%`:
              return new NumericValue(n.value % r.value);
            case `<`:
              return new BooleanValue(n.value < r.value);
            case `>`:
              return new BooleanValue(n.value > r.value);
            case `>=`:
              return new BooleanValue(n.value >= r.value);
            case `<=`:
              return new BooleanValue(n.value <= r.value);
          }
        else if (n instanceof ArrayValue && r instanceof ArrayValue)
          switch (e.operator.value) {
            case `+`:
              return new ArrayValue(n.value.concat(r.value));
          }
        else if (r instanceof ArrayValue) {
          let t = r.value.find((e) => e.value === n.value) !== void 0;
          switch (e.operator.value) {
            case `in`:
              return new BooleanValue(t);
            case `not in`:
              return new BooleanValue(!t);
          }
        }
        if (n instanceof StringValue || r instanceof StringValue)
          switch (e.operator.value) {
            case `+`:
              return new StringValue(n.value.toString() + r.value.toString());
          }
        if (n instanceof StringValue && r instanceof StringValue)
          switch (e.operator.value) {
            case `in`:
              return new BooleanValue(r.value.includes(n.value));
            case `not in`:
              return new BooleanValue(!r.value.includes(n.value));
          }
        if (n instanceof StringValue && r instanceof ObjectValue)
          switch (e.operator.value) {
            case `in`:
              return new BooleanValue(r.value.has(n.value));
            case `not in`:
              return new BooleanValue(!r.value.has(n.value));
          }
        throw SyntaxError(`Unknown operator "${e.operator.value}" between ${n.type} and ${r.type}`);
      }
      evaluateFilterExpression(e, t) {
        let n = this.evaluate(e.operand, t);
        if (e.filter.type === `Identifier`) {
          let t = e.filter;
          if (n instanceof ArrayValue)
            switch (t.value) {
              case `list`:
                return n;
              case `first`:
                return n.value[0];
              case `last`:
                return n.value[n.value.length - 1];
              case `length`:
                return new NumericValue(n.value.length);
              case `reverse`:
                return new ArrayValue(n.value.reverse());
              case `sort`:
                return new ArrayValue(
                  n.value.sort((e, t) => {
                    if (e.type !== t.type) throw Error(`Cannot compare different types: ${e.type} and ${t.type}`);
                    switch (e.type) {
                      case `NumericValue`:
                        return e.value - t.value;
                      case `StringValue`:
                        return e.value.localeCompare(t.value);
                      default:
                        throw Error(`Cannot compare type: ${e.type}`);
                    }
                  }),
                );
              default:
                throw Error(`Unknown ArrayValue filter: ${t.value}`);
            }
          else if (n instanceof StringValue)
            switch (t.value) {
              case `length`:
                return new NumericValue(n.value.length);
              case `upper`:
                return new StringValue(n.value.toUpperCase());
              case `lower`:
                return new StringValue(n.value.toLowerCase());
              case `title`:
                return new StringValue(titleCase(n.value));
              case `capitalize`:
                return new StringValue(n.value.charAt(0).toUpperCase() + n.value.slice(1));
              case `trim`:
                return new StringValue(n.value.trim());
              default:
                throw Error(`Unknown StringValue filter: ${t.value}`);
            }
          else if (n instanceof NumericValue)
            switch (t.value) {
              case `abs`:
                return new NumericValue(Math.abs(n.value));
              default:
                throw Error(`Unknown NumericValue filter: ${t.value}`);
            }
          else if (n instanceof ObjectValue)
            switch (t.value) {
              case `items`:
                return new ArrayValue(
                  Array.from(n.value.entries()).map(([e, t]) => new ArrayValue([new StringValue(e), t])),
                );
              case `length`:
                return new NumericValue(n.value.size);
              default:
                throw Error(`Unknown ObjectValue filter: ${t.value}`);
            }
          throw Error(`Cannot apply filter "${t.value}" to type: ${n.type}`);
        } else if (e.filter.type === `CallExpression`) {
          let r = e.filter;
          if (r.callee.type !== `Identifier`) throw Error(`Unknown filter: ${r.callee.type}`);
          let i = r.callee.value;
          if (n instanceof ArrayValue) {
            switch (i) {
              case `selectattr`: {
                if (n.value.some((e) => !(e instanceof ObjectValue)))
                  throw Error('`selectattr` can only be applied to array of objects');
                if (r.args.some((e) => e.type !== `StringLiteral`))
                  throw Error('arguments of `selectattr` must be strings');
                let [e, i, a] = r.args.map((e) => this.evaluate(e, t)),
                  o;
                if (i) {
                  let e = t.tests.get(i.value);
                  if (!e) throw Error(`Unknown test: ${i.value}`);
                  o = e;
                } else o = (...e) => e[0].__bool__().value;
                return new ArrayValue(
                  n.value.filter((t) => {
                    let n = t.value.get(e.value);
                    return n ? o(n, a) : !1;
                  }),
                );
              }
            }
            throw Error(`Unknown ArrayValue filter: ${i}`);
          } else throw Error(`Cannot apply filter "${i}" to type: ${n.type}`);
        }
        throw Error(`Unknown filter: ${e.filter.type}`);
      }
      evaluateTestExpression(e, t) {
        let n = this.evaluate(e.operand, t),
          r = t.tests.get(e.test.value);
        if (!r) throw Error(`Unknown test: ${e.test.value}`);
        let i = r(n);
        return new BooleanValue(e.negate ? !i : i);
      }
      evaluateUnaryExpression(e, t) {
        let n = this.evaluate(e.argument, t);
        switch (e.operator.value) {
          case `not`:
            return new BooleanValue(!n.value);
          default:
            throw SyntaxError(`Unknown operator: ${e.operator.value}`);
        }
      }
      evalProgram(e, t) {
        return this.evaluateBlock(e.body, t);
      }
      evaluateBlock(e, t) {
        let n = ``;
        for (let r of e) {
          let e = this.evaluate(r, t);
          e.type !== `NullValue` && e.type !== `UndefinedValue` && (n += e.value);
        }
        return new StringValue(n);
      }
      evaluateIdentifier(e, t) {
        return t.lookupVariable(e.value);
      }
      evaluateCallExpression(e, t) {
        let n = [],
          r = new Map();
        for (let i of e.args)
          if (i.type === `KeywordArgumentExpression`) {
            let e = i;
            r.set(e.key.value, this.evaluate(e.value, t));
          } else n.push(this.evaluate(i, t));
        r.size > 0 && n.push(new ObjectValue(r));
        let i = this.evaluate(e.callee, t);
        if (i.type !== `FunctionValue`) throw Error(`Cannot call something that is not a function: got ${i.type}`);
        return i.value(n, t);
      }
      evaluateSliceExpression(e, t, n) {
        if (!(e instanceof ArrayValue || e instanceof StringValue))
          throw Error(`Slice object must be an array or string`);
        let r = this.evaluate(t.start, n),
          i = this.evaluate(t.stop, n),
          a = this.evaluate(t.step, n);
        if (!(r instanceof NumericValue || r instanceof UndefinedValue))
          throw Error(`Slice start must be numeric or undefined`);
        if (!(i instanceof NumericValue || i instanceof UndefinedValue))
          throw Error(`Slice stop must be numeric or undefined`);
        if (!(a instanceof NumericValue || a instanceof UndefinedValue))
          throw Error(`Slice step must be numeric or undefined`);
        return e instanceof ArrayValue
          ? new ArrayValue(slice(e.value, r.value, i.value, a.value))
          : new StringValue(slice(Array.from(e.value), r.value, i.value, a.value).join(``));
      }
      evaluateMemberExpression(e, t) {
        let n = this.evaluate(e.object, t),
          r;
        if (e.computed) {
          if (e.property.type === `SliceExpression`) return this.evaluateSliceExpression(n, e.property, t);
          r = this.evaluate(e.property, t);
        } else r = new StringValue(e.property.value);
        let i;
        if (n instanceof ObjectValue) {
          if (!(r instanceof StringValue)) throw Error(`Cannot access property with non-string: got ${r.type}`);
          i = n.value.get(r.value) ?? n.builtins.get(r.value);
        } else if (n instanceof ArrayValue || n instanceof StringValue)
          if (r instanceof NumericValue)
            ((i = n.value.at(r.value)), n instanceof StringValue && (i = new StringValue(n.value.at(r.value))));
          else if (r instanceof StringValue) i = n.builtins.get(r.value);
          else throw Error(`Cannot access property with non-string/non-number: got ${r.type}`);
        else {
          if (!(r instanceof StringValue)) throw Error(`Cannot access property with non-string: got ${r.type}`);
          i = n.builtins.get(r.value);
        }
        return i instanceof RuntimeValue ? i : new UndefinedValue();
      }
      evaluateSet(e, t) {
        let n = this.evaluate(e.value, t);
        if (e.assignee.type === `Identifier`) {
          let r = e.assignee.value;
          t.setVariable(r, n);
        } else if (e.assignee.type === `MemberExpression`) {
          let r = e.assignee,
            i = this.evaluate(r.object, t);
          if (!(i instanceof ObjectValue)) throw Error(`Cannot assign to member of non-object`);
          if (r.property.type !== `Identifier`) throw Error(`Cannot assign to member with non-identifier property`);
          i.value.set(r.property.value, n);
        } else throw Error(`Invalid LHS inside assignment expression: ${JSON.stringify(e.assignee)}`);
        return new NullValue();
      }
      evaluateIf(e, t) {
        let n = this.evaluate(e.test, t);
        return this.evaluateBlock(n.__bool__().value ? e.body : e.alternate, t);
      }
      evaluateFor(e, t) {
        let n = new Environment(t),
          r = this.evaluate(e.iterable, n);
        if (!(r instanceof ArrayValue)) throw Error(`Expected iterable type in for loop: got ${r.type}`);
        let i = ``;
        for (let t = 0; t < r.value.length; ++t) {
          let a = new Map([
            [`index`, new NumericValue(t + 1)],
            [`index0`, new NumericValue(t)],
            [`revindex`, new NumericValue(r.value.length - t)],
            [`revindex0`, new NumericValue(r.value.length - t - 1)],
            [`first`, new BooleanValue(t === 0)],
            [`last`, new BooleanValue(t === r.value.length - 1)],
            [`length`, new NumericValue(r.value.length)],
            [`previtem`, t > 0 ? r.value[t - 1] : new UndefinedValue()],
            [`nextitem`, t < r.value.length - 1 ? r.value[t + 1] : new UndefinedValue()],
          ]);
          n.setVariable(`loop`, new ObjectValue(a));
          let o = r.value[t];
          if (e.loopvar.type === `Identifier`) n.setVariable(e.loopvar.value, o);
          else if (e.loopvar.type === `TupleLiteral`) {
            let t = e.loopvar;
            if (o.type !== `ArrayValue`) throw Error(`Cannot unpack non-iterable type: ${o.type}`);
            let r = o;
            if (t.value.length !== r.value.length)
              throw Error(`Too ${t.value.length > r.value.length ? `few` : `many`} items to unpack`);
            for (let e = 0; e < t.value.length; ++e) {
              if (t.value[e].type !== `Identifier`)
                throw Error(`Cannot unpack non-identifier type: ${t.value[e].type}`);
              n.setVariable(t.value[e].value, r.value[e]);
            }
          }
          let s = this.evaluateBlock(e.body, n);
          i += s.value;
        }
        return new StringValue(i);
      }
      evaluate(e, t) {
        if (e === void 0) return new UndefinedValue();
        switch (e.type) {
          case `Program`:
            return this.evalProgram(e, t);
          case `Set`:
            return this.evaluateSet(e, t);
          case `If`:
            return this.evaluateIf(e, t);
          case `For`:
            return this.evaluateFor(e, t);
          case `NumericLiteral`:
            return new NumericValue(Number(e.value));
          case `StringLiteral`:
            return new StringValue(e.value);
          case `BooleanLiteral`:
            return new BooleanValue(e.value);
          case `ArrayLiteral`:
            return new ArrayValue(e.value.map((e) => this.evaluate(e, t)));
          case `TupleLiteral`:
            return new TupleValue(e.value.map((e) => this.evaluate(e, t)));
          case `ObjectLiteral`: {
            let n = new Map();
            for (let [r, i] of e.value) {
              let e = this.evaluate(r, t);
              if (!(e instanceof StringValue)) throw Error(`Object keys must be strings: got ${e.type}`);
              n.set(e.value, this.evaluate(i, t));
            }
            return new ObjectValue(n);
          }
          case `Identifier`:
            return this.evaluateIdentifier(e, t);
          case `CallExpression`:
            return this.evaluateCallExpression(e, t);
          case `MemberExpression`:
            return this.evaluateMemberExpression(e, t);
          case `UnaryExpression`:
            return this.evaluateUnaryExpression(e, t);
          case `BinaryExpression`:
            return this.evaluateBinaryExpression(e, t);
          case `FilterExpression`:
            return this.evaluateFilterExpression(e, t);
          case `TestExpression`:
            return this.evaluateTestExpression(e, t);
          default:
            throw SyntaxError(`Unknown node type: ${e.type}`);
        }
      }
    };
  function convertToRuntimeValues(e) {
    switch (typeof e) {
      case `number`:
        return new NumericValue(e);
      case `string`:
        return new StringValue(e);
      case `boolean`:
        return new BooleanValue(e);
      case `object`:
        return e === null
          ? new NullValue()
          : Array.isArray(e)
            ? new ArrayValue(e.map(convertToRuntimeValues))
            : new ObjectValue(new Map(Object.entries(e).map(([e, t]) => [e, convertToRuntimeValues(t)])));
      case `function`:
        return new FunctionValue((t, n) => convertToRuntimeValues(e(...t.map((e) => e.value)) ?? null));
      default:
        throw Error(`Cannot convert to runtime value: ${e}`);
    }
  }
  var Template = class {
    parsed;
    constructor(e) {
      let t = tokenize(e, { lstrip_blocks: !0, trim_blocks: !0 });
      this.parsed = parse(t);
    }
    render(e) {
      let t = new Environment();
      (t.set(`false`, !1),
        t.set(`true`, !0),
        t.set(`raise_exception`, (e) => {
          throw Error(e);
        }),
        t.set(`range`, range));
      for (let [n, r] of Object.entries(e)) t.set(n, r);
      return new Interpreter(t).run(this.parsed).value;
    }
  };
  async function loadTokenizer(e, t) {
    let n = await Promise.all([
      getModelJSON(e, `tokenizer.json`, !0, t),
      getModelJSON(e, `tokenizer_config.json`, !0, t),
    ]);
    return (t.legacy !== null && (n[1].legacy = t.legacy), n);
  }
  function regexSplit(e, t) {
    let n = [],
      r = 0;
    for (let i of e.matchAll(t)) {
      let t = i[0];
      (r < i.index && n.push(e.slice(r, i.index)), t.length > 0 && n.push(t), (r = i.index + t.length));
    }
    return (r < e.length && n.push(e.slice(r)), n);
  }
  function createPattern(e, t = !0) {
    if (e.Regex !== void 0) {
      let t = e.Regex.replace(/\\([#&~])/g, `$1`);
      for (let [e, n] of PROBLEMATIC_REGEX_MAP) t = t.replaceAll(e, n);
      return new RegExp(t, `gu`);
    } else if (e.String !== void 0) {
      let n = escapeRegExp(e.String);
      return new RegExp(t ? n : `(${n})`, `gu`);
    } else return (console.warn(`Unknown pattern type:`, e), null);
  }
  function objectToMap(e) {
    return new Map(Object.entries(e));
  }
  function prepareTensorForDecode(e) {
    let t = e.dims;
    switch (t.length) {
      case 1:
        return e.tolist();
      case 2:
        if (t[0] !== 1)
          throw Error(
            'Unable to decode tensor with `batch size !== 1`. Use `tokenizer.batch_decode(...)` for batched inputs.',
          );
        return e.tolist()[0];
      default:
        throw Error(`Expected tensor to have 1-2 dimensions, got ${t.length}.`);
    }
  }
  function clean_up_tokenization(e) {
    return e
      .replace(/ \./g, `.`)
      .replace(/ \?/g, `?`)
      .replace(/ \!/g, `!`)
      .replace(/ ,/g, `,`)
      .replace(/ \' /g, `'`)
      .replace(/ n\'t/g, `n't`)
      .replace(/ \'m/g, `'m`)
      .replace(/ \'s/g, `'s`)
      .replace(/ \'ve/g, `'ve`)
      .replace(/ \'re/g, `'re`);
  }
  function remove_accents(e) {
    return e.replace(/[\u0300-\u036f]/g, ``);
  }
  function lowercase_and_remove_accent(e) {
    return remove_accents(e.toLowerCase());
  }
  function fuse(e, t, n) {
    let r = [],
      i = 0;
    for (; i < e.length; ) {
      if ((r.push(e[i]), (n.get(e[i]) ?? t) !== t)) {
        ++i;
        continue;
      }
      for (; i < e.length && (n.get(e[i]) ?? t) === t; ) ++i;
    }
    return r;
  }
  function whitespace_split(e) {
    return e.match(/\S+/g) || [];
  }
  const PUNCTUATION_REGEX = `\\p{P}\\u0021-\\u002F\\u003A-\\u0040\\u005B-\\u0060\\u007B-\\u007E`,
    PROBLEMATIC_REGEX_MAP = new Map([
      [`(?i:'s|'t|'re|'ve|'m|'ll|'d)`, `(?:'([sS]|[tT]|[rR][eE]|[vV][eE]|[mM]|[lL][lL]|[dD]))`],
    ]);
  var AddedToken = class {
      constructor(e) {
        ((this.content = e.content),
          (this.id = e.id),
          (this.single_word = e.single_word ?? !1),
          (this.lstrip = e.lstrip ?? !1),
          (this.rstrip = e.rstrip ?? !1),
          (this.special = e.special ?? !1),
          (this.normalized = e.normalized ?? null));
      }
    },
    TokenizerModel = class extends Callable {
      constructor(e) {
        (super(),
          (this.config = e),
          (this.vocab = []),
          (this.tokens_to_ids = new Map()),
          (this.unk_token_id = void 0),
          (this.unk_token = void 0),
          (this.end_of_word_suffix = void 0),
          (this.fuse_unk = this.config.fuse_unk ?? !1));
      }
      static fromConfig(e, ...t) {
        switch (e.type) {
          case `WordPiece`:
            return new WordPieceTokenizer(e);
          case `Unigram`:
            return new Unigram(e, ...t);
          case `BPE`:
            return new BPE(e);
          default:
            if (e.vocab) return new LegacyTokenizerModel(e, ...t);
            throw Error(`Unknown TokenizerModel type: ${e.type}`);
        }
      }
      _call(e) {
        let t = this.encode(e);
        return (this.fuse_unk && (t = fuse(t, this.unk_token_id, this.tokens_to_ids)), t);
      }
      encode(e) {
        throw Error(`encode should be implemented in subclass.`);
      }
      convert_tokens_to_ids(e) {
        return e.map((e) => this.tokens_to_ids.get(e) ?? this.unk_token_id);
      }
      convert_ids_to_tokens(e) {
        return e.map((e) => this.vocab[e] ?? this.unk_token);
      }
    },
    WordPieceTokenizer = class extends TokenizerModel {
      constructor(e) {
        (super(e),
          (this.tokens_to_ids = objectToMap(e.vocab)),
          (this.unk_token_id = this.tokens_to_ids.get(e.unk_token)),
          (this.unk_token = e.unk_token),
          (this.max_input_chars_per_word = e.max_input_chars_per_word ?? 100),
          (this.vocab = Array(this.tokens_to_ids.size)));
        for (let [e, t] of this.tokens_to_ids) this.vocab[t] = e;
      }
      encode(e) {
        let t = [];
        for (let n of e) {
          let e = [...n];
          if (e.length > this.max_input_chars_per_word) {
            t.push(this.unk_token);
            continue;
          }
          let r = !1,
            i = 0,
            a = [];
          for (; i < e.length; ) {
            let t = e.length,
              n = null;
            for (; i < t; ) {
              let r = e.slice(i, t).join(``);
              if ((i > 0 && (r = this.config.continuing_subword_prefix + r), this.tokens_to_ids.has(r))) {
                n = r;
                break;
              }
              --t;
            }
            if (n === null) {
              r = !0;
              break;
            }
            (a.push(n), (i = t));
          }
          r ? t.push(this.unk_token) : t.push(...a);
        }
        return t;
      }
    },
    Unigram = class extends TokenizerModel {
      constructor(e, t) {
        super(e);
        let n = e.vocab.length;
        ((this.vocab = Array(n)), (this.scores = Array(n)));
        for (let t = 0; t < n; ++t) {
          let n = e.vocab[t];
          ((this.vocab[t] = n[0]), (this.scores[t] = n[1]));
        }
        ((this.unk_token_id = e.unk_id),
          (this.unk_token = this.vocab[e.unk_id]),
          (this.tokens_to_ids = new Map(this.vocab.map((e, t) => [e, t]))),
          (this.bosToken = ` `),
          (this.bosTokenId = this.tokens_to_ids.get(this.bosToken)),
          (this.eosToken = t.eos_token),
          (this.eosTokenId = this.tokens_to_ids.get(this.eosToken)),
          (this.unkToken = this.vocab[this.unk_token_id]),
          (this.minScore = min(this.scores)[0]),
          (this.unkScore = this.minScore - 10),
          (this.scores[this.unk_token_id] = this.unkScore),
          (this.trie = new CharTrie()),
          this.trie.extend(this.vocab),
          (this.fuse_unk = !0));
      }
      populateNodes(e) {
        let t = e.sentence,
          n = t.length,
          r = 0;
        for (; r < n; ) {
          let n = 1,
            i = !1,
            a = [];
          for (let n of this.trie.commonPrefixSearch(t.slice(r))) {
            a.push(n);
            let t = this.tokens_to_ids.get(n),
              o = this.scores[t],
              s = n.length;
            (e.insert(r, s, o, t), !i && s === 1 && (i = !0));
          }
          (i || e.insert(r, 1, this.unkScore, this.unk_token_id), (r += 1));
        }
      }
      tokenize(e) {
        let t = new TokenLattice(e, this.bosTokenId, this.eosTokenId);
        return (this.populateNodes(t), t.tokens());
      }
      encode(e) {
        let t = [];
        for (let n of e) {
          let e = this.tokenize(n);
          t.push(...e);
        }
        return t;
      }
    };
  const BYTES_TO_UNICODE = (() => {
      let e = [
          ...Array.from({ length: 94 }, (e, t) => t + 33),
          ...Array.from({ length: 12 }, (e, t) => t + 161),
          ...Array.from({ length: 82 }, (e, t) => t + 174),
        ],
        t = e.slice(),
        n = 0;
      for (let r = 0; r < 256; ++r) e.includes(r) || (e.push(r), t.push(256 + n), (n += 1));
      let r = t.map((e) => String.fromCharCode(e));
      return Object.fromEntries(e.map((e, t) => [e, r[t]]));
    })(),
    UNICODE_TO_BYTES = reverseDictionary(BYTES_TO_UNICODE);
  var BPE = class extends TokenizerModel {
      constructor(e) {
        (super(e),
          (this.BPE_SPLIT_TOKEN = ` `),
          (this.tokens_to_ids = objectToMap(e.vocab)),
          (this.unk_token_id = this.tokens_to_ids.get(e.unk_token)),
          (this.unk_token = e.unk_token),
          (this.vocab = Array(this.tokens_to_ids.size)));
        for (let [e, t] of this.tokens_to_ids) this.vocab[t] = e;
        ((this.bpe_ranks = new Map(e.merges.map((e, t) => [e, t]))),
          (this.merges = e.merges.map((e) => e.split(this.BPE_SPLIT_TOKEN))),
          (this.end_of_word_suffix = e.end_of_word_suffix),
          (this.continuing_subword_suffix = e.continuing_subword_suffix ?? null),
          (this.byte_fallback = this.config.byte_fallback ?? !1),
          this.byte_fallback && (this.text_encoder = new TextEncoder()),
          (this.ignore_merges = this.config.ignore_merges ?? !1),
          (this.cache = new Map()));
      }
      bpe(e) {
        if (e.length === 0) return [];
        let t = this.cache.get(e);
        if (t !== void 0) return t;
        let n = Array.from(e);
        this.end_of_word_suffix && (n[n.length - 1] += this.end_of_word_suffix);
        let r = [];
        if (n.length > 1) {
          let e = new PriorityQueue((e, t) => e.score < t.score),
            t = { token: n[0], bias: 0, prev: null, next: null },
            i = t;
          for (let t = 1; t < n.length; ++t) {
            let r = { bias: t / n.length, token: n[t], prev: i, next: null };
            ((i.next = r), this._add_node(e, i), (i = r));
          }
          for (; !e.isEmpty(); ) {
            let n = e.pop();
            if (n.deleted || !n.next || n.next.deleted) continue;
            if (((n.deleted = !0), (n.next.deleted = !0), n.prev)) {
              let e = { ...n.prev };
              ((n.prev.deleted = !0), (n.prev = e), e.prev ? (e.prev.next = e) : (t = e));
            }
            let r = { token: n.token + n.next.token, bias: n.bias, prev: n.prev, next: n.next.next };
            (r.prev ? ((r.prev.next = r), this._add_node(e, r.prev)) : (t = r),
              r.next && ((r.next.prev = r), this._add_node(e, r)));
          }
          for (let e = t; e !== null; e = e.next) r.push(e.token);
        } else r = n;
        if (this.continuing_subword_suffix)
          for (let e = 0; e < r.length - 1; ++e) r[e] += this.continuing_subword_suffix;
        return (this.cache.set(e, r), r);
      }
      _add_node(e, t) {
        let n = this.bpe_ranks.get(t.token + this.BPE_SPLIT_TOKEN + t.next.token);
        n !== void 0 && ((t.score = n + t.bias), e.push(t));
      }
      encode(e) {
        let t = [];
        for (let n of e) {
          if (this.ignore_merges && this.tokens_to_ids.has(n)) {
            t.push(n);
            continue;
          }
          let e = this.bpe(n);
          for (let n of e)
            this.tokens_to_ids.has(n)
              ? t.push(n)
              : this.byte_fallback
                ? t.push(
                    ...Array.from(this.text_encoder.encode(n)).map(
                      (e) => `<0x${e.toString(16).toUpperCase().padStart(2, `0`)}>`,
                    ),
                  )
                : t.push(this.unk_token);
        }
        return t;
      }
    },
    LegacyTokenizerModel = class extends TokenizerModel {
      constructor(e, t) {
        (super(e),
          (this.tokens_to_ids = objectToMap(t.target_lang ? e.vocab[t.target_lang] : e.vocab)),
          (this.bos_token = t.bos_token),
          (this.bos_token_id = this.tokens_to_ids.get(this.bos_token)),
          (this.eos_token = t.eos_token),
          (this.eos_token_id = this.tokens_to_ids.get(this.eos_token)),
          (this.pad_token = t.pad_token),
          (this.pad_token_id = this.tokens_to_ids.get(this.pad_token)),
          (this.unk_token = t.unk_token),
          (this.unk_token_id = this.tokens_to_ids.get(this.unk_token)),
          (this.vocab = Array(this.tokens_to_ids.size)));
        for (let [e, t] of this.tokens_to_ids) this.vocab[t] = e;
      }
      encode(e) {
        return e;
      }
    },
    Normalizer = class extends Callable {
      constructor(e) {
        (super(), (this.config = e));
      }
      static fromConfig(e) {
        if (e === null) return null;
        switch (e.type) {
          case `BertNormalizer`:
            return new BertNormalizer(e);
          case `Precompiled`:
            return new Precompiled(e);
          case `Sequence`:
            return new NormalizerSequence(e);
          case `Replace`:
            return new Replace(e);
          case `NFC`:
            return new NFC(e);
          case `NFKC`:
            return new NFKC(e);
          case `NFKD`:
            return new NFKD(e);
          case `Strip`:
            return new StripNormalizer(e);
          case `StripAccents`:
            return new StripAccents(e);
          case `Lowercase`:
            return new Lowercase(e);
          case `Prepend`:
            return new Prepend(e);
          default:
            throw Error(`Unknown Normalizer type: ${e.type}`);
        }
      }
      normalize(e) {
        throw Error(`normalize should be implemented in subclass.`);
      }
      _call(e) {
        return this.normalize(e);
      }
    },
    Replace = class extends Normalizer {
      normalize(e) {
        let t = createPattern(this.config.pattern);
        return t === null ? e : e.replaceAll(t, this.config.content);
      }
    },
    NFC = class extends Normalizer {
      normalize(e) {
        return ((e = e.normalize(`NFC`)), e);
      }
    },
    NFKC = class extends Normalizer {
      normalize(e) {
        return ((e = e.normalize(`NFKC`)), e);
      }
    },
    NFKD = class extends Normalizer {
      normalize(e) {
        return ((e = e.normalize(`NFKD`)), e);
      }
    },
    StripNormalizer = class extends Normalizer {
      normalize(e) {
        return (
          this.config.strip_left && this.config.strip_right
            ? (e = e.trim())
            : (this.config.strip_left && (e = e.trimStart()), this.config.strip_right && (e = e.trimEnd())),
          e
        );
      }
    },
    StripAccents = class extends Normalizer {
      normalize(e) {
        return ((e = remove_accents(e)), e);
      }
    },
    Lowercase = class extends Normalizer {
      normalize(e) {
        return ((e = e.toLowerCase()), e);
      }
    },
    Prepend = class extends Normalizer {
      normalize(e) {
        return ((e = this.config.prepend + e), e);
      }
    },
    NormalizerSequence = class extends Normalizer {
      constructor(e) {
        (super(e), (this.normalizers = e.normalizers.map((e) => Normalizer.fromConfig(e))));
      }
      normalize(e) {
        return this.normalizers.reduce((e, t) => t.normalize(e), e);
      }
    },
    BertNormalizer = class extends Normalizer {
      _tokenize_chinese_chars(e) {
        let t = [];
        for (let n = 0; n < e.length; ++n) {
          let r = e[n],
            i = r.charCodeAt(0);
          this._is_chinese_char(i) ? (t.push(` `), t.push(r), t.push(` `)) : t.push(r);
        }
        return t.join(``);
      }
      _is_chinese_char(e) {
        return (
          (e >= 19968 && e <= 40959) ||
          (e >= 13312 && e <= 19903) ||
          (e >= 131072 && e <= 173791) ||
          (e >= 173824 && e <= 177983) ||
          (e >= 177984 && e <= 178207) ||
          (e >= 178208 && e <= 183983) ||
          (e >= 63744 && e <= 64255) ||
          (e >= 194560 && e <= 195103)
        );
      }
      stripAccents(e) {
        return e.normalize(`NFD`).replace(/[\u0300-\u036f]/g, ``);
      }
      _is_control(e) {
        switch (e) {
          case `	`:
          case `
`:
          case `\r`:
            return !1;
          default:
            return /^\p{Cc}|\p{Cf}|\p{Co}|\p{Cs}$/u.test(e);
        }
      }
      _clean_text(e) {
        let t = [];
        for (let n of e) {
          let e = n.charCodeAt(0);
          e === 0 || e === 65533 || this._is_control(n) || (/^\s$/.test(n) ? t.push(` `) : t.push(n));
        }
        return t.join(``);
      }
      normalize(e) {
        return (
          this.config.clean_text && (e = this._clean_text(e)),
          this.config.handle_chinese_chars && (e = this._tokenize_chinese_chars(e)),
          this.config.lowercase
            ? ((e = e.toLowerCase()), this.config.strip_accents !== !1 && (e = this.stripAccents(e)))
            : this.config.strip_accents && (e = this.stripAccents(e)),
          e
        );
      }
    },
    PreTokenizer = class extends Callable {
      static fromConfig(e) {
        if (e === null) return null;
        switch (e.type) {
          case `BertPreTokenizer`:
            return new BertPreTokenizer(e);
          case `Sequence`:
            return new PreTokenizerSequence(e);
          case `Whitespace`:
            return new WhitespacePreTokenizer(e);
          case `WhitespaceSplit`:
            return new WhitespaceSplit(e);
          case `Metaspace`:
            return new MetaspacePreTokenizer(e);
          case `ByteLevel`:
            return new ByteLevelPreTokenizer(e);
          case `Split`:
            return new SplitPreTokenizer(e);
          case `Punctuation`:
            return new PunctuationPreTokenizer(e);
          case `Digits`:
            return new DigitsPreTokenizer(e);
          case `Replace`:
            return new ReplacePreTokenizer(e);
          default:
            throw Error(`Unknown PreTokenizer type: ${e.type}`);
        }
      }
      pre_tokenize_text(e, t) {
        throw Error(`pre_tokenize_text should be implemented in subclass.`);
      }
      pre_tokenize(e, t) {
        return (Array.isArray(e) ? e.map((e) => this.pre_tokenize_text(e, t)) : this.pre_tokenize_text(e, t)).flat();
      }
      _call(e, t) {
        return this.pre_tokenize(e, t);
      }
    },
    BertPreTokenizer = class extends PreTokenizer {
      constructor(e) {
        (super(), (this.pattern = RegExp(`[^\\s${PUNCTUATION_REGEX}]+|[${PUNCTUATION_REGEX}]`, `gu`)));
      }
      pre_tokenize_text(e, t) {
        return e.trim().match(this.pattern) || [];
      }
    },
    ByteLevelPreTokenizer = class extends PreTokenizer {
      constructor(e) {
        (super(),
          (this.config = e),
          (this.add_prefix_space = this.config.add_prefix_space),
          (this.trim_offsets = this.config.trim_offsets),
          (this.use_regex = this.config.use_regex ?? !0),
          (this.pattern = /'s|'t|'re|'ve|'m|'ll|'d| ?\p{L}+| ?\p{N}+| ?[^\s\p{L}\p{N}]+|\s+(?!\S)|\s+/gu),
          (this.byte_encoder = BYTES_TO_UNICODE),
          (this.text_encoder = new TextEncoder()));
      }
      pre_tokenize_text(e, t) {
        return (
          this.add_prefix_space && !e.startsWith(` `) && (e = ` ` + e),
          (this.use_regex ? e.match(this.pattern) || [] : [e]).map((e) =>
            Array.from(this.text_encoder.encode(e), (e) => this.byte_encoder[e]).join(``),
          )
        );
      }
    },
    SplitPreTokenizer = class extends PreTokenizer {
      constructor(e) {
        (super(), (this.config = e), (this.pattern = createPattern(this.config.pattern, this.config.invert)));
      }
      pre_tokenize_text(e, t) {
        return this.pattern === null
          ? []
          : this.config.invert
            ? e.match(this.pattern) || []
            : regexSplit(e, this.pattern);
      }
    },
    PunctuationPreTokenizer = class extends PreTokenizer {
      constructor(e) {
        (super(), (this.config = e), (this.pattern = RegExp(`[^${PUNCTUATION_REGEX}]+|[${PUNCTUATION_REGEX}]+`, `gu`)));
      }
      pre_tokenize_text(e, t) {
        return e.match(this.pattern) || [];
      }
    },
    DigitsPreTokenizer = class extends PreTokenizer {
      constructor(e) {
        (super(), (this.config = e));
        let t = `[^\\d]+|\\d${this.config.individual_digits ? `` : `+`}`;
        this.pattern = new RegExp(t, `gu`);
      }
      pre_tokenize_text(e, t) {
        return e.match(this.pattern) || [];
      }
    },
    PostProcessor = class extends Callable {
      constructor(e) {
        (super(), (this.config = e));
      }
      static fromConfig(e) {
        if (e === null) return null;
        switch (e.type) {
          case `TemplateProcessing`:
            return new TemplateProcessing(e);
          case `ByteLevel`:
            return new ByteLevelPostProcessor(e);
          case `RobertaProcessing`:
            return new RobertaProcessing(e);
          case `BertProcessing`:
            return new BertProcessing(e);
          case `Sequence`:
            return new PostProcessorSequence(e);
          default:
            throw Error(`Unknown PostProcessor type: ${e.type}`);
        }
      }
      post_process(e, ...t) {
        throw Error(`post_process should be implemented in subclass.`);
      }
      _call(e, ...t) {
        return this.post_process(e, ...t);
      }
    },
    BertProcessing = class extends PostProcessor {
      constructor(e) {
        (super(e), (this.cls = e.cls[0]), (this.sep = e.sep[0]));
      }
      post_process(e, t = null, { add_special_tokens: n = !0 } = {}) {
        n && (e = mergeArrays([this.cls], e, [this.sep]));
        let r = Array(e.length).fill(0);
        if (t !== null) {
          let i = n && this instanceof RobertaProcessing ? [this.sep] : [],
            a = n ? [this.sep] : [];
          ((e = mergeArrays(e, i, t, a)), (r = mergeArrays(r, Array(t.length + i.length + a.length).fill(1))));
        }
        return { tokens: e, token_type_ids: r };
      }
    },
    RobertaProcessing = class extends BertProcessing {},
    TemplateProcessing = class extends PostProcessor {
      constructor(e) {
        (super(e), (this.single = e.single), (this.pair = e.pair));
      }
      post_process(e, t = null, { add_special_tokens: n = !0 } = {}) {
        let r = t === null ? this.single : this.pair,
          i = [],
          a = [];
        for (let o of r)
          `SpecialToken` in o
            ? n && (i.push(o.SpecialToken.id), a.push(o.SpecialToken.type_id))
            : `Sequence` in o &&
              (o.Sequence.id === `A`
                ? ((i = mergeArrays(i, e)), (a = mergeArrays(a, Array(e.length).fill(o.Sequence.type_id))))
                : o.Sequence.id === `B` &&
                  ((i = mergeArrays(i, t)), (a = mergeArrays(a, Array(t.length).fill(o.Sequence.type_id)))));
        return { tokens: i, token_type_ids: a };
      }
    },
    ByteLevelPostProcessor = class extends PostProcessor {
      post_process(e, t = null) {
        return (t && (e = mergeArrays(e, t)), { tokens: e });
      }
    },
    PostProcessorSequence = class extends PostProcessor {
      constructor(e) {
        (super(e), (this.processors = e.processors.map((e) => PostProcessor.fromConfig(e))));
      }
      post_process(e, t = null, n = {}) {
        let r;
        for (let i of this.processors)
          if (i instanceof ByteLevelPostProcessor) ((e = i.post_process(e).tokens), (t &&= i.post_process(t).tokens));
          else {
            let a = i.post_process(e, t, n);
            ((e = a.tokens), (r = a.token_type_ids));
          }
        return { tokens: e, token_type_ids: r };
      }
    },
    Decoder = class extends Callable {
      constructor(e) {
        (super(),
          (this.config = e),
          (this.added_tokens = []),
          (this.end_of_word_suffix = null),
          (this.trim_offsets = e.trim_offsets));
      }
      static fromConfig(e) {
        if (e === null) return null;
        switch (e.type) {
          case `WordPiece`:
            return new WordPieceDecoder(e);
          case `Metaspace`:
            return new MetaspaceDecoder(e);
          case `ByteLevel`:
            return new ByteLevelDecoder(e);
          case `Replace`:
            return new ReplaceDecoder(e);
          case `ByteFallback`:
            return new ByteFallback(e);
          case `Fuse`:
            return new FuseDecoder(e);
          case `Strip`:
            return new StripDecoder(e);
          case `Sequence`:
            return new DecoderSequence(e);
          case `CTC`:
            return new CTCDecoder(e);
          case `BPEDecoder`:
            return new BPEDecoder(e);
          default:
            throw Error(`Unknown Decoder type: ${e.type}`);
        }
      }
      _call(e) {
        return this.decode(e);
      }
      decode(e) {
        return this.decode_chain(e).join(``);
      }
      decode_chain(e) {
        throw Error('`decode_chain` should be implemented in subclass.');
      }
    },
    ReplaceDecoder = class extends Decoder {
      decode_chain(e) {
        let t = createPattern(this.config.pattern);
        return t === null ? e : e.map((e) => e.replaceAll(t, this.config.content));
      }
    },
    ByteFallback = class extends Decoder {
      constructor(e) {
        (super(e), (this.text_decoder = new TextDecoder()));
      }
      decode_chain(e) {
        let t = [],
          n = [];
        for (let r of e) {
          let e = null;
          if (r.length === 6 && r.startsWith(`<0x`) && r.endsWith(`>`)) {
            let t = parseInt(r.slice(3, 5), 16);
            isNaN(t) || (e = t);
          }
          if (e !== null) n.push(e);
          else {
            if (n.length > 0) {
              let e = this.text_decoder.decode(Uint8Array.from(n));
              (t.push(e), (n = []));
            }
            t.push(r);
          }
        }
        if (n.length > 0) {
          let e = this.text_decoder.decode(Uint8Array.from(n));
          (t.push(e), (n = []));
        }
        return t;
      }
    },
    FuseDecoder = class extends Decoder {
      decode_chain(e) {
        return [e.join(``)];
      }
    },
    StripDecoder = class extends Decoder {
      constructor(e) {
        (super(e),
          (this.content = this.config.content),
          (this.start = this.config.start),
          (this.stop = this.config.stop));
      }
      decode_chain(e) {
        return e.map((e) => {
          let t = 0;
          for (let n = 0; n < this.start && e[n] === this.content; ++n) t = n + 1;
          let n = e.length;
          for (let t = 0; t < this.stop; ++t) {
            let r = e.length - t - 1;
            if (e[r] === this.content) {
              n = r;
              continue;
            } else break;
          }
          return e.slice(t, n);
        });
      }
    },
    WordPieceDecoder = class extends Decoder {
      constructor(e) {
        (super(e), (this.cleanup = e.cleanup));
      }
      decode_chain(e) {
        return e.map(
          (e, t) => (
            t !== 0 && (e = e.startsWith(this.config.prefix) ? e.replace(this.config.prefix, ``) : ` ` + e),
            this.cleanup && (e = clean_up_tokenization(e)),
            e
          ),
        );
      }
    },
    ByteLevelDecoder = class extends Decoder {
      constructor(e) {
        (super(e),
          (this.byte_decoder = UNICODE_TO_BYTES),
          (this.text_decoder = new TextDecoder(`utf-8`, { fatal: !1, ignoreBOM: !0 })),
          (this.end_of_word_suffix = null));
      }
      convert_tokens_to_string(e) {
        let t = e.join(``),
          n = new Uint8Array([...t].map((e) => this.byte_decoder[e]));
        return this.text_decoder.decode(n);
      }
      decode_chain(e) {
        let t = [],
          n = [];
        for (let r of e)
          this.added_tokens.find((e) => e.content === r) === void 0
            ? n.push(r)
            : (n.length > 0 && (t.push(this.convert_tokens_to_string(n)), (n = [])), t.push(r));
        return (n.length > 0 && t.push(this.convert_tokens_to_string(n)), t);
      }
    },
    CTCDecoder = class extends Decoder {
      constructor(e) {
        (super(e),
          (this.pad_token = this.config.pad_token),
          (this.word_delimiter_token = this.config.word_delimiter_token),
          (this.cleanup = this.config.cleanup));
      }
      convert_tokens_to_string(e) {
        if (e.length === 0) return ``;
        let t = [e[0]];
        for (let n = 1; n < e.length; ++n) e[n] !== t.at(-1) && t.push(e[n]);
        let n = t.filter((e) => e !== this.pad_token).join(``);
        return (this.cleanup && (n = clean_up_tokenization(n).replaceAll(this.word_delimiter_token, ` `).trim()), n);
      }
      decode_chain(e) {
        return [this.convert_tokens_to_string(e)];
      }
    },
    DecoderSequence = class extends Decoder {
      constructor(e) {
        (super(e), (this.decoders = e.decoders.map((e) => Decoder.fromConfig(e))));
      }
      decode_chain(e) {
        return this.decoders.reduce((e, t) => t.decode_chain(e), e);
      }
    },
    BPEDecoder = class extends Decoder {
      constructor(e) {
        (super(e), (this.suffix = this.config.suffix));
      }
      decode_chain(e) {
        return e.map((t, n) => t.replaceAll(this.suffix, n === e.length - 1 ? `` : ` `));
      }
    },
    VitsDecoder = class extends Decoder {
      decode_chain(e) {
        let t = ``;
        for (let n = 1; n < e.length; n += 2) t += e[n];
        return [t];
      }
    },
    MetaspacePreTokenizer = class extends PreTokenizer {
      constructor(e) {
        (super(),
          (this.addPrefixSpace = e.add_prefix_space),
          (this.replacement = e.replacement),
          (this.strRep = e.str_rep || this.replacement),
          (this.prepend_scheme = e.prepend_scheme ?? `always`));
      }
      pre_tokenize_text(e, { section_index: t = void 0 } = {}) {
        let n = e.replaceAll(` `, this.strRep);
        return (
          this.addPrefixSpace &&
            !n.startsWith(this.replacement) &&
            (this.prepend_scheme === `always` || (this.prepend_scheme === `first` && t === 0)) &&
            (n = this.strRep + n),
          [n]
        );
      }
    },
    MetaspaceDecoder = class extends Decoder {
      constructor(e) {
        (super(e), (this.addPrefixSpace = e.add_prefix_space), (this.replacement = e.replacement));
      }
      decode_chain(e) {
        let t = [];
        for (let n = 0; n < e.length; ++n) {
          let r = e[n].replaceAll(this.replacement, ` `);
          (this.addPrefixSpace && n == 0 && r.startsWith(` `) && (r = r.substring(1)), t.push(r));
        }
        return t;
      }
    },
    Precompiled = class extends Normalizer {
      constructor(e) {
        (super(e), (this.charsmap = e.precompiled_charsmap));
      }
      normalize(e) {
        return (
          (e = e.replace(/[\u0001-\u0008\u000B\u000E-\u001F\u007F\u008F\u009F]/gm, ``)),
          (e = e.replace(
            /[\u0009\u000A\u000C\u000D\u1680\u200B\u200C\u200E\u200F\u2028\u2029\u2581\uFEFF\uFFFD]/gm,
            ` `,
          )),
          (e = e.includes(`～`)
            ? e
                .split(`～`)
                .map((e) => e.normalize(`NFKC`))
                .join(`～`)
            : e.normalize(`NFKC`)),
          e
        );
      }
    },
    PreTokenizerSequence = class extends PreTokenizer {
      constructor(e) {
        (super(), (this.tokenizers = e.pretokenizers.map((e) => PreTokenizer.fromConfig(e))));
      }
      pre_tokenize_text(e, t) {
        return this.tokenizers.reduce((e, n) => n.pre_tokenize(e, t), [e]);
      }
    },
    WhitespacePreTokenizer = class extends PreTokenizer {
      constructor(e) {
        super();
      }
      pre_tokenize_text(e, t) {
        return e.match(/\w+|[^\w\s]+/g) || [];
      }
    },
    WhitespaceSplit = class extends PreTokenizer {
      constructor(e) {
        super();
      }
      pre_tokenize_text(e, t) {
        return whitespace_split(e);
      }
    },
    ReplacePreTokenizer = class extends PreTokenizer {
      constructor(e) {
        (super(),
          (this.config = e),
          (this.pattern = createPattern(this.config.pattern)),
          (this.content = this.config.content));
      }
      pre_tokenize_text(e, t) {
        return this.pattern === null ? [e] : [e.replaceAll(this.pattern, this.config.content)];
      }
    };
  const SPECIAL_TOKEN_ATTRIBUTES = [
    `bos_token`,
    `eos_token`,
    `unk_token`,
    `sep_token`,
    `pad_token`,
    `cls_token`,
    `mask_token`,
  ];
  function padHelper(e, t, n, r) {
    for (let i of Object.keys(e)) {
      let a = t - e[i].length,
        o = n(i),
        s = Array(a).fill(o);
      e[i] = r === `right` ? mergeArrays(e[i], s) : mergeArrays(s, e[i]);
    }
  }
  function truncateHelper(e, t) {
    for (let n of Object.keys(e)) e[n].length = t;
  }
  var PreTrainedTokenizer = class extends Callable {
      return_token_type_ids = !1;
      _default_chat_template = `{% for message in messages %}{{'<|im_start|>' + message['role'] + '
' + message['content'] + '<|im_end|>' + '
'}}{% endfor %}{% if add_generation_prompt %}{{ '<|im_start|>assistant
' }}{% endif %}`;
      constructor(e, t) {
        (super(),
          (this._tokenizer_config = t),
          (this.normalizer = Normalizer.fromConfig(e.normalizer)),
          (this.pre_tokenizer = PreTokenizer.fromConfig(e.pre_tokenizer)),
          (this.model = TokenizerModel.fromConfig(e.model, t)),
          (this.post_processor = PostProcessor.fromConfig(e.post_processor)),
          (this.decoder = Decoder.fromConfig(e.decoder)),
          (this.special_tokens = []),
          (this.all_special_ids = []),
          (this.added_tokens = []));
        for (let t of e.added_tokens) {
          let e = new AddedToken(t);
          (this.added_tokens.push(e),
            this.model.tokens_to_ids.set(e.content, e.id),
            (this.model.vocab[e.id] = e.content),
            e.special && (this.special_tokens.push(e.content), this.all_special_ids.push(e.id)));
        }
        if (
          ((this.additional_special_tokens = t.additional_special_tokens ?? []),
          this.special_tokens.push(...this.additional_special_tokens),
          (this.special_tokens = [...new Set(this.special_tokens)]),
          this.decoder &&
            ((this.decoder.added_tokens = this.added_tokens),
            (this.decoder.end_of_word_suffix = this.model.end_of_word_suffix)),
          (this.added_tokens_regex =
            this.added_tokens.length > 0
              ? new RegExp(
                  this.added_tokens
                    .map((e) => `${e.lstrip ? `\\s*` : ``}(${escapeRegExp(e.content)})${e.rstrip ? `\\s*` : ``}`)
                    .join(`|`),
                )
              : null),
          (this.mask_token = this.getToken(`mask_token`)),
          (this.mask_token_id = this.model.tokens_to_ids.get(this.mask_token)),
          (this.pad_token = this.getToken(`pad_token`, `eos_token`)),
          (this.pad_token_id = this.model.tokens_to_ids.get(this.pad_token)),
          (this.sep_token = this.getToken(`sep_token`)),
          (this.sep_token_id = this.model.tokens_to_ids.get(this.sep_token)),
          (this.unk_token = this.getToken(`unk_token`)),
          (this.unk_token_id = this.model.tokens_to_ids.get(this.unk_token)),
          (this.model_max_length = t.model_max_length),
          (this.remove_space = t.remove_space),
          (this.clean_up_tokenization_spaces = t.clean_up_tokenization_spaces ?? !0),
          (this.do_lowercase_and_remove_accent = t.do_lowercase_and_remove_accent ?? !1),
          (this.padding_side = `right`),
          (this.legacy = !1),
          (this.chat_template = t.chat_template ?? null),
          Array.isArray(this.chat_template))
        ) {
          let e = Object.create(null);
          for (let { name: t, template: n } of this.chat_template) {
            if (typeof t != `string` || typeof n != `string`)
              throw Error(`Chat template must be a list of objects with "name" and "template" properties`);
            e[t] = n;
          }
          this.chat_template = e;
        }
        this._compiled_template_cache = new Map();
      }
      getToken(...e) {
        for (let t of e) {
          let e = this._tokenizer_config[t];
          if (e)
            if (typeof e == `object`) {
              if (e.__type === `AddedToken`) return e.content;
              throw Error(`Unknown token: ${e}`);
            } else return e;
        }
        return null;
      }
      static async from_pretrained(
        e,
        {
          progress_callback: t = null,
          config: n = null,
          cache_dir: r = null,
          local_files_only: i = !1,
          revision: a = `main`,
          legacy: o = null,
        } = {},
      ) {
        let s = await loadTokenizer(e, {
          progress_callback: t,
          config: n,
          cache_dir: r,
          local_files_only: i,
          revision: a,
          legacy: o,
        });
        return new this(...s);
      }
      _call(
        e,
        {
          text_pair: t = null,
          add_special_tokens: n = !0,
          padding: r = !1,
          truncation: i = null,
          max_length: a = null,
          return_tensor: o = !0,
          return_token_type_ids: s = null,
        } = {},
      ) {
        let c = Array.isArray(e),
          l;
        if (c) {
          if (e.length === 0) throw Error(`text array must be non-empty`);
          if (t !== null) {
            if (!Array.isArray(t)) throw Error(`text_pair must also be an array`);
            if (e.length !== t.length) throw Error(`text and text_pair must have the same length`);
            l = e.map((e, r) => this._encode_plus(e, t[r], { add_special_tokens: n, return_token_type_ids: s }));
          } else l = e.map((e) => this._encode_plus(e, null, { add_special_tokens: n, return_token_type_ids: s }));
        } else {
          if (e == null) throw Error(`text may not be null or undefined`);
          if (Array.isArray(t))
            throw Error(
              'When specifying `text_pair`, since `text` is a string, `text_pair` must also be a string (i.e., not an array).',
            );
          l = [this._encode_plus(e, t, { add_special_tokens: n, return_token_type_ids: s })];
        }
        if (
          (a === null
            ? (a = r === `max_length` ? this.model_max_length : max(l.map((e) => e.input_ids.length))[0])
            : i ||
              console.warn(
                'Truncation was not explicitly activated but `max_length` is provided a specific value, please use `truncation=true` to explicitly truncate examples to max length.',
              ),
          (a = Math.min(a, this.model_max_length)),
          r || i)
        )
          for (let e = 0; e < l.length; ++e)
            if (l[e].input_ids.length === a) continue;
            else
              l[e].input_ids.length > a
                ? i && truncateHelper(l[e], a)
                : r && padHelper(l[e], a, (e) => (e === `input_ids` ? this.pad_token_id : 0), this.padding_side);
        let u = {};
        if (o) {
          if (
            !(r && i) &&
            l.some((e) => {
              for (let t of Object.keys(e)) if (e[t].length !== l[0][t]?.length) return !0;
              return !1;
            })
          )
            throw Error(
              `Unable to create tensor, you should probably activate truncation and/or padding with 'padding=true' and 'truncation=true' to have batched tensors with the same length.`,
            );
          let e = [l.length, l[0].input_ids.length];
          for (let t of Object.keys(l[0]))
            u[t] = new Tensor(`int64`, BigInt64Array.from(l.flatMap((e) => e[t]).map(BigInt)), e);
        } else {
          for (let e of Object.keys(l[0])) u[e] = l.map((t) => t[e]);
          if (!c) for (let e of Object.keys(u)) u[e] = u[e][0];
        }
        return u;
      }
      _encode_text(e) {
        return e === null
          ? null
          : (this.added_tokens_regex ? e.split(this.added_tokens_regex).filter((e) => e) : [e])
              .map((e, t) => {
                if (this.added_tokens.find((t) => t.content === e) !== void 0) return e;
                {
                  if (
                    (this.remove_space === !0 && (e = e.trim().split(/\s+/).join(` `)),
                    this.do_lowercase_and_remove_accent && (e = lowercase_and_remove_accent(e)),
                    this.normalizer !== null && (e = this.normalizer(e)),
                    e.length === 0)
                  )
                    return [];
                  let n = this.pre_tokenizer === null ? [e] : this.pre_tokenizer(e, { section_index: t });
                  return this.model(n);
                }
              })
              .flat();
      }
      _encode_plus(e, t = null, { add_special_tokens: n = !0, return_token_type_ids: r = null } = {}) {
        let i = this._encode_text(e),
          a = this._encode_text(t),
          o = this.post_processor
            ? this.post_processor(i, a, { add_special_tokens: n })
            : { tokens: mergeArrays(i ?? [], a ?? []) },
          s = this.model.convert_tokens_to_ids(o.tokens),
          c = { input_ids: s, attention_mask: Array(s.length).fill(1) };
        return ((r ?? this.return_token_type_ids) && o.token_type_ids && (c.token_type_ids = o.token_type_ids), c);
      }
      encode(e, t = null, { add_special_tokens: n = !0, return_token_type_ids: r = null } = {}) {
        let { input_ids: i } = this._encode_plus(e, t, { add_special_tokens: n, return_token_type_ids: r });
        return i;
      }
      batch_decode(e, t = {}) {
        return (e instanceof Tensor && (e = e.tolist()), e.map((e) => this.decode(e, t)));
      }
      decode(e, t = {}) {
        if (
          (e instanceof Tensor && (e = prepareTensorForDecode(e)),
          !Array.isArray(e) || e.length === 0 || !isIntegralNumber(e[0]))
        )
          throw Error(`token_ids must be a non-empty array of integers.`);
        return this.decode_single(e, t);
      }
      decode_single(e, { skip_special_tokens: t = !1, clean_up_tokenization_spaces: n = null }) {
        let r = this.model.convert_ids_to_tokens(e);
        t && (r = r.filter((e) => !this.special_tokens.includes(e)));
        let i = this.decoder ? this.decoder(r) : r.join(` `);
        return (
          this.decoder &&
            this.decoder.end_of_word_suffix &&
            ((i = i.replaceAll(this.decoder.end_of_word_suffix, ` `)), t && (i = i.trim())),
          (n ?? this.clean_up_tokenization_spaces) && (i = clean_up_tokenization(i)),
          i
        );
      }
      get default_chat_template() {
        return (
          (this._warned_about_chat_template ||=
            (console.warn(
              'No chat template is defined for this tokenizer - using a default chat template that implements the ChatML format. If the default is not appropriate for your model, please set `tokenizer.chat_template` to an appropriate template. See https://huggingface.co/docs/transformers/main/chat_templating for more information.',
            ),
            !0)),
          this._default_chat_template
        );
      }
      apply_chat_template(
        e,
        {
          chat_template: t = null,
          add_generation_prompt: n = !1,
          tokenize: r = !0,
          padding: i = !1,
          truncation: a = !1,
          max_length: o = null,
          return_tensor: s = !0,
          tokenizer_kwargs: c = {},
          ...l
        } = {},
      ) {
        if (
          (this.chat_template && typeof this.chat_template == `object`) ||
          (this.chat_template === null && this.default_chat_template && typeof this.default_chat_template == `object`)
        ) {
          let e = this.chat_template ?? this.default_chat_template;
          if (t !== null && Object.hasOwn(e, t)) t = e[t];
          else if (t === null && `default` in e) t = e.default;
          else if (t === null)
            throw Error(
              `This model has multiple chat templates with no default specified! Please either pass a chat template or the name of the template you wish to use to the 'chat_template' argument. Available template names are ${Object.keys(e).sort()}.`,
            );
        } else t ??= this.chat_template ?? this.default_chat_template;
        if (typeof t != `string`) throw Error(`chat_template must be a string, but got ${typeof t}`);
        let u = this._compiled_template_cache.get(t);
        u === void 0 && ((u = new Template(t)), this._compiled_template_cache.set(t, u));
        let d = Object.create(null);
        for (let e of SPECIAL_TOKEN_ATTRIBUTES) {
          let t = this.getToken(e);
          t && (d[e] = t);
        }
        let f = u.render({ messages: e, add_generation_prompt: n, ...d, ...l });
        return r
          ? this._call(f, { add_special_tokens: !1, padding: i, truncation: a, max_length: o, return_tensor: s, ...c })
              .input_ids
          : f;
      }
    },
    BertTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    AlbertTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    MobileBertTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    SqueezeBertTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    DebertaTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    DebertaV2Tokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    HerbertTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    ConvBertTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    RoFormerTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    DistilBertTokenizer = class extends PreTrainedTokenizer {},
    CamembertTokenizer = class extends PreTrainedTokenizer {},
    XLMTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
      constructor(e, t) {
        (super(e, t),
          console.warn(
            'WARNING: `XLMTokenizer` is not yet supported by Hugging Face\'s "fast" tokenizers library. Therefore, you may experience slightly inaccurate results.',
          ));
      }
    },
    ElectraTokenizer = class extends PreTrainedTokenizer {
      return_token_type_ids = !0;
    },
    T5Tokenizer = class extends PreTrainedTokenizer {},
    GPT2Tokenizer = class extends PreTrainedTokenizer {
      _default_chat_template = `{% for message in messages %}" "{{ message.content }}{{ eos_token }}" "{% endfor %}`;
    },
    BartTokenizer = class extends PreTrainedTokenizer {},
    MBartTokenizer = class extends PreTrainedTokenizer {
      constructor(e, t) {
        (super(e, t),
          (this.languageRegex = /^[a-z]{2}_[A-Z]{2}$/),
          (this.language_codes = this.special_tokens.filter((e) => this.languageRegex.test(e))),
          (this.lang_to_token = (e) => e));
      }
      _build_translation_inputs(e, t, n) {
        return _build_translation_inputs(this, e, t, n);
      }
    },
    MBart50Tokenizer = class extends MBartTokenizer {},
    RobertaTokenizer = class extends PreTrainedTokenizer {},
    BloomTokenizer = class extends GPT2Tokenizer {
      constructor(e, t) {
        let n = `.,!?…。，、।۔،`,
          r = e.pre_tokenizer?.pretokenizers[0]?.pattern;
        (r && r.Regex === ` ?[^(\\s|[${n}])]+` && (r.Regex = ` ?[^\\s${n}]+`), super(e, t));
      }
    };
  const SPIECE_UNDERLINE = `▁`;
  var LlamaTokenizer = class extends PreTrainedTokenizer {
      _default_chat_template = `{% if messages[0]['role'] == 'system' %}{% set loop_messages = messages[1:] %}{% set system_message = messages[0]['content'] %}{% elif USE_DEFAULT_PROMPT == true and not '<<SYS>>' in messages[0]['content'] %}{% set loop_messages = messages %}{% set system_message = 'DEFAULT_SYSTEM_MESSAGE' %}{% else %}{% set loop_messages = messages %}{% set system_message = false %}{% endif %}{% for message in loop_messages %}{% if (message['role'] == 'user') != (loop.index0 % 2 == 0) %}{{ raise_exception('Conversation roles must alternate user/assistant/user/assistant/...') }}{% endif %}{% if loop.index0 == 0 and system_message != false %}{% set content = '<<SYS>>
' + system_message + '
<</SYS>>

' + message['content'] %}{% else %}{% set content = message['content'] %}{% endif %}{% if message['role'] == 'user' %}{{ bos_token + '[INST] ' + content.strip() + ' [/INST]' }}{% elif message['role'] == 'system' %}{{ '<<SYS>>
' + content.strip() + '
<</SYS>>

' }}{% elif message['role'] == 'assistant' %}{{ ' '  + content.strip() + ' ' + eos_token }}{% endif %}{% endfor %}`;
      DEFAULT_SYSTEM_PROMPT = `You are a helpful, respectful and honest assistant. Always answer as helpfully as possible, while being safe. Your answers should not include any harmful, unethical, racist, sexist, toxic, dangerous, or illegal content. Please ensure that your responses are socially unbiased and positive in nature.

If a question does not make any sense, or is not factually coherent, explain why instead of answering something not correct. If you don't know the answer to a question, please don't share false information.`;
      constructor(e, t) {
        (super(e, t),
          (this.use_default_system_prompt = t.use_default_system_prompt ?? !1),
          (this.legacy = t.legacy ?? !0),
          this.legacy ||
            ((this.normalizer = null),
            (this.pre_tokenizer = new MetaspacePreTokenizer({
              replacement: SPIECE_UNDERLINE,
              add_prefix_space: !0,
              prepend_scheme: `first`,
            }))));
      }
      _encode_text(e) {
        if (e === null) return null;
        if (this.legacy || e.length === 0) return super._encode_text(e);
        let t = super._encode_text(SPIECE_UNDERLINE + e.replaceAll(SPIECE_UNDERLINE, ` `));
        return (t.length > 1 && t[0] === SPIECE_UNDERLINE && this.special_tokens.includes(t[1]) && (t = t.slice(1)), t);
      }
      get default_chat_template() {
        return super.default_chat_template
          .replaceAll(`USE_DEFAULT_PROMPT`, this.use_default_system_prompt ? `true` : `false`)
          .replaceAll(
            `DEFAULT_SYSTEM_MESSAGE`,
            this.DEFAULT_SYSTEM_PROMPT.replaceAll(
              `
`,
              `\\n`,
            ).replaceAll(`'`, `\\'`),
          );
      }
    },
    CodeLlamaTokenizer = class extends LlamaTokenizer {},
    XLMRobertaTokenizer = class extends PreTrainedTokenizer {},
    MPNetTokenizer = class extends PreTrainedTokenizer {},
    FalconTokenizer = class extends PreTrainedTokenizer {},
    GPTNeoXTokenizer = class extends PreTrainedTokenizer {},
    EsmTokenizer = class extends PreTrainedTokenizer {},
    Qwen2Tokenizer = class extends PreTrainedTokenizer {},
    GemmaTokenizer = class extends PreTrainedTokenizer {
      _default_chat_template = `{% if messages[0]['role'] == 'system' %}{{ raise_exception('System role not supported') }}{% endif %}{% for message in messages %}{% if (message['role'] == 'user') != (loop.index0 % 2 == 0) %}{{ raise_exception('Conversation roles must alternate user/assistant/user/assistant/...') }}{% endif %}{% if (message['role'] == 'assistant') %}{% set role = 'model' %}{% else %}{% set role = message['role'] %}{% endif %}{{ '<start_of_turn>' + role + '
' + message['content'] | trim + '<end_of_turn>
' }}{% endfor %}{% if add_generation_prompt %}{{'<start_of_turn>model
'}}{% endif %}`;
    },
    Grok1Tokenizer = class extends PreTrainedTokenizer {};
  function _build_translation_inputs(e, t, n, r) {
    if (!(`language_codes` in e) || !Array.isArray(e.language_codes))
      throw Error('Tokenizer must have `language_codes` attribute set and it should be an array of language ids.');
    if (!(`languageRegex` in e) || !(e.languageRegex instanceof RegExp))
      throw Error('Tokenizer must have `languageRegex` attribute set and it should be a regular expression.');
    if (!(`lang_to_token` in e) || typeof e.lang_to_token != `function`)
      throw Error('Tokenizer must have `lang_to_token` attribute set and it should be a function.');
    let i = r.src_lang,
      a = r.tgt_lang;
    if (!e.language_codes.includes(a))
      throw Error(`Target language code "${a}" is not valid. Must be one of: {${e.language_codes.join(`, `)}}`);
    if (i !== void 0) {
      if (!e.language_codes.includes(i))
        throw Error(`Source language code "${i}" is not valid. Must be one of: {${e.language_codes.join(`, `)}}`);
      for (let t of e.post_processor.config.single)
        if (`SpecialToken` in t && e.languageRegex.test(t.SpecialToken.id)) {
          t.SpecialToken.id = e.lang_to_token(i);
          break;
        }
    }
    return ((r.forced_bos_token_id = e.model.convert_tokens_to_ids([e.lang_to_token(a)])[0]), e._call(t, n));
  }
  var NllbTokenizer = class extends PreTrainedTokenizer {
      constructor(e, t) {
        (super(e, t),
          (this.languageRegex = /^[a-z]{3}_[A-Z][a-z]{3}$/),
          (this.language_codes = this.special_tokens.filter((e) => this.languageRegex.test(e))),
          (this.lang_to_token = (e) => e));
      }
      _build_translation_inputs(e, t, n) {
        return _build_translation_inputs(this, e, t, n);
      }
    },
    M2M100Tokenizer = class extends PreTrainedTokenizer {
      constructor(e, t) {
        (super(e, t),
          (this.languageRegex = /^__[a-z]{2,3}__$/),
          (this.language_codes = this.special_tokens
            .filter((e) => this.languageRegex.test(e))
            .map((e) => e.slice(2, -2))),
          (this.lang_to_token = (e) => `__${e}__`));
      }
      _build_translation_inputs(e, t, n) {
        return _build_translation_inputs(this, e, t, n);
      }
    };
  const WHISPER_LANGUAGES = [
      [`en`, `english`],
      [`zh`, `chinese`],
      [`de`, `german`],
      [`es`, `spanish`],
      [`ru`, `russian`],
      [`ko`, `korean`],
      [`fr`, `french`],
      [`ja`, `japanese`],
      [`pt`, `portuguese`],
      [`tr`, `turkish`],
      [`pl`, `polish`],
      [`ca`, `catalan`],
      [`nl`, `dutch`],
      [`ar`, `arabic`],
      [`sv`, `swedish`],
      [`it`, `italian`],
      [`id`, `indonesian`],
      [`hi`, `hindi`],
      [`fi`, `finnish`],
      [`vi`, `vietnamese`],
      [`he`, `hebrew`],
      [`uk`, `ukrainian`],
      [`el`, `greek`],
      [`ms`, `malay`],
      [`cs`, `czech`],
      [`ro`, `romanian`],
      [`da`, `danish`],
      [`hu`, `hungarian`],
      [`ta`, `tamil`],
      [`no`, `norwegian`],
      [`th`, `thai`],
      [`ur`, `urdu`],
      [`hr`, `croatian`],
      [`bg`, `bulgarian`],
      [`lt`, `lithuanian`],
      [`la`, `latin`],
      [`mi`, `maori`],
      [`ml`, `malayalam`],
      [`cy`, `welsh`],
      [`sk`, `slovak`],
      [`te`, `telugu`],
      [`fa`, `persian`],
      [`lv`, `latvian`],
      [`bn`, `bengali`],
      [`sr`, `serbian`],
      [`az`, `azerbaijani`],
      [`sl`, `slovenian`],
      [`kn`, `kannada`],
      [`et`, `estonian`],
      [`mk`, `macedonian`],
      [`br`, `breton`],
      [`eu`, `basque`],
      [`is`, `icelandic`],
      [`hy`, `armenian`],
      [`ne`, `nepali`],
      [`mn`, `mongolian`],
      [`bs`, `bosnian`],
      [`kk`, `kazakh`],
      [`sq`, `albanian`],
      [`sw`, `swahili`],
      [`gl`, `galician`],
      [`mr`, `marathi`],
      [`pa`, `punjabi`],
      [`si`, `sinhala`],
      [`km`, `khmer`],
      [`sn`, `shona`],
      [`yo`, `yoruba`],
      [`so`, `somali`],
      [`af`, `afrikaans`],
      [`oc`, `occitan`],
      [`ka`, `georgian`],
      [`be`, `belarusian`],
      [`tg`, `tajik`],
      [`sd`, `sindhi`],
      [`gu`, `gujarati`],
      [`am`, `amharic`],
      [`yi`, `yiddish`],
      [`lo`, `lao`],
      [`uz`, `uzbek`],
      [`fo`, `faroese`],
      [`ht`, `haitian creole`],
      [`ps`, `pashto`],
      [`tk`, `turkmen`],
      [`nn`, `nynorsk`],
      [`mt`, `maltese`],
      [`sa`, `sanskrit`],
      [`lb`, `luxembourgish`],
      [`my`, `myanmar`],
      [`bo`, `tibetan`],
      [`tl`, `tagalog`],
      [`mg`, `malagasy`],
      [`as`, `assamese`],
      [`tt`, `tatar`],
      [`haw`, `hawaiian`],
      [`ln`, `lingala`],
      [`ha`, `hausa`],
      [`ba`, `bashkir`],
      [`jw`, `javanese`],
      [`su`, `sundanese`],
    ],
    WHISPER_LANGUAGE_MAPPING = new Map(WHISPER_LANGUAGES),
    WHISPER_TO_LANGUAGE_CODE_MAPPING = new Map([
      ...WHISPER_LANGUAGES.map(([e, t]) => [t, e]),
      [`burmese`, `my`],
      [`valencian`, `ca`],
      [`flemish`, `nl`],
      [`haitian`, `ht`],
      [`letzeburgesch`, `lb`],
      [`pushto`, `ps`],
      [`panjabi`, `pa`],
      [`moldavian`, `ro`],
      [`moldovan`, `ro`],
      [`sinhalese`, `si`],
      [`castilian`, `es`],
    ]);
  var WhisperTokenizer = class extends PreTrainedTokenizer {
      _default_chat_template = `{% for message in messages %}" "{{ message.content }}{{ eos_token }}" "{% endfor %}`;
      _decode_asr(
        e,
        {
          return_timestamps: t = !1,
          return_language: n = !1,
          time_precision: r = null,
          force_full_sequences: i = !0,
        } = {},
      ) {
        if (r === null) throw Error(`Must specify time_precision`);
        let a = null,
          o = t === `word`;
        function s() {
          return { language: a, timestamp: [null, null], text: `` };
        }
        let c = [],
          l = s(),
          u = 0,
          d = this.model.convert_tokens_to_ids([`<|notimestamps|>`])[0] + 1,
          f = [],
          p = [],
          m = !1,
          h = null,
          g = new Set(this.all_special_ids);
        for (let n of e) {
          let e = n.tokens,
            i = o ? n.token_timestamps : null,
            _ = null,
            v = d;
          if (`stride` in n) {
            let [t, i, a] = n.stride;
            if (((u -= i), (h = t - a), i && (v = i / r + d), a))
              for (let t = e.length - 1; t >= 0; --t) {
                let n = e[t];
                if (n >= d) {
                  if (_ !== null && (n - d) * r < h) break;
                  _ = n;
                }
              }
          }
          let y = [],
            b = [];
          for (let n = 0; n < e.length; ++n) {
            let h = e[n];
            if (g.has(h)) {
              let e = this.decode([h]),
                n = WHISPER_LANGUAGE_MAPPING.get(e.slice(2, -2));
              if (n !== void 0) {
                if (a !== null && n !== a && !t) {
                  f.push(y);
                  let e = this.findLongestCommonSequence(f)[0],
                    t = this.decode(e);
                  ((l.text = t), c.push(l), (f = []), (y = []), (l = s()));
                }
                a = l.language = n;
              }
            } else if (h >= d) {
              let e = round((h - d) * r + u, 2);
              if (_ !== null && h >= _) m = !0;
              else if (m || (f.length > 0 && h < v)) m = !1;
              else if (l.timestamp[0] === null) l.timestamp[0] = e;
              else if (e !== l.timestamp[0]) {
                ((l.timestamp[1] = e), f.push(y), o && p.push(b));
                let [t, n] = this.findLongestCommonSequence(f, p),
                  r = this.decode(t);
                ((l.text = r),
                  o && (l.words = this.collateWordTimestamps(t, n, a)),
                  c.push(l),
                  (f = []),
                  (y = []),
                  (p = []),
                  (b = []),
                  (l = s()));
              }
            } else if ((y.push(h), o)) {
              let e = round(i[n] + u, 2),
                t;
              ((t = n + 1 < i.length ? round(i[n + 1] + u, 2) : null), b.push([e, t]));
            }
          }
          if (`stride` in n) {
            let [e, t, r] = n.stride;
            u += e - r;
          }
          y.length > 0
            ? (f.push(y), o && p.push(b))
            : f.every((e) => e.length === 0) && ((l = s()), (f = []), (y = []), (p = []), (b = []));
        }
        if (f.length > 0) {
          if (i && t)
            throw Error(
              `Whisper did not predict an ending timestamp, which can happen if audio is cut off in the middle of a word. Also make sure WhisperTimeStampLogitsProcessor was used during generation.`,
            );
          let [e, n] = this.findLongestCommonSequence(f, p),
            r = this.decode(e);
          ((l.text = r), o && (l.words = this.collateWordTimestamps(e, n, a)), c.push(l));
        }
        let _ = Object.create(null),
          v = c.map((e) => e.text).join(``);
        if (t || n) {
          for (let e = 0; e < c.length; ++e) {
            let r = c[e];
            (t || delete r.timestamp, n || delete r.language);
          }
          if (o) {
            let e = [];
            for (let t of c) for (let n of t.words) e.push(n);
            _ = { chunks: e };
          } else _ = { chunks: c };
        }
        return [v, _];
      }
      findLongestCommonSequence(e, t = null) {
        let n = e[0],
          r = n.length,
          i = [],
          a = Array.isArray(t) && t.length > 0,
          o = a ? [] : null,
          s = a ? t[0] : null;
        for (let c = 1; c < e.length; ++c) {
          let l = e[c],
            u = 0,
            d = [r, r, 0, 0],
            f = l.length;
          for (let e = 1; e < r + f; ++e) {
            let t = e / 1e4,
              i = Math.max(0, r - e),
              a = Math.min(r, r + f - e),
              o = n.slice(i, a),
              s = Math.max(0, e - r),
              c = Math.min(f, e),
              p = l.slice(s, c);
            if (o.length !== p.length)
              throw Error(
                'There is a bug within whisper `decode_asr` function, please report it. Dropping to prevent bad inference.',
              );
            let m = o.filter((e, t) => e === p[t]).length,
              h = m / e + t;
            m > 1 && h > u && ((u = h), (d = [i, a, s, c]));
          }
          let [p, m, h, g] = d,
            _ = Math.floor((m + p) / 2),
            v = Math.floor((g + h) / 2);
          (i.push(...n.slice(0, _)),
            (n = l.slice(v)),
            (r = n.length),
            a && (o.push(...s.slice(0, _)), (s = t[c].slice(v))));
        }
        return (i.push(...n), a ? (o.push(...s), [i, o]) : [i, []]);
      }
      collateWordTimestamps(e, t, n) {
        let [r, i, a] = this.combineTokensIntoWords(e, n),
          o = [];
        for (let e = 0; e < r.length; ++e) {
          let n = a[e];
          o.push({ text: r[e], timestamp: [t[n.at(0)][0], t[n.at(-1)][1]] });
        }
        return o;
      }
      combineTokensIntoWords(e, t, n = `"'“¡¿([{-`, r = `"'.。,，!！?？:：”)]}、`) {
        t ??= `english`;
        let i, a, o;
        return (
          [`chinese`, `japanese`, `thai`, `lao`, `myanmar`].includes(t)
            ? ([i, a, o] = this.splitTokensOnUnicode(e))
            : ([i, a, o] = this.splitTokensOnSpaces(e)),
          this.mergePunctuations(i, a, o, n, r)
        );
      }
      decode(e, t) {
        let n;
        return (
          t && t.decode_with_timestamps
            ? (e instanceof Tensor && (e = prepareTensorForDecode(e)), (n = this.decodeWithTimestamps(e, t)))
            : (n = super.decode(e, t)),
          n
        );
      }
      decodeWithTimestamps(e, t) {
        let n = t?.time_precision ?? 0.02,
          r = Array.from(this.all_special_ids).at(-1) + 1,
          i = [[]];
        for (let t of e)
          if (t >= r) {
            let e = round((t - r) * n, 2);
            (i.push(`<|${e}|>`), i.push([]));
          } else i[i.length - 1].push(t);
        return ((i = i.map((e) => (typeof e == `string` ? e : super.decode(e, t)))), i.join(``));
      }
      splitTokensOnUnicode(e) {
        let t = this.decode(e, { decode_with_timestamps: !0 }),
          n = `�`,
          r = [],
          i = [],
          a = [],
          o = [],
          s = [],
          c = 0;
        for (let n = 0; n < e.length; ++n) {
          let l = e[n];
          (o.push(l), s.push(n));
          let u = this.decode(o, { decode_with_timestamps: !0 });
          (!u.includes(`�`) || t[c + u.indexOf(`�`)] === `�`) &&
            (r.push(u), i.push(o), a.push(s), (o = []), (s = []), (c += u.length));
        }
        return [r, i, a];
      }
      splitTokensOnSpaces(e) {
        let [t, n, r] = this.splitTokensOnUnicode(e),
          i = [],
          a = [],
          o = [],
          s = RegExp(`^[${PUNCTUATION_REGEX}]$`, `gu`);
        for (let e = 0; e < t.length; ++e) {
          let c = t[e],
            l = n[e],
            u = r[e],
            d = l[0] >= this.model.tokens_to_ids.get(`<|endoftext|>`),
            f = c.startsWith(` `),
            p = c.trim(),
            m = s.test(p);
          if (d || f || m || i.length === 0) (i.push(c), a.push(l), o.push(u));
          else {
            let e = i.length - 1;
            ((i[e] += c), a[e].push(...l), o[e].push(...u));
          }
        }
        return [i, a, o];
      }
      mergePunctuations(e, t, n, r, i) {
        let a = structuredClone(e),
          o = structuredClone(t),
          s = structuredClone(n),
          c = a.length - 2,
          l = a.length - 1;
        for (; c >= 0; )
          (a[c].startsWith(` `) && r.includes(a[c].trim())
            ? ((a[l] = a[c] + a[l]),
              (o[l] = mergeArrays(o[c], o[l])),
              (s[l] = mergeArrays(s[c], s[l])),
              (a[c] = ``),
              (o[c] = []),
              (s[c] = []))
            : (l = c),
            --c);
        for (c = 0, l = 1; l < a.length; )
          (!a[c].endsWith(` `) && i.includes(a[l])
            ? ((a[c] += a[l]),
              (o[c] = mergeArrays(o[c], o[l])),
              (s[c] = mergeArrays(s[c], s[l])),
              (a[l] = ``),
              (o[l] = []),
              (s[l] = []))
            : (c = l),
            ++l);
        return [a.filter((e) => e), o.filter((e) => e.length > 0), s.filter((e) => e.length > 0)];
      }
      get_decoder_prompt_ids({ language: e = null, task: t = null, no_timestamps: n = !0 } = {}) {
        let r = [];
        if (e) {
          e = e.toLowerCase();
          let t = WHISPER_TO_LANGUAGE_CODE_MAPPING.get(e);
          if (t === void 0)
            if (WHISPER_LANGUAGE_MAPPING.has(e)) t = e;
            else {
              let t = e.length === 2 ? WHISPER_LANGUAGE_MAPPING.keys() : WHISPER_LANGUAGE_MAPPING.values();
              throw Error(`Language "${e}" is not supported. Must be one of: ${JSON.stringify(t)}`);
            }
          let n = this.model.tokens_to_ids.get(`<|${t}|>`);
          if (n === void 0)
            throw Error(
              `Unable to find language "${t}" in model vocabulary. Please report this issue at https://github.com/xenova/transformers.js/issues/new/choose.`,
            );
          r.push(n);
        } else r.push(null);
        if (t) {
          if (((t = t.toLowerCase()), t !== `transcribe` && t !== `translate`))
            throw Error(`Task "${t}" is not supported. Must be one of: ["transcribe", "translate"]`);
          let e = this.model.tokens_to_ids.get(`<|${t}|>`);
          if (e === void 0)
            throw Error(
              `Unable to find task "${t}" in model vocabulary. Please report this issue at https://github.com/xenova/transformers.js/issues/new/choose.`,
            );
          r.push(e);
        } else r.push(null);
        if (n) {
          let e = this.model.tokens_to_ids.get(`<|notimestamps|>`);
          if (e === void 0)
            throw Error(
              `Unable to find "<|notimestamps|>" in model vocabulary. Please report this issue at https://github.com/xenova/transformers.js/issues/new/choose.`,
            );
          r.push(e);
        }
        return r.map((e, t) => [t + 1, e]).filter((e) => e[1] !== null);
      }
    },
    CodeGenTokenizer = class extends PreTrainedTokenizer {},
    CLIPTokenizer = class extends PreTrainedTokenizer {},
    SiglipTokenizer = class extends PreTrainedTokenizer {},
    MarianTokenizer = class extends PreTrainedTokenizer {
      constructor(e, t) {
        (super(e, t),
          (this.languageRegex = /^(>>\w+<<)\s*/g),
          (this.supported_language_codes = this.model.vocab.filter((e) => this.languageRegex.test(e))),
          console.warn(
            'WARNING: `MarianTokenizer` is not yet supported by Hugging Face\'s "fast" tokenizers library. Therefore, you may experience slightly inaccurate results.',
          ));
      }
      _encode_text(e) {
        if (e === null) return null;
        let [t, ...n] = e.trim().split(this.languageRegex);
        if (n.length === 0) return super._encode_text(t);
        if (n.length === 2) {
          let [e, t] = n;
          return (
            this.supported_language_codes.includes(e) ||
              console.warn(
                `Unsupported language code "${e}" detected, which may lead to unexpected behavior. Should be one of: ${JSON.stringify(this.supported_language_codes)}`,
              ),
            mergeArrays([e], super._encode_text(t))
          );
        }
      }
    },
    Wav2Vec2CTCTokenizer = class extends PreTrainedTokenizer {},
    BlenderbotTokenizer = class extends PreTrainedTokenizer {
      _default_chat_template = `{% for message in messages %}{% if message['role'] == 'user' %}{{ ' ' }}{% endif %}{{ message['content'] }}{% if not loop.last %}{{ '  ' }}{% endif %}{% endfor %}{{ eos_token }}`;
    },
    BlenderbotSmallTokenizer = class extends BlenderbotTokenizer {},
    SpeechT5Tokenizer = class extends PreTrainedTokenizer {},
    NougatTokenizer = class extends PreTrainedTokenizer {},
    VitsTokenizer = class extends PreTrainedTokenizer {
      constructor(e, t) {
        (super(e, t), (this.decoder = new VitsDecoder({})));
      }
    },
    CohereTokenizer = class extends PreTrainedTokenizer {},
    AutoTokenizer = class {
      static TOKENIZER_CLASS_MAPPING = {
        T5Tokenizer,
        DistilBertTokenizer,
        CamembertTokenizer,
        DebertaTokenizer,
        DebertaV2Tokenizer,
        BertTokenizer,
        HerbertTokenizer,
        ConvBertTokenizer,
        RoFormerTokenizer,
        XLMTokenizer,
        ElectraTokenizer,
        MobileBertTokenizer,
        SqueezeBertTokenizer,
        AlbertTokenizer,
        GPT2Tokenizer,
        BartTokenizer,
        MBartTokenizer,
        MBart50Tokenizer,
        RobertaTokenizer,
        WhisperTokenizer,
        CodeGenTokenizer,
        CLIPTokenizer,
        SiglipTokenizer,
        MarianTokenizer,
        BloomTokenizer,
        NllbTokenizer,
        M2M100Tokenizer,
        LlamaTokenizer,
        CodeLlamaTokenizer,
        XLMRobertaTokenizer,
        MPNetTokenizer,
        FalconTokenizer,
        GPTNeoXTokenizer,
        EsmTokenizer,
        Wav2Vec2CTCTokenizer,
        BlenderbotTokenizer,
        BlenderbotSmallTokenizer,
        SpeechT5Tokenizer,
        NougatTokenizer,
        VitsTokenizer,
        Qwen2Tokenizer,
        GemmaTokenizer,
        Grok1Tokenizer,
        CohereTokenizer,
        PreTrainedTokenizer,
      };
      static async from_pretrained(
        e,
        {
          quantized: t = !0,
          progress_callback: n = null,
          config: r = null,
          cache_dir: i = null,
          local_files_only: a = !1,
          revision: o = `main`,
          legacy: s = null,
        } = {},
      ) {
        let [c, l] = await loadTokenizer(e, {
            quantized: t,
            progress_callback: n,
            config: r,
            cache_dir: i,
            local_files_only: a,
            revision: o,
            legacy: s,
          }),
          u = l.tokenizer_class?.replace(/Fast$/, ``) ?? `PreTrainedTokenizer`,
          d = this.TOKENIZER_CLASS_MAPPING[u];
        return (
          (d ||=
            (console.warn(`Unknown tokenizer class "${u}", attempting to construct from base class.`),
            PreTrainedTokenizer)),
          new d(c, l)
        );
      }
    };
  async function loadConfig(e, t) {
    return await getModelJSON(e, `config.json`, !0, t);
  }
  var PretrainedConfig = class {
      constructor(e) {
        ((this.model_type = null), (this.is_encoder_decoder = !1), Object.assign(this, e));
      }
      static async from_pretrained(
        e,
        {
          progress_callback: t = null,
          config: n = null,
          cache_dir: r = null,
          local_files_only: i = !1,
          revision: a = `main`,
        } = {},
      ) {
        let o =
          n ??
          (await loadConfig(e, { progress_callback: t, config: n, cache_dir: r, local_files_only: i, revision: a }));
        return new this(o);
      }
    },
    AutoConfig = class {
      static async from_pretrained(...e) {
        return PretrainedConfig.from_pretrained(...e);
      }
    },
    LogitsProcessorList = class extends Callable {
      constructor() {
        (super(), (this.processors = []));
      }
      push(e) {
        this.processors.push(e);
      }
      extend(e) {
        this.processors.push(...e);
      }
      _call(e, t) {
        for (let n of t) this.processors.forEach((t) => t(e, n));
      }
      [Symbol.iterator]() {
        return this.processors.values();
      }
    },
    LogitsProcessor = class extends Callable {
      _call(e, t) {
        throw Error('`_call` should be implemented in a subclass');
      }
    },
    ForceTokensLogitsProcessor = class extends LogitsProcessor {
      constructor(e) {
        (super(), (this.force_token_map = Object.fromEntries(e ?? [])));
      }
      _call(e, t) {
        let n = this.force_token_map[e.length];
        return (exists(n) && (t.data.fill(-1 / 0), (t.data[n] = 0)), t);
      }
    },
    ForcedBOSTokenLogitsProcessor = class extends LogitsProcessor {
      constructor(e) {
        (super(), (this.bos_token_id = e));
      }
      _call(e, t) {
        return (e.length === 1 && (t.data.fill(-1 / 0), (t.data[this.bos_token_id] = 0)), t);
      }
    },
    ForcedEOSTokenLogitsProcessor = class extends LogitsProcessor {
      constructor(e, t) {
        (super(), (this.max_length = e), (this.forced_eos_token_id = t));
      }
      _call(e, t) {}
    },
    SuppressTokensAtBeginLogitsProcessor = class extends LogitsProcessor {
      constructor(e, t) {
        (super(), (this.begin_suppress_tokens = e), (this.begin_index = t));
      }
      _call(e, t) {
        if (e.length === this.begin_index) for (let e of this.begin_suppress_tokens) t.data[e] = -1 / 0;
        return t;
      }
    },
    WhisperTimeStampLogitsProcessor = class extends LogitsProcessor {
      constructor(e) {
        (super(),
          (this.eos_token_id = e.eos_token_id),
          (this.no_timestamps_token_id = e.no_timestamps_token_id),
          (this.timestamp_begin = this.no_timestamps_token_id + 1),
          (this.begin_index = (e.forced_decoder_ids || []).length + 2),
          e.forced_decoder_ids.slice(-1)[0][1] === this.no_timestamps_token_id && --this.begin_index,
          (this.max_initial_timestamp_index = e.max_initial_timestamp_index));
      }
      _call(e, t) {
        let n = t.data;
        if (((n[this.no_timestamps_token_id] = -1 / 0), e.length === this.begin_index - 1))
          return (n.fill(-1 / 0), (n[this.timestamp_begin] = 0), t);
        let r = e.slice(this.begin_index),
          i = r.length >= 1 && r[r.length - 1] >= this.timestamp_begin,
          a = r.length < 2 || r[r.length - 2] >= this.timestamp_begin;
        if (
          (i && (a ? n.subarray(this.timestamp_begin).fill(-1 / 0) : n.subarray(0, this.eos_token_id).fill(-1 / 0)),
          e.length === this.begin_index && this.max_initial_timestamp_index !== null)
        ) {
          let e = this.timestamp_begin + this.max_initial_timestamp_index;
          n.subarray(e + 1).fill(-1 / 0);
        }
        let o = log_softmax(n);
        return (
          Math.log(
            o
              .subarray(this.timestamp_begin)
              .map(Math.exp)
              .reduce((e, t) => e + t),
          ) > max(o.subarray(0, this.timestamp_begin))[0] && n.subarray(0, this.timestamp_begin).fill(-1 / 0),
          t
        );
      }
    },
    NoRepeatNGramLogitsProcessor = class extends LogitsProcessor {
      constructor(e) {
        (super(), (this.no_repeat_ngram_size = e));
      }
      getNgrams(e) {
        let t = e.length,
          n = [];
        for (let r = 0; r < t + 1 - this.no_repeat_ngram_size; ++r) {
          let t = [];
          for (let n = 0; n < this.no_repeat_ngram_size; ++n) t.push(e[r + n]);
          n.push(t);
        }
        let r = new Map();
        for (let e of n) {
          let t = e.slice(0, e.length - 1),
            n = JSON.stringify(t),
            i = r.get(n) ?? [];
          (i.push(e[e.length - 1]), r.set(n, i));
        }
        return r;
      }
      getGeneratedNgrams(e, t) {
        let n = t.slice(t.length + 1 - this.no_repeat_ngram_size, t.length);
        return e.get(JSON.stringify(n)) ?? [];
      }
      calcBannedNgramTokens(e) {
        let t = [];
        if (e.length + 1 < this.no_repeat_ngram_size) return t;
        {
          let t = this.getNgrams(e);
          return this.getGeneratedNgrams(t, e);
        }
      }
      _call(e, t) {
        let n = this.calcBannedNgramTokens(e);
        for (let e of n) t.data[e] = -1 / 0;
        return t;
      }
    },
    RepetitionPenaltyLogitsProcessor = class extends LogitsProcessor {
      constructor(e) {
        (super(), (this.penalty = e));
      }
      _call(e, t) {
        for (let n of e) t.data[n] < 0 ? (t.data[n] *= this.penalty) : (t.data[n] /= this.penalty);
        return t;
      }
    },
    MinLengthLogitsProcessor = class extends LogitsProcessor {
      constructor(e, t) {
        (super(), (this.min_length = e), (this.eos_token_id = Array.isArray(t) ? t : [t]));
      }
      _call(e, t) {
        if (e.length < this.min_length) for (let e of this.eos_token_id) t.data[e] = -1 / 0;
        return t;
      }
    },
    MinNewTokensLengthLogitsProcessor = class extends LogitsProcessor {
      constructor(e, t, n) {
        (super(),
          (this.prompt_length_to_skip = e),
          (this.min_new_tokens = t),
          (this.eos_token_id = Array.isArray(n) ? n : [n]));
      }
      _call(e, t) {
        if (e.length - this.prompt_length_to_skip < this.min_new_tokens)
          for (let e of this.eos_token_id) t.data[e] = -1 / 0;
        return t;
      }
    },
    NoBadWordsLogitsProcessor = class extends LogitsProcessor {
      constructor(e, t) {
        (super(), (this.bad_words_ids = e), (this.eos_token_id = Array.isArray(t) ? t : [t]));
      }
      _call(e, t) {
        for (let n of this.bad_words_ids) {
          let r = !0;
          for (let t = 1; t <= n.length - 1 && n.length < e.length; ++t)
            if (n.at(-t - 1) !== e.at(-t)) {
              r = !1;
              break;
            }
          r && (t.data[n.at(-1)] = -1 / 0);
        }
        return t;
      }
    };
  const GenerationConfig = class {
    constructor(e = {}) {
      ((this.max_length = e.max_length ?? 20),
        (this.max_new_tokens = e.max_new_tokens ?? null),
        (this.min_length = e.min_length ?? 0),
        (this.min_new_tokens = e.min_new_tokens ?? null),
        (this.early_stopping = e.early_stopping ?? !1),
        (this.max_time = e.max_time ?? null),
        (this.do_sample = e.do_sample ?? !1),
        (this.num_beams = e.num_beams ?? 1),
        (this.num_beam_groups = e.num_beam_groups ?? 1),
        (this.penalty_alpha = e.penalty_alpha ?? null),
        (this.use_cache = e.use_cache ?? !0),
        (this.temperature = e.temperature ?? 1),
        (this.top_k = e.top_k ?? 50),
        (this.top_p = e.top_p ?? 1),
        (this.typical_p = e.typical_p ?? 1),
        (this.epsilon_cutoff = e.epsilon_cutoff ?? 0),
        (this.eta_cutoff = e.eta_cutoff ?? 0),
        (this.diversity_penalty = e.diversity_penalty ?? 0),
        (this.repetition_penalty = e.repetition_penalty ?? 1),
        (this.encoder_repetition_penalty = e.encoder_repetition_penalty ?? 1),
        (this.length_penalty = e.length_penalty ?? 1),
        (this.no_repeat_ngram_size = e.no_repeat_ngram_size ?? 0),
        (this.bad_words_ids = e.bad_words_ids ?? null),
        (this.force_words_ids = e.force_words_ids ?? null),
        (this.renormalize_logits = e.renormalize_logits ?? !1),
        (this.constraints = e.constraints ?? null),
        (this.forced_bos_token_id = e.forced_bos_token_id ?? null),
        (this.forced_eos_token_id = e.forced_eos_token_id ?? null),
        (this.remove_invalid_values = e.remove_invalid_values ?? !1),
        (this.exponential_decay_length_penalty = e.exponential_decay_length_penalty ?? null),
        (this.suppress_tokens = e.suppress_tokens ?? null),
        (this.begin_suppress_tokens = e.begin_suppress_tokens ?? null),
        (this.forced_decoder_ids = e.forced_decoder_ids ?? null),
        (this.num_return_sequences = e.num_return_sequences ?? 1),
        (this.output_attentions = e.output_attentions ?? !1),
        (this.output_hidden_states = e.output_hidden_states ?? !1),
        (this.output_scores = e.output_scores ?? !1),
        (this.return_dict_in_generate = e.return_dict_in_generate ?? !1),
        (this.pad_token_id = e.pad_token_id ?? null),
        (this.bos_token_id = e.bos_token_id ?? null),
        (this.eos_token_id = e.eos_token_id ?? null),
        (this.encoder_no_repeat_ngram_size = e.encoder_no_repeat_ngram_size ?? 0),
        (this.decoder_start_token_id = e.decoder_start_token_id ?? null),
        (this.generation_kwargs = e.generation_kwargs ?? {}));
    }
  };
  var Sampler = class extends Callable {
      constructor(e) {
        (super(), (this.generation_config = e));
      }
      _call(e, t = -1) {
        return this.sample(e, t);
      }
      sample(e, t) {
        throw Error(`sample should be implemented in subclasses.`);
      }
      getLogits(e, t) {
        let n = e.dims.at(-1),
          r = e.data;
        if (t === -1) r = r.slice(-n);
        else {
          let e = t * n;
          r = r.slice(e, e + n);
        }
        return (
          this.generation_config.temperature > 0 && (r = r.map((e) => e / this.generation_config.temperature)),
          r
        );
      }
      randomSelect(e) {
        let t = e.reduce((e, t) => e + t, 0),
          n = Math.random() * t;
        for (let t = 0; t < e.length; ++t) if (((n -= e[t]), n <= 0)) return t;
        return 0;
      }
      static getSampler(e) {
        if (e.do_sample) return new MultinomialSampler(e);
        if (e.num_beams > 1) return new BeamSearchSampler(e);
        if (e.num_return_sequences > 1)
          throw Error(`num_return_sequences has to be 1 when doing greedy search, but is ${e.num_return_sequences}.`);
        return new GreedySampler(e);
      }
    },
    GreedySampler = class extends Sampler {
      sample(e, t = -1) {
        return [[max(this.getLogits(e, t))[1], 0]];
      }
    },
    MultinomialSampler = class extends Sampler {
      sample(e, t = -1) {
        let n = e.dims.at(-1);
        this.generation_config.top_k > 0 && (n = Math.min(this.generation_config.top_k, n));
        let r = getTopItems(this.getLogits(e, t), n),
          i = softmax(r.map((e) => e[1]));
        return Array.from({ length: this.generation_config.num_beams }, () => {
          let e = this.randomSelect(i);
          return [r[e][0], Math.log(i[e])];
        });
      }
    },
    BeamSearchSampler = class extends Sampler {
      sample(e, t = -1) {
        let n = e.dims.at(-1);
        this.generation_config.top_k > 0 && (n = Math.min(this.generation_config.top_k, n));
        let r = getTopItems(this.getLogits(e, t), n),
          i = softmax(r.map((e) => e[1]));
        return Array.from({ length: this.generation_config.num_beams }, (e, t) => [r[t][0], Math.log(i[t])]);
      }
    };
  const { InferenceSession, Tensor: ONNXTensor, env } = ONNX,
    MODEL_TYPES = { EncoderOnly: 0, EncoderDecoder: 1, Seq2Seq: 2, Vision2Seq: 3, DecoderOnly: 4, MaskGeneration: 5 },
    MODEL_TYPE_MAPPING = new Map(),
    MODEL_NAME_TO_CLASS_MAPPING = new Map(),
    MODEL_CLASS_TO_NAME_MAPPING = new Map();
  async function constructSession(e, t, n) {
    let r = await getModelFile(e, `onnx/${t}${n.quantized ? `_quantized` : ``}.onnx`, !0, n);
    try {
      return await InferenceSession.create(r, { executionProviders });
    } catch (e) {
      if (executionProviders.length === 1 && executionProviders[0] === `wasm`) throw e;
      return (
        console.warn(e),
        console.warn(
          'Something went wrong during model construction (most likely a missing operation). Using `wasm` as a fallback. ',
        ),
        await InferenceSession.create(r, { executionProviders: [`wasm`] })
      );
    }
  }
  function validateInputs(e, t) {
    let n = Object.create(null),
      r = [];
    for (let i of e.inputNames) {
      let e = t[i];
      if (!(e instanceof Tensor)) {
        r.push(i);
        continue;
      }
      n[i] = env.wasm.proxy ? e.clone() : e;
    }
    if (r.length > 0)
      throw Error(`An error occurred during model execution: "Missing the following inputs: ${r.join(`, `)}.`);
    let i = Object.keys(t).length,
      a = e.inputNames.length;
    if (i > a) {
      let n = Object.keys(t).filter((t) => !e.inputNames.includes(t));
      console.warn(
        `WARNING: Too many inputs were provided (${i} > ${a}). The following inputs will be ignored: "${n.join(`, `)}".`,
      );
    }
    return n;
  }
  async function sessionRun(e, t) {
    let n = validateInputs(e, t);
    try {
      let t = await e.run(n);
      return ((t = replaceTensors(t)), t);
    } catch (e) {
      throw (
        console.error(`An error occurred during model execution: "${e}".`),
        console.error(`Inputs given to model:`, n),
        e
      );
    }
  }
  function replaceTensors(e) {
    for (let t in e)
      e[t] instanceof ONNXTensor ? (e[t] = new Tensor(e[t])) : typeof e[t] == `object` && replaceTensors(e[t]);
    return e;
  }
  function toI64Tensor(e) {
    if (e instanceof Tensor) return e;
    if (e.length === 0) throw Error(`items must be non-empty`);
    if (Array.isArray(e[0])) {
      if (e.some((t) => t.length !== e[0].length))
        throw Error(
          `Unable to create tensor, you should probably activate truncation and/or padding with 'padding=True' and/or 'truncation=True' to have batched tensors with the same length.`,
        );
      return new Tensor(`int64`, BigInt64Array.from(e.flat().map((e) => BigInt(e))), [e.length, e[0].length]);
    } else return new Tensor(`int64`, BigInt64Array.from(e.map((e) => BigInt(e))), [1, e.length]);
  }
  function prepareAttentionMask(e, t) {
    let n = e.config.pad_token_id ?? null,
      r = e.config.eos_token_id ?? null;
    isIntegralNumber(r) && (r = [r]);
    let i = t.indexOf(n) !== -1,
      a = r === null || !r.includes(n);
    return i && a ? new Tensor(`int64`, BigInt64Array.from(t.data.map((e) => e != n)), t.dims) : ones_like(t);
  }
  function preparePositionIds(e, t, n) {
    if (!e.inputNames.includes(`position_ids`)) return;
    let r = new BigInt64Array(t.attention_mask.data.length);
    for (let e = 0; e < t.attention_mask.dims[0]; ++e) {
      let n = e * t.attention_mask.dims[1],
        i = BigInt(0);
      for (let e = 0; e < t.attention_mask.dims[1]; ++e) {
        let a = n + e;
        t.attention_mask.data[a] === 0n ? (r[a] = BigInt(1)) : ((r[a] = i), (i += t.attention_mask.data[a]));
      }
    }
    ((t.position_ids = new Tensor(`int64`, r, t.attention_mask.dims)),
      n && (t.position_ids = t.position_ids.slice(null, -1).unsqueeze_(-1)));
  }
  function boolTensor(e) {
    return new Tensor(`bool`, [e], [1]);
  }
  async function seq2seqForward(e, t) {
    let { encoder_outputs: n, past_key_values: r } = t;
    n ||= (await encoderForward(e, t)).last_hidden_state;
    let i = { input_ids: t.decoder_input_ids, encoder_hidden_states: n },
      a = !!r;
    (e.decoder_merged_session.inputNames.includes(`use_cache_branch`) && (i.use_cache_branch = boolTensor(a)),
      e.decoder_merged_session.inputNames.includes(`encoder_attention_mask`) &&
        (i.encoder_attention_mask = t.attention_mask),
      preparePositionIds(e.decoder_merged_session, i, a),
      e.addPastKeyValues(i, r));
    let o = await sessionRun(e.decoder_merged_session, i),
      s = o.logits;
    r = e.getPastKeyValues(o, r);
    let c = e.getAttentions(o);
    return new Seq2SeqLMOutput({ logits: s, past_key_values: r, encoder_outputs: n, ...c });
  }
  function seq2seqStartBeams(e, t, n, r) {
    let i = [],
      a = 0,
      o = e.requires_attention_mask ?? !0,
      s = n.decoder_input_ids ?? n.decoder_start_token_id ?? n.bos_token_id ?? n.eos_token_id;
    s instanceof Tensor ? (s = s.tolist().flat()) : Array.isArray(s) || (s = [s]);
    for (let n of t) {
      n.dims = [1, ...n.dims];
      let t = {
        inputs: n,
        encoder_outputs: null,
        prev_model_outputs: null,
        output_token_ids: s,
        done: !1,
        score: 0,
        id: a++,
      };
      (o && (t.attention_mask = prepareAttentionMask(e, n)), i.push(t));
    }
    return i;
  }
  async function seq2seqRunBeam(e, t) {
    let n = e.main_input_name,
      r = t.output_token_ids;
    t.prev_model_outputs && (r = r.slice(-1));
    let i = {
      [n]: t.inputs,
      decoder_input_ids: toI64Tensor(r),
      encoder_outputs: t.encoder_outputs,
      past_key_values: t.prev_model_outputs?.past_key_values,
    };
    t.attention_mask && (i.attention_mask = t.attention_mask);
    let a = await e.forward(i);
    return ((t.prev_model_outputs = a), (t.encoder_outputs = a.encoder_outputs), a);
  }
  function seq2seqUpdatebeam(e, t) {
    e.output_token_ids = [...e.output_token_ids, t];
  }
  async function encoderForward(e, t) {
    let n = Object.create(null);
    for (let r of e.session.inputNames) n[r] = t[r];
    return (
      e.session.inputNames.includes(`token_type_ids`) &&
        !n.token_type_ids &&
        (n.token_type_ids = new Tensor(`int64`, new BigInt64Array(n.input_ids.data.length), n.input_ids.dims)),
      await sessionRun(e.session, n)
    );
  }
  async function decoderForward(e, t) {
    let { input_ids: n, past_key_values: r, attention_mask: i } = t,
      a = { input_ids: n, attention_mask: i ?? prepareAttentionMask(e, n) },
      o = !!r;
    (e.session.inputNames.includes(`use_cache_branch`) && (a.use_cache_branch = boolTensor(o)),
      preparePositionIds(e.session, a, o),
      e.addPastKeyValues(a, r));
    let s = await sessionRun(e.session, a),
      c = s.logits;
    return ((r = e.getPastKeyValues(s, r)), { logits: c, past_key_values: r });
  }
  function decoderStartBeams(e, t, n, r, i) {
    let a = [],
      o = 0;
    for (let n of t) {
      let t = n.tolist().map(Number);
      n.dims = [1, ...n.dims];
      let s;
      i ? ((s = i[o]), (s.dims = [1, ...s.dims])) : (s = prepareAttentionMask(e, n));
      let c = {
        input: n,
        model_input_ids: n,
        attention_mask: s,
        prev_model_outputs: null,
        output_token_ids: t,
        num_output_tokens: r,
        done: !1,
        score: 0,
        id: o++,
      };
      a.push(c);
    }
    return a;
  }
  async function decoderRunBeam(e, t) {
    let n = new BigInt64Array(t.output_token_ids.length).fill(1n),
      r = {
        input_ids: t.model_input_ids,
        attention_mask: new Tensor(`int64`, n, [1, n.length]),
        past_key_values: t.prev_model_outputs?.past_key_values,
      },
      i = await e.forward(r);
    return ((t.prev_model_outputs = i), i);
  }
  function decoderUpdatebeam(e, t) {
    ((e.output_token_ids = [...e.output_token_ids, t]), (e.model_input_ids = new Tensor(`int64`, [BigInt(t)], [1, 1])));
  }
  var PreTrainedModel = class extends Callable {
      main_input_name = `input_ids`;
      constructor(e, t) {
        (super(), (this.config = e), (this.session = t));
        let n = MODEL_CLASS_TO_NAME_MAPPING.get(this.constructor),
          r = MODEL_TYPE_MAPPING.get(n);
        ((this.can_generate = !1),
          (this._runBeam = null),
          (this._getStartBeams = null),
          (this._updateBeam = null),
          (this._forward = null),
          r === MODEL_TYPES.DecoderOnly
            ? ((this.can_generate = !0),
              (this._runBeam = decoderRunBeam),
              (this._getStartBeams = decoderStartBeams),
              (this._updateBeam = decoderUpdatebeam),
              (this._forward = decoderForward))
            : r === MODEL_TYPES.Seq2Seq || r === MODEL_TYPES.Vision2Seq
              ? ((this.can_generate = !0),
                (this._runBeam = seq2seqRunBeam),
                (this._getStartBeams = seq2seqStartBeams),
                (this._updateBeam = seq2seqUpdatebeam),
                (this._forward = seq2seqForward))
              : (MODEL_TYPES.EncoderDecoder, (this._forward = encoderForward)));
      }
      async dispose() {
        let e = [];
        for (let t of Object.keys(this)) {
          let n = this[t];
          n instanceof InferenceSession && e.push(n.handler.dispose());
        }
        return await Promise.all(e);
      }
      static async from_pretrained(
        e,
        {
          quantized: t = !0,
          progress_callback: n = null,
          config: r = null,
          cache_dir: i = null,
          local_files_only: a = !1,
          revision: o = `main`,
          model_file_name: s = null,
        } = {},
      ) {
        let c = {
            quantized: t,
            progress_callback: n,
            config: r,
            cache_dir: i,
            local_files_only: a,
            revision: o,
            model_file_name: s,
          },
          l = MODEL_CLASS_TO_NAME_MAPPING.get(this),
          u = MODEL_TYPE_MAPPING.get(l),
          d;
        return (
          u === MODEL_TYPES.DecoderOnly
            ? (d = await Promise.all([
                AutoConfig.from_pretrained(e, c),
                constructSession(e, c.model_file_name ?? `decoder_model_merged`, c),
                getModelJSON(e, `generation_config.json`, !1, c),
              ]))
            : u === MODEL_TYPES.Seq2Seq || u === MODEL_TYPES.Vision2Seq
              ? (d = await Promise.all([
                  AutoConfig.from_pretrained(e, c),
                  constructSession(e, `encoder_model`, c),
                  constructSession(e, `decoder_model_merged`, c),
                  getModelJSON(e, `generation_config.json`, !1, c),
                ]))
              : u === MODEL_TYPES.MaskGeneration
                ? (d = await Promise.all([
                    AutoConfig.from_pretrained(e, c),
                    constructSession(e, `vision_encoder`, c),
                    constructSession(e, `prompt_encoder_mask_decoder`, c),
                  ]))
                : u === MODEL_TYPES.EncoderDecoder
                  ? (d = await Promise.all([
                      AutoConfig.from_pretrained(e, c),
                      constructSession(e, `encoder_model`, c),
                      constructSession(e, `decoder_model_merged`, c),
                    ]))
                  : (u !== MODEL_TYPES.EncoderOnly &&
                      console.warn(
                        `Model type for '${l ?? r?.model_type}' not found, assuming encoder-only architecture. Please report this at https://github.com/xenova/transformers.js/issues/new/choose.`,
                      ),
                    (d = await Promise.all([
                      AutoConfig.from_pretrained(e, c),
                      constructSession(e, c.model_file_name ?? `model`, c),
                    ]))),
          new this(...d)
        );
      }
      async _call(e) {
        return await this.forward(e);
      }
      async forward(e) {
        return await this._forward(this, e);
      }
      _get_logits_processor(e, t, n = null) {
        let r = new LogitsProcessorList();
        if (
          (e.repetition_penalty !== null &&
            e.repetition_penalty !== 1 &&
            r.push(new RepetitionPenaltyLogitsProcessor(e.repetition_penalty)),
          e.no_repeat_ngram_size !== null &&
            e.no_repeat_ngram_size > 0 &&
            r.push(new NoRepeatNGramLogitsProcessor(e.no_repeat_ngram_size)),
          e.bad_words_ids !== null && r.push(new NoBadWordsLogitsProcessor(e.bad_words_ids, e.eos_token_id)),
          e.min_length !== null &&
            e.eos_token_id !== null &&
            e.min_length > 0 &&
            r.push(new MinLengthLogitsProcessor(e.min_length, e.eos_token_id)),
          e.min_new_tokens !== null &&
            e.eos_token_id !== null &&
            e.min_new_tokens > 0 &&
            r.push(new MinNewTokensLengthLogitsProcessor(t, e.min_new_tokens, e.eos_token_id)),
          e.forced_bos_token_id !== null && r.push(new ForcedBOSTokenLogitsProcessor(e.forced_bos_token_id)),
          e.forced_eos_token_id !== null &&
            r.push(new ForcedEOSTokenLogitsProcessor(e.max_length, e.forced_eos_token_id)),
          e.begin_suppress_tokens !== null)
        ) {
          let n = t > 1 || e.forced_bos_token_id === null ? t : t + 1;
          (e.forced_decoder_ids !== null && (n += e.forced_decoder_ids[e.forced_decoder_ids.length - 1][0]),
            r.push(new SuppressTokensAtBeginLogitsProcessor(e.begin_suppress_tokens, n)));
        }
        return (
          e.forced_decoder_ids !== null && r.push(new ForceTokensLogitsProcessor(e.forced_decoder_ids)),
          n !== null && r.extend(n),
          r
        );
      }
      _get_generation_config(e) {
        let t = new GenerationConfig(this.config);
        return (
          `generation_config` in this && Object.assign(t, this.generation_config),
          e !== null && Object.assign(t, e),
          t
        );
      }
      async generate(e, t = null, n = null, { inputs_attention_mask: r = null } = {}) {
        if (!this.can_generate) {
          let e = `The current model class (${MODEL_CLASS_TO_NAME_MAPPING.get(this.constructor)}) is not compatible with \`.generate()\`, as it doesn't have a language model head.`,
            t = this.config.model_type,
            n =
              MODEL_WITH_LM_HEAD_MAPPING_NAMES.get(t) ??
              MODEL_FOR_SEQ_TO_SEQ_CAUSAL_LM_MAPPING_NAMES.get(t) ??
              MODEL_FOR_SPEECH_SEQ_2_SEQ_MAPPING_NAMES.get(t) ??
              MODEL_FOR_VISION_2_SEQ_MAPPING_NAMES.get(t);
          throw (n && (e += ` Please use the following class instead: '${n[0]}'`), Error(e));
        }
        if (!(e instanceof Tensor) && !isTypedArray(e) && !Array.isArray(e))
          throw Error(`\`inputs\` must be a Tensor, TypedArray, or Array, but is "${e.constructor.name}".`);
        let i;
        if (this.config.is_encoder_decoder) i = 0;
        else if (((i = e instanceof Tensor ? e.dims.at(-1) : e.length), i === 0))
          throw Error(`Must supply a non-empty array of input token ids.`);
        ((t = this._get_generation_config(t)),
          (n ??= new LogitsProcessorList()),
          (n = this._get_logits_processor(t, i, n)));
        let a = t.eos_token_id;
        a !== null && !Array.isArray(a) && (a = [a]);
        let o = 1,
          s = o + (t.max_new_tokens ?? 1 / 0),
          c = Number.isInteger(t.max_length) && (t.max_new_tokens ?? null) === null,
          l = Sampler.getSampler(t),
          u = this.getStartBeams(e, t, o, r);
        for (; u.some((e) => !e.done) && o < s; ) {
          let e = [];
          for (let r of u) {
            if (r.done) {
              e.push(r);
              continue;
            }
            if (c && r.output_token_ids.length >= t.max_length) {
              ((r.done = !0), e.push(r));
              continue;
            }
            let i = await this.runBeam(r);
            (t.output_attentions && this.addAttentionsToBeam(r, i), t.output_scores);
            let o = i.logits.slice(null, -1, null);
            n(r.output_token_ids, o);
            let s = l(o);
            for (let [t, n] of s) {
              let i = { ...r };
              (this.updateBeam(i, t), (i.score += n), a && a.includes(t) && (i.done = !0), e.push(i));
            }
          }
          (++o,
            (e = this.groupBeams(e).map((e) => e.sort((e, t) => t.score - e.score).slice(0, t.num_beams))),
            (u = e.flat()),
            t.callback_function && t.callback_function(u));
        }
        let d = this.groupBeams(u),
          f = (e) =>
            d
              .map((n) =>
                t.num_return_sequences > 1 ? n.slice(0, t.num_return_sequences).map((t) => t[e]) : [n[0][e]],
              )
              .flat(),
          p = f(`output_token_ids`);
        return t.return_dict_in_generate
          ? { sequences: p, decoder_attentions: f(`decoder_attentions`), cross_attentions: f(`cross_attentions`) }
          : p;
      }
      addAttentionsToBeam(e, t) {
        if (this.config.is_encoder_decoder) {
          if (!t.cross_attentions || t.cross_attentions.length === 0)
            throw Error(
              '`output_attentions` is true, but the model did not produce cross-attentions. This is most likely because the model was not exported with `output_attentions=True`.',
            );
          ((e.cross_attentions ||= []), e.cross_attentions.push(t.cross_attentions));
        }
        if (!t.decoder_attentions || t.decoder_attentions.length === 0)
          throw Error(
            '`output_attentions` is true, but the model did not produce decoder-attentions. This is most likely because the model was not exported with `output_attentions=True`.',
          );
        ((e.decoder_attentions ||= []), e.decoder_attentions.push(t.decoder_attentions));
      }
      groupBeams(e) {
        let t = Object.create(null);
        for (let n of e) t[n.id] === void 0 ? (t[n.id] = [n]) : t[n.id].push(n);
        return Object.values(t);
      }
      getPastKeyValues(e, t) {
        let n = Object.create(null);
        for (let r in e)
          if (r.startsWith(`present`)) {
            let i = r.replace(`present`, `past_key_values`);
            t && r.includes(`encoder`) ? (n[i] = t[i]) : (n[i] = e[r]);
          }
        return n;
      }
      getAttentions(e) {
        let t = Object.create(null);
        for (let n of [`cross_attentions`, `decoder_attentions`]) {
          let r = [];
          for (let t in e)
            if (t.startsWith(n)) {
              let n = t.split(`.`).pop();
              r[n] = e[t];
            }
          t[n] = r;
        }
        return t;
      }
      addPastKeyValues(e, t) {
        if (t) Object.assign(e, t);
        else {
          let t = 1;
          if (this.config.is_encoder_decoder && (this.add_encoder_pkv ?? !0)) {
            let t = [1, this.num_encoder_heads, 0, this.encoder_dim_kv],
              n = [1, this.num_decoder_heads, 0, this.decoder_dim_kv];
            for (let r = 0; r < this.num_decoder_layers; ++r)
              ((e[`past_key_values.${r}.encoder.key`] = new Tensor(`float32`, [], t)),
                (e[`past_key_values.${r}.encoder.value`] = new Tensor(`float32`, [], t)),
                (e[`past_key_values.${r}.decoder.key`] = new Tensor(`float32`, [], n)),
                (e[`past_key_values.${r}.decoder.value`] = new Tensor(`float32`, [], n)));
          } else if (this.config.model_type === `falcon`) {
            let t = [1 * this.num_heads, 0, this.dim_kv];
            for (let n = 0; n < this.num_layers; ++n)
              ((e[`past_key_values.${n}.key`] = new Tensor(`float32`, [], t)),
                (e[`past_key_values.${n}.value`] = new Tensor(`float32`, [], t)));
          } else if (this.config.multi_query) {
            let t = [1 * this.num_heads, 0, 2 * this.dim_kv];
            for (let n = 0; n < this.num_layers; ++n)
              e[`past_key_values.${n}.key_value`] = new Tensor(`float32`, [], t);
          } else if (this.config.model_type === `bloom`) {
            let t = [1 * this.num_heads, this.dim_kv, 0],
              n = [1 * this.num_heads, 0, this.dim_kv];
            for (let r = 0; r < this.num_layers; ++r)
              ((e[`past_key_values.${r}.key`] = new Tensor(`float32`, [], t)),
                (e[`past_key_values.${r}.value`] = new Tensor(`float32`, [], n)));
          } else {
            let t = [1, this.num_heads, 0, this.dim_kv];
            for (let n = 0; n < this.num_layers; ++n)
              ((e[`past_key_values.${n}.key`] = new Tensor(`float32`, [], t)),
                (e[`past_key_values.${n}.value`] = new Tensor(`float32`, [], t)));
          }
        }
      }
      getStartBeams(e, t, n, r) {
        return this._getStartBeams(this, e, t, n, r);
      }
      async runBeam(e) {
        return await this._runBeam(this, e);
      }
      updateBeam(e, t) {
        return this._updateBeam(e, t);
      }
    },
    ModelOutput = class {},
    BertPreTrainedModel = class extends PreTrainedModel {},
    BertModel = class extends BertPreTrainedModel {},
    BertForMaskedLM = class extends BertPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    BertForSequenceClassification = class extends BertPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    BertForTokenClassification = class extends BertPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    BertForQuestionAnswering = class extends BertPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    NomicBertPreTrainedModel = class extends PreTrainedModel {},
    NomicBertModel = class extends NomicBertPreTrainedModel {},
    RoFormerPreTrainedModel = class extends PreTrainedModel {},
    RoFormerModel = class extends RoFormerPreTrainedModel {},
    RoFormerForMaskedLM = class extends RoFormerPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    RoFormerForSequenceClassification = class extends RoFormerPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    RoFormerForTokenClassification = class extends RoFormerPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    RoFormerForQuestionAnswering = class extends RoFormerPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    ConvBertPreTrainedModel = class extends PreTrainedModel {},
    ConvBertModel = class extends ConvBertPreTrainedModel {},
    ConvBertForMaskedLM = class extends ConvBertPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    ConvBertForSequenceClassification = class extends ConvBertPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    ConvBertForTokenClassification = class extends ConvBertPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    ConvBertForQuestionAnswering = class extends ConvBertPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    ElectraPreTrainedModel = class extends PreTrainedModel {},
    ElectraModel = class extends ElectraPreTrainedModel {},
    ElectraForMaskedLM = class extends ElectraPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    ElectraForSequenceClassification = class extends ElectraPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    ElectraForTokenClassification = class extends ElectraPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    ElectraForQuestionAnswering = class extends ElectraPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    CamembertPreTrainedModel = class extends PreTrainedModel {},
    CamembertModel = class extends CamembertPreTrainedModel {},
    CamembertForMaskedLM = class extends CamembertPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    CamembertForSequenceClassification = class extends CamembertPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    CamembertForTokenClassification = class extends CamembertPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    CamembertForQuestionAnswering = class extends CamembertPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    DebertaPreTrainedModel = class extends PreTrainedModel {},
    DebertaModel = class extends DebertaPreTrainedModel {},
    DebertaForMaskedLM = class extends DebertaPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    DebertaForSequenceClassification = class extends DebertaPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    DebertaForTokenClassification = class extends DebertaPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    DebertaForQuestionAnswering = class extends DebertaPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    DebertaV2PreTrainedModel = class extends PreTrainedModel {},
    DebertaV2Model = class extends DebertaV2PreTrainedModel {},
    DebertaV2ForMaskedLM = class extends DebertaV2PreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    DebertaV2ForSequenceClassification = class extends DebertaV2PreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    DebertaV2ForTokenClassification = class extends DebertaV2PreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    DebertaV2ForQuestionAnswering = class extends DebertaV2PreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    DistilBertPreTrainedModel = class extends PreTrainedModel {},
    DistilBertModel = class extends DistilBertPreTrainedModel {},
    DistilBertForSequenceClassification = class extends DistilBertPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    DistilBertForTokenClassification = class extends DistilBertPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    DistilBertForQuestionAnswering = class extends DistilBertPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    DistilBertForMaskedLM = class extends DistilBertPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    EsmPreTrainedModel = class extends PreTrainedModel {},
    EsmModel = class extends EsmPreTrainedModel {},
    EsmForMaskedLM = class extends EsmPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    EsmForSequenceClassification = class extends EsmPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    EsmForTokenClassification = class extends EsmPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    MobileBertPreTrainedModel = class extends PreTrainedModel {},
    MobileBertModel = class extends MobileBertPreTrainedModel {},
    MobileBertForMaskedLM = class extends MobileBertPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    MobileBertForSequenceClassification = class extends MobileBertPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    MobileBertForQuestionAnswering = class extends MobileBertPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    MPNetPreTrainedModel = class extends PreTrainedModel {},
    MPNetModel = class extends MPNetPreTrainedModel {},
    MPNetForMaskedLM = class extends MPNetPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    MPNetForSequenceClassification = class extends MPNetPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    MPNetForTokenClassification = class extends MPNetPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    MPNetForQuestionAnswering = class extends MPNetPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    SqueezeBertPreTrainedModel = class extends PreTrainedModel {},
    SqueezeBertModel = class extends SqueezeBertPreTrainedModel {},
    SqueezeBertForMaskedLM = class extends SqueezeBertPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    SqueezeBertForSequenceClassification = class extends SqueezeBertPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    SqueezeBertForQuestionAnswering = class extends SqueezeBertPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    AlbertPreTrainedModel = class extends PreTrainedModel {},
    AlbertModel = class extends AlbertPreTrainedModel {},
    AlbertForSequenceClassification = class extends AlbertPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    AlbertForQuestionAnswering = class extends AlbertPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    AlbertForMaskedLM = class extends AlbertPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    T5PreTrainedModel = class extends PreTrainedModel {},
    T5Model = class extends T5PreTrainedModel {},
    T5ForConditionalGeneration = class extends T5PreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.num_decoder_layers),
          (this.num_decoder_heads = this.config.num_heads),
          (this.decoder_dim_kv = this.config.d_kv),
          (this.num_encoder_layers = this.config.num_layers),
          (this.num_encoder_heads = this.config.num_heads),
          (this.encoder_dim_kv = this.config.d_kv));
      }
    },
    LongT5PreTrainedModel = class extends PreTrainedModel {},
    LongT5Model = class extends LongT5PreTrainedModel {},
    LongT5ForConditionalGeneration = class extends LongT5PreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.num_decoder_layers),
          (this.num_decoder_heads = this.config.num_heads),
          (this.decoder_dim_kv = this.config.d_kv),
          (this.num_encoder_layers = this.config.num_layers),
          (this.num_encoder_heads = this.config.num_heads),
          (this.encoder_dim_kv = this.config.d_kv));
      }
    },
    MT5PreTrainedModel = class extends PreTrainedModel {},
    MT5Model = class extends MT5PreTrainedModel {},
    MT5ForConditionalGeneration = class extends MT5PreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.num_decoder_layers),
          (this.num_decoder_heads = this.config.num_heads),
          (this.decoder_dim_kv = this.config.d_kv),
          (this.num_encoder_layers = this.config.num_layers),
          (this.num_encoder_heads = this.config.num_heads),
          (this.encoder_dim_kv = this.config.d_kv));
      }
    },
    BartPretrainedModel = class extends PreTrainedModel {},
    BartModel = class extends BartPretrainedModel {},
    BartForConditionalGeneration = class extends BartPretrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.d_model / this.num_encoder_heads));
      }
    },
    BartForSequenceClassification = class extends BartPretrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    MBartPreTrainedModel = class extends PreTrainedModel {},
    MBartModel = class extends MBartPreTrainedModel {},
    MBartForConditionalGeneration = class extends MBartPreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.d_model / this.num_encoder_heads));
      }
    },
    MBartForSequenceClassification = class extends MBartPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    MBartForCausalLM = class extends MBartPreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.d_model / this.num_encoder_heads));
      }
    },
    BlenderbotPreTrainedModel = class extends PreTrainedModel {},
    BlenderbotModel = class extends BlenderbotPreTrainedModel {},
    BlenderbotForConditionalGeneration = class extends BlenderbotPreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.d_model / this.num_encoder_heads));
      }
    },
    BlenderbotSmallPreTrainedModel = class extends PreTrainedModel {},
    BlenderbotSmallModel = class extends BlenderbotSmallPreTrainedModel {},
    BlenderbotSmallForConditionalGeneration = class extends BlenderbotSmallPreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.d_model / this.num_encoder_heads));
      }
    },
    RobertaPreTrainedModel = class extends PreTrainedModel {},
    RobertaModel = class extends RobertaPreTrainedModel {},
    RobertaForMaskedLM = class extends RobertaPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    RobertaForSequenceClassification = class extends RobertaPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    RobertaForTokenClassification = class extends RobertaPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    RobertaForQuestionAnswering = class extends RobertaPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    XLMPreTrainedModel = class extends PreTrainedModel {},
    XLMModel = class extends XLMPreTrainedModel {},
    XLMWithLMHeadModel = class extends XLMPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    XLMForSequenceClassification = class extends XLMPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    XLMForTokenClassification = class extends XLMPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    XLMForQuestionAnswering = class extends XLMPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    XLMRobertaPreTrainedModel = class extends PreTrainedModel {},
    XLMRobertaModel = class extends XLMRobertaPreTrainedModel {},
    XLMRobertaForMaskedLM = class extends XLMRobertaPreTrainedModel {
      async _call(e) {
        return new MaskedLMOutput(await super._call(e));
      }
    },
    XLMRobertaForSequenceClassification = class extends XLMRobertaPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    XLMRobertaForTokenClassification = class extends XLMRobertaPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    XLMRobertaForQuestionAnswering = class extends XLMRobertaPreTrainedModel {
      async _call(e) {
        return new QuestionAnsweringModelOutput(await super._call(e));
      }
    },
    ASTPreTrainedModel = class extends PreTrainedModel {},
    ASTModel = class extends ASTPreTrainedModel {},
    ASTForAudioClassification = class extends ASTPreTrainedModel {},
    WhisperPreTrainedModel = class extends PreTrainedModel {},
    WhisperModel = class extends WhisperPreTrainedModel {},
    WhisperForConditionalGeneration = class extends WhisperPreTrainedModel {
      requires_attention_mask = !1;
      main_input_name = `input_features`;
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.d_model / this.num_encoder_heads));
      }
      async generate(e, t = null, n = null) {
        if (
          ((t = this._get_generation_config(t)),
          (t.return_timestamps ??= !1),
          t.return_timestamps && (n = [new WhisperTimeStampLogitsProcessor(t)]),
          t.return_token_timestamps &&
            ((t.output_attentions = !0),
            (t.return_dict_in_generate = !0),
            t.task === `translate` && console.warn(`Token-level timestamps may not be reliable for task 'translate'.`),
            !t.alignment_heads))
        )
          throw Error(
            'Model generation config has no `alignment_heads`, token-level timestamps not available. See https://gist.github.com/hollance/42e32852f24243b748ae6bc1f985b13a on how to add this property to the generation config.',
          );
        let r = await super.generate(e, t, n);
        return (
          t.return_token_timestamps &&
            t.alignment_heads &&
            (r.token_timestamps = this._extract_token_timestamps(r, t.alignment_heads, t.num_frames)),
          r
        );
      }
      _extract_token_timestamps(e, t, n = null, r = 0.02) {
        if (!e.cross_attentions)
          throw Error(
            'Model outputs must contain cross attentions to extract timestamps. This is most likely because the model was not exported with `output_attentions=True`.',
          );
        let i = this.config.median_filter_width;
        i === void 0 && (console.warn('Model config has no `median_filter_width`, using default value of 7.'), (i = 7));
        let a = e.cross_attentions.map((e) => {
            let r = Array.from({ length: this.config.decoder_layers }, (t, n) =>
                cat(
                  e.map((e) => e[n]),
                  2,
                ),
              ),
              a = stack(t.map(([e, t]) => (n ? r[e].slice(null, t, null, [0, n]) : r[e].slice(null, t))));
            a = a.transpose(1, 0, 2, 3);
            let [o, s] = std_mean(a, -2, 0, !0),
              c = a.clone();
            for (let e = 0; e < c.dims[0]; ++e) {
              let t = c[e];
              for (let n = 0; n < t.dims[0]; ++n) {
                let r = t[n],
                  a = o[e][n][0],
                  c = s[e][n][0];
                for (let e = 0; e < r.dims[0]; ++e) {
                  let t = r[e];
                  for (let e = 0; e < t.data.length; ++e) t.data[e] = (t.data[e] - c.data[e]) / a.data[e];
                  t.data.set(medianFilter(t.data, i));
                }
              }
            }
            return mean(c, 1);
          }),
          o = [e.sequences.length, e.sequences[0].length],
          s = new Tensor(`float32`, new Float32Array(o[0] * o[1]), o);
        for (let e = 0; e < o[0]; ++e) {
          let [t, n] = dynamicTimeWarping(a[e].neg().squeeze_(0)),
            i = mergeArrays(
              [1],
              Array.from({ length: t.length - 1 }, (e, n) => t[n + 1] - t[n]),
            ).map((e) => !!e),
            o = [];
          for (let e = 0; e < i.length; ++e) i[e] && o.push(n[e] * r);
          s[e].data.set(o, 1);
        }
        return s;
      }
    },
    VisionEncoderDecoderModel = class extends PreTrainedModel {
      main_input_name = `pixel_values`;
      constructor(e, t, n, r) {
        (super(e, t), (this.decoder_merged_session = n), (this.generation_config = r));
        let i = this.config.encoder,
          a = this.config.decoder,
          o = i.model_type;
        (MODEL_MAPPING_NAMES_ENCODER_ONLY.get(o) ?? MODEL_MAPPING_NAMES_ENCODER_DECODER.get(o)) ||
          console.warn(
            `Model type for encoder '${o}' not found, assuming encoder-only architecture. Please report this at https://github.com/xenova/transformers.js/issues/new/choose.`,
          );
        let s = MODEL_WITH_LM_HEAD_MAPPING_NAMES.get(a.model_type);
        if (!s)
          throw Error(
            `Unable to construct \`VisionEncoderDecoder\` due to unsupported decoder: "${this.config.decoder.model_type}"`,
          );
        let c = s[1],
          l = new c(a, n, r);
        ((this.add_encoder_pkv = `num_decoder_layers` in l),
          this.add_encoder_pkv
            ? ((this.num_decoder_layers = l.num_decoder_layers),
              (this.num_decoder_heads = l.num_decoder_heads),
              (this.decoder_dim_kv = l.decoder_dim_kv),
              (this.num_encoder_layers = l.num_encoder_layers),
              (this.num_encoder_heads = l.num_encoder_heads),
              (this.encoder_dim_kv = l.encoder_dim_kv))
            : ((this.num_layers = l.num_layers), (this.num_heads = l.num_heads), (this.dim_kv = l.dim_kv)));
      }
    },
    CLIPPreTrainedModel = class extends PreTrainedModel {},
    CLIPModel = class extends CLIPPreTrainedModel {},
    CLIPTextModelWithProjection = class extends CLIPPreTrainedModel {
      static async from_pretrained(e, t = {}) {
        return ((t.model_file_name ??= `text_model`), super.from_pretrained(e, t));
      }
    },
    CLIPVisionModelWithProjection = class extends CLIPPreTrainedModel {
      static async from_pretrained(e, t = {}) {
        return ((t.model_file_name ??= `vision_model`), super.from_pretrained(e, t));
      }
    },
    SiglipPreTrainedModel = class extends PreTrainedModel {},
    SiglipModel = class extends SiglipPreTrainedModel {},
    SiglipTextModel = class extends SiglipPreTrainedModel {
      static async from_pretrained(e, t = {}) {
        return ((t.model_file_name ??= `text_model`), super.from_pretrained(e, t));
      }
    },
    SiglipVisionModel = class extends CLIPPreTrainedModel {
      static async from_pretrained(e, t = {}) {
        return ((t.model_file_name ??= `vision_model`), super.from_pretrained(e, t));
      }
    },
    ChineseCLIPPreTrainedModel = class extends PreTrainedModel {},
    ChineseCLIPModel = class extends ChineseCLIPPreTrainedModel {},
    CLIPSegPreTrainedModel = class extends PreTrainedModel {},
    CLIPSegModel = class extends CLIPSegPreTrainedModel {},
    CLIPSegForImageSegmentation = class extends CLIPSegPreTrainedModel {},
    GPT2PreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.n_head),
          (this.num_layers = this.config.n_layer),
          (this.dim_kv = this.config.n_embd / this.num_heads));
      }
    },
    GPT2Model = class extends GPT2PreTrainedModel {},
    GPT2LMHeadModel = class extends GPT2PreTrainedModel {},
    GPTNeoPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_heads),
          (this.num_layers = this.config.num_layers),
          (this.dim_kv = this.config.hidden_size / this.num_heads));
      }
    },
    GPTNeoModel = class extends GPTNeoPreTrainedModel {},
    GPTNeoForCausalLM = class extends GPTNeoPreTrainedModel {},
    GPTNeoXPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_attention_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.num_heads));
      }
    },
    GPTNeoXModel = class extends GPTNeoXPreTrainedModel {},
    GPTNeoXForCausalLM = class extends GPTNeoXPreTrainedModel {},
    GPTJPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.n_head),
          (this.num_layers = this.config.n_layer),
          (this.dim_kv = this.config.n_embd / this.num_heads));
      }
    },
    GPTJModel = class extends GPTJPreTrainedModel {},
    GPTJForCausalLM = class extends GPTJPreTrainedModel {},
    GPTBigCodePreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.n_head),
          (this.num_layers = this.config.n_layer),
          (this.dim_kv = this.config.n_embd / this.num_heads));
      }
    },
    GPTBigCodeModel = class extends GPTBigCodePreTrainedModel {},
    GPTBigCodeForCausalLM = class extends GPTBigCodePreTrainedModel {},
    CodeGenPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.n_head),
          (this.num_layers = this.config.n_layer),
          (this.dim_kv = this.config.n_embd / this.num_heads));
      }
    },
    CodeGenModel = class extends CodeGenPreTrainedModel {},
    CodeGenForCausalLM = class extends CodeGenPreTrainedModel {},
    LlamaPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_key_value_heads ?? this.config.num_attention_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.config.num_attention_heads));
      }
    },
    LlamaModel = class extends LlamaPreTrainedModel {},
    LlamaForCausalLM = class extends LlamaPreTrainedModel {},
    Qwen2PreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_key_value_heads ?? this.config.num_attention_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.config.num_attention_heads));
      }
    },
    Qwen2Model = class extends Qwen2PreTrainedModel {},
    Qwen2ForCausalLM = class extends Qwen2PreTrainedModel {},
    PhiPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_attention_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.num_heads));
      }
    },
    PhiModel = class extends PhiPreTrainedModel {},
    PhiForCausalLM = class extends PhiPreTrainedModel {},
    BloomPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.n_head),
          (this.num_layers = this.config.n_layer),
          (this.dim_kv = this.config.hidden_size / this.num_heads));
      }
    },
    BloomModel = class extends BloomPreTrainedModel {},
    BloomForCausalLM = class extends BloomPreTrainedModel {},
    MptPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.n_heads),
          (this.num_layers = this.config.n_layers),
          (this.dim_kv = this.config.d_model / this.num_heads));
      }
    },
    MptModel = class extends MptPreTrainedModel {},
    MptForCausalLM = class extends MptPreTrainedModel {},
    OPTPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_attention_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.num_heads));
      }
    },
    OPTModel = class extends OPTPreTrainedModel {},
    OPTForCausalLM = class extends OPTPreTrainedModel {},
    ViTPreTrainedModel = class extends PreTrainedModel {},
    ViTModel = class extends ViTPreTrainedModel {},
    ViTForImageClassification = class extends ViTPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    FastViTPreTrainedModel = class extends PreTrainedModel {},
    FastViTModel = class extends FastViTPreTrainedModel {},
    FastViTForImageClassification = class extends FastViTPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    VitMattePreTrainedModel = class extends PreTrainedModel {},
    VitMatteForImageMatting = class extends VitMattePreTrainedModel {
      async _call(e) {
        return new ImageMattingOutput(await super._call(e));
      }
    },
    MobileViTPreTrainedModel = class extends PreTrainedModel {},
    MobileViTModel = class extends MobileViTPreTrainedModel {},
    MobileViTForImageClassification = class extends MobileViTPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    MobileViTV2PreTrainedModel = class extends PreTrainedModel {},
    MobileViTV2Model = class extends MobileViTV2PreTrainedModel {},
    MobileViTV2ForImageClassification = class extends MobileViTV2PreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    OwlViTPreTrainedModel = class extends PreTrainedModel {},
    OwlViTModel = class extends OwlViTPreTrainedModel {},
    OwlViTForObjectDetection = class extends OwlViTPreTrainedModel {},
    Owlv2PreTrainedModel = class extends PreTrainedModel {},
    Owlv2Model = class extends Owlv2PreTrainedModel {},
    Owlv2ForObjectDetection = class extends Owlv2PreTrainedModel {},
    BeitPreTrainedModel = class extends PreTrainedModel {},
    BeitModel = class extends BeitPreTrainedModel {},
    BeitForImageClassification = class extends BeitPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    DetrPreTrainedModel = class extends PreTrainedModel {},
    DetrModel = class extends DetrPreTrainedModel {},
    DetrForObjectDetection = class extends DetrPreTrainedModel {
      async _call(e) {
        return new DetrObjectDetectionOutput(await super._call(e));
      }
    },
    DetrForSegmentation = class extends DetrPreTrainedModel {
      async _call(e) {
        return new DetrSegmentationOutput(await super._call(e));
      }
    },
    DetrObjectDetectionOutput = class extends ModelOutput {
      constructor({ logits: e, pred_boxes: t }) {
        (super(), (this.logits = e), (this.pred_boxes = t));
      }
    },
    DetrSegmentationOutput = class extends ModelOutput {
      constructor({ logits: e, pred_boxes: t, pred_masks: n }) {
        (super(), (this.logits = e), (this.pred_boxes = t), (this.pred_masks = n));
      }
    },
    TableTransformerPreTrainedModel = class extends PreTrainedModel {},
    TableTransformerModel = class extends TableTransformerPreTrainedModel {},
    TableTransformerForObjectDetection = class extends TableTransformerPreTrainedModel {
      async _call(e) {
        return new TableTransformerObjectDetectionOutput(await super._call(e));
      }
    },
    TableTransformerObjectDetectionOutput = class extends DetrObjectDetectionOutput {},
    DeiTPreTrainedModel = class extends PreTrainedModel {},
    DeiTModel = class extends DeiTPreTrainedModel {},
    DeiTForImageClassification = class extends DeiTPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    ResNetPreTrainedModel = class extends PreTrainedModel {},
    ResNetModel = class extends ResNetPreTrainedModel {},
    ResNetForImageClassification = class extends ResNetPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    SwinPreTrainedModel = class extends PreTrainedModel {},
    SwinModel = class extends SwinPreTrainedModel {},
    SwinForImageClassification = class extends SwinPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    Swin2SRPreTrainedModel = class extends PreTrainedModel {},
    Swin2SRModel = class extends Swin2SRPreTrainedModel {},
    Swin2SRForImageSuperResolution = class extends Swin2SRPreTrainedModel {},
    DPTPreTrainedModel = class extends PreTrainedModel {},
    DPTModel = class extends DPTPreTrainedModel {},
    DPTForDepthEstimation = class extends DPTPreTrainedModel {},
    DepthAnythingPreTrainedModel = class extends PreTrainedModel {},
    DepthAnythingForDepthEstimation = class extends DepthAnythingPreTrainedModel {},
    GLPNPreTrainedModel = class extends PreTrainedModel {},
    GLPNModel = class extends GLPNPreTrainedModel {},
    GLPNForDepthEstimation = class extends GLPNPreTrainedModel {},
    DonutSwinPreTrainedModel = class extends PreTrainedModel {},
    DonutSwinModel = class extends DonutSwinPreTrainedModel {},
    ConvNextPreTrainedModel = class extends PreTrainedModel {},
    ConvNextModel = class extends ConvNextPreTrainedModel {},
    ConvNextForImageClassification = class extends ConvNextPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    ConvNextV2PreTrainedModel = class extends PreTrainedModel {},
    ConvNextV2Model = class extends ConvNextV2PreTrainedModel {},
    ConvNextV2ForImageClassification = class extends ConvNextV2PreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    Dinov2PreTrainedModel = class extends PreTrainedModel {},
    Dinov2Model = class extends Dinov2PreTrainedModel {},
    Dinov2ForImageClassification = class extends Dinov2PreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    YolosPreTrainedModel = class extends PreTrainedModel {},
    YolosModel = class extends YolosPreTrainedModel {},
    YolosForObjectDetection = class extends YolosPreTrainedModel {
      async _call(e) {
        return new YolosObjectDetectionOutput(await super._call(e));
      }
    },
    YolosObjectDetectionOutput = class extends ModelOutput {
      constructor({ logits: e, pred_boxes: t }) {
        (super(), (this.logits = e), (this.pred_boxes = t));
      }
    },
    SamPreTrainedModel = class extends PreTrainedModel {},
    SamModel = class extends SamPreTrainedModel {
      constructor(e, t, n) {
        (super(e, t), (this.prompt_encoder_mask_decoder = n));
      }
      async get_image_embeddings({ pixel_values: e }) {
        return await encoderForward(this, { pixel_values: e });
      }
      async forward(e) {
        if (
          ((!e.image_embeddings || !e.image_positional_embeddings) &&
            (e = { ...e, ...(await this.get_image_embeddings(e)) }),
          !e.input_labels)
        ) {
          let t = e.input_points.dims.slice(0, -1),
            n = t.reduce((e, t) => e * t, 1);
          e.input_labels = new Tensor(`int64`, new BigInt64Array(n).fill(1n), t);
        }
        return await sessionRun(this.prompt_encoder_mask_decoder, {
          input_points: e.input_points,
          input_labels: e.input_labels,
          image_embeddings: e.image_embeddings,
          image_positional_embeddings: e.image_positional_embeddings,
        });
      }
      async _call(e) {
        return new SamImageSegmentationOutput(await super._call(e));
      }
    },
    SamImageSegmentationOutput = class extends ModelOutput {
      constructor({ iou_scores: e, pred_masks: t }) {
        (super(), (this.iou_scores = e), (this.pred_masks = t));
      }
    },
    MarianPreTrainedModel = class extends PreTrainedModel {},
    MarianModel = class extends MarianPreTrainedModel {},
    MarianMTModel = class extends MarianPreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.d_model / this.num_encoder_heads));
      }
    },
    M2M100PreTrainedModel = class extends PreTrainedModel {},
    M2M100Model = class extends M2M100PreTrainedModel {},
    M2M100ForConditionalGeneration = class extends M2M100PreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.d_model / this.num_encoder_heads));
      }
    },
    Wav2Vec2PreTrainedModel = class extends PreTrainedModel {},
    Wav2Vec2Model = class extends Wav2Vec2PreTrainedModel {},
    Wav2Vec2ForCTC = class extends Wav2Vec2PreTrainedModel {
      async _call(e) {
        return new CausalLMOutput(await super._call(e));
      }
    },
    Wav2Vec2ForSequenceClassification = class extends Wav2Vec2PreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    Wav2Vec2ForAudioFrameClassification = class extends Wav2Vec2PreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    UniSpeechPreTrainedModel = class extends PreTrainedModel {},
    UniSpeechModel = class extends UniSpeechPreTrainedModel {},
    UniSpeechForCTC = class extends UniSpeechPreTrainedModel {
      async _call(e) {
        return new CausalLMOutput(await super._call(e));
      }
    },
    UniSpeechForSequenceClassification = class extends UniSpeechPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    UniSpeechSatPreTrainedModel = class extends PreTrainedModel {},
    UniSpeechSatModel = class extends UniSpeechSatPreTrainedModel {},
    UniSpeechSatForCTC = class extends UniSpeechSatPreTrainedModel {
      async _call(e) {
        return new CausalLMOutput(await super._call(e));
      }
    },
    UniSpeechSatForSequenceClassification = class extends UniSpeechSatPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    UniSpeechSatForAudioFrameClassification = class extends UniSpeechSatPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    Wav2Vec2BertPreTrainedModel = class extends PreTrainedModel {},
    Wav2Vec2BertModel = class extends Wav2Vec2BertPreTrainedModel {},
    Wav2Vec2BertForCTC = class extends Wav2Vec2BertPreTrainedModel {
      async _call(e) {
        return new CausalLMOutput(await super._call(e));
      }
    },
    Wav2Vec2BertForSequenceClassification = class extends Wav2Vec2BertPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    HubertModel = class extends Wav2Vec2PreTrainedModel {},
    HubertForCTC = class extends Wav2Vec2PreTrainedModel {
      async _call(e) {
        return new CausalLMOutput(await super._call(e));
      }
    },
    HubertForSequenceClassification = class extends Wav2Vec2PreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    WavLMPreTrainedModel = class extends PreTrainedModel {},
    WavLMModel = class extends WavLMPreTrainedModel {},
    WavLMForCTC = class extends WavLMPreTrainedModel {
      async _call(e) {
        return new CausalLMOutput(await super._call(e));
      }
    },
    WavLMForSequenceClassification = class extends WavLMPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    WavLMForXVector = class extends WavLMPreTrainedModel {
      async _call(e) {
        return new XVectorOutput(await super._call(e));
      }
    },
    WavLMForAudioFrameClassification = class extends WavLMPreTrainedModel {
      async _call(e) {
        return new TokenClassifierOutput(await super._call(e));
      }
    },
    SpeechT5PreTrainedModel = class extends PreTrainedModel {},
    SpeechT5ForSpeechToText = class extends SpeechT5PreTrainedModel {},
    SpeechT5ForTextToSpeech = class extends SpeechT5PreTrainedModel {
      constructor(e, t, n, r) {
        (super(e, t),
          (this.decoder_merged_session = n),
          (this.generation_config = r),
          (this.num_decoder_layers = this.config.decoder_layers),
          (this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.decoder_dim_kv = this.config.hidden_size / this.num_decoder_heads),
          (this.num_encoder_layers = this.config.encoder_layers),
          (this.num_encoder_heads = this.config.encoder_attention_heads),
          (this.encoder_dim_kv = this.config.hidden_size / this.num_encoder_heads));
      }
      async generate_speech(
        e,
        t,
        { threshold: n = 0.5, minlenratio: r = 0, maxlenratio: i = 20, vocoder: a = null } = {},
      ) {
        let o = { input_ids: e },
          { encoder_outputs: s, encoder_attention_mask: c } = await encoderForward(this, o),
          l = s.dims[1] / this.config.reduction_factor,
          u = Math.floor(l * i),
          d = Math.floor(l * r),
          f = this.config.num_mel_bins,
          p = [],
          m = null,
          h = null,
          g = 0;
        for (;;) {
          ++g;
          let e = boolTensor(!!h),
            r;
          r = h ? h.output_sequence_out : new Tensor(`float32`, new Float32Array(f), [1, 1, f]);
          let i = {
            use_cache_branch: e,
            output_sequence: r,
            encoder_attention_mask: c,
            speaker_embeddings: t,
            encoder_hidden_states: s,
          };
          (this.addPastKeyValues(i, m),
            (h = await sessionRun(this.decoder_merged_session, i)),
            (m = this.getPastKeyValues(h, m)));
          let { prob: a, spectrum: o } = h;
          if ((p.push(o), g >= d && (Array.from(a.data).filter((e) => e >= n).length > 0 || g >= u))) break;
        }
        let _ = cat(p),
          { waveform: v } = await sessionRun(a.session, { spectrogram: _ });
        return { spectrogram: _, waveform: v };
      }
    },
    SpeechT5HifiGan = class extends PreTrainedModel {
      main_input_name = `spectrogram`;
    },
    TrOCRPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_encoder_layers = this.num_decoder_layers = this.config.decoder_layers),
          (this.num_encoder_heads = this.num_decoder_heads = this.config.decoder_attention_heads),
          (this.encoder_dim_kv = this.decoder_dim_kv = this.config.d_model / this.num_decoder_heads));
      }
    },
    TrOCRForCausalLM = class extends TrOCRPreTrainedModel {},
    MistralPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_key_value_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.config.num_attention_heads));
      }
    },
    MistralModel = class extends MistralPreTrainedModel {},
    MistralForCausalLM = class extends MistralPreTrainedModel {},
    Starcoder2PreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_key_value_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.config.num_attention_heads));
      }
    },
    Starcoder2Model = class extends Starcoder2PreTrainedModel {},
    Starcoder2ForCausalLM = class extends Starcoder2PreTrainedModel {},
    FalconPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_attention_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.config.num_attention_heads));
      }
    },
    FalconModel = class extends FalconPreTrainedModel {},
    FalconForCausalLM = class extends FalconPreTrainedModel {},
    ClapPreTrainedModel = class extends PreTrainedModel {},
    ClapModel = class extends ClapPreTrainedModel {},
    ClapTextModelWithProjection = class extends ClapPreTrainedModel {
      static async from_pretrained(e, t = {}) {
        return ((t.model_file_name ??= `text_model`), super.from_pretrained(e, t));
      }
    },
    ClapAudioModelWithProjection = class extends ClapPreTrainedModel {
      static async from_pretrained(e, t = {}) {
        return ((t.model_file_name ??= `audio_model`), super.from_pretrained(e, t));
      }
    },
    VitsPreTrainedModel = class extends PreTrainedModel {},
    VitsModel = class extends VitsPreTrainedModel {
      async _call(e) {
        return new VitsModelOutput(await super._call(e));
      }
    },
    SegformerPreTrainedModel = class extends PreTrainedModel {},
    SegformerForImageClassification = class extends SegformerPreTrainedModel {},
    SegformerForSemanticSegmentation = class extends SegformerPreTrainedModel {},
    StableLmPreTrainedModel = class extends PreTrainedModel {
      constructor(e, t, n) {
        (super(e, t),
          (this.generation_config = n),
          (this.config.pad_token_id = this.config.eos_token_id),
          (this.num_heads = this.config.num_attention_heads),
          (this.num_layers = this.config.num_hidden_layers),
          (this.dim_kv = this.config.hidden_size / this.num_heads));
      }
    },
    StableLmForCausalLM = class extends StableLmPreTrainedModel {},
    EfficientNetPreTrainedModel = class extends PreTrainedModel {},
    EfficientNetModel = class extends EfficientNetPreTrainedModel {},
    EfficientNetForImageClassification = class extends EfficientNetPreTrainedModel {
      async _call(e) {
        return new SequenceClassifierOutput(await super._call(e));
      }
    },
    PretrainedMixin = class {
      static MODEL_CLASS_MAPPINGS = null;
      static BASE_IF_FAIL = !1;
      static async from_pretrained(
        e,
        {
          quantized: t = !0,
          progress_callback: n = null,
          config: r = null,
          cache_dir: i = null,
          local_files_only: a = !1,
          revision: o = `main`,
          model_file_name: s = null,
        } = {},
      ) {
        let c = {
          quantized: t,
          progress_callback: n,
          config: r,
          cache_dir: i,
          local_files_only: a,
          revision: o,
          model_file_name: s,
        };
        if (((r = await AutoConfig.from_pretrained(e, c)), (c.config ||= r), !this.MODEL_CLASS_MAPPINGS))
          throw Error('`MODEL_CLASS_MAPPINGS` not implemented for this type of `AutoClass`: ' + this.name);
        for (let t of this.MODEL_CLASS_MAPPINGS) {
          let n = t.get(r.model_type);
          if (n) return await n[1].from_pretrained(e, c);
        }
        if (this.BASE_IF_FAIL)
          return (
            console.warn(`Unknown model class "${r.model_type}", attempting to construct from base class.`),
            await PreTrainedModel.from_pretrained(e, c)
          );
        throw Error(`Unsupported model type: ${r.model_type}`);
      }
    };
  const MODEL_MAPPING_NAMES_ENCODER_ONLY = new Map([
      [`bert`, [`BertModel`, BertModel]],
      [`nomic_bert`, [`NomicBertModel`, NomicBertModel]],
      [`roformer`, [`RoFormerModel`, RoFormerModel]],
      [`electra`, [`ElectraModel`, ElectraModel]],
      [`esm`, [`EsmModel`, EsmModel]],
      [`convbert`, [`ConvBertModel`, ConvBertModel]],
      [`camembert`, [`CamembertModel`, CamembertModel]],
      [`deberta`, [`DebertaModel`, DebertaModel]],
      [`deberta-v2`, [`DebertaV2Model`, DebertaV2Model]],
      [`mpnet`, [`MPNetModel`, MPNetModel]],
      [`albert`, [`AlbertModel`, AlbertModel]],
      [`distilbert`, [`DistilBertModel`, DistilBertModel]],
      [`roberta`, [`RobertaModel`, RobertaModel]],
      [`xlm`, [`XLMModel`, XLMModel]],
      [`xlm-roberta`, [`XLMRobertaModel`, XLMRobertaModel]],
      [`clap`, [`ClapModel`, ClapModel]],
      [`clip`, [`CLIPModel`, CLIPModel]],
      [`clipseg`, [`CLIPSegModel`, CLIPSegModel]],
      [`chinese_clip`, [`ChineseCLIPModel`, ChineseCLIPModel]],
      [`siglip`, [`SiglipModel`, SiglipModel]],
      [`mobilebert`, [`MobileBertModel`, MobileBertModel]],
      [`squeezebert`, [`SqueezeBertModel`, SqueezeBertModel]],
      [`wav2vec2`, [`Wav2Vec2Model`, Wav2Vec2Model]],
      [`wav2vec2-bert`, [`Wav2Vec2BertModel`, Wav2Vec2BertModel]],
      [`unispeech`, [`UniSpeechModel`, UniSpeechModel]],
      [`unispeech-sat`, [`UniSpeechSatModel`, UniSpeechSatModel]],
      [`hubert`, [`HubertModel`, HubertModel]],
      [`wavlm`, [`WavLMModel`, WavLMModel]],
      [`audio-spectrogram-transformer`, [`ASTModel`, ASTModel]],
      [`vits`, [`VitsModel`, VitsModel]],
      [`detr`, [`DetrModel`, DetrModel]],
      [`table-transformer`, [`TableTransformerModel`, TableTransformerModel]],
      [`vit`, [`ViTModel`, ViTModel]],
      [`fastvit`, [`FastViTModel`, FastViTModel]],
      [`mobilevit`, [`MobileViTModel`, MobileViTModel]],
      [`mobilevitv2`, [`MobileViTV2Model`, MobileViTV2Model]],
      [`owlvit`, [`OwlViTModel`, OwlViTModel]],
      [`owlv2`, [`Owlv2Model`, Owlv2Model]],
      [`beit`, [`BeitModel`, BeitModel]],
      [`deit`, [`DeiTModel`, DeiTModel]],
      [`convnext`, [`ConvNextModel`, ConvNextModel]],
      [`convnextv2`, [`ConvNextV2Model`, ConvNextV2Model]],
      [`dinov2`, [`Dinov2Model`, Dinov2Model]],
      [`resnet`, [`ResNetModel`, ResNetModel]],
      [`swin`, [`SwinModel`, SwinModel]],
      [`swin2sr`, [`Swin2SRModel`, Swin2SRModel]],
      [`donut-swin`, [`DonutSwinModel`, DonutSwinModel]],
      [`yolos`, [`YolosModel`, YolosModel]],
      [`dpt`, [`DPTModel`, DPTModel]],
      [`glpn`, [`GLPNModel`, GLPNModel]],
      [`hifigan`, [`SpeechT5HifiGan`, SpeechT5HifiGan]],
      [`efficientnet`, [`EfficientNetModel`, EfficientNetModel]],
    ]),
    MODEL_MAPPING_NAMES_ENCODER_DECODER = new Map([
      [`t5`, [`T5Model`, T5Model]],
      [`longt5`, [`LongT5Model`, LongT5Model]],
      [`mt5`, [`MT5Model`, MT5Model]],
      [`bart`, [`BartModel`, BartModel]],
      [`mbart`, [`MBartModel`, MBartModel]],
      [`marian`, [`MarianModel`, MarianModel]],
      [`whisper`, [`WhisperModel`, WhisperModel]],
      [`m2m_100`, [`M2M100Model`, M2M100Model]],
      [`blenderbot`, [`BlenderbotModel`, BlenderbotModel]],
      [`blenderbot-small`, [`BlenderbotSmallModel`, BlenderbotSmallModel]],
    ]),
    MODEL_MAPPING_NAMES_DECODER_ONLY = new Map([
      [`bloom`, [`BloomModel`, BloomModel]],
      [`gpt2`, [`GPT2Model`, GPT2Model]],
      [`gptj`, [`GPTJModel`, GPTJModel]],
      [`gpt_bigcode`, [`GPTBigCodeModel`, GPTBigCodeModel]],
      [`gpt_neo`, [`GPTNeoModel`, GPTNeoModel]],
      [`gpt_neox`, [`GPTNeoXModel`, GPTNeoXModel]],
      [`codegen`, [`CodeGenModel`, CodeGenModel]],
      [`llama`, [`LlamaModel`, LlamaModel]],
      [`qwen2`, [`Qwen2Model`, Qwen2Model]],
      [`phi`, [`PhiModel`, PhiModel]],
      [`mpt`, [`MptModel`, MptModel]],
      [`opt`, [`OPTModel`, OPTModel]],
      [`mistral`, [`MistralModel`, MistralModel]],
      [`starcoder2`, [`Starcoder2Model`, Starcoder2Model]],
      [`falcon`, [`FalconModel`, FalconModel]],
    ]),
    MODEL_FOR_SPEECH_SEQ_2_SEQ_MAPPING_NAMES = new Map([
      [`speecht5`, [`SpeechT5ForSpeechToText`, SpeechT5ForSpeechToText]],
      [`whisper`, [`WhisperForConditionalGeneration`, WhisperForConditionalGeneration]],
    ]),
    MODEL_FOR_TEXT_TO_SPECTROGRAM_MAPPING_NAMES = new Map([
      [`speecht5`, [`SpeechT5ForTextToSpeech`, SpeechT5ForTextToSpeech]],
    ]),
    MODEL_FOR_TEXT_TO_WAVEFORM_MAPPING_NAMES = new Map([[`vits`, [`VitsModel`, VitsModel]]]),
    MODEL_FOR_SEQUENCE_CLASSIFICATION_MAPPING_NAMES = new Map([
      [`bert`, [`BertForSequenceClassification`, BertForSequenceClassification]],
      [`roformer`, [`RoFormerForSequenceClassification`, RoFormerForSequenceClassification]],
      [`electra`, [`ElectraForSequenceClassification`, ElectraForSequenceClassification]],
      [`esm`, [`EsmForSequenceClassification`, EsmForSequenceClassification]],
      [`convbert`, [`ConvBertForSequenceClassification`, ConvBertForSequenceClassification]],
      [`camembert`, [`CamembertForSequenceClassification`, CamembertForSequenceClassification]],
      [`deberta`, [`DebertaForSequenceClassification`, DebertaForSequenceClassification]],
      [`deberta-v2`, [`DebertaV2ForSequenceClassification`, DebertaV2ForSequenceClassification]],
      [`mpnet`, [`MPNetForSequenceClassification`, MPNetForSequenceClassification]],
      [`albert`, [`AlbertForSequenceClassification`, AlbertForSequenceClassification]],
      [`distilbert`, [`DistilBertForSequenceClassification`, DistilBertForSequenceClassification]],
      [`roberta`, [`RobertaForSequenceClassification`, RobertaForSequenceClassification]],
      [`xlm`, [`XLMForSequenceClassification`, XLMForSequenceClassification]],
      [`xlm-roberta`, [`XLMRobertaForSequenceClassification`, XLMRobertaForSequenceClassification]],
      [`bart`, [`BartForSequenceClassification`, BartForSequenceClassification]],
      [`mbart`, [`MBartForSequenceClassification`, MBartForSequenceClassification]],
      [`mobilebert`, [`MobileBertForSequenceClassification`, MobileBertForSequenceClassification]],
      [`squeezebert`, [`SqueezeBertForSequenceClassification`, SqueezeBertForSequenceClassification]],
    ]),
    MODEL_FOR_TOKEN_CLASSIFICATION_MAPPING_NAMES = new Map([
      [`bert`, [`BertForTokenClassification`, BertForTokenClassification]],
      [`roformer`, [`RoFormerForTokenClassification`, RoFormerForTokenClassification]],
      [`electra`, [`ElectraForTokenClassification`, ElectraForTokenClassification]],
      [`esm`, [`EsmForTokenClassification`, EsmForTokenClassification]],
      [`convbert`, [`ConvBertForTokenClassification`, ConvBertForTokenClassification]],
      [`camembert`, [`CamembertForTokenClassification`, CamembertForTokenClassification]],
      [`deberta`, [`DebertaForTokenClassification`, DebertaForTokenClassification]],
      [`deberta-v2`, [`DebertaV2ForTokenClassification`, DebertaV2ForTokenClassification]],
      [`mpnet`, [`MPNetForTokenClassification`, MPNetForTokenClassification]],
      [`distilbert`, [`DistilBertForTokenClassification`, DistilBertForTokenClassification]],
      [`roberta`, [`RobertaForTokenClassification`, RobertaForTokenClassification]],
      [`xlm`, [`XLMForTokenClassification`, XLMForTokenClassification]],
      [`xlm-roberta`, [`XLMRobertaForTokenClassification`, XLMRobertaForTokenClassification]],
    ]),
    MODEL_FOR_SEQ_TO_SEQ_CAUSAL_LM_MAPPING_NAMES = new Map([
      [`t5`, [`T5ForConditionalGeneration`, T5ForConditionalGeneration]],
      [`longt5`, [`LongT5ForConditionalGeneration`, LongT5ForConditionalGeneration]],
      [`mt5`, [`MT5ForConditionalGeneration`, MT5ForConditionalGeneration]],
      [`bart`, [`BartForConditionalGeneration`, BartForConditionalGeneration]],
      [`mbart`, [`MBartForConditionalGeneration`, MBartForConditionalGeneration]],
      [`marian`, [`MarianMTModel`, MarianMTModel]],
      [`m2m_100`, [`M2M100ForConditionalGeneration`, M2M100ForConditionalGeneration]],
      [`blenderbot`, [`BlenderbotForConditionalGeneration`, BlenderbotForConditionalGeneration]],
      [`blenderbot-small`, [`BlenderbotSmallForConditionalGeneration`, BlenderbotSmallForConditionalGeneration]],
    ]),
    MODEL_WITH_LM_HEAD_MAPPING_NAMES = new Map([
      [`bloom`, [`BloomForCausalLM`, BloomForCausalLM]],
      [`gpt2`, [`GPT2LMHeadModel`, GPT2LMHeadModel]],
      [`gptj`, [`GPTJForCausalLM`, GPTJForCausalLM]],
      [`gpt_bigcode`, [`GPTBigCodeForCausalLM`, GPTBigCodeForCausalLM]],
      [`gpt_neo`, [`GPTNeoForCausalLM`, GPTNeoForCausalLM]],
      [`gpt_neox`, [`GPTNeoXForCausalLM`, GPTNeoXForCausalLM]],
      [`codegen`, [`CodeGenForCausalLM`, CodeGenForCausalLM]],
      [`llama`, [`LlamaForCausalLM`, LlamaForCausalLM]],
      [`qwen2`, [`Qwen2ForCausalLM`, Qwen2ForCausalLM]],
      [`phi`, [`PhiForCausalLM`, PhiForCausalLM]],
      [`mpt`, [`MptForCausalLM`, MptForCausalLM]],
      [`opt`, [`OPTForCausalLM`, OPTForCausalLM]],
      [`mbart`, [`MBartForCausalLM`, MBartForCausalLM]],
      [`mistral`, [`MistralForCausalLM`, MistralForCausalLM]],
      [`starcoder2`, [`Starcoder2ForCausalLM`, Starcoder2ForCausalLM]],
      [`falcon`, [`FalconForCausalLM`, FalconForCausalLM]],
      [`trocr`, [`TrOCRForCausalLM`, TrOCRForCausalLM]],
      [`stablelm`, [`StableLmForCausalLM`, StableLmForCausalLM]],
    ]),
    MODEL_FOR_MASKED_LM_MAPPING_NAMES = new Map([
      [`bert`, [`BertForMaskedLM`, BertForMaskedLM]],
      [`roformer`, [`RoFormerForMaskedLM`, RoFormerForMaskedLM]],
      [`electra`, [`ElectraForMaskedLM`, ElectraForMaskedLM]],
      [`esm`, [`EsmForMaskedLM`, EsmForMaskedLM]],
      [`convbert`, [`ConvBertForMaskedLM`, ConvBertForMaskedLM]],
      [`camembert`, [`CamembertForMaskedLM`, CamembertForMaskedLM]],
      [`deberta`, [`DebertaForMaskedLM`, DebertaForMaskedLM]],
      [`deberta-v2`, [`DebertaV2ForMaskedLM`, DebertaV2ForMaskedLM]],
      [`mpnet`, [`MPNetForMaskedLM`, MPNetForMaskedLM]],
      [`albert`, [`AlbertForMaskedLM`, AlbertForMaskedLM]],
      [`distilbert`, [`DistilBertForMaskedLM`, DistilBertForMaskedLM]],
      [`roberta`, [`RobertaForMaskedLM`, RobertaForMaskedLM]],
      [`xlm`, [`XLMWithLMHeadModel`, XLMWithLMHeadModel]],
      [`xlm-roberta`, [`XLMRobertaForMaskedLM`, XLMRobertaForMaskedLM]],
      [`mobilebert`, [`MobileBertForMaskedLM`, MobileBertForMaskedLM]],
      [`squeezebert`, [`SqueezeBertForMaskedLM`, SqueezeBertForMaskedLM]],
    ]),
    MODEL_FOR_QUESTION_ANSWERING_MAPPING_NAMES = new Map([
      [`bert`, [`BertForQuestionAnswering`, BertForQuestionAnswering]],
      [`roformer`, [`RoFormerForQuestionAnswering`, RoFormerForQuestionAnswering]],
      [`electra`, [`ElectraForQuestionAnswering`, ElectraForQuestionAnswering]],
      [`convbert`, [`ConvBertForQuestionAnswering`, ConvBertForQuestionAnswering]],
      [`camembert`, [`CamembertForQuestionAnswering`, CamembertForQuestionAnswering]],
      [`deberta`, [`DebertaForQuestionAnswering`, DebertaForQuestionAnswering]],
      [`deberta-v2`, [`DebertaV2ForQuestionAnswering`, DebertaV2ForQuestionAnswering]],
      [`mpnet`, [`MPNetForQuestionAnswering`, MPNetForQuestionAnswering]],
      [`albert`, [`AlbertForQuestionAnswering`, AlbertForQuestionAnswering]],
      [`distilbert`, [`DistilBertForQuestionAnswering`, DistilBertForQuestionAnswering]],
      [`roberta`, [`RobertaForQuestionAnswering`, RobertaForQuestionAnswering]],
      [`xlm`, [`XLMForQuestionAnswering`, XLMForQuestionAnswering]],
      [`xlm-roberta`, [`XLMRobertaForQuestionAnswering`, XLMRobertaForQuestionAnswering]],
      [`mobilebert`, [`MobileBertForQuestionAnswering`, MobileBertForQuestionAnswering]],
      [`squeezebert`, [`SqueezeBertForQuestionAnswering`, SqueezeBertForQuestionAnswering]],
    ]),
    MODEL_FOR_VISION_2_SEQ_MAPPING_NAMES = new Map([
      [`vision-encoder-decoder`, [`VisionEncoderDecoderModel`, VisionEncoderDecoderModel]],
    ]),
    MODEL_FOR_DOCUMENT_QUESTION_ANSWERING_MAPPING_NAMES = new Map([
      [`vision-encoder-decoder`, [`VisionEncoderDecoderModel`, VisionEncoderDecoderModel]],
    ]),
    MODEL_FOR_IMAGE_CLASSIFICATION_MAPPING_NAMES = new Map([
      [`vit`, [`ViTForImageClassification`, ViTForImageClassification]],
      [`fastvit`, [`FastViTForImageClassification`, FastViTForImageClassification]],
      [`mobilevit`, [`MobileViTForImageClassification`, MobileViTForImageClassification]],
      [`mobilevitv2`, [`MobileViTV2ForImageClassification`, MobileViTV2ForImageClassification]],
      [`beit`, [`BeitForImageClassification`, BeitForImageClassification]],
      [`deit`, [`DeiTForImageClassification`, DeiTForImageClassification]],
      [`convnext`, [`ConvNextForImageClassification`, ConvNextForImageClassification]],
      [`convnextv2`, [`ConvNextV2ForImageClassification`, ConvNextV2ForImageClassification]],
      [`dinov2`, [`Dinov2ForImageClassification`, Dinov2ForImageClassification]],
      [`resnet`, [`ResNetForImageClassification`, ResNetForImageClassification]],
      [`swin`, [`SwinForImageClassification`, SwinForImageClassification]],
      [`segformer`, [`SegformerForImageClassification`, SegformerForImageClassification]],
      [`efficientnet`, [`EfficientNetForImageClassification`, EfficientNetForImageClassification]],
    ]),
    MODEL_FOR_OBJECT_DETECTION_MAPPING_NAMES = new Map([
      [`detr`, [`DetrForObjectDetection`, DetrForObjectDetection]],
      [`table-transformer`, [`TableTransformerForObjectDetection`, TableTransformerForObjectDetection]],
      [`yolos`, [`YolosForObjectDetection`, YolosForObjectDetection]],
    ]),
    MODEL_FOR_ZERO_SHOT_OBJECT_DETECTION_MAPPING_NAMES = new Map([
      [`owlvit`, [`OwlViTForObjectDetection`, OwlViTForObjectDetection]],
      [`owlv2`, [`Owlv2ForObjectDetection`, Owlv2ForObjectDetection]],
    ]),
    MODEL_FOR_IMAGE_SEGMENTATION_MAPPING_NAMES = new Map([
      [`detr`, [`DetrForSegmentation`, DetrForSegmentation]],
      [`clipseg`, [`CLIPSegForImageSegmentation`, CLIPSegForImageSegmentation]],
    ]),
    MODEL_FOR_SEMANTIC_SEGMENTATION_MAPPING_NAMES = new Map([
      [`segformer`, [`SegformerForSemanticSegmentation`, SegformerForSemanticSegmentation]],
    ]),
    MODEL_FOR_MASK_GENERATION_MAPPING_NAMES = new Map([[`sam`, [`SamModel`, SamModel]]]),
    MODEL_FOR_CTC_MAPPING_NAMES = new Map([
      [`wav2vec2`, [`Wav2Vec2ForCTC`, Wav2Vec2ForCTC]],
      [`wav2vec2-bert`, [`Wav2Vec2BertForCTC`, Wav2Vec2BertForCTC]],
      [`unispeech`, [`UniSpeechForCTC`, UniSpeechForCTC]],
      [`unispeech-sat`, [`UniSpeechSatForCTC`, UniSpeechSatForCTC]],
      [`wavlm`, [`WavLMForCTC`, WavLMForCTC]],
      [`hubert`, [`HubertForCTC`, HubertForCTC]],
    ]),
    MODEL_FOR_AUDIO_CLASSIFICATION_MAPPING_NAMES = new Map([
      [`wav2vec2`, [`Wav2Vec2ForSequenceClassification`, Wav2Vec2ForSequenceClassification]],
      [`wav2vec2-bert`, [`Wav2Vec2BertForSequenceClassification`, Wav2Vec2BertForSequenceClassification]],
      [`unispeech`, [`UniSpeechForSequenceClassification`, UniSpeechForSequenceClassification]],
      [`unispeech-sat`, [`UniSpeechSatForSequenceClassification`, UniSpeechSatForSequenceClassification]],
      [`wavlm`, [`WavLMForSequenceClassification`, WavLMForSequenceClassification]],
      [`hubert`, [`HubertForSequenceClassification`, HubertForSequenceClassification]],
      [`audio-spectrogram-transformer`, [`ASTForAudioClassification`, ASTForAudioClassification]],
    ]),
    MODEL_FOR_AUDIO_XVECTOR_MAPPING_NAMES = new Map([[`wavlm`, [`WavLMForXVector`, WavLMForXVector]]]),
    MODEL_FOR_AUDIO_FRAME_CLASSIFICATION_MAPPING_NAMES = new Map([
      [`unispeech-sat`, [`UniSpeechSatForAudioFrameClassification`, UniSpeechSatForAudioFrameClassification]],
      [`wavlm`, [`WavLMForAudioFrameClassification`, WavLMForAudioFrameClassification]],
      [`wav2vec2`, [`Wav2Vec2ForAudioFrameClassification`, Wav2Vec2ForAudioFrameClassification]],
    ]),
    MODEL_FOR_IMAGE_MATTING_MAPPING_NAMES = new Map([
      [`vitmatte`, [`VitMatteForImageMatting`, VitMatteForImageMatting]],
    ]),
    MODEL_FOR_IMAGE_TO_IMAGE_MAPPING_NAMES = new Map([
      [`swin2sr`, [`Swin2SRForImageSuperResolution`, Swin2SRForImageSuperResolution]],
    ]),
    MODEL_FOR_DEPTH_ESTIMATION_MAPPING_NAMES = new Map([
      [`dpt`, [`DPTForDepthEstimation`, DPTForDepthEstimation]],
      [`depth_anything`, [`DepthAnythingForDepthEstimation`, DepthAnythingForDepthEstimation]],
      [`glpn`, [`GLPNForDepthEstimation`, GLPNForDepthEstimation]],
    ]),
    MODEL_FOR_IMAGE_FEATURE_EXTRACTION_MAPPING_NAMES = new Map([
      [`clip`, [`CLIPVisionModelWithProjection`, CLIPVisionModelWithProjection]],
      [`siglip`, [`SiglipVisionModel`, SiglipVisionModel]],
    ]),
    MODEL_CLASS_TYPE_MAPPING = [
      [MODEL_MAPPING_NAMES_ENCODER_ONLY, MODEL_TYPES.EncoderOnly],
      [MODEL_MAPPING_NAMES_ENCODER_DECODER, MODEL_TYPES.EncoderDecoder],
      [MODEL_MAPPING_NAMES_DECODER_ONLY, MODEL_TYPES.DecoderOnly],
      [MODEL_FOR_SEQUENCE_CLASSIFICATION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_TOKEN_CLASSIFICATION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_SEQ_TO_SEQ_CAUSAL_LM_MAPPING_NAMES, MODEL_TYPES.Seq2Seq],
      [MODEL_FOR_SPEECH_SEQ_2_SEQ_MAPPING_NAMES, MODEL_TYPES.Seq2Seq],
      [MODEL_WITH_LM_HEAD_MAPPING_NAMES, MODEL_TYPES.DecoderOnly],
      [MODEL_FOR_MASKED_LM_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_QUESTION_ANSWERING_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_VISION_2_SEQ_MAPPING_NAMES, MODEL_TYPES.Vision2Seq],
      [MODEL_FOR_IMAGE_CLASSIFICATION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_IMAGE_SEGMENTATION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_SEMANTIC_SEGMENTATION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_IMAGE_MATTING_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_IMAGE_TO_IMAGE_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_DEPTH_ESTIMATION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_OBJECT_DETECTION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_ZERO_SHOT_OBJECT_DETECTION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_MASK_GENERATION_MAPPING_NAMES, MODEL_TYPES.MaskGeneration],
      [MODEL_FOR_CTC_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_AUDIO_CLASSIFICATION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_TEXT_TO_SPECTROGRAM_MAPPING_NAMES, MODEL_TYPES.Seq2Seq],
      [MODEL_FOR_TEXT_TO_WAVEFORM_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_AUDIO_XVECTOR_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_AUDIO_FRAME_CLASSIFICATION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
      [MODEL_FOR_IMAGE_FEATURE_EXTRACTION_MAPPING_NAMES, MODEL_TYPES.EncoderOnly],
    ];
  for (let [e, t] of MODEL_CLASS_TYPE_MAPPING)
    for (let [n, r] of e.values())
      (MODEL_TYPE_MAPPING.set(n, t), MODEL_CLASS_TO_NAME_MAPPING.set(r, n), MODEL_NAME_TO_CLASS_MAPPING.set(n, r));
  const CUSTOM_MAPPING = [
    [`CLIPTextModelWithProjection`, CLIPTextModelWithProjection, MODEL_TYPES.EncoderOnly],
    [`SiglipTextModel`, SiglipTextModel, MODEL_TYPES.EncoderOnly],
    [`ClapTextModelWithProjection`, ClapTextModelWithProjection, MODEL_TYPES.EncoderOnly],
    [`ClapAudioModelWithProjection`, ClapAudioModelWithProjection, MODEL_TYPES.EncoderOnly],
  ];
  for (let [e, t, n] of CUSTOM_MAPPING)
    (MODEL_TYPE_MAPPING.set(e, n), MODEL_CLASS_TO_NAME_MAPPING.set(t, e), MODEL_NAME_TO_CLASS_MAPPING.set(e, t));
  var AutoModel = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = MODEL_CLASS_TYPE_MAPPING.map((e) => e[0]);
      static BASE_IF_FAIL = !0;
    },
    AutoModelForSequenceClassification = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_SEQUENCE_CLASSIFICATION_MAPPING_NAMES];
    },
    AutoModelForTokenClassification = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_TOKEN_CLASSIFICATION_MAPPING_NAMES];
    },
    AutoModelForSeq2SeqLM = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_SEQ_TO_SEQ_CAUSAL_LM_MAPPING_NAMES];
    },
    AutoModelForSpeechSeq2Seq = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_SPEECH_SEQ_2_SEQ_MAPPING_NAMES];
    },
    AutoModelForTextToSpectrogram = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_TEXT_TO_SPECTROGRAM_MAPPING_NAMES];
    },
    AutoModelForTextToWaveform = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_TEXT_TO_WAVEFORM_MAPPING_NAMES];
    },
    AutoModelForCausalLM = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_WITH_LM_HEAD_MAPPING_NAMES];
    },
    AutoModelForMaskedLM = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_MASKED_LM_MAPPING_NAMES];
    },
    AutoModelForQuestionAnswering = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_QUESTION_ANSWERING_MAPPING_NAMES];
    },
    AutoModelForVision2Seq = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_VISION_2_SEQ_MAPPING_NAMES];
    },
    AutoModelForImageClassification = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_IMAGE_CLASSIFICATION_MAPPING_NAMES];
    },
    AutoModelForImageSegmentation = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_IMAGE_SEGMENTATION_MAPPING_NAMES];
    },
    AutoModelForSemanticSegmentation = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_SEMANTIC_SEGMENTATION_MAPPING_NAMES];
    },
    AutoModelForObjectDetection = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_OBJECT_DETECTION_MAPPING_NAMES];
    },
    AutoModelForZeroShotObjectDetection = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_ZERO_SHOT_OBJECT_DETECTION_MAPPING_NAMES];
    },
    AutoModelForCTC = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_CTC_MAPPING_NAMES];
    },
    AutoModelForAudioClassification = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_AUDIO_CLASSIFICATION_MAPPING_NAMES];
    },
    AutoModelForDocumentQuestionAnswering = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_DOCUMENT_QUESTION_ANSWERING_MAPPING_NAMES];
    },
    AutoModelForImageToImage = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_IMAGE_TO_IMAGE_MAPPING_NAMES];
    },
    AutoModelForDepthEstimation = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_DEPTH_ESTIMATION_MAPPING_NAMES];
    },
    AutoModelForImageFeatureExtraction = class extends PretrainedMixin {
      static MODEL_CLASS_MAPPINGS = [MODEL_FOR_IMAGE_FEATURE_EXTRACTION_MAPPING_NAMES];
    },
    Seq2SeqLMOutput = class extends ModelOutput {
      constructor({
        logits: e,
        past_key_values: t,
        encoder_outputs: n,
        decoder_attentions: r = null,
        cross_attentions: i = null,
      }) {
        (super(),
          (this.logits = e),
          (this.past_key_values = t),
          (this.encoder_outputs = n),
          (this.decoder_attentions = r),
          (this.cross_attentions = i));
      }
    },
    SequenceClassifierOutput = class extends ModelOutput {
      constructor({ logits: e }) {
        (super(), (this.logits = e));
      }
    },
    XVectorOutput = class extends ModelOutput {
      constructor({ logits: e, embeddings: t }) {
        (super(), (this.logits = e), (this.embeddings = t));
      }
    },
    TokenClassifierOutput = class extends ModelOutput {
      constructor({ logits: e }) {
        (super(), (this.logits = e));
      }
    },
    MaskedLMOutput = class extends ModelOutput {
      constructor({ logits: e }) {
        (super(), (this.logits = e));
      }
    },
    QuestionAnsweringModelOutput = class extends ModelOutput {
      constructor({ start_logits: e, end_logits: t }) {
        (super(), (this.start_logits = e), (this.end_logits = t));
      }
    },
    CausalLMOutput = class extends ModelOutput {
      constructor({ logits: e }) {
        (super(), (this.logits = e));
      }
    },
    ImageMattingOutput = class extends ModelOutput {
      constructor({ alphas: e }) {
        (super(), (this.alphas = e));
      }
    },
    VitsModelOutput = class extends ModelOutput {
      constructor({ waveform: e, spectrogram: t }) {
        (super(), (this.waveform = e), (this.spectrogram = t));
      }
    };
  const BROWSER_ENV = typeof self < `u`,
    WEBWORKER_ENV = BROWSER_ENV && self.constructor.name === `DedicatedWorkerGlobalScope`;
  let createCanvasFunction, ImageDataClass, loadImageFunction;
  if (BROWSER_ENV)
    ((createCanvasFunction = (e, t) => {
      if (!self.OffscreenCanvas) throw Error(`OffscreenCanvas not supported by this browser.`);
      return new self.OffscreenCanvas(e, t);
    }),
      (loadImageFunction = self.createImageBitmap),
      (ImageDataClass = self.ImageData));
  else if (import___vite_browser_external.default)
    loadImageFunction = async (e) => {
      let t = (await e.metadata()).channels,
        { data: n, info: r } = await e.rotate().raw().toBuffer({ resolveWithObject: !0 }),
        i = new RawImage(new Uint8ClampedArray(n), r.width, r.height, r.channels);
      return (t !== void 0 && t !== r.channels && i.convert(t), i);
    };
  else throw Error(`Unable to load image processing library.`);
  const RESAMPLING_MAPPING = { 0: `nearest`, 1: `lanczos`, 2: `bilinear`, 3: `bicubic`, 4: `box`, 5: `hamming` },
    CONTENT_TYPE_MAP = new Map([
      [`png`, `image/png`],
      [`jpg`, `image/jpeg`],
      [`jpeg`, `image/jpeg`],
      [`gif`, `image/gif`],
    ]);
  var RawImage = class e {
    constructor(e, t, n, r) {
      ((this.data = e), (this.width = t), (this.height = n), (this.channels = r));
    }
    get size() {
      return [this.width, this.height];
    }
    static async read(t) {
      if (t instanceof e) return t;
      if (typeof t == `string` || t instanceof URL) return await this.fromURL(t);
      throw Error(`Unsupported input type: ${typeof t}`);
    }
    static async fromURL(e) {
      let t = await getFile(e);
      if (t.status !== 200) throw Error(`Unable to read image from "${e}" (${t.status} ${t.statusText})`);
      let n = await t.blob();
      return this.fromBlob(n);
    }
    static async fromBlob(e) {
      if (BROWSER_ENV) {
        let t = await loadImageFunction(e),
          n = createCanvasFunction(t.width, t.height).getContext(`2d`);
        return (n.drawImage(t, 0, 0), new this(n.getImageData(0, 0, t.width, t.height).data, t.width, t.height, 4));
      } else {
        let t = (0, import___vite_browser_external.default)(await e.arrayBuffer());
        return await loadImageFunction(t);
      }
    }
    static fromTensor(t, n = `CHW`) {
      if (t.dims.length !== 3) throw Error(`Tensor should have 3 dimensions, but has ${t.dims.length} dimensions.`);
      if (n === `CHW`) t = t.transpose(1, 2, 0);
      else if (n !== `HWC`) throw Error(`Unsupported channel format: ${n}`);
      if (!(t.data instanceof Uint8ClampedArray || t.data instanceof Uint8Array))
        throw Error(`Unsupported tensor type: ${t.type}`);
      switch (t.dims[2]) {
        case 1:
        case 2:
        case 3:
        case 4:
          return new e(t.data, t.dims[1], t.dims[0], t.dims[2]);
        default:
          throw Error(`Unsupported number of channels: ${t.dims[2]}`);
      }
    }
    grayscale() {
      if (this.channels === 1) return this;
      let e = new Uint8ClampedArray(this.width * this.height * 1);
      switch (this.channels) {
        case 3:
        case 4:
          for (let t = 0, n = 0; t < this.data.length; t += this.channels) {
            let r = this.data[t],
              i = this.data[t + 1],
              a = this.data[t + 2];
            e[n++] = Math.round(0.2989 * r + 0.587 * i + 0.114 * a);
          }
          break;
        default:
          throw Error(`Conversion failed due to unsupported number of channels: ${this.channels}`);
      }
      return this._update(e, this.width, this.height, 1);
    }
    rgb() {
      if (this.channels === 3) return this;
      let e = new Uint8ClampedArray(this.width * this.height * 3);
      switch (this.channels) {
        case 1:
          for (let t = 0, n = 0; t < this.data.length; ++t)
            ((e[n++] = this.data[t]), (e[n++] = this.data[t]), (e[n++] = this.data[t]));
          break;
        case 4:
          for (let t = 0, n = 0; t < this.data.length; t += 4)
            ((e[n++] = this.data[t]), (e[n++] = this.data[t + 1]), (e[n++] = this.data[t + 2]));
          break;
        default:
          throw Error(`Conversion failed due to unsupported number of channels: ${this.channels}`);
      }
      return this._update(e, this.width, this.height, 3);
    }
    rgba() {
      if (this.channels === 4) return this;
      let e = new Uint8ClampedArray(this.width * this.height * 4);
      switch (this.channels) {
        case 1:
          for (let t = 0, n = 0; t < this.data.length; ++t)
            ((e[n++] = this.data[t]), (e[n++] = this.data[t]), (e[n++] = this.data[t]), (e[n++] = 255));
          break;
        case 3:
          for (let t = 0, n = 0; t < this.data.length; t += 3)
            ((e[n++] = this.data[t]), (e[n++] = this.data[t + 1]), (e[n++] = this.data[t + 2]), (e[n++] = 255));
          break;
        default:
          throw Error(`Conversion failed due to unsupported number of channels: ${this.channels}`);
      }
      return this._update(e, this.width, this.height, 4);
    }
    async resize(t, n, { resample: r = 2 } = {}) {
      let i = RESAMPLING_MAPPING[r] ?? r;
      if (BROWSER_ENV) {
        let r = this.channels,
          i = this.toCanvas(),
          a = createCanvasFunction(t, n).getContext(`2d`);
        return (a.drawImage(i, 0, 0, t, n), new e(a.getImageData(0, 0, t, n).data, t, n, 4).convert(r));
      } else {
        let e = this.toSharp();
        switch (i) {
          case `box`:
          case `hamming`:
            (i === `box` || i === `hamming`) &&
              (console.warn(`Resampling method ${i} is not yet supported. Using bilinear instead.`), (i = `bilinear`));
          case `nearest`:
          case `bilinear`:
          case `bicubic`:
            e = e.affine([t / this.width, 0, 0, n / this.height], { interpolator: i });
            break;
          case `lanczos`:
            e = e.resize({ width: t, height: n, fit: `fill`, kernel: `lanczos3` });
            break;
          default:
            throw Error(`Resampling method ${i} is not supported.`);
        }
        return await loadImageFunction(e);
      }
    }
    async pad([t, n, r, i]) {
      if (
        ((t = Math.max(t, 0)),
        (n = Math.max(n, 0)),
        (r = Math.max(r, 0)),
        (i = Math.max(i, 0)),
        t === 0 && n === 0 && r === 0 && i === 0)
      )
        return this;
      if (BROWSER_ENV) {
        let a = this.channels,
          o = this.toCanvas(),
          s = this.width + t + n,
          c = this.height + r + i,
          l = createCanvasFunction(s, c).getContext(`2d`);
        return (
          l.drawImage(o, 0, 0, this.width, this.height, t, r, s, c),
          new e(l.getImageData(0, 0, s, c).data, s, c, 4).convert(a)
        );
      } else {
        let e = this.toSharp().extend({ left: t, right: n, top: r, bottom: i });
        return await loadImageFunction(e);
      }
    }
    async crop([t, n, r, i]) {
      if (
        ((t = Math.max(t, 0)),
        (n = Math.max(n, 0)),
        (r = Math.min(r, this.width - 1)),
        (i = Math.min(i, this.height - 1)),
        t === 0 && n === 0 && r === this.width - 1 && i === this.height - 1)
      )
        return this;
      let a = r - t + 1,
        o = i - n + 1;
      if (BROWSER_ENV) {
        let r = this.channels,
          i = this.toCanvas(),
          s = createCanvasFunction(a, o).getContext(`2d`);
        return (s.drawImage(i, t, n, a, o, 0, 0, a, o), new e(s.getImageData(0, 0, a, o).data, a, o, 4).convert(r));
      } else {
        let e = this.toSharp().extract({ left: t, top: n, width: a, height: o });
        return await loadImageFunction(e);
      }
    }
    async center_crop(t, n) {
      if (this.width === t && this.height === n) return this;
      let r = (this.width - t) / 2,
        i = (this.height - n) / 2;
      if (BROWSER_ENV) {
        let a = this.channels,
          o = this.toCanvas(),
          s = createCanvasFunction(t, n).getContext(`2d`),
          c = 0,
          l = 0,
          u = 0,
          d = 0;
        return (
          r >= 0 ? (c = r) : (u = -r),
          i >= 0 ? (l = i) : (d = -i),
          s.drawImage(o, c, l, t, n, u, d, t, n),
          new e(s.getImageData(0, 0, t, n).data, t, n, 4).convert(a)
        );
      } else {
        let e = this.toSharp();
        if (r >= 0 && i >= 0) e = e.extract({ left: Math.floor(r), top: Math.floor(i), width: t, height: n });
        else if (r <= 0 && i <= 0) {
          let a = Math.floor(-i),
            o = Math.floor(-r);
          e = e.extend({ top: a, left: o, right: t - this.width - o, bottom: n - this.height - a });
        } else {
          let a = [0, 0],
            o = 0;
          i < 0 ? ((a[0] = Math.floor(-i)), (a[1] = n - this.height - a[0])) : (o = Math.floor(i));
          let s = [0, 0],
            c = 0;
          (r < 0 ? ((s[0] = Math.floor(-r)), (s[1] = t - this.width - s[0])) : (c = Math.floor(r)),
            (e = e
              .extend({ top: a[0], bottom: a[1], left: s[0], right: s[1] })
              .extract({ left: c, top: o, width: t, height: n })));
        }
        return await loadImageFunction(e);
      }
    }
    async toBlob(e = `image/png`, t = 1) {
      if (!BROWSER_ENV) throw Error(`toBlob() is only supported in browser environments.`);
      return await this.toCanvas().convertToBlob({ type: e, quality: t });
    }
    toTensor(e = `CHW`) {
      let t = new Tensor(`uint8`, new Uint8Array(this.data), [this.height, this.width, this.channels]);
      if (e !== `HWC`)
        if (e === `CHW`) t = t.permute(2, 0, 1);
        else throw Error(`Unsupported channel format: ${e}`);
      return t;
    }
    toCanvas() {
      if (!BROWSER_ENV) throw Error(`toCanvas() is only supported in browser environments.`);
      let e = this.clone().rgba(),
        t = createCanvasFunction(e.width, e.height),
        n = new ImageDataClass(e.data, e.width, e.height);
      return (t.getContext(`2d`).putImageData(n, 0, 0), t);
    }
    _update(e, t, n, r = null) {
      return ((this.data = e), (this.width = t), (this.height = n), r !== null && (this.channels = r), this);
    }
    clone() {
      return new e(this.data.slice(), this.width, this.height, this.channels);
    }
    convert(e) {
      if (this.channels === e) return this;
      switch (e) {
        case 1:
          this.grayscale();
          break;
        case 3:
          this.rgb();
          break;
        case 4:
          this.rgba();
          break;
        default:
          throw Error(`Conversion failed due to unsupported number of channels: ${this.channels}`);
      }
      return this;
    }
    async save(e) {
      if (BROWSER_ENV) {
        if (WEBWORKER_ENV) throw Error(`Unable to save an image from a Web Worker.`);
        let t = e.split(`.`).pop().toLowerCase(),
          n = CONTENT_TYPE_MAP.get(t) ?? `image/png`,
          r = await this.toBlob(n),
          i = URL.createObjectURL(r),
          a = document.createElement(`a`);
        ((a.href = i), (a.download = e), a.click(), a.remove());
      } else if (env$1.useFS) return await this.toSharp().toFile(e);
      else throw Error(`Unable to save the image because filesystem is disabled in this environment.`);
    }
    toSharp() {
      if (BROWSER_ENV) throw Error(`toSharp() is only supported in server-side environments.`);
      return (0, import___vite_browser_external.default)(this.data, {
        raw: { width: this.width, height: this.height, channels: this.channels },
      });
    }
  };
  async function read_audio(e, t) {
    if (typeof AudioContext > `u`)
      throw Error(
        'Unable to load audio from path/URL since `AudioContext` is not available in your environment. Instead, audio data should be passed directly to the pipeline/processor. For more information and some example code, see https://huggingface.co/docs/transformers.js/guides/node-audio-processing.',
      );
    let n = await (await getFile(e)).arrayBuffer(),
      r = new AudioContext({ sampleRate: t });
    t === void 0 && console.warn(`No sampling rate provided, using default of ${r.sampleRate}Hz.`);
    let i = await r.decodeAudioData(n),
      a;
    if (i.numberOfChannels === 2) {
      let e = Math.sqrt(2),
        t = i.getChannelData(0),
        n = i.getChannelData(1);
      a = new Float32Array(t.length);
      for (let r = 0; r < i.length; ++r) a[r] = (e * (t[r] + n[r])) / 2;
    } else a = i.getChannelData(0);
    return a;
  }
  function hanning(e) {
    if (e < 1) return new Float64Array();
    if (e === 1) return new Float64Array([1]);
    let t = e - 1,
      n = Math.PI / t,
      r = new Float64Array(e);
    for (let i = 0; i < e; ++i) {
      let e = 2 * i - t;
      r[i] = 0.5 + 0.5 * Math.cos(n * e);
    }
    return r;
  }
  const HERTZ_TO_MEL_MAPPING = {
    htk: (e) => 2595 * Math.log10(1 + e / 700),
    kaldi: (e) => 1127 * Math.log(1 + e / 700),
    slaney: (e, t = 1e3, n = 15, r = 27 / Math.log(6.4)) => (e >= t ? n + Math.log(e / t) * r : (3 * e) / 200),
  };
  function hertz_to_mel(e, t = `htk`) {
    let n = HERTZ_TO_MEL_MAPPING[t];
    if (!n) throw Error(`mel_scale should be one of "htk", "slaney" or "kaldi".`);
    return typeof e == `number` ? n(e) : e.map((e) => n(e));
  }
  const MEL_TO_HERTZ_MAPPING = {
    htk: (e) => 700 * (10 ** (e / 2595) - 1),
    kaldi: (e) => 700 * (Math.exp(e / 1127) - 1),
    slaney: (e, t = 1e3, n = 15, r = Math.log(6.4) / 27) => (e >= n ? t * Math.exp(r * (e - n)) : (200 * e) / 3),
  };
  function mel_to_hertz(e, t = `htk`) {
    let n = MEL_TO_HERTZ_MAPPING[t];
    if (!n) throw Error(`mel_scale should be one of "htk", "slaney" or "kaldi".`);
    return typeof e == `number` ? n(e) : e.map((e) => n(e));
  }
  function _create_triangular_filter_bank(e, t) {
    let n = Float64Array.from({ length: t.length - 1 }, (e, n) => t[n + 1] - t[n]),
      r = Array.from({ length: e.length }, () => Array(t.length));
    for (let n = 0; n < e.length; ++n) {
      let i = r[n];
      for (let r = 0; r < t.length; ++r) i[r] = t[r] - e[n];
    }
    let i = t.length - 2,
      a = Array.from({ length: i }, () => Array(e.length));
    for (let t = 0; t < e.length; ++t) {
      let e = r[t];
      for (let r = 0; r < i; ++r) {
        let i = -e[r] / n[r],
          o = e[r + 2] / n[r + 1];
        a[r][t] = Math.max(0, Math.min(i, o));
      }
    }
    return a;
  }
  function linspace(e, t, n) {
    let r = (t - e) / (n - 1);
    return Float64Array.from({ length: n }, (t, n) => e + r * n);
  }
  function mel_filter_bank(e, t, n, r, i, a = null, o = `htk`, s = !1) {
    if (a !== null && a !== `slaney`) throw Error(`norm must be one of null or "slaney"`);
    let c = linspace(hertz_to_mel(n, o), hertz_to_mel(r, o), t + 2),
      l = mel_to_hertz(c, o),
      u;
    if (s) {
      let t = i / (e * 2);
      ((u = hertz_to_mel(
        Float64Array.from({ length: e }, (e, n) => n * t),
        o,
      )),
        (l = c));
    } else u = linspace(0, Math.floor(i / 2), e);
    let d = _create_triangular_filter_bank(u, l);
    if (a !== null && a === `slaney`)
      for (let n = 0; n < t; ++n) {
        let t = d[n],
          r = 2 / (l[n + 2] - l[n]);
        for (let n = 0; n < e; ++n) t[n] *= r;
      }
    return d;
  }
  function padReflect(e, t, n) {
    let r = new e.constructor(e.length + t + n),
      i = e.length - 1;
    for (let n = 0; n < e.length; ++n) r[t + n] = e[n];
    for (let n = 1; n <= t; ++n) r[t - n] = e[calculateReflectOffset(n, i)];
    for (let a = 1; a <= n; ++a) r[i + t + a] = e[calculateReflectOffset(i - a, i)];
    return r;
  }
  function _db_conversion_helper(e, t, n, r, i) {
    if (n <= 0) throw Error(`reference must be greater than zero`);
    if (r <= 0) throw Error(`min_value must be greater than zero`);
    n = Math.max(r, n);
    let a = Math.log10(n);
    for (let n = 0; n < e.length; ++n) e[n] = t * Math.log10(Math.max(r, e[n]) - a);
    if (i !== null) {
      if (i <= 0) throw Error(`db_range must be greater than zero`);
      let t = max(e)[0] - i;
      for (let n = 0; n < e.length; ++n) e[n] = Math.max(e[n], t);
    }
    return e;
  }
  function amplitude_to_db(e, t = 1, n = 1e-5, r = null) {
    return _db_conversion_helper(e, 20, t, n, r);
  }
  function power_to_db(e, t = 1, n = 1e-10, r = null) {
    return _db_conversion_helper(e, 10, t, n, r);
  }
  function spectrogram(
    e,
    t,
    n,
    r,
    {
      fft_length: i = null,
      power: a = 1,
      center: o = !0,
      pad_mode: s = `reflect`,
      onesided: c = !0,
      preemphasis: l = null,
      mel_filters: u = null,
      mel_floor: d = 1e-10,
      log_mel: f = null,
      reference: p = 1,
      min_value: m = 1e-10,
      db_range: h = null,
      remove_dc_offset: g = null,
      max_num_frames: _ = null,
      do_pad: v = !0,
      transpose: y = !1,
    } = {},
  ) {
    let b = t.length;
    if ((i === null && (i = n), n > i)) throw Error(`frame_length (${n}) may not be larger than fft_length (${i})`);
    if (b !== n) throw Error(`Length of the window (${b}) must equal frame_length (${n})`);
    if (r <= 0) throw Error(`hop_length must be greater than zero`);
    if (a === null && u !== null)
      throw Error(
        'You have provided `mel_filters` but `power` is `None`. Mel spectrogram computation is not yet supported for complex-valued spectrogram. Specify `power` to fix this issue.',
      );
    if (o) {
      if (s !== `reflect`) throw Error(`pad_mode="${s}" not implemented yet.`);
      let t = Math.floor((i - 1) / 2) + 1;
      e = padReflect(e, t, t);
    }
    let x = Math.floor(1 + Math.floor((e.length - n) / r)),
      S = c ? Math.floor(i / 2) + 1 : i,
      C = x,
      w = x;
    _ !== null && (_ > x ? v && (w = _) : (w = C = _));
    let T = new FFT(i),
      E = new Float64Array(i),
      D = new Float64Array(T.outputBufferSize),
      O = Array(C);
    for (let i = 0; i < C; ++i) {
      let a = i * r;
      for (let t = 0; t < n; ++t) E[t] = e[a + t];
      if (g) {
        let e = 0;
        for (let t = 0; t < n; ++t) e += E[t];
        let t = e / n;
        for (let e = 0; e < n; ++e) E[e] -= t;
      }
      if (l !== null) {
        for (let e = n - 1; e >= 1; --e) E[e] -= l * E[e - 1];
        E[0] *= 1 - l;
      }
      for (let e = 0; e < t.length; ++e) E[e] *= t[e];
      T.realTransform(D, E);
      let o = Array(S);
      for (let e = 0; e < o.length; ++e) {
        let t = e << 1;
        o[e] = D[t] ** 2 + D[t + 1] ** 2;
      }
      O[i] = o;
    }
    if (a !== null && a !== 2) {
      let e = 2 / a;
      for (let t = 0; t < O.length; ++t) {
        let n = O[t];
        for (let t = 0; t < n.length; ++t) n[t] **= e;
      }
    }
    let k = u.length,
      A = new Float32Array(k * w),
      j = y ? [w, k] : [k, w];
    for (let e = 0; e < k; ++e) {
      let t = u[e];
      for (let n = 0; n < C; ++n) {
        let r = O[n],
          i = 0;
        for (let e = 0; e < S; ++e) i += t[e] * r[e];
        A[y ? n * k + e : e * C + n] = Math.max(d, i);
      }
    }
    if (a !== null && f !== null) {
      let e = Math.min(A.length, C * k);
      switch (f) {
        case `log`:
          for (let t = 0; t < e; ++t) A[t] = Math.log(A[t]);
          break;
        case `log10`:
          for (let t = 0; t < e; ++t) A[t] = Math.log10(A[t]);
          break;
        case `dB`:
          if (a === 1) amplitude_to_db(A, p, m, h);
          else if (a === 2) power_to_db(A, p, m, h);
          else throw Error(`Cannot use log_mel option '${f}' with power ${a}`);
          break;
        default:
          throw Error(`log_mel must be one of null, 'log', 'log10' or 'dB'. Got '${f}'`);
      }
    }
    return { data: A, dims: j };
  }
  function window_function(e, t, { periodic: n = !0, frame_length: r = null, center: i = !0 } = {}) {
    let a = n ? e + 1 : e,
      o;
    switch (t) {
      case `boxcar`:
        o = new Float64Array(a).fill(1);
        break;
      case `hann`:
      case `hann_window`:
        o = hanning(a);
        break;
      case `povey`:
        o = hanning(a).map((e) => e ** 0.85);
        break;
      default:
        throw Error(`Unknown window type ${t}.`);
    }
    if ((n && (o = o.subarray(0, e)), r === null)) return o;
    if (e > r) throw Error(`Length of the window (${e}) may not be larger than frame_length (${r})`);
    return o;
  }
  function center_to_corners_format([e, t, n, r]) {
    return [e - n / 2, t - r / 2, e + n / 2, t + r / 2];
  }
  function post_process_object_detection(e, t = 0.5, n = null, r = !1) {
    let i = e.logits,
      a = e.pred_boxes,
      [o, s, c] = i.dims;
    if (n !== null && n.length !== o)
      throw Error(`Make sure that you pass in as many target sizes as the batch dimension of the logits`);
    let l = [];
    for (let e = 0; e < o; ++e) {
      let o = n === null ? null : n[e],
        u = { boxes: [], classes: [], scores: [] },
        d = i[e],
        f = a[e];
      for (let e = 0; e < s; ++e) {
        let n = d[e],
          i = [],
          a;
        if (r) {
          a = n.sigmoid().data;
          for (let e = 0; e < a.length; ++e) a[e] > t && i.push(e);
        } else {
          let e = max(n.data)[1];
          if (e === c - 1) continue;
          (i.push(e), (a = softmax(n.data)));
        }
        for (let t of i) {
          let n = f[e].data;
          ((n = center_to_corners_format(n)),
            o !== null && (n = n.map((e, t) => e * o[(t + 1) % 2])),
            u.boxes.push(n),
            u.classes.push(t),
            u.scores.push(a[t]));
        }
      }
      l.push(u);
    }
    return l;
  }
  function validate_audio_inputs(e, t) {
    if (!(e instanceof Float32Array || e instanceof Float64Array))
      throw Error(
        `${t} expects input to be a Float32Array or a Float64Array, but got ${e?.constructor?.name ?? typeof e} instead. If using the feature extractor directly, remember to use \`read_audio(url, sampling_rate)\` to obtain the raw audio data of the file/url.`,
      );
  }
  function constraint_to_multiple_of(e, t, n = 0, r = null) {
    let i = e / t,
      a = bankers_round(i) * t;
    return (r !== null && a > r && (a = Math.floor(i) * t), a < n && (a = Math.ceil(i) * t), a);
  }
  function enforce_size_divisibility([e, t], n) {
    return [Math.max(Math.floor(e / n), 1) * n, Math.max(Math.floor(t / n), 1) * n];
  }
  var FeatureExtractor = class extends Callable {
      constructor(e) {
        (super(), (this.config = e));
      }
    },
    ImageFeatureExtractor = class extends FeatureExtractor {
      constructor(e) {
        (super(e),
          (this.image_mean = this.config.image_mean ?? this.config.mean),
          (this.image_std = this.config.image_std ?? this.config.std),
          (this.resample = this.config.resample ?? 2),
          (this.do_rescale = this.config.do_rescale ?? !0),
          (this.rescale_factor = this.config.rescale_factor ?? 1 / 255),
          (this.do_normalize = this.config.do_normalize),
          (this.do_resize = this.config.do_resize),
          (this.do_thumbnail = this.config.do_thumbnail),
          (this.size = this.config.size),
          (this.size_divisibility = this.config.size_divisibility ?? this.config.size_divisor),
          (this.do_center_crop = this.config.do_center_crop),
          (this.crop_size = this.config.crop_size),
          (this.do_convert_rgb = this.config.do_convert_rgb ?? !0),
          (this.do_crop_margin = this.config.do_crop_margin),
          (this.pad_size = this.config.pad_size),
          (this.do_pad = this.config.do_pad),
          this.do_pad &&
            !this.pad_size &&
            this.size &&
            this.size.width !== void 0 &&
            this.size.height !== void 0 &&
            (this.pad_size = this.size),
          (this.do_flip_channel_order = this.config.do_flip_channel_order ?? !1));
      }
      async thumbnail(e, t, n = 2) {
        let r = e.height,
          i = e.width,
          a = t.height,
          o = t.width,
          s = Math.min(r, a),
          c = Math.min(i, o);
        return s === r && c === i
          ? e
          : (r > i ? (c = Math.floor((i * s) / r)) : i > r && (s = Math.floor((r * c) / i)),
            await e.resize(c, s, { resample: n }));
      }
      async crop_margin(e, t = 200) {
        let n = e.clone().grayscale(),
          r = min(n.data)[0],
          i = max(n.data)[0] - r;
        if (i === 0) return e;
        let a = t / 255,
          o = n.width,
          s = n.height,
          c = 0,
          l = 0;
        for (let e = 0; e < n.height; ++e) {
          let t = e * n.width;
          for (let u = 0; u < n.width; ++u)
            (n.data[t + u] - r) / i < a &&
              ((o = Math.min(o, u)), (s = Math.min(s, e)), (c = Math.max(c, u)), (l = Math.max(l, e)));
        }
        return ((e = await e.crop([o, s, c, l])), e);
      }
      pad_image(e, t, n, { mode: r = `constant`, center: i = !1, constant_values: a = 0 } = {}) {
        let [o, s, c] = t,
          l,
          u;
        if ((typeof n == `number` ? ((l = n), (u = n)) : ((l = n.width), (u = n.height)), l !== s || u !== o)) {
          let n = new Float32Array(l * u * c);
          if (Array.isArray(a)) for (let e = 0; e < n.length; ++e) n[e] = a[e % c];
          else a !== 0 && n.fill(a);
          let [d, f] = i ? [Math.floor((l - s) / 2), Math.floor((u - o) / 2)] : [0, 0];
          for (let t = 0; t < o; ++t) {
            let r = (t + f) * l,
              i = t * s;
            for (let t = 0; t < s; ++t) {
              let a = (r + t + d) * c,
                o = (i + t) * c;
              for (let t = 0; t < c; ++t) n[a + t] = e[o + t];
            }
          }
          if (r === `symmetric`) {
            if (i) throw Error('`center` padding is not supported when `mode` is set to `symmetric`.');
            let t = o - 1,
              r = s - 1;
            for (let i = 0; i < u; ++i) {
              let a = i * l,
                u = calculateReflectOffset(i, t) * s;
              for (let t = 0; t < l; ++t) {
                if (i < o && t < s) continue;
                let l = (a + t) * c,
                  d = (u + calculateReflectOffset(t, r)) * c;
                for (let t = 0; t < c; ++t) n[l + t] = e[d + t];
              }
            }
          }
          ((e = n), (t = [u, l, c]));
        }
        return [e, t];
      }
      rescale(e) {
        for (let t = 0; t < e.length; ++t) e[t] = this.rescale_factor * e[t];
      }
      get_resize_output_image_size(e, t) {
        let [n, r] = e.size,
          i,
          a;
        if (this.do_thumbnail) {
          let { height: e, width: n } = t;
          i = Math.min(e, n);
        } else
          Number.isInteger(t)
            ? ((i = t), (a = this.config.max_size ?? i))
            : t !== void 0 && ((i = t.shortest_edge), (a = t.longest_edge));
        if (i !== void 0 || a !== void 0) {
          let e = i === void 0 ? 1 : Math.max(i / n, i / r),
            t = n * e,
            o = r * e,
            s = a === void 0 ? 1 : Math.min(a / t, a / o),
            c = Math.floor(Number((t * s).toFixed(2))),
            l = Math.floor(Number((o * s).toFixed(2)));
          return (
            this.size_divisibility !== void 0 && ([c, l] = enforce_size_divisibility([c, l], this.size_divisibility)),
            [c, l]
          );
        } else if (t !== void 0 && t.width !== void 0 && t.height !== void 0) {
          let e = t.width,
            i = t.height;
          if (this.config.keep_aspect_ratio && this.config.ensure_multiple_of) {
            let t = i / r,
              a = e / n;
            (Math.abs(1 - a) < Math.abs(1 - t) ? (t = a) : (a = t),
              (i = constraint_to_multiple_of(t * r, this.config.ensure_multiple_of)),
              (e = constraint_to_multiple_of(a * n, this.config.ensure_multiple_of)));
          }
          return [e, i];
        } else if (this.size_divisibility !== void 0) return enforce_size_divisibility([n, r], this.size_divisibility);
        else
          throw Error(`Could not resize image due to unsupported \`this.size\` option in config: ${JSON.stringify(t)}`);
      }
      async resize(e) {
        let [t, n] = this.get_resize_output_image_size(e, this.size);
        return await e.resize(t, n, { resample: this.resample });
      }
      async preprocess(
        e,
        {
          do_normalize: t = null,
          do_pad: n = null,
          do_convert_rgb: r = null,
          do_convert_grayscale: i = null,
          do_flip_channel_order: a = null,
        } = {},
      ) {
        this.do_crop_margin && (e = await this.crop_margin(e));
        let [o, s] = e.size;
        if (
          ((r ?? this.do_convert_rgb) ? (e = e.rgb()) : i && (e = e.grayscale()),
          this.do_resize && (e = await this.resize(e)),
          this.do_thumbnail && (e = await this.thumbnail(e, this.size, this.resample)),
          this.do_center_crop)
        ) {
          let t, n;
          (Number.isInteger(this.crop_size)
            ? ((t = this.crop_size), (n = this.crop_size))
            : ((t = this.crop_size.width), (n = this.crop_size.height)),
            (e = await e.center_crop(t, n)));
        }
        let c = [e.height, e.width],
          l = Float32Array.from(e.data),
          u = [e.height, e.width, e.channels];
        if ((this.do_rescale && this.rescale(l), t ?? this.do_normalize)) {
          let t = this.image_mean;
          Array.isArray(this.image_mean) || (t = Array(e.channels).fill(t));
          let n = this.image_std;
          if (
            (Array.isArray(this.image_std) || (n = Array(e.channels).fill(t)),
            t.length !== e.channels || n.length !== e.channels)
          )
            throw Error(
              `When set to arrays, the length of \`image_mean\` (${t.length}) and \`image_std\` (${n.length}) must match the number of channels in the image (${e.channels}).`,
            );
          for (let r = 0; r < l.length; r += e.channels)
            for (let i = 0; i < e.channels; ++i) l[r + i] = (l[r + i] - t[i]) / n[i];
        }
        if (n ?? this.do_pad) {
          if (this.pad_size) {
            let t = this.pad_image(l, [e.height, e.width, e.channels], this.pad_size);
            [l, u] = t;
          } else if (this.size_divisibility) {
            let [e, t] = enforce_size_divisibility([u[1], u[0]], this.size_divisibility);
            [l, u] = this.pad_image(l, u, { width: e, height: t });
          }
        }
        if (a ?? this.do_flip_channel_order) {
          if (u[2] !== 3) throw Error(`Flipping channel order is only supported for RGB images.`);
          for (let e = 0; e < l.length; e += 3) {
            let t = l[e];
            ((l[e] = l[e + 2]), (l[e + 2] = t));
          }
        }
        let d = new Tensor(`float32`, l, u).permute(2, 0, 1);
        return { original_size: [s, o], reshaped_input_size: c, pixel_values: d };
      }
      async _call(e, ...t) {
        Array.isArray(e) || (e = [e]);
        let n = await Promise.all(e.map((e) => this.preprocess(e)));
        return {
          pixel_values: stack(
            n.map((e) => e.pixel_values),
            0,
          ),
          original_sizes: n.map((e) => e.original_size),
          reshaped_input_sizes: n.map((e) => e.reshaped_input_size),
        };
      }
    },
    SegformerFeatureExtractor = class extends ImageFeatureExtractor {
      post_process_semantic_segmentation(e, t = null) {
        let n = e.logits,
          r = n.dims[0];
        if (t !== null && t.length !== r)
          throw Error(`Make sure that you pass in as many target sizes as the batch dimension of the logits`);
        let i = [];
        for (let e = 0; e < r; ++e) {
          let r = t === null ? null : t[e],
            a = n[e];
          r !== null && (a = interpolate(a, r, `bilinear`, !1));
          let [o, s] = r ?? a.dims.slice(-2),
            c = new Tensor(`int32`, new Int32Array(o * s), [o, s]),
            l = a[0].data;
          for (let e = 1; e < a.dims[0]; ++e) {
            let t = a[e].data;
            for (let n = 0; n < t.length; ++n) t[n] > l[n] && ((l[n] = t[n]), (c.data[n] = e));
          }
          let u = Array(a.dims[0]),
            d = c.data;
          for (let e = 0; e < d.length; ++e) {
            let t = d[e];
            u[t] = t;
          }
          let f = u.filter((e) => e !== void 0);
          i.push({ segmentation: c, labels: f });
        }
        return i;
      }
    },
    DPTFeatureExtractor = class extends ImageFeatureExtractor {},
    DPTImageProcessor = class extends DPTFeatureExtractor {},
    BitImageProcessor = class extends ImageFeatureExtractor {},
    GLPNFeatureExtractor = class extends ImageFeatureExtractor {},
    CLIPFeatureExtractor = class extends ImageFeatureExtractor {},
    ChineseCLIPFeatureExtractor = class extends ImageFeatureExtractor {},
    SiglipImageProcessor = class extends ImageFeatureExtractor {},
    ConvNextFeatureExtractor = class extends ImageFeatureExtractor {
      constructor(e) {
        (super(e), (this.crop_pct = this.config.crop_pct ?? 224 / 256));
      }
      async resize(e) {
        let t = this.size?.shortest_edge;
        if (t === void 0) throw Error(`Size dictionary must contain 'shortest_edge' key.`);
        if (t < 384) {
          let n = Math.floor(t / this.crop_pct),
            [r, i] = this.get_resize_output_image_size(e, { shortest_edge: n });
          ((e = await e.resize(r, i, { resample: this.resample })), (e = await e.center_crop(t, t)));
        } else e = await e.resize(t, t, { resample: this.resample });
        return e;
      }
    },
    ConvNextImageProcessor = class extends ConvNextFeatureExtractor {},
    ViTFeatureExtractor = class extends ImageFeatureExtractor {},
    ViTImageProcessor = class extends ImageFeatureExtractor {},
    EfficientNetImageProcessor = class extends ImageFeatureExtractor {
      constructor(e) {
        (super(e),
          (this.include_top = this.config.include_top ?? !0),
          this.include_top && (this.image_std = this.image_std.map((e) => e * e)));
      }
    },
    MobileViTFeatureExtractor = class extends ImageFeatureExtractor {},
    MobileViTImageProcessor = class extends MobileViTFeatureExtractor {},
    OwlViTFeatureExtractor = class extends ImageFeatureExtractor {
      post_process_object_detection(...e) {
        return post_process_object_detection(...e);
      }
    },
    Owlv2ImageProcessor = class extends OwlViTFeatureExtractor {},
    DeiTFeatureExtractor = class extends ImageFeatureExtractor {},
    BeitFeatureExtractor = class extends ImageFeatureExtractor {},
    DonutFeatureExtractor = class extends ImageFeatureExtractor {
      pad_image(e, t, n, r = {}) {
        let [i, a, o] = t,
          s = this.image_mean;
        Array.isArray(this.image_mean) || (s = Array(o).fill(s));
        let c = this.image_std;
        Array.isArray(c) || (c = Array(o).fill(s));
        let l = s.map((e, t) => -e / c[t]);
        return super.pad_image(e, t, n, { center: !0, constant_values: l, ...r });
      }
    },
    NougatImageProcessor = class extends DonutFeatureExtractor {},
    DetrFeatureExtractor = class extends ImageFeatureExtractor {
      async _call(e) {
        let t = await super._call(e),
          n = [t.pixel_values.dims[0], 64, 64],
          r = new Tensor(`int64`, new BigInt64Array(n.reduce((e, t) => e * t)).fill(1n), n);
        return { ...t, pixel_mask: r };
      }
      post_process_object_detection(...e) {
        return post_process_object_detection(...e);
      }
      remove_low_and_no_objects(e, t, n, r) {
        let i = [],
          a = [],
          o = [];
        for (let s = 0; s < e.dims[0]; ++s) {
          let c = e[s],
            l = t[s],
            u = max(c.data)[1];
          if (u === r) continue;
          let d = softmax(c.data)[u];
          d > n && (i.push(l), a.push(d), o.push(u));
        }
        return [i, a, o];
      }
      check_segment_validity(e, t, n, r = 0.5, i = 0.8) {
        let a = [],
          o = 0,
          s = 0;
        for (let i = 0; i < e.length; ++i) (e[i] === n && (a.push(i), ++o), t[n].data[i] >= r && ++s);
        let c = o > 0 && s > 0;
        return ((c &&= o / s > i), [c, a]);
      }
      compute_segments(e, t, n, r, i, a = null, o = null) {
        let [s, c] = o ?? e[0].dims,
          l = new Tensor(`int32`, new Int32Array(s * c), [s, c]),
          u = [];
        if (o !== null) for (let t = 0; t < e.length; ++t) e[t] = interpolate(e[t], o, `bilinear`, !1);
        let d = new Int32Array(e[0].data.length),
          f = new Float32Array(e[0].data.length);
        for (let n = 0; n < e.length; ++n) {
          let r = t[n];
          for (let t = 0; t < e[n].data.length; ++t)
            ((e[n].data[t] *= r), e[n].data[t] > f[t] && ((d[t] = n), (f[t] = e[n].data[t])));
        }
        let p = 0;
        for (let a = 0; a < n.length; ++a) {
          let o = n[a],
            [s, c] = this.check_segment_validity(d, e, a, r, i);
          if (s) {
            ++p;
            for (let e of c) l.data[e] = p;
            u.push({ id: p, label_id: o, score: t[a] });
          }
        }
        return [l, u];
      }
      post_process_panoptic_segmentation(e, t = 0.5, n = 0.5, r = 0.8, i = null, a = null) {
        i === null && (console.warn('`label_ids_to_fuse` unset. No instance will be fused.'), (i = new Set()));
        let o = e.logits,
          s = e.pred_masks.sigmoid(),
          [c, l, u] = o.dims;
        if ((--u, a !== null && a.length !== c))
          throw Error(`Make sure that you pass in as many target sizes as the batch dimension of the logits`);
        let d = [];
        for (let e = 0; e < c; ++e) {
          let c = a === null ? null : a[e],
            l = o[e],
            f = s[e],
            [p, m, h] = this.remove_low_and_no_objects(l, f, t, u);
          if (h.length === 0) {
            let [e, t] = c ?? f.dims.slice(-2),
              n = new Tensor(`int32`, new Int32Array(e * t).fill(-1), [e, t]);
            d.push({ segmentation: n, segments_info: [] });
            continue;
          }
          let [g, _] = this.compute_segments(p, m, h, n, r, i, c);
          d.push({ segmentation: g, segments_info: _ });
        }
        return d;
      }
      post_process_instance_segmentation() {
        throw Error(`Not implemented yet`);
      }
    },
    YolosFeatureExtractor = class extends ImageFeatureExtractor {
      post_process_object_detection(...e) {
        return post_process_object_detection(...e);
      }
    },
    SamImageProcessor = class extends ImageFeatureExtractor {
      reshape_input_points(e, t, n) {
        e = structuredClone(e);
        let r = calculateDimensions(e);
        if (r.length === 3) ((r = [1, ...r]), (e = [e]));
        else if (r.length !== 4)
          throw Error(
            'The input_points must be a 4D tensor of shape `batch_size`, `point_batch_size`, `nb_points_per_image`, `2`.',
          );
        for (let r = 0; r < e.length; ++r) {
          let i = t[r],
            a = n[r],
            o = [a[0] / i[0], a[1] / i[1]];
          for (let t = 0; t < e[r].length; ++t)
            for (let n = 0; n < e[r][t].length; ++n) for (let i = 0; i < e[r][t][n].length; ++i) e[r][t][n][i] *= o[i];
        }
        return new Tensor(`float32`, Float32Array.from(e.flat(1 / 0)), r);
      }
      add_input_labels(e, t) {
        let n = calculateDimensions(e);
        if (n.length === 2) ((n = [1, ...n]), (e = [e]));
        else if (n.length !== 3)
          throw Error(
            'The input_points must be a 4D tensor of shape `batch_size`, `point_batch_size`, `nb_points_per_image`, `2`.',
          );
        if (n.some((e, n) => e !== t.dims[n]))
          throw Error(`The first ${n.length} dimensions of 'input_points' and 'input_labels' must be the same.`);
        return new Tensor(`int64`, e.flat(1 / 0).map(BigInt), n);
      }
      async _call(e, t = null, n = null) {
        let r = await super._call(e);
        if ((t && (r.input_points = this.reshape_input_points(t, r.original_sizes, r.reshaped_input_sizes)), n)) {
          if (!r.input_points) throw Error('`input_points` must be provided if `input_labels` are provided.');
          r.input_labels = this.add_input_labels(n, r.input_points);
        }
        return r;
      }
      post_process_masks(e, t, n, { mask_threshold: r = 0, binarize: i = !0, pad_size: a = null } = {}) {
        let o = [];
        a ??= this.pad_size;
        let s = [a.height, a.width];
        for (let a = 0; a < t.length; ++a) {
          let c = t[a],
            l = n[a],
            u = e[a],
            d = [];
          for (let e = 0; e < u.dims[0]; ++e) {
            let t = u[e],
              n = interpolate(t, s, `bilinear`, !1);
            if (((n = n.slice(null, [0, l[0]], [0, l[1]])), (n = interpolate(n, c, `bilinear`, !1)), i)) {
              let e = new Uint8Array(n.data.length);
              for (let t = 0; t < n.data.length; ++t) n.data[t] > r && (e[t] = 1);
              n = new Tensor(`bool`, e, n.dims);
            }
            d.push(n);
          }
          o.push(stack(d));
        }
        return o;
      }
    },
    Swin2SRImageProcessor = class extends ImageFeatureExtractor {
      pad_image(e, t, n, r = {}) {
        let [i, a, o] = t;
        return super.pad_image(
          e,
          t,
          { width: a + ((n - (a % n)) % n), height: i + ((n - (i % n)) % n) },
          { mode: `symmetric`, center: !1, constant_values: -1, ...r },
        );
      }
    },
    VitMatteImageProcessor = class extends ImageFeatureExtractor {
      async _call(e, t) {
        (Array.isArray(e) || (e = [e]), Array.isArray(t) || (t = [t]));
        let n = await Promise.all(e.map((e) => this.preprocess(e))),
          r = await Promise.all(
            t.map((e) => this.preprocess(e, { do_normalize: !1, do_convert_rgb: !1, do_convert_grayscale: !0 })),
          );
        return {
          pixel_values: stack(
            n.map((e, t) => cat([e.pixel_values, r[t].pixel_values], 0)),
            0,
          ),
          original_sizes: n.map((e) => e.original_size),
          reshaped_input_sizes: n.map((e) => e.reshaped_input_size),
        };
      }
    },
    WhisperFeatureExtractor = class extends FeatureExtractor {
      constructor(e) {
        (super(e),
          (this.config.mel_filters ??= mel_filter_bank(
            Math.floor(1 + this.config.n_fft / 2),
            this.config.feature_size,
            0,
            8e3,
            this.config.sampling_rate,
            `slaney`,
            `slaney`,
          )),
          (this.window = window_function(this.config.n_fft, `hann`)));
      }
      _extract_fbank_features(e) {
        let { data: t, dims: n } = spectrogram(e, this.window, this.config.n_fft, this.config.hop_length, {
            power: 2,
            mel_filters: this.config.mel_filters,
            log_mel: `log10`,
            max_num_frames: this.config.nb_max_frames,
          }),
          r = max(t)[0];
        for (let e = 0; e < t.length; ++e) t[e] = (Math.max(t[e], r - 8) + 4) / 4;
        return { data: t, dims: n };
      }
      async _call(e) {
        validate_audio_inputs(e, `WhisperFeatureExtractor`);
        let t;
        e.length > this.config.n_samples
          ? (console.warn(
              'Attempting to extract features for audio longer than 30 seconds. If using a pipeline to extract transcript from a long audio clip, remember to specify `chunk_length_s` and/or `stride_length_s`.',
            ),
            (t = e.slice(0, this.config.n_samples)))
          : ((t = new Float32Array(this.config.n_samples)), t.set(e));
        let { data: n, dims: r } = this._extract_fbank_features(t);
        return { input_features: new Tensor(`float32`, n, [1, ...r]) };
      }
    },
    Wav2Vec2FeatureExtractor = class extends FeatureExtractor {
      _zero_mean_unit_var_norm(e) {
        let t = e.reduce((e, t) => e + t, 0) / e.length,
          n = e.reduce((e, n) => e + (n - t) ** 2, 0) / e.length;
        return e.map((e) => (e - t) / Math.sqrt(n + 1e-7));
      }
      async _call(e) {
        (validate_audio_inputs(e, `Wav2Vec2FeatureExtractor`), e instanceof Float64Array && (e = new Float32Array(e)));
        let t = e;
        this.config.do_normalize && (t = this._zero_mean_unit_var_norm(t));
        let n = [1, t.length];
        return {
          input_values: new Tensor(`float32`, t, n),
          attention_mask: new Tensor(`int64`, new BigInt64Array(t.length).fill(1n), n),
        };
      }
    },
    SeamlessM4TFeatureExtractor = class extends FeatureExtractor {
      constructor(e) {
        super(e);
        let t = this.config.sampling_rate,
          n = mel_filter_bank(256, this.config.num_mel_bins, 20, Math.floor(t / 2), t, null, `kaldi`, !0);
        for (let e = 0; e < n.length; ++e) n[e].push(0);
        ((this.mel_filters = n), (this.window = window_function(400, `povey`, { periodic: !1 })));
      }
      _extract_fbank_features(e, t) {
        return (
          (e = e.map((e) => e * 32768)),
          spectrogram(e, this.window, 400, 160, {
            fft_length: 512,
            power: 2,
            center: !1,
            preemphasis: 0.97,
            mel_filters: this.mel_filters,
            log_mel: `log`,
            mel_floor: 1.192092955078125e-7,
            remove_dc_offset: !0,
            max_num_frames: t,
            transpose: !0,
          })
        );
      }
      async _call(
        e,
        {
          padding: t = !0,
          pad_to_multiple_of: n = 2,
          do_normalize_per_mel_bins: r = !0,
          return_attention_mask: i = !0,
        } = {},
      ) {
        validate_audio_inputs(e, `SeamlessM4TFeatureExtractor`);
        let a = this._extract_fbank_features(e, this.config.max_length);
        if (r) {
          let [e, t] = a.dims;
          for (let n = 0; n < t; ++n) {
            let r = 0;
            for (let i = 0; i < e; ++i) r += a.data[i * t + n];
            let i = r / e,
              o = 0;
            for (let r = 0; r < e; ++r) o += (a.data[r * t + n] - i) ** 2;
            o /= e - 1;
            let s = Math.sqrt(o + 1e-7);
            for (let r = 0; r < e; ++r) {
              let e = r * t + n;
              a.data[e] = (a.data[e] - i) / s;
            }
          }
        }
        let o;
        if (t) {
          let [e, t] = a.dims,
            r = e % n;
          if (r > 0) {
            let n = new Float32Array(t * (e + r));
            (n.set(a.data), n.fill(this.config.padding_value, a.data.length));
            let s = e + r;
            ((a = { data: n, dims: [s, t] }),
              i && ((o = new Tensor(`int64`, new BigInt64Array(s), [1, s])), o.data.fill(1n, 0, e)));
          }
        }
        let [s, c] = a.dims,
          l = this.config.stride;
        if (s % l !== 0) throw Error(`The number of frames (${s}) must be a multiple of the stride (${l}).`);
        let u = new Tensor(`float32`, a.data, a.dims).view(1, Math.floor(s / l), c * l),
          d = { input_features: u };
        if (i) {
          let e = u.dims[1],
            t = new Tensor(`int64`, new BigInt64Array(e), [1, e]);
          if (o) for (let e = 1, n = 0; e < s; e += l, ++n) t.data[n] = o.data[e];
          else t.data.fill(1n);
          d.attention_mask = t;
        }
        return d;
      }
    },
    ASTFeatureExtractor = class extends FeatureExtractor {
      constructor(e) {
        super(e);
        let t = this.config.sampling_rate,
          n = mel_filter_bank(256, this.config.num_mel_bins, 20, Math.floor(t / 2), t, null, `kaldi`, !0);
        for (let e = 0; e < n.length; ++e) n[e].push(0);
        ((this.mel_filters = n),
          (this.window = window_function(400, `hann`, { periodic: !1 })),
          (this.mean = this.config.mean),
          (this.std = this.config.std));
      }
      _extract_fbank_features(e, t) {
        return spectrogram(e, this.window, 400, 160, {
          fft_length: 512,
          power: 2,
          center: !1,
          preemphasis: 0.97,
          mel_filters: this.mel_filters,
          log_mel: `log`,
          mel_floor: 1.192092955078125e-7,
          remove_dc_offset: !0,
          max_num_frames: t,
          transpose: !0,
        });
      }
      async _call(e) {
        validate_audio_inputs(e, `ASTFeatureExtractor`);
        let t = this._extract_fbank_features(e, this.config.max_length);
        if (this.config.do_normalize) {
          let e = this.std * 2;
          for (let n = 0; n < t.data.length; ++n) t.data[n] = (t.data[n] - this.mean) / e;
        }
        return { input_values: new Tensor(`float32`, t.data, [1, ...t.dims]) };
      }
    },
    ClapFeatureExtractor = class extends FeatureExtractor {
      constructor(e) {
        (super(e),
          (this.mel_filters = mel_filter_bank(
            this.config.nb_frequency_bins,
            this.config.feature_size,
            this.config.frequency_min,
            this.config.frequency_max,
            this.config.sampling_rate,
            null,
            `htk`,
          )),
          (this.mel_filters_slaney = mel_filter_bank(
            this.config.nb_frequency_bins,
            this.config.feature_size,
            this.config.frequency_min,
            this.config.frequency_max,
            this.config.sampling_rate,
            `slaney`,
            `slaney`,
          )),
          (this.window = window_function(this.config.fft_window_size, `hann`)));
      }
      _get_input_mel(e, t, n, r) {
        let i,
          a = !1,
          o = e.length - t;
        if (o > 0)
          if (n === `rand_trunc`) {
            a = !0;
            let n = Math.floor(Math.random() * (o + 1));
            ((e = e.subarray(n, n + t)),
              (i = this._extract_fbank_features(e, this.mel_filters_slaney, this.config.nb_max_samples)),
              (i.dims = [1, ...i.dims]));
          } else throw Error(`Truncation strategy "${n}" not implemented`);
        else {
          if (o < 0) {
            let n = new Float64Array(t);
            if ((n.set(e), r === `repeat`))
              for (let r = e.length; r < t; r += e.length) n.set(e.subarray(0, Math.min(e.length, t - r)), r);
            else if (r === `repeatpad`) for (let t = e.length; t < -o; t += e.length) n.set(e, t);
            e = n;
          }
          if (n === `fusion`) throw Error(`Truncation strategy "${n}" not implemented`);
          ((i = this._extract_fbank_features(e, this.mel_filters_slaney, this.config.nb_max_samples)),
            (i.dims = [1, ...i.dims]));
        }
        return { ...i, longer: a };
      }
      _extract_fbank_features(e, t, n = null) {
        return spectrogram(e, this.window, this.config.fft_window_size, this.config.hop_length, {
          power: 2,
          mel_filters: t,
          log_mel: `dB`,
          max_num_frames: n,
          do_pad: !1,
          transpose: !0,
        });
      }
      async _call(e, { max_length: t = null } = {}) {
        validate_audio_inputs(e, `ClapFeatureExtractor`);
        let n = this._get_input_mel(e, t ?? this.config.nb_max_samples, this.config.truncation, this.config.padding);
        return { input_features: new Tensor(`float32`, n.data, [1, ...n.dims]) };
      }
    },
    SpeechT5FeatureExtractor = class extends FeatureExtractor {},
    Processor = class extends Callable {
      constructor(e) {
        (super(), (this.feature_extractor = e));
      }
      async _call(e, ...t) {
        return await this.feature_extractor(e, ...t);
      }
    },
    SamProcessor = class extends Processor {
      async _call(...e) {
        return await this.feature_extractor(...e);
      }
      post_process_masks(...e) {
        return this.feature_extractor.post_process_masks(...e);
      }
      reshape_input_points(...e) {
        return this.feature_extractor.reshape_input_points(...e);
      }
    },
    WhisperProcessor = class extends Processor {
      async _call(e) {
        return await this.feature_extractor(e);
      }
    },
    Wav2Vec2ProcessorWithLM = class extends Processor {
      async _call(e) {
        return await this.feature_extractor(e);
      }
    },
    SpeechT5Processor = class extends Processor {
      async _call(e) {
        return await this.feature_extractor(e);
      }
    },
    OwlViTProcessor = class extends Processor {},
    AutoProcessor = class {
      static FEATURE_EXTRACTOR_CLASS_MAPPING = {
        ImageFeatureExtractor,
        WhisperFeatureExtractor,
        ViTFeatureExtractor,
        MobileViTFeatureExtractor,
        MobileViTImageProcessor,
        OwlViTFeatureExtractor,
        Owlv2ImageProcessor,
        CLIPFeatureExtractor,
        ChineseCLIPFeatureExtractor,
        SiglipImageProcessor,
        ConvNextFeatureExtractor,
        ConvNextImageProcessor,
        SegformerFeatureExtractor,
        BitImageProcessor,
        DPTImageProcessor,
        DPTFeatureExtractor,
        GLPNFeatureExtractor,
        BeitFeatureExtractor,
        DeiTFeatureExtractor,
        DetrFeatureExtractor,
        YolosFeatureExtractor,
        DonutFeatureExtractor,
        NougatImageProcessor,
        EfficientNetImageProcessor,
        ViTImageProcessor,
        VitMatteImageProcessor,
        SamImageProcessor,
        Swin2SRImageProcessor,
        Wav2Vec2FeatureExtractor,
        SeamlessM4TFeatureExtractor,
        SpeechT5FeatureExtractor,
        ASTFeatureExtractor,
        ClapFeatureExtractor,
      };
      static PROCESSOR_CLASS_MAPPING = {
        WhisperProcessor,
        Wav2Vec2ProcessorWithLM,
        SamProcessor,
        SpeechT5Processor,
        OwlViTProcessor,
      };
      static async from_pretrained(
        e,
        {
          progress_callback: t = null,
          config: n = null,
          cache_dir: r = null,
          local_files_only: i = !1,
          revision: a = `main`,
        } = {},
      ) {
        let o =
            n ??
            (await getModelJSON(e, `preprocessor_config.json`, !0, {
              progress_callback: t,
              config: n,
              cache_dir: r,
              local_files_only: i,
              revision: a,
            })),
          s = o.feature_extractor_type ?? o.image_processor_type,
          c = this.FEATURE_EXTRACTOR_CLASS_MAPPING[s];
        if (!c)
          if (o.size !== void 0)
            (console.warn(
              `Feature extractor type "${s}" not found, assuming ImageFeatureExtractor due to size parameter in config.`,
            ),
              (c = ImageFeatureExtractor));
          else throw Error(`Unknown Feature Extractor type: ${s}`);
        return new (this.PROCESSOR_CLASS_MAPPING[o.processor_class] ?? Processor)(new c(o));
      }
    };
  async function prepareImages(e) {
    return (Array.isArray(e) || (e = [e]), await Promise.all(e.map((e) => RawImage.read(e))));
  }
  async function prepareAudios(e, t) {
    return (
      Array.isArray(e) || (e = [e]),
      await Promise.all(
        e.map((e) =>
          typeof e == `string` || e instanceof URL
            ? read_audio(e, t)
            : e instanceof Float64Array
              ? new Float32Array(e)
              : e,
        ),
      )
    );
  }
  function get_bounding_box(e, t) {
    t && (e = e.map((e) => e | 0));
    let [n, r, i, a] = e;
    return { xmin: n, ymin: r, xmax: i, ymax: a };
  }
  var Pipeline = class extends Callable {
      constructor({ task: e, model: t, tokenizer: n = null, processor: r = null }) {
        (super(), (this.task = e), (this.model = t), (this.tokenizer = n), (this.processor = r));
      }
      async dispose() {
        await this.model.dispose();
      }
    },
    TextClassificationPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, { topk: t = 1 } = {}) {
        let n = this.tokenizer(e, { padding: !0, truncation: !0 }),
          r = await this.model(n),
          i =
            this.model.config.problem_type === `multi_label_classification`
              ? (e) => e.sigmoid().data
              : (e) => softmax(e.data),
          a = this.model.config.id2label,
          o = [];
        for (let e of r.logits) {
          let n = getTopItems(i(e), t).map((e) => ({ label: a[e[0]], score: e[1] }));
          t === 1 ? o.push(...n) : o.push(n);
        }
        return Array.isArray(e) || t === 1 ? o : o[0];
      }
    },
    TokenClassificationPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, { ignore_labels: t = [`O`] } = {}) {
        let n = Array.isArray(e),
          r = this.tokenizer(n ? e : [e], { padding: !0, truncation: !0 }),
          i = (await this.model(r)).logits,
          a = this.model.config.id2label,
          o = [];
        for (let e = 0; e < i.dims[0]; ++e) {
          let n = r.input_ids[e],
            s = i[e],
            c = [];
          for (let e = 0; e < s.dims[0]; ++e) {
            let r = s[e],
              i = max(r.data)[1],
              o = a ? a[i] : `LABEL_${i}`;
            if (t.includes(o)) continue;
            let l = this.tokenizer.decode([n[e].item()], { skip_special_tokens: !0 });
            if (l === ``) continue;
            let u = softmax(r.data);
            c.push({ entity: o, score: u[i], index: e, word: l, start: null, end: null });
          }
          o.push(c);
        }
        return n ? o : o[0];
      }
    },
    QuestionAnsweringPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, t, { topk: n = 1 } = {}) {
        let r = this.tokenizer(e, { text_pair: t, padding: !0, truncation: !0 }),
          i = await this.model(r),
          a = [];
        for (let e = 0; e < i.start_logits.dims[0]; ++e) {
          let t = r.input_ids[e],
            o = t.indexOf(this.tokenizer.sep_token_id),
            s = product(
              Array.from(softmax(i.start_logits[e].data))
                .map((e, t) => [e, t])
                .filter((e) => e[1] > o),
              Array.from(softmax(i.end_logits[e].data))
                .map((e, t) => [e, t])
                .filter((e) => e[1] > o),
            )
              .filter((e) => e[0][1] <= e[1][1])
              .map((e) => [e[0][1], e[1][1], e[0][0] * e[1][0]])
              .sort((e, t) => t[2] - e[2]);
          for (let e = 0; e < Math.min(s.length, n); ++e) {
            let [n, r, i] = s[e],
              o = [...t].slice(n, r + 1),
              c = this.tokenizer.decode(o, { skip_special_tokens: !0 });
            a.push({ answer: c, score: i });
          }
        }
        return n === 1 ? a[0] : a;
      }
    },
    FillMaskPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, { topk: t = 5 } = {}) {
        let n = this.tokenizer(e, { padding: !0, truncation: !0 }),
          r = await this.model(n),
          i = [];
        for (let e = 0; e < n.input_ids.dims[0]; ++e) {
          let a = n.input_ids[e],
            o = a.indexOf(this.tokenizer.mask_token_id);
          if (o === -1) throw Error(`Mask token (${this.tokenizer.mask_token}) not found in text.`);
          let s = r.logits[e][o],
            c = getTopItems(softmax(s.data), t);
          i.push(
            c.map((e) => {
              let t = [...a];
              return (
                (t[o] = e[0]),
                {
                  score: e[1],
                  token: e[0],
                  token_str: this.tokenizer.model.vocab[e[0]],
                  sequence: this.tokenizer.decode(t, { skip_special_tokens: !0 }),
                }
              );
            }),
          );
        }
        return Array.isArray(e) ? i : i[0];
      }
    },
    Text2TextGenerationPipeline = class extends Pipeline {
      _key = `generated_text`;
      constructor(e) {
        super(e);
      }
      async _call(e, t = {}) {
        (Array.isArray(e) || (e = [e]), this.model.config.prefix && (e = e.map((e) => this.model.config.prefix + e)));
        let n = this.model.config.task_specific_params;
        n && n[this.task] && n[this.task].prefix && (e = e.map((e) => n[this.task].prefix + e));
        let r = this.tokenizer,
          i = { padding: !0, truncation: !0 },
          a;
        a =
          this instanceof TranslationPipeline && `_build_translation_inputs` in r
            ? r._build_translation_inputs(e, i, t).input_ids
            : r(e, i).input_ids;
        let o = await this.model.generate(a, t);
        return r.batch_decode(o, { skip_special_tokens: !0 }).map((e) => ({ [this._key]: e }));
      }
    },
    SummarizationPipeline = class extends Text2TextGenerationPipeline {
      _key = `summary_text`;
      constructor(e) {
        super(e);
      }
    },
    TranslationPipeline = class extends Text2TextGenerationPipeline {
      _key = `translation_text`;
      constructor(e) {
        super(e);
      }
    };
  function isChat(e) {
    return Array.isArray(e) && e.every((e) => `role` in e && `content` in e);
  }
  var TextGenerationPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, t = {}) {
        let n = !1,
          r = !1,
          i;
        if (typeof e == `string`) i = e = [e];
        else if (Array.isArray(e) && e.every((e) => typeof e == `string`)) ((n = !0), (i = e));
        else {
          if (isChat(e)) e = [e];
          else if (Array.isArray(e) && e.every(isChat)) n = !0;
          else throw Error(`Input must be a string, an array of strings, a Chat, or an array of Chats`);
          ((r = !0),
            (i = e.map((e) => this.tokenizer.apply_chat_template(e, { tokenize: !1, add_generation_prompt: !0 }))));
        }
        let a = t.add_special_tokens ?? !1,
          o = r ? !1 : (t.return_full_text ?? !0);
        this.tokenizer.padding_side = `left`;
        let { input_ids: s, attention_mask: c } = this.tokenizer(i, {
            add_special_tokens: a,
            padding: !0,
            truncation: !0,
          }),
          l = await this.model.generate(s, t, null, { inputs_attention_mask: c }),
          u = this.tokenizer.batch_decode(l, { skip_special_tokens: !0 }),
          d;
        !o &&
          s.dims.at(-1) > 0 &&
          (d = this.tokenizer.batch_decode(s, { skip_special_tokens: !0 }).map((e) => e.length));
        let f = Array.from({ length: e.length }, (e) => []);
        for (let t = 0; t < u.length; ++t) {
          let n = Math.floor((t / l.length) * e.length);
          (d && (u[t] = u[t].slice(d[n])),
            f[n].push({ generated_text: r ? [...e[n], { role: `assistant`, content: u[t] }] : u[t] }));
        }
        return !n && f.length === 1 ? f[0] : f;
      }
    },
    ZeroShotClassificationPipeline = class extends Pipeline {
      constructor(e) {
        (super(e),
          (this.label2id = Object.fromEntries(
            Object.entries(this.model.config.label2id).map(([e, t]) => [e.toLowerCase(), t]),
          )),
          (this.entailment_id = this.label2id.entailment),
          this.entailment_id === void 0 &&
            (console.warn(`Could not find 'entailment' in label2id mapping. Using 2 as entailment_id.`),
            (this.entailment_id = 2)),
          (this.contradiction_id = this.label2id.contradiction ?? this.label2id.not_entailment),
          this.contradiction_id === void 0 &&
            (console.warn(`Could not find 'contradiction' in label2id mapping. Using 0 as contradiction_id.`),
            (this.contradiction_id = 0)));
      }
      async _call(e, t, { hypothesis_template: n = `This example is {}.`, multi_label: r = !1 } = {}) {
        let i = Array.isArray(e);
        (i || (e = [e]), Array.isArray(t) || (t = [t]));
        let a = t.map((e) => n.replace(`{}`, e)),
          o = r || t.length === 1,
          s = [];
        for (let n of e) {
          let e = [];
          for (let t of a) {
            let r = this.tokenizer(n, { text_pair: t, padding: !0, truncation: !0 }),
              i = await this.model(r);
            o
              ? e.push([i.logits.data[this.contradiction_id], i.logits.data[this.entailment_id]])
              : e.push(i.logits.data[this.entailment_id]);
          }
          let r = (o ? e.map((e) => softmax(e)[1]) : softmax(e)).map((e, t) => [e, t]).sort((e, t) => t[0] - e[0]);
          s.push({ sequence: n, labels: r.map((e) => t[e[1]]), scores: r.map((e) => e[0]) });
        }
        return i ? s : s[0];
      }
    },
    FeatureExtractionPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, { pooling: t = `none`, normalize: n = !1, quantize: r = !1, precision: i = `binary` } = {}) {
        let a = this.tokenizer(e, { padding: !0, truncation: !0 }),
          o = await this.model(a),
          s = o.last_hidden_state ?? o.logits ?? o.token_embeddings;
        if (t !== `none`)
          if (t === `mean`) s = mean_pooling(s, a.attention_mask);
          else if (t === `cls`) s = s.slice(null, 0);
          else throw Error(`Pooling method '${t}' not supported.`);
        return (n && (s = s.normalize(2, -1)), r && (s = quantize_embeddings(s, i)), s);
      }
    },
    ImageFeatureExtractionPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, { pool: t = null } = {}) {
        let n = await prepareImages(e),
          { pixel_values: r } = await this.processor(n),
          i = await this.model({ pixel_values: r }),
          a;
        if (t) {
          if (!(`pooler_output` in i))
            throw Error(
              `No pooled output was returned. Make sure the model has a 'pooler' layer when using the 'pool' option.`,
            );
          a = i.pooler_output;
        } else a = i.last_hidden_state ?? i.logits ?? i.image_embeds;
        return a;
      }
    },
    AudioClassificationPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, { topk: t = null } = {}) {
        let n = !Array.isArray(e),
          r = this.processor.feature_extractor.config.sampling_rate,
          i = await prepareAudios(e, r),
          a = this.model.config.id2label,
          o = [];
        for (let e of i) {
          let n = await this.processor(e),
            r = (await this.model(n)).logits[0],
            i = getTopItems(softmax(r.data), t).map((e) => ({ label: a[e[0]], score: e[1] }));
          t === 1 ? o.push(...i) : o.push(i);
        }
        return !n || t === 1 ? o : o[0];
      }
    },
    ZeroShotAudioClassificationPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, t, { hypothesis_template: n = `This is a sound of {}.` } = {}) {
        let r = !Array.isArray(e);
        r && (e = [e]);
        let i = t.map((e) => n.replace(`{}`, e)),
          a = this.tokenizer(i, { padding: !0, truncation: !0 }),
          o = this.processor.feature_extractor.config.sampling_rate,
          s = await prepareAudios(e, o),
          c = [];
        for (let e of s) {
          let n = await this.processor(e),
            r = softmax((await this.model({ ...a, ...n })).logits_per_audio.data);
          c.push([...r].map((e, n) => ({ score: e, label: t[n] })));
        }
        return r ? c[0] : c;
      }
    },
    AutomaticSpeechRecognitionPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, t = {}) {
        switch (this.model.config.model_type) {
          case `whisper`:
            return this._call_whisper(e, t);
          case `wav2vec2`:
          case `wav2vec2-bert`:
          case `unispeech`:
          case `unispeech-sat`:
          case `hubert`:
            return this._call_wav2vec2(e, t);
          default:
            throw Error(
              `AutomaticSpeechRecognitionPipeline does not support model type '${this.model.config.model_type}'.`,
            );
        }
      }
      async _call_wav2vec2(e, t = {}) {
        (t.language &&
          console.warn('`language` parameter is not yet supported for `wav2vec2` models, defaulting to "English".'),
          t.task &&
            console.warn('`task` parameter is not yet supported for `wav2vec2` models, defaulting to "transcribe".'));
        let n = !Array.isArray(e);
        n && (e = [e]);
        let r = this.processor.feature_extractor.config.sampling_rate,
          i = await prepareAudios(e, r),
          a = [];
        for (let e of i) {
          let t = await this.processor(e),
            n = (await this.model(t)).logits[0],
            r = [];
          for (let e of n) r.push(max(e.data)[1]);
          let i = this.tokenizer.decode(r);
          a.push({ text: i });
        }
        return n ? a[0] : a;
      }
      async _call_whisper(e, t = {}) {
        let n = t.return_timestamps ?? !1,
          r = t.chunk_length_s ?? 0,
          i = t.chunk_callback ?? null,
          a = t.force_full_sequences ?? !1,
          o = t.stride_length_s ?? null;
        n === `word` && (t.return_token_timestamps = !0);
        let s = pop(t, `language`, null),
          c = pop(t, `task`, null);
        if (s || c || n) {
          if (t.forced_decoder_ids)
            throw Error(
              'Cannot specify `language`/`task`/`return_timestamps` and `forced_decoder_ids` at the same time.',
            );
          let e = this.tokenizer.get_decoder_prompt_ids({ language: s, task: c, no_timestamps: !n });
          e.length > 0 && (t.forced_decoder_ids = e);
        }
        let l = !Array.isArray(e);
        l && (e = [e]);
        let u = this.processor.feature_extractor.config.chunk_length / this.model.config.max_source_positions,
          d = this.processor.feature_extractor.config.hop_length,
          f = this.processor.feature_extractor.config.sampling_rate,
          p = await prepareAudios(e, f),
          m = [];
        for (let e of p) {
          let s = [];
          if (r > 0) {
            if (o === null) o = r / 6;
            else if (r <= o) throw Error('`chunk_length_s` must be larger than `stride_length_s`.');
            let t = f * r,
              n = f * o,
              i = t - 2 * n,
              a = 0;
            for (; a < e.length; ) {
              let r = e.subarray(a, a + t),
                o = await this.processor(r),
                c = a === 0,
                l = a + i >= e.length;
              (s.push({ stride: [r.length, c ? 0 : n, l ? 0 : n], input_features: o.input_features, is_last: l }),
                (a += i));
            }
          } else
            s = [{ stride: [e.length, 0, 0], input_features: (await this.processor(e)).input_features, is_last: !0 }];
          for (let e of s) {
            t.num_frames = Math.floor(e.stride[0] / d);
            let r = await this.model.generate(e.input_features, t);
            (n === `word`
              ? ((e.tokens = r.sequences[0]),
                (e.token_timestamps = r.token_timestamps.tolist()[0].map((e) => round(e, 2))))
              : (e.tokens = r[0]),
              (e.stride = e.stride.map((e) => e / f)),
              i !== null && i(e));
          }
          let [c, l] = this.tokenizer._decode_asr(s, {
            time_precision: u,
            return_timestamps: n,
            force_full_sequences: a,
          });
          m.push({ text: c, ...l });
        }
        return l ? m[0] : m;
      }
    },
    ImageToTextPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, t = {}) {
        let n = Array.isArray(e),
          r = await prepareImages(e),
          { pixel_values: i } = await this.processor(r),
          a = [];
        for (let e of i) {
          e.dims = [1, ...e.dims];
          let n = await this.model.generate(e, t),
            r = this.tokenizer.batch_decode(n, { skip_special_tokens: !0 }).map((e) => ({ generated_text: e.trim() }));
          a.push(r);
        }
        return n ? a : a[0];
      }
    },
    ImageClassificationPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, { topk: t = 1 } = {}) {
        let n = Array.isArray(e),
          r = await prepareImages(e),
          { pixel_values: i } = await this.processor(r),
          a = await this.model({ pixel_values: i }),
          o = this.model.config.id2label,
          s = [];
        for (let e of a.logits) {
          let n = getTopItems(softmax(e.data), t).map((e) => ({ label: o[e[0]], score: e[1] }));
          t === 1 ? s.push(...n) : s.push(n);
        }
        return n || t === 1 ? s : s[0];
      }
    },
    ImageSegmentationPipeline = class extends Pipeline {
      constructor(e) {
        (super(e),
          (this.subtasks_mapping = {
            panoptic: `post_process_panoptic_segmentation`,
            instance: `post_process_instance_segmentation`,
            semantic: `post_process_semantic_segmentation`,
          }));
      }
      async _call(
        e,
        {
          threshold: t = 0.5,
          mask_threshold: n = 0.5,
          overlap_mask_area_threshold: r = 0.8,
          label_ids_to_fuse: i = null,
          target_sizes: a = null,
          subtask: o = null,
        } = {},
      ) {
        if (Array.isArray(e) && e.length !== 1)
          throw Error(`Image segmentation pipeline currently only supports a batch size of 1.`);
        let s = await prepareImages(e),
          c = s.map((e) => [e.height, e.width]),
          { pixel_values: l, pixel_mask: u } = await this.processor(s),
          d = await this.model({ pixel_values: l, pixel_mask: u }),
          f = null;
        if (o !== null) f = this.subtasks_mapping[o];
        else
          for (let [e, t] of Object.entries(this.subtasks_mapping))
            if (t in this.processor.feature_extractor) {
              ((f = this.processor.feature_extractor[t].bind(this.processor.feature_extractor)), (o = e));
              break;
            }
        let p = this.model.config.id2label,
          m = [];
        if (o === `panoptic` || o === `instance`) {
          let e = f(d, t, n, r, i, a ?? c)[0],
            o = e.segmentation;
          for (let t of e.segments_info) {
            let e = new Uint8ClampedArray(o.data.length);
            for (let n = 0; n < o.data.length; ++n) o.data[n] === t.id && (e[n] = 255);
            let n = new RawImage(e, o.dims[1], o.dims[0], 1);
            m.push({ score: t.score, label: p[t.label_id], mask: n });
          }
        } else if (o === `semantic`) {
          let { segmentation: e, labels: t } = f(d, a ?? c)[0];
          for (let n of t) {
            let t = new Uint8ClampedArray(e.data.length);
            for (let r = 0; r < e.data.length; ++r) e.data[r] === n && (t[r] = 255);
            let r = new RawImage(t, e.dims[1], e.dims[0], 1);
            m.push({ score: null, label: p[n], mask: r });
          }
        } else throw Error(`Subtask ${o} not supported.`);
        return m;
      }
    },
    ZeroShotImageClassificationPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, t, { hypothesis_template: n = `This is a photo of {}` } = {}) {
        let r = Array.isArray(e),
          i = await prepareImages(e),
          a = t.map((e) => n.replace(`{}`, e)),
          o = this.tokenizer(a, {
            padding: this.model.config.model_type === `siglip` ? `max_length` : !0,
            truncation: !0,
          }),
          { pixel_values: s } = await this.processor(i),
          c = await this.model({ ...o, pixel_values: s }),
          l = this.model.config.model_type === `siglip` ? (e) => e.sigmoid().data : (e) => softmax(e.data),
          u = [];
        for (let e of c.logits_per_image) {
          let n = [...l(e)].map((e, n) => ({ score: e, label: t[n] }));
          (n.sort((e, t) => t.score - e.score), u.push(n));
        }
        return r ? u : u[0];
      }
    },
    ObjectDetectionPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, { threshold: t = 0.9, percentage: n = !1 } = {}) {
        let r = Array.isArray(e);
        if (r && e.length !== 1) throw Error(`Object detection pipeline currently only supports a batch size of 1.`);
        let i = await prepareImages(e),
          a = n ? null : i.map((e) => [e.height, e.width]),
          { pixel_values: o, pixel_mask: s } = await this.processor(i),
          c = await this.model({ pixel_values: o, pixel_mask: s }),
          l = this.processor.feature_extractor.post_process_object_detection(c, t, a),
          u = this.model.config.id2label,
          d = l.map((e) =>
            e.boxes.map((t, r) => ({ score: e.scores[r], label: u[e.classes[r]], box: get_bounding_box(t, !n) })),
          );
        return r ? d : d[0];
      }
    },
    ZeroShotObjectDetectionPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, t, { threshold: n = 0.1, topk: r = null, percentage: i = !1 } = {}) {
        let a = Array.isArray(e),
          o = await prepareImages(e),
          s = this.tokenizer(t, { padding: !0, truncation: !0 }),
          c = await this.processor(o),
          l = [];
        for (let e = 0; e < o.length; ++e) {
          let a = o[e],
            u = i ? null : [[a.height, a.width]],
            d = c.pixel_values[e].unsqueeze_(0),
            f = await this.model({ ...s, pixel_values: d }),
            p = this.processor.feature_extractor.post_process_object_detection(f, n, u, !0)[0],
            m = p.boxes
              .map((e, n) => ({ score: p.scores[n], label: t[p.classes[n]], box: get_bounding_box(e, !i) }))
              .sort((e, t) => t.score - e.score);
          (r !== null && (m = m.slice(0, r)), l.push(m));
        }
        return a ? l : l[0];
      }
    },
    DocumentQuestionAnsweringPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e, t, n = {}) {
        let r = (await prepareImages(e))[0],
          { pixel_values: i } = await this.processor(r),
          a = `<s_docvqa><s_question>${t}</s_question><s_answer>`,
          o = this.tokenizer(a, { add_special_tokens: !1, padding: !0, truncation: !0 }).input_ids,
          s = await this.model.generate(i, {
            ...n,
            decoder_input_ids: o,
            max_length: this.model.config.decoder.max_position_embeddings,
          }),
          c = this.tokenizer.batch_decode(s)[0].match(/<s_answer>(.*?)<\/s_answer>/),
          l = null;
        return (c && c.length >= 2 && (l = c[1].trim()), [{ answer: l }]);
      }
    },
    TextToAudioPipeline = class extends Pipeline {
      DEFAULT_VOCODER_ID = `Xenova/speecht5_hifigan`;
      constructor(e) {
        (super(e), (this.vocoder = e.vocoder ?? null));
      }
      async _call(e, { speaker_embeddings: t = null } = {}) {
        return this.processor
          ? this._call_text_to_spectrogram(e, { speaker_embeddings: t })
          : this._call_text_to_waveform(e);
      }
      async _call_text_to_waveform(e) {
        let t = this.tokenizer(e, { padding: !0, truncation: !0 }),
          { waveform: n } = await this.model(t),
          r = this.model.config.sampling_rate;
        return { audio: n.data, sampling_rate: r };
      }
      async _call_text_to_spectrogram(e, { speaker_embeddings: t }) {
        if (
          ((this.vocoder ||=
            (console.log(`No vocoder specified, using default HifiGan vocoder.`),
            await AutoModel.from_pretrained(this.DEFAULT_VOCODER_ID, { quantized: !1 }))),
          (typeof t == `string` || t instanceof URL) && (t = new Float32Array(await (await fetch(t)).arrayBuffer())),
          t instanceof Float32Array)
        )
          t = new Tensor(`float32`, t, [1, t.length]);
        else if (!(t instanceof Tensor))
          throw Error('Speaker embeddings must be a `Tensor`, `Float32Array`, `string`, or `URL`.');
        let { input_ids: n } = this.tokenizer(e, { padding: !0, truncation: !0 }),
          { waveform: r } = await this.model.generate_speech(n, t, { vocoder: this.vocoder }),
          i = this.processor.feature_extractor.config.sampling_rate;
        return { audio: r.data, sampling_rate: i };
      }
    },
    ImageToImagePipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e) {
        let t = await prepareImages(e),
          n = await this.processor(t),
          r = await this.model(n),
          i = [];
        for (let e of r.reconstruction) {
          let t = e.squeeze().clamp_(0, 1).mul_(255).round_().to(`uint8`);
          i.push(RawImage.fromTensor(t));
        }
        return i.length > 1 ? i : i[0];
      }
    },
    DepthEstimationPipeline = class extends Pipeline {
      constructor(e) {
        super(e);
      }
      async _call(e) {
        let t = await prepareImages(e),
          n = await this.processor(t),
          { predicted_depth: r } = await this.model(n),
          i = [];
        for (let e = 0; e < t.length; ++e) {
          let n = interpolate(r[e], t[e].size.reverse(), `bilinear`, !1),
            a = n.mul_(255 / max(n.data)[0]).to(`uint8`);
          i.push({ predicted_depth: r[e], depth: RawImage.fromTensor(a) });
        }
        return i.length > 1 ? i : i[0];
      }
    };
  const SUPPORTED_TASKS = Object.freeze({
      'text-classification': {
        tokenizer: AutoTokenizer,
        pipeline: TextClassificationPipeline,
        model: AutoModelForSequenceClassification,
        default: { model: `Xenova/distilbert-base-uncased-finetuned-sst-2-english` },
        type: `text`,
      },
      'token-classification': {
        tokenizer: AutoTokenizer,
        pipeline: TokenClassificationPipeline,
        model: AutoModelForTokenClassification,
        default: { model: `Xenova/bert-base-multilingual-cased-ner-hrl` },
        type: `text`,
      },
      'question-answering': {
        tokenizer: AutoTokenizer,
        pipeline: QuestionAnsweringPipeline,
        model: AutoModelForQuestionAnswering,
        default: { model: `Xenova/distilbert-base-cased-distilled-squad` },
        type: `text`,
      },
      'fill-mask': {
        tokenizer: AutoTokenizer,
        pipeline: FillMaskPipeline,
        model: AutoModelForMaskedLM,
        default: { model: `Xenova/bert-base-uncased` },
        type: `text`,
      },
      summarization: {
        tokenizer: AutoTokenizer,
        pipeline: SummarizationPipeline,
        model: AutoModelForSeq2SeqLM,
        default: { model: `Xenova/distilbart-cnn-6-6` },
        type: `text`,
      },
      translation: {
        tokenizer: AutoTokenizer,
        pipeline: TranslationPipeline,
        model: AutoModelForSeq2SeqLM,
        default: { model: `Xenova/t5-small` },
        type: `text`,
      },
      'text2text-generation': {
        tokenizer: AutoTokenizer,
        pipeline: Text2TextGenerationPipeline,
        model: AutoModelForSeq2SeqLM,
        default: { model: `Xenova/flan-t5-small` },
        type: `text`,
      },
      'text-generation': {
        tokenizer: AutoTokenizer,
        pipeline: TextGenerationPipeline,
        model: AutoModelForCausalLM,
        default: { model: `Xenova/gpt2` },
        type: `text`,
      },
      'zero-shot-classification': {
        tokenizer: AutoTokenizer,
        pipeline: ZeroShotClassificationPipeline,
        model: AutoModelForSequenceClassification,
        default: { model: `Xenova/distilbert-base-uncased-mnli` },
        type: `text`,
      },
      'audio-classification': {
        pipeline: AudioClassificationPipeline,
        model: AutoModelForAudioClassification,
        processor: AutoProcessor,
        default: { model: `Xenova/wav2vec2-base-superb-ks` },
        type: `audio`,
      },
      'zero-shot-audio-classification': {
        tokenizer: AutoTokenizer,
        pipeline: ZeroShotAudioClassificationPipeline,
        model: AutoModel,
        processor: AutoProcessor,
        default: { model: `Xenova/clap-htsat-unfused` },
        type: `multimodal`,
      },
      'automatic-speech-recognition': {
        tokenizer: AutoTokenizer,
        pipeline: AutomaticSpeechRecognitionPipeline,
        model: [AutoModelForSpeechSeq2Seq, AutoModelForCTC],
        processor: AutoProcessor,
        default: { model: `Xenova/whisper-tiny.en` },
        type: `multimodal`,
      },
      'text-to-audio': {
        tokenizer: AutoTokenizer,
        pipeline: TextToAudioPipeline,
        model: [AutoModelForTextToWaveform, AutoModelForTextToSpectrogram],
        processor: [AutoProcessor, null],
        default: { model: `Xenova/speecht5_tts` },
        type: `text`,
      },
      'image-to-text': {
        tokenizer: AutoTokenizer,
        pipeline: ImageToTextPipeline,
        model: AutoModelForVision2Seq,
        processor: AutoProcessor,
        default: { model: `Xenova/vit-gpt2-image-captioning` },
        type: `multimodal`,
      },
      'image-classification': {
        pipeline: ImageClassificationPipeline,
        model: AutoModelForImageClassification,
        processor: AutoProcessor,
        default: { model: `Xenova/vit-base-patch16-224` },
        type: `multimodal`,
      },
      'image-segmentation': {
        pipeline: ImageSegmentationPipeline,
        model: [AutoModelForImageSegmentation, AutoModelForSemanticSegmentation],
        processor: AutoProcessor,
        default: { model: `Xenova/detr-resnet-50-panoptic` },
        type: `multimodal`,
      },
      'zero-shot-image-classification': {
        tokenizer: AutoTokenizer,
        pipeline: ZeroShotImageClassificationPipeline,
        model: AutoModel,
        processor: AutoProcessor,
        default: { model: `Xenova/clip-vit-base-patch32` },
        type: `multimodal`,
      },
      'object-detection': {
        pipeline: ObjectDetectionPipeline,
        model: AutoModelForObjectDetection,
        processor: AutoProcessor,
        default: { model: `Xenova/detr-resnet-50` },
        type: `multimodal`,
      },
      'zero-shot-object-detection': {
        tokenizer: AutoTokenizer,
        pipeline: ZeroShotObjectDetectionPipeline,
        model: AutoModelForZeroShotObjectDetection,
        processor: AutoProcessor,
        default: { model: `Xenova/owlvit-base-patch32` },
        type: `multimodal`,
      },
      'document-question-answering': {
        tokenizer: AutoTokenizer,
        pipeline: DocumentQuestionAnsweringPipeline,
        model: AutoModelForDocumentQuestionAnswering,
        processor: AutoProcessor,
        default: { model: `Xenova/donut-base-finetuned-docvqa` },
        type: `multimodal`,
      },
      'image-to-image': {
        pipeline: ImageToImagePipeline,
        model: AutoModelForImageToImage,
        processor: AutoProcessor,
        default: { model: `Xenova/swin2SR-classical-sr-x2-64` },
        type: `image`,
      },
      'depth-estimation': {
        pipeline: DepthEstimationPipeline,
        model: AutoModelForDepthEstimation,
        processor: AutoProcessor,
        default: { model: `Xenova/dpt-large` },
        type: `image`,
      },
      'feature-extraction': {
        tokenizer: AutoTokenizer,
        pipeline: FeatureExtractionPipeline,
        model: AutoModel,
        default: { model: `Xenova/all-MiniLM-L6-v2` },
        type: `text`,
      },
      'image-feature-extraction': {
        processor: AutoProcessor,
        pipeline: ImageFeatureExtractionPipeline,
        model: [AutoModelForImageFeatureExtraction, AutoModel],
        default: { model: `Xenova/vit-base-patch16-224-in21k` },
        type: `image`,
      },
    }),
    TASK_ALIASES = Object.freeze({
      'sentiment-analysis': `text-classification`,
      ner: `token-classification`,
      asr: `automatic-speech-recognition`,
      'text-to-speech': `text-to-audio`,
      embeddings: `feature-extraction`,
    });
  async function pipeline(
    e,
    t = null,
    {
      quantized: n = !0,
      progress_callback: r = null,
      config: i = null,
      cache_dir: a = null,
      local_files_only: o = !1,
      revision: s = `main`,
      model_file_name: c = null,
    } = {},
  ) {
    e = TASK_ALIASES[e] ?? e;
    let l = SUPPORTED_TASKS[e.split(`_`, 1)[0]];
    if (!l) throw Error(`Unsupported pipeline: ${e}. Must be one of [${Object.keys(SUPPORTED_TASKS)}]`);
    t || ((t = l.default.model), console.log(`No model specified. Using default model: "${t}".`));
    let u = {
        quantized: n,
        progress_callback: r,
        config: i,
        cache_dir: a,
        local_files_only: o,
        revision: s,
        model_file_name: c,
      },
      d = await loadItems(
        new Map([
          [`tokenizer`, l.tokenizer],
          [`model`, l.model],
          [`processor`, l.processor],
        ]),
        t,
        u,
      );
    ((d.task = e), dispatchCallback(r, { status: `ready`, task: e, model: t }));
    let f = l.pipeline;
    return new f(d);
  }
  async function loadItems(e, t, n) {
    let r = Object.create(null),
      i = [];
    for (let [a, o] of e.entries()) {
      if (!o) continue;
      let e;
      ((e = Array.isArray(o)
        ? new Promise(async (e, r) => {
            let i;
            for (let r of o) {
              if (r === null) {
                e(null);
                return;
              }
              try {
                e(await r.from_pretrained(t, n));
                return;
              } catch (e) {
                i = e;
              }
            }
            r(i);
          })
        : o.from_pretrained(t, n)),
        (r[a] = e),
        i.push(e));
    }
    await Promise.all(i);
    for (let [e, t] of Object.entries(r)) r[e] = await t;
    return r;
  }
  env$1.allowLocalModels = !1;
  const MODEL_NAME = `Xenova/clip-vit-base-patch32`;
  var PipelineSingleton = class {
    static task = `zero-shot-image-classification`;
    static model = MODEL_NAME;
    static instance = null;
    static async getInstance(e = null) {
      return (
        this.instance === null && (this.instance = pipeline(this.task, this.model, { progress_callback: e })),
        this.instance
      );
    }
  };
  self.addEventListener(`message`, async (e) => {
    let { action: t, imageBase64: n } = e.data;
    if (t === `load`)
      try {
        (await PipelineSingleton.getInstance((e) => {
          self.postMessage({ status: `progress`, progress: e });
        }),
          self.postMessage({ status: `ready` }));
      } catch (e) {
        self.postMessage({ status: `error`, error: e.message });
      }
    if (t === `analyze`)
      try {
        let e = await PipelineSingleton.getInstance();
        self.postMessage({ status: `processing`, message: `Verificando presença de cabelo...` });
        let t = await e(n, [
          `a close-up photo of perfectly healthy, shiny, and smooth hair`,
          `a close-up photo of dry, frizzy, and unruly hair`,
          `a close-up photo of severely damaged, broken, and chemically treated hair`,
          `a close-up photo of thin, sparse hair with visible scalp`,
          `a photo of a human hand, arm, or face`,
          `a photo of a random object, room, or background`,
        ]);
        self.postMessage({ status: `complete`, results: t });
      } catch (e) {
        self.postMessage({ status: `error`, error: e.message });
      }
  });
})();
